import {
  invalidcoord,
  string2pos
} from "./chunk-HJ6L54YS.js";
import {
  HandlerBase,
  require_debounce
} from "./chunk-KV4W2ACA.js";
import {
  importPlot
} from "./chunk-CCYVGZGI.js";
import {
  Menu,
  getAncestorWithComputedStyle,
  set_base_zindex
} from "./chunk-ELJX3QIQ.js";
import {
  sample_match_termvaluesetting
} from "./chunk-N7DVQTPC.js";
import {
  mayShowRememberedGvQ
} from "./chunk-EEB5VE2A.js";
import {
  icons,
  topBarInit
} from "./chunk-6RRZRISL.js";
import {
  termInfoInit
} from "./chunk-2KM4PRQM.js";
import {
  boxplot_getvalue,
  computePercentile,
  compute_bins,
  dofetch,
  dofetch2,
  dofetch3,
  getRequiredAuth,
  getSavedToken,
  initBinConfig,
  isInSession,
  isUsableTerm,
  setTokenByDsRoute
} from "./chunk-GRVO7RW4.js";
import {
  getFractionTvsTerm,
  getWrappedTvslst,
  isFractionTw,
  validateTermCollectionFraction,
  validateVariantFilter
} from "./chunk-7CJKL3LK.js";
import {
  NumericModes,
  clearDtTermMnames,
  dtTermTypes,
  equals,
  getDtsFromGroups,
  getGvQCacheKey,
  isCategoricalTerm,
  isDictionaryType,
  isNonDictionaryType,
  isNumericTerm,
  isNumericTw,
  isSingleCellTerm,
  matchesGvQueryEntry,
  numericTypes,
  restoreGvQueryEntry,
  setGroupsetParentTerms,
  termItemType,
  termType2label,
  trimGvQForCache,
  trimGvTermCopy,
  typeGroup
} from "./chunk-HZ3TCGBK.js";
import {
  CATEGORICAL,
  DATE,
  DNA_METHYLATION,
  FLOAT,
  GENE_EXPRESSION,
  GENE_VARIANT,
  INTEGER,
  ISOFORM_EXPRESSION,
  JUNCTION,
  METABOLITE_INTENSITY,
  PROTEOME_ABUNDANCE,
  PROTEOME_DAP,
  PSEUDOBULK,
  PseudobulkAssay,
  SINGLECELL_CELLTYPE,
  SINGLECELL_GENE_EXPRESSION,
  SNP,
  SSGSEA,
  TERM_COLLECTION,
  TermTypeGroups,
  TermTypes,
  dt2color,
  dt2label,
  dtTerms,
  dtcnv,
  dtfusionrna,
  dtsnvindel,
  dtsv,
  exoncolor,
  getColors,
  gmmode,
  mclass,
  plotColor,
  tkt
} from "./chunk-IZUYLFOX.js";
import {
  AppApi,
  Bus,
  StoreApi,
  StoreBase,
  copyMerge,
  deepEqual,
  deepFreeze,
  getCompInit,
  getInitFxn,
  multiInit,
  sleep
} from "./chunk-WINIL2KN.js";
import {
  niceNumLabels
} from "./chunk-7X6NF7NI.js";
import {
  isNumeric,
  isStrictNumeric,
  toUserUnit,
  uiLabel
} from "./chunk-W5J3LTYS.js";
import {
  axisBottom,
  axisLeft,
  axisTop,
  quadtree
} from "./chunk-Z2ZITHT4.js";
import {
  format,
  linear,
  log
} from "./chunk-4OLM3KSB.js";
import {
  roundValue,
  roundValueAuto
} from "./chunk-TLT4YIG3.js";
import {
  create_default,
  pointer_default,
  select_default
} from "./chunk-I6Y4O3RR.js";
import {
  rgb
} from "./chunk-Q5RDQNIT.js";
import {
  handler
} from "./chunk-DQC5FFGV.js";
import {
  __commonJS,
  __export,
  __glob,
  __toESM
} from "./chunk-HS5PO5ZQ.js";

// ../node_modules/partjson/dist/partjson.umd.js
var require_partjson_umd = __commonJS({
  "../node_modules/partjson/dist/partjson.umd.js"(exports, module) {
    !(function(t2, e) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (t2 = t2 || self).Partjson = e();
    })(exports, function() {
      "use strict";
      class t2 {
        constructor(t3) {
          this.Pj = t3, this.opts = ["@delimit", "@errmode"], this.contexts = ["@branch", "@parent", "@root", "@self", "@values", "@key"], this.filters = ["@split()", "@before()", "@join()", "@ignore()"], this.post = ["@after()", "@dist()", "@end()"], this.terms = [...this.opts, ...this.contexts, ...this.filters, ...this.post];
        }
        setFxn(t3, e2, s2, r2) {
          this[t3] ? s2[t3] = this[t3](r2, e2, s2) : e2.errors.push(["key", "UNRECOGNIZED-RESERVED-" + t3]);
        }
        trueFxn() {
          return true;
        }
        notDefined(t3) {
          return void 0 === t3;
        }
      }
      t2.prototype["@split"] = function(t3) {
        const e2 = t3.slice(1, -2), s2 = this.Pj.opts["="][e2];
        if (!s2) throw `missing @split() function ${e2}`;
        this.Pj.split = s2;
      }, t2.prototype["@before"] = function(t3, e2) {
        const s2 = t3.slice(1, -2), r2 = this.Pj.opts["="][s2];
        return r2 || (e2.errors.push(["val", "MISSING-" + e2.term + "-FXN", s2]), this.trueFxn);
      }, t2.prototype["@after"] = t2.prototype["@before"], t2.prototype["@done"] = t2.prototype["@before"], t2.prototype["@join"] = function(t3, e2, s2) {
        return (s3, r2) => {
          let o2 = true;
          for (const i4 in t3) {
            const n2 = t3[i4].slice(1, -2), l2 = this.Pj.opts["="][n2];
            if (l2) {
              const t4 = l2(s3, r2, i4);
              t4 ? this.Pj.joins.set(i4, t4) : o2 = false;
            } else e2.errors.push(["val", "MISSING-@join-FXN", n2]);
          }
          return o2;
        };
      }, t2.prototype["@dist"] = function(t3, e2) {
        const s2 = Array.isArray(t3) ? t3 : [t3], r2 = {};
        for (const t4 of s2) r2[t4] = this.Pj.converter.subs["@"](this.Pj, t4);
        return (t4) => {
          t4["@dist"] = ((s3) => {
            for (const o2 in r2) {
              const i4 = (0, r2[o2])(null, t4);
              i4 ? Array.isArray(i4) ? i4.includes(s3) || i4.push(s3) : t4.errors.push([e2, "NON-ARRAY-DIST-TARGET", o2]) : t4.errors.push([e2, "MISSING-DIST-TARGET", o2]);
            }
          });
        };
      }, t2.prototype["@ignore"] = function(t3, e2, s2) {
        if (!t3["@ignore()"]) return e2;
        const r2 = Array.isArray(t3["@ignore()"]) || "string" == typeof t3["@ignore()"] || "object" != typeof t3["@ignore()"], o2 = r2 ? { "@": t3["@ignore()"] } : t3["@ignore()"], i4 = {};
        for (const t4 in o2) {
          const e3 = o2[t4];
          if (Array.isArray(e3)) i4[t4] = ((t5) => e3.includes(t5));
          else if ("string" == typeof e3 && "=" == e3[0]) {
            const r3 = this.Pj.opts["="][e3.slice(1, -2)];
            r3 ? i4[t4] = r3 : (s2.errors.push(["val", "MISSING-@ignore()-FXN", e3]), i4[t4] = this.notDefined);
          } else s2.errors.push(["val", "UNSUPPORTED-@ignore()-VALUE", e3]), i4[t4] = this.notDefined;
        }
        return r2 ? i4 : Object.assign({}, e2, i4);
      };
      class e {
        constructor(t3) {
          this.Pj = t3, this.allowedKeyTypes = /* @__PURE__ */ new Set(["string", "number"]);
        }
        getFxn(t3, e2) {
          const [s2, r2] = this.Pj.converter.default(this.Pj, t3, e2, t3.term);
          if (s2) return this[r2.conv](s2, t3);
        }
        getAllowedKeys(t3, e2, s2, r2) {
          if (!Array.isArray(t3)) return r2.errors.push(["key", "NON-ARRAY-KEYS", e2]), [];
          const o2 = [];
          for (const i4 of t3) s2.ignore(i4) || (this.allowedKeyTypes.has(typeof i4) ? o2.push(i4) : r2.errors.push([s2, "INVALID-RESULT-KEY", e2]));
          return o2;
        }
      }
      e.prototype[""] = function(t3, e2) {
        return (s2, r2) => this.getAllowedKeys([t3(s2, r2)], s2, e2, r2);
      }, e.prototype["()"] = e.prototype[""], e.prototype["[]"] = function(t3, e2) {
        return (s2, r2) => this.getAllowedKeys(t3(s2, r2), s2, e2, r2);
      }, e.prototype["(]"] = e.prototype["[]"];
      class s {
        constructor(t3) {
          this.Pj = t3;
        }
        getFxn(t3, e2) {
          return this[this.getValType(t3.templateVal) + "Filler"](t3, e2, t3.templateVal);
        }
        getValType(t3) {
          return "string" == typeof t3 ? "str" : Array.isArray(t3) ? "arr" : t3 && "object" == typeof t3 ? "obj" : "default";
        }
        strFiller(t3, e2, s2, r2) {
          const [o2, i4] = this.Pj.converter.default(this.Pj, t3, e2, s2);
          if (!o2) return;
          const n2 = (r2 || i4.aggr) + "," + i4.conv;
          return n2 in this ? this[n2](o2, t3) : void 0;
        }
        arrFiller(t3, e2, s2) {
          const r2 = this.getValType(s2[0]);
          return "str" == r2 ? this.strFiller(t3, e2, s2[0], "[]") : "arr" == r2 ? this["[[,]]"](s2[0], t3) : "obj" == r2 ? this["[{}]"](s2[0], t3) : this.defaultFiller(t3, e2, s2);
        }
        objFiller(t3, e2, s2) {
          return this.Pj.parseTemplate(s2, t3.inheritedIgnore, t3.lineage), (t4, e3, r2) => {
            this.Pj.setResultContext("{}", e3, r2), this.Pj.processRow(t4, s2, r2[e3]);
          };
        }
        defaultFiller(t3, e2, s2) {
          const r2 = JSON.stringify(s2);
          return (t4, e3, s3) => {
            s3[e3] = JSON.parse(r2);
          };
        }
        getArrSeed(t3) {
          const e2 = t3.templateVal && t3.templateVal.length > 1 ? t3.templateVal[1] : 1;
          if ("set" == e2) return (t4, e3, s2) => {
            e3 in t4 ? Array.isArray(t4[e3]) && (t4[e3] = new Set(t4[e3])) : t4[e3] = /* @__PURE__ */ new Set(), t4[e3].add(s2);
          };
          if (0 == e2) return (t4, e3, s2) => {
            e3 in t4 || (t4[e3] = []), t4[e3].push(s2);
          };
          if (this.isNumeric(e2)) {
            const t4 = /* @__PURE__ */ new Map();
            return (s2, r2, o2) => {
              r2 in s2 || (s2[r2] = []), t4.has(s2[r2]) || t4.set(s2[r2], /* @__PURE__ */ new Map());
              const i4 = t4.get(s2[r2]);
              i4.has(o2) || i4.set(o2, 0);
              const n2 = i4.get(o2);
              n2 < e2 && (s2[r2].push(o2), i4.set(o2, n2 + 1));
            };
          }
        }
        isNumeric(t3) {
          return !isNaN(parseFloat(t3)) && isFinite(t3) && "" !== t3;
        }
      }
      s.prototype[","] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          const n2 = t3(s2, i4);
          e2.ignore(n2, r2, s2) || (o2[r2] = n2);
        };
      }, s.prototype[",()"] = s.prototype[","], s.prototype[",[]"] = s.prototype[","], s.prototype[",(]"] = s.prototype[","], s.prototype["[],"] = function(t3, e2) {
        const s2 = this.getArrSeed(e2);
        if (s2) return (r2, o2, i4, n2) => {
          const l2 = t3(r2, n2);
          e2.ignore(l2, o2, r2, n2) || s2(i4, o2, l2);
        };
        e2.errors.push(["val", "INVALID-[]-OPTION"]);
      }, s.prototype["[],()"] = s.prototype["[],"], s.prototype["[],[]"] = function(t3, e2) {
        const s2 = this.getArrSeed(e2);
        return (r2, o2, i4, n2) => {
          const l2 = t3(r2, n2);
          if (Array.isArray(l2)) for (const t4 of l2) e2.ignore(t4, o2, r2, n2) || s2(i4, o2, t4);
          else n2.errors.push([e2, "NON-ARRAY-VALS", r2]);
        };
      }, s.prototype["[],(]"] = s.prototype["[],[]"], s.prototype["[{}]"] = function(t3, e2) {
        this.Pj.parseTemplate(t3, e2.inheritedIgnore, e2.lineage);
        const s2 = e2.templateVal && e2.templateVal.length > 1 ? e2.templateVal[1] : "";
        if (!s2) return (e3, s3, r2) => {
          this.Pj.setResultContext("[]", s3, r2);
          const o2 = this.Pj.setResultContext("{}", r2[s3].length, r2[s3]);
          this.Pj.processRow(e3, t3, o2);
        };
        if ("string" == typeof s2) {
          const [r2, o2] = this.Pj.converter.default(this.Pj, Object.assign({}, { templateVal: s2 }), e2.inheritedIgnore, s2);
          return o2.aggr || o2.skip || o2.timing ? void e2.errors.push(["val", "INVALID-[{}]-OPTION-TOKEN"]) : (o3, i4, n2, l2) => {
            const c2 = this.Pj.setResultContext("[]", i4, n2, true), p = this.Pj.contexts.get(c2).tracker, h = r2(o3, l2), u = "]" == s2.slice(-1) ? h : [h];
            if (Array.isArray(u)) for (const e3 of u) if (p.has(e3)) this.Pj.processRow(o3, t3, p.get(e3));
            else {
              const s3 = this.Pj.setResultContext("{}", c2.length, c2, false, e3, o3, t3);
              s3 && (p.set(e3, s3), this.Pj.processRow(o3, t3, s3));
            }
            else l2.errors.push([e2, "NON-ARRAY-VALS", o3]);
          };
        }
        e2.errors.push(["val", "INVALID-[{}]-OPTION"]);
      }, s.prototype["[[,]]"] = function(t3, e2) {
        const s2 = [];
        for (const r2 of t3) {
          const t4 = Object.assign({}, e2, { templateVal: r2 });
          s2.push(this.getFxn(t4, e2.inheritedIgnore));
        }
        return "map" != (e2.templateVal[1] ? e2.templateVal[1] : "") ? (t4, e3, r2) => {
          e3 in r2 || (r2[e3] = []);
          const o2 = [];
          for (const e4 in s2) s2[+e4](t4, +e4, o2);
          r2[e3].push(o2);
        } : (t4, e3, r2) => {
          e3 in r2 ? r2[e3] instanceof Map || (r2[e3] = new Map(r2[e3])) : r2[e3] = /* @__PURE__ */ new Map();
          const o2 = [];
          s2[0](t4, 0, o2), r2[e3].has(o2[0]) && (o2[1] = r2[e3].get(o2[0])), s2[1](t4, 1, o2), r2[e3].set(o2[0], o2[1]);
        };
      }, s.prototype["+,"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          r2 in o2 || (o2[r2] = 0);
          const n2 = t3(s2, i4);
          e2.ignore(n2, r2, s2, i4) || (this.isNumeric(n2) ? o2[r2] += +n2 : i4.errors.push([e2, "NON-NUMERIC-INCREMENT", s2]));
        };
      }, s.prototype["+,()"] = s.prototype["+,"], s.prototype["+,[]"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          r2 in o2 || (o2[r2] = 0);
          const n2 = t3(s2, i4);
          if (Array.isArray(n2)) for (const t4 of n2) e2.ignore(t4, r2, s2, i4) || (this.isNumeric(t4) ? o2[r2] += +t4 : i4.errors.push([e2, "NON-NUMERIC-INCREMENT", s2]));
          else e2.errors.push(["val", "NON-ARRAY-VALS", s2]);
        };
      }, s.prototype["+,(]"] = s.prototype["+,[]"], s.prototype["-,"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          r2 in o2 || (o2[r2] = 0);
          const n2 = t3(s2, i4);
          e2.ignore(n2, r2, s2, i4) || (this.isNumeric(n2) ? o2[r2] += -n2 : i4.errors.push([e2, "NON-NUMERIC-DECREMENT", s2]));
        };
      }, s.prototype["-,()"] = s.prototype["-,"], s.prototype["-,[]"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          const n2 = t3(s2, i4);
          if (Array.isArray(n2)) {
            r2 in o2 || (o2[r2] = 0);
            for (const t4 of n2) e2.ignore(t4, r2, s2, i4) || (o2[r2] += -t4);
          } else e2.errors.push(["val", "NON-ARRAY-VALS", s2]);
        };
      }, s.prototype["-,(]"] = s.prototype["-,[]"], s.prototype["<,"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          const n2 = t3(s2, i4);
          if (e2.ignore(n2, r2, s2, i4)) return;
          const l2 = +n2;
          this.isNumeric(l2) ? r2 in o2 ? o2[r2] < l2 && (o2[r2] = l2) : o2[r2] = l2 : i4.errors.push([e2, "NON-NUMERIC-THAN", s2]);
        };
      }, s.prototype["<,()"] = s.prototype["<,"], s.prototype["<,[]"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          const n2 = t3(s2, i4);
          if (Array.isArray(n2)) for (const t4 of n2) {
            if (e2.ignore(t4, r2, s2, i4)) return;
            if (!this.isNumeric(t4)) return void i4.errors.push([e2, "NON-NUMERIC-THAN", s2]);
            const n3 = +t4;
            r2 in o2 ? o2[r2] < n3 && (o2[r2] = n3) : o2[r2] = n3;
          }
          else e2.errors.push(["val", "NON-ARRAY-VALS", s2]);
        };
      }, s.prototype["<,(]"] = s.prototype["<,[]"], s.prototype[">,"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          const n2 = t3(s2, i4);
          e2.ignore(n2, r2, s2, i4) || (this.isNumeric(n2) ? r2 in o2 ? o2[r2] > n2 && (o2[r2] = n2) : o2[r2] = n2 : i4.errors.push([e2, "NON-NUMERIC-THAN", s2]));
        };
      }, s.prototype[">,()"] = s.prototype[">,"], s.prototype[">,[]"] = function(t3, e2) {
        return (s2, r2, o2, i4) => {
          const n2 = t3(s2, i4);
          if (Array.isArray(n2)) for (const t4 of n2) {
            if (e2.ignore(t4, r2, s2, i4)) return;
            if (!this.isNumeric(t4)) return void i4.errors.push([e2, "NON-NUMERIC-THAN", s2]);
            const n3 = +t4;
            r2 in o2 ? o2[r2] > n3 && (o2[r2] = n3) : o2[r2] = n3;
          }
          else e2.errors.push(["val", "NON-ARRAY-VALS", s2]);
        };
      }, s.prototype[">,(]"] = s.prototype[">,[]"];
      class r {
        constructor(t3) {
          this.Pj = t3, this.allErrSet = /* @__PURE__ */ new Set(), this.allErrObj = /* @__PURE__ */ Object.create(null), this.mode = { input: "{}", result: "{}-", root: "", console: "{}" }, this.modeKeys = ["input", "result", "root", "console"], this.setMode();
        }
        setMode(t3 = {}) {
          Array.isArray(t3) ? this.modeKeys.forEach((e2, s2) => this.mode[e2] = t3[s2]) : "object" == typeof t3 && this.modeKeys.forEach((e2) => {
            e2 in t3 && (this.mode[e2] = t3[e2]);
          });
        }
        clear(t3 = {}) {
          this.allErrSet.clear(), this.allErrObj = /* @__PURE__ */ Object.create(null), this.setMode(t3);
        }
        markErrors(t3, e2) {
          if (!e2) return;
          const s2 = "[]" == this.mode.result.slice(0, 2) ? [] : {};
          for (const r2 in e2.filler.inputs) {
            const o2 = e2.filler.inputs[r2];
            for (const e3 of o2.errors) {
              const [r3, i4, n2] = e3;
              "key" == r3 ? (this.track(s2, e3, o2.lineage.join(this.Pj.delimit)), this.mode.input && (t3["{{ " + i4 + " }} " + o2.term] = o2.templateVal)) : "val" == r3 && (Array.isArray(o2.templateVal) ? (this.track(s2, e3, o2.templateVal[0]), this.mode.input && (t3[o2.term] = ["{{ " + i4 + " }} ", ...o2.templateVal])) : "string" == typeof o2.templateVal ? (this.track(s2, e3, o2.templateVal), this.mode.input && (t3[o2.term] = "{{ " + i4 + " }} " + o2.templateVal)) : (this.track(s2, e3, o2.templateVal), this.mode.input && (t3[o2.term] = "{{ " + i4 + " }} ")));
            }
          }
          if (e2.errors.length) {
            const r2 = {};
            t3["@errors"] = r2;
            for (const t4 of e2.errors) {
              const [e3, o2, i4] = t4;
              if (this.track(s2, t4, e3.term), !this.mode.input) continue;
              const n2 = "{{ " + o2 + " }} " + e3.term;
              n2 in r2 || (r2[n2] = 0), r2[n2] += 1;
            }
          }
          if (e2.filler.errors.length) for (const t4 of e2.filler.errors) this.track(s2, t4, t4[2], false);
          Object.keys(s2).length && this.mode.result && (t3["@errors"] = s2);
        }
        track(t3, e2, s2, r2 = true) {
          this.allErrSet.add(e2), this.trackAsObj(this.allErrObj, e2, s2), r2 && "-" == this.mode.result.slice(-1) || (Array.isArray(t3) ? t3.push(e2) : this.trackAsObj(t3, e2, s2));
        }
        trackAsObj(t3, e2, s2) {
          const [r2, o2, i4] = e2;
          o2 in t3 || (t3[o2] = /* @__PURE__ */ Object.create(null)), s2 in t3[o2] || (t3[o2][s2] = i4 ? [] : 0), i4 ? t3[o2][s2].includes(i4) || t3[o2][s2].push(i4) : t3[o2][s2] += 1;
        }
        log() {
          const t3 = [...this.allErrSet];
          if (t3.length) {
            if (this.mode.root) {
              const e2 = this.mode.root;
              this.Pj.tree["@errorsAll"] = "[]" == e2 ? t3 : this.allErrObj;
            }
            if (this.mode.console) {
              const e2 = this.mode.console.slice(0, 2);
              console.log("[]" == e2 ? t3 : this.allErrObj);
            }
          }
        }
      }
      function o(t3, e2) {
        const s2 = t3.skipSymbols.includes(e2[0]) ? e2[0] : "", r2 = e2.slice(s2.length, s2.length + 3), o2 = t3.timeSymbols.includes(r2) ? r2 : "", i4 = s2.length + o2.length, n2 = e2[i4], l2 = e2.slice(-2), c2 = t3.aggrSymbols.includes(n2) && n2 != e2 ? n2 : "", p = t3.convSymbols.includes(l2) && l2 != e2 ? l2 : "", h = c2 && p ? e2.slice(i4 + 1, -2) : c2 ? e2.slice(i4 + 1) : p ? e2.slice(i4, -2) : s2 || o2 ? e2.slice(i4) : e2, u = t3.subsSymbols.includes(h[0]) ? h[0] : "", a = c2 + u + p, f = u ? h.slice(1) : h;
        return [h, a, { skip: s2, time: o2, aggr: c2, subs: u, stem: f, conv: p, subterm: h }, t3.steps.indexOf(o2)];
      }
      const i3 = { "#": function(t3, e2, s2) {
        t3.commentedTerms.has(s2) || t3.commentedTerms.set(s2, []), t3.commentedTerms.get(s2).push(e2);
      }, "*": function(t3, e2, s2) {
        t3.focusTemplate[s2.term.slice(1)] = s2.templateVal;
      }, "": function(t3, e2, s2) {
        return t3.valFiller.isNumeric(e2) ? () => +e2 : () => e2;
      }, $: function(t3, e2, s2) {
        if ("$" == e2 || e2 == "$" + t3.delimit) return (t4) => t4;
        if (e2.includes(t3.delimit)) {
          const s3 = e2.slice(1).split(t3.delimit);
          "" == s3[0] && s3.shift();
          const r2 = (t4, e3) => t4 ? t4[e3] : void 0;
          return (t4) => s3.reduce(r2, t4);
        }
        {
          const t4 = e2.slice(1);
          return (e3) => e3[t4];
        }
      }, "=": function(t3, e2, s2) {
        const r2 = e2.slice(1).split(t3.delimit).reduce((t4, e3) => t4 && e3 in t4 ? t4[e3] : void 0, t3.opts["="]);
        if (r2) return (t4) => r2;
        s2.errors.push(["val", "MISSING-EXTERNAL-SUBS"]);
      }, "@": function(t3, e2, s2) {
        if (!t3.reserved.opts.includes(e2)) {
          if ("@" == e2 || e2 == "@" + t3.delimit) return (t4, e3) => e3.self;
          if (e2.includes(t3.delimit)) {
            const r2 = e2.split(t3.delimit), o2 = (r3, o3) => {
              if ("@" == o3[0] && o3.length > 1 && !t3.reserved.contexts.includes(o3)) return s2.errors.push(["val", "UNRECOGNIZED-CONTEXT-" + e2, s2.lineage.join(".") + "." + o3]), [null, null];
              const [i4, n2] = r3;
              return i4 && o3 ? "@" == o3 ? [n2.self, n2] : "@values" == o3 ? [Object.values(i4), n2] : "@" == o3[0] ? [n2[o3.slice(1)], t3.contexts.get(n2[o3.slice(1)])] : [i4[o3], t3.contexts.get(i4[o3])] : [null, null];
            };
            return (t4, e3) => r2.reduce(o2, [e3.self, e3])[0];
          }
          if (t3.reserved.contexts.includes(e2)) {
            const t4 = e2.slice(1);
            return (e3, s3) => s3[t4];
          }
          s2.errors.push(["val", "UNRECOGNIZED-CONTEXT-" + e2]);
        }
      }, "&": function(t3, e2, s2) {
        const r2 = e2.slice(1).split(t3.delimit), o2 = r2.shift();
        if (r2.length) {
          if (1 == r2.length) {
            const e3 = r2[0];
            return () => {
              const s3 = t3.joins.get(o2);
              return s3 ? s3[e3] : null;
            };
          }
          {
            const e3 = (t4, e4) => t4 ? t4[e4] : null;
            t3.joins.get(o2);
            return (s3) => r2.reduce(e3, t3.joins.get(o2));
          }
        }
        return () => t3.joins.get(o2);
      } }, n = { "": function(t3, e2, s2) {
        return t3;
      }, "()": function(t3, e2, s2) {
        if ("=" == s2.subs) {
          const r2 = t3();
          return "function" != typeof r2 ? void e2.errors.push(["val", "NOT-A-FUNCTION", s2.subs + s2.term + s2.conv]) : r2;
        }
        return (s3, r2) => {
          const o2 = t3(s3, r2);
          if ("function" == typeof o2) return o2(s3, r2);
          e2.errors.push(["val", "NOT-A-FUNCTION", s3]);
        };
      } };
      n["[]"] = n[""], n["(]"] = n["()"];
      var l = Object.freeze({ __proto__: null, default: function(t3, e2, s2, r2) {
        const [l2, c2, p] = o(t3, r2);
        if (t3.reserved.opts.includes(l2)) return [];
        const h = l2 + p.conv;
        if (e2.ignore = h in s2 ? s2[h] : s2["@"], p.skip && "~" != p.skip) return i3[p.skip](t3, l2, e2), [];
        if (p.subs in i3) {
          const s3 = i3[p.subs](t3, l2, e2);
          return s3 ? [n[p.conv](s3, e2, p), p] : [];
        }
        return e2.errors.push(["val", "UNSUPPORTED-SYMBOL-" + p.subs]), [];
      }, parseTerm: o, subs: i3, conv: n });
      class c {
        constructor(o2 = {}) {
          this.defaultOpts = { template: {}, seed: "{}", "=": {} }, this.opts = Object.assign(this.defaultOpts, o2), this.delimit = ".", this.subsSymbols = ["$", "=", "@", "&"], this.convSymbols = ["()", "[]", "(]"], this.aggrSymbols = ["+", "-", "<", ">"], this.timePost = ["_0:", "_1:", "_2:", "_3:", "_4:", "_5:", "_6:", "_7:", "_8:", "_9:"], this.timeSymbols = [":__", "_:_", "__:", ...this.timePost], this.skipSymbols = ["#", "*", "~"], this.steps = [":__", "", "_:_"], this.errors = new r(this), this.reserved = new t2(this), this.keyFiller = new e(this), this.valFiller = new s(this), this.commentedTerms = /* @__PURE__ */ new Map(), this.joins = /* @__PURE__ */ new Map(), this.fillers = /* @__PURE__ */ new Map(), this.contexts = /* @__PURE__ */ new Map(), this.temps = /* @__PURE__ */ new Map(), this.refresh();
        }
        refresh(t3 = {}) {
          this.times = { start: +/* @__PURE__ */ new Date() }, Object.assign(this.opts, t3), "string" != typeof this.opts.template && (this.opts.template = JSON.stringify(this.opts.template));
          const e2 = JSON.parse(this.opts.template);
          this.errors.clear(e2["@errmode"]), e2["@delimit"] && (this.delimit = e2["@delimit"]), this.commentedTerms.clear(), this.joins.clear(), this.fillers.clear(), this.contexts.clear(), this.temps.clear(), delete this.tree, this.tree = this.setResultContext(this.opts.seed), this.focusTemplate = /* @__PURE__ */ Object.create(null), this.parseTemplate(e2, { "@": this.reserved.notDefined }), this.times.parse = +/* @__PURE__ */ new Date() - this.times.start, Object.keys(this.focusTemplate).length ? (this.parseTemplate(this.focusTemplate, { "@": this.reserved.notDefined }), this.template = this.focusTemplate) : this.template = e2, this.postLoopTerms = /* @__PURE__ */ Object.create(null), this.done = [], this.opts.data && this.add(this.opts.data, false), this.errors.log(this.fillers);
        }
        setResultContext(t3, e2 = null, s2 = null, r2 = false, o2, i4 = null, n2 = null) {
          const l2 = null !== e2 && e2 in s2 ? s2[e2] : JSON.parse(t3);
          if (this.contexts.has(l2)) return l2;
          const c2 = { branch: e2, parent: s2, context: this.contexts.get(s2), self: l2, root: this.tree ? this.tree : l2, joins: this.joins, errors: [], key: o2 };
          if (r2 && (c2.tracker = /* @__PURE__ */ new Map()), i4 && n2) {
            const t4 = this.fillers.get(n2);
            if (!t4["@before"](i4, c2)) return;
            if (t4["@join"] && !t4["@join"](i4, c2)) return;
          }
          return this.contexts.set(l2, c2), null !== e2 && (s2[e2] = l2), l2;
        }
        parseTemplate(t3, e2, s2 = []) {
          const r2 = /* @__PURE__ */ Object.create(null);
          r2.inputs = /* @__PURE__ */ Object.create(null), r2["@before"] = this.reserved.trueFxn, r2["@after"] = this.reserved.trueFxn, r2.postTerms = {}, r2.errors = [];
          const i4 = this.reserved["@ignore"](t3, e2, r2);
          r2["@ignore"] = i4, this.fillers.set(t3, r2);
          const n2 = this.steps.map((t4) => []);
          for (const e3 in t3) {
            const [l2, c2, p, h] = o(this, e3), u = t3[e3], a = r2.inputs[e3] = { term: e3, subterm: l2, symbols: c2, keyTokens: p, templateVal: u, lineage: [...s2, e3], inheritedIgnore: i4, errors: [] };
            "@()" == c2 ? this.reserved.setFxn(l2, a, r2, u) : (a.keyFxn = this.keyFiller.getFxn(a, i4), a.keyFxn && (a.valFxn = this.valFiller.getFxn(a, i4), "__:" == p.time || this.timePost.includes(p.time) ? (r2.postTerms[p.time] || (r2.postTerms[p.time] = []), r2.postTerms[p.time].includes(e3) || r2.postTerms[p.time].push(e3)) : n2[h].push(e3)));
          }
          r2.steps = n2.filter((t4) => t4.length);
        }
        add(t3, e2 = true) {
          this.times.start || (this.times.start = +/* @__PURE__ */ new Date()), e2 && this.errors.clear(), this.joins.clear();
          for (const e3 of t3) if (this.split) for (const t4 of this.split(e3)) this.processRow(t4, this.template, this.tree), this.joins.clear();
          else this.processRow(e3, this.template, this.tree), this.joins.clear();
          this.processResult(this.tree);
          for (const t4 of this.timePost) if (this.postLoopTerms[t4]) for (const e3 of this.postLoopTerms[t4]) this.postLoop(e3.self, e3, t4);
          for (const t4 of this.done) t4.done(t4.self, t4);
          for (const [t4, e3] of this.temps) for (const s2 of e3) delete t4[s2];
          this.times.total = +/* @__PURE__ */ new Date() - this.times.start, delete this.times.start, e2 && this.errors.log();
        }
        processRow(t3, e2, s2) {
          const r2 = this.contexts.get(s2), o2 = this.fillers.get(e2);
          if (r2.filler = o2, o2["@before"](t3, r2) && (!o2["@join"] || o2["@join"](t3, r2))) {
            for (const e3 of o2.steps) for (const i4 of e3) {
              const e4 = o2.inputs[i4];
              if (e4.keyFxn && e4.valFxn) {
                const o3 = e4.keyFxn(t3, r2);
                for (const i5 of o3) e4.valFxn(t3, i5, s2, r2), "~" == e4.keyTokens.skip && (this.temps.has(s2) || this.temps.set(s2, /* @__PURE__ */ new Set()), this.temps.get(s2).add(i5));
              }
            }
            o2["@after"](t3, r2), o2["@dist"] && o2["@dist"](r2), o2["@done"] && !this.done.includes(r2) && (r2.done = o2["@done"], this.done.push(r2));
            for (const t4 in o2.postTerms) this.postLoopTerms[t4] || (this.postLoopTerms[t4] = []), this.postLoopTerms[t4].includes(r2) || this.postLoopTerms[t4].push(r2);
            return true;
          }
        }
        postLoop(t3, e2, s2 = "__:") {
          if (e2 && e2.filler && e2.filler.postTerms[s2]) for (const r2 of e2.filler.postTerms[s2]) {
            const s3 = e2.filler.inputs[r2];
            if (s3.keyFxn && s3.valFxn) {
              const r3 = s3.keyFxn(null, e2);
              for (const o2 of r3) s3.valFxn(null, o2, t3, e2);
            }
          }
        }
        processResult(t3) {
          const e2 = this.contexts.get(t3);
          this.postLoop(t3, e2, "__:");
          for (const e3 in t3) {
            const s2 = t3[e3];
            if (s2) {
              if (Array.isArray(s2) || s2 instanceof Set || s2 instanceof Map) for (const t4 of s2) "object" == typeof t4 && this.processResult(t4);
              else if ("object" == typeof s2) {
                const t4 = this.contexts.get(s2);
                t4 && t4["@dist"] && t4["@dist"](s2), this.processResult(s2);
              }
            }
          }
          e2 && e2.filler && this.errors.markErrors(t3, e2);
        }
        copyResult(t3, e2 = {}) {
          if (arguments.length && void 0 === t3) return;
          const s2 = arguments.length ? t3 : this.tree;
          for (const t4 in s2) {
            const r2 = s2[t4];
            if (r2 instanceof Set || r2 instanceof Map) e2[t4] = [...r2];
            else if (Array.isArray(r2)) {
              e2[t4] = [];
              for (const s3 of r2) if (Array.isArray(s3)) {
                const r3 = [];
                e2[t4].push(r3), this.copyResult(s3, r3);
              } else if (s3 && "object" == typeof s3) {
                const r3 = /* @__PURE__ */ Object.create(null);
                e2[t4].push(r3), this.copyResult(s3, r3);
              } else e2[t4] = JSON.parse(JSON.stringify(r2));
            } else r2 && "object" == typeof r2 ? (e2[t4] = /* @__PURE__ */ Object.create(null), this.copyResult(r2, e2[t4])) : e2[t4] = JSON.parse(JSON.stringify(r2));
          }
          return e2;
        }
      }
      return c.prototype.converter = l, c;
    });
  }
});

// tw/categorical.ts
var termType = "categorical";
var CategoricalBase = class _CategoricalBase {
  // option to fill-in/mutate the input raw term object in-place
  // - does not have to construct, but may require forced type casting in consumer code
  static fill(term) {
    if (term instanceof _CategoricalBase) return;
    _CategoricalBase.validate(term);
    if (!term.name) term.name = term.id;
    if (!term.groupsetting) term.groupsetting = { disabled: false };
    if (!term.values) term.values = {};
  }
  static validate(term) {
    if (typeof term !== "object") throw "term is not an object";
    if (term.type != termType) throw `incorrect term.type='${term?.type}', expecting '${termType}'`;
  }
  // option to construct an object instance and not mutate the input raw term
  // - will be used instead of tw.term literal object
  constructor(term) {
    _CategoricalBase.validate(term);
    this.id = term.id;
    this.name = term.name || term.id;
    this.groupsetting = term.groupsetting || { disabled: false };
    this.values = term.values || {};
  }
};

// tw/snp.ts
var termType2 = "snp";
var SnpBase = class _SnpBase {
  // option to construct an object instance and not mutate the input raw term
  // - will be used instead of tw.term literal object
  constructor(term) {
    this.type = termType2;
    _SnpBase.validate(term);
    this.id = term.id;
    this.name = term.name;
    this.chr = term.chr;
    this.start = term.start;
    this.stop = term.stop;
    this.ref = term.ref;
    this.alt = term.alt;
    this.groupsetting = term.groupsetting || { disabled: false };
    this.values = term.values || {};
  }
  // option to fill-in/mutate the input raw term object in-place
  // - does not have to construct, but may require forced type casting in consumer code
  static fill(term) {
    if (term instanceof _SnpBase) return;
    _SnpBase.validate(term);
    if (!term.groupsetting) term.groupsetting = { disabled: false };
    if (!term.values) term.values = {};
  }
  static validate(term) {
    if (typeof term !== "object") throw "term is not an object";
    if (term.type != termType2) throw `incorrect term.type='${term?.type}', expecting '${termType2}'`;
    if (!term.id || !term.name) throw "missing snp id/name";
    if (!term.chr || !Number.isInteger(term.start) || !Number.isInteger(term.stop))
      throw "incomplete position information";
    if (!term.ref || !term.alt) throw "missing allele information";
  }
};

// tw/singleCellCellType.ts
var termType3 = SINGLECELL_CELLTYPE;
var SingleCellCellTypeBase = class _SingleCellCellTypeBase {
  constructor(term) {
    this.type = termType3;
    _SingleCellCellTypeBase.validate(term);
    this.sample = term.sample;
    this.plot = term.plot || "";
    this.groupsetting = term.groupsetting || { disabled: false };
    this.values = term.values || {};
  }
  static fill(term) {
    if (term instanceof _SingleCellCellTypeBase) return;
    _SingleCellCellTypeBase.validate(term);
    if (!term.groupsetting) term.groupsetting = { disabled: false };
    if (!term.values) term.values = {};
    if (typeof term.sample == "string") term.sample = { sID: term.sample };
  }
  static validate(term) {
    if (!term || typeof term !== "object") throw new Error("term is not an object");
    if (term.type != termType3) throw new Error(`incorrect term.type='${term?.type}', expecting '${termType3}'`);
    if (!term?.sample) throw new Error("missing term.sample");
  }
};

// tw/TwBase.ts
var TwBase = class {
  constructor(tw, opts) {
    this.isAtomic = true;
    this.#isFrozen = false;
    this.#tw = tw;
    this.type = tw.type;
    this.isAtomic = true;
    this.$id = typeof tw.$id == "string" ? tw.$id : get$id();
    if (tw.label) this.label = tw.label;
    if (tw.legend) this.legend = tw.legend;
    if (tw.exclude) this.exclude = tw.exclude;
    if (tw.sortSamples) this.sortSamples = tw.sortSamples;
    if (tw.minNumSamples) this.minNumSamples = tw.minNumSamples;
    if (tw.valueFilter) this.valueFilter = tw.valueFilter;
    if (tw.values) this.values = tw.values;
    if (opts.addons?.[this.type]) {
      Object.defineProperties(this, opts.addons[this.type]);
    }
  }
  #tw;
  #isFrozen;
  static setHiddenValues(q, term) {
    if (q.hiddenValues) return;
    q.hiddenValues = {};
    if (term.values) {
      for (const k in term.values) {
        if (term.values[k].uncomputable) q.hiddenValues[k] = 1;
      }
    }
  }
  getTw() {
    return this.#tw;
  }
  render(a) {
    console.log(a);
    throw `should implement this method in subclass code, as needed`;
  }
  getStatus(_, __) {
    return { text: "" };
  }
  getMinCopy(override = {}) {
    const tw = this.#tw;
    const copy = { type: tw.type, term: {}, q: structuredClone(override.q || tw.q) };
    if (tw.$id) copy.$id = tw.$id;
    if (tw.term) {
      if (isDictionaryType(tw.term.type)) {
        if (tw.term.id) copy.term.id = tw.term.id;
        if (tw.term.name) copy.term.name = tw.term.name;
        if (tw.term.type) copy.term.type = tw.term.type;
        if (tw.term.groupsetting) copy.term.groupsetting = tw.term.groupsetting;
      } else {
        copy.term = structuredClone(tw.term);
        if (copy.term.bins?.default?.isDummyPreset) delete copy.term.bins;
      }
    }
    if (copy.q) {
      delete copy.q.isAtomic;
    }
    return copy;
  }
  deepFreeze() {
    if (this.#isFrozen) return this;
    deepFreeze(this);
    this.#isFrozen = true;
    return this;
  }
};
var idSuffix = `_${Math.random().toString().slice(-5)}_${Date.now().toString().slice(-8, -3)}`;
var i = 0;
function get$id() {
  return `TwBase_${i++}_${idSuffix}`;
}

// tw/geneExpression.ts
var termType4 = "geneExpression";
var GeneExpBase = class _GeneExpBase {
  // option to fill-in/mutate the input raw term object in-place
  // - does not have to construct, but may require forced type casting in consumer code
  static async fill(term, opts) {
    _GeneExpBase.validate(term);
    if (!term.name) {
      term.unit = getGEunit(opts.vocabApi);
      const name = `${term.gene} ${term.unit}`;
      term.name = name;
    }
  }
  static validate(term) {
    if (typeof term !== "object") throw "term is not an object";
    if (term.type != termType4) throw `incorrect term.type='${term?.type}', expecting '${termType4}'`;
    if (term.type != "geneExpression") throw "unexpected term.type";
    if (typeof term !== "object") throw "term is not an object";
    if (!term.gene && !term.name) throw "no gene or name present";
    if (!term.gene || typeof term.gene != "string") throw "geneExpression term.gene must be non-empty string";
  }
  // option to construct an object instance and not mutate the input raw term
  // - will be used instead of term literal object
  constructor(term, opts) {
    _GeneExpBase.validate(term);
    this.gene = term.gene || term.name;
    this.unit = term.unit || getGEunit(opts.vocabApi);
    this.name = term.name || `${term.gene} ${this.unit}`;
  }
};
function getGEunit(vocabApi) {
  return vocabApi.termdbConfig.queries.geneExpression?.unit || "Gene Expression";
}

// tw/isoformExpression.ts
var IsoformExpBase = class _IsoformExpBase {
  // option to fill-in/mutate the input raw term object in-place
  static async fill(term, opts) {
    _IsoformExpBase.validate(term);
    if (!term.name) {
      term.unit = opts.vocabApi.termdbConfig.queries.isoformExpression?.unit || "Isoform Expression";
      const name = `${term.isoform} ${term.unit}`;
      term.name = name;
    }
  }
  static validate(term) {
    if (typeof term !== "object") throw "term is not an object";
    if (term.type != ISOFORM_EXPRESSION) throw `incorrect term.type='${term?.type}', expecting '${ISOFORM_EXPRESSION}'`;
    if (!term.isoform && !term.name) throw "no isoform or name present";
    if (!term.isoform || typeof term.isoform != "string")
      throw "isoformExpression term.isoform must be non-empty string";
  }
  constructor(term, opts) {
    _IsoformExpBase.validate(term);
    this.isoform = term.isoform || term.name;
    this.unit = term.unit || opts.vocabApi.termdbConfig.queries.isoformExpression?.unit || "Isoform Expression";
    this.name = term.name || `${term.isoform} ${this.unit}`;
  }
};

// tw/metaboliteIntensity.ts
var termType5 = "metaboliteIntensity";
var MetaboliteIntensityBase = class _MetaboliteIntensityBase {
  // option to construct an object instance and not mutate the input raw term
  // - will be used instead of term literal object
  constructor(term) {
    this.type = termType5;
    _MetaboliteIntensityBase.validate(term);
    this.metabolite = term.metabolite || term.name;
    this.name = term.name || term.metabolite;
    this.unit = term.unit || "";
    if (term.bins) this.bins = term.bins;
  }
  // option to fill-in/mutate the input raw term object in-place
  // - does not have to construct, but may require forced type casting in consumer code
  static async fill(term) {
    _MetaboliteIntensityBase.validate(term);
    if (!term.metabolite) term.metabolite = term.name;
    else if (!term.name) term.name = term.metabolite;
  }
  static validate(term) {
    if (term.type != "metaboliteIntensity") throw "unexpected term.type";
    if (typeof term !== "object") throw "term is not an object";
    if (!term.name && !term.metabolite) throw `missing both term.name and metabolite`;
  }
};

// tw/proteomeAbundance.ts
var termType6 = "proteomeAbundance";
var ProteomeAbundanceBase = class _ProteomeAbundanceBase {
  // option to construct an object instance and not mutate the input raw term
  // - will be used instead of term literal object
  constructor(term) {
    this.type = termType6;
    _ProteomeAbundanceBase.validate(term);
    this.protein = term.protein || term.name;
    this.name = term.name || term.protein;
    this.unit = term.unit || "";
    if (term.bins) this.bins = term.bins;
  }
  // option to fill-in/mutate the input raw term object in-place
  // - does not have to construct, but may require forced type casting in consumer code
  static async fill(term) {
    _ProteomeAbundanceBase.validate(term);
    if (!term.protein) term.protein = term.name;
    else if (!term.name) term.name = term.protein;
  }
  static validate(term) {
    if (term.type != "proteomeAbundance") throw "unexpected term.type";
    if (typeof term !== "object") throw "term is not an object";
    if (!term.name && !term.protein) throw `missing both term.name and protein`;
  }
};

// tw/date.ts
var termType7 = "date";
var DateBase = class _DateBase {
  // option to construct an object instance and not mutate the input raw term
  // - will be used instead of term literal object
  constructor(term) {
    this.type = termType7;
    _DateBase.validate(term);
  }
  // option to fill-in/mutate the input raw term object in-place
  // - does not have to construct, but may require forced type casting in consumer code
  static async fill(term) {
    this.validate(term);
  }
  static validate(term) {
    if (term.type != "date") throw "unexpected term.type";
    if (typeof term !== "object") throw "term is not an object";
    if (!term.name || typeof term.name != "string") throw "invalid date term.name";
  }
};

// tw/ssGSEA.ts
var termType8 = "ssGSEA";
var SsGSEABase = class _SsGSEABase {
  // option to construct an object instance and not mutate the input raw term
  // - will be used instead of term literal object
  constructor(term) {
    this.type = termType8;
    _SsGSEABase.validate(term);
    this.id = term.id;
    this.name = term.name || term.id;
    this.bins = term.bins;
    this.unit = term.unit;
  }
  // option to fill-in/mutate the input raw term object in-place
  // - does not have to construct, but may require forced type casting in consumer code
  static async fill(term) {
    _SsGSEABase.validate(term);
    if (!term.name) term.name = term.id;
  }
  static validate(term) {
    if (term.type != "ssGSEA") throw `unexpected term.type='$term.type', should be '${termType8}'`;
    if (typeof term !== "object") throw "term is not an object";
    if (!term.id) throw "term.id missing";
  }
};

// tw/dnaMethylation.ts
var termType9 = DNA_METHYLATION;
var DnaMethylationBase = class _DnaMethylationBase {
  static async fill(term, opts) {
    _DnaMethylationBase.validate(term);
    if (!term.id) term.id = makeDNAMethTermId(term);
    if (!term.name) {
      term.unit = getDNAMethUnit(term.genomicFeatureType, opts.vocabApi);
      term.name = getDNAMethTermName(term);
    }
  }
  static validate(term) {
    if (!term || typeof term !== "object") throw "Term is missing or not an object";
    if (term.type != termType9) throw `Incorrect term.type='${term?.type}', expecting '${termType9}'`;
    if (!term.chr || !Number.isInteger(term.start) || !Number.isInteger(term.stop))
      throw "Incomplete coordinate in term{}";
    if (!term.genomicFeatureType) throw "Missing term.genomicFeatureType";
    if (term.genomicFeatureType !== "gene" && term.featureName)
      throw "term.featureName required for DNA methylation term when genomicFeatureType = gene";
  }
  constructor(term, opts) {
    _DnaMethylationBase.validate(term);
    this.id = term.id || makeDNAMethTermId(term);
    this.unit = term.unit || getDNAMethUnit(term.genomicFeatureType, opts.vocabApi);
    this.name = term.name || getDNAMethTermName({ ...term, id: this.id }, this.unit);
  }
};
function makeDNAMethTermId(term) {
  return `${term.chr}:${term.start}-${term.stop}`;
}
function getDNAMethUnit(genomicFeatureType, vocabApi) {
  switch (genomicFeatureType) {
    case "promoter":
      return vocabApi.termdbConfig.queries.dnaMethylation?.promoter?.unit || "Average M-value";
    case "gene":
      return vocabApi.termdbConfig.queries.dnaMethylation?.unit || "Average Beta Value";
    default:
      return vocabApi.termdbConfig.queries.dnaMethylation?.unit || "Average Beta Value";
  }
}
function getDNAMethTermName(term, termUnit, noun) {
  const unit = term.unit || termUnit;
  if (!unit) throw "Unit is required to generate term name";
  const id3 = term.id || makeDNAMethTermId(term);
  const featureName = term.featureName || id3;
  switch (term.genomicFeatureType) {
    case "promoter":
      return `${noun || "Promoter"} ${unit} (${id3})`;
    case "gene":
      return `${featureName} - Promoter ${unit} (${id3})`;
    default:
      return `${id3} ${unit}`;
  }
}

// tw/singleCellGeneExpression.ts
var termType10 = SINGLECELL_GENE_EXPRESSION;
var SingleCellGeneExpressionBase = class _SingleCellGeneExpressionBase {
  constructor(term, opts) {
    this.type = termType10;
    _SingleCellGeneExpressionBase.validate(term);
    this.gene = term.gene;
    this.sample = term.sample;
    this.unit = term.unit || getSCGEunit(opts.vocabApi);
  }
  static fill(term, opts) {
    if (term instanceof _SingleCellGeneExpressionBase) return;
    _SingleCellGeneExpressionBase.validate(term);
    if (!term.name) {
      term.unit = getSCGEunit(opts.vocabApi);
      term.name = `${term.gene} ${term.unit}`;
    }
  }
  static validate(term) {
    if (!term || typeof term !== "object") throw new Error("term is not an object");
    if (term.type != termType10) throw new Error(`incorrect term.type='${term?.type}', expecting '${termType10}'`);
    if (!term.gene && !term.name) throw new Error("no gene or name present");
    if (!term.gene || typeof term.gene != "string") throw new Error(`${termType10} term.gene must be non-empty string`);
    if (!term.sample) throw new Error("missing sample name");
  }
};
function getSCGEunit(vocabApi) {
  return vocabApi.termdbConfig.queries.singleCell.geneExpression?.unit || "Gene Expression";
}

// tw/pseudobulk.ts
var termType11 = PSEUDOBULK;
var PseudobulkBase = class _PseudobulkBase {
  constructor(term) {
    this.type = termType11;
    _PseudobulkBase.validate(term);
    this.assay = term.assay;
    this.memberId = term.memberId;
    this.category = term.category;
    this.gene = term.gene;
  }
  static fill(term) {
    if (term instanceof _PseudobulkBase) return;
    _PseudobulkBase.validate(term);
    return term;
  }
  static validate(term) {
    if (!term || typeof term !== "object") throw new Error("term is not an object");
    if (term.type != termType11) throw new Error(`incorrect term.type='${term?.type}', expecting '${termType11}'`);
    if (!term.assay || !PseudobulkAssay.includes(term.assay)) throw new Error("term.assay is missing or invalid");
    if (!term.memberId || typeof term.memberId !== "string") throw new Error("term.memberId is missing or not a string");
    if (!term.category || typeof term.category !== "string") throw new Error("term.category is missing or not a string");
    if (!term.gene || typeof term.gene !== "string") throw new Error("term.gene is missing or not a string");
  }
};

// tw/numeric.ts
var NumericBase = class _NumericBase extends TwBase {
  static {
    this.termTypes = /* @__PURE__ */ new Set([
      "integer",
      "float",
      "date",
      "geneExpression",
      "isoformExpression",
      JUNCTION,
      "metaboliteIntensity",
      "proteomeAbundance",
      "ssGSEA",
      "dnaMethylation",
      SINGLECELL_GENE_EXPRESSION,
      PSEUDOBULK
    ]);
  }
  constructor(tw, opts) {
    super(tw, opts);
    this.type = tw.type;
    this.term = tw.term;
  }
  static async fill(tw, opts = {}) {
    if (!tw.term) throw `missing tw.term, must already be filled in`;
    if (!_NumericBase.termTypes.has(tw.term.type)) throw `non-numeric term.type='${tw.term.type}'`;
    switch (tw.term.type) {
      case "integer":
      case "float":
        if (!tw.q.mode) tw.q.mode = "discrete";
        break;
      case "geneExpression":
        GeneExpBase.fill(tw.term, opts);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case "isoformExpression":
        IsoformExpBase.fill(tw.term, opts);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case JUNCTION:
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case "metaboliteIntensity":
        MetaboliteIntensityBase.fill(tw.term);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case "proteomeAbundance":
        ProteomeAbundanceBase.fill(tw.term);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case "date":
        DateBase.fill(tw.term);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case "ssGSEA":
        SsGSEABase.fill(tw.term);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case "dnaMethylation":
        DnaMethylationBase.fill(tw.term, opts);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case SINGLECELL_GENE_EXPRESSION:
        SingleCellGeneExpressionBase.fill(tw.term, opts);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
      case PSEUDOBULK:
        PseudobulkBase.fill(tw.term);
        if (!tw.q.mode) tw.q.mode = "continuous";
        break;
    }
    if (opts.defaultQ) {
      opts.defaultQ.isAtomic = true;
      tw.q.isAtomic = true;
      if (opts.defaultQ.preferredBins == "median") {
        if (!opts.defaultQ.type) opts.defaultQ.type = "custom-bin";
        else if (opts.defaultQ.type != "custom-bin") throw ".type must be custom-bin when .preferredBins=median";
      }
      copyMerge(tw.q, opts.defaultQ);
    }
    switch (tw.q.mode) {
      case "discrete":
        if (tw.q.type != "regular-bin") {
          if (Array.isArray(tw.q.lst)) tw.q.type = "custom-bin";
        }
        if (!tw.q.type) {
          if (tw.term.bins && !tw.term.bins.default?.isDummyPreset) mayFillQWithPresetBins(tw);
          else tw.q.type = "regular-bin";
        }
        break;
      case "binary":
        tw.q.type = "custom-bin";
        break;
      case "continuous":
      case "spline":
        delete tw.q.type;
        break;
      default:
        throw "numeric tw.q.mode not supported";
    }
    tw.type = tw.q.type == "regular-bin" ? "NumTWRegularBin" : tw.q.type == "custom-bin" || tw.q.mode == "binary" ? "NumTWCustomBin" : tw.q.mode == "continuous" ? "NumTWCont" : tw.q.mode == "spline" ? "NumTWSpline" : tw.type;
    switch (tw.type) {
      case "NumTWRegularBin":
        return await NumRegularBin.fill(tw, opts);
      case "NumTWCustomBin":
        return await NumCustomBins.fill(tw, opts);
      case "NumTWCont":
        return await NumCont.fill(tw);
      case "NumTWSpline":
        return await NumSpline.fill(tw);
      default:
        throw `tw.type='${tw.type} (q.mode:q.type=${tw.q.mode}:${tw.q.type}' is not supported by NumericBase.fill()`;
    }
  }
  getTitleText() {
    return this.term.name;
  }
};
var NumRegularBin = class extends NumericBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    this.#tw = tw;
  }
  getTw() {
    return this.#tw;
  }
  getStatus() {
    const vc = this.term.valueConversion;
    if (vc) return { text: `bin size=${toUserUnit(this.q.bin_size, this.term)} ${vc.toUnit}s` };
    return { text: "bin size=" + this.q.bin_size };
  }
  // See the relevant comments in the NumericBase.fill() function above
  static async fill(tw, opts = {}) {
    if (!tw.type) tw.type = "NumTWRegularBin";
    else if (tw.type != "NumTWRegularBin") throw `expecting tw.type='NumTWRegularBin', got '${tw.type}'`;
    if (!tw.q.mode) tw.q.mode = "discrete";
    else if (tw.q.mode != "discrete" && tw.q.mode != "binary" && tw.q.mode != "continuous")
      throw `expecting tw.q.mode='discrete'|'binary'|'continous', got '${tw.q.mode}'`;
    if (tw.q.type && tw.q.type != "regular-bin") throw `expecting tw.q.type='regular-bin', got '${tw.q.type}'`;
    if (!tw.term.bins || tw.term.bins.default?.isDummyPreset) {
      await opts.vocabApi.setTermBins(tw);
    }
    if (tw.q.isDummyPreset || !tw.q.first_bin || !isNumeric(tw.q.bin_size)) mayFillQWithPresetBins(tw);
    if (tw.q.bin_size === null) throw new Error(`No ${tw.term.name} numeric data to create bins`);
    if (!isNumeric(tw.q.bin_size)) throw `tw.q.bin_size=${tw.q.bin_size} is not numeric`;
    if (!tw.q.first_bin) throw `missing tw.q.first_bin`;
    if (!isNumeric(tw.q.first_bin?.stop)) throw `tw.q.first_bin.stop is not numeric`;
    TwBase.setHiddenValues(tw.q, tw.term);
    return tw;
  }
};
var NumCustomBins = class extends NumericBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    this.#tw = tw;
  }
  getTw() {
    return this.#tw;
  }
  getStatus(opts, data) {
    if (this.q.mode == "binary") {
      const regressionStatus = opts.usecase?.target == "regression" && this.q.lst.find((x) => x.label != data.refGrp)?.label;
      return { text: regressionStatus || "binary" };
    }
    return { text: this.q.lst.length + " bins" };
  }
  // See the relevant comments in the NumericBase.fill() function above
  static async fill(tw, opts = {}) {
    if (!tw.type) tw.type = "NumTWCustomBin";
    else if (tw.type != "NumTWCustomBin") throw `expecting tw.type='NumTWCustomBin', got '${tw.type}'`;
    if (!tw.q.mode) tw.q.mode = "discrete";
    else if (tw.q.mode != "discrete" && tw.q.mode != "binary" && tw.q.mode != "continuous")
      throw `expecting tw.q.mode='discrete'|binary|continuous', got '${tw.q.mode}'`;
    if (tw.q.mode == "binary" && !tw.q.preferredBins) tw.q.preferredBins = "median";
    if (!tw.term.bins) {
      await opts.vocabApi.setTermBins(tw);
    }
    if (tw.q.preferredBins == "median" && !tw.q.lst?.length) await fillQWithMedianBin(tw, opts.vocabApi);
    else if (tw.q.type != "custom-bin") throw `expecting tw.q.type='custom-bin', got '${tw.q.type}'`;
    if (!Array.isArray(tw.q.lst)) mayFillQWithPresetBins(tw);
    if (!tw.q.lst || !tw.q.lst.length) throw `missing or empty q.lst[] for custom-bin`;
    if (tw.q.mode == "binary" && tw.q.lst.length != 2) throw `numeric q.mode='binary' requires exactly 2 bins`;
    TwBase.setHiddenValues(tw.q, tw.term);
    tw.type = "NumTWCustomBin";
    return tw;
  }
};
var NumCont = class extends NumericBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    this.#tw = tw;
  }
  getTw() {
    return this.#tw;
  }
  getStatus() {
    return { text: this.q.scale ? `scale=${this.q.scale}` : "continuous" };
  }
  // See the relevant comments in the NumericBase.fill() function above
  static async fill(tw) {
    if (!tw.type) tw.type = "NumTWCont";
    else if (tw.type != "NumTWCont") throw `expecting tw.type='NumTWCont', got '${tw.type}'`;
    if (tw.q.mode != "continuous") throw `tw.q.mode='${tw.q.mode}', expecting 'continuous'`;
    TwBase.setHiddenValues(tw.q, tw.term);
    tw.type = "NumTWCont";
    return tw;
  }
};
var NumSpline = class extends NumericBase {
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
  }
  getStatus() {
    return { text: "cubic spline" };
  }
  static async fill(tw) {
    if (!tw.type) tw.type = "NumTWSpline";
    else if (tw.type != "NumTWSpline") throw `expecting tw.type='NumTWSpline', got '${tw.type}'`;
    if (tw.q.mode != "spline") throw `tw.q.mode='${tw.q.mode}', expecting 'spline'`;
    if (!tw.q.knots) throw `missing tw.q.knots`;
    if (!tw.q.knots.length) throw `empty tw.q.knots[]`;
    TwBase.setHiddenValues(tw.q, tw.term);
    tw.type = "NumTWSpline";
    return tw;
  }
};
async function fillQWithMedianBin(tw, vocabApi) {
  const result = await vocabApi.getPercentile(tw.term, [50], vocabApi.state.termfilter);
  if (!result.values) throw ".values[] missing from vocab.getPercentile()";
  const median = roundValueAuto(result.values[0]);
  tw.q.type = "custom-bin";
  tw.q.lst = [
    {
      startunbounded: true,
      stop: median,
      stopinclusive: false,
      label: "<" + median
      // if label is missing, cuminc will break with "unexpected seriesId", cuminc.js:367
    },
    {
      start: median,
      startinclusive: true,
      stopunbounded: true,
      label: "\u2265" + median
    }
  ];
  delete tw.q.preferredBins;
}
var validPreferredBins = /* @__PURE__ */ new Set(["default", "less", "median"]);
function mayFillQWithPresetBins(tw) {
  if (!tw.term.bins) throw `missing tw.term.bins`;
  const preferredBins = tw.q.preferredBins || "default";
  if (!validPreferredBins.has(preferredBins)) throw `invalid preferredBins='${preferredBins}'`;
  if (preferredBins != "median") {
    if (!Object.keys(tw.term.bins).includes(preferredBins))
      throw `term.bins does not have a preset '${preferredBins}' key`;
    const bins = structuredClone(tw.term.bins[preferredBins]);
    if (!bins.mode) bins.mode = "discrete";
    if (tw.q.type && tw.q.type != bins.type) throw `mismatched tw.q.type and term.bins[preferredBins].type`;
    if (tw.q.isDummyPreset) {
      tw.q = bins;
      delete tw.q.descrStats;
    } else {
      const qkeys = Object.keys(tw.q);
      for (const [k, v] of Object.entries(bins)) {
        if (!qkeys.includes(k)) tw.q[k] = v;
      }
      delete tw.q.preferredBins;
    }
  }
}

// tw/collection/NumericTermCollection.ts
var termType12 = "termCollection";
var NumericTermCollection = class _NumericTermCollection {
  constructor(term) {
    this.type = termType12;
    this.memberType = "numeric";
    _NumericTermCollection.validate(term);
    this.id = term.id;
    this.name = term.name;
    this.termlst = term.termlst;
    this.termIds = term.termIds;
    this.propsByTermId = term.propsByTermId || {};
    this.numerators = term.numerators;
  }
  // Mutates the raw term object in-place; routes from CollectionCont.fill()
  static fill(term, opts = {}) {
    if (term instanceof _NumericTermCollection) return;
    if (term.isCustom && term.termlst?.length) {
      if (!term.propsByTermId) term.propsByTermId = {};
    } else {
      if (!opts.vocabApi?.termdbConfig?.termCollections)
        throw `missing vocabApi.termdbConfig.termCollections argument for fill()`;
      const tc = opts.vocabApi.termdbConfig.termCollections.find((c) => c.name === term.name);
      if (tc) {
        if (!Array.isArray(tc.termIds)) throw new Error(`missing termCollection.termIds for '${tc.name}'`);
        if (!Array.isArray(tc.termlst)) throw new Error("missing tc.termlst[]");
        if (tc.termIds.length == 0) throw new Error("empty termIds[]");
        if (tc.termIds.length != tc.termlst.length) throw new Error("tc.termIds.length!=tc.termlst.length");
        if (!tc.propsByTermId) throw new Error(`propsByTermId missing for termCollection='${tc.name}'`);
        if (!term.propsByTermId) term.propsByTermId = tc.propsByTermId;
        if (!term.termlst) term.termlst = tc.termlst;
        if (tc.isCustom) term.isCustom = tc.isCustom;
        term.name = tc.name;
        const propsByTermId = term.propsByTermId;
        for (const t2 of term.termlst) {
          if (!propsByTermId[t2.id]) propsByTermId[t2.id] = tc.propsByTermId[t2.id];
        }
      } else if (!term.termlst?.length) {
        throw new Error(`no matching termCollection for '${term.name}'`);
      }
    }
    term.memberType = "numeric";
    if (!term.isCustom && !term.termIds) term.termIds = term.termlst.map((t2) => t2.id || t2.name);
    _NumericTermCollection.validate(term);
  }
  static validate(term) {
    if (typeof term !== "object") throw "term is not an object";
    if (term.type != termType12) throw `incorrect term.type='${term?.type}', expecting '${termType12}'`;
  }
};

// tw/collection/QualTermCollection.ts
var termType13 = "termCollection";
var QualTermCollection = class _QualTermCollection {
  constructor(term) {
    this.type = termType13;
    this.memberType = "categorical";
    _QualTermCollection.validate(term);
    this.id = term.id;
    this.name = term.name;
    this.termlst = term.termlst;
    this.termIds = term.termIds;
    this.propsByTermId = term.propsByTermId || {};
    this.categoryKeys = term.categoryKeys;
  }
  // Mutates the raw term object in-place; routes from CollectionQual.fill()
  static fill(term, opts = {}) {
    if (term instanceof _QualTermCollection) return;
    if (term.isCustom && term.termlst?.length) {
      if (!term.propsByTermId) term.propsByTermId = {};
    } else {
      if (!opts.vocabApi?.termdbConfig?.termCollections)
        throw `missing vocabApi.termdbConfig.termCollections argument for fill()`;
      const tc = opts.vocabApi.termdbConfig.termCollections.find((c) => c.name === term.name);
      if (tc) {
        if (!Array.isArray(tc.termIds)) throw new Error(`missing termCollection.termIds for '${tc.name}'`);
        if (!Array.isArray(tc.termlst)) throw new Error("missing tc.termlst[]");
        if (tc.termIds.length == 0) throw new Error("empty termIds[]");
        if (tc.termIds.length != tc.termlst.length) throw new Error("tc.termIds.length!=tc.termlst.length");
        if (!tc.propsByTermId) throw new Error(`propsByTermId missing for termCollection='${tc.name}'`);
        if (!term.propsByTermId) term.propsByTermId = tc.propsByTermId;
        if (!term.termlst) term.termlst = tc.termlst;
        if (tc.isCustom) term.isCustom = tc.isCustom;
        term.name = tc.name;
        const rawCategoryKeys = term.categoryKeys ?? tc.categoryKeys;
        if (rawCategoryKeys) term.categoryKeys = rawCategoryKeys;
        const propsByTermId = term.propsByTermId;
        for (const t2 of term.termlst) {
          if (!propsByTermId[t2.id]) propsByTermId[t2.id] = tc.propsByTermId[t2.id];
        }
      } else if (!term.termlst?.length) {
        throw new Error(`no matching termCollection for '${term.name}'`);
      }
    }
    term.memberType = "categorical";
    if (!term.isCustom && !term.termIds) term.termIds = term.termlst.map((t2) => t2.id || t2.name);
    _QualTermCollection.validate(term);
  }
  static validate(term) {
    if (typeof term !== "object") throw "term is not an object";
    if (term.type != termType13) throw `incorrect term.type='${term?.type}', expecting '${termType13}'`;
  }
};

// tw/collection/CollectionCont.ts
var CollectionCont = class extends TwBase {
  static fill(tw, opts = {}) {
    NumericTermCollection.fill(tw.term, opts);
    tw.type = "TermCollectionTWCont";
    if (!tw.q) tw.q = { mode: "continuous", type: "values", lst: [] };
    else {
      if (!tw.q.mode) tw.q.mode = "continuous";
      if (!tw.q.type) tw.q.type = "values";
      if (!tw.q.lst) tw.q.lst = [];
      if (!tw.q.numerators)
        tw.q.numerators = tw.term.termIds?.slice() || tw.term.termlst?.map((t2) => t2.id || t2.name) || [];
    }
    return tw;
  }
  constructor(tw, opts) {
    super(tw, opts);
    this.term = tw.term;
    this.q = tw.q;
  }
  getMinCopy() {
    const copy = { type: this.type, term: {}, q: structuredClone(this.q) };
    if (this.$id) copy.$id = this.$id;
    copy.term.type = this.term.type;
    copy.term.name = this.term.name;
    if (this.term.id) copy.term.id = this.term.id;
    copy.term.memberType = this.term.memberType;
    if (this.term.numerators) copy.term.numerators = structuredClone(this.term.numerators);
    if (this.term.propsByTermId) copy.term.propsByTermId = structuredClone(this.term.propsByTermId);
    if (this.term.valueTransform) copy.term.valueTransform = structuredClone(this.term.valueTransform);
    copy.term.termIds = this.term.termlst?.map((t2) => t2.id || t2.name) || [];
    if (this.term.isCustom) {
      copy.term.isCustom = true;
      copy.term.termlst = structuredClone(this.term.termlst);
    }
    if (copy.q) {
      delete copy.q.isAtomic;
    }
    return copy;
  }
  transformData(d) {
    const termsValue = d.value;
    const selectedTermIds = this.q.lst?.length ? new Set(this.q.lst) : null;
    const allValues = {};
    for (const [label, value] of Object.entries(termsValue)) {
      if (selectedTermIds && !selectedTermIds.has(label)) continue;
      let transformedV = value;
      if (this.term.valueTransform) {
        const offset = this.term.valueTransform.offset;
        if (typeof offset === "number") {
          transformedV += offset;
        }
      }
      if (transformedV !== 0) {
        allValues[label] = transformedV;
      }
    }
    const absoluteSum = Object.values(allValues).reduce((total, val) => total + Math.abs(val), 0);
    const positiveEntries = Object.entries(allValues).filter(([, value]) => value > 0);
    const negativeEntries = Object.entries(allValues).filter(([, value]) => value < 0);
    const hasMixedValues = positiveEntries.length > 0 && negativeEntries.length > 0;
    let pre_val_sum_positive = 0;
    let pre_val_sum_negative = 0;
    let numerators_sum = 0;
    const values = [];
    for (const [label, value] of positiveEntries) {
      const pct = absoluteSum > 0 ? value / absoluteSum * 100 : 0;
      if (pct && this.q.numerators?.includes(label)) {
        numerators_sum += pct;
      }
      const color = this.term.propsByTermId[label]?.color;
      values.push({
        label,
        value: pct,
        pre_val_sum: pre_val_sum_positive,
        color
      });
      pre_val_sum_positive += pct;
    }
    for (const [label, value] of negativeEntries) {
      const pct = absoluteSum > 0 ? value / absoluteSum * 100 : 0;
      if (Math.abs(pct) && this.q.numerators?.includes(label)) {
        numerators_sum += Math.abs(pct);
      }
      const color = this.term.propsByTermId[label]?.color;
      values.push({
        label,
        value: pct,
        pre_val_sum: pre_val_sum_negative,
        color
      });
      pre_val_sum_negative += pct;
    }
    d.values = values;
    d.numerators_sum = numerators_sum;
    d.hasMixedValues = hasMixedValues;
    delete d.value;
  }
};

// tw/collection/CollectionFraction.ts
var CollectionFraction = class extends TwBase {
  static fill(tw, opts = {}) {
    NumericTermCollection.fill(tw.term, opts);
    if (!tw.q) throw new Error("fraction termCollection requires q");
    if (!tw.q.mode) tw.q.mode = "continuous";
    const memberIds = tw.term.termIds?.slice() || tw.term.termlst?.map((term2) => term2.id || term2.name) || [];
    if (!tw.q.denominators?.length) tw.q.denominators = memberIds;
    if (!tw.q.numerators?.length) tw.q.numerators = memberIds.slice();
    validateTermCollectionFraction(tw.q, tw.term);
    const term = tw.term;
    if (!term.bins) {
      const regular = {
        type: "regular-bin",
        mode: "discrete",
        bin_size: 0.25,
        first_bin: { startunbounded: true, stop: 0.25 },
        last_bin: { start: 0.75, stopunbounded: true },
        startinclusive: true
      };
      term.bins = { default: regular, less: structuredClone(regular), min: 0, max: 1 };
    }
    tw.type = "TermCollectionTWFraction";
    return tw;
  }
  constructor(tw, opts) {
    super(tw, opts);
    this.term = tw.term;
    this.q = tw.q;
  }
  getMinCopy() {
    const copy = { type: "TermCollectionTWFraction", term: {}, q: structuredClone(this.q) };
    if (this.$id) copy.$id = this.$id;
    copy.term.type = this.term.type;
    copy.term.name = this.term.name;
    if (this.term.id) copy.term.id = this.term.id;
    copy.term.memberType = this.term.memberType;
    if (this.term.propsByTermId) copy.term.propsByTermId = structuredClone(this.term.propsByTermId);
    copy.term.termIds = this.term.termlst?.map((term) => term.id || term.name) || [];
    if (this.term.isCustom) {
      copy.term.isCustom = true;
      copy.term.termlst = structuredClone(this.term.termlst);
    }
    delete copy.q.isAtomic;
    return copy;
  }
};

// tw/collection/CollectionQual.ts
var CollectionQual = class extends TwBase {
  static fill(tw, opts = {}) {
    QualTermCollection.fill(tw.term, opts);
    tw.type = "TermCollectionTWQual";
    if (!tw.q)
      tw.q = {
        mode: "discrete",
        type: "values",
        lst: tw.term.termIds || tw.term.termlst?.map((t2) => t2.id || t2.name) || []
      };
    else {
      if (!tw.q.mode) tw.q.mode = "discrete";
      if (!tw.q.type) tw.q.type = "values";
      if (!tw.q.lst) tw.q.lst = tw.term.termIds || tw.term.termlst?.map((t2) => t2.id || t2.name) || [];
    }
    if (!tw.q.categoryKeys && tw.term.categoryKeys?.length) {
      tw.q.categoryKeys = structuredClone(tw.term.categoryKeys);
    }
    return tw;
  }
  constructor(tw, opts) {
    super(tw, opts);
    this.term = tw.term;
    this.q = tw.q;
  }
  getMinCopy() {
    const copy = { type: this.type, term: {}, q: structuredClone(this.q) };
    if (this.$id) copy.$id = this.$id;
    copy.term.type = this.term.type;
    copy.term.name = this.term.name;
    if (this.term.id) copy.term.id = this.term.id;
    copy.term.memberType = this.term.memberType;
    if (this.term.categoryKeys) copy.term.categoryKeys = structuredClone(this.term.categoryKeys);
    if (this.term.propsByTermId) copy.term.propsByTermId = structuredClone(this.term.propsByTermId);
    copy.term.termIds = this.term.termlst?.map((t2) => t2.id || t2.name) || [];
    if (this.term.isCustom) {
      copy.term.isCustom = true;
      copy.term.termlst = structuredClone(this.term.termlst);
    }
    if (copy.q) {
      delete copy.q.isAtomic;
    }
    return copy;
  }
};

// tw/collection/CollectionBase.ts
var CollectionBase = class extends TwBase {
  constructor(tw, opts) {
    super(tw, opts);
    this.type = tw.type;
    this.term = tw.term;
    this.q = tw.q;
  }
  static fill(tw, opts = {}) {
    const legacyQ = tw.q;
    if (legacyQ?.type === "fraction") {
      tw.type = "TermCollectionTWFraction";
      tw.q = legacyQ.mode === "discrete" ? {
        ...legacyQ,
        type: "custom-bin",
        lst: legacyQ.fractionBins,
        denominators: legacyQ.lst
      } : {
        mode: "continuous",
        denominators: legacyQ.lst,
        numerators: legacyQ.numerators
      };
      delete tw.q.fractionBins;
    }
    if (opts.defaultQ) {
      const defaultQ = structuredClone(opts.defaultQ);
      const q = tw.q || {};
      if (!defaultQ.denominators?.length && q.denominators?.length) delete defaultQ.denominators;
      if (!defaultQ.numerators?.length && q.numerators?.length) delete defaultQ.numerators;
      tw.q = { ...q, ...defaultQ };
    }
    if (tw.type === "TermCollectionTWFraction" || Array.isArray(tw.q?.denominators))
      tw.type = "TermCollectionTWFraction";
    if (!tw.type) {
      const term = tw.term;
      if (term.isCustom && term.memberType) {
        tw.type = term.memberType === "numeric" ? tw.type === "TermCollectionTWFraction" ? "TermCollectionTWFraction" : "TermCollectionTWCont" : "TermCollectionTWQual";
      } else {
        if (!opts.vocabApi?.termdbConfig?.termCollections)
          throw `missing vocabApi.termdbConfig.termCollections argument for fill()`;
        const tc = opts.vocabApi.termdbConfig.termCollections.find((c) => c.name === term.name);
        if (!tc) throw new Error(`no matching termCollection for '${term.name}'`);
        tw.type = tc.type === "numeric" ? tw.type === "TermCollectionTWFraction" ? "TermCollectionTWFraction" : "TermCollectionTWCont" : "TermCollectionTWQual";
      }
    }
    switch (tw.type) {
      case "TermCollectionTWCont": {
        CollectionCont.fill(tw, opts);
        break;
      }
      case "TermCollectionTWFraction": {
        CollectionFraction.fill(tw, opts);
        break;
      }
      case "TermCollectionTWQual": {
        CollectionQual.fill(tw, opts);
        break;
      }
      default:
        throw `unexpected collection tw.type='${tw.type}'`;
    }
    return tw;
  }
};

// dom/animation.js
function appear(d, display) {
  d.style("opacity", 0).style("display", display || "block").transition().style("opacity", 1);
}
function disappear(d, remove) {
  d.style("opacity", 1).transition().style("opacity", 0).call(() => {
    if (remove) {
      d.remove();
    } else {
      d.style("display", "none").style("opacity", 1);
    }
  });
}

// dom/axisstyle.js
function axisstyle(p) {
  if (!p || !p.axis) return;
  if (!p.color) {
    p.color = "#545454";
  }
  p.axis.selectAll("line").attr("stroke", p.color).attr("shape-rendering", "crispEdges");
  p.axis.selectAll("path").attr("fill", "none").attr("stroke", p.showline ? p.color : "none").attr("stroke-width", p.showline ? 1 : 0).attr("shape-rendering", "crispEdges");
  p.axis.selectAll("text").style("cursor", "default").attr("font-size", p.fontsize ? p.fontsize + "px" : "12px").attr("fill", p.color);
}

// dom/boxplot.js
function drawBoxplot({ bp, g, color, scale, rowheight, labpad, labColor = color }) {
  if (bp.label) {
    bp.labelG = g.append("text").attr("font-family", "Arial").attr("text-anchor", "end").attr("dominant-baseline", "central").attr("fill", labColor).attr("x", -labpad).attr("y", rowheight / 2).attr("font-size", Math.min(15, rowheight)).text(bp.label);
  }
  if (bp.w1 != void 0 || bp.w2 != void 0) {
    const w1 = scale(bp.w1);
    const w2 = scale(bp.w2);
    const p25 = scale(bp.p25);
    const p50 = scale(bp.p50);
    const p75 = scale(bp.p75);
    bp.hline = g.append("line").attr("stroke", color).attr("shape-rendering", "crispEdges").attr("x1", w1).attr("x2", w2).attr("y1", rowheight / 2).attr("y2", rowheight / 2);
    bp.linew1 = g.append("line").attr("stroke", color).attr("shape-rendering", "crispEdges").attr("x1", w1).attr("x2", w1).attr("y1", 0).attr("y2", rowheight);
    bp.linew2 = g.append("line").attr("stroke", color).attr("shape-rendering", "crispEdges").attr("x1", w2).attr("x2", w2).attr("y1", 0).attr("y2", rowheight);
    bp.box = g.append("rect").attr("fill", bp?.rectFill || "white").attr("stroke", color).attr("shape-rendering", "crispEdges").attr("x", p25).attr("y", 0).attr("width", p75 - p25).attr("height", rowheight);
    bp.linep50 = g.append("line").attr("stroke", color).attr("shape-rendering", "crispEdges").attr("x1", p50).attr("x2", p50).attr("y1", 0).attr("y2", rowheight);
  }
  for (const d of bp.out) {
    const v = Number.isFinite(d) ? d : Number.isFinite(d.value) ? d.value : void 0;
    if (v == void 0) continue;
    g.append("circle").attr("stroke", color).attr("fill", "white").attr("fill-opacity", 0).attr("cx", scale(v)).attr("cy", rowheight / 2).attr("r", bp?.radius || rowheight / 3);
  }
}

// dom/checkbox.ts
function make_one_checkbox(arg) {
  const { holder, labeltext, title, callback, checked, divstyle, id: id3, testid } = arg;
  const div = holder.append("div");
  if (divstyle) {
    for (const k in divstyle) div.style(k, divstyle[k]);
  }
  const label = div.append("label").on("mousedown", (event2) => {
    event2.stopPropagation();
  });
  const input = label.append("input").attr("type", "checkbox").property("checked", checked).on("input", async () => {
    input.property("disabled", true);
    await callback(input.property("checked"));
    input.property("disabled", false);
  });
  if (title) input.attr("title", title);
  if (id3) input.attr("id", id3);
  if (testid) input.attr("data-testid", testid);
  if (labeltext) label.append("span").html("&nbsp;" + labeltext);
  return input;
}

// src/client.js
var client_exports = {};
__export(client_exports, {
  Menu: () => Menu,
  appear: () => appear2,
  axisstyle: () => axisstyle,
  base_zindex: () => base_zindex,
  bulk_badline: () => bulk_badline,
  bwSetting: () => bwSetting,
  category2legend: () => category2legend,
  clinvar_printhtml: () => clinvar_printhtml,
  colorantisense: () => colorantisense,
  colorbgleft: () => colorbgleft,
  colorbgright: () => colorbgright,
  colorctx: () => colorctx,
  colorinframe: () => colorinframe,
  coloroutframe: () => coloroutframe,
  disappear: () => disappear2,
  dofetch: () => dofetch,
  dofetch2: () => dofetch2,
  dofetch3: () => dofetch3,
  ensureisblock: () => ensureisblock,
  export_data: () => export_data,
  filetypeselect: () => filetypeselect,
  fillbar: () => fillbar,
  first_genetrack_tolist: () => first_genetrack_tolist,
  flyindi: () => flyindi,
  font: () => font,
  getdomaintypes: () => getdomaintypes,
  gmlst2loci: () => gmlst2loci,
  gmmode: () => gmmode2,
  keyupEnter: () => keyupEnter,
  labelbox: () => labelbox,
  make_table_2col: () => make_table_2col,
  may_findmatchingsnp: () => may_findmatchingsnp,
  mclasscolor2table: () => mclasscolor2table,
  mclasscolorchangeui: () => mclasscolorchangeui,
  newpane: () => newpane,
  newpane3: () => newpane3,
  ranksays: () => ranksays,
  rgb2hex: () => rgb2hex,
  sayerror: () => sayerror,
  snp_printhtml: () => snp_printhtml,
  tab2box: () => tab2box,
  tab_wait: () => tab_wait,
  textlensf: () => textlensf,
  tkexists: () => tkexists,
  tkt: () => tkt2,
  to_svg: () => to_svg,
  unspecified: () => unspecified
});

// common/1stGenetk.js
function first_genetrack_tolist(genome, lst) {
  if (!genome.tracks) return;
  for (const t2 of genome.tracks) {
    if (t2.__isgene) {
      lst.push(t2);
      return;
    }
  }
}

// src/client.js
var font = "Arial";
var unspecified = "Unspecified";
var colorinframe = "green";
var coloroutframe = "#858585";
var colorbgleft = "#FCE3B8";
var colorbgright = "#D2E2FC";
var colorantisense = "red";
var colorctx = "#DE3336";
var textlensf = 0.6;
var base_zindex = null;
var tkt2 = tkt;
var gmmode2 = gmmode;
function appear2(d, display) {
  d.style("opacity", 0).style("display", display || "block").transition().style("opacity", 1);
}
function disappear2(d, remove) {
  d.style("opacity", 1).transition().style("opacity", 0).call(() => {
    if (remove) {
      d.remove();
    } else {
      d.style("display", "none").style("opacity", 1);
    }
  });
}
function newpane(pm) {
  if (pm.setzindex) {
    base_zindex = pm.setzindex;
    set_base_zindex(pm.setzindex);
    return;
  }
  const dur = 300;
  const pp = {};
  const body = select_default(document.body);
  pp.pane = body.append("div").attr("class", "sja_pane").style("left", pm.x + window.pageXOffset + "px").style("top", pm.y + window.pageYOffset + "px").style("opacity", 0);
  if (pm.$id) {
    pp.pane.attr("id", pm.$id);
  }
  if (base_zindex) {
    pp.pane.style("z-index", base_zindex);
  }
  pp.pane.transition().duration(dur).style("opacity", 1);
  const toprow = pp.pane.append("div").on("mousedown", (event2) => {
    event2.preventDefault();
    event2.stopPropagation();
    const oldx = Number.parseInt(pp.pane.style("left")), oldy = Number.parseInt(pp.pane.style("top"));
    const x0 = event2.clientX, y0 = event2.clientY;
    body.on("mousemove", (event3) => {
      pp.pane.style("left", oldx + event3.clientX - x0 + "px").style("top", oldy + event3.clientY - y0 + "px");
    });
    body.on("mouseup", function() {
      body.on("mouseup", null).on("mousemove", null);
    });
    document.body.appendChild(pp.pane.node());
  });
  const butt = toprow.append("div").attr("class", "sja_menuoption").style("display", "inline-block").style("padding", "4px 10px").style("margin", "0px").style("border-right", "solid 1px white").style("cursor", "default").style("font-size", "1.5em").on("mousedown", (event2) => {
    document.body.dispatchEvent(new Event("mousedown"));
    event2.stopPropagation();
  });
  if (pm.toshrink) {
    pp.mini = false;
    butt.html("&#9473;").on("click", () => {
      butt.html(pp.mini ? "&#9473;" : "&#9725;");
      if (pp.mini) {
        appear2(pp.body);
      } else {
        disappear2(pp.body);
      }
      pp.mini = !pp.mini;
    });
  } else {
    butt.html("&times;");
    if (pm.close) {
      butt.on("click", pm.close);
    } else if (pm.closekeep) {
      butt.on("click", () => {
        pp.pane.transition().duration(dur).style("opacity", 0).call(() => pp.pane.style("display", "none"));
      });
    } else {
      butt.on("click", () => {
        pp.pane.transition().duration(dur).style("opacity", 0).call(() => pp.pane.remove());
      });
    }
  }
  pp.header = toprow.append("div").style("display", "inline-block").style("font-family", font).style("padding", pm.headpad || "5px 10px");
  pp.body = pp.pane.append("div").style("font-family", font);
  return pp;
}
function getdomaintypes(gm) {
  if (!gm.pdomains) return [];
  const types2 = /* @__PURE__ */ new Map();
  for (const i3 of gm.pdomains) {
    const key = i3.name + i3.description;
    if (types2.has(key)) {
      types2.get(key).start = Math.min(types2.get(key).start, i3.start);
    } else {
      types2.set(key, {
        name: i3.name,
        description: i3.description,
        color: i3.color,
        start: i3.start,
        iscustom: i3.iscustom,
        url: i3.url,
        pmid: i3.pmid,
        CDD: i3.CDD,
        Pfam: i3.Pfam,
        SMART: i3.SMART,
        COG: i3.COG,
        PRK: i3.PRK,
        Curated_at_NCBI: i3.Curated_at_NCBI
      });
    }
  }
  const lst = [];
  for (const [key, domaintype] of types2) {
    domaintype.key = key;
    domaintype.fill = domaintype.color;
    domaintype.stroke = rgb(domaintype.color).darker(1).toString();
    delete domaintype.color;
    lst.push(domaintype);
  }
  lst.sort((a, b) => a.start - b.start);
  return lst;
}
function newpane3(x, y, genomes) {
  const pane = newpane({ x, y });
  const inputdiv = pane.body.append("div").style("margin", "40px 20px 20px 20px");
  const p = inputdiv.append("p");
  p.append("span").html("Genome&nbsp;");
  const gselect = p.append("select");
  for (const n in genomes) {
    gselect.append("option").text(n);
  }
  const filediv = inputdiv.append("div").style("margin", "20px 0px");
  const saydiv = pane.body.append("div").style("margin", "10px 20px");
  const visualdiv = pane.body.append("div").style("margin", "20px");
  return [pane, inputdiv, gselect.node(), filediv, saydiv, visualdiv];
}
function to_svg(svg, name, opts = {}) {
  if (opts.apply_dom_styles) {
    opts.svgClone = svg.cloneNode(true);
    const clone = select_default(opts.svgClone);
    for (const elem of opts.svgClone.querySelectorAll(".sjpp-exclude-svg-download")) {
      elem.remove();
    }
    const styles = window.getComputedStyle(svg);
    for (const s of styles) {
      clone.style(s, styles.getPropertyValue(s));
    }
  }
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.addEventListener(
    "click",
    function() {
      const serializer = new XMLSerializer();
      const svg_blob = new Blob([serializer.serializeToString(opts.svgClone ? opts.svgClone : svg)], {
        type: "image/svg+xml"
      });
      a.download = name + ".svg";
      a.href = URL.createObjectURL(svg_blob);
      document.body.removeChild(a);
    },
    false
  );
  a.click();
}
function filetypeselect(holder) {
  const s = holder.append("select");
  s.append("option").text("SNV and indel");
  s.append("option").text("SV (tabular format)");
  s.append("option").text("Fusion gene (tabular format)");
  s.append("option").text("ITD");
  s.append("option").text("Deletion, intragenic");
  s.append("option").text("Truncation");
  s.append("option").text("CNV, gene-level");
  return s;
}
function export_data(title, lst, posx = 1, posy = 1, rows = 10, cols = 100, div = null) {
  let body;
  if (!div) {
    const pane = newpane({
      x: (window.innerWidth / 2 - 200) * posx,
      y: (window.innerHeight / 2 - 150) * posy
    });
    pane.header.text(title);
    body = pane.body;
  } else {
    div.append("p").text(title);
    body = div.append("div");
  }
  for (const w of lst) {
    const div2 = body.append("div").style("margin-top", "10px");
    if (w.label) {
      div2.append("div").text(w.label).style("margin", "5px");
    }
    body.append("textarea").text(w.text).attr("readonly", 1).attr("rows", rows).attr("cols", cols);
  }
  body.append("p").style("font-size", ".7em").text("Click on the text box above and press Ctrl-A to select all text for copy-pasting.");
}
function flyindi(from, to) {
  const p1 = from.node().getBoundingClientRect();
  const p2 = to.node().getBoundingClientRect();
  const d = select_default(document.body).append("div").style("position", "absolute").style("border", "solid 1px black").style("left", p1.left + window.pageXOffset + "px").style("top", p1.top + window.pageYOffset + "px").style("width", p1.width + "px").style("height", p1.height + "px");
  if (base_zindex) {
    d.style("z-index", base_zindex + 3);
  }
  d.transition().duration(500).style("left", p2.left + window.pageXOffset + "px").style("top", p2.top + window.pageYOffset + "px").style("width", p2.width + "px").style("height", p2.height + "px").on("end", () => d.remove());
}
function labelbox(arg) {
  const fontsize = 16;
  if (!arg.color) {
    arg.color = "#ccc";
  }
  const d0 = arg.holder.append("div").style("position", "relative").style("padding-top", fontsize / 2 + "px");
  if (arg.margin) {
    d0.style("margin", arg.margin);
  }
  const bin = d0.append("div").style("border", "solid 1px " + arg.color).style("padding", fontsize + "px").style("padding-bottom", fontsize / 2 + "px");
  d0.append("div").text(arg.label).style("position", "absolute").style("left", "15px").style("top", "0px").style("background-color", "white").style("color", arg.color).style("font-family", font).style("font-size", fontsize + "px").style("padding", "0px 10px");
  return bin;
}
function category2legend(categories, holder) {
  holder.selectAll("*").remove();
  for (const key in categories) {
    const c = categories[key];
    const div = holder.append("div").style("display", "inline-block").style("white-space", "nowrap").style("padding", "5px 20px 5px 0px");
    div.append("div").style("display", "inline-block").style("background-color", c.color).style("margin-right", "5px").style("padding", "0px 4px").html("&nbsp;");
    div.append("div").style("display", "inline-block").style("color", c.color).text(c.label);
  }
}
function bulk_badline(header, lines) {
  if (window.location.hostname == "viz.stjude.cloud" || window.location.hostname == "pecan.stjude.cloud") return;
  if (window.sessionStorage.getItem("suppressErrors")?.includes(`"bulk-bad-lines"`)) return;
  const np = newpane({ x: 400, y: 60 });
  np.body.style("margin", "20px 10px 10px 10px");
  np.header.text(lines.length + " line" + (lines.length > 1 ? "s" : "") + " rejected, click to check");
  if (lines.length <= 50) {
    for (const [number, err, line] of lines) {
      np.body.append("div").classed("sja_clbtext", true).style("margin", "3px").text("Line " + number + ": " + err).on("click", () => {
        const n2 = newpane({ x: 500, y: 60 });
        n2.header.text("Line " + number);
        n2.body.style("margin", "10px");
        const t2 = n2.body.append("table").style("border-spacing", "1px").style("border-collapse", "separate");
        let fl = true;
        for (let i3 = 0; i3 < header.length; i3++) {
          const tr = t2.append("tr");
          if (fl) {
            tr.style("background-color", "#ededed");
          }
          fl = !fl;
          tr.append("td").text(header[i3]);
          tr.append("td").text(line[i3] == void 0 ? "" : line[i3]);
        }
      });
    }
    return;
  }
  const reason = /* @__PURE__ */ new Map();
  for (const [number, err, line] of lines) {
    if (!reason.has(err)) {
      reason.set(err, []);
    }
    reason.get(err).push({ number, line });
  }
  const lst = [...reason];
  lst.sort((a, b) => b[1].length - a[1].length);
  for (const [thisreason, linelst] of lst) {
    const line1 = linelst[0];
    np.body.append("div").classed("sja_menuoption", true).style("margin", "5px").text(
      "Line " + line1.number + ": " + thisreason + (linelst.length > 1 ? " (total " + linelst.length + " lines)" : "")
    ).on("click", () => {
      const n2 = newpane({ x: 500, y: 60 });
      n2.header.text("Line " + line1.number);
      const t2 = n2.body.style("margin", "10px").append("table");
      let fl = true;
      for (let i3 = 0; i3 < header.length; i3++) {
        const tr = t2.append("tr");
        if (fl) {
          tr.style("background-color", "#ededed");
        }
        fl = !fl;
        tr.append("td").text(header[i3]);
        tr.append("td").text(line1.line[i3] == void 0 ? "" : line1.line[i3]);
      }
    });
  }
}
function ensureisblock(b) {
  if (!b) return "No Block{} object given";
  if (typeof b != "object") return "Block is not an object";
  if (!b.error) return "method block.error() missing";
  if (!b.genome) return "block.genome missing";
  return null;
}
function mclasscolorchangeui(tip) {
  tip.d.append("p").html('<span style="color:#858585;font-size:.7em">EXAMPLE</span> M ; red');
  const input = tip.d.append("textarea").attr("cols", 25).attr("rows", 5).attr("placeholder", "One class per line, join color and class code by semicolon.");
  const row = tip.d.append("div");
  row.append("button").text("Submit").on("click", () => {
    const str = input.property("value").trim();
    if (!str) return;
    errdiv.text("");
    const good = [];
    for (const line of str.split("\n")) {
      const l = line.split(";");
      if (l.length != 2) return errdiv.text("no separator in line: " + line);
      const c = l[0].trim();
      const color = l[1].trim();
      if (!c || !color) return errdiv.text("wrong line: " + line);
      if (!mclass[c]) return errdiv.text("wrong class: " + c);
      good.push([c, color]);
    }
    if (good.length) {
      for (const [c, color] of good) {
        mclass[c].color = color;
      }
      mclasscolor2table(table);
      errdiv.text("New color set!");
    }
  });
  row.append("button").text("Clear").on("click", () => {
    input.property("value", "");
    errdiv.text("");
  });
  const errdiv = row.append("span").style("margin-left", "10px");
  const table = tip.d.append("div").style("margin-top", "5px");
  mclasscolor2table(table);
  tip.d.append("p").style("font-size", ".8em").html(
    "<a href=https://en.wikipedia.org/wiki/Web_colors target=_blank>Use color names</a>, or #ff0000 or rgb(255,0,0)"
  );
}
function mclasscolor2table(table, snvonly) {
  table.style("border-spacing", "3px").selectAll("*").remove();
  const tr = table.append("tr").style("color", "#858585").style("font-size", ".7em");
  tr.append("td").text("CLASS");
  tr.append("td").attr("colspan", 2).text("LABEL, COLOR");
  for (const k in mclass) {
    const c = mclass[k];
    if (snvonly && c.dt != dtsnvindel) continue;
    const tr2 = table.append("tr");
    tr2.append("td").text(k);
    {
      const dot = tr2.append("td").append("span").attr("class", "sja_mcdot").style("background-color", c.color).html("&nbsp;&nbsp;");
      if (k == "Blank") dot.style("border", "solid 1px #eee");
    }
    tr2.append("td").text(c.label).style("color", k == "Blank" ? "#ddd" : c.color);
  }
}
var bwSetting = {
  height: 1,
  pcolor: 2,
  ncolor: 3,
  pcolor2: 4,
  ncolor2: 5,
  autoscale: 6,
  fixedscale: 7,
  percentilescale: 8,
  nodotplot: 9,
  usedotplot: 10,
  usedividefactor: 11,
  nodividefactor: 12
};
function tkexists(t2, tklst) {
  for (const t0 of tklst) {
    if (t0.type != t2.type) continue;
    switch (t2.type) {
      case tkt2.bigwig:
      case tkt2.bedj:
      case tkt2.junction:
      case tkt2.mdsjunction:
      case tkt2.bampile:
      case tkt2.hicstraw:
      case tkt2.expressionrank:
        if (t2.file && t2.file == t0.file || t2.url && t2.url == t0.url) {
          return t0;
        }
        break;
      case tkt2.bigwigstranded:
        if (t2.strand1 && t0.strand1 && t2.strand1.file == t0.strand1.file && t2.strand1.url == t0.strand1.url) {
          if (t2.strand2 && t0.strand2 && t2.strand2.file == t0.strand2.file && t2.strand2.url == t0.strand2.url) {
            return t0;
          }
        }
        break;
    }
  }
  return null;
}
function ranksays(v) {
  if (v >= 100) return "HIGHEST";
  if (v >= 90) return "HIGH " + v + "%";
  if (v >= 70) return "high " + v + "%";
  if (v >= 30) return v + "%";
  if (v >= 10) return "low " + v + "%";
  if (v > 0) return "LOW " + v + "%";
  return "LOWEST";
}
function rgb2hex(rgb2) {
  if (rgb2[0] == "#") return rgb2;
  const r = rgb2.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  return r && r.length === 4 ? "#" + ("0" + parseInt(r[1], 10).toString(16)).slice(-2) + ("0" + parseInt(r[2], 10).toString(16)).slice(-2) + ("0" + parseInt(r[3], 10).toString(16)).slice(-2) : "";
}
function keyupEnter(event2) {
  return event2.code == "Enter" || event2.code == "NumpadEnter";
}
function may_findmatchingsnp(chr, poslst, genome, alleleLst) {
  if (!genome || !genome.hasSNP) return;
  const p = {
    byCoord: true,
    genome: genome.name,
    chr,
    ranges: [],
    alleleLst
  };
  for (const i3 of poslst) {
    if (Number.isFinite(i3)) {
      p.ranges.push({ start: i3, stop: i3 + 1 });
    } else if (i3.start && i3.stop) {
      p.ranges.push(i3);
    }
  }
  return dofetch("snp", p).then((data) => {
    if (data.error) throw data.error;
    return data.results;
  });
}
function snp_printhtml(m, d) {
  d.append("a").text(m.name).attr("href", "https://www.ncbi.nlm.nih.gov/snp/" + m.name).attr("target", "_blank");
  d.append("div").attr("class", "sja_tinylogo_body").text(m.observed);
  d.append("div").attr("class", "sja_tinylogo_head").text("ALLELE");
}
function clinvar_printhtml(m, d) {
  d.append("div").style("display", "inline-block").style("background", m.bg).style("padding", "3px").append("a").attr("href", "https://www.ncbi.nlm.nih.gov/clinvar/variation/" + m.id).attr("target", "_blank").style("color", m.textcolor).text(m.value).style("font-size", ".9em").style("text-decoration", "none");
}
function gmlst2loci(gmlst) {
  const locs = [];
  for (const f of gmlst) {
    let nooverlap = true;
    for (const r of locs) {
      if (f.chr == r.chr && Math.max(f.start, r.start) < Math.min(f.stop, r.stop)) {
        r.start = Math.min(r.start, f.start);
        r.stop = Math.max(r.stop, f.stop);
        nooverlap = false;
      }
    }
    if (nooverlap) {
      locs.push({
        name: f.isoform,
        chr: f.chr,
        start: f.start,
        stop: f.stop
      });
    }
  }
  return locs;
}
function tab2box(holder, tabs, runall, tabheader) {
  const tr = holder.append("table").style("border-spacing", "0px").style("border-collapse", "separate").append("tr");
  const tdleft = tr.append("td").style("vertical-align", "top").style("padding", "10px 0px 10px 10px");
  const tdright = tr.append("td").style("vertical-align", "top").style("border-left", "solid 1px #aaa").style("padding", "10px");
  const has_acitve_tab = tabs.findIndex((t2) => t2.active) == -1 ? false : true;
  if (tabheader) {
    const tHeader = tdleft.append("div").style("padding", "5px 10px").style("margin", "5px 5px 10px 5px").style("font-weight", "550").text(tabheader);
  }
  for (let i3 = 0; i3 < tabs.length; i3++) {
    const tab = tabs[i3];
    tab.tab = tdleft.append("div").style("padding", "5px 10px").style("margin", "0px").style("border-top", "solid 1px #ddd").style("border-radius", "0px").classed("sja_menuoption", !has_acitve_tab && i3 != 0).html(tab.label);
    tab.box = tdright.append("div").style("padding", "3px").style("display", !has_acitve_tab && i3 == 0 || tab.active ? "block" : "none");
    if (runall && tab.callback || !has_acitve_tab && i3 == 0 && tab.callback || tab.active) {
      tab.callback(tab.box);
      delete tab.callback;
    }
    if (has_acitve_tab) tab.tab.classed("sja_menuoption", !tab.active);
    tab.tab.on("click", () => {
      if (tab.box.style("display") != "none") {
        tab.tab.classed("sja_menuoption", true);
        tab.box.style("display", "none");
      } else {
        tab.tab.classed("sja_menuoption", false);
        appear2(tab.box);
        for (let j = 0; j < tabs.length; j++) {
          if (i3 != j) {
            tabs[j].tab.classed("sja_menuoption", true);
            tabs[j].box.style("display", "none");
          }
        }
      }
      if (tab.callback) {
        tab.callback(tab.box);
        delete tab.callback;
      }
    });
  }
}
function tab_wait(d) {
  return d.append("div").style("margin", "30px").text("Loading...");
}

// dom/ColorScale/ColorScaleMenu.ts
var ColorScaleMenu = class {
  constructor(opts) {
    this.colors = ["white", "red"];
    this.tip = new Menu({ padding: "2px" });
    this.appendColorInput = (td, idx) => {
      const colorInput = td.append("input").style("width", "60px").attr("type", "color").style("padding", "0px").style("border", "none").style("margin", "0px").attr("value", rgb(this.colors[idx]).formatHex()).on("change", async () => {
        const color = colorInput.node().value;
        this.colors[idx] = color;
        await this.setColorsCallback(color, idx);
        this.tip.hide();
      });
    };
    this.appendValueInput = (elem, elemValue, min, max) => {
      if (elemValue == null) return;
      const valueInput = elem.append("input").attr("type", "number").style("width", "60px").attr("value", elemValue).style("padding", "3px");
      if (min) valueInput.attr("min", min);
      if (max) valueInput.attr("max", max);
      valueInput.on("keyup", async (event2) => {
        if (event2.code != "Enter") return;
        const valueNode = valueInput.node();
        if (!valueNode) return;
        const value = parseFloat(valueNode.value);
        if (!Number.isFinite(value)) {
          alert("Please enter a valid number");
          return;
        }
        const opts = {
          cutoffMode: this.cutoffMode
        };
        if (this.cutoffMode == "fixed") {
          const idx = elemValue == this.domain[0] ? 0 : this.domain.length - 1;
          this.domain[idx] = value;
          opts.min = this.domain[0];
          opts.max = this.domain[this.domain.length - 1];
        } else if (this.cutoffMode == "percentile") {
          if (value <= 0 || value >= 100) {
            alert("Please enter a value between 0 and 100");
            return;
          }
          this.percentile = value;
          opts.percentile = value;
        }
        await this.numInputCallback(opts);
        this.tip.hide();
      });
      return valueInput;
    };
    this.domain = [...opts.domain];
    this.colors = opts.colors;
    if (opts.setNumbersCallback) {
      this.numInputCallback = opts.setNumbersCallback;
      this.cutoffMode = opts.cutoffMode;
      this.default = {
        min: this.domain[0],
        max: this.domain[this.domain.length - 1]
      };
      if (opts.percentile) {
        this.default.percentile = opts.defaultPercentile;
        this.percentile = opts.percentile;
      }
    }
    if (opts.setColorsCallback) this.setColorsCallback = opts.setColorsCallback;
    this.renderMenu(opts.scaleSvg, opts.barG);
  }
  renderMenu(scaleSvg, barG) {
    let showTooltip = true;
    scaleSvg.on("click", (event2) => {
      event2.stopPropagation();
      this.tip.clear().showunder(barG.node());
      const selectDiv = this.tip.d.append("div").style("padding", "2px");
      const table = this.tip.d.append("table").style("margin", "auto");
      const submitPromptCell = table.append("tr").append("td").attr("colspan", "2").style("opacity", 0.65).style("font-size", "0.7em").text("Press ENTER to submit").style("display", this.cutoffMode != "auto" ? "" : "none");
      const percentRow = table.append("tr").style("padding", "5px").append("td").attr("colspan", "2").style("display", this.cutoffMode == "percentile" ? "" : "none");
      const minMaxPromptRow = table.append("tr").style("text-align", "center").style("display", this.setColorsCallback ? "table-row" : "none");
      minMaxPromptRow.append("td").text("Min").style("padding-left", "5px").style("text-align", "left");
      minMaxPromptRow.append("td").style("padding-left", "5px").style("text-align", "left").text("Max");
      if (this.numInputCallback) {
        const options = [
          { label: "Automatic", value: "auto", selected: this.cutoffMode == "auto" },
          { label: "Fixed", value: "fixed", selected: this.cutoffMode == "fixed" }
        ];
        if (this.default?.percentile) {
          options.push({
            label: "Percentile",
            value: "percentile",
            selected: this.cutoffMode == "percentile"
          });
        }
        const select = selectDiv.append("select");
        select.selectAll("option").data(options).enter().append("option").text((d) => d.label).property("value", (d) => d.value).property("selected", (d) => d.selected);
        const percentInput = this.appendValueInput(percentRow, this.percentile ?? null, 0.1, 100);
        const minMaxInputRow = table.append("tr").style("display", this.cutoffMode == "fixed" ? "table-row" : "none");
        const minInput = this.appendValueInput(minMaxInputRow.append("td"), this.domain[0]);
        this.appendValueInput(minMaxInputRow.append("td"), this.domain[this.domain.length - 1]);
        select.on("change", async () => {
          this.cutoffMode = select.node().value;
          if (!this.default) throw new Error("Auto values not set for #dom/ColorScale.");
          if (this.cutoffMode == "auto") {
            minMaxPromptRow.style("display", this.setColorsCallback ? "table-row" : "none");
            this.domain[0] = this.default.min;
            this.domain[this.domain.length - 1] = this.default.max;
            this.percentile = this.default.percentile;
            await this.numInputCallback({
              cutoffMode: this.cutoffMode,
              min: this.default.min,
              max: this.default.max
            });
            this.tip.hide();
          }
          minMaxPromptRow.style(
            "display",
            this.setColorsCallback || this.cutoffMode == "fixed" ? "table-row" : "none"
          );
          submitPromptCell.style("display", this.cutoffMode != "auto" ? "" : "none");
          minMaxInputRow.style("display", this.cutoffMode == "fixed" ? "table-row" : "none");
          if (this.cutoffMode == "fixed") minInput.node().focus();
          percentRow.style("display", this.cutoffMode == "percentile" ? "" : "none");
          if (this.cutoffMode == "percentile") percentInput.node().focus();
        });
      }
      if (this.setColorsCallback) {
        const colorRow = table.append("tr").style("text-align", "center");
        this.appendColorInput(colorRow.append("td").style("padding-right", "10px"), 0);
        this.appendColorInput(colorRow.append("td"), this.colors.length - 1);
      }
      showTooltip = false;
    }).on("mouseenter", (event2) => {
      event2.stopPropagation();
      if (showTooltip == false) return;
      this.tip.clear().showunder(barG.node());
      const text = `Click to customize ${this.setColorsCallback ? "colors" : ""} ${this.numInputCallback && this.setColorsCallback ? " and " : ""}${this.numInputCallback ? "values" : ""}`;
      this.tip.d.append("div").style("padding", "2px").text(text);
    }).on("mouseleave", () => {
      if (showTooltip) this.tip.hide();
    });
  }
};

// dom/ColorScale/ColorScale.ts
var ColorScale = class {
  constructor(opts) {
    this.barheight = opts.barheight || 14;
    this.barwidth = opts.barwidth || 100;
    this.colors = opts?.colors?.length ? opts.colors : ["white", "red"];
    this.domain = opts.domain;
    this.fontSize = opts.fontSize || 10;
    this.markedValue = opts.markedValue && opts.markedValue > 1e-3 ? opts.markedValue : null;
    this.ticks = opts.ticks || 5;
    this.tickSize = opts.tickSize || 1;
    this.topTicks = opts.topTicks || false;
    this.validateOpts(opts);
    this.tickValues = niceNumLabels(opts.domain);
    let scaleSvg;
    if (opts.width || opts.height) {
      scaleSvg = opts.holder.append("svg").attr("width", opts.width || 100).attr("height", opts.height || 30);
    } else scaleSvg = opts.holder;
    scaleSvg.attr("data-testid", "sjpp-color-scale");
    let barG;
    const position = opts.position || "0,0";
    if (opts.labels) {
      barG = this.renderLabels(scaleSvg, opts.labels, position);
    } else barG = scaleSvg.append("g").attr("transform", `translate(${position})`);
    const id3 = opts.id || Math.random().toString();
    const defs = barG.append("defs");
    const gradient = defs.append("linearGradient").attr("data-testid", "sjpp-color-scale-bar").attr("id", id3);
    if (this.topTicks === true) {
      const { scale, scaleAxis } = this.makeAxis(barG, id3);
      this.makeColorBar(gradient);
      this.dom = { gradient, scale, scaleAxis, barG };
    } else {
      this.makeColorBar(gradient);
      const { scale, scaleAxis } = this.makeAxis(barG, id3);
      this.dom = { gradient, scale, scaleAxis, barG };
      this.markedValueInColorBar();
    }
    this.render();
    if (opts.setColorsCallback || opts.numericInputs) {
      this.menu = this.renderMenu(opts, scaleSvg, barG);
    }
  }
  validateOpts(opts) {
    if (!opts.holder) throw new Error("No holder provided for #dom/ColorScale.");
    if (!opts.domain || !opts.domain.length) throw new Error("No data provided for #dom/ColorScale.");
    if (opts.domain.length != this.colors.length) {
      throw new Error("Data and color arrays for #dom/ColorScale must be the same length");
    }
    if (opts.domain.length != new Set(opts.domain).size) {
      throw new Error("Duplicate values in #dom/ColorScale opts.domain");
    }
    if (opts.labels && (!opts.labels.left || !opts.labels.right))
      throw new Error("Missing a label for #dom/ColorScale.");
  }
  renderLabels(scaleSvg, labels, position) {
    const addLabel = (text, x, y) => {
      return scaleSvg.append("text").text(text).attr("class", "sjpp-color-scale-label").attr("font-size", ".8em").attr("opacity", 0.6).attr("text-anchor", "end").attr("transform", `translate(${x}, ${y})`);
    };
    const [posX, posY] = position.split(",").map(Number);
    const leftLabel = addLabel(labels.left, posX, posY + 10);
    const leftBBox = leftLabel.node().getBBox();
    const startXPos = posX + leftBBox.x + leftBBox.width + 20;
    const barGPos = `${startXPos}, ${posY}`;
    const rightLabelX = startXPos + this.barwidth + 40;
    const rightLabelY = posY + 10;
    const barG = scaleSvg.append("g").attr("transform", `translate(${barGPos})`);
    addLabel(labels.right, rightLabelX, rightLabelY);
    const totalWidth = scaleSvg.node().getBBox().width + leftBBox.width;
    scaleSvg.attr("width", totalWidth);
    return barG;
  }
  getRange() {
    return this.tickValues.map((_, i3) => {
      return this.barwidth * (i3 / (this.tickValues.length - 1));
    });
  }
  makeColorBar(gradient) {
    const gradElem = gradient || this.dom.gradient;
    for (const [idx, c] of this.colors.entries()) {
      const offset = idx / (this.colors.length - 1) * 100;
      gradElem.append("stop").attr("offset", `${offset}%`).attr("stop-color", `${c}`);
    }
  }
  makeAxis(div, id3) {
    div.append("rect").attr("class", "sjpp-color-scale-rect").attr("height", this.barheight).attr("width", this.barwidth).attr("fill", "url(#" + id3 + ")");
    const scaleAxis = div.append("g").attr("data-testid", "sjpp-color-scale-axis");
    if (this.topTicks === false) scaleAxis.attr("transform", `translate(0, ${this.barheight})`);
    const scale = linear().domain(this.tickValues).range(this.getRange());
    return { scale, scaleAxis };
  }
  markedValueInColorBar() {
    if (this.markedValue == null || this.topTicks === true) return;
    this.dom.line = this.dom.barG.append("line").classed("sjpp-color-scale-marked", true).attr("data-testid", "sjpp-color-scale-marked-tick").attr("y1", this.barheight - 2).attr("y2", this.barheight + 1).attr("stroke", "black");
    this.dom.label = this.dom.barG.append("text").classed("sjpp-color-scale-marked", true).attr("data-testid", "sjpp-color-scale-marked-label").attr("text-anchor", "middle").attr("font-family", font).attr("font-size", `${this.fontSize + 2}px`).attr("y", this.barheight - 3).attr("fill", "white").attr("stroke", "black").attr("stroke-width", 0.3);
    this.updateValueInColorBar();
  }
  render() {
    const axis = this.getAxis();
    axisstyle({
      axis: this.dom.scaleAxis.call(axis),
      showline: false,
      fontsize: this.fontSize
    });
  }
  renderMenu(opts, scaleSvg, barG) {
    const _opts = {
      scaleSvg,
      barG,
      domain: this.domain,
      colors: this.colors
    };
    if (opts.setColorsCallback)
      _opts.setColorsCallback = async (val, idx) => {
        if (!val || !isFinite(idx)) return;
        await opts.setColorsCallback(val, idx);
        this.updateColors();
      };
    if (opts.numericInputs) {
      _opts.cutoffMode = opts.numericInputs.cutoffMode || "auto";
      if (opts.numericInputs.defaultPercentile || opts.numericInputs.percentile) {
        _opts.defaultPercentile = opts.numericInputs.defaultPercentile ?? opts.numericInputs.percentile;
        _opts.percentile = opts.numericInputs.percentile ?? opts.numericInputs.defaultPercentile;
      }
      _opts.setNumbersCallback = async (obj) => {
        if (!obj) return;
        await opts.numericInputs.callback(obj);
        this.updateAxis();
      };
    }
    const menu = new ColorScaleMenu(_opts);
    return menu;
  }
  getAxis() {
    const axis = this.topTicks === true ? axisTop(this.dom.scale) : axisBottom(this.dom.scale);
    axis.ticks(this.ticks).tickSize(this.tickSize);
    return axis;
  }
  updateColors() {
    this.dom.gradient.selectAll("stop").remove();
    this.makeColorBar();
  }
  updateAxis() {
    this.dom.scaleAxis.selectAll("*").remove();
    this.tickValues = niceNumLabels(this.domain);
    this.dom.scale = linear().domain(this.tickValues).range(this.getRange());
    this.dom.scaleAxis.transition().duration(400).call(this.getAxis()).selectAll("text").attr("font-size", `${this.fontSize}px`);
    const pathElem = this.dom.scaleAxis.select("path").node();
    if (pathElem instanceof SVGPathElement) pathElem.style.stroke = "none";
  }
  updateValueInColorBar() {
    if (this.markedValue == null || this.topTicks === true) return;
    if (!this.dom.line || !this.dom.label) {
      this.markedValueInColorBar();
    }
    const x = Math.min(this.barwidth, this.dom.scale(this.markedValue));
    this.dom.line.attr("x1", x).attr("x2", x);
    this.dom.label.attr("x", x).text(Math.floor(this.markedValue));
  }
  updateMenu() {
    if (!this.menu) return;
    this.menu.colors = this.colors;
    this.menu.domain = this.domain;
  }
  updateScale() {
    if (this.domain.length != this.colors.length)
      throw new Error("Data and color arrays for #dom/ColorScale must be the same length");
    this.updateColors();
    this.updateAxis();
    this.updateValueInColorBar();
    this.updateMenu();
  }
};

// dom/ColorScale/colorScale.helpers.ts
function getInterpolatedDomainRange({
  absMin,
  absMax,
  negInterpolator,
  posInterpolator,
  middleColor = "white",
  totalNumSteps = 100
}) {
  const denominator = negInterpolator && posInterpolator ? totalNumSteps / 2 : totalNumSteps;
  const stepSize = (absMax - absMin) / denominator;
  const neg = { values: /* @__PURE__ */ new Set(), colors: [] };
  const pos = { values: /* @__PURE__ */ new Set(), colors: [] };
  let n = -absMax;
  for (let p = 0; p < absMax; p += stepSize) {
    if (p == 0) continue;
    if (negInterpolator) {
      n += stepSize;
      if (n == 0) continue;
      const vn = n;
      neg.values.add(vn);
      neg.colors.push(negInterpolator(-vn / absMax));
    }
    if (posInterpolator) {
      const vp = p;
      pos.values.add(vp);
      pos.colors.push(posInterpolator(vp / absMax));
    }
  }
  if (negInterpolator && posInterpolator) {
    const domain = [-absMax, ...neg.values, 0, ...pos.values, absMax];
    const range2 = [negInterpolator(1), ...neg.colors, middleColor, ...pos.colors, posInterpolator(1)];
    if (domain.length != range2.length)
      throw new Error(`unable to generate same-sized numeric -/+ domain and color range`);
    return { domain, range: range2 };
  } else if (negInterpolator) {
    const domain = [-absMax, ...neg.values, 0];
    const range2 = [negInterpolator(1), ...neg.colors, negInterpolator(0)];
    if (domain.length != range2.length) throw new Error(`unable to generate same-sized negative domain and color range`);
    return { domain, range: range2 };
  } else if (posInterpolator) {
    const domain = [0, ...pos.values, absMax];
    const range2 = [posInterpolator(0), ...pos.colors, posInterpolator(1)];
    if (domain.length != range2.length) throw new Error(`unable to generate same-sized positive domain and color range`);
    return { domain, range: range2 };
  } else {
    throw `missing both negInterpolator and posInterpolator in getInterpolatedDomainRange()`;
  }
}
function colorDelta(rgb1, rgb2) {
  const a = rgb1.split("(")[1].slice(0, -1).split(",").slice(0, 3);
  const b = rgb2.split("(")[1].slice(0, -1).split(",").slice(0, 3);
  let maxDiff = 0;
  for (const [i3, v] of a.entries()) {
    const d = v - b[i3];
    if (maxDiff < d) maxDiff = d;
  }
  return maxDiff;
}
function removeOutliers(domain, _opts = {}) {
  const opts = Object.assign(
    {
      minPercentile: 0.01,
      maxPercentile: 0.99,
      baseValue: void 0
      // if specified and detected in the domain, this value must not be considered an outlier
    },
    _opts
  );
  const sorted = domain.sort((a, b) => a - b);
  const first = sorted[0] === opts.baseValue ? opts.baseValue : sorted[Math.floor(sorted.length * opts.minPercentile)];
  const last = sorted[sorted.length - 1] === opts.baseValue ? opts.baseValue : sorted[Math.floor(sorted.length * opts.maxPercentile)];
  let calculatedArray = sorted.filter((d) => d >= first && d <= last);
  if (calculatedArray.length === 0) {
    const hasNeg = sorted[0] < 0;
    const hasBoth = hasNeg && sorted[sorted.length - 1] > 0;
    const idxClosestToZero = () => {
      return sorted.reduce((closestIdx, currentValue, currentIdx) => {
        const closestValue = sorted[closestIdx];
        return Math.abs(currentValue) < Math.abs(closestValue) ? currentIdx : closestIdx;
      }, 0);
    };
    const idx = hasBoth ? idxClosestToZero() : hasNeg ? sorted.length - 1 : 0;
    const firstValue = sorted[idx] ?? 0;
    const secondValue = hasBoth ? sorted[idx - 1] ?? firstValue : hasNeg ? sorted[idx - 1] ?? firstValue : sorted[idx + 1] ?? firstValue;
    const thirdValue = hasBoth ? sorted[idx + 1] ?? firstValue : hasNeg ? sorted[idx - 2] ?? secondValue : sorted[idx + 2] ?? secondValue;
    calculatedArray = [firstValue, secondValue, thirdValue].sort((a, b) => a - b);
  }
  return calculatedArray;
}
function computeTicks(domainRange, targetIntervals) {
  if (!isFinite(domainRange) || domainRange === 0 || targetIntervals == 0) return 1;
  if (domainRange < 0 || targetIntervals < 0) {
    throw new Error(
      `Neither domainRange or targetIntervals can be a non-negative number. Received domainRange: ${domainRange}, targetIntervals: ${targetIntervals}`
    );
  }
  const intervals = Math.max(1, targetIntervals ?? 4);
  const step = domainRange / intervals;
  if (!isFinite(step) || step <= 0) return 1;
  return step <= 2 ? 2 : step <= 3 ? 3 : 5;
}

// dom/cnvConfig.ts
function renderCnvConfig(arg) {
  const { cnvGainCutoff, cnvLossCutoff } = arg;
  const cnvMaxLength = arg.cnvMaxLength === null ? -1 : arg.cnvMaxLength;
  const fractionOverlap = arg.fractionOverlap || 0.8;
  if (!Number.isFinite(cnvGainCutoff) && !Number.isFinite(cnvLossCutoff) && !Number.isFinite(cnvMaxLength)) {
    return;
  }
  const div = arg.holder;
  div.style("margin", "10px");
  const tip = new Menu({ padding: "5px" });
  const genotypeDiv = div.append("div").style("margin-bottom", "10px");
  let genotypeRadio;
  if (arg.genotypeToggle) {
    const cnvWT = arg.cnvWT || false;
    genotypeDiv.append("div").style("display", "inline-block").style("margin-right", "5px").style("opacity", 0.7).text("CNV genotype");
    genotypeRadio = make_radios({
      holder: genotypeDiv,
      styles: { display: "inline-block" },
      options: [
        { label: "Altered", value: "altered", checked: !cnvWT },
        { label: "Wildtype", value: "wildtype", checked: cnvWT }
      ],
      callback: () => {
      }
    });
  }
  const cutoffsDiv = div.append("div");
  cutoffsDiv.append("div").style("opacity", 0.7).style("margin-bottom", "10px").text("CNV cutoffs:");
  const inputsDiv = cutoffsDiv.append("div").style("margin-left", "10px");
  let cnvGainInput;
  if (Number.isFinite(cnvGainCutoff)) {
    const cnvGainDiv = inputsDiv.append("div").style("margin-bottom", "5px");
    cnvGainDiv.append("span").style("opacity", 0.7).text("Minimum CNV Gain (log2 ratio)");
    cnvGainInput = cnvGainDiv.append("input").attr("data-testid", "sjpp-cnv-gain-input").attr("type", "number").property("value", cnvGainCutoff).style("width", "100px").style("margin-left", "15px").on("change", (event2) => {
      const value = event2.target.value;
      if (!isValidNumber(value)) {
        window.alert("Please enter a numeric value.");
        event2.target.value = cnvGainCutoff;
        return;
      }
      if (Number(value) < 0) {
        window.alert("Value must be a positive value.");
        event2.target.value = cnvGainCutoff;
        return;
      }
    });
  }
  let cnvLossInput;
  if (Number.isFinite(cnvLossCutoff)) {
    const cnvLossDiv = inputsDiv.append("div").style("margin-bottom", "5px");
    cnvLossDiv.append("span").style("opacity", 0.7).text("Maximum CNV Loss (log2 ratio)");
    cnvLossInput = cnvLossDiv.append("input").attr("data-testid", "sjpp-cnv-loss-input").attr("type", "number").property("value", cnvLossCutoff).style("width", "100px").style("margin-left", "15px").on("change", (event2) => {
      const value = event2.target.value;
      if (!isValidNumber(value)) {
        window.alert("Please enter a numeric value.");
        event2.target.value = cnvLossCutoff;
        return;
      }
      if (Number(value) > 0) {
        window.alert("Value must be a negative value.");
        event2.target.value = cnvLossCutoff;
        return;
      }
    });
  }
  let cnvLengthInput;
  if (Number.isFinite(cnvMaxLength)) {
    const cnvLengthDiv = inputsDiv.append("div").style("margin-bottom", "5px");
    cnvLengthDiv.append("span").style("opacity", 0.7).text("CNV Max Length (bp)");
    cnvLengthInput = cnvLengthDiv.append("input").attr("data-testid", "sjpp-cnv-length-input").attr("type", "number").property("value", cnvMaxLength).style("width", "100px").style("margin-left", "15px").on("change", (event2) => {
      const value = event2.target.value;
      if (!isValidNumber(value)) {
        window.alert("Please enter a numeric value.");
        event2.target.value = cnvMaxLength;
        return;
      }
    }).on("mouseover", (event2) => {
      tip.clear();
      tip.d.append("div").text("Please enter a positive value. To include all CNV segments, enter -1.");
      tip.showunder(event2.target);
    }).on("mouseout", () => {
      tip.hide();
    });
  }
  let overlapInput;
  if (arg.showOverlap && Number.isFinite(fractionOverlap)) {
    const percentOverlap = fractionOverlap * 100;
    const overlapDiv = inputsDiv.append("div").style("margin-bottom", "5px");
    overlapDiv.append("span").style("opacity", 0.7).text("Minimum Overlap (%)");
    overlapInput = overlapDiv.append("input").attr("data-testid", "sjpp-cnv-length-input").attr("type", "number").property("value", percentOverlap).style("width", "100px").style("margin-left", "15px").on("change", (event2) => {
      const value = event2.target.value;
      if (!isValidNumber(value)) {
        window.alert("Please enter a numeric value.");
        event2.target.value = percentOverlap;
        return;
      }
    }).on("mouseover", (event2) => {
      tip.clear();
      tip.d.append("div").text("Percent of query region overlapping CNV segment");
      tip.showunder(event2.target);
    }).on("mouseout", () => {
      tip.hide();
    });
  }
  div.append("div").append("button").attr("data-testid", "sjpp-cnvConfig-apply").style("margin-top", "15px").text("Apply").on("click", () => {
    const config = {};
    if (cnvGainInput) config.cnvGainCutoff = Number(cnvGainInput.property("value"));
    if (cnvLossInput) config.cnvLossCutoff = Number(cnvLossInput.property("value"));
    if (cnvLengthInput) {
      const tempCnvMaxLength = Number(cnvLengthInput.property("value"));
      config.cnvMaxLength = tempCnvMaxLength == -1 ? null : tempCnvMaxLength;
    }
    if (overlapInput) {
      const percentOverlap = Number(overlapInput.property("value"));
      config.fractionOverlap = percentOverlap / 100;
    }
    if (genotypeRadio) {
      const radios = genotypeRadio.inputs.nodes();
      const selected = radios.find((r) => r.checked);
      if (!selected) throw "no selected radio found";
      config.cnvWT = selected.value == "wildtype";
    }
    arg.callback(config);
  });
}
function isValidNumber(s) {
  if (s === "") return false;
  const n = Number(s);
  return Number.isFinite(n);
}

// dom/sayerror.ts
function sayerror(holder, o) {
  let msg;
  if (typeof o == "string") {
    msg = o;
  } else {
    msg = o.message || o.error;
    if (o.stack) console.log(o.stack);
  }
  holder.style("padding-left", "10px");
  const div = holder.append("div").attr("class", holder.classed("sja_errorbar") ? null : "sja_errorbar").style("border-radius", "5px");
  div.append("div").style("padding-right", "8px").html("&#10005;").style("display", "inline-block").on("click", () => {
    disappear(div, true);
  });
  div.append("div").style("display", "inline-block").text(msg);
}
function throwMsgWithFilePathAndFnName(message) {
  try {
    throw new Error();
  } catch (error) {
    const stackLines = error.stack.split("\n");
    const callerLine = stackLines[2].trim();
    const regex = /\s*at\s+(.*)\s+\((.*).proteinpaint.js:(\d+):(\d+)\)/;
    const match2 = callerLine.match(regex);
    if (match2) {
      const functionName = match2[1];
      const fileName = match2[2].replace(/^.*\/bin\//, "").replace(/_([^_]+)$/, ".$1").replaceAll(/_/g, "/");
      const errorMsg = `${message} [${fileName} ${functionName}()]`;
      throw new Error(errorMsg);
    } else {
      throw new Error(message);
    }
  }
}
function showErrorsWithCounter(errs, holder) {
  if (typeof errs == "string") return sayerror(holder, errs);
  if (errs.length === 0) return;
  if (errs.length === 1) return sayerror(holder, errs[0]);
  let showErrors = false;
  const wrapper = holder.append("div").attr("class", "sja_errorbar").on("click", () => {
    showErrors = !showErrors;
    errorsDiv.style("display", showErrors ? "block" : "none");
  });
  wrapper.append("div").style("padding-right", "8px").style("display", "inline-block").html("&#10005;").on("click", () => {
    disappear(wrapper, true);
  });
  const counterTextDiv = wrapper.append("div").style("display", "inline-block");
  counterTextDiv.append("div").style("display", "inline-block").style("color", "white").style("background-color", "red").style("border-radius", "100px").style("padding", "1px 4px").text(errs.length);
  counterTextDiv.append("div").text("errors found.").style("padding", "3px").style("display", "inline-block");
  const errorsDiv = wrapper.append("div").style("display", "none").style("margin-left", "10px");
  for (const err of errs) {
    errorsDiv.append("div").text(err);
  }
}

// dom/genePlotActions.ts
function createLollipopFromGene(geneSymbol, app) {
  const cfg = {
    type: "plot_create",
    config: {
      chartType: "genomeBrowser",
      snvindel: { shown: true },
      // always set snvindel.shown=true so the mds3 tk is always shown; since grin2 works for this ds, it doesn't matter whether snvindel/cnv/svfusion any is present; all will be shown in mds3 tk
      geneSearchResult: { geneSymbol }
    }
  };
  if (app.vocabApi.termdbConfig.queries.trackLst?.activeTracks) {
    cfg.config.trackLst = structuredClone(app.vocabApi.termdbConfig.queries.trackLst);
    cfg.config.trackLst.activeTracks = [];
  }
  app.dispatch(cfg);
}
async function createMatrixFromGenes(geneSymbols, app) {
  const MAX_GENES = 100;
  const genesToUse = geneSymbols.slice(0, MAX_GENES);
  try {
    const termwrappers = await Promise.all(
      genesToUse.map(async (gene) => {
        const term = {
          type: "geneVariant",
          gene,
          name: gene
        };
        const minTwCopy = app.vocabApi.getTwMinCopy({ term, q: {} });
        return {
          $id: await get$id2(minTwCopy),
          term,
          q: {}
        };
      })
    );
    app.dispatch({
      type: "plot_create",
      config: {
        chartType: "matrix",
        dataType: "geneVariant",
        termgroups: [
          {
            name: "Genomic Alterations",
            lst: termwrappers
          }
        ]
      }
    });
  } catch (error) {
    sayerror(app.dom.div, `Error creating matrix: ${error instanceof Error ? error.message : error}`);
  }
}

// dom/resultsTable.ts
function showResultsTable(opts) {
  const {
    tableDiv,
    hits,
    app,
    clickMenu,
    columns: prebuiltColumns,
    rows: prebuiltRows,
    dataItems: prebuiltDataItems,
    getRowKey = (item) => item.gene,
    matrixButtonFormat = "Matrix ({n})",
    ...renderTableOpts
  } = opts;
  const dataItems = prebuiltDataItems || hits;
  if (!dataItems || dataItems.length === 0) return;
  const useManhattanDefaults = !prebuiltColumns && hits && hits[0]?.chrom;
  if (!prebuiltColumns && !useManhattanDefaults) {
    throw new Error("showResultsTable: `columns` is required when `hits` is not manhattan-shaped");
  }
  const columns = prebuiltColumns || [
    { label: "Gene" },
    { label: `${hits[0].chrom.charAt(0).toUpperCase()}${hits[0].chrom.slice(1).toLowerCase()} pos` },
    { label: "Type" },
    { label: "Q-value", sortable: true },
    { label: "Subject count", sortable: true }
  ];
  const rows = prebuiltRows || hits.map((d) => [
    { value: d.gene },
    { html: `<span style="font-size:.8em">${d.start}-${d.end}</span>` },
    { html: `<span style="color:${d.color}">\u25CF</span> ${d.type.charAt(0).toUpperCase() + d.type.slice(1)}` },
    { value: d.q_value.toPrecision(3) },
    { value: d.nsubj }
  ]);
  const tableOptions = {
    div: tableDiv,
    columns,
    rows,
    showLines: false,
    showHeader: true,
    striped: true,
    resize: "both",
    header: { allowSort: true },
    ...renderTableOpts
  };
  if (app) {
    let lastTouchedGene = null;
    let selectionOrder = [];
    tableOptions.buttonsToLeft = true;
    tableOptions.buttons = [
      {
        text: matrixButtonFormat.replace("{n}", "0"),
        callback: (selectedIndices, buttonNode) => {
          if (selectedIndices.length > 0) {
            buttonNode.disabled = true;
            const selectedGenes = selectedIndices.map((idx) => getRowKey(dataItems[idx]));
            clickMenu?.hide();
            createMatrixFromGenes(selectedGenes, app);
          }
        },
        onChange: (selectedIndices, buttonNode) => {
          buttonNode.textContent = matrixButtonFormat.replace("{n}", String(selectedIndices.length));
          buttonNode.disabled = selectedIndices.length === 0;
        }
      },
      {
        text: "Lollipop",
        callback: (_selectedIndices, buttonNode) => {
          if (lastTouchedGene) {
            buttonNode.disabled = true;
            clickMenu?.hide();
            createLollipopFromGene(lastTouchedGene, app);
          }
        },
        onChange: (selectedIndices, buttonNode) => {
          const result = updateSelectionTracking(selectionOrder, selectedIndices, dataItems, getRowKey);
          selectionOrder = result.selectionOrder;
          lastTouchedGene = result.lastTouchedGene;
          buttonNode.textContent = result.buttonText;
          buttonNode.disabled = result.buttonDisabled;
        }
      }
    ];
  }
  renderTable(tableOptions);
}
function updateSelectionTracking(currentSelectionOrder, selectedIndices, dataSource, getRowKey) {
  const newlySelected = selectedIndices.filter((idx) => !currentSelectionOrder.includes(idx));
  const updatedSelectionOrder = currentSelectionOrder.filter((idx) => selectedIndices.includes(idx));
  updatedSelectionOrder.push(...newlySelected);
  let lastTouchedGene = null;
  let buttonText = "Lollipop";
  if (updatedSelectionOrder.length > 0) {
    const lastSelectedIdx = updatedSelectionOrder[updatedSelectionOrder.length - 1];
    const dataItem = dataSource[lastSelectedIdx];
    const v = dataItem != null ? getRowKey(dataItem) : null;
    lastTouchedGene = v != null ? String(v) : null;
    if (lastTouchedGene !== null) buttonText = `Lollipop (${lastTouchedGene})`;
  }
  return {
    selectionOrder: updatedSelectionOrder,
    lastTouchedGene,
    buttonText,
    buttonDisabled: lastTouchedGene === null
  };
}

// dom/dataPointClickMenu.ts
function openActionMenu(opts) {
  opts.menu.clear();
  const container = opts.menu.d.append("div").style("margin", "10px");
  if (opts.actions.length > 0) {
    const buttonRow = container.append("div").style("margin-bottom", "10px");
    for (const a of opts.actions) {
      buttonRow.append("button").attr("class", "sja_menuoption").style("margin-right", "5px").text(a.label).on("click", async () => {
        opts.menu.hide();
        await a.onClick();
      });
    }
  }
  opts.renderInfo(container);
  opts.menu.show2(opts.event.clientX, opts.event.clientY);
}
function openMultiHitClickMenu(opts) {
  opts.menu.clear();
  const holder = opts.menu.d.append("div").style("margin", "10px");
  if (opts.header) {
    holder.append("div").style("color", "#888").style("font-weight", "bold").style("margin", "0 0 6px 0").text(opts.header);
  }
  showResultsTable({
    tableDiv: holder,
    dataItems: opts.items,
    columns: opts.columns,
    rows: opts.rows,
    getRowKey: opts.getRowKey,
    singleMode: true,
    // `i` is the sorted-table position, not the original index — after a
    // column sort it would point at the wrong item. The checkbox node's
    // `value` is the original index (renderTable sets it from rowsCopy
    // before sorting), so resolve from there.
    noButtonCallback: (_i, checkbox) => {
      const originalIdx = Number.parseInt(checkbox.value);
      if (Number.isNaN(originalIdx)) return;
      opts.onRowClick(opts.items[originalIdx], opts.event);
    }
  });
  opts.menu.show2(opts.event.clientX, opts.event.clientY);
}

// dom/quadtreeHitTest.ts
function findPointsInRadius(qt, mx, my, hitRadius, getX = (d) => d.pixel_x, getY = (d) => d.pixel_y) {
  const candidates = [];
  qt.visit((node, x1, y1, x2, y2) => {
    if (x1 > mx + hitRadius || x2 < mx - hitRadius || y1 > my + hitRadius || y2 < my - hitRadius) {
      return true;
    }
    if (!node.length) {
      let current = node;
      while (current) {
        const point = current.data;
        if (point) {
          const px2 = getX(point);
          const py = getY(point);
          const distance = Math.sqrt((mx - px2) ** 2 + (my - py) ** 2);
          if (distance <= hitRadius) {
            candidates.push({ point, distance });
          }
        }
        current = current.next;
      }
    }
    return false;
  });
  return candidates;
}

// dom/hoverShapes.ts
function drawHoverShapes(layer, shapes2) {
  layer.selectAll("path").remove();
  for (const s of shapes2) {
    const p = layer.append("path").attr("d", s.path).attr("transform", s.transform).attr("fill", s.fill ?? "none").attr("stroke", s.stroke ?? "black").attr("stroke-width", s.strokeWidth ?? 1.5);
    if (s.fillOpacity !== void 0) p.attr("fill-opacity", s.fillOpacity);
    if (s.nonScalingStroke !== false) p.style("vector-effect", "non-scaling-stroke");
  }
}

// dom/dataPointInteractions.ts
var DataPointInteractions = class {
  constructor(opts) {
    this.qt = null;
    this.clickMenuIsShown = false;
    this.opts = opts;
    this.clickMenu = new Menu({
      padding: opts.clickMenuPadding ?? "",
      onHide: () => {
        this.clickMenuIsShown = false;
        drawHoverShapes(this.opts.hoverLayer, []);
      }
    });
  }
  /** Build the quadtree and wire mousemove / mouseleave / click on the cover. */
  attach() {
    this.qt = quadtree().x(this.opts.getX).y(this.opts.getY).addAll(this.opts.points);
    this.opts.hoverTip.d.style("pointer-events", "none");
    this.opts.cover.on("mousemove", (event2) => this.onMousemove(event2));
    this.opts.cover.on("mouseleave", () => this.onMouseleave());
    this.opts.cover.on("click", (event2) => this.onClick(event2));
  }
  /** Detach, then dispose of the click Menu. Use instead of `detach()` when this instance is
   * being discarded rather than paused — a Menu owns a div on `<body>` and a body-level
   * mousedown listener, so a caller that constructs a new DataPointInteractions per render
   * leaks both for every render unless it destroys the old one. Not reusable afterwards. */
  destroy() {
    this.detach();
    this.clickMenu.destroy();
  }
  /** Detach event handlers and clear hover state. Quadtree is dropped. */
  detach() {
    this.opts.cover.on("mousemove", null);
    this.opts.cover.on("mouseleave", null);
    this.opts.cover.on("click", null);
    drawHoverShapes(this.opts.hoverLayer, []);
    this.opts.hoverTip.hide();
    this.opts.hoverTip.d.style("pointer-events", null);
    this.clickMenu.hide();
    this.qt = null;
  }
  resolveHitRadius() {
    const r = this.opts.hitRadius;
    return typeof r === "function" ? r() : r;
  }
  localCoords(event2) {
    if (this.opts.toLocalCoords) return this.opts.toLocalCoords(event2);
    const rect = this.opts.cover.node().getBoundingClientRect();
    return [event2.clientX - rect.left, event2.clientY - rect.top];
  }
  findCandidates(event2) {
    if (!this.qt) return [];
    const [mx, my] = this.localCoords(event2);
    const hits = findPointsInRadius(this.qt, mx, my, this.resolveHitRadius(), this.opts.getX, this.opts.getY);
    const buffer = this.opts.perDotBuffer ?? 0;
    return hits.filter((c) => {
      if (this.opts.isHidden && this.opts.isHidden(c.point)) return false;
      if (this.opts.perDotRadius) return c.distance <= this.opts.perDotRadius(c.point) + buffer;
      return true;
    }).sort((a, b) => a.distance - b.distance).map((c) => c.point);
  }
  /** Apply the optional cluster-around-seed step. */
  resolveDots(candidates) {
    if (!this.opts.getCluster || candidates.length === 0) return candidates;
    return this.opts.getCluster(candidates[0], this.opts.points);
  }
  onMousemove(event2) {
    if (this.clickMenuIsShown) return;
    const dots = this.resolveDots(this.findCandidates(event2));
    if (dots.length === 0) {
      drawHoverShapes(this.opts.hoverLayer, []);
      this.opts.hoverTip.hide();
      return;
    }
    const max = this.opts.maxTooltipRows ?? 5;
    const shown = dots.slice(0, max);
    const additional = dots.length - shown.length;
    drawHoverShapes(
      this.opts.hoverLayer,
      shown.map((d) => this.opts.toHoverSpec(d))
    );
    this.opts.hoverTip.clear();
    if (shown.length === 1) {
      this.opts.renderSingleHoverTooltip(shown[0], this.opts.hoverTip.d);
    } else {
      const holder = this.opts.hoverTip.d.append("div").style("margin", "10px");
      const { columns, rows } = this.opts.buildMultiHitTableData(shown);
      showResultsTable({
        tableDiv: holder,
        dataItems: shown,
        getRowKey: this.opts.getRowKey,
        columns,
        rows
      });
      if (additional > 0) {
        const noun = this.opts.itemNoun ?? "item";
        holder.append("div").style("font-size", "0.85em").style("color", "#666").style("font-style", "italic").text(`and ${additional} more ${noun}${additional > 1 ? "s" : ""}...`);
      }
    }
    this.opts.hoverTip.show2(event2.clientX, event2.clientY);
  }
  onMouseleave() {
    if (this.clickMenuIsShown) return;
    drawHoverShapes(this.opts.hoverLayer, []);
    this.opts.hoverTip.hide();
  }
  onClick(event2) {
    const dots = this.resolveDots(this.findCandidates(event2));
    if (dots.length === 0) return;
    this.opts.hoverTip.hide();
    this.clickMenuIsShown = true;
    drawHoverShapes(
      this.opts.hoverLayer,
      dots.map((d) => this.opts.toHoverSpec(d))
    );
    const ctx = {
      clickMenu: this.clickMenu,
      dismiss: () => {
        this.clickMenuIsShown = false;
        drawHoverShapes(this.opts.hoverLayer, []);
      }
    };
    if (dots.length === 1) {
      if (this.opts.onSingleClick) this.opts.onSingleClick(dots[0], event2, ctx);
      else this.openDefaultActionMenu(dots[0], event2);
      return;
    }
    if (this.opts.onMultiClick) this.opts.onMultiClick(dots, event2, ctx);
    else this.openDefaultMultiHitMenu(dots, event2);
  }
  openDefaultActionMenu(d, event2) {
    if (!this.opts.getActions) return;
    openActionMenu({
      menu: this.clickMenu,
      event: event2,
      actions: this.opts.getActions(d),
      renderInfo: (container) => this.opts.renderSingleHitInfo?.(d, container)
    });
  }
  openDefaultMultiHitMenu(dots, event2) {
    if (!this.opts.getRowKey) return;
    const { columns, rows } = this.opts.buildMultiHitTableData(dots);
    openMultiHitClickMenu({
      menu: this.clickMenu,
      event: event2,
      items: dots,
      columns,
      rows,
      getRowKey: this.opts.getRowKey,
      onRowClick: (d, e) => this.openDefaultActionMenu(d, e)
    });
  }
};

// dom/sketchGm.ts
function setupCanvas(canvas, width, height) {
  const dpr = window.devicePixelRatio || 1;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  canvas.width = width * dpr;
  canvas.height = height * dpr;
  const ctx = canvas.getContext("2d");
  ctx.scale(dpr, dpr);
  return ctx;
}
function sketchSplicerna(holder, gm, pxwidth, color) {
  let intronpx = 10;
  if (intronpx * (gm.exon.length - 1) > pxwidth * 0.3) {
    intronpx = Math.max(2, pxwidth * 0.3 / (gm.exon.length - 1));
  }
  let exonlen = 0;
  for (const e of gm.exon) {
    exonlen += e[1] - e[0];
  }
  const inw = intronpx * (gm.exon.length - 1);
  const exonsf = (pxwidth - (inw > pxwidth * 0.4 ? 0 : inw)) / exonlen;
  pxwidth = exonsf * exonlen + inw;
  const canvas = holder.append("canvas").node();
  const h = 20;
  const pad = 4;
  const ctx = setupCanvas(canvas, pxwidth, h);
  ctx.strokeStyle = color;
  ctx.beginPath();
  ctx.moveTo(0, Math.floor(h / 2) - 0.5);
  ctx.lineTo(pxwidth, Math.floor(h / 2) - 0.5);
  ctx.stroke();
  const reverse = gm.strand === "-";
  let x = 0;
  for (const e of gm.exon) {
    let thin1 = null, thick = null, thin2 = null;
    if (reverse) {
      if (gm.codingstop === void 0 || gm.codingstart === void 0) {
        thin1 = e;
      } else {
        const start = e[1], stop = e[0], cds5 = gm.codingstop, cds3 = gm.codingstart;
        if (stop >= cds5) {
          thin1 = e;
        } else if (stop >= cds3) {
          if (start >= cds5) {
            thin1 = [cds5, start];
            thick = [stop, cds5];
          } else {
            thick = e;
          }
        } else {
          if (start >= cds5) {
            thin1 = [cds5, start];
            thin2 = [stop, cds3];
            thick = [cds3, cds5];
          } else if (start >= cds3) {
            thin2 = [stop, cds3];
            thick = [cds3, start];
          } else {
            thin2 = e;
          }
        }
      }
    } else {
      if (gm.codingstart === void 0 || gm.codingstop === void 0) {
        thin1 = e;
      } else {
        if (e[1] <= gm.codingstart) {
          thin1 = e;
        } else if (e[1] <= gm.codingstop) {
          if (e[0] <= gm.codingstart) {
            thin1 = [e[0], gm.codingstart];
            thick = [gm.codingstart, e[1]];
          } else {
            thick = e;
          }
        } else {
          if (e[0] <= gm.codingstart) {
            thin1 = [e[0], gm.codingstart];
            thin2 = [gm.codingstop, e[1]];
            thick = [gm.codingstart, gm.codingstop];
          } else if (e[0] < gm.codingstop) {
            thin2 = [gm.codingstop, e[1]];
            thick = [e[0], gm.codingstop];
          } else {
            thin2 = e;
          }
        }
      }
    }
    if (thin1) {
      ctx.fillStyle = "#aaa";
      const exonw = Math.max(1, (thin1[1] - thin1[0]) * exonsf);
      ctx.fillRect(x, pad, exonw, h - pad * 2);
      x += exonw;
    }
    if (thick) {
      ctx.fillStyle = color;
      const exonw = Math.max(1, (thick[1] - thick[0]) * exonsf);
      ctx.fillRect(x, 0, exonw, h);
      x += exonw;
    }
    if (thin2) {
      ctx.fillStyle = "#aaa";
      const exonw = Math.max(1, (thin2[1] - thin2[0]) * exonsf);
      ctx.fillRect(x, pad, exonw, h - pad * 2);
      x += exonw;
    }
    x += intronpx;
  }
}
function posToPx(rglst, chr, pos, exonsf, intronw) {
  let x = 0;
  let nearest;
  let nearestDist = Infinity;
  for (const r of rglst) {
    if (r.chr !== chr) {
      x += r.width + intronw;
      continue;
    }
    if (pos >= r.start && pos <= r.stop) {
      return x + (r.reverse ? r.stop - pos : pos - r.start) * exonsf;
    }
    const dist = pos < r.start ? r.start - pos : pos - r.stop;
    if (dist < nearestDist) {
      nearestDist = dist;
      const edge = pos < r.start ? r.start : r.stop;
      nearest = x + (r.reverse ? r.stop - edge : edge - r.start) * exonsf;
    }
    x += r.width + intronw;
  }
  return nearest;
}
function sketchGmsum(holder, rglst, gm, exonsf, intronw, pxwidth, h, color, opts = {}) {
  const canvas = holder.append("canvas").node();
  const pad = Math.ceil(h / 5);
  const ctx = setupCanvas(canvas, pxwidth, h);
  const start = posToPx(rglst, gm.chr, gm.start, exonsf, intronw);
  const stop = posToPx(rglst, gm.chr, gm.stop, exonsf, intronw);
  if (start !== void 0 && stop !== void 0) {
    ctx.strokeStyle = color;
    ctx.beginPath();
    ctx.moveTo(start, Math.floor(h / 2) + 0.5);
    ctx.lineTo(stop, Math.floor(h / 2) + 0.5);
    ctx.stroke();
  }
  const thin = [];
  if (gm.utr5) thin.push(...gm.utr5);
  if (gm.utr3) thin.push(...gm.utr3);
  if (!gm.cdslen) thin.push(...gm.exon);
  for (const e of thin) {
    let x = 0;
    for (const r of rglst) {
      if (r.chr !== gm.chr) {
        x += r.width + intronw;
        continue;
      }
      const start2 = Math.max(e[0], r.start);
      const stop2 = Math.min(e[1], r.stop);
      if (start2 >= stop2) {
        x += r.width + intronw;
        continue;
      }
      ctx.fillStyle = "#aaa";
      ctx.fillRect(
        x + (r.reverse ? (r.stop - stop2) * exonsf : (start2 - r.start) * exonsf),
        pad,
        Math.max(1, (stop2 - start2) * exonsf),
        h - pad * 2
      );
      x += r.width + intronw;
    }
  }
  if (gm.coding) {
    for (const e of gm.coding) {
      let x = 0;
      for (const r of rglst) {
        if (r.chr !== gm.chr) {
          x += r.width + intronw;
          continue;
        }
        const start2 = Math.max(e[0], r.start);
        const stop2 = Math.min(e[1], r.stop);
        if (start2 >= stop2) {
          x += r.width + intronw;
          continue;
        }
        ctx.fillStyle = color;
        ctx.fillRect(
          x + (r.reverse ? (r.stop - stop2) * exonsf : (start2 - r.start) * exonsf),
          0,
          Math.max(1, (stop2 - start2) * exonsf),
          h
        );
        x += r.width + intronw;
      }
    }
  }
  if (opts.exonNumbers) drawExonNumbers(ctx, rglst, gm, exonsf, intronw, h);
}
function drawExonNumbers(ctx, rglst, gm, exonsf, intronw, h) {
  const ordered = [...gm.exon].sort((a, b) => a[0] - b[0]);
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = `${Math.max(8, Math.min(10, h - 6))}px Arial`;
  for (const [i3, e] of ordered.entries()) {
    const label = String(gm.strand == "-" ? ordered.length - i3 : i3 + 1);
    let bestX = 0;
    let bestW = 0;
    let bestCenter = 0;
    let x = 0;
    for (const r of rglst) {
      if (r.chr !== gm.chr) {
        x += r.width + intronw;
        continue;
      }
      const start = Math.max(e[0], r.start);
      const stop = Math.min(e[1], r.stop);
      const w = (stop - start) * exonsf;
      if (start < stop && w > bestW) {
        bestW = w;
        bestX = x + (r.reverse ? (r.stop - stop) * exonsf : (start - r.start) * exonsf);
        bestCenter = (start + stop) / 2;
      }
      x += r.width + intronw;
    }
    if (bestW < ctx.measureText(label).width + 4) continue;
    const onCoding = gm.coding?.some((c) => c[0] <= bestCenter && c[1] >= bestCenter);
    ctx.fillStyle = onCoding ? "#fff" : "#333";
    ctx.fillText(label, bestX + bestW / 2, h / 2);
  }
}
function sketchRna(holder, gm, pxwidth, color) {
  const canvas = holder.append("canvas").node();
  const h = 20;
  const pad = 4;
  const ctx = setupCanvas(canvas, pxwidth, h);
  if (!gm.cdslen) {
    ctx.fillStyle = "#aaa";
    ctx.fillRect(0, pad, pxwidth, h - pad * 2);
    return;
  }
  const sf = pxwidth / gm.rnalen;
  let x = 0;
  if (gm.utr5) {
    let ulen = 0;
    for (const e of gm.utr5) ulen += e[1] - e[0];
    ctx.fillStyle = "#aaa";
    ctx.fillRect(0, pad, sf * ulen, h - pad * 2);
    x = sf * ulen;
  }
  if (gm.pdomains && gm.pdomains.length) {
    ctx.fillStyle = "white";
    ctx.fillRect(x, 0, gm.cdslen * sf, h);
    gm.pdomains.sort((a, b) => b.stop - b.start - a.stop + a.start);
    for (const domain of gm.pdomains) {
      ctx.fillStyle = domain.color;
      ctx.fillRect(x + domain.start * 3 * sf, 0, (domain.stop - domain.start + 1) * 3 * sf, h);
    }
    ctx.strokeStyle = "black";
    ctx.strokeRect(x, 0, gm.cdslen * sf, h);
  } else {
    ctx.fillStyle = color;
    ctx.fillRect(x, 0, gm.cdslen * sf, h);
  }
  x += gm.cdslen * sf;
  if (gm.utr3) {
    let ulen = 0;
    for (const e of gm.utr3) ulen += e[1] - e[0];
    ctx.fillStyle = "#aaa";
    ctx.fillRect(x, pad, sf * ulen, h - pad * 2);
  }
}
function sketchProtein2(holder, gm, pxwidth) {
  const canvas = holder.append("canvas").node();
  const h = 20;
  const ctx = setupCanvas(canvas, pxwidth, h);
  const sf = pxwidth / (gm.cdslen / 3);
  gm.pdomains.sort((a, b) => b.stop - b.start - a.stop + a.start);
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, pxwidth, h);
  for (const domain of gm.pdomains) {
    ctx.fillStyle = domain.color;
    ctx.fillRect(domain.start * sf, 0, (domain.stop - domain.start + 1) * sf, h);
  }
  ctx.strokeStyle = "black";
  ctx.strokeRect(0, 0, pxwidth, h);
}
function sketchGene(holder, gm, pxwidth, h, bpstart, bpstop, color, nostrand, reverse) {
  const canvas = holder.append("canvas").node();
  const ctx = setupCanvas(canvas, pxwidth, h);
  const sf = linear().range([1, pxwidth]);
  if (reverse) {
    sf.domain([bpstop, bpstart]);
  } else {
    sf.domain([bpstart, bpstop]);
  }
  ctx.strokeStyle = color;
  ctx.fillStyle = color;
  bpBox(ctx, gm.start, gm.stop, bpstart, bpstop, h / 2, 1);
  const pad = Math.ceil(h / 5);
  if (gm.utr3) {
    for (const e of gm.utr3) {
      bpBox(ctx, e[0], e[1], bpstart, bpstop, pad + 1, h - pad * 2 - 1);
    }
  }
  if (gm.utr5) {
    for (const e of gm.utr5) {
      bpBox(ctx, e[0], e[1], bpstart, bpstop, pad + 1, h - pad * 2 - 1);
    }
  }
  if (gm.coding) {
    for (const e of gm.coding) {
      bpBox(ctx, e[0], e[1], bpstart, bpstop, 1, h);
    }
  }
  if (gm.codingstart === gm.codingstop) {
    for (const e of gm.exon) {
      bpBox(ctx, e[0], e[1], bpstart, bpstop, pad + 1, h - pad * 2 - 1);
    }
  }
  if (!nostrand && gm.strand) {
    const ypad = 3;
    if (gm.coding) {
      for (const e of gm.coding) {
        bpStrand(ctx, gm.strand, e[0], e[1], bpstart, bpstop, 1 + ypad, h - ypad * 2 - 1, "white");
      }
    }
    if (gm.intron) {
      for (const e of gm.intron) {
        bpStrand(ctx, gm.strand, e[0], e[1], bpstart, bpstop, 1 + ypad, h - ypad * 2 - 1, color);
      }
    }
  }
  function bpBox(ctx2, start, stop, borderstart, borderstop, y, h2) {
    const a = Math.max(start, borderstart);
    const b = Math.min(stop, borderstop);
    if (a >= b) return;
    ctx2.fillRect(Math.floor(sf(reverse ? b : a)), y, Math.max(1, Math.abs(sf(b) - sf(a))), h2);
  }
  function bpStrand(ctx2, strand, start, stop, borderstart, borderstop, y, h2, strokeColor) {
    const a = Math.max(start, borderstart);
    const b = Math.min(stop, borderstop);
    if (a >= b) return;
    const pad2 = 2, spacing = h2 / 2, w = sf(b) - sf(a);
    if (w <= pad2 * 2 + h2 / 2) return;
    ctx2.strokeStyle = strokeColor;
    const fillcount = Math.floor((w - pad2 * 2) / (h2 / 2 + spacing));
    let x = Math.floor(sf(a) + (w - fillcount * (h2 / 2 + spacing)) / 2) + 0.5;
    ctx2.beginPath();
    for (let i3 = 0; i3 < fillcount; i3++) {
      if (strand === "+") {
        ctx2.moveTo(x, y);
        ctx2.lineTo(x + h2 / 2, y + h2 / 2);
        ctx2.lineTo(x, y + h2);
      } else {
        ctx2.moveTo(x + h2 / 2, y);
        ctx2.lineTo(x, y + h2 / 2);
        ctx2.lineTo(x + h2 / 2, y + h2);
      }
      x += h2 / 2 + spacing;
    }
    ctx2.stroke();
  }
}
function sketchProtein(holder, gm, _pxwidth) {
  let aalen = -1;
  if (gm.cdslen) {
    aalen = gm.cdslen / 3;
  }
  return holder.append("span").html(
    "&nbsp;" + (aalen > 0 ? Math.ceil(aalen) + " AA" + (Number.isInteger(aalen) ? "" : " (incomplete CDS)") : "noncoding")
  );
}

// dom/isoformSelect.ts
function allgm2sum(gmlst) {
  const chr2gm = /* @__PURE__ */ new Map();
  for (const gm of gmlst) {
    if (gm.hidden) {
      continue;
    }
    if (!chr2gm.has(gm.chr)) {
      chr2gm.set(gm.chr, []);
    }
    chr2gm.get(gm.chr).push(gm);
  }
  const alllst = [];
  for (const [chr, gmlstForChr] of chr2gm.entries()) {
    const elst = [];
    for (const m of gmlstForChr) {
      for (const e of m.exon) {
        elst.push([e[0], e[1]]);
      }
    }
    if (elst.length === 0) continue;
    const reverse = gmlstForChr[0].strand == "-";
    elst.sort((a, b) => a[0] - b[0]);
    let thisregion = elst[0];
    const rglst = [];
    for (let i3 = 1; i3 < elst.length; i3++) {
      const e = elst[i3];
      if (e[0] > thisregion[1]) {
        const r2 = {
          chr,
          bstart: thisregion[0],
          bstop: thisregion[1],
          start: thisregion[0],
          stop: thisregion[1],
          reverse
        };
        if (reverse) {
          rglst.unshift(r2);
        } else {
          rglst.push(r2);
        }
        thisregion = e;
      } else {
        thisregion[1] = Math.max(thisregion[1], e[1]);
      }
    }
    const r = {
      chr,
      bstart: thisregion[0],
      bstop: thisregion[1],
      start: thisregion[0],
      stop: thisregion[1],
      reverse
    };
    if (reverse) {
      rglst.unshift(r);
    } else {
      rglst.push(r);
    }
    alllst.push(...rglst);
  }
  return [alllst, chr2gm.size];
}
function isoformSelect(opts) {
  const { holder, allgm, multiSelect } = opts;
  const maxHeight = opts.maxHeight ?? 200;
  const scrollThreshold = opts.scrollThreshold ?? 10;
  const [rglst, chrcount] = allgm2sum(allgm);
  if (rglst.length === 0) return;
  let pxwidth = 370;
  let intronpx = 10;
  if (intronpx * (rglst.length - 1) > pxwidth * 0.3) {
    intronpx = Math.max(2, pxwidth * 0.3 / (rglst.length - 1));
  }
  const inw = intronpx * (rglst.length - 1);
  const exonlen = rglst.reduce((a, b) => a + b.stop - b.start, 0);
  const exonsf = (pxwidth - (inw > pxwidth * 0.4 ? 0 : inw)) / exonlen;
  pxwidth = exonlen * exonsf + inw;
  for (const e of rglst) {
    e.width = Math.ceil((e.stop - e.start) * exonsf);
  }
  const checkedSet = new Set(multiSelect ? opts.selectedIsoforms || [] : []);
  const checkboxes = [];
  let selectAllCheckbox;
  let submitBtn;
  if (multiSelect) {
    const headerDiv = holder.append("div").style("margin-bottom", "4px");
    selectAllCheckbox = headerDiv.append("input").attr("type", "checkbox").property("checked", checkedSet.size === allgm.length).style("cursor", "pointer").on("change", function() {
      const checked = this.checked;
      for (const cb of checkboxes) {
        cb.input.property("checked", checked);
        if (checked) checkedSet.add(cb.isoform);
        else checkedSet.delete(cb.isoform);
      }
      updateSubmitBtn();
    });
    headerDiv.append("span").text(" Select all").style("cursor", "pointer").style("user-select", "none").on("click", () => {
      const el = selectAllCheckbox.node();
      el.checked = !el.checked;
      el.dispatchEvent(new Event("change"));
    });
  }
  let mayscroll = holder;
  if (allgm.length > scrollThreshold) {
    mayscroll = holder.append("div").attr("tabindex", 0).style("height", maxHeight + "px").style("overflow-y", "scroll").style("resize", "vertical");
  }
  const table = mayscroll.append("table").style("color", "#555");
  const gmlabellst = [];
  for (const gm of allgm) {
    const tr = table.append("tr").attr("tabindex", 0);
    if (multiSelect) {
      const cb = tr.append("td").append("input").attr("type", "checkbox").property("checked", checkedSet.has(gm.isoform)).style("cursor", "pointer").on("change", function() {
        if (this.checked) checkedSet.add(gm.isoform);
        else checkedSet.delete(gm.isoform);
        selectAllCheckbox.property("checked", checkedSet.size === allgm.length);
        updateSubmitBtn();
      });
      checkboxes.push({ isoform: gm.isoform, input: cb });
      tr.style("cursor", "pointer").on("click", (event2) => {
        if (event2.target.tagName === "INPUT") return;
        const el = cb.node();
        el.checked = !el.checked;
        el.dispatchEvent(new Event("change"));
      });
      tr.on("keydown", (event2) => {
        if (event2.key === "Enter" || event2.key === " ") {
          event2.preventDefault();
          const el = cb.node();
          el.checked = !el.checked;
          el.dispatchEvent(new Event("change"));
        }
      });
    } else {
      tr.attr("class", "sja_clb");
      const selectRow = () => {
        for (const gm2 of gmlabellst) {
          gm2.label.style(
            "color",
            gm2.isoform == gm.isoform && gm2.chr == gm.chr && gm2.start == gm.start ? "#cc0000" : "#545454"
          );
        }
        opts.onSelect(gm);
      };
      tr.on("click", selectRow);
      tr.on("keydown", (event2) => {
        if (event2.key == "Enter") selectRow();
      });
    }
    tr.append("td").text(gm.isdefault ? "DEFAULT" : "").style("font-size", ".6em");
    const usegm = !multiSelect ? opts.usegm : void 0;
    const isActive = !multiSelect && usegm && gm.isoform == usegm.isoform && gm.chr == usegm.chr && gm.start == usegm.start;
    const lab = tr.append("td").text(gm.isoform).style("color", isActive ? "#cc0000" : "#545454");
    if (!multiSelect) {
      gmlabellst.push({ isoform: gm.isoform, chr: gm.chr, start: gm.start, label: lab });
    }
    if (chrcount > 1) {
      tr.append("td").text(gm.chr);
    }
    sketchGmsum(tr.append("td"), rglst, gm, exonsf, intronpx, pxwidth, 16, exoncolor);
    sketchProtein(tr.append("td"), gm, 200);
  }
  if (multiSelect) {
    submitBtn = holder.append("button").style("margin-top", "8px").style("cursor", "pointer").on("click", () => {
      const selected = allgm.filter((gm) => checkedSet.has(gm.isoform));
      if (selected.length > 0) opts.onMultiSelect(selected);
    });
    updateSubmitBtn();
  }
  function updateSubmitBtn() {
    const count = checkedSet.size;
    const label = multiSelect && opts.getSubmitLabel ? opts.getSubmitLabel(count) : `Submit (${count})`;
    submitBtn.property("disabled", count === 0).text(label);
  }
}
var zoomPadExons = 1;
var zoomMinExons = 6;
function markerSpan(markers, range2) {
  const positions = [];
  for (const m of markers || []) if (Number.isFinite(m.pos)) positions.push(m.pos);
  if (range2) positions.push(range2.start, range2.stop);
  if (!positions.length) return null;
  return [Math.min(...positions), Math.max(...positions)];
}
function breakpointGms(gms, markers, range2) {
  const span = markerSpan(markers, range2);
  if (!span) return gms;
  const [lo, hi] = span;
  const kept = gms.filter((gm) => gm.stop >= lo && gm.start <= hi);
  return kept.length ? kept : gms;
}
function focusRegions(rglst, markers, range2) {
  if (rglst.length < zoomMinExons) return rglst;
  const span = markerSpan(markers, range2);
  if (!span) return rglst;
  const [lo, hi] = span;
  const byPos = [...rglst].sort((a, b) => a.start - b.start);
  let first = 0;
  while (first < byPos.length - 1 && byPos[first].stop < lo) first++;
  let last = byPos.length - 1;
  while (last > first && byPos[last].start > hi) last--;
  first = Math.max(0, first - zoomPadExons);
  last = Math.min(byPos.length - 1, last + zoomPadExons);
  const kept = new Set(byPos.slice(first, last + 1));
  return rglst.filter((r) => kept.has(r));
}
function locusLabel(chr, start, stop) {
  if (stop - start >= 1e6) return `${chr}:${(start / 1e6).toFixed(2)}-${(stop / 1e6).toFixed(2)}Mb`;
  return `${chr}:${Math.round(start / 1e3)}-${Math.round(stop / 1e3)}kb`;
}
function makeScale(arg) {
  return arg.mode == "rna" ? makeExonScale(arg) : makeLinearScale(arg);
}
function makeLinearScale(arg) {
  const { chr, gms, pxwidth } = arg;
  const positions = [];
  for (const gm of gms) positions.push(gm.start, gm.stop);
  for (const m of arg.markers || []) if (Number.isFinite(m.pos)) positions.push(m.pos);
  if (!positions.length) throw "no gene model or marker to make a scale with";
  const min = Math.min(...positions);
  const max = Math.max(...positions);
  const pad = Math.max(1, Math.ceil((max - min) * 0.05));
  const start = Math.max(0, min - pad);
  const stop = max + pad;
  const reverse = gms[0]?.strand == "-";
  const exonsf = pxwidth / (stop - start);
  const rglst = [{ chr, bstart: start, bstop: stop, start, stop, reverse, width: pxwidth }];
  return {
    chr,
    mode: "genomic",
    zoomed: false,
    start,
    stop,
    reverse,
    pxwidth,
    exonsf,
    rglst,
    intronpx: 0,
    pos2px: (pos) => (reverse ? stop - pos : pos - start) * exonsf,
    px2pos: (px2) => {
      const pos = Math.round(reverse ? stop - px2 / exonsf : start + px2 / exonsf);
      return Math.max(start, Math.min(stop, pos));
    }
  };
}
function makeExonScale(arg) {
  const { chr, gms, pxwidth } = arg;
  const [allrg] = allgm2sum(gms.filter((gm) => gm.chr == chr));
  if (!allrg.length) return makeLinearScale(arg);
  const rglst = focusRegions(allrg, arg.markers, arg.range);
  const zoomed = rglst.length < allrg.length;
  const reverse = !!rglst[0].reverse;
  const gaps = rglst.length - 1;
  const intronpx = gaps ? Math.min(10, pxwidth * 0.4 / gaps) : 0;
  const exonlen = rglst.reduce((n, r) => n + r.stop - r.start, 0);
  const exonsf = (pxwidth - intronpx * gaps) / exonlen;
  const offsets = [];
  let x = 0;
  for (const r of rglst) {
    r.width = (r.stop - r.start) * exonsf;
    offsets.push(x);
    x += r.width + intronpx;
  }
  const start = Math.min(...rglst.map((r) => r.start));
  const stop = Math.max(...rglst.map((r) => r.stop));
  const byPos = rglst.map((r, i3) => ({ r, offset: offsets[i3] })).sort((a, b) => a.r.start - b.r.start);
  return {
    chr,
    mode: "rna",
    zoomed,
    start,
    stop,
    reverse,
    pxwidth,
    exonsf,
    rglst,
    intronpx,
    pos2px: (pos) => {
      const p = Math.max(start, Math.min(stop, pos));
      for (const { r, offset } of byPos) {
        if (p > r.stop) continue;
        const q = Math.max(p, r.start);
        return offset + (reverse ? r.stop - q : q - r.start) * exonsf;
      }
      return pxwidth;
    },
    px2pos: (px2) => {
      const x2 = Math.max(0, Math.min(pxwidth, px2));
      for (const [i3, r] of rglst.entries()) {
        if (x2 > offsets[i3] + r.width) continue;
        const within = Math.max(0, x2 - offsets[i3]) / exonsf;
        return Math.round(reverse ? r.stop - within : r.start + within);
      }
      const last = rglst[rglst.length - 1];
      return reverse ? last.start : last.stop;
    }
  };
}
var selectColor = "#1e6edc";
var markColor = "#5A5A5A";
var outColor = "#b0b0b0";
var otherOutColor = "#d6d6d6";
var hoverColor = "#cc0000";
function renderBreakpointMarks(a) {
  const { canvas, markers, scale, pxwidth, height, direction } = a;
  const ctx = setupCanvas(canvas, pxwidth, height);
  const baseY = direction == "up" ? height - 0.5 : 0.5;
  ctx.strokeStyle = "#ccc";
  ctx.beginPath();
  ctx.moveTo(0, baseY);
  ctx.lineTo(pxwidth, baseY);
  ctx.stroke();
  if (!markers.length) return;
  const maxCount = Math.max(...markers.map((m) => m.samplecount || 1));
  for (const m of markers) {
    const h = 5 + (height - 8) * Math.sqrt((m.samplecount || 1) / maxCount);
    const x = Math.round(scale.pos2px(m.pos)) + 0.5;
    const y0 = direction == "up" ? height - 1 : 1;
    ctx.strokeStyle = a.getColor ? a.getColor(m) : markColor;
    ctx.beginPath();
    ctx.moveTo(x, y0);
    ctx.lineTo(x, direction == "up" ? y0 - h : y0 + h);
    ctx.stroke();
  }
}
function renderIsoformRows(a) {
  for (const gm of visibleGms(a.gms, a.scale)) {
    a.labelCol.append("div").style("height", a.rowHeight + "px").style("overflow", "hidden").style("white-space", "nowrap").style("font-size", ".8em").style("color", gm.isdefault ? hoverColor : "#545454").attr("title", gm.isoform).text(gm.isoform);
    const row = a.graphCol.append("div").style("height", a.rowHeight + "px");
    sketchGmsum(row, a.scale.rglst, gm, a.scale.exonsf, a.scale.intronpx, a.pxwidth, a.rowHeight - 2, exoncolor, {
      // a zoomed layout gives an exon box the room for its number; an unzoomed one
      // of a many-exon gene does not, and none is drawn
      exonNumbers: true
    });
  }
}
function visibleGms(gms, scale) {
  return gms.filter((gm) => gm.stop >= scale.start && gm.start <= scale.stop);
}
function attachRangeDrag(sel, pxwidth, onDrag) {
  const clampPx = (px2) => Math.max(0, Math.min(pxwidth, px2));
  sel.on("mousedown", (event2) => {
    event2.preventDefault();
    const rect = sel.node().getBoundingClientRect();
    const x0 = clampPx(event2.clientX - rect.left);
    const onMove = (e) => {
      const x1 = clampPx(e.clientX - rect.left);
      if (Math.abs(x1 - x0) < 2) return;
      onDrag(x0, x1);
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  });
}
function renderRangeControls(a) {
  const controlDiv = a.holder.append("div").style("margin-top", "6px").style("font-size", ".8em");
  controlDiv.append("span").style("opacity", 0.7).text(a.chr + ":");
  const startInput = addPosInput();
  controlDiv.append("span").style("opacity", 0.7).text("-");
  const stopInput = addPosInput();
  const applyBtn = controlDiv.append("button").attr("data-testid", "sjpp-isoformRangeSelect-apply").style("margin-left", "8px").text("Apply").on("click", a.onApply);
  const clearBtn = controlDiv.append("button").attr("data-testid", "sjpp-isoformRangeSelect-clear").style("margin-left", "5px").text("Clear").on("click", a.onClear);
  return {
    /** show the given range on the inputs, and enable the buttons only when there is one */
    update(range2) {
      startInput.property("value", range2 ? range2.start : "");
      stopInput.property("value", range2 ? range2.stop : "");
      applyBtn.property("disabled", !range2);
      clearBtn.property("disabled", !range2);
    }
  };
  function addPosInput() {
    return controlDiv.append("input").attr("type", "number").attr("data-testid", "sjpp-isoformRangeSelect-pos").style("width", "85px").style("margin", "0 3px").on("change", () => {
      const startText = String(startInput.property("value")).trim();
      const stopText = String(stopInput.property("value")).trim();
      const start = Number(startText);
      const stop = Number(stopText);
      if (!startText || !stopText || !Number.isFinite(start) || !Number.isFinite(stop)) {
        a.onTyped(void 0);
        return;
      }
      a.onTyped({ start: Math.min(start, stop), stop: Math.max(start, stop) });
    });
  }
}
function isoformRangeSelect(opts) {
  const { holder, chr, callback } = opts;
  const pxwidth = opts.pxwidth ?? 400;
  const labelWidth = opts.labelWidth ?? 110;
  const rowHeight = 18;
  const markerHeight = 40;
  const markers = (opts.markers || []).filter((m) => Number.isFinite(m.pos));
  const allgm = opts.allgm.filter((gm) => gm.chr == chr && !gm.hidden);
  const gms = breakpointGms(allgm, markers, opts.range);
  if (!gms.length && !markers.length) {
    holder.append("div").style("opacity", 0.6).text("No gene model or breakpoint to display");
    return;
  }
  const scale = makeScale({ chr, gms, markers, pxwidth, mode: opts.mode, range: opts.range });
  let range2 = opts.range ? { start: opts.range.start, stop: opts.range.stop } : null;
  const infoDiv = holder.append("div").attr("data-testid", "sjpp-isoformRangeSelect-info").style("font-size", ".8em").style("opacity", 0.7).style("margin-bottom", "3px").style("height", "1.2em");
  const flexDiv = holder.append("div").style("display", "flex");
  const labelCol = flexDiv.append("div").style("width", labelWidth + "px").style("flex", "0 0 auto");
  const graphCol = flexDiv.append("div").style("position", "relative").style("width", pxwidth + "px");
  const locusCell = labelCol.append("div").attr("data-testid", "sjpp-isoformRangeSelect-locus").style("height", markerHeight + "px").style("display", "flex").style("align-items", "flex-end");
  if (scale.zoomed) {
    locusCell.append("div").style("font-size", ".7em").style("opacity", 0.6).style("overflow", "hidden").style("white-space", "nowrap").attr("title", `${chr}:${scale.start.toLocaleString()}-${scale.stop.toLocaleString()}`).text(locusLabel(chr, scale.start, scale.stop));
  }
  const track = graphCol.append("div").attr("data-testid", "sjpp-isoformRangeSelect-track").attr("data-scale-mode", scale.mode).style("cursor", "crosshair");
  const markerCanvas = track.append("canvas").attr("data-testid", "sjpp-isoformRangeSelect-marks").style("display", "block");
  renderBreakpointMarks({
    canvas: markerCanvas.node(),
    markers,
    scale,
    pxwidth,
    height: markerHeight,
    // the isoform sketches are below the marks, so the marks stand on them
    direction: "up"
  });
  renderIsoformRows({ labelCol, graphCol: track, gms, scale, pxwidth, rowHeight });
  const overlay = graphCol.append("div").attr("data-testid", "sjpp-isoformRangeSelect-overlay").style("position", "absolute").style("top", 0).style("bottom", 0).style("background", "rgba(30,110,220,.18)").style("border-left", `1px solid ${selectColor}`).style("border-right", `1px solid ${selectColor}`).style("pointer-events", "none").style("display", "none");
  const controls = renderRangeControls({
    holder,
    chr,
    onTyped: (r) => setRange(r || range2),
    onApply: () => {
      if (!range2) return;
      callback({ chr, start: range2.start, stop: range2.stop });
    },
    onClear: () => {
      setRange(null);
      callback(null);
    }
  });
  attachRangeDrag(track, pxwidth, (x0, x1) => setRangeFromPx(x0, x1));
  markerCanvas.on("mousemove", (event2) => {
    const rect = markerCanvas.node().getBoundingClientRect();
    const x = event2.clientX - rect.left;
    const hovered = markers.find((m) => Math.abs(scale.pos2px(m.pos) - x) <= 3);
    if (hovered) {
      const count = hovered.samplecount;
      infoDiv.text(`${chr}:${hovered.pos.toLocaleString()}${count ? ` \xB7 ${sampleLabel(count)}` : ""}`);
    } else {
      updateInfo();
    }
  });
  markerCanvas.on("mouseleave", () => updateInfo());
  setRange(range2);
  return {
    scale,
    getRange: () => range2 ? { chr, start: range2.start, stop: range2.stop } : null,
    setRange: (r) => setRange(r)
  };
  function setRangeFromPx(x0, x1) {
    const a = scale.px2pos(x0);
    const b = scale.px2pos(x1);
    setRange({ start: Math.min(a, b), stop: Math.max(a, b) });
  }
  function setRange(r) {
    range2 = r ? { start: Math.max(scale.start, r.start), stop: Math.min(scale.stop, r.stop) } : null;
    if (range2) {
      const x0 = scale.pos2px(range2.start);
      const x1 = scale.pos2px(range2.stop);
      overlay.style("display", "").style("left", Math.min(x0, x1) + "px").style("width", Math.max(1, Math.abs(x1 - x0)) + "px");
    } else {
      overlay.style("display", "none");
    }
    controls.update(range2);
    updateInfo();
  }
  function updateInfo() {
    if (!range2) {
      infoDiv.text(`${markers.length} breakpoints, drag to select a range`);
      return;
    }
    const inRange = markers.filter((m) => m.pos >= range2.start && m.pos <= range2.stop);
    const samples = inRange.reduce((n, m) => n + (m.samplecount || 0), 0);
    infoDiv.text(
      `${chr}:${range2.start.toLocaleString()}-${range2.stop.toLocaleString()} \xB7 ${inRange.length} of ${markers.length} breakpoints` + (samples ? `, ${sampleLabel(samples)}` : "")
    );
  }
  function sampleLabel(n) {
    return opts.samplesAreUpperBound ? `up to ${n} samples` : `${n} samples`;
  }
}
function isoformPairRangeSelect(opts) {
  const { holder, self: self2, partner, callback } = opts;
  const pxwidth = opts.pxwidth ?? 400;
  const labelWidth = opts.labelWidth ?? 110;
  const rowHeight = 18;
  const trackGap = 10;
  const linkHeight = 70;
  const links = opts.links.filter((l) => Number.isFinite(l.selfPos) && Number.isFinite(l.partnerPos));
  const selfMarks = collapseMarks((l) => l.selfPos);
  const partnerMarks = collapseMarks((l) => l.partnerPos);
  const selfGms = breakpointGms(
    self2.allgm.filter((gm) => gm.chr == self2.chr && !gm.hidden),
    selfMarks,
    self2.range
  );
  const partnerGms = breakpointGms(
    partner.allgm.filter((gm) => gm.chr == partner.chr && !gm.hidden),
    partnerMarks,
    partner.range
  );
  if (!links.length && (!selfGms.length || !partnerGms.length)) {
    holder.append("div").style("opacity", 0.6).text("No gene model or breakpoint to display");
    return;
  }
  const selfScale = makeScale({
    chr: self2.chr,
    gms: selfGms,
    markers: selfMarks,
    pxwidth,
    mode: opts.mode,
    range: self2.range
  });
  const partnerScale = makeScale({
    chr: partner.chr,
    gms: partnerGms,
    markers: partnerMarks,
    pxwidth,
    mode: opts.mode,
    range: partner.range
  });
  const maxCount = Math.max(...links.map((l) => l.samplecount || 1), 1);
  let range2 = partner.range ? { start: partner.range.start, stop: partner.range.stop } : null;
  let hoveredLink;
  const infoDiv = holder.append("div").attr("data-testid", "sjpp-isoformPairSelect-info").style("font-size", ".8em").style("opacity", 0.7).style("margin-bottom", "3px").style("height", "2.4em").style("overflow", "hidden");
  const flexDiv = holder.append("div").style("display", "flex");
  const labelCol = flexDiv.append("div").style("width", labelWidth + "px").style("flex", "0 0 auto");
  const graphCol = flexDiv.append("div").style("position", "relative").style("width", pxwidth + "px");
  const selfRows = visibleGms(selfGms, selfScale);
  const partnerRows = visibleGms(partnerGms, partnerScale);
  const selfTrack = graphCol.append("div").attr("data-testid", "sjpp-isoformPairSelect-selfTrack").attr("data-scale-mode", selfScale.mode);
  renderIsoformRows({ labelCol, graphCol: selfTrack, gms: selfRows, scale: selfScale, pxwidth, rowHeight });
  selfTrack.append("div").style("height", trackGap + "px");
  labelCol.append("div").style("height", trackGap + "px");
  const geneLabels = labelCol.append("div").style("height", linkHeight + "px").style("display", "flex").style("flex-direction", "column").style("justify-content", "space-between");
  addGeneLabel(geneLabels, self2.gene, selfScale);
  addGeneLabel(geneLabels, partner.gene, partnerScale);
  const linkCanvas = graphCol.append("canvas").attr("data-testid", "sjpp-isoformPairSelect-links").style("display", "block");
  const partnerTrack = graphCol.append("div").attr("data-testid", "sjpp-isoformPairSelect-partnerTrack").attr("data-scale-mode", partnerScale.mode).style("cursor", "crosshair");
  partnerTrack.append("div").style("height", trackGap + "px");
  labelCol.append("div").style("height", trackGap + "px");
  renderIsoformRows({ labelCol, graphCol: partnerTrack, gms: partnerRows, scale: partnerScale, pxwidth, rowHeight });
  const selfHeight = selfRows.length * rowHeight + trackGap;
  const partnerTop = selfHeight + linkHeight;
  const partnerHeight = trackGap + partnerRows.length * rowHeight;
  if (self2.range) {
    const overlay2 = graphCol.append("div").attr("data-testid", "sjpp-isoformPairSelect-selfOverlay").style("position", "absolute").style("top", 0).style("height", selfHeight + "px").style("background", "rgba(120,120,120,.14)").style("border-left", "1px dashed #999").style("border-right", "1px dashed #999").style("pointer-events", "none");
    const x0 = selfScale.pos2px(Math.max(selfScale.start, self2.range.start));
    const x1 = selfScale.pos2px(Math.min(selfScale.stop, self2.range.stop));
    overlay2.style("left", Math.min(x0, x1) + "px").style("width", Math.max(1, Math.abs(x1 - x0)) + "px");
  }
  const overlay = graphCol.append("div").attr("data-testid", "sjpp-isoformPairSelect-overlay").style("position", "absolute").style("top", partnerTop + "px").style("height", partnerHeight + "px").style("background", "rgba(30,110,220,.18)").style("border-left", `1px solid ${selectColor}`).style("border-right", `1px solid ${selectColor}`).style("pointer-events", "none").style("display", "none");
  const controls = renderRangeControls({
    holder,
    chr: partner.chr,
    onTyped: (r) => setRange(r || range2),
    onApply: () => {
      if (!range2) return;
      callback({ chr: partner.chr, start: range2.start, stop: range2.stop });
    },
    onClear: () => {
      setRange(null);
      callback(null);
    }
  });
  attachRangeDrag(partnerTrack, pxwidth, (x0, x1) => {
    const a = partnerScale.px2pos(x0);
    const b = partnerScale.px2pos(x1);
    setRange({ start: Math.min(a, b), stop: Math.max(a, b) });
  });
  partnerTrack.on("mousemove", (event2) => {
    const rect = partnerTrack.node().getBoundingClientRect();
    const x = event2.clientX - rect.left;
    const hovered = partnerMarks.find((m) => Math.abs(partnerScale.pos2px(m.pos) - x) <= 3);
    if (hovered) {
      infoDiv.text(
        `${partner.gene} ${partner.chr}:${hovered.pos.toLocaleString()}` + (hovered.samplecount ? ` \xB7 ${sampleLabel(hovered.samplecount)}` : "")
      );
    } else {
      updateInfo();
    }
  });
  partnerTrack.on("mouseleave", () => updateInfo());
  linkCanvas.on("click", () => {
    if (hoveredLink) setRange({ start: hoveredLink.partnerPos, stop: hoveredLink.partnerPos });
  });
  linkCanvas.on("mousemove", (event2) => {
    const rect = linkCanvas.node().getBoundingClientRect();
    const hovered = findLink(event2.clientX - rect.left, event2.clientY - rect.top);
    if (hovered != hoveredLink) {
      hoveredLink = hovered;
      linkCanvas.style("cursor", hovered ? "pointer" : "default");
      render();
    }
    if (hovered) infoDiv.text(linkLabel(hovered));
    else updateInfo();
  });
  linkCanvas.on("mouseleave", () => {
    if (hoveredLink) {
      hoveredLink = void 0;
      render();
    }
    updateInfo();
  });
  setRange(range2);
  return {
    selfScale,
    partnerScale,
    getRange: () => range2 ? { chr: partner.chr, start: range2.start, stop: range2.stop } : null,
    setRange: (r) => setRange(r)
  };
  function collapseMarks(get) {
    const byPos = /* @__PURE__ */ new Map();
    for (const l of links) {
      const pos = get(l);
      byPos.set(pos, (byPos.get(pos) || 0) + (l.samplecount || 0));
    }
    return [...byPos].map(([pos, samplecount]) => ({ pos, samplecount }));
  }
  function addGeneLabel(holder2, gene, scale) {
    const div = holder2.append("div");
    div.append("div").style("font-size", ".8em").style("font-weight", "bold").style("overflow", "hidden").style("white-space", "nowrap").attr("title", gene).text(gene);
    div.append("div").attr("data-testid", "sjpp-isoformPairSelect-locus").style("font-size", ".7em").style("opacity", 0.6).style("overflow", "hidden").style("white-space", "nowrap").attr("title", `${scale.chr}:${scale.start.toLocaleString()}-${scale.stop.toLocaleString()}`).text(scale.zoomed ? locusLabel(scale.chr, scale.start, scale.stop) : scale.chr);
  }
  function inPartnerRange(l) {
    return !range2 || l.partnerPos >= range2.start && l.partnerPos <= range2.stop;
  }
  function inSelfRange(l) {
    return !self2.range || l.selfPos >= self2.range.start && l.selfPos <= self2.range.stop;
  }
  function linkColor(l) {
    if (!inSelfRange(l)) return otherOutColor;
    if (!range2) return markColor;
    return inPartnerRange(l) ? selectColor : outColor;
  }
  function findLink(x, y) {
    let best;
    let bestDist = 4;
    for (const l of links) {
      const d = distToSegment(x, y, selfScale.pos2px(l.selfPos), 0, partnerScale.pos2px(l.partnerPos), linkHeight);
      if (d < bestDist) {
        bestDist = d;
        best = l;
      }
    }
    return best;
  }
  function linkLabel(l) {
    return `${self2.gene} ${self2.chr}:${l.selfPos.toLocaleString()} \u2192 ${partner.gene} ${partner.chr}:${l.partnerPos.toLocaleString()}` + (l.samplecount ? ` \xB7 ${l.samplecount} samples` : "") + (inSelfRange(l) ? "" : `, outside the ${self2.gene} range`);
  }
  function setRange(r) {
    range2 = r ? { start: Math.max(partnerScale.start, r.start), stop: Math.min(partnerScale.stop, r.stop) } : null;
    if (range2) {
      const x0 = partnerScale.pos2px(range2.start);
      const x1 = partnerScale.pos2px(range2.stop);
      overlay.style("display", "").style("left", Math.min(x0, x1) + "px").style("width", Math.max(1, Math.abs(x1 - x0)) + "px");
    } else {
      overlay.style("display", "none");
    }
    controls.update(range2);
    render();
    updateInfo();
  }
  function updateInfo() {
    if (!range2) {
      infoDiv.text(`${links.length} breakpoint pairs \xB7 drag over ${partner.gene}, or click a link, to select a range`);
      return;
    }
    const inRange = links.filter(inPartnerRange);
    const reachable = inRange.filter(inSelfRange);
    const samples = reachable.reduce((n, l) => n + (l.samplecount || 0), 0);
    infoDiv.text(
      `${partner.chr}:${range2.start.toLocaleString()}-${range2.stop.toLocaleString()} \xB7 ${inRange.length} of ${links.length} breakpoint pairs` + // the two ranges are applied together, so say when this one is not what narrows
      (reachable.length == inRange.length ? "" : `, ${reachable.length} within the ${self2.gene} range`) + (samples ? `, ${sampleLabel(samples)}` : "")
    );
  }
  function sampleLabel(n) {
    return opts.samplesAreUpperBound ? `up to ${n} samples` : `${n} samples`;
  }
  function render() {
    renderLinks();
  }
  function renderLinks() {
    const ctx = setupCanvas(linkCanvas.node(), pxwidth, linkHeight);
    const sorted = [...links].sort((a, b) => (a.samplecount || 1) - (b.samplecount || 1));
    for (const l of sorted) {
      if (l != hoveredLink) drawLink(ctx, l, linkColor(l));
    }
    if (hoveredLink) drawLink(ctx, hoveredLink, hoverColor);
  }
  function drawLink(ctx, l, color) {
    const strength = Math.sqrt((l.samplecount || 1) / maxCount);
    ctx.strokeStyle = color;
    ctx.lineWidth = 0.75 + 3.25 * strength;
    ctx.globalAlpha = l == hoveredLink ? 1 : 0.85;
    ctx.beginPath();
    ctx.moveTo(selfScale.pos2px(l.selfPos), 0);
    ctx.lineTo(partnerScale.pos2px(l.partnerPos), linkHeight);
    ctx.stroke();
    ctx.globalAlpha = 1;
  }
}
function distToSegment(px2, py, x1, y1, x2, y2) {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const len2 = dx * dx + dy * dy;
  const t2 = len2 ? Math.max(0, Math.min(1, ((px2 - x1) * dx + (py - y1) * dy) / len2)) : 0;
  return Math.hypot(px2 - (x1 + t2 * dx), py - (y1 + t2 * dy));
}

// dom/variantConfig.ts
function scopeLabel(m) {
  if (m.gene) return m.gene;
  return m.region ? `${m.region.chr}:${m.region.start + 1}-${m.region.stop}` : "";
}
function breakpointRangeLabel(r) {
  return `${r.chr}:${r.start.toLocaleString()}-${r.stop.toLocaleString()}`;
}
function renderVariantConfig(arg) {
  const { holder, dt, mafFilter } = arg;
  const genotype = arg.genotype || "variant";
  if (!["variant", "wt", "nt"].includes(genotype)) throw "invalid genotype";
  const values = Object.entries(arg.values).map(([k, v]) => {
    return { key: k, label: v.label, value: k };
  });
  const classSampleCount = /* @__PURE__ */ new Map();
  for (const [k, v] of Object.entries(arg.values)) {
    if (Number.isFinite(v.samplecount)) classSampleCount.set(k, v.samplecount);
  }
  const selectedMnames = (arg.selectedValues || []).filter((v) => v.mname);
  const selectedValues = arg.selectedValues?.length ? arg.selectedValues : values;
  const preservedMnames = selectedMnames.filter((s) => !arg.mnames?.some((m) => m.mname == s.mname && m.class == s.key && matchesGvQueryEntry(s, m))).map((s) => {
    const m = { mname: s.mname, class: s.key, samplecount: 0 };
    if (s.gene) m.gene = s.gene;
    else if (s.region) m.region = s.region;
    return m;
  });
  const mnames = [...arg.mnames || [], ...preservedMnames];
  for (const m of preservedMnames) {
    if (!values.some((v) => v.key == m.class))
      values.push({ key: m.class, label: mclass[m.class]?.label || m.class, value: m.class });
  }
  if (classSampleCount.size) {
    values.sort((a, b) => (classSampleCount.get(b.key) || 0) - (classSampleCount.get(a.key) || 0));
  }
  if (!Number.isInteger(dt)) throw "unexpected dt value";
  const mcount = arg.mcount || "any";
  if (!["any", "single", "multiple", "all"].includes(mcount)) throw "invalid mcount";
  const isSvFusion = dt == dtsv || dt == dtfusionrna;
  const scaleMode = dt == dtfusionrna ? "rna" : "genomic";
  const canSelectBreakpoint = isSvFusion && !!arg.getGeneModels && mnames.some((m) => m.breakpoints?.length);
  const hideClassList = isSvFusion && values.length == 1;
  let selfBreakpointRange = arg.selfBreakpointRange;
  const partnerBreakpointRanges = /* @__PURE__ */ new Map();
  for (const [i3, m] of mnames.entries()) {
    const selected = selectedMnames.find((s) => s.mname == m.mname && s.key == m.class && matchesGvQueryEntry(s, m));
    if (selected?.partnerBreakpointRange) partnerBreakpointRanges.set(i3, selected.partnerBreakpointRange);
  }
  let breakpointTip;
  const geneModelCache = /* @__PURE__ */ new Map();
  holder.style("margin", "10px");
  if (arg.header) {
    holder.append("div").style("font-weight", "bold").style("font-size", ".9em").text(arg.header);
  }
  const genotypeDiv = holder.append("div").attr("data-testid", "sjpp-variantConfig-genotype").style("margin-top", "10px");
  genotypeDiv.append("div").style("display", "inline-block").style("margin-right", "5px").style("opacity", 0.7).text("Genotype");
  const genotypeRadio = make_radios({
    holder: genotypeDiv,
    styles: { display: "inline-block" },
    options: [
      { label: dt2label[dt], value: "variant", checked: genotype == "variant" },
      { label: "Wildtype", value: "wt", checked: genotype == "wt" },
      { label: "Not tested", value: "nt", checked: genotype == "nt" }
    ],
    callback: (value) => {
      variantsDiv.style("display", value == "variant" ? "block" : "none");
      applyBtn.property("disabled", value == "variant" && !values.length);
    }
  });
  const variantsDiv = holder.append("div").attr("data-testid", "sjpp-variantConfig-variant").style("display", genotype == "variant" ? "block" : "none").style("margin-top", "10px");
  let countRadio;
  let classTableDiv;
  let updateMnameRowDisplay = () => {
  };
  let getCheckedMnames = () => [];
  let selfRangeNote;
  let showGeneInMnames = false;
  if (values.length) {
    const aboveDiv = hideClassList ? variantsDiv.append("div") : void 0;
    const flexDiv = variantsDiv.append("div").style("display", "flex").style("gap", "25px");
    const classDiv = hideClassList ? void 0 : flexDiv.append("div").attr("data-testid", "sjpp-variantConfig-class");
    if (!hideClassList) {
      classDiv.append("div").style("opacity", 0.7).style("margin-bottom", "5px").text(dt2label[dt]);
      const tableDiv = classDiv.append("div").style("margin-left", "5px").style("font-size", "0.8rem");
      classTableDiv = tableDiv;
      const rows = [];
      const selectedIdxs = [];
      const showClassCount = classSampleCount.size > 0;
      for (const [i3, m] of values.entries()) {
        const label = m.label || m.key;
        const row = [{ value: label }];
        if (showClassCount) {
          const n = classSampleCount.get(m.key);
          row.push({
            value: `${n || 0}`,
            dataTestId: n ? "sjpp-variantConfig-class-count" : "sjpp-variantConfig-class-absent"
          });
        }
        rows.push(row);
        if (selectedValues.find((s) => s.key == m.key)) selectedIdxs.push(i3);
      }
      const columns = [{ label: "Class" }];
      if (showClassCount) columns.push({ label: "Samples" });
      renderTable({
        rows,
        columns,
        div: tableDiv,
        maxWidth: "40vw",
        maxHeight: "40vh",
        noButtonCallback: () => updateMnameRowDisplay(),
        striped: false,
        showLines: false,
        selectedRows: selectedIdxs
      });
    }
    if (canSelectBreakpoint && arg.gene) {
      const selfDiv = (aboveDiv || classDiv).append("div").attr("data-testid", "sjpp-variantConfig-selfBreakpoint").style("margin", aboveDiv ? "0 0 8px 5px" : "8px 0 0 5px");
      selfDiv.append("span").style("opacity", 0.7).text(`${arg.gene} breakpoint `);
      const selfBtn = selfDiv.append("span").attr("class", "sja_clbtext").attr("data-testid", "sjpp-variantConfig-selfBreakpoint-btn").style("cursor", "pointer");
      const updateSelfBtn = () => {
        selfBtn.style("color", selfBreakpointRange ? "#1e6edc" : "#858585").text(selfBreakpointRange ? breakpointRangeLabel(selfBreakpointRange) : "any position");
      };
      updateSelfBtn();
      selfBtn.on("click", (event2) => {
        const checkedClasses = getCheckedClasses();
        const markers = collectMarkers(
          mnames.filter((m) => checkedClasses.has(m.class)),
          (m) => m.breakpoints?.map((b) => ({ pos: b.pos, samplecount: b.samplecount })) || []
        );
        openBreakpointMenu({
          event: event2,
          gene: arg.gene,
          markers,
          range: selfBreakpointRange,
          noPositionCount: mnames.filter((m) => checkedClasses.has(m.class)).reduce((n, m) => n + (m.noPositionCount || 0), 0),
          /* the marks merge the breakpoints of every checked variant, so a sample with
          events to two partners at one position is counted once per event and no total
          here can be shown as an exact tally */
          samplesAreUpperBound: true,
          callback: (range2) => {
            selfBreakpointRange = range2 || void 0;
            updateSelfBtn();
            updateMnameRowDisplay();
          }
        });
      });
    }
    if (mnames.length) {
      const section = flexDiv.append("div").attr("data-testid", "sjpp-variantConfig-mname");
      let expanded = selectedMnames.length > 0;
      const toggle = section.append("div").style("cursor", "pointer").style("opacity", 0.7).style("margin-bottom", "5px");
      const listWrapper = section.append("div").style("margin-left", "5px");
      let visibleMnameCount = mnames.length;
      const updateToggle = () => {
        const count = selfBreakpointRange ? `${visibleMnameCount}/${mnames.length}` : `${visibleMnameCount}`;
        toggle.html(`${expanded ? "&#9660;" : "&#9658;"} Specific variants (${count})`);
        listWrapper.style("display", expanded ? "block" : "none");
      };
      toggle.on("click", () => {
        expanded = !expanded;
        updateToggle();
      });
      updateToggle();
      listWrapper.append("div").style("font-size", ".75em").style("opacity", 0.6).style("margin", "3px 0").text("Checked variants replace the class selection; classes apply when no variant is checked.");
      if (canSelectBreakpoint && arg.gene) {
        selfRangeNote = listWrapper.append("div").attr("data-testid", "sjpp-variantConfig-selfBreakpoint-note").style("font-size", ".75em").style("opacity", 0.6).style("margin", "3px 0").style("display", "none");
      }
      const mnameListDiv = listWrapper.append("div").style("font-size", "0.8rem");
      const showGene = new Set(mnames.map(scopeLabel).filter((s) => s)).size > 1;
      showGeneInMnames = showGene;
      const hasGeneScope = mnames.some((m) => m.gene);
      const hasRegionScope = mnames.some((m) => !m.gene && m.region);
      const scopeColumnLabel = hasGeneScope && hasRegionScope ? "Gene/Region" : hasRegionScope ? "Region" : "Gene";
      const mnameRows = [];
      const selectedMnameIdxs = [];
      const countCells = [];
      for (const [i3, m] of mnames.entries()) {
        const countCell = {
          value: sampleCountLabel(m),
          dataTestId: m.samplecount ? "sjpp-variantConfig-mname-count" : "sjpp-variantConfig-mname-absent"
        };
        countCells[i3] = countCell;
        const row = [{ value: m.mname }, { value: arg.values[m.class]?.label || m.class }, countCell];
        if (showGene) row.unshift({ value: scopeLabel(m) });
        if (canSelectBreakpoint) row.push({ value: "" });
        mnameRows.push(row);
        if (selectedMnames.some((s) => s.mname == m.mname && s.key == m.class && matchesGvQueryEntry(s, m)))
          selectedMnameIdxs.push(i3);
      }
      const mnameColumns = [{ label: "Variant" }, { label: "Class" }, { label: "Samples" }];
      if (showGene) mnameColumns.unshift({ label: scopeColumnLabel });
      if (canSelectBreakpoint) mnameColumns.push({ label: "Breakpoint" });
      renderTable({
        rows: mnameRows,
        columns: mnameColumns,
        div: mnameListDiv,
        maxWidth: "40vw",
        maxHeight: "30vh",
        noButtonCallback: () => updateMnameRowDisplay(),
        striped: false,
        showLines: false,
        selectedRows: selectedMnameIdxs
      });
      if (canSelectBreakpoint) {
        for (const [i3, row] of mnameRows.entries()) {
          const m = mnames[i3];
          const cell = row[row.length - 1];
          const btn = cell.__td.append("span").attr("data-testid", "sjpp-variantConfig-partnerBreakpoint-btn").style("font-size", ".9em");
          const update = () => {
            const r = partnerBreakpointRanges.get(i3);
            btn.style("color", r ? "#1e6edc" : "#858585").text(r ? breakpointRangeLabel(r) : "any position");
          };
          update();
          if (!m.breakpoints?.length) {
            btn.style("opacity", 0.4).text("n/a").attr("title", "no breakpoint position for this variant");
            continue;
          }
          btn.attr("class", "sja_clbtext").style("cursor", "pointer").on("click", (event2) => {
            event2.stopPropagation();
            openBreakpointMenu({
              event: event2,
              // the partner gene of a fusion is named by the mname
              gene: m.mname,
              markers: collectMarkers(
                [m],
                (e) => (e.breakpoints || []).map((b) => ({
                  pos: b.partnerPos,
                  chr: b.partnerChr,
                  samplecount: b.samplecount
                }))
              ),
              range: partnerBreakpointRanges.get(i3),
              noPositionCount: m.noPositionCount || 0,
              samplesAreUpperBound: !hasExactBreakpointCounts(m),
              /* the breakpoints of this variant are pairs of one on the term's own
              gene and one on the partner (see BreakpointEntry), so chart them over
              both genes rather than the partner alone. the range on the own gene is
              read here rather than captured, so that the chart reflects whatever it
              is when the menu is opened */
              pair: arg.gene ? { selfGene: arg.gene, selfRange: selfBreakpointRange, links: m.breakpoints } : void 0,
              callback: (range2) => {
                if (range2) partnerBreakpointRanges.set(i3, range2);
                else partnerBreakpointRanges.delete(i3);
                update();
              }
            });
          });
        }
      }
      updateMnameRowDisplay = () => {
        const checkedClasses = getCheckedClasses();
        let visibleCount = 0;
        mnameListDiv.select("tbody").selectAll("tr").style("display", function() {
          const checkbox = this.querySelector("input[type=checkbox]");
          const m = mnames[Number(checkbox.value)];
          if (checkedClasses.has(m.class) && isInSelfBreakpointRange(m)) {
            visibleCount++;
            return "";
          }
          checkbox.checked = false;
          return "none";
        });
        visibleMnameCount = visibleCount;
        for (const [i3, m] of mnames.entries()) {
          countCells[i3]?.__td?.text(sampleCountLabel(m)).attr("title", sampleCountTitle(m));
        }
        updateToggle();
        if (selfRangeNote) {
          selfRangeNote.style("display", selfBreakpointRange ? "block" : "none").text(
            selfBreakpointRange ? `Only variants with a ${arg.gene} breakpoint in ${breakpointRangeLabel(
              selfBreakpointRange
            )} are listed.` : ""
          );
        }
      };
      getCheckedMnames = () => {
        const checked = [];
        mnameListDiv.select("tbody").selectAll("input[type=checkbox]").each(function() {
          if (this.checked) checked.push({ m: mnames[Number(this.value)], i: Number(this.value) });
        });
        return checked;
      };
      updateMnameRowDisplay();
    }
    if (dt == dtsnvindel) {
      const countDiv = variantsDiv.append("div").style("margin-top", "5px");
      countDiv.append("div").style("display", "inline-block").style("margin-right", "5px").style("opacity", 0.7).text("Occurrence");
      const countOpts = [
        { label: "Any", value: "any" },
        { label: "Single", value: "single" },
        { label: "Multiple", value: "multiple" }
      ];
      countOpts.forEach((opt) => {
        if (opt.value == mcount) opt.checked = true;
      });
      if (!countOpts.some((opt) => opt.checked)) {
        if (mcount == "all") countOpts.push({ label: "All", value: "all", checked: true });
      }
      countRadio = make_radios({
        holder: countDiv,
        styles: { display: "inline-block" },
        options: countOpts,
        callback: () => {
        }
      });
      if (mafFilter) {
        const mafDiv = variantsDiv.append("div").style("margin-top", "5px");
        mafDiv.append("div").style("display", "inline-block").style("margin-right", "5px").style("opacity", 0.7).text("MAF filter");
        filterInit({
          emptyLabel: "+",
          holder: mafDiv,
          header_mode: "hide_search",
          isMafFilter: true,
          // will be handled by "client/filter/tvs.numeric.js"
          vocab: { terms: mafFilter.terms },
          callback: async (filter2) => {
            mafFilter.active = filter2;
          }
        }).main(mafFilter.active);
      }
    }
  } else {
    variantsDiv.append("div").style("display", values.length ? "none" : "block").text(`No ${dt2label[dt]} found`);
  }
  const applyBtn = holder.append("div").append("button").attr("data-testid", "sjpp-variantConfig-apply").style("margin-top", "15px").property("disabled", genotype == "variant" && !values.length).text("Apply").on("click", () => {
    const selectedGenotype = genotypeRadio.inputs.nodes().find((r) => r.checked);
    if (!selectedGenotype) throw "no genotype selected";
    const config = { values: [], genotype: selectedGenotype.value };
    if (config.genotype == "variant") {
      const checkedMnames = getCheckedMnames();
      if (checkedMnames.length) {
        for (const { m, i: i3 } of checkedMnames) {
          const v = {
            key: m.class,
            label: showGeneInMnames && scopeLabel(m) ? `${scopeLabel(m)} ${m.mname}` : m.mname,
            value: m.mname,
            mname: m.mname
          };
          if (m.gene) v.gene = m.gene;
          else if (m.region) v.region = m.region;
          const partnerRange = partnerBreakpointRanges.get(i3);
          if (partnerRange) v.partnerBreakpointRange = partnerRange;
          config.values.push(v);
        }
      } else if (classTableDiv) {
        const checkboxes = classTableDiv.select("tbody").selectAll("input").nodes();
        for (const c of checkboxes) {
          if (c.checked) config.values.push(values[Number(c.value)]);
        }
      } else {
        config.values.push(...values);
      }
      if (dt == dtsnvindel) {
        const selectedCount = countRadio.inputs.nodes().find((r) => r.checked);
        if (!selectedCount) throw "no mutation count selected";
        config.mcount = selectedCount.value;
        if (mafFilter) config.mafFilter = mafFilter.active;
      } else {
        config.mcount = "any";
      }
      if (isSvFusion) config.selfBreakpointRange = selfBreakpointRange;
    }
    arg.callback(config);
  });
  function isInSelfBreakpointRange(m) {
    if (!selfBreakpointRange) return true;
    if (!m.samplecount) return true;
    const { start, stop } = selfBreakpointRange;
    return !!m.breakpoints?.some((b) => b.pos >= start && b.pos <= stop);
  }
  function samplesInSelfRange(m) {
    if (!selfBreakpointRange) return m.samplecount;
    const { start, stop } = selfBreakpointRange;
    const n = (m.breakpoints || []).reduce((sum, b) => b.pos >= start && b.pos <= stop ? sum + b.samplecount : sum, 0);
    return Math.min(n, m.samplecount);
  }
  function hasExactBreakpointCounts(m) {
    const pairs = (m.breakpoints || []).reduce((n, b) => n + b.samplecount, 0);
    return pairs + (m.noPositionCount || 0) <= m.samplecount;
  }
  function sampleCountLabel(m) {
    if (!selfBreakpointRange || !m.samplecount) return `${m.samplecount}`;
    return `${hasExactBreakpointCounts(m) ? "" : "\u2264"}${samplesInSelfRange(m)}/${m.samplecount}`;
  }
  function sampleCountTitle(m) {
    if (!selfBreakpointRange || !m.samplecount) return null;
    const exact = hasExactBreakpointCounts(m);
    return `${exact ? "" : "Up to "}${samplesInSelfRange(m)} of ${m.samplecount} samples have a ${arg.gene} breakpoint in ${breakpointRangeLabel(selfBreakpointRange)}` + (exact ? "" : ". Some samples have more than one event of this variant, which the breakpoint tally cannot tell apart");
  }
  function getCheckedClasses() {
    const checked = /* @__PURE__ */ new Set();
    if (!classTableDiv) {
      for (const v of values) checked.add(v.key);
      return checked;
    }
    const checkboxes = classTableDiv.select("tbody").selectAll("input").nodes();
    for (const [i3, c] of checkboxes.entries()) {
      if (c.checked) checked.add(values[i3].key);
    }
    return checked;
  }
  function collectMarkers(items, get) {
    const byKey = /* @__PURE__ */ new Map();
    for (const m of items) {
      for (const b of get(m)) {
        if (!Number.isFinite(b.pos)) continue;
        const key = `${b.chr || ""}|${b.pos}`;
        const entry = byKey.get(key);
        if (entry) entry.samplecount += b.samplecount;
        else byKey.set(key, { ...b });
      }
    }
    return [...byKey.values()];
  }
  function mostCommonChr(markers) {
    const count = /* @__PURE__ */ new Map();
    for (const m of markers) {
      if (m.chr) count.set(m.chr, (count.get(m.chr) || 0) + m.samplecount);
    }
    let best;
    let bestCount = 0;
    for (const [chr, n] of count) {
      if (n > bestCount) {
        best = chr;
        bestCount = n;
      }
    }
    return best;
  }
  function loadGeneModels(gene) {
    if (!geneModelCache.has(gene)) {
      geneModelCache.set(
        gene,
        /* NOTE the getter is called inside then(), not as the argument of resolve():
        there its own synchronous throw would escape before a promise existed to catch
        it, leaving the menu on "Loading..." rather than degrading as documented */
        Promise.resolve().then(() => arg.getGeneModels(gene)).then((gmlst) => gmlst || []).catch((e) => {
          console.warn(`no gene model for ${gene}: ${e?.message || e}`);
          geneModelCache.delete(gene);
          return [];
        })
      );
    }
    return geneModelCache.get(gene);
  }
  function geneChr(gmlst) {
    return (gmlst.find((g) => g.isdefault) || gmlst[0])?.chr;
  }
  async function openBreakpointMenu(a) {
    if (!breakpointTip)
      breakpointTip = new Menu({
        padding: "10px",
        /* this ui is rendered inside a menu, e.g. the tvs edit menu. declaring that
        menu as the parent keeps it, and its own ancestors, open when clicking inside
        this one; without it every other open menu treats a click here as a click
        outside itself and hides. same idiom as getDom() in termsetting/TermSetting.ts,
        and the ancestors above the parent are picked up from it (see setRelatedMenus
        in dom/menu.js) */
        parent_menu: holder.node()?.closest(".sja_menu_div")
      });
    const tip = breakpointTip;
    tip.clear().showunder(a.event.target);
    const div = tip.d.append("div");
    div.append("div").style("opacity", 0.6).text("Loading...");
    const [gmlst, selfGmlst] = await Promise.all([
      loadGeneModels(a.gene),
      a.pair ? loadGeneModels(a.pair.selfGene) : Promise.resolve([])
    ]);
    div.selectAll("*").remove();
    const chr = mostCommonChr(a.markers) || geneChr(gmlst);
    if (!chr) {
      div.append("div").text(`Unknown chromosome of ${a.gene}`);
      return;
    }
    const headerDiv = div.append("div").style("margin-bottom", "5px").style("font-size", ".9em").style("opacity", 0.7);
    const noteDiv = div.append("div");
    const chartDiv = div.append("div");
    const addNote = (text) => noteDiv.append("div").style("font-size", ".75em").style("opacity", 0.6).style("margin-bottom", "5px").text(text);
    if (a.noPositionCount) {
      addNote(
        `${a.noPositionCount} samples have events without a breakpoint position; they are not charted and do not match a range`
      );
    }
    const selfChr = a.pair ? geneChr(selfGmlst) : void 0;
    let paired = false;
    if (a.pair && selfChr) {
      const links = a.pair.links.filter((l) => l.partnerChr == chr);
      const rendered = isoformPairRangeSelect({
        holder: chartDiv,
        self: {
          gene: a.pair.selfGene,
          chr: selfChr,
          allgm: selfGmlst,
          range: a.pair.selfRange?.chr == selfChr ? a.pair.selfRange : void 0
        },
        partner: {
          gene: a.gene,
          chr,
          allgm: gmlst,
          // a range of another chr is not of this locus, so is not the current one
          range: a.range?.chr == chr ? a.range : void 0
        },
        links: links.map((l) => ({ selfPos: l.pos, partnerPos: l.partnerPos, samplecount: l.samplecount })),
        mode: scaleMode,
        samplesAreUpperBound: a.samplesAreUpperBound,
        callback: (range2) => {
          tip.hide();
          a.callback(range2);
        }
      });
      if (rendered) {
        paired = true;
        const dropped = a.pair.links.length - links.length;
        if (dropped) {
          addNote(`${dropped} breakpoint pairs are on another chromosome of ${a.gene}; they are not charted`);
        }
      } else {
        chartDiv.selectAll("*").remove();
      }
    }
    headerDiv.text(
      paired ? `${a.pair.selfGene} :: ${a.gene} breakpoints, select a range on ${a.gene}` : `${a.gene} breakpoints`
    );
    if (paired) return;
    isoformRangeSelect({
      holder: chartDiv,
      allgm: gmlst,
      chr,
      markers: a.markers.filter((m) => !m.chr || m.chr == chr),
      // a range of another chr is not of this locus, so is not shown as the current one
      range: a.range?.chr == chr ? a.range : void 0,
      mode: scaleMode,
      samplesAreUpperBound: a.samplesAreUpperBound,
      callback: (range2) => {
        tip.hide();
        a.callback(range2);
      }
    });
  }
}

// common/svg.download.js
function downloadSingleSVG(svg, filename, parent, name = "") {
  const svgParent = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  if (parent) {
    const svgStyles = window.getComputedStyle(parent);
    for (const [prop, value] of Object.entries(svgStyles)) {
      if (prop.startsWith("font")) svgParent.style[prop] = value;
    }
  }
  const svgNode = svg.node().cloneNode(true);
  const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
  if (name) {
    g.setAttribute("transform", `translate(0, ${50})`);
    const title = document.createElementNS("http://www.w3.org/2000/svg", "text");
    title.textContent = name;
    g.appendChild(title);
    svgNode.setAttribute("transform", `translate(${0}, ${80})`);
  }
  g.appendChild(svgNode);
  svgParent.appendChild(g);
  const link = document.createElement("a");
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  const serializer = new XMLSerializer();
  const svg_blob = new Blob([serializer.serializeToString(svgParent)], {
    type: "image/svg+xml"
  });
  link.href = URL.createObjectURL(svg_blob);
  link.click();
  link.remove();
}
function downloadChart(mainGsel, svgName, styleParent = null) {
  const mainGs = [];
  const translate = { x: void 0, y: void 0 };
  const titles = [];
  let maxw = 0, maxh = 0, tboxh = 0;
  let prevY = 0, numChartsPerRow = 0;
  mainGsel.each(function() {
    mainGs.push(this);
    const bbox = this.getBBox();
    if (bbox.width > maxw) maxw = bbox.width;
    if (bbox.height > maxh) maxh = bbox.height;
    const divY = Math.round(this.parentNode.parentNode.getBoundingClientRect().y);
    if (!numChartsPerRow) {
      prevY = divY;
      numChartsPerRow++;
    } else if (Math.abs(divY - prevY) < 5) {
      numChartsPerRow++;
    }
    const xy = select_default(this).attr("transform").split("translate(")[1].split(")")[0].split(",").map((d) => +d.trim());
    if (translate.x === void 0 || xy[0] > translate.x) translate.x = +xy[0];
    if (translate.y === void 0 || xy[1] > translate.y) translate.y = +xy[1];
    const title = this.parentNode.parentNode.firstChild;
    const tbox = title.getBoundingClientRect();
    if (tbox.width > maxw) maxw = tbox.width;
    if (tbox.height > tboxh) tboxh = tbox.height;
    titles.push({ text: title.innerText, styles: window.getComputedStyle(title), tbox });
  });
  maxw += 80;
  maxh += 80;
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const svgSel = select_default(svg).style("display", "block").style("opacity", 1).attr("width", numChartsPerRow * maxw).attr("height", Math.floor(mainGs.length / numChartsPerRow) * maxh);
  if (styleParent) {
    const svgStyles = window.getComputedStyle(styleParent);
    for (const prop of svgStyles) {
      if (prop.startsWith("font")) svgSel.style(prop, svgStyles.getPropertyValue(prop));
    }
  }
  mainGs.forEach((g, i3) => {
    const mainG = g.cloneNode(true);
    const colNum = i3 % numChartsPerRow;
    const rowNum = Math.floor(i3 / numChartsPerRow);
    const corner = { x: colNum * maxw + translate.x + 80, y: rowNum * maxh + translate.y };
    const title = select_default(svg).append("text").attr("transform", "translate(" + (corner.x + titles[i3].tbox.width / 2 - 100) + "," + corner.y + ")").text(titles[i3].text);
    for (const prop of titles[i3].styles) {
      if (prop.startsWith("font")) title.style(prop, titles[i3].styles.getPropertyValue(prop));
    }
    svg.appendChild(mainG);
  });
  to_svg(svg, svgName, { apply_dom_styles: true });
}
function downloadAggregatedSVG(chartImages, svgName) {
  const x = 50;
  const svgParent = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const styles = [];
  let y = 20;
  for (const chart of chartImages) {
    const parent = chart.parent || chart.svg.node();
    const svg = chart.svg.clone(true);
    const g = document.createElementNS("http://www.w3.org/2000/svg", "g");
    g.setAttribute("transform", `translate(${x}, ${y})`);
    const svgStyles = window.getComputedStyle(parent);
    for (const [prop, value] of Object.entries(svgStyles)) {
      if (prop.startsWith("font")) g.style[prop] = value;
    }
    const title = document.createElementNS("http://www.w3.org/2000/svg", "text");
    title.textContent = chart.name;
    g.appendChild(title);
    const svgNode = svg.node();
    const bbox = svgNode.getBoundingClientRect();
    svgNode.setAttribute("transform", `translate(${x}, ${50})`);
    g.appendChild(svgNode);
    svgParent.appendChild(g);
    y += bbox.height + 70;
  }
  svgParent.setAttribute("height", `${y + 20}`);
  to_svg(svgParent, svgName, { apply_dom_styles: true });
}

// dom/downloadMenu.ts
var DownloadMenu = class {
  constructor(chartImages, filename = "charts", textCallback) {
    this.menu = new Menu({ padding: "0px" });
    this.chartImages = chartImages;
    this.multipleSVGs = chartImages.length > 1;
    this.filename = filename.replace(/\s/g, "_");
    if (textCallback) {
      if (typeof textCallback != "function") throw new Error("textCallback not function");
      this.textCallback = textCallback;
    }
  }
  show(x, y, elem = null) {
    this.menu.clear();
    const menuDiv = this.menu.d.append("div");
    menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-download-pdf-portrait").attr("tabindex", 0).text("PDF Portrait").on("click", () => {
      downloadSVGsAsPdf(this.chartImages, this.filename, "portrait");
      this.menu.hide();
    });
    menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-download-pdf-landscape").text("PDF Landscape").on("click", () => {
      downloadSVGsAsPdf(this.chartImages, this.filename, "landscape");
      this.menu.hide();
    });
    menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-download-svg").text("SVG").on("click", () => {
      downloadAggregatedSVG(this.chartImages, this.filename);
      this.menu.hide();
    });
    if (this.multipleSVGs) {
      menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-download-multiple-svgs").text("Multiple SVG").on("click", () => {
        for (const chart of this.chartImages)
          downloadSingleSVG(chart.svg, chart.name.replace(/[^a-zA-Z0-9]/g, "_"), chart.svg.node(), chart.name);
        this.menu.hide();
      });
    }
    if (this.textCallback) {
      menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-download-text").text("Text").on("click", () => {
        to_textfile(this.filename + ".txt", this.textCallback());
        this.menu.hide();
      });
    }
    this.menu.show(x - 20, y - 10, true, true, true, elem);
  }
};
async function downloadSVGsAsPdf(chartImages, filename, orientation, filterImgs = []) {
  const JSPDF = await import("./jspdf.es.min-V7ONHJJV.js");
  const { jsPDF } = JSPDF;
  await import("./svg2pdf.es.min-NIFE2BIE.js");
  const doc = new jsPDF(orientation, "pt", "a4");
  doc.setFontSize(12);
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 50;
  const x = 0.05 * pageWidth;
  for (const filterImgUrl of filterImgs) {
    doc.addImage(filterImgUrl, "PNG", x, y, 0, 30);
    y += 30;
  }
  if (filterImgs.length > 0) y += 50;
  for (const chartImage of chartImages) {
    const name = chartImage.name;
    const svg = chartImage.svg.node().cloneNode(true);
    const parent = chartImage.parent || chartImage.svg.node();
    const svgStyles = window.getComputedStyle(parent);
    for (const [prop, value] of Object.entries(svgStyles)) {
      if (prop.startsWith("font")) svg.style[prop] = value;
    }
    parent.appendChild(svg);
    const svgWidth = svg.getAttribute("width");
    const svgHeight = svg.getAttribute("height");
    const scale = getPdfScale(pageWidth, pageHeight, svgWidth, svgHeight);
    const width = svgWidth * scale;
    const height = svgHeight * scale;
    if (y != 50 && y + height > pageHeight - 20) {
      doc.addPage();
      y = 50;
    }
    if (name.trim()) doc.text(name.length > 90 ? name.slice(0, 90) + "..." : name, x + 10, y - 20);
    else y -= 20;
    svg.setAttribute("viewBox", `0 0 ${svgWidth} ${svgHeight}`);
    await doc.svg(svg, { x, y, width, height });
    y = y + height + 50;
    parent.removeChild(svg);
  }
  doc.save(filename + ".pdf");
}
function getPdfScale(pageWidth, pageHeight, svgWidth, svgHeight) {
  const ratio = 72 / 96;
  const width = svgWidth * ratio;
  const height = svgHeight * ratio;
  let scaleWidth = 1, scaleHeight = 1;
  if (width > pageWidth) {
    scaleWidth = pageWidth / width;
  }
  if (height > pageHeight) {
    scaleHeight = pageHeight / height;
  }
  const scale = Math.min(scaleWidth, scaleHeight) * 0.9;
  return scale * ratio;
}

// dom/downloadTextfile.js
function to_textfile(filename, text) {
  const a = document.createElement("a");
  a.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
  a.setAttribute("download", filename);
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

// dom/fillbar.js
function fillbar(td, v, at) {
  if (!at) at = {};
  const w = at.width || 40;
  const h = at.height || 12;
  let g;
  if (td) {
    td.attr("aria-label", (v.f * 100).toFixed(0) + "%" + (v.v1 != void 0 ? " (" + v.v1 + "/" + v.v2 + ")" : ""));
    g = td.append("svg").attr("width", w).attr("height", h);
  } else {
    g = select_default(document.body).append("svg");
  }
  let y = 0;
  g.append("rect").attr("y", y).attr("width", w).attr("height", h).attr("fill", at.fillbg || "#CBE2F5");
  g.append("rect").attr("y", y).attr("width", w * v.f).attr("height", h).attr("fill", at.fill || "#69A1D1");
  if (at.readcountcredible && v.v2 < at.readcountcredible) {
    const smudge = "#545454";
    const smudge2 = 0.3;
    g.append("rect").attr("y", y).attr("width", w).attr("height", h).attr("fill", smudge).attr("fill-opacity", smudge2);
  }
  if (td) return g;
  g.remove();
  return "<svg width=" + w + " height=" + h + ">" + g.node().innerHTML + "</svg>";
}

// dom/genesearch.ts
var import_debounce = __toESM(require_debounce(), 1);
var debounceDelay = 500;
function addGeneSearchbox(arg) {
  const tip = arg.tip, row = arg.row;
  const result = {};
  try {
    if (typeof arg.genome != "object") throw "genome not object";
    if (arg.searchOnly) {
      if (arg.searchOnly != "gene" && arg.searchOnly != "genes" && arg.searchOnly != "snp")
        throw "searchOnly not gene/genes/snp";
      if (arg.searchOnly == "snp" && !arg.genome.hasSNP) throw 'Cannot support .searchOnly = "snp". Genome lacks SNP';
    }
    if (arg.allowVariant) {
      if (arg.searchOnly == "gene" || arg.searchOnly == "genes")
        throw "when allowVariant is true, searchOnly cannot be gene/genes";
    }
  } catch (e) {
    row.append("span").text(e);
    return result;
  }
  let placeholder, width = 150;
  if ("placeholder" in arg) {
    placeholder = arg.placeholder;
  } else if (arg?.searchOnly == "gene") {
    placeholder = "Gene";
    width = 100;
  } else if (arg?.searchOnly == "genes") {
    placeholder = "Gene names";
    width = 200;
  } else {
    placeholder = arg?.searchOnly == "snp" ? "Position" : "Gene, position";
    if (arg.genome.hasSNP) {
      placeholder += ", dbSNP";
      width += 40;
    }
    if (arg.allowVariant) {
      placeholder += ", variant";
      width += 40;
    }
  }
  const searchbox = row.append("input").attr("type", "search").attr("placeholder", placeholder).attr("aria-label", "Gene symbol, position, or alias").property("disabled", arg.disableInput || false).attr("class", "sja_genesearchinput").attr("data-testid", arg.testid || "sja_genesearchinput").style("width", width + "px");
  result.searchbox = searchbox;
  searchbox.on("focus", (event2) => {
    event2.target.select();
  }).on("keyup", async (event2) => {
    const input = event2.target;
    const v = input.value.trim();
    if (arg.emptyInputCallback && v.length == 0 && keyupEnter(event2)) {
      tip.hide();
      arg.emptyInputCallback();
      searchStat.word.text("");
      searchStat.mark.html("");
      return;
    }
    if (v.length <= 1) return tip.hide();
    searchStat.mark.html("");
    searchStat.word.style("font-size", "0.7em");
    if (arg.hideHelp) {
      searchStat.word.text("");
    } else {
      searchStat.word.text("Press ENTER to search, ESC to cancel");
    }
    if (keyupEnter(event2)) {
      searchbox.property("disabled", true);
      await checkInput();
      if (arg?.searchOnly != "snp") {
        const hitgene = tip.d.select(".sja_menuoption[isgene='1']");
        if (hitgene.size()) {
          const geneSymbol2 = hitgene.datum();
          if (arg.searchOnly == "gene" || arg.searchOnly == "genes") {
            getResult({ geneSymbol: geneSymbol2 }, geneSymbol2);
            tip.hide();
            input.blur();
            debouncer.clear();
          } else {
            await geneCoordSearch(geneSymbol2);
          }
          searchbox.property("disabled", false);
          return;
        }
        if (arg.searchOnly == "genes") {
          const validGenes = await parseMultiGenes(v);
          if (validGenes?.length) {
            getResult({ genes: validGenes }, `${validGenes.length} gene${validGenes.length > 1 ? "s" : ""}`);
          } else {
            getResult(null, "Gene not found");
          }
          tip.hide();
          input.blur();
          debouncer.clear();
          searchbox.property("disabled", false);
          return;
        }
      }
      if (arg?.searchOnly == "gene") {
        getResult(null, "Gene not found");
        searchbox.property("disabled", false);
        return;
      }
      if (arg.allowVariant) {
        const variant = await string2variant(v, arg.genome);
        if (variant) {
          getResult(variant, v);
          searchbox.property("disabled", false);
          return;
        }
      }
      const hitsnp = tip.d.select(".sja_menuoption[issnp='1']");
      if (hitsnp.size()) {
        const hit = hitsnp.datum();
        getResult(
          { chr: hit.chrom, start: hit.chromStart, stop: hit.chromEnd, ref: hit.ref, alt: hit.alt },
          hit.name || v
        );
        searchbox.property("disabled", false);
        tip.hide();
        return;
      }
      if (arg?.searchOnly == "snp") {
        getResult(null, "Variant not found");
        searchbox.property("disabled", false);
        return;
      }
      const pos = string2pos(v, arg.genome);
      if (pos) {
        getResult(pos, "Valid coordinate");
        searchbox.property("disabled", false);
        return;
      }
      getResult(null, "No match");
      searchbox.property("disabled", false);
      return;
    }
    if (event2.code == "Escape") {
      tip.hide();
      if (result.chr) {
        getResult(result, result.fromWhat);
      } else if (arg.defaultCoord) {
        const d = arg.defaultCoord;
        input.value = d.chr + (d.isVariant ? "." + d.pos + "." + d.ref + "." + d.alt : ":" + d.start + "-" + d.stop);
      }
      input.blur();
      return;
    }
    if (event2.key == "ArrowDown") {
      tip.d.selectAll(".sja_menuoption").attr("tabindex", 0).on("keyup", (event3) => {
        if (event3.key == "Enter") {
          event3.target.click();
        } else if (event3.key == "ArrowDown") {
          if (event3.target.nextSibling) event3.target.nextSibling.focus();
        } else if (event3.key == "ArrowUp") {
          if (event3.target.previousSibling) event3.target.previousSibling.focus();
        }
      });
      tip.d.select(".sja_menuoption").node().focus();
      return;
    }
    debouncer();
  });
  if (!arg.focusOff) {
    searchbox.node().focus();
  }
  const searchStat = {
    mark: row.append("span").style("margin-left", "5px"),
    word: row.append("span").style("margin-left", "5px").style("font-size", ".8em").style("opacity", 0.6)
  };
  async function checkInput() {
    const v = searchbox.property("value").trim();
    if (!v) return;
    tip.showunder(searchbox.node()).clear();
    if (arg?.searchOnly == "genes") {
      const lst = v.split(/[,\s\t\n]+/).map((name) => name.trim()).filter((name) => name.length > 0);
      if (lst.length === 0) return;
      if (lst.length == 1) {
      } else {
        tip.hide();
        return;
      }
    }
    if (arg?.searchOnly != "snp") {
      const gene = await dofetch3("genelookup", { body: { genome: arg.genome.name, input: v } });
      if (gene.error) {
        tip.d.append("div").style("margin", "5px").text(gene.error);
        return;
      }
      if (gene.hits?.length) {
        tip.d.selectAll("div").data(gene.hits).join("div").text((d) => d).attr("class", "sja_menuoption").attr("data-testid", (d) => `sjpp-genesearch-gene-hit-${d.toLowerCase().replace(/\s/g, "-")}`).style("border-radius", "0px").attr("isgene", 1).on("click", async (event2, d) => {
          if (arg?.searchOnly == "gene" || arg.searchOnly == "genes") {
            getResult({ geneSymbol: d }, d);
            tip.hide();
          } else {
            await geneCoordSearch(d);
          }
        });
        return;
      }
    }
    if (arg.allowVariant) {
      const variant = await string2variant(v, arg.genome);
      if (variant) return;
    }
    if (arg.genome.hasSNP) {
      const dbsnp = await dofetch3("snp", { body: { byName: true, genome: arg.genome.name, lst: [v] } });
      if (dbsnp.error) throw dbsnp.error;
      if (dbsnp?.results?.length) {
        displayVariantHits(tip, dbsnp.results);
        return;
      }
    }
    const pos = string2pos(v, arg.genome, true);
    if (pos) {
      if (arg?.searchOnly == "snp") {
        if (!pos.actualposition?.len) return;
        const chr = pos.chr;
        const start = pos.actualposition.position - 1;
        const stop = start + pos.actualposition.len;
        const ranges = [{ start, stop }];
        const dbsnp = await dofetch3("snp", { body: { byCoord: true, genome: arg.genome.name, chr, ranges } });
        if (dbsnp.error) throw dbsnp.error;
        if (dbsnp.results.length) {
          const variants = pos.actualposition.len == 1 ? dbsnp.results.filter((hit) => hit.chromStart == start) : dbsnp.results;
          displayVariantHits(tip, variants);
        }
      }
      return;
    }
  }
  const debouncer = (0, import_debounce.debounce)(checkInput, debounceDelay);
  async function parseMultiGenes(v) {
    const lst = v.split(/[,\s\t\n]+/).map((name) => name.trim()).filter((name) => name.length > 0);
    const validGenes = [];
    for (const s of lst) {
      const gene = await dofetch3("genelookup", { body: { genome: arg.genome.name, input: s } });
      if (!gene || gene.error || !gene.hits?.length) {
      } else {
        validGenes.push({ geneSymbol: gene.hits[0] });
      }
    }
    return validGenes;
  }
  function displayVariantHits(tip2, data) {
    tip2.d.selectAll("div").data(data).join("div").text((d) => {
      const pos = `${d.chrom}:${d.chromStart + 1}`;
      const alleles = `${d.ref}>${d.alt.join(",")}`;
      return `${d.name} (${pos} ${alleles})`;
    }).attr("class", "sja_menuoption").attr("data-testid", (d) => `sjpp-genesearch-snp-hit-${d.name.toLowerCase().replace(/\s/g, "-")}`).style("border-radius", "0px").attr("issnp", 1).on("click", (event2, d) => {
      getResult({ chr: d.chrom, start: d.chromStart, stop: d.chromEnd, ref: d.ref, alt: d.alt }, d.name);
      tip2.hide();
    });
  }
  async function geneCoordSearch(geneSymbol2) {
    tip.hide();
    const data = await dofetch3("genelookup", { body: { genome: arg.genome.name, input: geneSymbol2, deep: 1 } });
    if (data.error) throw data.error;
    if (!data.gmlst?.length) throw "cannot retrieve gene coordinates";
    const loci = gmlst2loci(data.gmlst);
    if (loci.length == 1) {
      getResult(loci[0], geneSymbol2, geneSymbol2);
      return;
    }
    tip.showunder(searchbox.node()).clear();
    tip.d.selectAll("div").data(loci).join("div").attr("class", "sja_menuoption").attr("data-testid", (d) => `sjpp-genesearch-isoform-hit-${d.name.toLowerCase().replace(/\s/g, "-")}`).style("border-radius", "0px").text((d) => d.name + " " + d.chr + ":" + d.start + "-" + d.stop).on("click", (event2, d) => {
      tip.hide();
      getResult(d, geneSymbol2 + ", " + d.name, d.name);
    });
  }
  if (arg.defaultCoord) {
    const d = arg.defaultCoord;
    if (d.isVariant) {
      searchbox.property("value", d.chr + "." + d.pos + "." + d.ref + "." + d.alt);
      result.pos = d.pos;
      result.ref = d.ref;
      result.alt = d.alt;
    } else {
      searchbox.property("value", d.chr + ":" + d.start + "-" + d.stop);
      result.start = d.start;
      result.stop = d.stop;
    }
    result.chr = d.chr;
  }
  async function getResult(r, fromWhat, geneSymbol2) {
    if (r) {
      for (const k in result) delete result[k];
      if (r.isVariant) {
        result.chr = r.chr;
        result.pos = r.pos;
        result.ref = r.ref;
        result.alt = r.alt;
      } else if (r.chr) {
        searchbox.property("value", r.chr + ":" + r.start + "-" + r.stop);
        result.chr = r.chr;
        result.start = r.start;
        result.stop = r.stop;
        if (r.actualposition) result.actualposition = r.actualposition;
        if (r.ref) result.ref = r.ref;
        if (r.alt) result.alt = r.alt;
      } else if (r.geneSymbol) {
        searchbox.property("value", r.geneSymbol);
        result.geneSymbol = r.geneSymbol;
      } else if (r.genes) {
        result.genes = r.genes;
      }
      searchStat.mark.style("color", "green").html("&check;");
      if (geneSymbol2) {
        result.geneSymbol = geneSymbol2;
      }
    } else {
      searchStat.mark.style("color", "red").html("&cross;");
    }
    searchStat.word.text(fromWhat || "");
    result.fromWhat = fromWhat;
    if (r && arg.callback) {
      if (arg.hideInputBeforeCallback) {
        searchbox.style("display", "none");
        arg.row.selectAll(":scope>span").style("display", "none");
      }
      await arg.callback();
    }
  }
  const geneSymbol = arg.geneSymbol || "";
  if (geneSymbol) {
    searchbox.property("value", geneSymbol);
    if (arg.triggerSearch)
      searchbox.node().dispatchEvent(
        new KeyboardEvent("keyup", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          // deprecated but still widely used
          which: 13,
          // deprecated but still widely used
          bubbles: true,
          // important to allow the event to bubble up
          cancelable: true
        })
      );
    else setTimeout(() => getResult({ geneSymbol: arg.geneSymbol }, geneSymbol), 10);
  }
  return result;
}
async function string2variant(v, genome) {
  const variant = string2simpleVariant(v, genome);
  if (variant) {
    return variant;
  }
  return await string2hgvs(v, genome);
}
function string2simpleVariant(v, genome) {
  const tmp = v.split(".");
  if (tmp.length != 4) return;
  const chr = tmp[0];
  const pos = Number(tmp[1]);
  const e = invalidcoord(genome, chr, pos, pos);
  if (e) return;
  return {
    isVariant: true,
    chr,
    pos,
    ref: tmp[2],
    alt: tmp[3]
  };
}
async function string2hgvs(v, genome) {
  const tmp = v.split(":g.");
  if (tmp.length != 2) {
    return;
  }
  const chr = tmp[0];
  if (tmp[1].includes("delins")) {
    return await hgvs_delins(chr, tmp[1], genome);
  }
  if (tmp[1].includes("del")) {
    return await hgvs_del(chr, tmp[1], genome);
  }
  if (tmp[1].includes("ins")) {
    return hgvs_ins(chr, tmp[1]);
  }
  return hgvs_snv(chr, tmp[1]);
}
function hgvs_snv(chr, v) {
  const tmp = v.match(/^(\d+)([ATCG])>([ATCG])$/);
  if (!tmp || tmp.length != 4) {
    return;
  }
  const pos = Number(tmp[1]);
  if (!Number.isInteger(pos)) return;
  return {
    isVariant: true,
    chr,
    pos,
    ref: tmp[2],
    alt: tmp[3]
  };
}
function hgvs_ins(chr, v) {
  const [tmppos, altAllele] = v.split("ins");
  if (!altAllele) return;
  const pos = Number(tmppos.split("_")[0]);
  if (!Number.isInteger(pos)) return;
  return {
    isVariant: true,
    chr,
    pos: pos + 1,
    // "pos1_pos2" from hgvs string means insertion between the two nucleotides
    // should use pos2 when ref allele is missing
    ref: "-",
    alt: altAllele
  };
}
async function hgvs_del(chr, v, genome) {
  const [tmppos, refAllele] = v.split("del");
  if (refAllele) {
    const pos = Number(tmppos.split("_")[0]);
    if (!Number.isInteger(pos)) return;
    return {
      isVariant: true,
      chr,
      pos,
      ref: refAllele,
      alt: "-"
    };
  }
  const [t1, t2] = tmppos.split("_");
  const start = Number(t1);
  const stop = t2 ? Number(t2) : start + 1;
  if (!Number.isInteger(start) || !Number.isInteger(stop)) return;
  const refAllele2 = await getRefAllele(chr, start, stop, genome);
  return {
    isVariant: true,
    chr,
    // pos, No variable to access??
    ref: refAllele2,
    alt: "-"
  };
}
async function hgvs_delins(chr, v, genome) {
  const tmp = v.match(/^(\d+)_(\d+)delins([ATCG]+)$/);
  if (!tmp || tmp.length != 4) {
    return;
  }
  const p1 = Number(tmp[1]), p2 = Number(tmp[2]), altAllele = tmp[3];
  if (!Number.isInteger(p1) || !Number.isInteger(p2)) return;
  const refAllele = await getRefAllele(chr, p1, p2, genome);
  return {
    isVariant: true,
    chr,
    pos: p1,
    ref: refAllele,
    alt: altAllele
  };
}
async function getRefAllele(chr, start, stop, genome) {
  const body = {
    coord: chr + ":" + start + "-" + stop,
    genome: genome.name
  };
  const d = await dofetch3("ntseq", { body });
  return d.seq;
}

// dom/GeneSetEdit/addButton.ts
function addButton(opts) {
  if (!opts.div || !opts.text || !opts.callback) throw new Error("Missing required parameters");
  const btn = opts.div.append("button").property("disabled", opts.disabled || false).style("display", opts.getDisplayStyle ? opts.getDisplayStyle() : "").style("border", "none").style("border-radius", "20px").style("padding", "10px 15px").text(opts.text).on("click", () => {
    opts.callback();
  });
  if (opts.testid) btn.attr("data-testid", opts.testid);
  return btn;
}

// dom/GeneSetEdit/radioWithContent.ts
function makeRadiosWithContentDivs(options, div) {
  const divs = div.selectAll().data(options, (d) => d.value).enter().append("div").style("margin", "5px");
  const labels = divs.append("label").on("mousedown", (event2) => {
    event2.stopPropagation();
  });
  const inputs = labels.append("input").attr("type", "radio").attr("name", (d) => d.label).attr("value", (d) => d.value).property("checked", (d) => d.checked).on("input", async function(event2, d) {
    event2.stopPropagation();
    inputs.property("disabled", true);
    inputs.property("checked", false);
    div.selectAll(".contentDiv").style("display", "none");
    const contentDiv = select_default(this.parentNode).append("div").classed("contentDiv", true).style("padding-left", "25px").style("display", "block");
    await d.callback(contentDiv);
    select_default(this).property("checked", true);
    inputs.property("disabled", false);
  });
  inputs.filter((d) => d.checked).property("checked", true);
  labels.append("span").html((d) => "&nbsp;" + d.label);
  labels.append("span").style("display", "block").style("padding-left", "25px").style("font-size", "0.75em").html((d) => d.sublabel || "");
}

// dom/GeneSetEdit/GenesMenu.ts
var import_debounce2 = __toESM(require_debounce(), 1);
var GenesMenu = class {
  constructor(opts) {
    /** Collects nested param .options:[] for submenus. See 'boolean' type. */
    this.params2Add = [];
    this.tip = opts.tip;
    this.genome = opts.genome;
    this.params = opts.params;
    this.callback = opts.callback;
    this.addOptionalParams = opts.addOptionalParams;
    this.tip.d.style("padding", "15px");
    this.render();
    for (const param of this.params2Add) this.addOptionalParams(param);
  }
  render() {
    for (const param of this.params) {
      const input = this.addParameter(param.param, this.tip.d.append("div"));
      param.input = input;
    }
    this.tip.d.on("mousedown", (event2) => {
      event2.stopPropagation();
    });
    const calGenesBtn = addButton({
      div: this.tip.d.append("div").style("padding", "20px").style("display", "inline-block"),
      text: "Calculate genes",
      callback: async () => {
        calGenesBtn.property("disabled", true).text("Loading...");
        await this.callback();
        this.tip.hide();
      }
    });
  }
  addParameter(param, div) {
    let input;
    if (param.type == "boolean") {
      if (param?.options?.length) {
        const holder = div.append("div").attr("data-testid", "sjpp-submenu-checkbox").style("padding", "2px");
        const contentDiv = div.append("div").style("padding-left", "20px");
        input = make_one_checkbox({
          holder,
          id: param.id,
          checked: param.checked,
          labeltext: param.label,
          callback: () => {
            contentDiv.style("display", input.property("checked") ? "block" : "none");
          }
        });
        input.on("mousedown", (event2) => {
          event2.stopPropagation();
        });
        for (const option of param.options) {
          const optionInput = this.addParameter(option, contentDiv.append("div"));
          option.parentId = param.id;
          this.params2Add.push({ param: option, input: optionInput });
        }
        contentDiv.style("display", input.property("checked") ? "block" : "none");
      } else {
        input = div.append("input").style("padding", "2px").attr("type", "checkbox").attr("id", param.id);
        if (param.value) input.property("checked", param.value);
        this.addLabels(div, "label", param);
      }
    } else if (param.type == "string" && param.value) {
      input = make_one_checkbox({
        holder: div,
        id: param.id,
        checked: true,
        labeltext: param.label,
        callback: (event2) => {
          event2.stopPropagation();
        }
      });
    } else if (param.type == "number") {
      input = div.append("input").attr("type", "number").style("width", "50px").style("padding", "5px").attr("id", param.id);
      if (param.value) input.attr("value", param.value);
      this.addLabels(div, "span", param);
    } else if (param.type == "radio") {
      const hasChecked = param.options.find((d) => d.checked);
      if (!hasChecked) param.options[0].checked = true;
      input = div.append("div").attr("id", param.id);
      input.append("p").style("font-size", "0.8em").style("opacity", 0.75).text(param.label);
      this.addRadioValue(param);
      this.addRadioCallbacks(param, this.genome);
      makeRadiosWithContentDivs(param.options, input);
    }
    return input;
  }
  addLabels(div, elem, param) {
    if (!param.sublabel) div.append(elem).html(param.label).attr("for", param.id);
    else {
      const labelDiv = div.append("div").style("display", "inline-block").style("vertical-align", "middle");
      labelDiv.append(elem).style("display", "block").style("padding-top", "3px").html(param.label).attr("for", param.id);
      labelDiv.append("span").style("display", "block").style("font-size", "0.75em").html(param.sublabel);
    }
  }
  addRadioValue(param) {
    if (param.value) return;
    const checked = param.options.find((d) => d.checked);
    if (checked) {
      param.value = {
        type: checked.value,
        geneList: null
      };
    }
  }
  addRadioCallbacks(param, genome) {
    for (const opt of param.options) {
      if (!opt.type) opt.type = "boolean";
      if (opt.type == "tree") {
        opt.callback = async (holder) => {
          const termdb = await import("./app-2NSQK3GQ.js");
          const treeDiv = holder.append("div");
          await termdb.appInit({
            holder: treeDiv,
            state: {
              dslabel: opt.value,
              genome: genome.name,
              nav: {
                header_mode: "search_only"
              }
            },
            tree: {
              click_term: (term) => {
                holder.append("div").classed("ts_pill sja_filter_tag_btn sja_tree_click_term termlabel", true).style("margin", "5px").text(`${term.id}`);
                param.value = {
                  type: opt.value,
                  geneList: term._geneset.map((t2) => t2.symbol)
                };
                treeDiv.selectAll("*").remove();
              }
            }
          });
        };
      }
      if (opt.type == "text") {
        opt.callback = async (holder) => {
          holder.append("span").style("display", "block").style("font-size", "0.8em").style("opacity", 0.75).text("Enter genes separated by spaces or commas");
          holder.append("textarea").style("display", "block").on(
            "keyup",
            (0, import_debounce2.debounce)(function() {
              const geneList = this.value.split(/[\s,]+/).map((t2) => t2.trim()).filter((t2) => t2 !== "");
              param.value = {
                type: opt.value,
                geneList
              };
            }),
            500
          );
        };
      }
      if (opt.type == "boolean") {
        opt.callback = () => {
          param.value = {
            type: opt.value,
            geneList: null
          };
        };
      }
    }
  }
};

// dom/GeneSetEdit/GeneSetEditUI.ts
var GeneSetEditUI = class {
  constructor(opts) {
    this.holder = opts.holder;
    this.genome = opts.genome;
    this.callback = opts.callback;
    this.vocabApi = opts.vocabApi;
    this.termsAsListed = opts.termsAsListed;
    this.customInputs = opts.customInputs;
    this.geneList = structuredClone(opts.geneList || []);
    const parent_menu = opts.holder?.node()?.closest(".sja_menu_div") || opts.holder.node();
    this.tip2 = new Menu({ padding: "0px", parent_menu, test: "test" });
    this.updateName = true;
    this.minNumGenes = opts.minNumGenes || 0;
    if ("maxNumGenes" in opts) this.maxNumGenes = opts.maxNumGenes;
    if ("mode" in opts) this.mode = opts.mode;
    if ("titleText" in opts) this.titleText = opts.titleText;
    this.origLst = structuredClone(this.geneList);
    this.origNames = opts.termsAsListed ? JSON.stringify(this.geneList.map((t2) => t2.gene)) : JSON.stringify(this.geneList.map((t2) => t2.gene).sort());
    this.menuList = [];
    if (opts.limitedGenesList) this.limitedGenesList = opts.limitedGenesList;
    const dom = this.getDom(opts);
    this.api = {
      dom,
      topMutatedGenesParams: [],
      topVariablyExpressedGenesParams: [],
      statColor2label: /* @__PURE__ */ new Map(),
      destroy: () => {
        this.tip2.destroy();
        opts.holder.remove();
      }
    };
    this.getParams();
    this.createMenuList();
    this.renderTextControls(this.api.dom.textControlDiv);
    this.renderGenes();
  }
  getDom(opts) {
    this.holder.selectAll("*").remove();
    const div = this.holder.append("div");
    if (this.titleText) {
      div.append("div").style("margin-bottom", "10px").html(this.titleText);
    }
    const defaultMenu = div.append("div").attr("class", "sja_genesetinput").style("display", opts.hideDefaultMenu ? "none" : "").style("padding", "5px");
    const headerDiv = defaultMenu.append("div");
    const label = headerDiv.append("label");
    label.append("span").html("Search");
    const row = label.append("div").style("display", "inline-flex").style("align-items", "center").style("margin", "8px 0px -5px 0px");
    const controlDiv = headerDiv.append("div").style("display", "inline-flex").style("align-items", "center").style("float", "right").style("gap", "5px");
    const addGene = this.addGene.bind(this);
    this.geneSearch = addGeneSearchbox({
      testid: "sjpp-geneSetEditUi-geneSearchInput",
      tip: this.tip2,
      genome: this.genome,
      row,
      searchOnly: "genes",
      callback: addGene,
      hideHelp: true,
      focusOff: true
    });
    if (opts.nameInput) {
      const nameDiv = row.append("div").style("margin-left", "10px");
      nameDiv.append("span").text("Name");
      this.nameInput = nameDiv.append("input").attr("data-testid", "sja_genesetinput_name").attr("type", "text").style("width", "150px");
    }
    return {
      holder: div,
      defaultMenu,
      textControlDiv: controlDiv.append("div"),
      clearBtn: addButton({
        div: controlDiv,
        text: "Clear",
        disabled: !this.geneList?.length,
        callback: () => {
          this.geneList = [];
          this.updateName = true;
          this.renderGenes();
        }
      }),
      restoreBtn: this.geneList?.length ? addButton({
        div: controlDiv,
        disabled: true,
        text: "Restore",
        callback: () => {
          this.geneList = this.origLst;
          this.renderGenes();
        }
      }) : null,
      geneHoldingDiv: this.renderGeneHoldingDiv(defaultMenu),
      statLegendDiv: div.append("div"),
      submitBtn: addButton({
        div: defaultMenu.append("div").style("margin-top", "10px"),
        testid: "sjpp-genesetedit-submitbtn",
        text: "Submit",
        disabled: !this.geneList?.length,
        callback: () => {
          if (this.maxNumGenes && this.geneList.length > this.maxNumGenes) {
            window.alert(
              `Gene set size (${this.geneList.length} genes) exceeds the allowed limit (${this.maxNumGenes} genes).`
            );
            return;
          }
          this.api.dom.submitBtn.property("disabled", true).text("Loading...");
          const result = { geneList: this.geneList };
          if (this.nameInput) result.name = this.nameInput.property("value");
          this.callback(result);
        }
      })
    };
  }
  getParams() {
    if (this.mode == TermTypes.GENE_VARIANT && this.vocabApi.termdbConfig?.queries?.topMutatedGenes) {
      if (this.vocabApi.termdbConfig.queries.topMutatedGenes.arguments) {
        for (const param of this.vocabApi.termdbConfig.queries.topMutatedGenes.arguments)
          this.api.topMutatedGenesParams.push({ param });
      }
    }
    if (this.mode == TermTypes.GENE_EXPRESSION && this.vocabApi.termdbConfig?.queries?.topVariablyExpressedGenes) {
      if (this.vocabApi.termdbConfig.queries.topVariablyExpressedGenes.arguments) {
        for (const param of this.vocabApi.termdbConfig.queries.topVariablyExpressedGenes.arguments) {
          if (param.type == "radio" && (!param.options || param.options.length == 0))
            throw "Radio button must have options";
          this.api.topVariablyExpressedGenesParams.push({ param });
        }
      }
    }
  }
  baseGeneMenuArgs(arr) {
    arr = this.removeDuplicates(arr);
    return {
      tip: this.tip2,
      genome: this.genome,
      params: arr,
      addOptionalParams: ({ param, input }) => {
        arr.push({ param, input });
      }
    };
  }
  removeDuplicates(arr) {
    for (const param of arr) {
      if (param.param?.options) {
        param.param.options.forEach((opt) => {
          if (!opt.id) return;
          const i3 = arr.findIndex((i4) => i4.param.id == opt.id);
          if (i3 != -1) arr.splice(i3, 1);
        });
      }
    }
    return arr;
  }
  createMenuList() {
    if (this.api?.topMutatedGenesParams.length > 0) {
      this.menuList.push({
        label: "Top mutated genes",
        callback: async (event2) => {
          this.tip2.clear().showunder(event2.target);
          const callback = async () => {
            const args = {};
            this.getInputs(this.api.topMutatedGenesParams, args);
            const result = await this.vocabApi.getTopMutatedGenes(args);
            this.geneList = [];
            this.geneList.push(...result.genes);
            this.renderGenes();
          };
          const menuArgs = Object.assign(this.baseGeneMenuArgs(this.api.topMutatedGenesParams), { callback });
          new GenesMenu(menuArgs);
        }
      });
    }
    if (this.api?.topVariablyExpressedGenesParams.length > 0) {
      this.menuList.push({
        label: "Top variably expressed genes",
        callback: (event2) => {
          const copy = structuredClone(this.api.topVariablyExpressedGenesParams);
          copy.filter((p) => p.param.type == "radio" && p.param?.options).forEach((p) => {
            if (typeof p.param.options[0].value === "string") {
              p.param.value = { type: p.param.options[0].value, value: null };
            } else {
              console.error(`Unexpected radio button value type: ${typeof p.param.options[0].value}`);
            }
          });
          this.tip2.clear().showunder(event2.target);
          const callback = async () => {
            const args = {};
            this.getInputs(copy, args);
            const result = await this.vocabApi.getTopVariablyExpressedGenes(args);
            this.geneList = [];
            if (result.genes) {
              for (const gene of result.genes) this.geneList.push({ gene });
            }
            this.renderGenes();
          };
          const menuArgs = Object.assign(this.baseGeneMenuArgs(copy), { callback });
          new GenesMenu(menuArgs);
        }
      });
    }
    if (this.genome?.termdbs?.msigdb) {
      for (const key in this.genome.termdbs) {
        const tdb = this.genome.termdbs[key];
        this.menuList.push({
          label: `${tdb.label} gene set`,
          callback: (event2) => this.showMSigDbTree(event2, key),
          isPreset: true,
          testid: `sjpp-geneSetEditUi-${key}`
        });
      }
    }
    if (this.customInputs) {
      for (const btn of this.customInputs) {
        const opts = {
          label: btn.label,
          callback: () => {
            btn.showInput({
              callback: ({ geneList }) => {
                this.geneList = geneList;
                this.renderGenes();
              }
            });
          },
          tagName: "button"
        };
        if (btn.getDisplayStyle) opts.getDisplayStyle = btn.getDisplayStyle;
        this.menuList.push(opts);
      }
    }
  }
  async showMSigDbTree(event2, key) {
    this.tip2.clear().showunder(event2.target);
    const termdb = await import("./app-2NSQK3GQ.js");
    termdb.appInit({
      holder: this.tip2.d,
      state: {
        dslabel: key,
        genome: this.genome.name,
        nav: {
          header_mode: "search_only"
        }
      },
      tree: {
        click_term: this.msigClickTerm || ((term) => {
          this.geneList = [];
          const geneset = term._geneset;
          if (geneset) {
            for (const gene of geneset) this.geneList.push({ gene: gene.symbol });
            this.renderGenes(term.name);
            this.updateName = false;
          }
          this.tip2.hide();
          this.api.dom.submitBtn.node().focus();
        })
      }
    });
  }
  renderTextControls(div, includeFilter) {
    for (const menu of this.menuList) {
      if (includeFilter && !includeFilter(menu)) continue;
      if (menu.tagName == "button")
        addButton({
          div,
          text: menu.label,
          getDisplayStyle: menu.getDisplayStyle || (() => ""),
          callback: menu.callback,
          testid: menu.testid
        });
      else {
        div.append("a").attr("data-testid", menu.testid || null).style("text-decoration", "underline").style("padding", "0px 10px").style("color", "black").html(`${menu.label} &#9660;`).on("click", async (event2) => {
          await menu.callback(event2);
        });
      }
    }
  }
  /** Get the input value for the entire menu */
  getInputs(arr, args) {
    for (const { param, input } of arr) {
      if (param.parentId) {
        const parent = arr.find((i3) => i3.param.id == param.parentId);
        if (!parent || !parent.input.node().checked) return;
      }
      const id3 = input.attr("id");
      args[id3] = this.getInputValue({ param, input });
    }
  }
  /** Get value for single input based on type */
  getInputValue({ param, input }) {
    if (param.type == "radio") return param.value;
    const value = input.node().value;
    if (input.attr("type") == "number") return Number(value);
    if (input.attr("type") == "checkbox") {
      if (param.type == "string") return input.node().checked ? param.value : "";
      if (param.type == "boolean") return input.node().checked ? 1 : 0;
    }
  }
  renderGeneHoldingDiv(div) {
    return div.append("div").append("div").style("display", "flex").style("flex-wrap", "wrap").style("gap", "5px").style("min-height", "20px").style("border", "solid 1px #aaa").style("margin", "15px 0px").style("padding", "6px 2px").style("min-height", "30px");
  }
  renderStatLegend() {
    if (!this.api.statColor2label || this.api.statColor2label.size == 0) {
      this.api.dom.statLegendDiv.style("display", "none");
      return;
    }
    this.api.dom.statLegendDiv.style("display", "block").selectAll("*").remove();
    for (const [c, n] of this.api.statColor2label) {
      this.api.dom.statLegendDiv.append("div").style("display", "inline-block").style("width", "12px").style("height", "12px").style("background-color", c);
      this.api.dom.statLegendDiv.append("span").html(` ${n} &nbsp;&nbsp;`);
    }
    return this.api.dom.statLegendDiv;
  }
  /** Functions supporting adding/removing genes from the geneHoldingDiv */
  addGene() {
    if (this.geneSearch.geneSymbol) {
      const gene = this.geneSearch.geneSymbol;
      for (const item of this.geneList) {
        if (item.gene == gene) {
          window.alert(`The gene ${gene} has already been added`);
          return;
        }
      }
      if (gene) this.geneList.push({ gene });
    } else if (this.geneSearch.genes) {
      const newGenes = [];
      const duplicates = [];
      for (const geneObj of this.geneSearch.genes) {
        const geneName = geneObj.geneSymbol;
        const isDuplicate = this.geneList.some((item) => item.gene === geneName);
        if (isDuplicate) {
          duplicates.push(geneName);
        } else {
          newGenes.push({ gene: geneName });
        }
      }
      if (newGenes.length > 0) {
        this.geneList.push(...newGenes);
      }
      if (duplicates.length > 0) {
        window.alert(`The following genes were already added and skipped: ${duplicates.join(", ")}`);
      }
    }
    this.renderGenes();
  }
  renderGenes(geneSetName) {
    this.api.dom.geneHoldingDiv.selectAll("*").remove();
    const renderGene = this.renderGene.bind(this);
    const deleteGene = this.deleteGene.bind(this);
    this.api.dom.geneHoldingDiv.selectAll("div").data(this.geneList || []).enter().append("div").attr("aria-label", "Click to delete").attr("class", "sja_menuoption").attr("data-testid", `sjpp-delete-gene-option`).attr("tabindex", 0).style("position", "relative").style("display", "inline-block").style("padding", "5px 16px 5px 9px").style("margin-left", "5px").each(function(gene) {
      const div = select_default(this).style("border-radius", "5px");
      renderGene(div, gene);
      div.on("click", () => deleteGene(gene));
    }).on("mouseover", function(event2) {
      const div = select_default(event2.target);
      div.append("div").style("margin-left", "4px").classed("sjpp_deletebt", true).style("display", "inline-block").style("position", "absolute").style("right", "0px").style("top", "0px").style("transform", "scale(0.6)").style("pointer-events", "none").html(
        `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path stroke='#f00' d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                </svg>`
      );
    }).on("mouseout", function(event2) {
      select_default(event2.target).select(".sjpp_deletebt").remove();
    }).on("focus", (event2) => {
      event2.target.dispatchEvent(new PointerEvent("mouseover"));
    }).on("blur", (event2) => {
      event2.target.dispatchEvent(new PointerEvent("mouseout"));
    }).on("keyup", (event2) => {
      if (event2.key == "Enter") event2.target.click();
    });
    this.renderStatLegend();
    if (this.nameInput && this.updateName) {
      this.nameInput.property("value", geneSetName || this.geneList.map((g) => g.gene).join(", "));
    }
    this.api.dom.clearBtn.property("disabled", !this.geneList?.length);
    const hasChanged = this.origNames !== (this.termsAsListed ? JSON.stringify(this.geneList.map((t2) => t2.gene)) : JSON.stringify(this.geneList.map((t2) => t2.gene).sort()));
    this.api.dom.restoreBtn?.property("disabled", !hasChanged);
    this.api.dom.submitBtn.property(
      "disabled",
      !hasChanged || this.minNumGenes && this.geneList?.length < this.minNumGenes || !this.geneList?.length
    );
    if (hasChanged) this.api.dom.submitBtn.node().focus();
  }
  renderGene(div, gene) {
    let notInList = false;
    if (this.limitedGenesList && !this.limitedGenesList?.includes(gene.gene)) {
      notInList = true;
    }
    if (gene.mutationStat) {
      div.style("text-decoration", notInList ? "line-through" : "").html(`${gene.gene}&nbsp;&nbsp;`);
      for (const m of gene.mutationStat) {
        let bgcolor;
        let textcolor = "black";
        if ("class" in m) {
          if (!mclass[m.class]) throw "invalid stat class";
          bgcolor = mclass[m.class].color;
          this.api.statColor2label.set(bgcolor, mclass[m.class].label);
        } else if ("dt" in m) {
          if (!dt2color[m["dt"]]) throw "invalid stat dt";
          bgcolor = dt2color[m["dt"]];
          textcolor = "white";
          this.api.statColor2label.set(bgcolor, dt2label[m["dt"]]);
        } else {
          throw "stat missing dt/class";
        }
        div.insert("span").style("font-size", ".7em").style("background-color", bgcolor).style("padding", "1px 2px").style("color", textcolor).text(m.count);
      }
    } else {
      div.insert("div").style("display", "inline-block").style("text-decoration", notInList ? "line-through" : "").html(gene.gene);
    }
  }
  deleteGene(d) {
    const i3 = this.geneList.findIndex((g) => g.gene === d.gene);
    if (i3 != -1) {
      this.geneList.splice(i3, 1);
      this.renderGenes();
    }
  }
};

// dom/GeneSetEdit/GeneSetEditUIwithTabs.ts
var tabRadioSuffix = Math.random().toString().slice(-5);
var tabRadioIndex = 0;
var GeneSetEditUIwithTabs = class extends GeneSetEditUI {
  constructor(opts) {
    super({ ...opts, hideDefaultMenu: true });
    this.opts = opts;
    this.api.dom.defaultMenu.style("display", "none");
    this.tabRadioName = `sjpp-geneset-tab-radio-${tabRadioIndex++}-${tabRadioSuffix}`;
    const tabsDiv = this.api.dom.holder.insert("div", ".sja_genesetinput");
    this.setQuickMenu(tabsDiv);
    this.setPresetMenu(tabsDiv);
    this.setCustomMenu(tabsDiv);
  }
  setQuickMenu(tabsDiv) {
    const quickDiv = tabsDiv.append("div").style("min-height", "24px");
    const topGenesLabel = quickDiv.append("label");
    const rankingType = this.mode == "geneVariant" ? "mutated" : "variably expressed";
    topGenesLabel.append("input").attr("type", "radio").attr("name", this.tabRadioName).property("checked", true).property("value", "topGenes").on("change", () => {
      this.customMenu.style("display", "none");
      this.api.dom.geneHoldingDiv.style("display", "none");
      this.presetMenu.style("display", "none");
      delete this.msigClickTerm;
      this.quickApplyBtn.style("display", "");
    });
    topGenesLabel.append("span").text(`Top `);
    const numGenesInput = topGenesLabel.append("input").attr("type", "number").style("width", "60px").property("value", this.maxNumGenes);
    topGenesLabel.append("span").text(`${rankingType} genes`);
    this.quickApplyBtn = quickDiv.append("button").style("margin-left", "10px").html("Submit").on("click", async () => {
      const numGenes = Number(numGenesInput.property("value"));
      this.quickApplyBtn.property("disabled", true);
      try {
        await this.setTopGenes(numGenes);
      } catch (error) {
        console.error(error);
      } finally {
        this.quickApplyBtn.property("disabled", false);
      }
    });
  }
  setPresetMenu(tabsDiv) {
    const presetDiv = tabsDiv.append("div").style("min-height", "24px");
    const presetGenesLabel = presetDiv.append("label");
    presetGenesLabel.append("input").attr("type", "radio").attr("name", this.tabRadioName).property("value", "presetGenes").on("change", () => {
      this.quickApplyBtn.style("display", "none");
      this.api.dom.geneHoldingDiv.style("display", "none");
      this.customMenu.style("display", "none");
      this.presetMenu.selectAll("*").remove();
      this.msigClickTerm = (term) => {
        this.geneList = [];
        const result = { geneList: this.geneList };
        if (this.nameInput) result.name = this.nameInput.property("value");
        for (const gene of term._geneset) this.geneList.push({ gene: gene.symbol });
        this.callback(result);
        this.tip2.hide();
      };
      this.renderTextControls(this.presetMenu, (m) => m.isPreset === true);
      this.presetMenu.style("display", "inline-block");
      this.presetMenu.node()?.firstChild?.dispatchEvent(new PointerEvent("click", { bubbles: true }));
    });
    presetGenesLabel.append("span").text(`Prebuilt gene set`);
    this.presetMenu = presetDiv.append("div").style("display", "inline-block");
  }
  setCustomMenu(tabsDiv) {
    const customDiv = tabsDiv.append("div").style("min-height", "24px");
    const customGenesLabel = customDiv.append("label");
    customGenesLabel.append("input").attr("type", "radio").attr("name", this.tabRadioName).property("value", "customGenes").on("change", () => {
      this.quickApplyBtn.style("display", "none");
      this.presetMenu.style("display", "none");
      delete this.msigClickTerm;
      this.api.dom.geneHoldingDiv.style("display", "");
      this.customMenu.style("display", "");
    });
    customGenesLabel.append("span").text(`Custom gene set`);
    this.customMenu = this.api.dom.defaultMenu;
  }
  async setTopGenes(numGenes = 0) {
    let data;
    if (this.mode == "geneVariant") {
      const body = {
        maxGenes: numGenes || this.maxNumGenes
      };
      data = await this.vocabApi.getTopMutatedGenes(body);
    } else if (this.mode == "geneExpression") {
      const body = {
        //genome: this.vocabApi.state.vocab.genome,
        //dslabel: this.vocabApi.state.vocab.dslabel,
        maxGenes: numGenes || this.maxNumGenes
      };
      data = await this.vocabApi.getTopVariablyExpressedGenes(body);
    } else {
      throw "unknown opts.mode [geneset.js]";
    }
    if (!data) throw "invalid server response";
    if (data.error) throw data.error;
    if (!data.genes) return [];
    this.callback({
      geneList: data.genes.map((gene) => ({
        gene: typeof gene == "string" ? gene : gene.gene
      }))
    });
  }
};

// dom/html.legend.js
function htmlLegend(legendDiv, viz = { settings: {}, handlers: {} }, barDiv) {
  const isHidden = {};
  function render(data, opts = {}) {
    const s = viz.settings;
    if (!opts.div) legendDiv.selectAll("*").remove();
    if (data.every((d) => Array.isArray(d))) {
      for (let i3 = 0; i3 < data.length; i3++) {
        const barDivChild = barDiv.select(`.pp-sbar-div:nth-child(${i3 + 1})`);
        generateLegend(data[i3], s, barDivChild);
      }
    } else if (data.every((d) => typeof d == "object")) {
      generateLegend(data, s, opts.div || legendDiv);
    } else {
      throw "render() only takes an array of objects or an array of arrays";
    }
  }
  function generateLegend(data, s, oneLegendDiv) {
    oneLegendDiv.selectAll(".pp-sbar-div-oneLegend").remove();
    oneLegendDiv.append("div").attr("class", "pp-sbar-div-oneLegend").attr("data-testid", "pp-sbar-div-oneLegend").style("width", s.mainWidth || "").style(
      "text-align",
      data.legendTextAlign || s.legendTextAlign || (s.legendOrientation == "vertical" ? "left" : "center")
    ).style("display", s.legendOrientation == "grid" ? "grid" : "").style("grid-template-rows", s.legendOrientation == "grid" ? "auto auto" : "").style("gap", s.legendOrientation == "grid" ? "10px" : "").selectAll("div").data(data).enter().append("div").each(addLegendRow);
    if (s.legendChartSide == "right") {
      setTimeout(() => {
        const pbox = viz.dom.container.node().parentNode.getBoundingClientRect();
        const mbox = viz.dom.container.node().getBoundingClientRect();
        const lbox = viz.dom.legendDiv.node().getBoundingClientRect();
        const currPadTop = parseFloat(viz.dom.legendDiv.style("padding-top"));
        const padTop = pbox.height - mbox.height + (mbox.height - lbox.height + currPadTop) / 2;
        if (Math.abs(currPadTop - padTop) < 20) return;
        viz.dom.legendDiv.transition().duration(100).style("padding-top", padTop < 0 ? 0 : padTop + "px");
      }, 1200);
    }
  }
  function addLegendRow(d) {
    const s = viz.settings;
    const div = select_default(this).style(
      "display",
      s.legendOrientation == "vertical" || s.legendOrientation == "grid" ? "block" : "inline-block"
    );
    if (d.name) {
      if (s.legendChartSide == "right") {
        div.style("text-align", "left");
        div.append("div").style("font-size", s.legendFontSize).style("font-weight", 600).html(d.name);
        div.append("div").selectAll("div").data(d.items).enter().append("div").style("display", s.legendOrientation == "vertical" ? "block" : "inline-block").style("margin-right", "5px").each(addLegendItem);
      } else {
        div.style("white-space", "nowrap").style("width", s.legendOrientation == "vertical" ? "fit-content" : null);
        div.append("div").style(
          "display",
          s.legendOrientation == "grid" || s.legendOrientation == "vertical" ? "block" : "inline-block"
        ).style("width", d.rowLabelHangLeft ? d.rowLabelHangLeft + "px" : null).style("margin-left", s.legendOrientation == "vertical" ? "15px" : null).style("text-align", d.rowLabelHangLeft ? "right" : null).style("font-weight", 600).style("vertical-align", "top").html(d.name);
        div.append("div").style(
          "display",
          s.legendOrientation == "grid" || s.legendOrientation == "vertical" ? "block" : "inline-block"
        ).style("max-width", 1.2 * d.rowLabelHangLeft + "px").style("white-space", "normal").style("vertical-align", "top").selectAll("div").data(d.items).enter().append("div").style("display", "inline-block").style("margin-left", "15px").each(addLegendItem);
      }
    } else {
      div.selectAll("div").data(d.items).enter().append("div").style("display", s.legendOrientation == "vertical" ? "block" : "inline-block").style("margin-left", "15px").each(addLegendItem);
    }
  }
  function addLegendItem(d) {
    const s = viz.settings;
    const div = select_default(this);
    const color = d.fill ? d.fill : d.stroke ? d.stroke : d.color;
    div.attr("class", "legend-row").classed("sjpp-hidden-legend-item", d.isHidden ? true : false).style("display", s.legendOrientation == "vertical" ? "block" : "inline-block").style("width", s.legendOrientation == "vertical" ? "fit-content" : null);
    if (d.svg) {
      div.append("svg").attr("width", d.svgw).attr("height", d.svgh).style("display", "inline-block").style("vertical-align", "top").style("border", d.border).html((d2) => d2.svg);
    } else if (!d.noIcon) {
      const stroke = d.noEditColor ? color : rgb(color).darker();
      div.append("div").style("display", "inline-block").style("position", "relative").style("min-width", "12px").style("height", "12px").style("top", "1px").style("border", d.border ? d.border : "1px solid " + stroke).style("border-radius", d.shape == "circle" ? "6px" : "").style("background-color", d.shape == "circle" ? "" : color).style("cursor", "isHidden" in d ? "pointer" : "default").style("color", d.textColor ? d.textColor : "#fff").style("font-size", "10px").style("vertical-align", d.inset ? "top" : "").style("padding", d.inset ? "0 3px" : "").text(d.inset).on("click", viz.handlers.legend?.onColorClick);
    }
    div.append("div").classed("sjpp-htmlLegend", true).attr("data-testid", "sjpp-htmlLegend-" + d.seriesId).style("display", "inline-block").style("margin-left", d.svg ? "1px" : "3px").style("cursor", handleCursor(d)).style("font-size", s.legendFontSize).style("line-height", s.legendFontSize).style("vertical-align", d.svg ? "top" : null).style("text-decoration", d.isHidden ? "line-through" : "none").html(d.text).on("click", viz.handlers.legend?.click);
    if (Object.keys(viz.handlers).length) {
      div.on("mouseover", viz.handlers.legend.mouseover).on("mouseout", viz.handlers.legend.mouseout);
    }
  }
  return render;
}
function handleCursor(d) {
  if ("isClickable" in d) {
    return d.isClickable ? "pointer" : "default";
  }
  return "isHidden" in d ? "pointer" : "default";
}

// dom/InvalidDataUI.ts
var InvalidDataUI = class _InvalidDataUI {
  static {
    this.defaults = {
      backgroundColor: "#f8f9fa",
      borderColor: "#dee2e6",
      borderRadius: "4px",
      color: "#dc3545",
      //punch red
      fontSize: 12,
      //use px, adjusted
      padding: 8,
      // use px, adjusted
      margin: "12px"
    };
  }
  static render(container, invalidInfo) {
    const expandableContainer = container.append("div").style("margin-top", _InvalidDataUI.defaults.margin).attr("id", "sjpp-invalid-data-ui");
    const expandableHeader = expandableContainer.append("div").style("display", "flex").style("align-items", "center").style("gap", "8px").style("cursor", "pointer").style("padding", `${_InvalidDataUI.defaults.padding}px`).style("border-radius", _InvalidDataUI.defaults.borderRadius).style("transition", "background-color 0.2s").style("background-color", "rgba(220, 53, 69, 0.1)").style("border", "1px solid rgba(220, 53, 69, 0.2)").on("mouseenter", function() {
      select_default(this).style("background-color", "rgba(220, 53, 69, 0.15)");
    }).on("mouseleave", function() {
      select_default(this).style("background-color", "rgba(220, 53, 69, 0.1)");
    });
    const expandIcon = expandableHeader.append("span").style("font-size", `${_InvalidDataUI.defaults.fontSize}px`).style("color", _InvalidDataUI.defaults.color).style("transition", "transform 0.2s").text("\u25B6");
    expandableHeader.append("span").style("color", _InvalidDataUI.defaults.color).style("text-decoration", "underline").style("font-size", `${_InvalidDataUI.defaults.fontSize + 1}px`).style("font-weight", "500").text(`View ${invalidInfo.entries.length} invalid entries`);
    const expandableContent = expandableContainer.append("div").style("display", "none").style("margin-top", _InvalidDataUI.defaults.margin).style("padding", `${_InvalidDataUI.defaults.padding + 4}px`).style("background-color", "#fff").style("border", "1px solid #f5c6cb").style("border-radius", `${_InvalidDataUI.defaults.borderRadius}`).style("box-shadow", "inset 0 1px 3px rgba(0, 0, 0, 0.1)");
    const tableContainer = expandableContent.append("div").style("max-height", "300px").style("overflow-y", "auto").style("border", `1px solid ${_InvalidDataUI.defaults.borderColor}`).style("border-radius", _InvalidDataUI.defaults.borderRadius);
    renderTable({
      div: tableContainer,
      columns: [
        { label: "Data Type", sortable: true },
        { label: "Reason", sortable: true }
      ],
      rows: invalidInfo.entries.map((e) => [{ value: e.dataType }, { value: e.reason }]),
      showLines: true,
      striped: true,
      showHeader: true,
      maxHeight: "280px",
      resize: false,
      header: {
        allowSort: true,
        style: {
          "background-color": _InvalidDataUI.defaults.backgroundColor,
          "font-weight": "bold",
          "border-bottom": `2px solid ${_InvalidDataUI.defaults.borderColor}`
        }
      }
    });
    expandableContent.append("div").style("margin-top", _InvalidDataUI.defaults.margin).style("padding", `${_InvalidDataUI.defaults.padding}px`).style("background-color", _InvalidDataUI.defaults.backgroundColor).style("border-radius", _InvalidDataUI.defaults.borderRadius).style("font-size", `${_InvalidDataUI.defaults.fontSize}px`).style("color", "#495057").style("line-height", "1.4").text(invalidInfo.errorMsg || "Please address the issues above before proceeding.");
    let isExpanded = false;
    expandableHeader.on("click", function() {
      isExpanded = !isExpanded;
      if (isExpanded) {
        expandableContent.style("display", "block");
        expandIcon.style("transform", "rotate(90deg)").text("\u25BC");
      } else {
        expandableContent.style("display", "none");
        expandIcon.style("transform", "rotate(0deg)").text("\u25B6");
      }
    });
  }
};

// dom/LegendCircleReference.ts
var LegendCircleReference = class {
  constructor(opts) {
    this.color = "#aaa";
    this.shift = 20;
    this.width = 70;
    this.tip = new Menu({ padding: "5px" });
    this.validateOpts(opts);
    this.g = opts.g;
    this.inputMax = opts.inputMax;
    this.inputMin = opts.inputMin;
    this.isAscending = opts.isAscending ?? true;
    this.maxLabel = opts.maxLabel ?? opts.maxRadius;
    this.maxRadius = opts.maxRadius;
    this.minLabel = opts.minLabel ?? opts.minRadius;
    this.minRadius = opts.minRadius;
    this.x = opts.x ?? 40;
    this.y = opts.y ?? 40;
    if (opts.menu) this.menu = opts.menu;
    if (opts.title) this.title = opts.title;
    this.renderLegendComponent();
  }
  validateOpts(opts) {
    if (!opts.g) throw `Missing g in LegendCircleReference`;
    if (opts.maxRadius > opts.inputMax) throw `Max radius must be less than inputMax`;
    if (opts.minRadius < opts.inputMin) throw `Min radius must be greater than inputMin`;
  }
  renderLegendComponent() {
    this.g.selectAll("*").remove();
    if (this.title) this.g.append("text").style("font-weight", "bold").style("font-size", "0.8em").text(this.title);
    const minG = this.g.append("g").attr("transform", `translate(${this.x},${this.y})`);
    const maxG = this.g.append("g").attr("transform", `translate(${this.x + this.width},${this.y})`);
    const startRadius = this.isAscending ? this.minRadius : this.maxRadius;
    this.renderLabel(minG, -startRadius - this.shift, this.minLabel);
    this.renderReferenceCircle(minG, startRadius);
    const endRadius = this.isAscending ? this.maxRadius : this.minRadius;
    this.renderReferenceCircle(maxG, endRadius);
    this.renderLabel(maxG, endRadius + this.shift, this.maxLabel);
    this.renderScalingLine(minG, this.minRadius, this.maxRadius);
    this.renderScalingLine(minG, -this.minRadius, -this.maxRadius);
    const minBBox = minG.node().getBBox();
    const maxBBox = maxG.node().getBBox();
    if (this.menu) {
      this.g.append("rect").attr("width", minBBox.width + maxBBox.width).attr("height", (this.isAscending ? maxBBox.height : minBBox.height) + 20).attr("fill", "transparent").on("click", () => {
        this.renderMenu();
      });
    }
  }
  renderReferenceCircle(g, radius) {
    g.append("circle").style("fill", this.color).style("stroke", this.color).attr("cx", 0).attr("cy", 0).attr("r", radius);
  }
  renderLabel(g, x, text) {
    g.append("text").attr("x", x).attr("y", 5).style("font-size", ".8em").text(text);
  }
  renderScalingLine(g, minRadius, maxRadius) {
    g.append("line").attr("x1", 0).attr("y1", this.isAscending ? minRadius : maxRadius).attr("x2", this.width).attr("y2", this.isAscending ? maxRadius : minRadius).style("stroke", this.color);
  }
  renderMenu() {
    if (!this.menu) return;
    this.tip.clear().showunder(this.g.node());
    const div = this.tip.d.append("div");
    const minMaxRow = div.append("div");
    if (this.menu?.minMaxLabel)
      minMaxRow.append("span").style("padding-right", "10px").style("opacity", 0.7).style("font-size", ".8em").text(`${this.menu.minMaxLabel.toUpperCase()}`);
    this.addInput(minMaxRow, "Min", this.minRadius);
    this.addInput(minMaxRow, "Max", this.maxRadius);
    if (this.menu.showOrder) {
      const orderRow = div.append("div");
      make_radios({
        holder: orderRow,
        options: [
          {
            checked: this.isAscending,
            label: "Ascending",
            title: "Show in ascending order",
            value: true
          },
          {
            checked: !this.isAscending,
            label: "Descending",
            title: "Show in descending order",
            value: false
          }
        ],
        callback: (value) => {
          if (!this.menu) return;
          this.isAscending = value;
          this.menu.callback({ min: this.minRadius, max: this.maxRadius, isAscending: this.isAscending });
          this.renderLegendComponent();
          this.tip.hide();
        }
      });
    }
  }
  addInput(div, label, value) {
    div.append("label").text(label);
    const input = div.append("input").style("width", "50px").attr("type", "number").attr("min", this.inputMin).attr("max", this.inputMax).attr("value", value).on("change", () => {
      if (!this.menu) return;
      const value2 = input.property("value");
      this[`${label.toLowerCase()}Radius`] = Number(value2);
      this.menu.callback({ min: this.minRadius, max: this.maxRadius, isAscending: this.isAscending });
      this.renderLegendComponent();
      this.tip.hide();
    });
  }
};

// dom/maxLabelWidth.ts
function getMaxLabelWidth(svg, items, size = 1) {
  const svgNode = svg.node();
  if (!svgNode || !svgNode.checkVisibility())
    console.debug(new Error(`The svg is not rendered or visible in getMaxLabelWidth().`));
  let maxLabelLgth = 0;
  for (const item of items) {
    const label = svg.append("text").text(item).style("font-size", `${size}em`);
    maxLabelLgth = Math.max(maxLabelLgth, label.node().getBBox().width);
    label.remove();
  }
  return maxLabelLgth;
}

// dom/MultiTermWrapperEditUI.ts
var MultiTermWrapperEditUI = class {
  constructor(opts) {
    this.type = "multiTermEditUI";
    this.app = opts.app;
    this.callback = opts.callback;
    const holder = opts.holder.attr("data-testid", "sjpp-multi-tw-edit-ui");
    const header = holder.append("div").attr("data-testid", "sjpp-edit-ui-header").style("display", "block").style("padding", "10px");
    const tws = holder.append("div").style("display", "block").style("margin-left", "10px");
    const submitDiv = holder.append("div").attr("data-testid", "sjpp-edit-ui-submit").style("display", "block").style("padding", "10px").style("margin-left", "5px");
    this.dom = {
      holder,
      header,
      tws,
      submitBtn: submitDiv.append("button").style("display", "inline-block"),
      footer: submitDiv.append("div").attr("data-testid", "sjpp-edit-ui-footer").style("display", "inline-block").style("margin-left", "10px")
    };
    this.twList = opts.twList || [];
    this.inputListLength = this.twList.length;
    this.buttonLabel = opts.buttonLabel || "Submit";
    this.maxNum = opts.maxNum || Infinity;
    this.headerText = opts.headerText || "";
    this.customInputs = opts.customInputs || {};
    this.disable_terms = opts.disable_terms || [];
    if (opts.state) this.state = opts.state;
    setRenderers(this);
  }
  async renderUI() {
    this.dom.header.style("font-style", "italic").style("opacity", 0.7).text(this.headerText);
    this.dom.submitBtn.text(this.buttonLabel).on("click", () => {
      this.callback(this.twList);
    });
    this.update(this);
  }
  async getNewPill(d, div) {
    const disable_terms = [...this.disable_terms, ...this.twList.map((tw) => tw.term)];
    const _opts = {
      abbrCutoff: 50,
      debug: this.app.opts?.debug,
      disable_terms,
      genomeObj: this.app.opts.genome,
      holder: div,
      menuOptions: "!replace",
      numericEditMenuVersion: ["continuous", "discrete"],
      placeholder: "Add term",
      vocabApi: this.app.vocabApi,
      callback: (tw) => {
        const twListCopy = this.twList.slice(0);
        const idx = twListCopy.findIndex((t2) => t2.$id === d.tw.$id);
        if (idx !== -1 && !tw?.term) {
          twListCopy.splice(idx, 1);
        } else if (idx == -1) {
          tw.$id = d.tw.$id;
          twListCopy.push(tw);
        } else twListCopy[idx] = tw;
        this.twList = twListCopy;
        this.update(this);
      }
    };
    if (this.state) {
      _opts.activeCohort = this.state.activeCohort;
    }
    if (this.app.opts?.genome) {
      _opts.genomeObj = this.app.opts.genome;
    }
    const termsettingOpts = Object.assign({}, _opts, this.customInputs);
    const pill = await termsettingInit(termsettingOpts);
    return pill;
  }
  async renderTerm(d, numericOpts = false) {
    if (!d?.pill) return;
    const pillOps = this.getPillOpts(d, numericOpts);
    await d.pill.main(pillOps);
  }
  getPillOpts(d, numericOpts) {
    const pillOps = {
      term: d.tw.term,
      q: d.tw.q
    };
    if (d.tw.$id) pillOps.$id = d.tw.$id;
    if (this.state) {
      pillOps.activeCohort = this.state.activeCohort;
      pillOps.filter = this.state?.termfilter?.filter;
    }
    if (numericOpts) {
      pillOps.numericEditMenuVersion = ["continuous", "discrete"];
    }
    return pillOps;
  }
};
function setRenderers(self2) {
  self2.update = () => {
    self2.dom.tws.selectAll("div").remove();
    const twListCopy = self2.twList.map((tw) => {
      return { tw };
    });
    if (twListCopy.length < self2.maxNum) {
      twListCopy.push({ tw: { $id: Math.random().toString() } });
    }
    const tws = self2.dom.tws.selectAll(":scope>.sjpp-edit-ui-pill").data(twListCopy, (d) => d.tw?.$id);
    tws.exit().remove();
    tws.each(self2.renderTerm);
    tws.enter().append("div").attr("class", "sjpp-edit-ui-pill").each(self2.addTerm);
    self2.dom.submitBtn.property("disabled", self2.twList.length === 0 && self2.inputListLength == 0);
    self2.dom.footer.text(
      `${self2.twList.length === 0 && self2.inputListLength > 0 ? `Terms removed` : `${self2.twList.length} terms selected`}`
    );
  };
  self2.addTerm = async function(d) {
    const div = select_default(this);
    d.pill = await self2.getNewPill(d, div);
    self2.renderTerm(d, true);
  };
}

// dom/numericAxis.js
function makeNumericAxisConfig({ holder, callback, setting, noPercentile }) {
  if (!holder) throw "no holder";
  if (typeof callback != "function") throw "callback not function";
  if (!setting) setting = { auto: 1 };
  if (setting.auto) {
  } else if (setting.fixed) {
    if (!Number.isFinite(setting.fixed.min)) throw "fixed.min is not number";
    if (!Number.isFinite(setting.fixed.max)) throw "fixed.max is not number";
    if (setting.fixed.min >= setting.fixed.max) throw "fixed min>=max";
  } else if (setting.percentile) {
    if (setting.percentile < 0 || setting.percentile > 100) throw "invalid setting.percentile";
  } else {
    throw "invalid setting{}";
  }
  const row = holder.append("div");
  row.append("span").html("Y scale&nbsp;&nbsp;");
  const ss = row.append("select");
  const op1 = ss.append("option").text("Automatic");
  const op2 = ss.append("option").text("Fixed");
  let op3;
  if (!noPercentile) op3 = ss.append("option").text("Percentile");
  ss.on("change", (event2) => {
    const si = event2.target.selectedIndex;
    if (si == 0) {
      fixedDiv.style("display", "none");
      percentileDiv.style("display", "none");
      callback({ auto: 1 });
      return;
    }
    if (si == 1) {
      fixedDiv.style("display", "");
      maxInput.node().focus();
      percentileDiv.style("display", "none");
      return;
    }
    fixedDiv.style("display", "none");
    percentileDiv.style("display", "");
    perInput.node().focus();
  });
  ss.property("selectedIndex", setting.auto ? 0 : setting.fixed ? 1 : 2);
  let maxInput, minInput, perInput;
  const fixedDiv = row.append("div").style("margin", "10px").style("display", setting.fixed ? "block" : "none");
  {
    const row1 = fixedDiv.append("div");
    row1.append("span").html("Max&nbsp;").style("font-family", "Courier").style("font-size", ".9em");
    maxInput = row1.append("input").attr("type", "number").style("width", "50px");
    if (setting.fixed) maxInput.property("value", setting.fixed.max);
    const row2 = fixedDiv.append("div");
    row2.append("span").html("Min&nbsp;").style("font-family", "Courier").style("font-size", ".9em");
    minInput = row2.append("input").attr("type", "number").style("width", "50px");
    if (setting.fixed) minInput.property("value", setting.fixed.min);
    row2.append("button").text("Set").style("margin-left", "5px").on("click", () => {
      let min, max;
      max = maxInput.property("value");
      if (max == "") {
        return;
      }
      max = Number.parseFloat(max);
      if (Number.isNaN(max)) {
        alert("invalid max value");
        return;
      }
      min = minInput.property("value");
      if (min == "") {
        return;
      }
      min = Number.parseFloat(min);
      if (Number.isNaN(min)) {
        alert("invalid min value");
        return;
      }
      if (min >= max) {
        alert("Min must be smaller than max");
        return;
      }
      callback({ fixed: { min, max } });
    });
  }
  const percentileDiv = row.append("div").style("margin-top", "6px").style("display", setting.percentile ? "block" : "none");
  percentileDiv.append("span").html("Percentile&nbsp;").style("font-family", "Courier").style("font-size", ".9em");
  perInput = percentileDiv.append("input").attr("type", "number").style("width", "50px");
  if (setting.percentile) {
    perInput.property("value", setting.percentile);
  }
  const setpercentile = (s) => {
    if (s == "") return;
    const v = Number.parseInt(s);
    if (Number.isNaN(v) || v <= 0 || v > 100) {
      alert("percentile should be integer within range 0-100");
      return;
    }
    callback({ percentile: v });
  };
  perInput.on("keyup", (event2) => {
    if (!keyupEnter(event2)) return;
    setpercentile(perInput.property("value"));
  });
  percentileDiv.append("button").text("Set").style("margin-left", "5px").on("click", () => {
    setpercentile(perInput.property("value"));
  });
}

// dom/radiobutton.ts
var nameSuffix = 0;
function make_radios(opts) {
  if (!opts.callback && !opts.listeners) throw `Missing event callback for radios [#dom/radiobutton.js]`;
  if (opts.callback && opts.listeners)
    throw `Both callback() and .listeners defined [#dom/radiobutton.js]. Only supply one.`;
  const inputName = opts.inputName || "pp-dom-radio-" + nameSuffix++;
  if (!opts.styles) opts.styles = {};
  if (!opts.styles.display) {
    if (opts.labelDisplay) opts.styles.display = opts.labelDisplay;
    else {
      const len = opts.options.reduce((total, d) => total + d.label.length + 4, 0);
      opts.styles.display = len < 36 ? "inline-block" : "block";
    }
  }
  const styleKeys = Object.keys(opts.styles);
  if (!styleKeys.includes("padding")) opts.styles.padding = "3px";
  const divs = opts.holder.selectAll("div").data(opts.options, (d) => d?.value).enter().append("div").attr("aria-label", (d) => d.title).style("padding", opts.styles.padding);
  if (opts.styles) {
    for (const k in opts.styles) {
      divs.style(k, opts.styles[k]);
    }
  }
  const labels = divs.append("label");
  const inputs = labels.append("input").attr("type", "radio").attr("name", inputName).attr("value", (d) => d.value).style("vertical-align", opts.styles && "vertical-align" in opts.styles ? opts.styles["vertical-align"] : "").style("margin-top", "2px").style("margin-right", 0).property("checked", (d) => d?.checked);
  if (opts.options.find((i3) => i3.testid)) {
    inputs.attr("data-testid", (i3) => i3.testid);
  }
  if (opts.callback) {
    inputs.on("input", async (event2, d) => {
      inputs.property("disabled", true);
      if (!opts.callback) return;
      await opts.callback(d.value);
      radio.main(d.value);
      inputs.property("disabled", false);
    });
  }
  const radioText = labels.append("span").style("vertical-align", opts.styles && "vertical-align" in opts.styles ? opts.styles["vertical-align"] : "").html((d) => "&nbsp;" + d.label);
  if (opts?.listeners?.input) {
    inputs.on("mouseup", opts.listeners.input).on("keyup", opts.listeners.input);
    radioText.on("mouseup", opts.listeners.input).on("keyup", opts.listeners.input);
  }
  const radio = {
    divs,
    labels,
    inputs,
    main(currValue) {
      radio["currValue"] = currValue;
      inputs.property("checked", (d) => d.value == radio["currValue"]);
    }
  };
  return radio;
}

// dom/renderAtRisk.js
function renderAtRiskG({ g, s, chart, order, term2toColor, onSerieClick }) {
  const atRiskGroups = [];
  const xTickValues = chart.xTickValues.filter((xTick) => xTick >= chart.xMin);
  for (const series of chart.visibleSerieses) {
    const counts = [];
    let i3 = 0, d = series.data[0], prev = d, nCensored = 0;
    for (const time of xTickValues) {
      while (d && d.x < time) {
        nCensored += d.ncensor;
        prev = d;
        i3++;
        d = series.data[i3];
      }
      if (d && d.x === time) {
        counts.push([time, d.nrisk, nCensored]);
      } else {
        counts.push([time, prev.nrisk - prev.nevent - prev.ncensor, nCensored]);
      }
    }
    const { seriesId, seriesLabel } = series;
    atRiskGroups.push({ seriesId, seriesLabel, counts });
  }
  const y = s.svgh - s.svgPadding.top - s.svgPadding.bottom + 60;
  const seriesOrder = order || chart.serieses.map((s2) => s2.seriesId);
  g.selectAll(".sjpp-atrisk-title").remove();
  if (s.atRiskVisible) {
    atRiskGroups.sort((a, b) => seriesOrder.indexOf(a.seriesId) - seriesOrder.indexOf(b.seriesId));
    const addYoffset = chart.serieses.length == 1 && !chart.serieses[0].seriesId;
    const titleg = g.append("text").attr("class", "sjpp-atrisk-title").attr("transform", `translate(${s.atRiskLabelOffset}, ${addYoffset ? 2 * s.axisTitleFontSize : 0})`).attr("text-anchor", "end").attr("font-size", `${s.axisTitleFontSize - 4}px`).attr("cursor", chart.serieses.length == 1 ? "pointer" : "default").text("Number at risk").on("click", chart.serieses.length == 1 ? (e) => onSerieClick({ seriesId: "" }, e.clientX, e.clientY) : null);
    if (term2toColor[""]) titleg.style("fill", s.defaultColor);
    titleg.append("tspan").attr("x", 0).attr("y", s.axisTitleFontSize - 4).text("(# censored)");
  } else {
    atRiskGroups.length = 0;
  }
  const sg = g.attr("transform", `translate(0,${y})`).selectAll(":scope > g").data(atRiskGroups, (s2) => s2.seriesLabel || s2.seriesId);
  sg.exit().remove();
  sg.each(function(atRiskGroup, i3) {
    const { seriesId, seriesLabel, counts } = atRiskGroup;
    const y2 = (i3 + 1) * (2 * s.axisTitleFontSize);
    const g2 = select_default(this).attr("transform", `translate(0,${y2})`).attr("fill", term2toColor[""] ? s.defaultColor : term2toColor[seriesId].adjusted);
    let legendText = g2.select(":scope>text");
    if (!legendText.size()) legendText = g2.append("text");
    legendText.text(seriesId && seriesId !== "*" ? seriesLabel || seriesId : "");
    let ticksG = g2.select(":scope>g");
    if (!ticksG.size()) ticksG = g2.append("g");
    renderAtRiskTick(ticksG, chart, xTickValues, s, atRiskGroup);
  });
  sg.enter().append("g").each(function(atRiskGroup, i3) {
    const { seriesId, seriesLabel, counts } = atRiskGroup;
    const y2 = (i3 + 1) * (2 * s.axisTitleFontSize);
    const g2 = select_default(this).attr("transform", `translate(0,${y2})`).attr("fill", term2toColor[""] ? s.defaultColor : term2toColor[seriesId].adjusted).on("click", (e) => onSerieClick({ seriesId }, e.clientX, e.clientY));
    g2.append("text").attr("data-testid", "sjpp-atrisk-seriesId").attr("transform", `translate(${s.atRiskLabelOffset}, 0)`).attr("text-anchor", "end").attr("font-size", `${s.axisTitleFontSize - 4}px`).attr("cursor", "pointer").datum({ seriesId }).text(seriesId && seriesId !== "*" ? seriesLabel || seriesId : "");
    renderAtRiskTick(g2.append("g"), chart, xTickValues, s, atRiskGroup);
  });
}
function renderAtRiskTick(g, chart, xTickValues, s, atRiskGroup) {
  const { seriesId, counts } = atRiskGroup;
  const reversed = counts.slice().reverse();
  const data = xTickValues.map((tickVal) => {
    if (tickVal === 0) return { seriesId, tickVal, atRisk: counts[0][1], nCensored: counts[0][2] };
    const d = reversed.find((d2) => d2[0] <= tickVal);
    return { seriesId, tickVal, atRisk: d[1], nCensored: d[2] };
  });
  const text = g.selectAll("text").data(data);
  text.exit().remove();
  text.attr("transform", (d) => `translate(${chart.xScale(d.tickVal)},0)`).attr("text-anchor", "middle").attr("font-size", `${s.axisTitleFontSize - 4}px`).attr("cursor", "pointer").each(renderAtRiskLabel);
  text.enter().append("text").attr("transform", (d) => `translate(${chart.xScale(d.tickVal)},0)`).attr("text-anchor", "middle").attr("data-testid", `sjpp-atrisk-text-count-${seriesId}`).attr("font-size", `${s.axisTitleFontSize - 4}px`).attr("cursor", "pointer").each(renderAtRiskLabel);
  function renderAtRiskLabel(d) {
    const tspans = select_default(this).selectAll("tspan").data([d.atRisk, `(${d.nCensored})`]);
    tspans.exit().remove();
    tspans.attr("y", (d2, i3) => i3 === 0 ? 0 : i3 * (s.axisTitleFontSize - 4)).text((d2) => d2);
    tspans.enter().append("tspan").attr("x", 0).attr("y", (d2, i3) => i3 === 0 ? 0 : i3 * (s.axisTitleFontSize - 4)).text((d2) => d2);
  }
}

// dom/renderPvalueTable.js
function renderPvalues({
  title,
  titleTestid = void 0,
  holder,
  plot,
  tests,
  s,
  bins,
  tip,
  setActiveMenu,
  updateHiddenPvalues
}) {
  let fontSize;
  if (s.axisTitleFontSize) {
    fontSize = s.axisTitleFontSize - 2;
  } else fontSize = 15;
  const maxPvalsToShow = 10;
  holder.selectAll("*").remove();
  if (!plot) {
    throw `plot type '${plot}' not recognized`;
  }
  holder.append("div").style("padding-bottom", "5px").style("font-size", fontSize + "px").style("font-weight", "bold").attr("data-testid", titleTestid || "sjpp-pvalueTable-title").text(title);
  const tablediv = holder.append("div").style("border", "1px solid #ccc");
  if (plot == "violin" && tests.pvalues.length > maxPvalsToShow || tests.length > maxPvalsToShow) {
    tablediv.style("overflow", "auto").style("height", "220px");
  }
  const visibleTests = s.hiddenPvalues ? tests.filter((t2) => !s.hiddenPvalues.find((p) => p.series1.id === t2.series1.id && p.series2.id === t2.series2.id)) : tests;
  if (plot == "violin" ? visibleTests.pvalues.length : visibleTests.length) {
    const binOrder = bins && bins.length > 0 ? bins.map((b) => b.label) : null;
    if (binOrder) {
      for (const test of visibleTests) {
        const orderedSeries = [test.series1.id, test.series2.id].sort(
          (a, b) => binOrder.indexOf(a) - binOrder.indexOf(b)
        );
        if (test.series2.id == orderedSeries[0]) {
          test.series1_new = test.series2;
          test.series2_new = test.series1;
          test.series1 = test.series1_new;
          test.series2 = test.series2_new;
          delete test.series1_new;
          delete test.series2_new;
        }
      }
      visibleTests.sort(
        (a, b) => binOrder.indexOf(a.series1.id) - binOrder.indexOf(b.series1.id) || binOrder.indexOf(a.series2.id) - binOrder.indexOf(b.series2.id)
      );
    }
    const table = tablediv.append("table").style("width", "100%");
    table.append("thead").append("tr").selectAll("td").data(["Group 1", "Group 2", "P-value"]).enter().append("td").style("padding", "1px 8px 1px 2px").style("color", "#555").style("position", "sticky").style("top", "0px").style("background", "white").style("font-size", fontSize + "px").text((column) => column);
    const tbody = table.append("tbody");
    const tr = tbody.selectAll("tr").data(plot == "violin" ? visibleTests.pvalues : visibleTests).enter().append("tr").attr("class", `pp-${plot}-chartLegends-pvalue`);
    if (plot == "survival") {
      tr.on("click", (event2, t2) => {
        const hiddenPvalues = s.hiddenPvalues.slice();
        hiddenPvalues.push(t2);
        updateHiddenPvalues(hiddenPvalues);
      });
    }
    tr.selectAll("td").data((d) => [d.series1, d.series2, d.pvalue]).enter().append("td").attr("aria-label", plot ? "Click to hide a p-value" : "").style("color", plot == "violin" ? "black" : (d) => d.color).style("padding", "1px 8px 1px 2px").style("font-size", fontSize + "px").style("cursor", plot == "survival" ? "pointer" : "auto").text((d) => plot == "violin" ? d : d.text);
    if (plot == "cuminc") {
      if (visibleTests.find((test) => test.permutation)) {
        holder.append("div").style("margin-top", "10px").style("font-size", fontSize - 2 + "px").text("*computed by permutation of Gray's test statistic");
      }
    }
  }
  if (plot == "survival") {
    const hiddenTests = tests.filter(
      (t2) => s.hiddenPvalues.find((p) => p.series1.id === t2.series1.id && p.series2.id === t2.series2.id)
    );
    if (hiddenTests.length) {
      holder.append("div").style("color", "#aaa").style("cursor", "pointer").html(`<span style='color:#aaa; font-weight:400'><span>Hidden tests (${hiddenTests.length})</span>`).on("click", (event2) => {
        tip.clear();
        const divs = tip.d.append("div").selectAll("div").data(hiddenTests).enter().append("div").each(function(d) {
          setActiveMenu(true);
          const div = select_default(this);
          div.append("input").attr("type", "checkbox").style("margin-right", "5px");
          div.append("span").html(`${d.series1.id} vs ${d.series2.id}`);
        });
        tip.d.append("button").html("Show checked test(s)").on("click", () => {
          const hiddenPvalues = [];
          divs.filter(function() {
            return !select_default(this.firstChild).property("checked");
          }).each((d) => hiddenPvalues.push(d));
          updateHiddenPvalues(hiddenPvalues);
          tip.hide();
        });
        tip.show(event2.clientX, event2.clientY);
      });
    }
    if (s.maxTimeToEvent && visibleTests.length) {
      holder.append("div").style("margin-top", "10px").style("font-size", fontSize - 2 + "px").text((visibleTests.length > 1 ? "p-values are" : "p-value is") + " computed with all survival data");
    }
  }
}

// dom/sampleTypeSelect.ts
function renderSampleTypeSelect(holder, querySampleTypes, termdbConfig) {
  holder.selectAll("*").remove();
  if (!Array.isArray(querySampleTypes) || querySampleTypes.length < 2) return;
  const sampleTypeConfig = {};
  for (const sampleType of querySampleTypes) {
    sampleTypeConfig[sampleType] = termdbConfig.sampleTypes[sampleType];
  }
  const sampleTypeCheckboxDiv = holder.append("div").attr("class", "sjpp-genesearch-sampletype-checkboxes").style("margin-right", "8px");
  const sampleTypeCheckboxes = [];
  for (const [k, v] of Object.entries(sampleTypeConfig)) {
    const label = sampleTypeCheckboxDiv.append("label").style("display", "inline-flex").style("align-items", "center").style("margin-right", "10px");
    const input = label.append("input").attr("type", "checkbox").attr("value", k);
    label.append("span").style("margin-left", "4px").text(v.name);
    sampleTypeCheckboxes.push(input);
  }
  return sampleTypeCheckboxes;
}
function getSelectedSampleTypes(sampleTypeSelect) {
  if (!sampleTypeSelect) return;
  return sampleTypeSelect.filter((checkbox) => checkbox.property("checked")).map((checkbox) => Number(checkbox.property("value")));
}

// dom/sandbox.ts
function renderSandboxFormDiv(holder, genomes) {
  holder.classed("sjpp-sandbox-form", true);
  const inputdiv = holder.append("div").style("margin", "40px 20px 20px 20px").classed("sjpp-sandbox-form-inputDiv", true);
  const p = inputdiv.append("p").classed("sjpp-sandbox-form-gselect", true);
  p.append("span").html("Genome&nbsp;");
  const gselect = p.append("select");
  for (const n in genomes) {
    gselect.append("option").text(n);
  }
  const filediv = inputdiv.append("div").style("margin", "20px 0px").classed("sjpp-sandbox-form-fileDiv", true);
  const saydiv = holder.append("div").style("margin", "10px 20px").classed("sjpp-sandbox-form-sayDiv", true);
  const visualdiv = holder.append("div").style("margin", "20px").classed("sjpp-sandbox-form-visualDiv", true);
  return [inputdiv, gselect.node(), filediv, saydiv, visualdiv];
}
var plotIdToSandboxId = {};
var sandboxIdStr = Math.random().toString().slice(-6) + "-" + (+/* @__PURE__ */ new Date()).toString().slice(-8);
var sandboxIdSuffix = 0;
function newSandboxDiv(sandbox_holder, opts = {}) {
  const insertSelector = opts.beforePlotId ? opts.beforePlotId in plotIdToSandboxId ? "#" + plotIdToSandboxId[opts.beforePlotId] : `#${opts.beforePlotId}` : ":first-child";
  const app_div = sandbox_holder.insert("div", insertSelector).attr("class", "sjpp-sandbox");
  let sandboxId;
  if (opts.plotId) {
    sandboxId = `sjpp-sandbox-${sandboxIdStr}-${sandboxIdSuffix++}`;
    app_div.attr("id", sandboxId);
    plotIdToSandboxId[opts.plotId] = sandboxId;
  }
  const header_row = app_div.append("div").attr("class", "sjpp-output-sandbox-header").style("width", opts.style?.width || "95vw").style("border", "1px solid #ccc").style("display", "flex").style("align-items", "center").style("justify-content", "left");
  const hoverInColor = "blue";
  const hoverOutColor = "black";
  const closeBtn = header_row.append("div").classed("sjpp-output-sandbox-close-bt", true).style("cursor", "pointer").style("vertical-align", "middle").on("mouseenter", () => {
    const path2 = closeBtn.select("path");
    path2.attr("stroke", hoverInColor);
  }).on("mouseleave", () => {
    const path2 = closeBtn.select("path");
    path2.attr("stroke", hoverOutColor);
  }).html(
    `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000" class="bi bi-x-lg" viewBox="0 0 16 16">
		  <path stroke='#000' d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
		</svg>`
  ).on("mousedown", (event2) => {
    document.body.dispatchEvent(new Event("mousedown"));
    event2.stopPropagation();
  }).on("click", () => {
    header_row.on("click", null).on("mousedown", null);
    app_div.selectAll("*").remove();
    if (typeof opts.close === "function") opts.close();
  });
  const collapseBtnDiv = header_row.append("div").attr("title", "Click to collapse or expand this chart sandbox").classed("sjpp-output-sandbox-collapse-btn", true);
  const expandBtnDiv = header_row.append("div").classed("sjpp-output-sandbox-expand-btn", true).style("display", "none");
  const header = header_row.append("div").attr("id", "sandbox-header-text").style("display", "inline-flex").style("align-items", "center").style("justify-content", "left").style("padding", "5px 10px");
  const body = app_div.append("div").attr("class", "sjpp-output-sandbox-content sjpp_show_scrollbar").style("width", opts.style?.width || "95vw");
  let isSandboxContentVisible = true;
  icons["collapse"](collapseBtnDiv, {
    fontSize: "1.5em",
    padding: "4px 10px",
    color: "black",
    handler: expandCollapse
  });
  icons["expand"](expandBtnDiv, {
    fontSize: "1.5em",
    padding: "4px 10px",
    color: "black",
    display: "none",
    handler: expandCollapse
  });
  collapseBtnDiv.on("mouseenter", () => {
    const path2 = collapseBtnDiv.select("path");
    path2.attr("stroke", hoverInColor);
  }).on("mouseleave", () => {
    const path2 = collapseBtnDiv.select("path");
    path2.attr("stroke", hoverOutColor);
  });
  expandBtnDiv.on("mouseenter", () => {
    const path2 = expandBtnDiv.select("path");
    path2.attr("stroke", hoverInColor);
  }).on("mouseleave", () => {
    const path2 = expandBtnDiv.select("path");
    path2.attr("stroke", hoverOutColor);
  });
  function expandCollapse() {
    isSandboxContentVisible = !isSandboxContentVisible;
    collapseBtnDiv.style("display", isSandboxContentVisible == true ? "inline-block" : "none");
    expandBtnDiv.style("display", isSandboxContentVisible == true ? "none" : "inline-block");
    body.style("display", isSandboxContentVisible == true ? "block" : "none");
  }
  return { header_row, header, body, app_div, id: sandboxId };
}

// dom/search.ts
var import_debounce3 = __toESM(require_debounce(), 1);
var InputSearch = class {
  constructor(opts) {
    this.holder = opts.holder;
    this.input = opts.holder.append("input").attr("type", "search");
    this.tip = opts.tip || new Menu({ border: "", padding: "0px" });
    this.style = opts.style || {};
    this.size = opts.size || 20;
    this.placeholder = opts.placeholder || "";
    this.title = opts.title || "";
    this.searchItems = opts.searchItems;
    this.app = opts.app;
  }
  initUI() {
    this.holder.style("padding", "padding" in this.style ? this.style.padding : "5px").style("display", "inline-block");
    this.input.attr("class", "sjpp-input-search").style("border", "border" in this.style ? this.style.border : "5px").attr("size", this.size).attr("placeholder", this.placeholder).attr("aria-label", this.title).on("keyup", async (event2) => {
      if (event2.key == "ArrowDown") {
        this.tip.d.select(".sja_menuoption").node()?.focus();
        return;
      }
      if (keyupEnter(event2)) await this.enterSearch();
      (0, import_debounce3.debounce)(this.addSearchItems(), 400);
    });
  }
  async addSearchItems() {
    if (!this.input.property("value").trim()) {
      this.tip.hide();
      return;
    }
    try {
      this.tip.clear().showunder(this.input.node());
      const resultsWrapper = this.tip.d.append("div");
      const results = await this.searchItems();
      await resultsWrapper.append("div").style("display", "flex").selectAll().data(results.filter((r) => r.items?.length >= 1)).enter().append("div").style("display", "block").style("border-left", "0.5px solid lightgrey").each(this.showResultsList);
    } catch (e) {
      if (e.stack) console.error(e.stack);
      else throwMsgWithFilePathAndFnName(e);
    }
  }
  async showResultsList(result) {
    result.wrapper = select_default(this);
    result.wrapper.style("padding", "5px");
    result.titleDiv = result.wrapper.append("span").style("padding", "3px 0px 5px").style("opacity", 0.65).style("font-size", "0.8em").text(result.title);
    await result.wrapper.append("div").classed("sjpp-result-wrapper", true).selectAll("div").data(result.items).enter().append("div").classed("sja_menuoption", true).classed("sjpp-search-result", true).attr(
      "data-testid",
      (d) => `sjpp-search-result-${(d.name || d.label || d.title || d).toString().toLowerCase().replace(/\s/g, "-")}`
    ).style("display", "block").style("padding-left", "10px").style("background-color", result.color || "").text((d) => d.name || d.label || d.title || d).on("click", (event2, item) => {
      event2.stopPropagation();
      result.callback(item);
    });
  }
  async enterSearch() {
    if (!this.input.property("value").trim()) return;
    const wrapper = this.tip.d.select(".sjpp-result-wrapper").node();
    const result = this.tip.d.select(".sjpp-search-result").node();
    if (result != null && result.__data__) wrapper.__data__.callback(result.__data__);
    else {
      const results = await this.searchItems();
      const defaultCallback = results.filter((d) => d.default);
      defaultCallback[0].callback(this.input.property("value"));
    }
    this.input.property("value", "");
    this.tip.hide();
  }
  updatePlaceholder(placeholder) {
    this.input.attr("placeholder", placeholder);
  }
};

// plots/AppBase.ts
var AppBase = class {
  // dom: any
  // config: any
  constructor(opts) {
    this.opts = this.validateOpts(opts);
    this.id = opts.id;
  }
  validateOpts(o = {}) {
    if (!o.holder) throw `missing opts.holder in the app constructor argument`;
    if (!o.callbacks) o.callbacks = {};
    if (o.state) {
      if (!o.state.vocab) o.state.vocab = {};
      if (typeof o.state.vocab != "object") throw "opts.state.vocab{} is not an object";
      if (o.state.genome) {
        o.state.vocab.genome = o.state.genome;
        delete o.state.genome;
      }
      if (o.state.dslabel) {
        o.state.vocab.dslabel = o.state.dslabel;
        delete o.state.dslabel;
      }
    }
    if (o.app) {
      for (const [k, v] of Object.entries(o.app)) {
        o[k] = v;
      }
      delete o.app;
    }
    return o;
  }
};

// termdb/tree.js
var childterm_indent = "25px";
var root_ID = "root";
var custom_variables_ID = "_Custom_Variables_";
var minTermCount2scroll = 20;
var scrollDivMaxHeight = "400px";
var cls_termdiv = "termdiv";
var cls_termchilddiv = "termchilddiv";
var cls_termbtn = "termbtn";
var cls_termlabel = "termlabel";
var cls_termloading = "termloading";
var cls_termcheck = "termcheck";
var TdbTree = class {
  static type = "tree";
  /*
  Termdb Tree Component
  - api-related and data processing code
    within this class declaration
  */
  constructor(opts) {
    this.type = "tree";
    setInteractivity(this);
    setRenderers2(this);
    this.loadingTermSet = /* @__PURE__ */ new Set();
    this.termsByCohort = {};
    this.expandAll = "expandAll" in opts ? opts.expandAll : false;
  }
  init() {
    this.dom = {
      holder: this.opts.holder.append("div")
    };
  }
  reactsTo(action) {
    if (action.type.startsWith("tree_")) return true;
    if (action.type.startsWith("filter_")) return true;
    if (action.type.startsWith("cohort_")) return true;
    if (action.type.startsWith("info_")) return true;
    if (action.type.startsWith("submenu_")) return true;
    if (action.type == "app_refresh") return true;
    if (action.type == "set_term_type_group") return true;
  }
  getState(appState) {
    const filter2 = getNormalRoot(appState.termfilter.filter);
    const state = {
      isVisible: !appState.submenu.term,
      activeCohort: appState.activeCohort,
      expandedTermIds: appState.tree.expandedTermIds,
      selectedTerms: appState.selectedTerms,
      termfilter: { filter: filter2 },
      usecase: appState.tree.usecase,
      termTypeGroup: appState.termTypeGroup
    };
    if (appState.termdbConfig.selectCohort) {
      state.toSelectCohort = true;
      const choice = appState.termdbConfig.selectCohort.values[appState.activeCohort];
      if (choice) {
        state.cohortValuelst = choice.keys;
      }
    }
    return state;
  }
  async main() {
    if (this.state.termTypeGroup != TermTypeGroups.DICTIONARY_VARIABLES) {
      this.dom.holder.style("display", "none");
      return;
    }
    if (!this.state.isVisible) {
      this.dom.holder.style("display", "none");
      return;
    }
    if (this.state.toSelectCohort) {
      if (!this.state.cohortValuelst) {
        return;
      }
    }
    this.termsById = this.getTermsById();
    const root = this.termsById[root_ID];
    root.terms = await this.requestTermRecursive(root);
    root.terms.push(...await this.mayGetCustomTerms());
    this.dom.holder.style("display", "block");
    await this.renderBranch(root, this.dom.holder);
    this.dom.holder.selectAll(".termbtn, .sja_tree_click_term").attr("tabindex", 0).attr("data-testid", "sjpp_termdbbutton").on("keyup", (event2) => {
      if (event2.key == "Enter") event2.target.click();
    });
  }
  getTermsById() {
    if (!(this.state.activeCohort in this.termsByCohort)) {
      this.termsByCohort[this.state.activeCohort] = {
        [root_ID]: {
          id: root_ID,
          __tree_isroot: true
          // must not delete this flag
        }
      };
    }
    return this.termsByCohort[this.state.activeCohort];
  }
  async requestTermRecursive(term) {
    const data = await this.app.vocabApi.getTermChildren(
      term,
      this.state.toSelectCohort ? this.state.cohortValuelst : null,
      this.state.termfilter.filter
    );
    if (data.error) throw data.error;
    if (!data.lst || data.lst.length == 0) {
      return [];
    }
    const terms = [];
    for (const t2 of data.lst) {
      const copy = Object.assign({}, t2);
      terms.push(copy);
      if (this.state.expandedTermIds.includes(copy.id)) {
        copy.terms = await this.requestTermRecursive(copy);
      } else {
        const t0 = this.termsById[copy.id || copy.name];
        if (t0 && t0.terms) {
          copy.terms = t0.terms;
        }
      }
      this.termsById[copy.id || copy.name] = copy;
    }
    return terms;
  }
  bindKey(term) {
    return term.id || term.name;
  }
  async mayGetCustomTerms() {
    const tws = await this.app.vocabApi.getCustomTerms();
    if (!tws.length) return [];
    const id3 = custom_variables_ID;
    const parentTerm = {
      name: "Custom Variables",
      id: id3,
      isleaf: false,
      included_types: ["categorical"],
      child_types: ["categorical"],
      terms: tws.map((tw) => {
        this.termsById[tw.term.id || tw.term.name] = tw.term;
        tw.term.isleaf = true;
        return tw.term;
      })
    };
    this.termsById[id3] = parentTerm;
    return [parentTerm];
  }
};
var treeInit = getCompInit(TdbTree);
function setRenderers2(self2) {
  self2.renderBranch = (term, div, button) => {
    if (!term || !term.terms) return;
    if (term.terms.length >= minTermCount2scroll) {
      if (div.classed("sjpp_show_scrollbar")) {
      } else {
        div.style("max-height", scrollDivMaxHeight).style("padding", "10px").style("resize", "vertical").classed("sjpp_show_scrollbar", true);
      }
    }
    if (self2.opts.disable_terms) {
      term.terms.forEach((t2) => {
        if (t2.disabled) self2.opts.disable_terms.push(t2);
      });
    }
    self2.included_terms = [];
    if (self2.state.usecase) {
      for (const t2 of term.terms) {
        const uses = isUsableTerm(t2, self2.state.usecase, self2.app.vocabApi.termdbConfig);
        if (uses && uses.size) {
          self2.included_terms.push(t2);
        }
      }
    } else {
      self2.included_terms.push(...term.terms);
    }
    const id3 = term.id || term.name;
    if (!(id3 in self2.termsById) || !self2.included_terms.length) {
      div.style("display", "none");
      return;
    }
    if (self2.loadingTermSet.has(term.id)) {
      self2.loadingTermSet.delete(term.id);
      div.select("." + cls_termloading).remove();
    }
    const expandedTermIds = self2.state.expandedTermIds;
    if (!expandedTermIds.includes(term.id)) {
      div.style("display", "none");
      if (button) button.text("+");
      return;
    }
    div.style("display", "block");
    if (button) button.text("-");
    const divs = div.selectAll("." + cls_termdiv).data(self2.included_terms, self2.bindKey);
    divs.exit().each(self2.hideTerm);
    divs.each(self2.updateTerm);
    divs.enter().append("div").each(self2.addTerm);
    for (const child of term.terms) {
      if (expandedTermIds.includes(child.id)) {
        self2.renderBranch(
          child,
          div.selectAll("." + cls_termchilddiv).filter((i3) => i3.id == child.id),
          div.selectAll("." + cls_termbtn).filter((i3) => i3.id == child.id)
        );
      }
    }
  };
  self2.hideTerm = function(term) {
    const id3 = term.id || term.name;
    if (id3 in self2.termsById && self2.state.expandedTermIds.includes(term.id)) return;
    select_default(this).style("display", "none");
  };
  self2.updateTerm = function(term) {
    const div = select_default(this);
    const id3 = term.id || term.name;
    if (!(id3 in self2.termsById)) {
      div.style("display", "none");
      return;
    }
    const termIsDisabled = self2.opts?.disable_terms?.some((t2) => equals(t2, term));
    const uses = isUsableTerm(term, self2.state.usecase, self2.app.vocabApi.termdbConfig);
    div.style("display", "");
    const isExpanded = self2.state.expandedTermIds.includes(term.id);
    div.select("." + cls_termbtn).text(isExpanded ? "-" : "+");
    div.select("." + cls_termchilddiv).style("display", isExpanded ? "block" : "none");
    const tid = term.id || term.name;
    const isSelected = self2.state.selectedTerms.find((t2) => (t2.id ? t2.id === id3 : t2.name == id3) && t2.type === term.type);
    div.select("." + cls_termlabel).style(
      "background-color",
      !uses.has("plot") || termIsDisabled ? "" : isSelected ? "rgba(255, 194, 10,0.5)" : "#cfe2f3"
    );
    div.select("." + cls_termcheck).style("display", uses.has("plot") && isSelected && !termIsDisabled ? "inline-block" : "none");
  };
  self2.addTerm = async function(term) {
    const termIsDisabled = self2.opts?.disable_terms?.some((t2) => equals(t2, term));
    const uses = isUsableTerm(term, self2.state.usecase, self2.app.vocabApi.termdbConfig);
    const div = select_default(this).attr("class", cls_termdiv).style("margin", term.isleaf ? "" : "2px").style("padding", "0px 5px");
    if (uses.has("branch")) {
      div.append("div").attr("class", "sja_menuoption " + cls_termbtn).style("display", "inline-block").style("padding", "4px 9px").style("font-family", "courier").text("+").on("click", (event2) => {
        event2.stopPropagation();
        self2.toggleBranch(term);
      });
      if (self2.expandAll) self2.toggleBranch(term);
    }
    const id3 = term.id || term.name;
    const isSelected = self2.state.selectedTerms.find((t2) => t2.id === id3 && t2.type === term.type);
    const labeldiv = div.append("div").attr("class", cls_termlabel).style("display", "inline-block").style("padding", "5px").style("opacity", termIsDisabled ? 0.4 : null).text(term.name);
    let infoIcon_div;
    if (term.hashtmldetail) {
      infoIcon_div = div.append("div").style("display", "inline-block");
    }
    if (uses.size > 0) {
      if (termIsDisabled) {
        labeldiv.attr("class", "sja_tree_click_term_disabled " + cls_termlabel).style("padding", "5px 8px").style("margin", "1px 0px").style("opacity", 0.7);
      } else if (uses.has("plot")) {
        labeldiv.attr("class", "ts_pill sja_filter_tag_btn sja_tree_click_term " + cls_termlabel).style("color", "black").style("padding", "5px 8px").style("border-radius", "6px").style("background-color", isSelected ? "rgba(255, 194, 10,0.5)" : "#cfe2f3").style("margin", "1px 0px").style("cursor", "default").on("click", () => self2.clickTerm(term));
      }
      if (term.samplecount !== void 0) {
        div.append("div").style("font-size", ".8em").style("display", "inline-block").style("margin-left", "5px").style("color", term.samplecount ? "#777" : "#ddd").text("n=" + term.samplecount);
      }
    }
    if (term.hashtmldetail) {
      termInfoInit({
        vocabApi: self2.app.vocabApi,
        icon_holder: infoIcon_div,
        content_holder: div.append("div"),
        id: term.id,
        state: { term }
      });
    }
    let selected_checkbox;
    if (self2.opts.submit_lst) {
      selected_checkbox = div.append("div").attr("class", cls_termcheck).style("color", "#008000").style("display", isSelected ? "inline-block" : "none").html("&check;");
    }
    if (!term.isleaf) {
      div.append("div").attr("class", cls_termchilddiv).style("padding-left", childterm_indent);
    }
  };
}
function setInteractivity(self2) {
  self2.toggleBranch = function(term) {
    if (term.isleaf) return;
    const t0 = self2.termsById[term.id || term.name];
    if (!t0) throw "invalid term id";
    if (!t0.terms) {
      if (self2.loadingTermSet.has(t0.id)) return;
      self2.loadingTermSet.add(t0.id);
      select_default(this.parentNode).selectAll("." + cls_termchilddiv).filter((d) => d.id === t0.id).style("display", "block").append("div").text("Loading...").attr("class", cls_termloading).style("opacity", 0.5).style("padding", "5px");
    }
    const expanded = self2.state.expandedTermIds.includes(term.id);
    const type = expanded ? "tree_collapse" : "tree_expand";
    self2.app.dispatch({ type, termId: term.id });
  };
  self2.clickTerm = async (term) => {
    if (self2.opts.click_term2select_tvs) {
      self2.app.dispatch({ type: "submenu_set", submenu: { term, type: "tvs" } });
      return;
    }
    if (self2.opts.click_term_wrapper) {
      self2.opts.click_term_wrapper(term);
      return;
    }
    if (self2.opts.submit_lst) {
      const id3 = term.id || term.name;
      const i3 = self2.state.selectedTerms.findIndex((t2) => (t2.id ? t2.id === id3 : t2.name == id3) && t2.type === term.type);
      if (i3 == -1) {
        self2.app.dispatch({
          type: "app_refresh",
          state: {
            selectedTerms: [...self2.state.selectedTerms, term]
          }
        });
      } else {
        const selectedTerms = self2.state.selectedTerms.slice(0);
        selectedTerms.splice(i3, 1);
        self2.app.dispatch({
          type: "app_refresh",
          state: { selectedTerms }
        });
      }
      return;
    }
    throw "missing term click callback";
  };
}

// import("./handlers/**/*.ts") in termdb/TermTypeSearch.ts
var globImport_handlers_ts = __glob({
  "./handlers/cohort.ts": () => import("./cohort-ZLQA2KPW.js"),
  "./handlers/dnaMethylation.ts": () => import("./dnaMethylation-2627GIZW.js"),
  "./handlers/geneExpression.ts": () => import("./geneExpression-CNBSE3KW.js"),
  "./handlers/geneVariant.ts": () => import("./geneVariant-Y7GASAY6.js"),
  "./handlers/isoformExpression.ts": () => import("./isoformExpression-XWLMWXEK.js"),
  "./handlers/junction.customTerm.ts": () => import("./junction.customTerm-FRYWSS4P.js"),
  "./handlers/junction.ts": () => import("./junction-AUXJROOE.js"),
  "./handlers/proteomeAbundance.ts": () => import("./proteomeAbundance-CA6XBPNA.js"),
  "./handlers/pseudobulk.ts": () => import("./pseudobulk-Y7HWDLIV.js"),
  "./handlers/rememberedGvQ.ts": () => import("./rememberedGvQ-PAXCLMTI.js"),
  "./handlers/singleCellCellType.ts": () => import("./singleCellCellType-35TDG2YM.js"),
  "./handlers/singleCellGeneExpression.ts": () => import("./singleCellGeneExpression-7AHJYFWJ.js"),
  "./handlers/snp.ts": () => import("./snp-OXDVSFGB.js"),
  "./handlers/snplocus.ts": () => import("./snplocus-6EOYR4JT.js"),
  "./handlers/snplst.ts": () => import("./snplst-C7QTB474.js"),
  "./handlers/ssGSEA.ts": () => import("./ssGSEA-OYEIDW4M.js"),
  "./handlers/termCollection.ts": () => import("./termCollection-QDGR6J36.js"),
  "./handlers/termCollectionFractionSelection.ts": () => import("./termCollectionFractionSelection-2O32HROA.js"),
  "./handlers/test/dnaMethylation.integration.spec.ts": () => import("./dnaMethylation.integration.spec-HSZKXED3.js"),
  "./handlers/test/geneExpression.unit.spec.ts": () => import("./geneExpression.unit.spec-SCBRU5BG.js"),
  "./handlers/test/geneVariant.integration.spec.ts": () => import("./geneVariant.integration.spec-2ATUV7NH.js"),
  "./handlers/test/isoformExpression.unit.spec.ts": () => import("./isoformExpression.unit.spec-T7VN2WPK.js"),
  "./handlers/test/junction.unit.spec.ts": () => import("./junction.unit.spec-ODVQMDI5.js"),
  "./handlers/test/pseudbulk.unit.spec.ts": () => import("./pseudbulk.unit.spec-JJ2I4KPM.js"),
  "./handlers/test/rememberedGvQ.unit.spec.ts": () => import("./rememberedGvQ.unit.spec-N43O4YTF.js"),
  "./handlers/test/singleCellCellType.unit.spec.ts": () => import("./singleCellCellType.unit.spec-G5AVNAUK.js"),
  "./handlers/test/singleCellGeneExpression.unit.spec.ts": () => import("./singleCellGeneExpression.unit.spec-LGZMOVTB.js"),
  "./handlers/test/snp.unit.spec.ts": () => import("./snp.unit.spec-B7LCCGWA.js"),
  "./handlers/test/ssGSEA.unit.spec.ts": () => import("./ssGSEA.unit.spec-SY5XFF45.js"),
  "./handlers/test/termCollection.unit.spec.ts": () => import("./termCollection.unit.spec-PQMFOWLF.js"),
  "./handlers/test/termCollectionFractionSelection.unit.spec.ts": () => import("./termCollectionFractionSelection.unit.spec-WXGCO2RF.js")
});

// termdb/TermTypeSearch.ts
var {
  SNP_LOCUS,
  SNP_LIST,
  SINGLECELL_CELLTYPE: SINGLECELL_CELLTYPE2,
  SINGLECELL_GENE_EXPRESSION: SINGLECELL_GENE_EXPRESSION2,
  TERM_COLLECTION: TERM_COLLECTION2,
  MUTATION_CNV_FUSION,
  METABOLITE_INTENSITY: METABOLITE_INTENSITY2,
  DICTIONARY_VARIABLES,
  GENE_EXPRESSION: GENE_EXPRESSION2,
  ISOFORM_EXPRESSION: ISOFORM_EXPRESSION2,
  DNA_METHYLATION: DNA_METHYLATION2,
  PROTEOME_ABUNDANCE: PROTEOME_ABUNDANCE2,
  PSEUDOBULK: PSEUDOBULK2,
  SSGSEA: SSGSEA2,
  COHORT
} = TermTypeGroups;
var useCasesExcluded = {
  matrix: [SNP_LOCUS, SNP_LIST, SINGLECELL_CELLTYPE2, SINGLECELL_GENE_EXPRESSION2, COHORT],
  facet: [SNP_LOCUS, SNP_LIST, SINGLECELL_CELLTYPE2, SINGLECELL_GENE_EXPRESSION2, COHORT],
  filter: [SNP_LOCUS, SNP_LIST],
  dictionary: [SNP_LOCUS, SNP_LIST, COHORT],
  summary: [SNP_LOCUS, SNP_LIST, TERM_COLLECTION2, COHORT],
  summaryInput: [SNP_LOCUS, SNP_LIST, TERM_COLLECTION2, SINGLECELL_CELLTYPE2, SINGLECELL_GENE_EXPRESSION2, COHORT],
  barchart: [SNP_LOCUS, SNP_LIST, TERM_COLLECTION2, COHORT],
  violin: [SNP_LOCUS, SNP_LIST, TERM_COLLECTION2, COHORT],
  sampleScatter: [SNP_LOCUS, SNP_LIST, TERM_COLLECTION2, COHORT],
  cuminc: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    METABOLITE_INTENSITY2,
    ISOFORM_EXPRESSION2,
    PROTEOME_ABUNDANCE2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    COHORT
  ],
  dataDownload: [
    //SNP_LOCUS, //this tabs require that the handler for this term type to be implemented
    //SNP_LIST, //this tabs require that the handler for this term type to be implemented
    MUTATION_CNV_FUSION,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    COHORT
  ],
  //Later on can support other term types like snplocus, snplst, geneVariant, non dictionary terms
  survival: [SNP_LOCUS, SNP_LIST, TERM_COLLECTION2, SINGLECELL_CELLTYPE2, SINGLECELL_GENE_EXPRESSION2, COHORT],
  //Used from the termsetting when searching for a term, as any term with categories is allowed
  default: [SNP_LOCUS, SNP_LIST, TERM_COLLECTION2, SINGLECELL_CELLTYPE2, SINGLECELL_GENE_EXPRESSION2, COHORT],
  regression: [SNP_LIST, SNP_LOCUS, TERM_COLLECTION2, SINGLECELL_CELLTYPE2, SINGLECELL_GENE_EXPRESSION2, COHORT],
  metaboliteIntensity: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    DICTIONARY_VARIABLES,
    GENE_EXPRESSION2,
    ISOFORM_EXPRESSION2,
    DNA_METHYLATION2,
    PROTEOME_ABUNDANCE2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    PSEUDOBULK2,
    COHORT
  ],
  proteomeAbundance: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    DICTIONARY_VARIABLES,
    GENE_EXPRESSION2,
    ISOFORM_EXPRESSION2,
    DNA_METHYLATION2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    METABOLITE_INTENSITY2,
    PSEUDOBULK2,
    COHORT
  ],
  proteinView: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    DICTIONARY_VARIABLES,
    GENE_EXPRESSION2,
    ISOFORM_EXPRESSION2,
    DNA_METHYLATION2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    METABOLITE_INTENSITY2,
    PSEUDOBULK2,
    COHORT
  ],
  geneExpression: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    DICTIONARY_VARIABLES,
    ISOFORM_EXPRESSION2,
    METABOLITE_INTENSITY2,
    PROTEOME_ABUNDANCE2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    COHORT
  ],
  isoformExpression: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    DICTIONARY_VARIABLES,
    GENE_EXPRESSION2,
    METABOLITE_INTENSITY2,
    PROTEOME_ABUNDANCE2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    COHORT
  ],
  correlationVolcano: [SNP_LOCUS, SNP_LIST, MUTATION_CNV_FUSION, TERM_COLLECTION2, COHORT],
  numericDictTermCluster: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    GENE_EXPRESSION2,
    METABOLITE_INTENSITY2,
    PROTEOME_ABUNDANCE2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    DNA_METHYLATION2,
    COHORT
  ],
  termCollections: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    GENE_EXPRESSION2,
    ISOFORM_EXPRESSION2,
    DNA_METHYLATION2,
    METABOLITE_INTENSITY2,
    PROTEOME_ABUNDANCE2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    COHORT
  ],
  runChart2: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    GENE_EXPRESSION2,
    ISOFORM_EXPRESSION2,
    DNA_METHYLATION2,
    METABOLITE_INTENSITY2,
    PROTEOME_ABUNDANCE2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    COHORT
  ],
  aggregateMatrix: [
    SNP_LOCUS,
    SNP_LIST,
    MUTATION_CNV_FUSION,
    ISOFORM_EXPRESSION2,
    DNA_METHYLATION2,
    METABOLITE_INTENSITY2,
    PROTEOME_ABUNDANCE2,
    SSGSEA2,
    TERM_COLLECTION2,
    SINGLECELL_CELLTYPE2,
    SINGLECELL_GENE_EXPRESSION2,
    COHORT
  ]
};
var TermTypeSearch = class _TermTypeSearch {
  constructor(opts) {
    this.refreshActiveHandler = false;
    this.type = _TermTypeSearch.type;
    this.genomeObj = opts.genome;
    this.click_term = opts.click_term;
    this.submit_lst = opts.submit_lst;
    this.termCollectionSelectionMode = opts.termCollectionSelectionMode;
    const selectedTermsDiv = opts.topbar.append("div").style("width", "99%").style("display", "flex").style("flex-wrap", "wrap").style("gap", "5px").style("min-height", "20px").style("margin", "10px 0px").style("padding", "6px 2px");
    this.types = [];
    this.tabs = [];
    this.handlerByType = {};
    this.dom = { holder: opts.holder, topbar: opts.topbar, selectedTermsDiv, submitDiv: opts.submitDiv };
    this.useCasesExcluded = structuredClone(useCasesExcluded);
  }
  static {
    this.type = "termTypeSearch";
  }
  async init(appState) {
    this.types = appState.allowedTermTypes || this.app.vocabApi.termdbConfig?.allowedTermTypes || ["categorical"];
    if (!this.types) return;
    if (this.app.vocabApi.termdbConfig?.useCasesExcluded)
      Object.assign(this.useCasesExcluded, this.app.vocabApi.termdbConfig?.useCasesExcluded);
    const tabs = getAllowedTabs(appState, this);
    for (const tab of tabs) {
      try {
        if (!this.usesDefaultSearch(tab.termTypeGroup)) {
          const _ = await globImport_handlers_ts(`./handlers/${tab.termType}.ts`);
          this.handlerByType[tab.termType] = await new _.SearchHandler();
          if (!this.handlerByType[tab.termType].init) throw new Error("init not implemented");
        }
        this.addLoadTopTerms(tab.termType);
      } catch (e) {
        throw new Error(`error with handler='./handlers/${tab.termType}.ts': ${e}`);
      }
      this.tabs.push(tab);
    }
    if (this.submit_lst) {
      this.dom.clearbt = this.dom.submitDiv.append("button").style("margin-left", "5px").text("Clear").on("click", () => this.selectTerms([]));
    }
    if (this.tabs.length == 0) throw "No term types allowed for this use case";
    if (this.tabs.length == 1) return;
    new Tabs({
      holder: this.dom.holder,
      tabsPosition: "vertical",
      linePosition: "right",
      tabs: this.tabs
    }).main();
    for (const t2 of this.tabs) {
      const holder = t2.contentHolder.style("padding-left", "20px");
      holder.append("div");
    }
  }
  reactsTo(action) {
    if (action.type.startsWith("submenu_")) return true;
    if (action.type == "set_term_type_group") return true;
    if (action.type == "app_refresh") {
      if (this.activeHandler?.type === TermTypes.JUNCTION) this.refreshActiveHandler = true;
      return true;
    }
  }
  async main() {
    this.dom.holder.style("display", this.state.isVisible ? "inline-block" : "none");
    this.dom.topbar.style("display", this.state.isVisible ? "inline-block" : "none");
    if (this.submit_lst) {
      this.dom.selectedTermsDiv.style("display", this.state.selectedTerms.length > 0 ? "flex" : "none");
    } else this.dom.selectedTermsDiv.style("display", "none");
    this.renderTermsSelected();
    if (this.dom.clearbt) this.dom.clearbt.property("disabled", this.state.selectedTerms.length == 0);
    if (this.refreshActiveHandler) {
      this.refreshActiveHandler = false;
      await this.initActiveHandler();
    }
  }
  renderTermsSelected() {
    this.dom.selectedTermsDiv.selectAll("*").remove();
    this.dom.selectedTermsDiv.selectAll("div").data(this.state.selectedTerms).enter().append("div").attr("aria-label", "Click to delete").attr("class", "sja_menuoption").attr("tabindex", 0).style("position", "relative").style("display", "inline-block").style("padding", "5px 16px 5px 9px").style("margin-left", "5px").each(renderTerm).on("click", (e, t2) => this.deleteTerm(e, t2)).on("mouseover", function(event2) {
      const deleteSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#000" class="bi bi-x-lg" viewBox="0 0 16 16">
				<path stroke='#f00' d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
				</svg>`;
      const div = select_default(event2.target);
      div.append("div").style("margin-left", "4px").classed("sjpp_deletebt", true).style("display", "inline-block").style("position", "absolute").style("right", "0px").style("top", "0px").style("transform", "scale(0.6)").style("pointer-events", "none").html(deleteSvg);
    }).on("mouseout", function(event2) {
      select_default(event2.target).select(".sjpp_deletebt").remove();
    });
    function renderTerm(term) {
      const div = select_default(this).style("border-radius", "5px");
      div.insert("div").style("display", "inline-block").html(term.gene || term.name);
    }
  }
  deleteTerm(e, t2) {
    const i3 = this.state.selectedTerms.findIndex((term) => term.name === t2.name);
    if (i3 != -1) {
      const selectedTerms = [...this.state.selectedTerms];
      selectedTerms.splice(i3, 1);
      this.app.dispatch({
        type: "app_refresh",
        state: { selectedTerms }
      });
    }
  }
  getState(appState) {
    return {
      dslabel: appState.dslabel,
      termTypeGroup: appState.termTypeGroup,
      //See comment in store for usage
      usecase: appState.tree.usecase,
      isVisible: !appState.submenu.term,
      selectedTerms: appState.selectedTerms,
      termfilter: appState.termfilter,
      customTerms: appState.customTerms
    };
  }
  usesDefaultSearch(termTypeGroup) {
    return termTypeGroup == DICTIONARY_VARIABLES || termTypeGroup == METABOLITE_INTENSITY2;
  }
  async addLoadTopTerms(type) {
    if (type == TermTypes.METABOLITE_INTENSITY)
      this.dom.submitDiv.append("button").style("margin-left", "5px").text("Load top terms").on("click", async () => {
        const args = {
          filter0: this.state.termfilter.filter0,
          filter: this.state.termfilter.filter,
          type
        };
        const result = await this.app.vocabApi.getTopTermsByType(args);
        this.selectTerms(result.terms);
      });
  }
  async selectTerms(terms) {
    await this.app.dispatch({
      type: "app_refresh",
      state: {
        selectedTerms: terms
      }
    });
  }
  async setTermTypeGroup(type, termTypeGroup, details = {}) {
    await this.app.dispatch({ type: "set_term_type_group", value: termTypeGroup });
    const tab = this.tabs.find((tab2) => tab2.termTypeGroup == termTypeGroup);
    if (!tab) return;
    const holder = tab.contentHolder;
    holder.selectAll("*").remove();
    if (tab.termTypeGroup != DICTIONARY_VARIABLES && tab.termTypeGroup != METABOLITE_INTENSITY2) {
      this.activeHandler = { type, holder, details };
      await this.initActiveHandler();
    }
  }
  async initActiveHandler() {
    if (!this.activeHandler) return;
    const { type, holder, details } = this.activeHandler;
    holder.selectAll("*").remove();
    const { usecase } = this.state?.usecase ? this.state : this.getState(this.app.getState());
    await this.handlerByType[type].init({
      holder,
      app: this.app,
      genomeObj: this.genomeObj,
      callback: (term) => this.selectTerm(term),
      details,
      usecase,
      termCollectionSelectionMode: this.termCollectionSelectionMode,
      /* whether the q of the selected term reaches the consumer, so that a handler does
      not offer a q that would be dropped on the way. Only click_term takes a whole tw,
      see selectTerm() below: submit_lst keeps just the term, and the tvs path requires a
      predefined groupset, see getDtTerm() */
      keepsQ: !!this.click_term
    });
  }
  //This callback will be called by the handlers when a term is selected
  selectTerm(term) {
    if (this.click_term) this.click_term(term);
    else if (this.submit_lst) {
      const t2 = term.term || term;
      if (term.type == TermTypes.TERM_COLLECTION) {
        this.app.dispatch({
          type: "app_refresh",
          state: {
            selectedTerms: [t2]
          }
        });
      } else {
        this.app.dispatch({
          type: "app_refresh",
          state: {
            selectedTerms: [...this.state.selectedTerms, t2]
          }
        });
      }
    } else {
      this.app.dispatch({
        type: "submenu_set",
        submenu: {
          type: "tvs",
          term: term.term?.type == "geneVariant" ? this.getDtTerm(term) : term
        }
      });
    }
  }
  // get child dt term from geneVariant term to use for tvs
  getDtTerm(tw) {
    if (tw.term.type != "geneVariant") throw "term.type is not geneVariant";
    if (tw.q.type != "predefined-groupset") throw "q.type must be predefined-groupset";
    const dtTerm = tw.term.childTerms[tw.q.predefined_groupset_idx];
    if (!dtTerm) throw "dtTerm not found";
    return dtTerm;
  }
};
var TermTypeSearchInit = getCompInit(TermTypeSearch);
function allowsCollectionFraction(selectionMode, vocabApi) {
  if (selectionMode != "fraction") return false;
  return vocabApi?.termdbConfig?.termCollections?.some((c) => c.type == "numeric") === true;
}
function isFractionOnlyUseCase(target, self2) {
  if (!target || !allowsCollectionFraction(self2.termCollectionSelectionMode, self2.app?.vocabApi)) return false;
  return self2.useCasesExcluded[target]?.includes(TERM_COLLECTION2) === true;
}
function getAllowedTabs(state, self2) {
  const tabs = [];
  const allowedTermTypes = state.allowedTermTypes || self2.types;
  for (const type of allowedTermTypes) {
    const termTypeGroup = typeGroup[type];
    if (tabs.some((tab) => tab.termTypeGroup == termTypeGroup)) {
      continue;
    }
    if (type == TermTypes.TERM_COLLECTION) {
      const collections = self2.app.vocabApi?.termdbConfig?.termCollections;
      if (!collections) throw new Error("termdbConfig.termCollections missing");
      const fractionOnly = isFractionOnlyUseCase(state.tree.usecase?.target, self2);
      for (const c of collections) {
        if (c.type != "categorical" && c.type != "numeric") throw new Error("tc.type not categorical/numeric");
        if (fractionOnly && c.type != "numeric") continue;
        switch (state.tree.usecase?.target) {
          case "dictionary":
          case "filter":
          case "matrix":
          case "facet":
            if (c.type == "categorical") continue;
            break;
          default:
            break;
        }
        tabs.push({
          label: c.name,
          termType: type,
          termTypeGroup,
          callback: () => self2.setTermTypeGroup(type, termTypeGroup, c)
        });
      }
    } else {
      let label = termTypeGroup;
      if (type == TermTypes.GENE_VARIANT) {
        const labels = [];
        if (self2.app.vocabApi.termdbConfig.queries.snvindel) labels.push("Mutation");
        if (self2.app.vocabApi.termdbConfig.queries.cnv) labels.push("CNV");
        if (self2.app.vocabApi.termdbConfig.queries.svfusion) labels.push("Fusion");
        if (labels.length == 0) continue;
        label = labels.join("/");
      }
      tabs.push({
        label,
        termType: type,
        termTypeGroup,
        callback: () => self2.setTermTypeGroup(type, termTypeGroup)
      });
    }
  }
  return tabs;
}
function getAllowedTermTypesForUseCase(state, app) {
  const allowedTermTypes = [];
  const types2 = app.vocabApi.termdbConfig?.allowedTermTypes || ["categorical"];
  const usecase = state.tree.usecase;
  const { target, detail } = usecase;
  const dsUseCasesExcluded = Object.assign(
    structuredClone(useCasesExcluded),
    app.vocabApi.termdbConfig?.useCasesExcluded || {}
  );
  for (const type of types2) {
    if (type == TermTypes.SNP_LIST || type == TermTypes.SNP_LOCUS) {
      continue;
    }
    const termTypeGroup = typeGroup[type];
    if (!termTypeGroup) {
      throw new Error(`should not happen: no group for a term type = ${type}`);
    }
    if (usecase?.specialCase?.type == "singleCell") {
      if (!isSingleCellTerm({ type }) && !usecase.specialCase?.isMeta) continue;
    } else {
      if (isSingleCellTerm({ type })) continue;
    }
    if (type == TermTypes.TERM_COLLECTION && allowsCollectionFraction(app.opts?.tree?.termCollectionSelectionMode, app.vocabApi)) {
      allowedTermTypes.push(type);
      continue;
    }
    if (target && dsUseCasesExcluded[target]?.includes(termTypeGroup)) continue;
    if (target == "regression") {
      if (type == TermTypes.SNP) continue;
      if (detail != "independent" && isNonDictionaryType(type)) continue;
    }
    if (target == "sampleScatter") {
      if (detail == "numeric" && !numericTypes.has(type)) continue;
    }
    if ((target == "survival" || target == "cuminc") && termTypeGroup != DICTIONARY_VARIABLES) {
      if (detail == "term") continue;
    }
    if (target == "dataDownload") {
      if (type == TermTypes.SNP) continue;
    }
    allowedTermTypes.push(type);
  }
  return allowedTermTypes;
}

// termdb/store.ts
var defaultState = {
  header_mode: "search_only",
  // will be ignored if there is no dataset termdb.selectCohort
  // or value will be set to match a filter node that has been tagged
  // as 'cohortfilter' in state.termfilter.filter
  activeCohort: 0,
  tree: {
    usecase: {},
    expandedTermIds: []
  },
  submenu: {
    // type: 'tvs', may add other types later
    // term: {} or undefined
  },
  search: { isVisible: true },
  selectedTerms: [],
  termfilter: {
    filter: {
      type: "tvslst",
      in: true,
      join: "",
      lst: []
    }
  }
};
var TdbStore = class extends StoreBase {
  constructor(opts, api) {
    super(opts);
    this.defaultState = defaultState;
    this.useCasesExcluded = structuredClone(useCasesExcluded);
    this.type = "store";
    this.app = opts.app;
    this.api = api;
    this.state = this.copyMerge(this.toJson(defaultState), opts.state);
    this.prevGeneratedId = 0;
  }
  static {
    this.type = "store";
  }
  validateOpts(opts) {
    if (!opts.state) throw ".state{} missing";
    const s = opts.state;
    if (s.vocab) {
      if (s.vocab.dslabel) {
        if (!s.vocab.genome) throw ".state[.vocab].genome missing";
      } else if (s.vocab.genome) {
        if (!s.vocab.dslabel) throw ".state[.vocab].dslabel missing";
      } else {
        if (!Array.isArray(s.vocab.terms)) throw "vocab.terms must be an array of objects";
      }
    }
    return opts;
  }
  validateState() {
    const s = this.state;
    if (s.tree.expandedTermIds.length == 0) {
      s.tree.expandedTermIds.push(root_ID, custom_variables_ID);
    } else {
      if (s.tree.expandedTermIds[0] != root_ID) {
        s.tree.expandedTermIds.unshift(root_ID);
      }
    }
  }
  async init() {
    this.state.termdbConfig = await this.app.vocabApi.getTermdbConfig();
    this.state.allowedTermTypes = getAllowedTermTypesForUseCase(this.state, this.app);
    this.state.termTypeGroup = typeGroup[this.state.allowedTermTypes[0]];
    let filterUiRoot = getFilterItemByTag(this.state.termfilter.filter, "filterUiRoot");
    if (!filterUiRoot) {
      this.state.termfilter.filter.tag = "filterUiRoot";
      filterUiRoot = this.state.termfilter.filter;
    }
    if (this.state.termdbConfig.selectCohort) {
      let cohortFilter = getFilterItemByTag(this.state.termfilter.filter, "cohortFilter");
      if (!cohortFilter) {
        cohortFilter = {
          tag: "cohortFilter",
          type: "tvs",
          tvs: {
            term: JSON.parse(JSON.stringify(this.state.termdbConfig.selectCohort.term)),
            values: this.state.activeCohort == -1 ? [] : this.state.termdbConfig.selectCohort.values[this.state.activeCohort].keys.map((key) => {
              return { key, label: key };
            })
          }
        };
        this.state.termfilter.filter = {
          type: "tvslst",
          in: true,
          join: "and",
          lst: [cohortFilter, filterUiRoot]
        };
      } else {
        const sorter = (a, b) => a < b ? -1 : 1;
        cohortFilter.tvs.values.sort((a, b) => a.key < b.key ? -1 : 1);
        const keysStr = JSON.stringify(cohortFilter.tvs.values.map((v) => v.key).sort(sorter));
        const i3 = this.state.termdbConfig.selectCohort.values.findIndex(
          (v) => keysStr == JSON.stringify(v.keys.sort(sorter))
        );
        if (this.state.activeCohort !== -1 && this.state.activeCohort !== 0 && i3 !== this.state.activeCohort) {
          console.log("Warning: cohortFilter will override the state.activeCohort due to mismatch");
        }
        this.state.activeCohort = i3;
      }
    } else {
      this.state.activeCohort = -1;
      if (this.state.header_mode === "with_cohortHtmlSelect") {
        console.warn(`no termdbConfig.selectCohort to use for state.header_mode = 'with_cohortHtmlSelect'`);
        this.state.header_mode = "search_only";
      }
    }
  }
  setId(item) {
    item.$id = this.prevGeneratedId++;
    if (item.$lst) {
      for (const subitem of item.$lst) {
        this.setId(subitem);
      }
    }
  }
};
TdbStore.prototype.actions = {
  app_refresh(action) {
    this.state = this.copyMerge(this.toJson(this.state), action.state ? action.state : {});
  },
  cohort_set(action) {
    this.state.activeCohort = action.activeCohort;
    const cohort = this.state.termdbConfig.selectCohort.values[action.activeCohort];
    const cohortFilter = getFilterItemByTag(this.state.termfilter.filter, "cohortFilter");
    if (!cohortFilter) throw `No item tagged with 'cohortFilter'`;
    cohortFilter.tvs.values = cohort.keys.map((key) => {
      return { key, label: key };
    });
  },
  tree_expand(action) {
    if (this.state.tree.expandedTermIds.includes(action.termId)) return;
    this.state.tree.expandedTermIds.push(action.termId);
  },
  tree_collapse(action) {
    const i3 = this.state.tree.expandedTermIds.indexOf(action.termId);
    if (i3 == -1) return;
    this.state.tree.expandedTermIds.splice(i3, 1);
  },
  filter_replace(action) {
    const replacementFilter = action.filter ? action.filter : { type: "tvslst", join: "", in: 1, lst: [] };
    if (!action.filter.tag) {
      this.state.termfilter.filter = replacementFilter;
    } else {
      const filter2 = getFilterItemByTag(this.state.termfilter.filter, action.filter.tag);
      if (!filter2) throw `cannot replace missing filter with tag '${action.filter.tag}'`;
      const parent = findParent(this.state.termfilter.filter, filter2.$id);
      if (parent == filter2) {
        this.state.termfilter.filter = replacementFilter;
      } else {
        const i3 = parent.lst.indexOf(filter2);
        parent.lst[i3] = replacementFilter;
      }
    }
  },
  submenu_set(action) {
    const term = action.submenu && action.submenu.term;
    if (!term) {
      this.state.submenu = {};
      this.state.tree.expandedTermIds = [root_ID];
    } else {
      const expandedTermIds = [root_ID];
      if (term.__ancestors) {
        expandedTermIds.push(...term.__ancestors);
      }
      if (isUsableTerm(term, this.state.tree.usecase || {}, this.state.termdbConfig).has("plot")) {
        Object.assign(this.state.submenu, action.submenu);
      } else {
        expandedTermIds.push(term.id);
        delete this.state.submenu.term;
      }
      this.state.tree.expandedTermIds = expandedTermIds;
    }
  },
  /** Changing the state.termTypeGroup in TermTypeSearch notifies
   * the tree of which handler should be shown. */
  set_term_type_group({ value }) {
    this.state.termTypeGroup = value;
  }
};
var storeInit = StoreApi.getInitFxn(TdbStore);

// termdb/Vocab.js
var Vocab = class {
  termdbConfig = {};
  constructor(opts) {
    this.app = opts.app;
    this.opts = opts;
    this.state = opts.state;
    this.vocab = opts.state.vocab;
    this.currAnnoData = { samples: {}, refs: { byTermId: {} }, lastTerms: [], lastFilter: {} };
    this.missingCatValsByTermId = {};
    const dslabel = this.vocab?.dslabel || this.state?.dslabel;
    this.dofetch3 = dofetch3;
  }
  create(componentGetAbortSignal) {
    return Object.create(this, {
      // Make a component-level abort signal easily accessible inside all vocabApi methods,
      // usage example: `init.signal = this.getAbortSignal?.() || this.app?.getAbortSignal?.()` in dofetch3()
      // This overrides the default app-level cancellation fallback with a component/plot-level
      // signal, so app-wide state changes do not cancel fetch requests that should remain scoped
      // to the current component instance.
      // Details at https://github.com/stjude/proteinpaint/wiki/Using-AbortController-to-prevent-race-condition
      getAbortSignal: {
        value: () => componentGetAbortSignal()
      }
    });
  }
  async main(stateOverride = null) {
    if (stateOverride) Object.assign(this.state, stateOverride);
    else this.state = structuredClone(this.app?.getState?.() || this.opts.state);
    if (this.state.vocab) this.vocab = this.state.vocab;
    const dslabel = this.state.dslabel || this.state.vocab.dslabel;
    this.verifiedToken = !this.state.termdbConfig?.requiredAuth?.length || await isInSession(dslabel, "termdb");
    if (dslabel) await this.maySetVerifiedToken(dslabel);
  }
  async maySetVerifiedToken(dslabel) {
    if (this.verifiedToken === true) return this.verifiedToken;
    const protectedRoute = "termdb";
    const auth = this.state.termdbConfig?.requiredAuth.find((a) => a.route == protectedRoute) || getRequiredAuth(dslabel, protectedRoute);
    if (!auth) {
      this.verifiedToken = true;
      return;
    }
    const token = await this.opts.getDatasetAccessToken?.(protectedRoute) || getSavedToken(dslabel, protectedRoute);
    if (this.verifedToken && token === this.verifiedToken) return this.verifiedToken;
    try {
      if (!token && auth.type == "jwt") {
        delete this.verifiedToken;
        return;
      }
      if (auth.type == "jwt" || auth.type == "basic" && !this.verifedToken && token) {
        const headers = {
          [auth.headerKey]: token
        };
        const route = auth.route || "termdb";
        if (!headers.authorization && token) headers.authorization = `Bearer ${btoa(token)}`;
        const data = await dofetch3("/jwt-status", {
          method: "POST",
          headers,
          body: {
            dslabel,
            route,
            embedder: location.hostname
          }
        });
        this.verifiedToken = data.status === "ok";
        if (data.error) {
          this.tokenVerificationPayload = data;
          throw data.error;
        } else {
          this.sessionId = auth.headerKey && data[auth.headerKey] || data["x-sjppds-sessionid"] || data["x-ds-access-token"];
          delete this.tokenVerificationMessage;
          delete this.tokenVerificationPayload;
          if (data.jwt) {
            setTokenByDsRoute(dslabel, data.route, data.jwt);
          }
        }
      } else if (auth.route != "/**") {
        throw `unsupported requiredAuth='${auth.type}'`;
      }
    } catch (e) {
      this.tokenVerificationMessage = e.message || e.reason || e;
    }
  }
  hasVerifiedToken() {
    return this.verifiedToken && true;
  }
  async mayGetAuthHeaders(route = "") {
    const dslabel = this.state.vocab.dslabel;
    const auth = this.state.termdbConfig?.requiredAuth?.find((a) => a.route == route) || getRequiredAuth(dslabel, route);
    if (!auth) return {};
    if (!this.verifiedToken) {
      if (await isInSession(dslabel, "termdb")) {
        const jwt2 = getSavedToken(this.state.vocab.dslabel, route);
        if (jwt2) this.verifiedToken = jwt2;
      } else {
        this.tokenVerificationMessage = `requires login for this data`;
        return;
      }
    }
    const headers = {};
    if (auth.headerKey && typeof this.verifiedToken == "string") headers[auth.headerKey] = this.verifiedToken;
    if (this.sessionId) headers["x-sjppds-sessionid"] = this.sessionId;
    const jwt = getSavedToken(dslabel, route) || await this.opts.getDatasetAccessToken?.(route);
    if (jwt) headers.authorization = `Bearer ${btoa(jwt)}`;
    return headers;
  }
  getClientAuthResult() {
    return this.state.termdbConfig?.clientAuthResult;
  }
  async trackDsAction({ action, details }) {
    const headers = { "x-sjppds-sessionid": this.sessionId };
    const jwt = await this.opts.getDatasetAccessToken?.("termdb");
    if (jwt) headers.authorization = "Bearer " + btoa(jwt);
    await dofetch3("/authorizedActions", {
      method: "POST",
      credentials: "include",
      headers,
      body: Object.assign({
        dslabel: this.vocab.dslabel,
        action,
        details,
        "x-sjppds-sessionid": this.sessionId
      })
    });
  }
  // get a minimum copy of tw
  // for better GET caching by the browser
  getTwMinCopy(tw) {
    if (!tw) return;
    const copy = { type: tw.type, term: {}, q: structuredClone(tw.q) };
    delete copy.q.isAtomic;
    if (tw.$id) copy.$id = tw.$id;
    if (tw.term) {
      if (isDictionaryType(tw.term.type)) {
        if (tw.term.id) copy.term.id = tw.term.id;
        if (tw.term.name) copy.term.name = tw.term.name;
        if (tw.term.type) copy.term.type = tw.term.type;
        if (tw.term.values) copy.term.values = tw.term.values;
        if (tw.term.groupsetting) copy.term.groupsetting = tw.term.groupsetting;
        if (tw.term.termIds) copy.term.termIds = tw.term.termIds;
        if (tw.term.memberType) copy.term.memberType = tw.term.memberType;
        if (tw.term.valueTransform) copy.term.valueTransform = tw.term.valueTransform;
        if (tw.term.categoryKeys) copy.term.categoryKeys = tw.term.categoryKeys;
        if (tw.term.termlst) copy.term.termlst = tw.term.termlst;
        if (tw.term.propsByTermId) copy.term.propsByTermId = tw.term.propsByTermId;
        if (tw.term.isCustom) copy.term.isCustom = tw.term.isCustom;
        if (tw.term.valueMeaning) copy.term.valueMeaning = tw.term.valueMeaning;
      } else {
        copy.term = structuredClone(tw.term);
        if (copy.term.bins?.default?.isDummyPreset) delete copy.term.bins;
        trimGvTermCopy(copy.term, copy.q);
      }
    }
    return copy;
  }
  /* Remember a geneVariant setting the user just built, see remember_gvq() in
  client/mass/store.ts. A no-op in a host app whose store does not track them, since only
  the mass store does, so that the same termsetting UI works in every host. */
  rememberGvQ(term, q) {
    if (!this.state?.reuse?.gvQByGene || !this.app?.dispatch) return;
    this.app.dispatch({ type: "remember_gvq", term, q: structuredClone(q) });
  }
  /* The settings remembered for the gene(s) of a geneVariant term, most recent first, as
  	{label, q} entries -- see remember_gvq() in client/mass/store.ts.
  
  	Returns [] in a host app whose store does not track them, and copies so that a caller can
  	hand a q to fillTermWrapper(), which fills in place. */
  getGvQLst(term) {
    const key = getGvQCacheKey(term);
    const cache3 = this.state.reuse?.gvQByGene;
    const lst = key && cache3?.[key];
    return lst ? structuredClone(lst) : [];
  }
  async addCustomTerm(obj) {
    await this.app.dispatch({
      type: "add_customTerm",
      obj
    });
  }
  async deleteCustomTerm(name) {
    await this.app.dispatch({
      type: "delete_customTerm",
      name
    });
  }
  async deleteCustomTermById(id3) {
    await this.app.dispatch({
      type: "delete_customTerm",
      id: id3
    });
  }
  async getCustomTerms() {
    if (!Array.isArray(this.state.customTerms)) return [];
    return this.state.customTerms.map((i3) => i3.tw);
  }
  async addGroup(obj) {
    await this.app.dispatch({
      type: "add_group",
      obj
    });
  }
  async deleteGroup(name) {
    await this.app.dispatch({
      type: "delete_group",
      name
    });
  }
  async getGroups() {
    if (!Array.isArray(this.state.groups)) return [];
    return this.state.groups;
  }
  isAbortError(e) {
    if (e instanceof DOMException) return e.name === "AbortError";
    if (typeof e == "string") return e.includes("stale sequenceId") || e.includes("AbortError");
    return false;
  }
};

// termdb/TermdbVocab.js
var TermdbVocab = class extends Vocab {
  // getAbortSignal() will be used to cancel async fetch requests or canvas rendering that may
  // lead to a mismatch between cohort label and rendered data due to race condition.
  // Assume that the rarely used FrontendVocab will not require fetch/rendering cancellation,
  // so there is no need to have this on the parent Vocab class as an inherited method.
  // (May revisit this assumption as needed.)
  //
  // The default is to trigger cancellation at the beginning of every app.dispatch(),
  // if the signal option is provided to fetch().
  //
  // A more targeted, plot-level cancellation may override this and should be preferred,
  // which is done in PlotBase constructor using prototypal inheritance. See details at
  // https://github.com/stjude/proteinpaint/wiki/Using-AbortController-to-prevent-race-condition
  getAbortSignal() {
    return this.app?.getAbortSignal?.();
  }
  // migrated from termdb/store
  async getTermdbConfig() {
    if (this.opts.getDatasetAccessToken) {
      try {
        await this.maySetVerifiedToken(this.state.vocab.dslabel);
      } catch (e) {
        console.log(e);
      }
    }
    const headers = await this.mayGetAuthHeaders("termdb");
    const data = await this.dofetch3("termdb/config", {
      headers,
      body: {
        genome: this.vocab.genome,
        dslabel: this.vocab.dslabel,
        embedder: window.location.hostname
      }
    });
    if (data.error) throw data.error;
    this.termdbConfig = data.termdbConfig || {};
    return this.termdbConfig;
  }
  async getTermChildren(term, cohortValuelst, filter2) {
    let data;
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      filter: getNormalRoot(filter2)
    };
    if (cohortValuelst) {
      body.cohortValues = cohortValuelst.slice().sort().join(",");
    }
    if (this.state.treeFilter) {
      body.treeFilter = this.state.treeFilter;
    }
    if (term.__tree_isroot) {
      body.default_rootterm = 1;
      data = await this.dofetch3("termdb/rootterm", { body }, this.opts.fetchOpts);
    } else {
      body.get_children = 1;
      body.tid = term.id;
      data = await this.dofetch3("termdb/termchildren", { body }, this.opts.fetchOpts);
    }
    if (data.error) throw data.error;
    for (const term2 of data.lst) {
      if (term2.type == "integer" || term2.type == "float") {
        if (term2.bins?.rounding) term2.bins.default.rounding = term2.bins.rounding;
        if (term2.bins?.label_offset && !term2.bins?.default?.label_offset)
          term2.bins.default.label_offset = term2.bins.label_offset;
      }
    }
    return data;
  }
  /* from termdb/plot
  Input:
  opts{}
  	.term={}
  		.id=str
  		.term={}
  		.q={}
  	.term2={}
  		id/term/q
  	.term0={}
  		id/term/q
  	.filter={}
  Output:
  	a structure from the termdb/barsql route
  */
  async getNestedChartSeriesData(opts, signal = void 0) {
    const [route, body] = this.getTdbDataUrl(opts);
    const headers = await this.mayGetAuthHeaders("termdb");
    const initOpts = { headers, body };
    initOpts.signal = signal;
    const data = await this.dofetch3(route, initOpts, this.opts.fetchOpts);
    if (data.error) throw data.error;
    const valuesByTermId = {};
    if (data.charts) {
      for (const chart of data.charts) {
        this.mayFillInMissingCatValues(opts.term0, chart.chartId, chart.total);
        for (const series of chart.serieses) {
          this.mayFillInMissingCatValues(opts.term, series.seriesId, series.total);
          for (const data2 of series.data) {
            this.mayFillInMissingCatValues(opts.term2, data2.dataId, data2.total);
          }
        }
      }
    }
    this.mayFillCategories(opts, data.categories);
    return data;
  }
  mayFillInMissingCatValues(term, key, total) {
    if (!key) return;
    if (!(term?.id in this.missingCatValsByTermId)) return;
    const t2 = this.missingCatValsByTermId[term.id];
    if (!(key in t2.values)) {
      t2.values[key] = {
        key,
        label: key
        /*color: */
      };
      t2.samplecount[key] = { samplecount: 0, key, label: key };
    }
    t2.samplecount[key].samplecount += total;
  }
  // fill in term.categories with
  // categories computed from the data
  mayFillCategories(opts, categories) {
    if (!categories) return;
    if (!Array.isArray(categories)) throw "categories is not array";
    for (const [i3, k] of ["term0", "term", "term2"].entries()) {
      const tw = opts[k];
      if (!tw) continue;
      const c = categories[i3];
      if (!Object.keys(c).length) continue;
      tw.term.categories = c;
    }
  }
  /*
  		Create URL parameters for charts that use the 
  		`/termdb*` server route, which expects the  
  		term0, term, term2 variable naming convention
  
  		Arguments:
  		opts
  		- chart configuration object with termwrappers of
  			term (required), term0 (optional) and term2 (optional)
  		
  		.term 
  			required, {term, q}
  		.term2
  			optional overlay term, {term, q}
  		.term0
  			optional divide-by term, {term, q}
  		.filter
  			optional filter object 
  		.filter0
  			optional gdc filter
  	*/
  getTdbDataUrl(opts) {
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      embedder: window.location.hostname
    };
    for (const _key of ["term0", "term", "term2"]) {
      const tw = this.getTwMinCopy(opts[_key]);
      if (!tw) continue;
      if (!tw.q) throw "plot." + _key + ".q{} missing: " + tw.term.id;
      if (!tw.$id) throw new Error("plot." + _key + ".$id missing: " + tw.term.id);
      body[_key == "term" ? "term1" : _key] = tw;
    }
    if (opts.filter) {
      const filter2 = getNormalRoot(opts.filter);
      if (filter2.lst.length) {
        body.filter = filter2;
      }
    }
    if (opts.filter0) body.filter0 = opts.filter0;
    if ("grade" in opts) body.grade = opts.grade;
    if ("minSampleSize" in opts) body.minSampleSize = opts.minSampleSize;
    if (opts.term2) {
      const hiddenValues = {
        term1: opts.term.q.hiddenValues ? Object.keys(opts.term.q.hiddenValues).map((h) => opts.term.term.values?.[h]?.label || h) : [],
        term2: opts.term2.q.hiddenValues ? Object.keys(opts.term2.q.hiddenValues).map((h) => opts.term2.term.values?.[h]?.label || h) : []
      };
      body.hiddenValues = hiddenValues;
    }
    if (opts.get) body.get = opts.get;
    if (opts.chartType == "survival") return ["termdb/survival", body];
    if (opts.chartType == "cuminc") return ["termdb/cuminc", body];
    return [opts.chartType ? "termdb" : "termdb/barsql", body];
  }
  /*
  		May override certain term-related configuration (like bins),
  		from the server response data to the corresponding term's 
  		current state.
  
  		Arguments
  		config
  		- chart configuration object with termwrappers of
  			term (required), term0 (optional) and term2 (optional)
  
  		- data
  			server response data in the format of 
  			{
  				charts: [{
  					chartId: '...',
  					serieses: [{
  						seriesId: '...',
  						data: [{
  							dataId: '...',
  							total: *samplecount*
  						}, ...],
  						total: *samplecount*
  					}, ...],
  					total: *samplecount*
  				}, ...],
  
  				refs: {...}
  			}
  	*/
  syncTermData(config, data, prevConfig = {}) {
    if (!data || !data.refs) return;
    for (const [i3, key] of ["term0", "term", "term2"].entries()) {
      const term = config[key];
      const persistTerm = !prevConfig[key] || prevConfig[key].term?.id === term?.term?.id;
      if (term == "genotype") continue;
      if (!term) {
        if (key == "term") throw `missing plot.term{}`;
        continue;
      }
      if (data.refs.bins) {
        term.bins = data.refs.bins[i3];
        if (data.refs.q && data.refs.q[i3]) {
          if (!term.q) term.q = {};
          const q = data.refs.q[i3];
          if (q !== term.q || !persistTerm) {
            if (q.type != term.q.type || q.mode != term.q.mode) {
              for (const key2 in term.q) {
                if (key2 != "hiddenValues" || !persistTerm) delete term.q[key2];
              }
            }
            Object.assign(term.q, q);
          }
        }
      }
      if (!term.q) term.q = {};
    }
  }
  /* 
  	Generate regression analysis results
  	config{}
  	.regressionType: 'linear' | 'logistic'
  	.outcome {term, q, refGrp}
  	.independent[ {term, q, refGrp}, ... ]
  */
  async getRegressionData(opts) {
    if (!isDictionaryType(opts.outcome.term.type)) throw "outcome must be dictionary term";
    const outcome = this.getTwMinCopy(opts.outcome);
    if (!outcome.q.mode && opts.regressionType == "linear") outcome.q.mode = "continuous";
    outcome.refGrp = opts.outcome.refGrp;
    if (opts.outcome.nonRefGrp) outcome.nonRefGrp = opts.outcome.nonRefGrp;
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      filter0: opts.filter0,
      includeUnivariate: opts.includeUnivariate,
      regressionType: opts.regressionType,
      outcome,
      independent: opts.independent.map((tw) => {
        const copy = this.getTwMinCopy(tw);
        copy.refGrp = tw.refGrp;
        copy.interactions = tw.interactions || [];
        return copy;
      })
    };
    const filterData = getNormalRoot(opts.filter);
    if (filterData.lst.length) body.filter = filterData;
    const data = await this.dofetch3("termdb/regression", { body }, this.opts.fetchOpts);
    if (data.error) throw data.error;
    return data;
  }
  /*
  str: search phrase
  cohorStr
  usecase
  targetType
  	snp = find if str matches with dbsnp
  	category = match with catgory of a term (not implemented yet)
  	blank string for default behavior of matching with dict term or gene names
  */
  async findTerm(str, cohortStr = "", usecase = null, targetType = "") {
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      findterm: encodeURIComponent(str),
      cohortStr
    };
    if (usecase) body.usecase = usecase;
    if (this.state.treeFilter) body.treeFilter = this.state.treeFilter;
    if (targetType) body.targetType = targetType;
    const data = await this.dofetch3("termdb", { body });
    if (data.error) throw data.error;
    const n = str.toUpperCase();
    const r = { equals: [], startsWith: [], startsWord: [], includes: [] };
    for (const i3 of data.lst) {
      const name = i3.name.toUpperCase();
      if (name === n) r.equals.push(i3);
      else if (name.startsWith(n)) r.startsWith.push(i3);
      else if (name.includes(" " + n)) r.startsWord.push(i3);
      else r.includes.push(i3);
    }
    data.lst = [...r.equals, ...r.startsWith, ...r.startsWord, ...r.includes];
    return data;
  }
  // from termdb/terminfo
  async getTermInfo(id3) {
    if (!id3) throw ".getTermInfo: Missing term id";
    const args = ["genome=" + this.vocab.genome + "&dslabel=" + this.vocab.dslabel + "&getterminfo=1&tid=" + id3];
    const data = await this.dofetch3("/termdb?" + args.join("&"), {}, this.opts.fetchOpts);
    if (data.error) throw data.error;
    return data;
  }
  async getCohortSampleCount(cohort) {
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      cohort
    };
    const data = await this.dofetch3("termdb/cohort/summary", { body }, this.opts.fetchOpts);
    if (!data) throw "missing data";
    if (data.error) throw data.error;
    return data.count;
  }
  /** opts: 
  	  filterJSON: JSON || string, required
  	returns sample list in array of [{id, name}....]
   */
  async getFilteredSampleList(filterJSON, filter0) {
    if (filter0 === void 0) filter0 = this.state?.termfilter?.filter0;
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      getsamplelist: 1,
      filter: typeof filterJSON == "string" ? filterJSON : getNormalRoot(filterJSON),
      filter0
    };
    const data = await this.dofetch3("termdb", { body }, this.opts.fetchOpts);
    if (!data) throw `missing data`;
    if (data.error) throw data.error;
    if (!Array.isArray(data)) throw "data is not array";
    return data;
  }
  /** opts: 
  	  filterJSON: JSON || string, required
  	returns sample count per type
   */
  async getGrin2Data(body, signal) {
    const headers = await this.mayGetAuthHeaders("termdb");
    const payload = { ...body, genome: this.vocab.genome, dslabel: this.vocab.dslabel };
    const data = await this.dofetch3("grin2", { headers, body: payload, signal }, this.opts.fetchOpts);
    if (data.error) throw data.error;
    return data;
  }
  async getFilteredSampleCount(filterJSON, filter0) {
    if (filter0 === void 0) filter0 = this.state?.termfilter?.filter0;
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      getsamplecount: 1,
      filter: getNormalRoot(filterJSON),
      filter0
    };
    const data = await this.dofetch3("termdb", { body }, this.opts.fetchOpts);
    if (!data) throw `missing data`;
    if (data.error) throw data.error;
    return data.count;
  }
  async getViolinBox(arg, _body = {}, signal = void 0) {
    const headers = await this.mayGetAuthHeaders("termdb");
    const twCopy = this.getTwMinCopy(arg.tw);
    twCopy.q.mode = "continuous";
    if (!arg.plotType) throw new Error('plotType is required: must be "violin" or "box"');
    if (arg.plotType !== "violin" && arg.plotType !== "box") {
      throw new Error('plotType must be either "violin" or "box"');
    }
    const body = Object.assign(
      {
        plotType: arg.plotType,
        genome: this.vocab.genome,
        dslabel: this.vocab.dslabel,
        filter: arg.filter || this.state.termfilter?.filter,
        filter0: this.state.termfilter?.filter0
      },
      arg,
      // override the tws spread in from arg with their min copies
      { tw: twCopy }
    );
    if (arg.overlayTw) body.overlayTw = this.getTwMinCopy(arg.overlayTw);
    if (arg.divideTw) body.divideTw = this.getTwMinCopy(arg.divideTw);
    if (arg.plotType === "violin") {
      Object.assign(body, {
        embedder: window.location.hostname,
        devicePixelRatio: window.devicePixelRatio,
        isKDE: "isKDE" in arg ? arg.isKDE : true,
        ticks: arg.ticks,
        datasymbol: arg.datasymbol || "rug",
        orientation: arg.orientation || "horizontal",
        radius: arg.radius || 8,
        svgw: arg.svgw || 200
      });
    }
    Object.assign(body, _body);
    if (body.filter) body.filter = getNormalRoot(body.filter);
    const init = { headers, body, signal };
    const data = await this.dofetch3("termdb/violinBox", init);
    if (data.error) throw data.error;
    return data;
  }
  async getPercentile(term, percentile_lst, termfilter) {
    if (percentile_lst.find((p) => !Number.isInteger(p))) throw "non-integer percentiles found";
    if (Math.max(...percentile_lst) > 99 || Math.min(...percentile_lst) < 1) throw "percentiles must be between 1-99";
    const body = {
      getpercentile: percentile_lst,
      term,
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel
    };
    if (termfilter) {
      if (termfilter.filter) body.filter = getNormalRoot(termfilter.filter);
      if (termfilter.filter0) body.filter0 = termfilter.filter0;
    }
    const signal = this.getAbortSignal();
    return await this.dofetch3("termdb/getpercentile", { body, signal });
  }
  async getDescrStats(tw, termfilter, logScale, signal) {
    const body = {
      tw,
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel
    };
    if (logScale) body.logScale = true;
    if (termfilter) {
      if (termfilter.filter) body.filter = getNormalRoot(termfilter.filter);
      if (termfilter.filter0) body.filter0 = termfilter.filter0;
    }
    return await this.dofetch3("/termdb/descrstats", { body, signal });
  }
  /**
   * Retrieve terms by ids from the term database.
   * @param {Array} ids - The array of term ids to retrieve
   * @param {string} [_dslabel=null] - The dataset label (optional)
   * @param {string} [_genome=null] - The genome identifier (optional)
   * @return {Object} The terms data retrieved based on the provided ids
   */
  async getTerms(ids, _dslabel = null, _genome = null) {
    if (!ids) throw "getTerms: ids missing";
    if (!Array.isArray(ids)) throw `invalid ids`;
    const dslabel = _dslabel || this.state.vocab?.dslabel;
    const genome = _genome || this.state.vocab?.genome;
    if (!dslabel) throw "getTerms: dslabel missing";
    if (!genome) throw "getTerms: genome missing";
    const body = {
      genome,
      dslabel,
      ids,
      embedder: window.location.hostname
    };
    const data = await this.dofetch3(`termdb/termsbyids`, { body });
    if (data.error) throw "getTerm: " + data.error;
    for (const id3 in data.terms) {
      const term = data.terms[id3];
      if (term.type == "categorical" && !term.values) this.missingCatValsByTermId[term.id] = term;
    }
    return data.terms;
  }
  async getterm(termid, dslabel = null, genome = null) {
    if (!termid) throw "getterm: termid missing";
    const result = await this.getTerms([termid], dslabel, genome);
    const term = result[termid];
    if (!term) throw "no term found for " + termid;
    return term;
  }
  graphable(term) {
    if (!term) throw "graphable: term is missing";
    return isUsableTerm(term).has("plot");
  }
  /*
  	accepts one term of any type, including categorical, non-categorical, and non-dictionary
  	return number of samples per category/bin/grade/group etc
  	optionally, caller can supply a {term1_q: {...}} key-object value in _body to customize categories
  
  	for a caller that holds a term but no wrapper, e.g. a filter tvs editor: a tvs is not a tw, and
  	its q-shaped fields are assembled into term1_q here rather than a wrapper being faked for it.
  	a caller that does hold a wrapper must call getTwCategories() instead
  	*/
  async getCategories(term, filter2, _body = {}) {
    const { term1_q, ...body } = _body;
    return await this.getTwCategories({ term, q: term1_q || {} }, filter2, body);
  }
  /*
  	same as getCategories(), for a caller that holds the whole term wrapper.
  
  	tw.type is what makes this more than a convenience: it decides how the server reduces the term
  	to categories, and the term alone does not imply it. a fraction termCollection resolves to one
  	number per sample only for tw.type='TermCollectionTWFraction'; without it the collection stays
  	one value per member term and the server returns one "category" per sample rather than the
  	fraction's bins
  	*/
  async getTwCategories(tw, filter2, _body = {}) {
    const term = tw.term;
    const signal = this.getAbortSignal();
    const headers = await this.mayGetAuthHeaders();
    if (term.type == "snplst" || term.type == "snplocus") {
      const body2 = Object.assign(
        {
          validateSnps: 1,
          sumSamples: 1,
          genome: this.state.vocab.genome,
          dslabel: this.state.vocab.dslabel
        },
        _body
      );
      if (filter2) body2.filter = getNormalRoot(filter2);
      if (this.state.termfilter?.filter0) body2.filter0 = this.state.termfilter.filter0;
      return await this.dofetch3("/termdb", { headers, body: body2, signal });
    }
    if (term.category2samplecount) {
      const l2 = [];
      for (const key in term.category2samplecount) {
        l2.push({
          key,
          label: term?.values?.[key]?.label || key,
          samplecount: term.category2samplecount[key]
        });
      }
      return { lst: l2 };
    }
    if (_body.categories) {
      return _body.categories;
    }
    if (_body.skip_categories) {
      return { lst: [] };
    }
    const body = {
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      tw: this.getTwMinCopy(tw),
      ..._body
    };
    if (filter2) {
      body.filter = getNormalRoot(filter2);
    }
    if (this.state.termfilter?.filter0) body.filter0 = this.state.termfilter.filter0;
    const data = await this.dofetch3("termdb/categories", { headers, body, signal });
    if (data.error) throwMsgWithFilePathAndFnName(data.error);
    return data;
  }
  async getNumericUncomputableCategories(term, filter2) {
    const body = {
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      tid: term.id
    };
    if (filter2) body.filter = getNormalRoot(filter2);
    if (this.state.termfilter?.filter0) body.filter0 = this.state.termfilter.filter0;
    try {
      const data = await this.dofetch3("/termdb/numericcategories", { body });
      if (data.error) throw data.error;
      return data;
    } catch (e) {
      if (!this.isAbortError(e)) window.alert(e.message || e);
    }
  }
  /* when arg.text is true, arg should only be {text} from a snplst term;
  else, it should be the q{} of snplocus term: {chr,start,stop,variant_filter}
  to generate snp-sample gt matrix cache file and return file name
  */
  async validateSnps(arg) {
    const lst = ["validateSnps=1", "genome=" + this.state.vocab.genome, "dslabel=" + this.state.vocab.dslabel];
    if (arg.text) {
      lst.push("snptext=" + encodeURIComponent(arg.text));
    } else if (arg.chr) {
      lst.push("chr=" + arg.chr);
      lst.push("start=" + arg.start);
      lst.push("stop=" + arg.stop);
      if (arg.variant_filter) lst.push("variant_filter=" + encodeURIComponent(JSON.stringify(arg.variant_filter)));
    }
    return await this.dofetch3("/termdb?" + lst.join("&"));
  }
  async get_variantFilter() {
    const body = { getvariantfilter: 1, genome: this.state.vocab.genome, dslabel: this.state.vocab.dslabel };
    if (this.state.termfilter?.filter0) body.filter0 = this.state.termfilter.filter0;
    return await this.dofetch3("termdb", { body });
  }
  /*
  	The server data sample annotations and refs are both indexed 
  	by term id, but will be remapped to be annotated instead with 
  	tw.$id. This will prevent conflicts when the same term.id is used
  	multiple times in the terms[] argument, such as for the matrix plot.
  
  	Arguments:
  
  	opts{}
  	.filter        a filter object
  	.filter0       read-only json object, only used for gdc dataset to store the cohort filter obj built by CohortBuilder
  	.terms[{}]     an array of termWrapper objects
  		tw.$id       id to disambugate when multiple terms
  					 with the same ID are in terms[], such as in matrix plot
  	.termsPerRequest optional, a number greater than 1;
  					 when provided, a request includes the number of terms specified, improving the response times
  	Returns 
  	{
  		lst: [{
  			sample, 
  			term1: {key, value}, 
  			term2: {key, values}, 
  			...
  		}],
  		refs: {
  			byTermId: {termIdorName1: {term, q}},
  			bySampleId: {...}
  		}
  	}
  	
  	
  	Expected server-data response
  	{}
  	.samples{}
  		[sample]{}
  			sample: the sample ID
  			[$id]: {} // $id is tw id, not term id
  				key, value, // only used for dict term
  				values:[]
  					// used for non-dict term e.g. gene mutation
  					{sample, ...mutation properties...}
  	
  	.refs{}
  		.byTermId{}
  			[$id]: {bins, etc}   metadata for processed terms, useful
  													for specifying value order, colors, etc.
  		.bySampleId{}
  			[sample]: {
  				label:str, // required, the display name of this sample
  				otherLabels:[ {map to sjcloud}, {link to pbtp},] // optional, to define later
  			}
  			available sample name(s) mapped to each sample, for display only
  
  	!!! NOTE !!!
  	May fill in following attributes on term object if missing or met conditions:
  	(the modifications are on term object and not tracked in state)
  
  	tw.term.category2samplecount = {}
  	tw.term.values={}
  	*/
  async getAnnotatedSampleData(opts, _refs = {}) {
    const headers = await this.mayGetAuthHeaders("termdb");
    if (!headers) return;
    const filter2 = getNormalRoot(opts.filter);
    const samples = {};
    const refs = { byTermId: _refs.byTermId || {}, bySampleId: _refs.bySampleId || {} };
    const promises = [];
    const samplesToShow = /* @__PURE__ */ new Set();
    const currentGeneNames = opts.isHierCluster || opts.isSummary ? null : opts.terms.filter((tw) => tw.term.type === "geneVariant").map((tw) => tw.term.chr ? `${tw.term.chr}:${tw.term.start}-${tw.term.stop}` : tw.term.name).sort();
    const allTerms2update = opts.terms.slice().sort((a, b) => a.term.name < b.term.name ? -1 : 1);
    const maxNumTerms = this.opts.app.vocabApi.termdbConfig?.maxAnnoTermsPerClientRequest || opts.terms.length;
    let numResponses = 0;
    if (opts.loadingDiv) opts.loadingDiv.html("Updating data ...");
    const warnings = [];
    const frozenEmptyObj = Object.freeze({});
    const signal = opts.signal || this.getAbortSignal();
    while (true) {
      const copies = getTerms2update(allTerms2update, maxNumTerms);
      if (copies.length == 0) break;
      const init = {
        headers,
        credentials: "include",
        body: {
          for: "matrix",
          genome: this.vocab.genome,
          dslabel: this.vocab.dslabel,
          // one request per term
          terms: copies.map(this.getTwMinCopy),
          filter: filter2,
          embedder: window.location.hostname,
          isSummary: opts.isSummary
        },
        signal
      };
      if (opts.filter0) init.body.filter0 = opts.filter0;
      if (opts.isHierCluster) init.body.isHierCluster = true;
      if (this.opts.app.vocabApi.termdbConfig?.limitDictTermSamplesToMutated && copies.find((tw) => tw.term.id && (!tw.term?.type || isDictionaryType(tw.term.type))) && currentGeneNames?.length) {
        init.body.currentGeneNames = currentGeneNames;
      }
      promises.push(
        this.dofetch3("termdb", init).then((data) => {
          if (data.error) throw data.error;
          if (data.warning) warnings.push(data.warning.message);
          if (!data.refs.bySampleId) data.refs.bySampleId = {};
          const $copyAs = data.refs.$codes.copyAs || {};
          const $objAssign = data.refs.$codes.objAssign || {};
          for (const tw of copies) {
            const { shortId, queries } = data.refs.byTermId[tw.$id] || frozenEmptyObj;
            const origTw = opts.terms.find((o) => o.$id === tw.$id);
            for (const [sampleId, sample] of Object.entries(data.samples)) {
              if (!Object.keys(sample).filter((k) => k != "sample").length) continue;
              samplesToShow.add(sampleId);
              if (!(sampleId in samples)) {
                if (!data.refs.bySampleId[sampleId]) data.refs.bySampleId[sampleId] = {};
                if (typeof data.refs.bySampleId[sampleId] == "string")
                  data.refs.bySampleId[sampleId] = { label: data.refs.bySampleId[sampleId] };
                const _ref_ = data.refs.bySampleId[sampleId];
                if (!_ref_.label) _ref_.label = sampleId;
                const s = {
                  sample: sampleId,
                  // must reserve _ref -> should not be used as a term.id or tw.$id
                  _ref_
                };
                samples[sampleId] = s;
              }
              if (!sample.sample) sample.sample = data.refs.bySampleId[sampleId].sample || sampleId;
              if (!sample.sampleName) sample.sampleName = data.refs.bySampleId[sampleId].sampleName || sample.sample;
              const d = shortId ? sample[shortId] : sample[tw.$id];
              if (!d) continue;
              if (shortId in sample) {
                sample[tw.$id] = d;
                delete sample[shortId];
                if (d.$) d[$copyAs[d.$]] = d.key;
                if (d.values) {
                  for (const v of d.values) {
                    restoreGvQueryEntry(v, queries);
                    if (!v.class && v.$) {
                      Object.assign(v, $objAssign[v.$]);
                      delete v.$;
                    }
                  }
                }
              }
              if (origTw.transformData) origTw.transformData(d);
              samples[sampleId][tw.$id] = d;
            }
            for (const sampleId in data.refs.bySampleId) {
              refs.bySampleId[sampleId] = data.refs.bySampleId[sampleId];
            }
            refs.byTermId[tw.$id] = tw;
            if (tw.$id in data.refs.byTermId) {
              refs.byTermId[tw.$id] = Object.assign({}, refs.byTermId[tw.$id], data.refs.byTermId[tw.$id]);
            }
          }
          numResponses++;
          if (opts.loadingDiv) opts.loadingDiv.html(`Updating data (${numResponses}/${promises.length}) ...`);
        }).catch((e) => {
          if (signal) this.app?.triggerAbort("", signal);
          throw e;
        })
      );
    }
    try {
      if (opts.loadingDiv) opts.loadingDiv.html(`Updating data (0/${promises.length})`);
      await Promise.all(promises);
      if (opts.loadingDiv) opts.loadingDiv.html("");
    } catch (e) {
      if (typeof e == "string") {
        const _e = e.toLowerCase();
        if (e.includes("token") || e.includes("jwt") || e.includes("login") || e.includes("sign") || e.includes("auth") || e.includes("credential")) {
          this.tokenVerificationMessage = e;
        }
      }
      throw e;
    }
    try {
      if (opts.loadingDiv) opts.loadingDiv.html(`Processing data ...`);
      const dictTerm$ids = opts.terms.filter((tw) => isDictionaryType(tw.term.type)).map((tw) => tw.$id);
      const lst = [];
      if (!dictTerm$ids.length) {
        lst.push(...Object.values(samples));
      } else {
        for (const sampleId in samples) {
          const row = samples[sampleId];
          for (const $id2 in row) {
            if (dictTerm$ids.includes($id2)) {
              lst.push(row);
              break;
            }
          }
        }
        if (!lst.length && this.termdbConfig?.matrix?.settings?.displayDictRowWithNoValues) {
          lst.push(...Object.values(samples));
        }
      }
      const sampleFilter = new RegExp(opts.sampleNameFilter || ".*");
      const data = {
        lst: lst.filter((row) => samplesToShow.has(row.sample) && sampleFilter.test(row.sample)),
        refs,
        warnings
      };
      data.samples = data.lst.reduce((obj, row) => {
        obj[row.sample] = row;
        return obj;
      }, {});
      for (const tw of opts.terms) {
        mayFillInCategory2samplecount4term(tw, data.lst, this.termdbConfig);
      }
      return data;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
  // ids: [str], where str are string term IDS or names
  async getTermTypes(ids) {
    const init = {
      body: {
        for: "termTypes",
        genome: this.vocab.genome,
        dslabel: this.vocab.dslabel,
        ids: JSON.stringify(ids)
      }
    };
    const data = await this.dofetch3("termdb", init, this.opts.fetchOpts);
    if (data.error) throw data.error;
    return data;
  }
  async getLDdata(tkname, m) {
    const body = {
      getLDdata: 1,
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      ldtkname: tkname,
      m: { chr: m.chr, pos: m.pos, ref: m.ref, alt: m.alt }
    };
    return await this.dofetch3("termdb", { body });
  }
  async getScatterData(opts, signal = void 0) {
    const headers = await this.mayGetAuthHeaders("termdb");
    const body = {
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      plotName: opts.name,
      coordTWs: opts.coordTWs?.map((tw) => this.getTwMinCopy(tw)),
      filter: getNormalRoot(opts.filter),
      filter0: opts.filter0,
      embedder: window.location.hostname,
      singleCellPlot: opts.singleCellPlot,
      chartType: opts.chartType,
      excludeOutliers: opts.excludeOutliers
    };
    if (opts.colorColumn) body.colorColumn = opts.colorColumn;
    if (opts.colorTW) body.colorTW = this.getTwMinCopy(opts.colorTW);
    if (opts.shapeTW) body.shapeTW = this.getTwMinCopy(opts.shapeTW);
    if (opts.divideByTW) body.divideByTW = this.getTwMinCopy(opts.divideByTW);
    if (opts.scaleDotTW) body.scaleDotTW = this.getTwMinCopy(opts.scaleDotTW);
    return await this.dofetch3("termdb/sampleScatter", { headers, body, signal });
  }
  async getScatterSingleCellPlotData(opts, signal = void 0) {
    const headers = await this.mayGetAuthHeaders("termdb");
    const body = {
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      ...opts
    };
    if (body.colorTW) body.colorTW = this.getTwMinCopy(opts.colorTW);
    if (body.filter) body.filter = getNormalRoot(opts.filter);
    return await this.dofetch3("termdb/singleCellPlots", { headers, body, signal });
  }
  async getDefaultBins(opts) {
    const headers = await this.mayGetAuthHeaders("termdb");
    const body = {
      for: "getDefaultBins",
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      tw: opts.tw.getMinCopy?.({ q: {} }) || this.getTwMinCopy({ type: opts.tw.type, term: opts.tw.term, q: {} }),
      embedder: window.location.hostname
    };
    const tf = this.state.termfilter || this.opts?.state?.termfilter;
    if (tf) {
      if (tf.filter) body.filter = getNormalRoot(tf.filter);
      if (tf.filter0) body.filter0 = tf.filter0;
    }
    const signal = opts.signal || this.getAbortSignal();
    return await this.dofetch3("termdb", { headers, body, signal });
  }
  // it's safer to separately treat term and q as persisted objects but not tw,
  // since tw may have been constructed only as an argument for this function
  // and not as a persisted object elsewhere
  async setTermBins({ $id: $id2, term, q }) {
    let presetBins = await this.getDefaultBins({ tw: { $id: $id2, term, q } });
    if ("error" in presetBins) throw presetBins.error;
    if (presetBins.default?.bin_size === null || presetBins.default?.first_bin.stop === null) {
      presetBins = {
        default: {
          mode: "discrete",
          type: "regular-bin",
          bin_size: 1,
          first_bin: { startunbounded: true, stop: 2 },
          isDummyPreset: true
        }
      };
    }
    term.bins = presetBins;
    if (q.mode == "discrete" && !q.type) {
      const currMode = q.mode;
      for (const key in q) {
        if (key != "isAtomic") delete q[key];
      }
      Object.assign(q, term.bins.default);
      q.mode = currMode;
    }
  }
  async getSingleSampleData(opts) {
    const headers = await this.mayGetAuthHeaders("termdb");
    const body = {
      for: "singleSampleData",
      sampleId: opts.sampleId,
      term_ids: opts.term_ids,
      filter: getNormalRoot(opts.filter),
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      embedder: window.location.hostname
    };
    const data = await this.dofetch3("termdb", { headers, body });
    const byTermId = {};
    if ("error" in data) return data;
    for (const row of data) {
      const term = JSON.parse(row.jsondata);
      byTermId[row.term_id] = { value: row.value, term };
    }
    return byTermId;
  }
  async getAllSamples() {
    const headers = await this.mayGetAuthHeaders("termdb");
    const body = {
      for: "getAllSamples",
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      embedder: window.location.hostname
    };
    const data = await this.dofetch3("termdb", { headers, body });
    return data;
  }
  async getSamplesByName(opts) {
    const headers = await this.mayGetAuthHeaders("termdb");
    const body = {
      for: "getSamplesByName",
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      embedder: window.location.hostname
    };
    if (opts?.filter) body.filter = getNormalRoot(opts.filter);
    const data = await this.dofetch3("termdb", { headers, body });
    return data;
  }
  async getProfileFacilities() {
    const headers = await this.mayGetAuthHeaders("termb");
    const body = {
      for: "getProfileFacilities",
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      embedder: window.location.hostname
    };
    const data = await this.dofetch3("termdb", { headers, body });
    const result = [];
    for (const row of data) result.push(row.name);
    return result;
  }
  async getLowessCurve(opts) {
    const headers = await this.mayGetAuthHeaders("termb");
    const body = {
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      getLowessCurve: 1,
      coords: opts.coords
    };
    return await this.dofetch3("termdb", { headers, body });
  }
  async getMultivalueTWs(opts) {
    const headers = await this.mayGetAuthHeaders("termb");
    const body = {
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel,
      for: "getMultivalueTWs",
      parent_id: opts?.parent_id
    };
    return await this.dofetch3("termdb", { headers, body });
  }
  async getCohortsData(opts) {
    const body = {
      genome: this.state.vocab.genome,
      dslabel: this.state.vocab.dslabel
    };
    return await this.dofetch3("termdb/cohorts", { body });
  }
  async getMatrixByName(name) {
    return await this.dofetch3("termdb", {
      body: {
        for: "matrix",
        getPlotDataByName: name,
        genome: this.state.vocab.genome,
        dslabel: this.state.vocab.dslabel
      }
    });
  }
  async getNumericDictTermClusterByName(name) {
    return await this.dofetch3("termdb", {
      body: {
        for: "numericDictTermCluster",
        getPlotDataByName: name,
        genome: this.state.vocab.genome,
        dslabel: this.state.vocab.dslabel
      }
    });
  }
  async getTopMutatedGenes(arg) {
    if (!arg.genome) arg.genome = this.state.vocab.genome;
    if (!arg.dslabel) arg.dslabel = this.state.vocab.dslabel;
    arg.filter = getNormalRoot(arg.filter || this.state.termfilter.filter);
    if (!arg.filter0) arg.filter0 = this.state.termfilter.filter0;
    return await this.dofetch3("termdb/topMutatedGenes", { method: "GET", body: arg });
  }
  async getTopVariablyExpressedGenes(arg) {
    if (!arg.genome) arg.genome = this.state.vocab.genome;
    if (!arg.dslabel) arg.dslabel = this.state.vocab.dslabel;
    arg.filter = getNormalRoot(arg.filter || this.state.termfilter.filter);
    if (!arg.filter0) arg.filter0 = this.state.termfilter.filter0;
    return await this.dofetch3("termdb/topVariablyExpressedGenes", { method: "GET", body: arg });
  }
  async getTopTermsByType(args) {
    args.genome = this.state.vocab.genome;
    args.dslabel = this.state.vocab.dslabel;
    if (args.filter) args.filter = getNormalRoot(args.filter);
    return await this.dofetch3("termdb/getTopTermsByType", { method: "GET", body: args });
  }
  async getSampleImages(sampleId) {
    const args = {};
    args.genome = this.state.vocab.genome;
    args.dslabel = this.state.vocab.dslabel;
    args.sampleId = sampleId;
    return await this.dofetch3("termdb/getSampleImages", { method: "GET", body: args });
  }
  /* 
  		samples[]					!!! CRITICAL: the samples data must not be modified !!!
  			sample{} 			  the source sample object, will not be changed directly
  				[attr.from]   any collection of keys from the attributes[] argument
  
  		attributes[]
  			.attr{}
  				.from         string, the object to map from, required
  				.to           string, the object to map to, optional
  				.convert      optional step, somehow the caller must know this is needed?
  	*/
  async convertSampleId(samples, attributes) {
    const byAttr = /* @__PURE__ */ new Map();
    const bySample = [];
    for (const sample of samples) {
      const obj = {};
      bySample.push(obj);
      for (const attr of attributes) {
        if (!("to" in attr)) attr.to = attr.from;
        if (!attr.convert) {
          mayAssign(obj, attr.to, sample[attr.from]);
          continue;
        }
        if (sample._ref_?.[attr.to]) {
          mayAssign(obj, attr.to, sample._ref_[attr.to]);
          continue;
        }
        if (!byAttr.has(attr)) byAttr.set(attr, {});
        const fromValMap = byAttr.get(attr);
        const v = sample[attr.from];
        if (!fromValMap[v]) fromValMap[v] = [];
        fromValMap[v].push({ obj, sample });
      }
    }
    const promises = [];
    for (const [attr, fromValMap] of byAttr) {
      const inputs = Object.keys(fromValMap);
      promises.push(
        await this.dofetch3("termdb", {
          body: {
            for: "convertSampleId",
            inputs,
            genome: this.state.vocab.genome,
            dslabel: this.state.vocab.dslabel
          }
        }).then((r) => {
          for (const v of inputs) {
            for (const { sample, obj } of fromValMap[v]) {
              mayAssign(obj, attr.to, r.mapping[v]);
            }
          }
        })
      );
    }
    await Promise.all(promises);
    return bySample.filter((d) => Object.keys(d).length);
    function mayAssign(obj, key, value) {
      if (!bySample.some((d) => d[key] == value)) {
        obj[key] = value;
      }
    }
  }
  async getCorrelationVolcanoData(arg, _body = {}) {
    const headers = await this.mayGetAuthHeaders("termdb");
    arg.featureTw = this.getTwMinCopy(arg.featureTw);
    arg.variableTwLst = arg.variableTwLst.map((tw) => this.getTwMinCopy(tw));
    const body = Object.assign(
      {
        genome: this.vocab.genome,
        dslabel: this.vocab.dslabel
      },
      arg,
      _body
    );
    if (body.filter) body.filter = getNormalRoot(body.filter);
    const d = await this.dofetch3("termdb/correlationVolcano", { headers, body });
    return d;
  }
  async filterTermValues(args) {
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      ...args
    };
    if (body.filter) body.filter = getNormalRoot(body.filter);
    if (body.terms) {
      body.terms = structuredClone(body.terms);
      for (const tw of body.terms) {
        this.mayStripTwProps(tw);
      }
    }
    if (body.facilityTW) this.mayStripTwProps(body.facilityTW);
    return await this.dofetch3("termdb/filterTermValues", { body });
  }
  async getProfileFormScores(args) {
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      ...args
    };
    if (body.filter) body.filter = getNormalRoot(body.filter);
    if (body.terms) {
      for (const t2 of body.terms) {
        if (t2.term.id) t2.term = { id: t2.term.id };
      }
    }
    return await this.dofetch3("termdb/profileFormScores", { body });
  }
  // strip some tw properties that
  // - are not used in the server (relevant to only client-side code),
  // - may recovered on the server side such as for dictionary terms
  mayStripTwProps(tw) {
    if (!tw) return;
    delete tw.type;
    delete tw.isAtomic;
    delete tw.hiddenValues;
    delete tw.q.isAtomic;
    delete tw.q.hiddenValues;
    if (tw.term.id && (!tw.term.type || isDictionaryType(tw.term.type))) tw.term = { id: tw.term.id };
  }
  async getAggregateMatrixData(opts) {
    const body = {
      genome: this.vocab.genome,
      dslabel: this.vocab.dslabel,
      rows: opts.rows,
      columns: opts.columns,
      gradientMethod: opts.gradientMethod,
      sizeMethod: opts.sizeMethod,
      minDotSize: opts.minDotSize,
      maxDotSize: opts.maxDotSize,
      filter: opts.filter,
      filter0: opts.filter0
    };
    const formatTw = (term) => {
      if (isSingleCellTerm(term)) return { term, q: {} };
      else return this.getTwMinCopy({ term, q: {} });
    };
    Object.keys(body.rows).forEach((section) => {
      body.rows[section] = body.rows[section].map((term) => formatTw(term));
    });
    Object.keys(body.columns).forEach((member) => {
      body.columns[member] = body.columns[member].map((term) => formatTw(term));
    });
    if (body.filter) body.filter = getNormalRoot(body.filter);
    const signal = opts.signal || this.getAbortSignal();
    return await this.dofetch3("termdb/aggregateMatrix", { body, signal });
  }
};
function mayFillInCategory2samplecount4term(tw, lst, termdbConfig) {
  if (tw.term.type != "categorical") {
    return;
  }
  if (!("$id" in tw)) {
    return;
  }
  const k2c = {};
  const k2label = {};
  for (const s of lst) {
    if (!s[tw.$id]) continue;
    const categoryKey = s[tw.$id].key;
    k2c[categoryKey] = 1 + (k2c[categoryKey] || 0);
    k2label[categoryKey] = { key: categoryKey, label: categoryKey };
  }
  tw.term.category2samplecount = k2c;
  if (termdbConfig?.alwaysRefillCategoricalTermValues || !tw.term.values || Object.keys(tw.term.values).length == 0) {
    tw.term.values = k2label;
  }
}
function getTerms2update(lst, count) {
  const copies = [];
  let i3 = 0, n = lst.length;
  while (i3 < n) {
    i3++;
    const _tw = lst.shift();
    const tw = _tw.getMinCopy?.() || _tw;
    if (copies.find(
      (c) => c.term.type === tw.term.type && (("id" in c.term || "id" in tw.term) && c.term.id === tw.term.id || c.term.name === tw.term.name)
    )) {
      lst.push(tw);
    } else {
      copies.push(tw);
    }
    if (copies.length >= count) break;
  }
  return copies;
}

// plots/barchart/barchart.data.ts
var import_partjson = __toESM(require_partjson_umd(), 1);
function getBarchartData(_q, data) {
  const q = JSON.parse(JSON.stringify(_q));
  if (!q.term1) q.term1 = q.term ? q.term : {};
  if (!q.term1_q) q.term1_q = {};
  if (!q.term0) q.term0 = {};
  if (!q.term0_q) q.term0_q = {};
  if (!q.term2) q.term2 = {};
  if (!q.term2_q) q.term2_q = {};
  if (!q.filter) q.filter = { type: "tvslst", join: "", lst: [] };
  const pj = getCharts(q, data);
  return pj.tree.results;
}
var templateBar = JSON.stringify({
  "@before()": "=prep()",
  "@join()": {
    idVal: "=idVal()"
  },
  results: {
    "_2:maxAcrossCharts": "=maxAcrossCharts()",
    charts: [
      {
        chartId: "@key",
        total: "+1",
        "_1:maxSeriesTotal": "=maxSeriesTotal()",
        "@done()": "=filterEmptySeries()",
        serieses: [
          {
            total: "+1",
            seriesId: "@key",
            max: "<&idVal.dataVal",
            // needed by client-side boxplot renderer
            "~values": ["&idVal.dataVal", 0],
            "~sum": "+&idVal.dataVal",
            "__:boxplot": "=boxplot()",
            "~samples": ["$sample", "set"],
            //'__:AF': '=getAF()',
            data: [
              {
                dataId: "@key",
                total: "+1"
                //samples: ['$sample']
              },
              "&idVal.dataId[]"
            ]
          },
          "&idVal.seriesId[]"
        ]
      },
      "&idVal.chartId[]"
    ],
    "~sum": "+&idVal.seriesVal",
    "~values": ["&idVal.seriesVal", 0],
    "__:boxplot": "=boxplot()",
    refs: {
      cols: ["&idVal.seriesId[]"],
      colgrps: ["-"],
      rows: ["&idVal.dataId[]"],
      rowgrps: ["-"],
      col2name: {
        "&idVal.seriesId[]": {
          name: "@branch",
          grp: "-"
        }
      },
      row2name: {
        "&idVal.dataId[]": {
          name: "@branch",
          grp: "-"
        }
      },
      "__:useColOrder": "=useColOrder()",
      "__:useRowOrder": "=useRowOrder()",
      "__:bins": "=bins()",
      //'__:q': '=q()',
      "@done()": "=sortColsRows()"
    },
    "@done()": "=sortCharts()"
  }
});
function getCharts(q, data) {
  const idValFxns = {
    categorical: getCategoricalIdVal,
    integer: getNumericIdVal,
    float: getNumericIdVal,
    undefined: getUndefinedIdVal
    // NOTE: condition terms are not currently supported for frontend vocab
  };
  return new import_partjson.default({
    data,
    seed: `{"values": []}`,
    // result seed
    template: templateBar,
    "=": {
      idVal(row, _) {
        const [chartId, chartVal] = idValFxns[q.term0.type](row.data, q.term0, q.term0_q, data);
        const [seriesId, seriesVal] = idValFxns[q.term1.type](row.data, q.term1, q.term1_q, data);
        const [dataId, dataVal] = idValFxns[q.term2.type](row.data, q.term2, q.term2_q, data);
        return {
          chartId,
          chartVal,
          seriesId,
          seriesVal,
          dataId,
          dataVal
        };
      },
      prep(row) {
        return sample_match_termvaluesetting(row.data, q.filter);
      },
      maxSeriesTotal(_, context) {
        let maxSeriesTotal = 0;
        for (const grp of context.self.serieses) {
          if (grp && grp.total > maxSeriesTotal) {
            maxSeriesTotal = grp.total;
          }
        }
        return maxSeriesTotal;
      },
      maxAcrossCharts(_, context) {
        let maxAcrossCharts = 0;
        for (const chart of context.self.charts) {
          if (chart.maxSeriesTotal > maxAcrossCharts) {
            maxAcrossCharts = chart.maxSeriesTotal;
          }
        }
        return maxAcrossCharts;
      },
      boxplot(_, context) {
        if (!context.self.values || !context.self.values.length) return;
        const values = context.self.values.filter((d) => d !== null && !isNaN(d));
        if (!values.length) return;
        values.sort((i3, j) => i3 - j);
        const stat = boxplot_getvalue(values);
        stat.mean = context.self.sum / values.length;
        let s = 0;
        for (const v of values) {
          s += Math.pow(v - stat.mean, 2);
        }
        stat.sd = Math.sqrt(s / (values.length - 1));
        if (isNaN(stat.sd)) stat.sd = null;
        return stat;
      },
      numSamples(_, context) {
        return context.self.samples.size;
      },
      filterEmptySeries(result) {
        const nonempty = result.serieses.filter((series) => series.total);
        result.serieses.splice(0, result.serieses.length, ...nonempty);
      },
      sortColsRows(result) {
        if (q.term1_q.orderedLabels) {
          const labels = q.term1_q.orderedLabels;
          result.cols.sort((a, b) => labels.indexOf(a) - labels.indexOf(b));
        }
        if (q.term2.orderedLabels) {
          const labels = q.term2_q.orderedLabels;
          result.rows.sort((a, b) => labels.indexOf(a) - labels.indexOf(b));
        }
      },
      sortCharts() {
      },
      useColOrder() {
        return q.term1_q.orderedLabels && q.term1_q.orderedLabels.length > 0;
      },
      useRowOrder() {
        return q.term2_q.orderedLabels && q.term2_q.orderedLabels.length > 0;
      },
      bins() {
        return [q.term0_q, q.term1_q, q.term2_q].map((d) => d.computed_bins);
      },
      q() {
      }
    }
  });
}
function getCategoricalIdVal(d, term) {
  const id3 = "id" in term ? d[term.id] : "-";
  const value = "id" in term && isNumeric(d[term.id]) ? +d[term.id] : 0;
  return [[id3], value];
}
function getNumericIdVal(d, term, q, rows) {
  if (!("id" in term) || !(term.id in d)) return [[], void 0];
  if (!q.computed_bins) {
    const summary = {};
    rows.map((row) => {
      if (!isNumeric(row.data[term.id])) return;
      const v2 = +row.data[term.id];
      if (!("min" in summary) || summary.min > v2) summary.min = v2;
      if (!("max" in summary) || summary.max < v2) summary.max = v2;
    });
    const percentiles = () => summary;
    q.computed_bins = compute_bins(q, percentiles);
    q.orderedLabels = q.computed_bins.map((d2) => d2.label);
  }
  const v = d[term.id];
  if (term.values && v in term.values && term.values[v].uncomputable) {
    return [[term.values[v].label], void 0];
  }
  if (isNumeric(d[term.id])) {
    const ids = [];
    for (const b of q.computed_bins) {
      if (b.startunbounded) {
        if (v < b.stop) {
          ids.push(b.label);
        } else if (b.stopinclusive && v === b.stop) {
          ids.push(b.label);
        }
      } else if (b.stopunbounded) {
        if (v > b.start) {
          ids.push(b.label);
        } else if (b.stopinclusive && v === b.start) {
          ids.push(b.label);
        }
      } else if ((v > b.start || v === b.start && b.startinclusive) && (v < b.stop || v === b.stop && b.stopinclusive)) {
        ids.push(b.label);
      }
      if (ids.length) break;
    }
    return [ids, v];
  }
  return [[], void 0];
}
function getUndefinedIdVal() {
  return [["-"], void 0];
}
function getCategoryData(q, data) {
  if (!data || !data.length) {
    return {
      lst: Object.keys(q.term.values).map((k) => {
        return { key: k, label: q.term.values[k].label, value: k };
      })
    };
  }
  const pj = new import_partjson.default({
    data,
    template: JSON.stringify({
      "@before()": "=prep()",
      "@join()": {
        idVal: "=idVal()"
      },
      results: {
        "&idVal.id": {
          samplecount: "+1",
          ":__key": "&idVal.id",
          ":__label": "&idVal.id",
          ":__value": "&idVal.id"
        }
      }
    }),
    "=": {
      prep(row) {
        return sample_match_termvaluesetting(row.data, q.filter);
      },
      idVal(row) {
        const [id3, value] = getCategoricalIdVal(row.data, q.term);
        return { id: id3[0], value };
      }
    }
  });
  return { lst: Object.values(pj.tree.results) };
}

// termdb/FrontendVocab.js
var FrontendVocab = class extends Vocab {
  constructor(opts) {
    super(opts);
    this.datarows = [];
    if (opts.state.vocab.sampleannotation) {
      const anno = opts.state.vocab.sampleannotation;
      Object.keys(anno).forEach((sample) => this.datarows.push({ sample, data: anno[sample] }));
    }
  }
  getTermdbConfig() {
    return { selectCohort: this.vocab.selectCohort, supportedChartTypes: [] };
  }
  getTermChildren(term, cohortValuelst) {
    const cohortValuestr = (cohortValuelst || []).slice().sort().join(",");
    const parent_id = term.__tree_isroot ? null : term.id;
    return {
      lst: this.vocab.terms.filter(
        (t2) => t2.parent_id === parent_id && (!cohortValuestr.length || cohortValuestr === t2.cohortValues.slice().sort.join(","))
      )
    };
  }
  // from termdb/plot
  async getNestedChartSeriesData(opts) {
    const q = {
      term1: opts.term ? opts.term.term : {},
      term1_q: opts.term ? opts.term.q : void 0,
      term0: opts.term0 ? opts.term0.term : void 0,
      term0_q: opts.term0 ? opts.term0.q : void 0,
      term2: opts.term2 ? opts.term2.term : void 0,
      term2_q: opts.term2 ? opts.term2.q : void 0,
      filter: this.state.termfilter && this.state.termfilter.filter
    };
    return getBarchartData(q, this.datarows);
  }
  /*
          May override certain term-related configuration (like bins),
          from the server response data to the corresponding term's 
          current state.
  
          Arguments
          config
          - chart configuration object with termwrappers of
              term (required), term0 (optional) and term2 (optional)
  
          - data
              server response data in the format of 
              {
                  charts: [{
                      chartId: '...',
                      serieses: [{
                          seriesId: '...',
                          data: [{
                              dataId: '...',
                              total: *samplecount*
                          }, ...],
                          total: *samplecount*
                      }, ...],
                      total: *samplecount*
                  }, ...],
  
                  refs: {...}
              }
      */
  syncTermData(config, data, prevConfig = {}) {
    if (!data || !data.refs) return;
    for (const [i3, key] of ["term0", "term", "term2"].entries()) {
      const term = config[key];
      if (term == "genotype") return;
      if (!term) {
        if (key == "term") throw `missing plot.term{}`;
        return;
      }
      if (data.refs.bins) {
        term.bins = data.refs.bins[i3];
        if (data.refs.q && data.refs.q[i3]) {
          if (!term.q) term.q = {};
          const q = data.refs.q[i3];
          if (q !== term.q) {
            for (const key2 in term.q) delete term.q[key2];
            Object.assign(term.q, q);
          }
        }
      }
      if (!term.q) term.q = {};
    }
  }
  // from termdb/search
  async findTerm(str, cohortStr, usecase = null) {
    return {
      lst: this.vocab.terms.filter(
        (t2) => t2.name.includes(str) && (!cohortStr || cohortStr === t2.cohortValues.slice().sort.join(","))
      )
    };
  }
  // from termdb/terminfo
  async getTermInfo(id3) {
    const term = this.vocab.find((t2) => t2.id === id3);
    if (!term) return void 0;
    return { terminfo: t.info };
  }
  // from termdb/nav
  async getCohortSampleCount(cohortName) {
    if (!cohortName) return;
    const term = this.vocab.find((t2) => t2.id === id);
    if (!term || !term.cohortValues.includes(cohortName)) return;
    if (!term.samplecount) term.samplecount = {};
    if (!(cohortName in term.samplecount)) {
      term.samplecount[cohortName] = Object.keys(this.vocab.sampleannotation).length;
    }
    return { samplecount: term.samplecount[cohortName] };
  }
  /*** To-Do ***/
  async getCohortsData(opts) {
    return null;
  }
  async getFilteredSampleCount(filterJSON) {
    return "TBD";
  }
  async getDensityPlotData(term_id, num_obj, filter2) {
    if (!this.datarows || !this.datarows.length) {
      const term2 = this.vocab.terms.find((t2) => t2.id === term_id);
      const minvalue2 = term2.range && term2.range;
      return {
        minvalue: term2.range && term2.range.start,
        maxvalue: term2.range && term2.range.stop
      };
    }
    const values = [];
    const distinctValues = /* @__PURE__ */ new Set();
    let minvalue, maxvalue, samplecount = 0;
    let samples = {};
    for (const anno of this.datarows) {
      if (samples[anno.sample]) continue;
      const data = anno.s || anno.data;
      if (data && sample_match_termvaluesetting(data, filter2)) {
        samples[anno.sample] = this.vocab.sampleannotation[anno.sample];
      }
    }
    for (const sample in samples) {
      if (!(term_id in this.vocab.sampleannotation[sample])) continue;
      const _v = this.vocab.sampleannotation[sample][term_id];
      if (isNumeric(_v)) {
        const v = +_v;
        samplecount += 1;
        if (minvalue === void 0 || v < minvalue) minvalue = v;
        if (maxvalue === void 0 || v > maxvalue) maxvalue = v;
        values.push(v);
        distinctValues.add(v);
      }
    }
    const term = this.vocab.terms.find((t2) => t2.id == term_id);
    const default_ticks_n = 40;
    const ticks_n = term.type == "integer" && maxvalue - minvalue < default_ticks_n ? maxvalue - minvalue : term.type == "float" && distinctValues.size < default_ticks_n ? distinctValues : default_ticks_n;
    const xscale = linear().domain([minvalue, maxvalue]).range([num_obj.plot_size.xpad, num_obj.plot_size.width - num_obj.plot_size.xpad]);
    const density = get_histogram(xscale.ticks(ticks_n))(values);
    return {
      density,
      densitymax: density.reduce((maxv, v, i3) => i3 === 0 || v[1] > maxv ? v[1] : maxv, 0),
      minvalue,
      maxvalue,
      samplecount
    };
  }
  async getPercentile(term, percentile_lst, filter2) {
    if (percentile_lst.find((p) => !Number.isInteger(p))) throw "non-integer percentiles found";
    if (Math.max(...percentile_lst) > 99 || Math.min(...percentile_lst) < 1) throw "percentiles must be between 1-99";
    const perc_values = [];
    const values = [];
    const samples = {};
    for (const anno of this.datarows) {
      if (samples[anno.sample]) continue;
      const data = anno.s || anno.data;
      if (data && sample_match_termvaluesetting(data, filter2)) {
        samples[anno.sample] = this.vocab.sampleannotation[anno.sample];
      }
    }
    for (const sample in samples) {
      if (!(term.id in this.vocab.sampleannotation[sample])) continue;
      const _v = Number(this.vocab.sampleannotation[sample][term.id]);
      if (!Number.isFinite(_v)) throw "non-numeric value";
      values.push(_v);
    }
    values.sort((a, b) => a - b);
    for (const percentile of percentile_lst) {
      const perc_value = computePercentile(values, percentile, true);
      perc_values.push(perc_value);
    }
    return { values: perc_values };
  }
  async getDescrStats(term_id, filter2, settings) {
    const values = [];
    const samples = {};
    for (const anno of this.datarows) {
      if (samples[anno.sample]) continue;
      const data = anno.s || anno.data;
      if (data && sample_match_termvaluesetting(data, filter2)) {
        samples[anno.sample] = this.vocab.sampleannotation[anno.sample];
      }
    }
    for (const sample in samples) {
      if (!(term_id in this.vocab.sampleannotation[sample])) continue;
      const _v = Number(this.vocab.sampleannotation[sample][term_id]);
      if (!Number.isFinite(_v)) throw "non-numeric value";
      values.push(_v);
    }
    return computeDescrStats(values);
  }
  async getTerms(ids, _dslabel = null, _genome = null) {
    if (!ids) throw "getTerms: ids missing";
    if (!Array.isArray(ids)) throw `invalid ids`;
    const terms = {};
    for (const id3 of ids) {
      const term = this.vocab.terms.find((t2) => t2.id === id3);
      if (term) terms[id3] = term;
    }
    return terms;
  }
  async getterm(termid) {
    if (!termid) throw "getterm: termid missing";
    return this.vocab.terms.find((d) => d.id == termid);
  }
  async getCategories(term, filter2, lst = null) {
    const q = { term, filter: filter2 };
    const data = getCategoryData(q, this.datarows);
    return data;
  }
  /** same split as TermdbVocab: a caller holding a whole wrapper passes it here. a frontend vocab
  tallies the rows it was handed, so nothing beyond the term is read yet */
  async getTwCategories(tw, filter2, lst = null) {
    return await this.getCategories(tw.term, filter2, lst);
  }
  getNumericUncomputableCategories(term, filter2) {
    throw "to be implemented!! getNumericUncomputableCategories";
  }
  graphable(term) {
    if (!term) throw "graphable: term is missing";
    return isUsableTerm(term).has("plot");
  }
  q_to_param(q) {
    const q2 = JSON.parse(JSON.stringify(q));
    delete q2.hiddenValues;
    return encodeURIComponent(JSON.stringify(q2));
  }
};
function get_histogram(ticks) {
  return (values) => {
    const bins = [];
    for (let i3 = 0; i3 < ticks.length; i3++) bins.push([ticks[i3], 0]);
    for (const v of values) {
      for (let i3 = 1; i3 < ticks.length; i3++) {
        if (v <= ticks[i3]) {
          bins[i3 - 1][1]++;
          break;
        }
      }
    }
    return bins;
  };
}
function computeDescrStats(values, showOutlierRange = false) {
  if (!values.length) {
    return {};
  }
  if (values.some((v) => !Number.isFinite(v))) throw new Error("non-numeric values found");
  const sorted_arr = values.sort((a, b) => a - b);
  const n = sorted_arr.length;
  const median = computePercentile(sorted_arr, 50, true);
  const mean = getMean(sorted_arr);
  const variance = getVariance(sorted_arr);
  const stdDev = Math.sqrt(variance);
  const p25 = computePercentile(sorted_arr, 25, true);
  const p75 = computePercentile(sorted_arr, 75, true);
  const IQR = p75 - p25;
  const min = sorted_arr[0];
  const max = sorted_arr[sorted_arr.length - 1];
  const outlierMin = p25 - 1.5 * IQR;
  const outlierMax = p75 + 1.5 * IQR;
  const stats = {
    total: { label: "Total", value: n },
    min: { label: "Minimum", value: min },
    p25: { label: "1st quartile", value: p25 },
    median: { label: "Median", value: median },
    p75: { label: "3rd quartile", value: p75 },
    max: { label: "Maximum", value: max },
    mean: { label: "Mean", value: mean },
    stdDev: { label: "Standard deviation", value: stdDev }
    //variance: { label: 'Variance', value: variance }, // not necessary to report, as it is just stdDev^2
    //iqr: { label: 'Inter-quartile range', value: IQR } // not necessary to report, as it is just p75-p25
  };
  if (showOutlierRange) {
    stats.outlierMin = { label: "Outlier minimum", value: outlierMin };
    stats.outlierMax = { label: "Outlier maximum", value: outlierMax };
  }
  for (const v of Object.values(stats)) {
    const rounded = roundValueAuto(v.value);
    v.value = rounded;
  }
  return stats;
}
function getMean(data) {
  return data.reduce((sum, value) => sum + value, 0) / data.length;
}
function getVariance(data) {
  const meanValue = getMean(data);
  const squaredDifferences = data.map((value) => Math.pow(value - meanValue, 2));
  return squaredDifferences.reduce((sum, value) => sum + value, 0) / (data.length - 1);
}

// termdb/vocabulary.js
function vocabInit(opts) {
  if (opts.vocab && !opts.state) {
    opts.state = { vocab: opts.vocab };
  }
  if (!opts.state) throw "missing opts.state";
  if (!opts.state.vocab) {
    opts.state.vocab = opts.vocab ? opts.vocab : {};
  }
  const vocab = opts.state.vocab;
  if (opts.state.genome) {
    vocab.genome = opts.state.genome;
    delete opts.state.genome;
  }
  if (opts.state.dslabel) {
    vocab.dslabel = opts.state.dslabel;
    delete opts.state.dslabel;
  }
  if (vocab.dslabel) {
    return new TermdbVocab(opts);
  } else if (vocab.terms) {
    const vocabApi = new FrontendVocab(opts);
    return vocabApi;
  } else {
    throw `unable to initialize vocabApi`;
  }
}
function q_to_param(q) {
  const q2 = JSON.parse(JSON.stringify(q));
  delete q2.hiddenValues;
  return encodeURIComponent(JSON.stringify(q2));
}
function getVocabFromSamplesArray({ samples, sample_attributes }) {
  const terms = {
    __root: {
      id: "root",
      name: "root",
      __tree_isroot: true
    }
  };
  const sanno = {};
  for (const a of samples) {
    const s = a.sample;
    if (!sanno[s]) sanno[s] = {};
    Object.assign(sanno[s], a.s);
    for (const key in a.s) {
      if (!terms[key]) {
        const name = sample_attributes[key] && sample_attributes[key].label ? sample_attributes[key].label : key;
        terms[key] = {
          id: key,
          name,
          parent_id: null,
          type: sample_attributes[key].type == "float" ? "float" : sample_attributes[key].type == "integer" ? "integer" : (
            // need to work with the cloud/PROPEL team to define type for legacy scatterplot usage
            "categorical"
          ),
          values: {},
          isleaf: true
        };
      }
      const t2 = terms[key];
      if (!("id" in t2)) t2.id = key;
      if (!("parent_id" in t2)) t2.parent_id = null;
      if (!("values" in t2)) t2.values = {};
      if (!("isleaf" in t2)) t2.isleaf = true;
      if (!t2.computableVals && (t2.type == "float" || t2.type == "integer")) {
        t2.computableVals = [];
      }
      const value = a.s[key];
      if (t2.type == "categorical") {
        t2.groupsetting = { disabled: true };
        if (!(value in t2.values)) {
          t2.values[value] = { key: value, label: value };
        }
      } else if (t2.type == "integer" || t2.type == "float") {
        if (value === "Not Available" && !(value in t2.values)) {
          t2.values[value] = { label: value, uncomputable: true };
        }
        if (!(value in t2.values)) {
          if (!isNumeric(a.s[key])) throw `non-numeric term value='${value}' for term='${key}'`;
          a.s[key] = Number(a.s[key]);
          const val = a.s[key];
          t2.computableVals.push(val);
        }
      } else if (t2.type == "condition") {
      } else if (t2.type == SINGLECELL_GENE_EXPRESSION) {
      } else {
        throw "Term type not supported:" + t2.type;
      }
    }
  }
  for (const key in terms) {
    const t2 = terms[key];
    if ((t2.type == "integer" || t2.type == "float") && !t2.bins) {
      t2.bins = {
        default: initBinConfig(t2.computableVals)
      };
      delete t2.computableVals;
    }
  }
  return {
    sampleannotation: sanno,
    terms: Object.values(terms)
  };
}

// termdb/submenu.js
var TdbSubmenu = class _TdbSubmenu {
  static type = "submenu";
  constructor(opts) {
    this.type = _TdbSubmenu.type;
    this.dom = { holder: opts.holder };
    setRenderers3(this);
  }
  reactsTo(action) {
    if (action.type.startsWith("submenu_")) return true;
    if (action.type == "app_refresh") return true;
  }
  getState(appState) {
    return {
      type: appState.submenu.type,
      term: appState.submenu.term,
      termfilter: appState.termfilter
    };
  }
  main() {
    if (!this.state.term) {
      this.dom.holder.style("display", "none");
      return;
    }
    if (this.state.type == "tvs") this.showTvsMenu(this.state.term);
    else throw `unsupported submenu.type='${this.state.type}'`;
  }
};
var submenuInit = getCompInit(TdbSubmenu);
function setRenderers3(self2) {
  self2.showTvsMenu = function(term) {
    self2.dom.holder.selectAll("*").remove();
    self2.dom.holder.style("display", "block").append("div").style("margin", "10px 10px 15px 10px").append("span").html("&laquo; " + (self2.app.opts.tree?.backToSelectionText || "Back to variable selection")).attr("class", "sja_clbtext").attr("data-testid", "sja_treesubmenu_backprompt").on("click", () => self2.app.dispatch({ type: "submenu_set", submenu: {} }));
    if (!dtTermTypes.has(term.type)) {
      self2.dom.holder.style("display", "block").append("div").style("margin", "10px 0px 5px 10px").style("font-weight", "bold").style("font-size", ".9em").text(term.name);
    }
    showTvsMenu({
      term,
      filter: self2.state.termfilter.filter,
      holder: self2.dom.holder.append("div"),
      vocabApi: self2.app.vocabApi,
      debug: self2.app.debug,
      getCategoriesArguments: self2.app.opts.getCategoriesArguments,
      isMafFilter: self2.app.opts.isMafFilter,
      callback: self2.app.opts.tree.click_term2select_tvs
    });
  };
}

// termdb/search.js
var import_debounce4 = __toESM(require_debounce(), 1);
var TermSearch = class _TermSearch {
  static type = "search";
  constructor(opts) {
    this.type = _TermSearch.type;
    this.customEvents = ["postSearch"];
    setRenderers4(this);
    setInteractivity2(this);
    this.dom = { holder: opts.holder };
    this.isVisible = "isVisible" in opts ? opts.isVisible : true;
  }
  async init(appState) {
    this.initUI(this.getState(appState));
  }
  reactsTo(action) {
    if (action.type == "set_term_type_group") return true;
    if (action.type == "app_refresh") return true;
    const prefix = action.type.split("_")[0];
    return ["search", "cohort", "submenu"].includes(prefix);
  }
  getState(appState) {
    return {
      isVisible: !appState.submenu.term && this.isVisible,
      cohortStr: appState.activeCohort == -1 || !appState.termdbConfig.selectCohort ? "" : appState.termdbConfig.selectCohort.values[appState.activeCohort].keys.slice().sort().join(","),
      allowedTermTypes: appState.termdbConfig?.allowedTermTypes || [],
      expandedTermIds: appState.tree.expandedTermIds,
      selectedTerms: appState.selectedTerms,
      usecase: appState.tree.usecase,
      search: appState.search,
      termTypeGroup: appState.termTypeGroup
    };
  }
  isTermTypeSupported() {
    const termTypeGroup = this.state.termTypeGroup;
    if (termTypeGroup == TermTypeGroups.DICTIONARY_VARIABLES) return true;
    if (termTypeGroup == TermTypeGroups.METABOLITE_INTENSITY) return true;
    if (termTypeGroup == TermTypeGroups.PROTEOME_ABUNDANCE) return true;
    return false;
  }
  async main() {
    if (!this.isTermTypeSupported()) {
      this.dom.holder.style("display", "none");
      return;
    }
    this.dom.input.node().value = "";
    this.dom.input.attr(
      "placeholder",
      // termTypeGroup values cannot cover geneset, thus this check
      // tdbcfg is missing for front vocab?
      `Search ${this.app.vocabApi.termdbConfig?.isGeneSetTermdb ? "Gene Sets" : this.state.termTypeGroup}`
    );
    this.clear();
    this.dom.holder.style("display", this.state.isVisible ? "block" : "none");
  }
  // targetType optional, see vocab.findTerm()
  async doSearch(str) {
    if (!str || str.length < 3) {
      this.clear();
      this.bus.emit("postSearch", []);
      return;
    }
    const data = await this.app.vocabApi.findTerm(
      str,
      this.state.cohortStr,
      this.state.usecase,
      this.state.termTypeGroup
    );
    this.currData = data;
    if (!data.lst || data.lst.length == 0) {
      this.noResult();
    } else {
      this.showTerms(data);
    }
    this.bus.emit("postSearch", data);
  }
};
var searchInit = getCompInit(TermSearch);
function setRenderers4(self2) {
  self2.initUI = (state) => {
    self2.dom.holder.style("display", self2.search && self2.search.isVisible == false ? "none" : "block");
    const searchDiv = self2.dom.holder.append("div").style("text-align", "left");
    self2.dom.input = searchDiv.append("input").attr("type", "search").attr("class", "tree_search").style("width", "250px").style("margin", "10px").style("display", "inline-block").on("input", (0, import_debounce4.debounce)(self2.onInput, 300)).on("keyup", self2.onKeyup);
    self2.dom.resultCntDiv = searchDiv.append("div").style("display", "none");
    if (self2.opts.focus != "off") self2.dom.input.node().focus();
    self2.dom.resultDiv = (self2.opts.resultsHolder || self2.dom.holder).append("div").attr("class", "sjpp_show_scrollbar").style("max-height", "35vh").style("display", "none").style("grid-template-columns", "auto auto");
    const div_term = self2.dom.resultDiv.append("div");
    self2.dom.resultDiv_terms = div_term.append("div").style("border-left", self2.opts.resultsHolder ? "" : "solid 1px rgb(133,182,225)").style("margin", "0px 0px 10px 10px").style("padding-left", "5px");
  };
  self2.noResult = () => {
    self2.clear();
    self2.dom.resultDiv.style("display", "inline-grid");
    self2.dom.resultDiv_terms.append("div").style("padding", "3px 3px 3px 0px").style("opacity", 0.5).text("No match");
  };
  self2.showTerms = (data) => {
    if (self2.opts.disable_terms) {
      data.lst.forEach((t2) => {
        if (t2.disabled) self2.opts.disable_terms.push(t2);
      });
    }
    self2.clear();
    self2.dom.resultDiv.style("display", "inline-grid");
    if (data.lst.length) {
      self2.dom.resultDiv_terms.append("table").selectAll().data(data.lst).enter().append("tr").each(self2.showTerm);
      self2.dom.resultCntDiv.style("display", "inline-block").text(`${data.lst.length} results`);
    }
    self2.focusableResults = [...self2.dom.resultDiv.node().querySelectorAll(".sja_tree_click_term, .sja_menuoption")];
  };
  self2.showTerm = function(term) {
    const tr = select_default(this);
    const button = tr.append("td").text(term.name);
    const uses = isUsableTerm(term, self2.state.usecase, self2.app.vocabApi.termdbConfig);
    if ((self2.opts.click_term || self2.app.opts?.tree?.click_term_wrapper) && uses.has("plot")) {
      if (term && self2.opts.disable_terms?.find((term2) => equals(term, term2))) {
        button.attr("class", "sja_tree_click_term_disabled").style("display", "block").style("padding", "5px 8px").style("margin", "1px 0px").style("opacity", 0.4);
      } else {
        button.attr("class", "ts_pill sja_filter_tag_btn sja_tree_click_term").attr("tabindex", 0).style("display", "block").style("color", "black").style("padding", "5px 8px").style("border-radius", "6px").style("background-color", "#cfe2f3").style("margin", "1px 0px").style("cursor", "default").on("click", () => {
          if (self2.opts.click_term) {
            self2.opts.click_term(term);
          } else {
            self2.app.opts.tree.click_term_wrapper(term);
          }
          self2.clear();
          self2.dom.input.property("value", "");
        }).on("keyup", self2.navInputValueByKeyboard);
      }
      if (term.samplecount !== void 0) {
        tr.append("td").append("div").style("font-size", ".8em").style("display", "inline-block").style("margin-left", "5px").style("color", term.samplecount ? "#777" : "#ddd").text("n=" + term.samplecount);
      }
    } else {
      button.attr("class", "sja_menuoption").attr("tabindex", 0).on("click", () => {
        self2.clear();
        self2.dom.input.property("value", "");
        const expandedTermIds = [root_ID];
        if (term.type && isNonDictionaryType(term.type)) {
          self2.app.dispatch({
            type: "app_refresh",
            state: {
              selectedTerms: [...self2.state.selectedTerms, term]
            }
          });
        } else {
          if (term.__ancestors) {
            expandedTermIds.push(...term.__ancestors);
          }
          if (!self2.app.vocabApi.graphable(term)) expandedTermIds.push(term.id);
          self2.app.dispatch({
            type: "app_refresh",
            state: {
              tree: { expandedTermIds }
            }
          });
        }
      }).on("keyup", self2.navInputValueByKeyboard);
    }
    tr.append("td").text((term.__ancestorNames || []).join(" > ")).style("opacity", 0.5).style("font-size", ".7em");
  };
  self2.clear = () => {
    self2.dom.resultDiv_terms.selectAll("*").remove();
    self2.dom.resultDiv.style("display", "none");
    self2.dom.resultCntDiv.style("display", "none");
  };
}
function setInteractivity2(self2) {
  self2.onKeyup = (event2) => {
    if (event2.key == "ArrowDown" && self2.currData?.lst?.length) {
      self2.dom.resultDiv.select(".sja_tree_click_term, .sja_menuoption").node().focus();
      return;
    }
    if (!keyupEnter(event2)) return;
    self2.onInput(event2);
  };
  self2.onInput = async (event2) => {
    const str = self2.dom.input.property("value");
    try {
      await self2.doSearch(str);
    } catch (e) {
      self2.clear();
      self2.dom.resultDiv.style("display", "inline-grid");
      sayerror(self2.dom.resultDiv_terms, "Error: " + (e.message || e));
      if (e.stack) console.log(e.stack);
    }
  };
  self2.navInputValueByKeyboard = (event2) => {
    if (event2.key == "Enter") event2.target.click();
    else if (event2.key.startsWith("Arrow")) {
      const i3 = self2.focusableResults.findIndex((r) => r === event2.target);
      if (event2.key == "ArrowDown") {
        if (i3 < self2.focusableResults.length - 1) self2.focusableResults[i3 + 1].focus();
        else self2.focusableResults[0].focus();
      } else if (event2.key == "ArrowUp") {
        if (i3 != 0) self2.focusableResults[i3 - 1].focus();
        else self2.focusableResults[self2.focusableResults.length - 1].focus();
      }
    }
  };
}

// termdb/handlers/termCollectionFractionSelection.ts
var numeratorTestId = "sjpp-term-collection-numerator";
var denominatorTestId = "sjpp-term-collection-denominator";
function getRowInputs(tableDiv) {
  const trs = tableDiv.select("tbody").node()?.querySelectorAll("tr") || [];
  return [...trs].map((tr) => ({
    numerator: tr.querySelector(`[data-testid="${numeratorTestId}"]`),
    denominator: tr.querySelector(`[data-testid="${denominatorTestId}"]`)
  }));
}
function getDefaultFractionSelection(termlst) {
  if (!termlst?.length) throw new Error("Cannot configure a fraction from an empty term collection");
  return { numerators: [termlst[0].id], denominators: termlst.map((term) => term.id) };
}
function getFractionSelectionError(selection) {
  if (!selection.denominators || selection.denominators.length < 2) return "Select at least two denominators.";
  if (!selection.numerators?.length) return "Select at least one numerator.";
  if (selection.numerators.some((id3) => !selection.denominators.includes(id3)))
    return "Every numerator must also be selected as a denominator.";
  return void 0;
}
function renderFractionSelection(opts) {
  const { selection } = opts;
  const termlst = opts.termlst || selection.termlst || [];
  if (!termlst.length) throw new Error("Cannot configure a fraction from an empty term collection");
  const tableDiv = opts.holder.append("div").attr("data-testid", "sjpp-term-collection-fraction-selection");
  const isNumerator = (term) => selection.numerators?.includes(term.id) === true;
  const isDenominator = (term) => selection.denominators?.includes(term.id) === true;
  const rows = termlst.map((term) => [
    {},
    {
      html: `<input type="checkbox" data-testid="${numeratorTestId}" ${isNumerator(term) ? "checked" : ""} ${isDenominator(term) ? "" : "disabled"}/>`
    },
    { html: `<input type="checkbox" data-testid="${denominatorTestId}" ${isDenominator(term) ? "checked" : ""}/>` }
  ]);
  renderTable({
    columns: [
      {
        label: termItemType(termlst[0]),
        fillCell: (td, index) => fillTermNameCell(td, termlst[index], opts.propsByTermId)
      },
      { label: "Numerator" },
      { label: "Denominator" }
    ],
    rows,
    div: tableDiv,
    maxWidth: "40vw",
    maxHeight: "40vh",
    striped: false,
    showHeader: true,
    columnButtons: void 0,
    buttons: void 0
  });
  const selectBtn = opts.selectCallback ? opts.holder.append("div").style("padding", "6px 20px").append("button").attr("data-testid", "sjpp-term-collection-fraction-select").text(opts.buttonLabel || "Select").on("click", () => opts.selectCallback(selection)) : void 0;
  const updateSelectBtn = () => {
    if (!selectBtn) return;
    const error = getFractionSelectionError(selection);
    selectBtn.property("disabled", Boolean(error)).attr("title", error || null);
  };
  const inputs = getRowInputs(tableDiv);
  const updateSelection = () => {
    selection.denominators = termlst.filter((_, i3) => inputs[i3]?.denominator?.checked === true).map((term) => term.id);
    selection.numerators = termlst.filter((_, i3) => inputs[i3]?.numerator?.checked === true).map((term) => term.id);
    updateSelectBtn();
    opts.onChange?.();
  };
  for (const { numerator, denominator } of inputs) {
    if (!numerator || !denominator) continue;
    denominator.addEventListener("change", () => {
      numerator.disabled = !denominator.checked;
      if (!denominator.checked) numerator.checked = false;
      updateSelection();
    });
    numerator.addEventListener("change", updateSelection);
  }
  updateSelectBtn();
}
function fillTermNameCell(td, term, propsByTermId) {
  const color = propsByTermId?.[term.id]?.color || term.color;
  if (color) {
    td.append("span").attr("data-testid", "sjpp-term-collection-member-color").style("display", "inline-block").style("width", "10px").style("height", "10px").style("margin-right", "5px").style("background-color", color);
  }
  td.append("span").text(term.name || term.id);
}
function pickCollectionFraction(opts) {
  const { term } = opts;
  const selection = getDefaultFractionSelection(term.termlst);
  renderFractionSelection({
    holder: opts.holder,
    termlst: term.termlst,
    selection,
    propsByTermId: term.propsByTermId,
    buttonLabel: opts.buttonLabel,
    // the button is only enabled for an applicable selection, no need to validate here
    selectCallback: () => opts.callback(makeFractionTermWrapper(term, selection))
  });
}
function mayRenderFractionSelection(opts) {
  const { term, listDiv, fractionDiv, callback } = opts;
  if (opts.selectionMode !== "fraction") return false;
  if (term?.type !== TermTypes.TERM_COLLECTION || term.memberType !== "numeric") return false;
  if (!term.termlst?.length) return false;
  fractionDiv.selectAll("*").remove();
  listDiv.style("display", "none");
  fractionDiv.style("display", "");
  fractionDiv.append("div").append("button").attr("data-testid", "sjpp-term-collection-fraction-back").text("\xAB Back").on("click", () => {
    fractionDiv.style("display", "none").selectAll("*").remove();
    listDiv.style("display", "");
  });
  pickCollectionFraction({ holder: fractionDiv, term, callback });
  return true;
}
function makeFractionTermWrapper(term, selection) {
  return {
    type: "TermCollectionTWFraction",
    term,
    q: {
      mode: "continuous",
      numerators: selection.numerators,
      denominators: selection.denominators
    }
  };
}

// termdb/app.ts
var TdbApp = class extends AppBase {
  // expected class-specific props
  constructor(opts, api) {
    super(opts);
    this.type = "app";
    this.components = {};
    this.wasDestroyed = false;
    this.opts = this.validateOpts(this.opts);
    this.api = api;
    this.dom = this.getDom(this.opts);
  }
  static {
    this.type = "app";
  }
  // override AppBase.validateOpts()
  validateOpts(o) {
    if (o.vocabApi) {
    } else if (o.state && o.state.vocab) {
      if (typeof o.state.vocab != "object") throw "opts.state.vocab{} is not an object";
    } else if (o.state && o.state.genome) {
      const s = o.state;
      if (!s.vocab) s.vocab = {};
      s.vocab.genome = s.genome;
      delete s.genome;
      if (s.dslabel) {
        s.vocab.dslabel = s.dslabel;
        delete s.dslabel;
      }
    } else {
      throw "neither state.vocab{} or opts.vocabApi provided";
    }
    if (o.tree) {
      if (o.tree.disable_terms && !o.tree.click_term && !o.tree.click_term2select_tvs && (!o.barchart || !o.barchart.bar_click_override)) {
        throw `opts.tree.disable_terms is used only when opts.tree.click_term, opts.tree.click_term2select_tvs, or opts.barchart.bar_click_override is set`;
      }
      if (!o.search) o.search = {};
      if (o.tree.click_term2select_tvs) {
        o.search.click_term = (term) => this.api.dispatch({
          type: "submenu_set",
          submenu: { term, type: "tvs" }
        });
      }
      if (o.tree.click_term) {
        o.tree.click_term_wrapper = async (term) => {
          if (this.state.termdbConfig.isGeneSetTermdb) {
            const geneset = await dofetch3("termdb", {
              body: {
                genome: this.state.vocab.genome,
                dslabel: this.state.vocab.dslabel,
                genesetByTermId: term.id
              }
            });
            term._geneset = geneset;
          }
          if (this.mayShowFractionSelection(term, o.tree)) return;
          o.tree.click_term(term);
        };
      }
      if (o.tree.disable_terms) o.search.disable_terms = o.tree.disable_terms;
    }
    if (o.app) {
      for (const [k, v] of Object.entries(o.app)) {
        o[k] = v;
      }
      delete o.app;
    }
    return o;
  }
  getDom(opts) {
    if (!opts.holder) select_default("body").append("div");
    const submitDiv = opts.holder.append("div").style("display", opts.tree?.submit_lst ? "" : "none").style("text-align", "center").style("margin", "10px 5px");
    const submitBtn = submitDiv.append("button").property("disabled", true).on(
      "click",
      () => (
        // state is frozen, must submit non-frozen copies
        this.opts.tree?.submit_lst(this.state.selectedTerms.map((t2) => structuredClone(t2)))
      )
    );
    const topbar = opts.holder.append("div");
    const termTypeSearchDiv = topbar.append("div").style("display", "inline-block");
    const treeDiv = topbar.append("div").style("display", "inline-block").style("vertical-align", "top");
    const fractionDiv = opts.holder.append("div").style("display", "none");
    return {
      topbar,
      fractionDiv,
      holder: opts.holder,
      termTypeSearchDiv,
      searchDiv: treeDiv.append("div"),
      treeDiv: treeDiv.append("div"),
      customTermDiv: treeDiv.append("div").style("margin", "10px"),
      submitDiv,
      submitBtn,
      filterDiv: topbar.append("div").style("display", "none"),
      errdiv: opts.holder.append("div"),
      tip: new Menu({ padding: "5px" })
    };
  }
  /* Render the numerator/denominator chooser for a numeric term collection that was clicked
  	in the tree or dictionary search, matching what the term search handlers do for the same
  	collection types. Returns true when the chooser is shown, in which case the click callback
  	is deferred until the user submits a selection.
  
  	term: the clicked term
  	treeOpts: opts.tree{}, supplies termCollectionSelectionMode and the click_term() callback
  	*/
  mayShowFractionSelection(term, treeOpts) {
    return mayRenderFractionSelection({
      term,
      selectionMode: treeOpts.termCollectionSelectionMode,
      // the tree is hidden, not destroyed, so that the user may back out and select another term
      listDiv: this.dom.topbar,
      fractionDiv: this.dom.fractionDiv,
      callback: (tw) => treeOpts.click_term(tw)
    });
  }
  async preApiFreeze(api) {
    try {
      if (this.opts.vocabApi) {
        api.vocabApi = this.opts.vocabApi;
      } else {
        const state = {
          vocab: this.opts.state.vocab || {
            genome: this.opts.state.genome,
            dslabel: this.opts.state.dslabel
          }
        };
        api.vocabApi = await vocabInit({ app: this.api, state, fetchOpts: this.opts.fetchOpts });
      }
      api.appInit = appInit;
    } catch (e) {
      console.log(e);
      throw e;
    }
  }
  async init() {
    try {
      this.store = await storeInit({ app: this.api, state: this.opts.state });
      this.state = await this.store.copyState();
      this.components = await this.initComponents();
      await this.api.dispatch();
    } catch (e) {
      this.printError(e);
    }
  }
  async initComponents() {
    const header_mode = this.state.nav?.header_mode;
    const compPromises = {
      search: searchInit({
        app: this.api,
        holder: this.dom.searchDiv,
        isVisible: header_mode !== "hide_search"
      }),
      termTypeSearch: TermTypeSearchInit({
        app: this.api,
        holder: this.dom.termTypeSearchDiv,
        topbar: this.dom.topbar,
        genome: this.opts.vocabApi?.app?.opts?.genome,
        click_term: this.opts.tree?.click_term,
        submit_lst: this.opts.tree?.submit_lst,
        termCollectionSelectionMode: this.opts.tree?.termCollectionSelectionMode,
        submitDiv: this.dom.submitDiv
      }),
      tree: treeInit({
        app: this.api,
        holder: this.dom.treeDiv,
        headerDiv: this.dom.headerDiv,
        expandAll: header_mode == "hide_search"
      })
    };
    if (this.opts.tree && this.opts.tree.click_term2select_tvs) {
      compPromises.submenu = submenuInit({
        app: this.api,
        holder: this.dom.holder.append("div").style("display", "none")
      });
    }
    return multiInit(compPromises);
  }
  async main() {
    this.api.vocabApi.main();
    const n = this.state.selectedTerms.length;
    const min = this.opts.tree?.minTermsToSubmit || 1;
    this.dom.submitBtn.property("disabled", n < min).text(
      !n ? "Search or click term(s)" : n < min ? `Select at least ${min} ${min > 1 ? "terms" : "term"}` : `Submit ${n} ${n > 1 ? "terms" : "term"}`
    );
    this.dom.holder.selectAll("search, .termbtn, button").attr("tabindex", 0);
    this.dom.holder.selectAll(".termbtn").on("keyup", (event2) => {
      if (event2.key == "Enter") event2.target.click();
    });
  }
  printError(e) {
    sayerror(this.dom.errdiv, "Error: " + (e.message || e));
    if (e.stack) console.log(e.stack);
  }
};
var appInit = AppApi.getInitFxn(TdbApp);

// dom/select2Terms.js
function select2Terms(tip, app, chartType, detail, callback, detail2) {
  const tip2 = new Menu({
    // creates tip2 on every launch
    padding: "5px",
    parent_menu: tip.d.node()
    // uses tip as parent to avoid hiding tip when toggling tabs inside tip2
  });
  let xterm, yterm;
  let xlab = "X", ylab = "Y";
  if (chartType == "facet") {
    ylab = "Row&nbsp;&nbsp;&nbsp;";
    xlab = "Column";
  }
  const d0 = tip.d.append("div").style("margin", "10px");
  {
    const row2 = d0.append("div");
    row2.append("span").html(xlab + "&nbsp;").style("font-family", "Courier");
    const xdiv = row2.append("div").attr("class", "ts_pill sja_filter_tag_btn").attr("data-testid", chartType == "facet" ? "sjpp-facet-column-selector" : null).style("padding", "3px 6px").style("border-radius", "6px").text("+").on("click", (e) => {
      getTreeTerm(xdiv, (term) => xterm = term, detail);
    });
  }
  {
    const row2 = d0.append("div").style("margin", "1px 0px 5px 0px");
    row2.append("span").html(ylab + "&nbsp;").style("font-family", "Courier");
    const ydiv = row2.append("div").attr("class", "ts_pill sja_filter_tag_btn").attr("data-testid", chartType == "facet" ? "sjpp-facet-row-selector" : null).style("padding", "3px 6px").style("border-radius", "6px").text("+").on("click", (e) => {
      getTreeTerm(ydiv, (term) => yterm = term, detail2 || detail);
    });
  }
  const row = d0.append("div");
  const submitBtn = row.append("button").attr("data-testid", chartType == "facet" ? "sjpp-facet-submit" : null).text("Submit").property("disabled", true).on("click", () => {
    callback(xterm, yterm);
    tip.hide();
  });
  row.append("span").html("&nbsp;Select two variables to plot").style("opacity", 0.6).style("font-size", ".7em");
  function getTreeTerm(div, callback2, detail3) {
    const disable_terms = [];
    if (xterm) disable_terms.push(xterm);
    if (yterm) disable_terms.push(yterm);
    appInit({
      holder: tip2.clear().showunder(div.node()).d,
      vocabApi: app.vocabApi,
      state: {
        activeCohort: app.getState().activeCohort,
        tree: { usecase: { detail: detail3, target: chartType } }
      },
      tree: {
        disable_terms,
        click_term: (term) => {
          const t2 = term.term || term;
          callback2(t2);
          tip2.hide();
          div.text(t2.name);
          if (xterm != null && yterm != null) submitBtn.property("disabled", false);
        }
      }
    });
  }
}

// dom/shapes.js
var shapes = {
  //circle filled
  filledCircle: {
    path: "M 8,8 m 8,0 a 8,8 0 1,0 -16,0 a 8,8 0 1,0 16,0",
    calculatePath: (opts) => {
      const _opts = { radius: 16 };
      Object.assign(_opts, opts);
      const { radius } = _opts;
      return `M${radius},0 A${radius},${radius} 0 1,1 ${-radius},0 A${radius},${radius} 0 1,1 ${radius},0 Z`;
    },
    isFilled: true
  },
  //rectangle empty
  // https://icons.getbootstrap.com/icons/file/
  emptyVerticalRectangle: {
    path: "M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1",
    calculatePath: (opts) => {
      const _opts = { height: 16, width: 16 };
      Object.assign(_opts, opts);
      const { width, height } = _opts;
      return `M-${width / 2},-${height / 2}h${width}v${height}h-${width}z`;
    },
    isFilled: false
  },
  //circle empty
  //https://icons.getbootstrap.com/icons/circle/
  emptyCircle: {
    path: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16",
    calculatePath: (opts) => {
      const _opts = { radius: 16 };
      Object.assign(_opts, opts);
      const { radius } = _opts;
      return `M${radius},0 A${radius},${radius} 0 1,1 ${-radius},0 A${radius},${radius} 0 1,1 ${radius},0 Z`;
    },
    isFilled: false
  },
  // shield empty
  // https://icons.getbootstrap.com/icons/shield/
  emptyShield: {
    path: "M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56",
    calculatePath: (opts) => {
      const _opts = { width: 16, height: 24 };
      Object.assign(_opts, opts);
      const { width, height } = _opts;
      const halfWidth = width / 2;
      const arcRadius = halfWidth;
      return `M-${halfWidth},-${height / 2} A${arcRadius},${arcRadius} 0 0,1 ${halfWidth},-${height / 2} L${halfWidth},${height * 0.1} L0,${height / 2} L-${halfWidth},${height * 0.1} Z`;
    },
    isFilled: false
  },
  // triangle filled
  // https://icons.getbootstrap.com/icons/triangle-fill/
  filledTriangle: {
    path: "M7.022 1.566a1.13 1.13 0 0 1 1.96 0l6.857 11.667c.457.778-.092 1.767-.98 1.767H1.144c-.889 0-1.437-.99-.98-1.767z",
    calculatePath: (opts) => {
      const _opts = { height: 16, width: 16, isUp: true };
      Object.assign(_opts, opts);
      const { width, height, isUp } = _opts;
      const xOffset = width / 2;
      const yOffset = height / 2;
      const p1 = isUp ? `M0,-${yOffset}` : `M0,${yOffset}`;
      const p2 = isUp ? `L${xOffset},${yOffset}` : `L${xOffset},-${yOffset}`;
      const p3 = isUp ? `L-${xOffset},${yOffset}` : `L-${xOffset},-${yOffset}`;
      return `${p1} ${p2} ${p3} Z`;
    },
    isFilled: true
  },
  //triangle empty
  //https://icons.getbootstrap.com/icons/triangle/
  emptyTriangle: {
    path: "M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z",
    calculatePath: (opts) => {
      const _opts = { height: 16, width: 16, isUp: true };
      Object.assign(_opts, opts);
      const { width, height, isUp } = _opts;
      const xOffset = width / 2;
      const yOffset = height / 2;
      const p1 = isUp ? `M0,-${yOffset}` : `M0,${yOffset}`;
      const p2 = isUp ? `L${xOffset},${yOffset}` : `L${xOffset},-${yOffset}`;
      const p3 = isUp ? `L-${xOffset},${yOffset}` : `L-${xOffset},-${yOffset}`;
      return `${p1} ${p2} ${p3} Z`;
    },
    isFilled: false
  },
  //shield filled
  filledShield: {
    path: "M5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56",
    isFilled: true
  },
  //diamond filled
  filledDiamond: {
    path: "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098z",
    isFilled: true
  },
  //cross large
  largeCross: {
    path: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
  },
  //diamond empty
  emptyDiamond: {
    path: "M8.384 1.226a.463.463 0 0 0-.768 0l-4.56 6.468a.54.54 0 0 0 0 .612l4.56 6.469a.463.463 0 0 0 .768 0l4.56-6.469a.54.54 0 0 0 0-.612zM6.848.613a1.39 1.39 0 0 1 2.304 0l4.56 6.468a1.61 1.61 0 0 1 0 1.838l-4.56 6.468a1.39 1.39 0 0 1-2.304 0L2.288 8.92a1.61 1.61 0 0 1 0-1.838z",
    isFilled: false
  },
  //plus
  plusIcon: {
    path: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
  },
  // egg filled
  filledEgg: {
    path: "M14 10a6 6 0 0 1-12 0C2 5.686 5 0 8 0s6 5.686 6 10",
    isFilled: true
  },
  //pentagon filled
  filledPentagon: {
    path: "M7.685.256a.5.5 0 0 1 .63 0l7.421 6.03a.5.5 0 0 1 .162.538l-2.788 8.827a.5.5 0 0 1-.476.349H3.366a.5.5 0 0 1-.476-.35L.102 6.825a.5.5 0 0 1 .162-.538l7.42-6.03Z",
    isFilled: true
  },
  //egg empty
  emptyEgg: {
    path: "M8 15a5 5 0 0 1-5-5c0-1.956.69-4.286 1.742-6.12.524-.913 1.112-1.658 1.704-2.164C7.044 1.206 7.572 1 8 1s.956.206 1.554.716c.592.506 1.18 1.251 1.704 2.164C12.31 5.714 13 8.044 13 10a5 5 0 0 1-5 5m0 1a6 6 0 0 0 6-6c0-4.314-3-10-6-10S2 5.686 2 10a6 6 0 0 0 6 6",
    isFilled: false
  },
  //pentagon empty
  emptyPentagon: {
    path: "M7.685 1.545a.5.5 0 0 1 .63 0l6.263 5.088a.5.5 0 0 1 .161.539l-2.362 7.479a.5.5 0 0 1-.476.349H4.099a.5.5 0 0 1-.476-.35L1.26 7.173a.5.5 0 0 1 .161-.54l6.263-5.087Zm8.213 5.28a.5.5 0 0 0-.162-.54L8.316.257a.5.5 0 0 0-.631 0L.264 6.286a.5.5 0 0 0-.162.538l2.788 8.827a.5.5 0 0 0 .476.349h9.268a.5.5 0 0 0 .476-.35l2.788-8.826Z",
    isFilled: false
  },
  //suit diamond filled
  filledDiamondSuit: {
    path: "M2.45 7.4 7.2 1.067a1 1 0 0 1 1.6 0L13.55 7.4a1 1 0 0 1 0 1.2L8.8 14.933a1 1 0 0 1-1.6 0L2.45 8.6a1 1 0 0 1 0-1.2",
    isFilled: true
  },
  //square empty
  //https://icons.getbootstrap.com/icons/square/
  emptySquare: {
    path: "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z",
    calculatePath: (opts) => {
      const _opts = { height: 16, width: 16 };
      Object.assign(_opts, opts);
      const { width, height } = _opts;
      return `M-${width / 2},-${height / 2} h${width} v${height} h-${width} Z`;
    },
    isFilled: false
  },
  //suit diamond empty
  emptyDiamondSuit: {
    path: "M6.95.435c.58-.58 1.52-.58 2.1 0l6.515 6.516c.58.58.58 1.519 0 2.098L9.05 15.565c-.58.58-1.519.58-2.098 0L.435 9.05a1.48 1.48 0 0 1 0-2.098zm1.4.7a.495.495 0 0 0-.7 0L1.134 7.65a.495.495 0 0 0 0 .7l6.516 6.516a.495.495 0 0 0 .7 0l6.516-6.516a.495.495 0 0 0 0-.7L8.35 1.134z",
    isFilled: false
  },
  //cross
  crossShape: {
    path: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
  },
  //square filled
  // https://icons.getbootstrap.com/icons/square-fill/
  filledSquare: {
    path: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z",
    calculatePath(opts) {
      const _opts = { height: 16, width: 16 };
      Object.assign(_opts, opts);
      const { width, height } = _opts;
      return `M-${width / 2},-${height / 2} h${width} v${height} h-${width} Z`;
    },
    isFilled: true
  },
  //rectangle filled
  // https://icons.getbootstrap.com/icons/file-fill/
  filledVerticalRectangle: {
    path: "M4 0h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2",
    calculatePath: (opts) => {
      const _opts = { height: 16, width: 16 };
      Object.assign(_opts, opts);
      const { width, height } = _opts;
      return `M-${width / 2},-${height / 2}h${width}v${height}h-${width}z`;
    },
    isFilled: true
  }
};
var shapesArray = Object.values(shapes).map((shape) => shape.path);
function shapeSelector(div, callback, arr = shapesArray, opts = {}) {
  const size = 20;
  const cols = 8;
  const height = Math.ceil(arr.length / cols) * size;
  div.style("background-color", "backgroundColor" in opts ? opts.backgroundColor : "white");
  const svg = div.append("div").style("padding", "5px").append("svg").attr("width", size * cols).attr("height", height);
  let count = 0;
  let y = 0;
  for (const shape of arr) {
    const index = count + y * cols;
    const shapeG = svg.append("g").attr("transform", `translate(${size * count}, ${y * size})`);
    shapeG.append("rect").attr("width", size).attr("height", size).attr("fill", "transparent").style("pointer-events", "all");
    shapeG.append("path").style("fill", "gray").attr("d", shape);
    shapeG.on("mouseover", function() {
      select_default(this).select("path").style("fill", "black");
    });
    shapeG.on("mouseout", function() {
      select_default(this).select("path").style("fill", "gray");
    });
    shapeG.on("click", () => {
      callback(index);
    });
    count++;
    if (count % cols == 0) {
      count = 0;
      y++;
    }
  }
}

// dom/ssmLink.ts
function makeSsmLink(ssm_urls, m, variantNameDom, genome) {
  const separateUrls = [];
  if (Array.isArray(ssm_urls)) {
    for (const ssm_url of ssm_urls) {
      if (ssm_url.namekey == "regulomedb") {
        if (typeof m.chr == "string" && m.pos !== void 0 && Number.isInteger(m.pos)) {
          const coord = `${m.chr}%3A${m.pos}-${m.pos + 1}`;
          separateUrls.push(
            `<a href="${ssm_url.base}regions=${coord}&genome=${genome == "hg38" ? "GRCh38" : genome}" target="_blank">${ssm_url.linkText}</a>`
          );
        }
        continue;
      }
      makeGeneralLink(ssm_url, m, variantNameDom, separateUrls);
    }
  } else {
    makeGeneralLink(ssm_urls, m, variantNameDom, separateUrls);
  }
  return separateUrls;
}
function makeGeneralLink(ssm_url, m, variantNameDom, separateUrls) {
  const mValue = m[ssm_url.namekey];
  if (mValue == void 0) return;
  const url = ssm_url.base + mValue;
  if (ssm_url.shownSeparately) {
    separateUrls.push(`<a href="${url}" target="_blank">${ssm_url.linkText || mValue}</a>`);
    return;
  }
  variantNameDom.html(`<a href="${url}" target="_blank">${variantNameDom.html()}</a>`);
}

// dom/strFormatHelpers.ts
function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

// dom/svg.legend.js
function svgLegend(opts) {
  let currlinex = 0;
  let currliney = 0;
  let currG;
  const defaultSettings = {
    ontop: false,
    lineh: 25,
    padx: 5,
    padleft: 0,
    //150,
    padright: 20,
    padbtm: 30,
    fontsize: 12,
    iconh: 10,
    iconw: 10,
    hangleft: 1,
    linesep: false,
    mutationorder: [
      "M",
      "E",
      "F",
      "N",
      "S",
      "D",
      "I",
      "P",
      "L",
      "Intron",
      "ITD",
      "DEL",
      "NLOSS",
      "CLOSS",
      "Utr3",
      "Utr5",
      "X",
      "noncoding",
      "Fuserna",
      "SV",
      "CNV_amplification",
      "CNV_homozygous_deletion",
      "CNV_amp",
      "CNV_loss",
      "CNV_loh",
      "snv",
      "mnv"
    ],
    itemOpacity: 1
  };
  const settings = Object.assign(defaultSettings, opts.settings || {});
  function render(data, overrides = {}) {
    Object.assign(settings, overrides.settings || {});
    currlinex = settings.padleft;
    currliney = 0;
    opts.holder.selectAll("g").remove();
    opts.holder.selectAll("text").remove();
    const d = settings.dimensions;
    if (!opts.holder.attr("transform")) {
      opts.holder.attr("transform", settings.ontop ? null : `translate(${d.xOffset},${settings.svgh})`);
    }
    if (opts.note && data.length) {
      opts.holder.append("text").style("font-size", "0.8em").text(opts.note).attr("transform", `translate(-135, 15)`).attr("font-style", "italic");
    }
    const l = opts.holder.selectAll("g").data(data);
    l.exit().remove();
    l.enter().append("g").each(addGroup);
    return currliney + settings.lineh + settings.padbtm;
  }
  function addGroup(d, i3) {
    if (!d.items || !d.items.length) return;
    currlinex = 0;
    currliney += settings.lineh;
    let g = select_default(this).style("opacity", d.crossedOut ? "0.6" : 1);
    if (d.id) g = g.attr("id", d.id);
    if (d.class) g = g.attr("class", d.class);
    const leftdist = settings.hangleft ? settings.padleft + settings.hangleft - settings.padx : settings.padleft;
    const grplabel = g.append("text").attr("transform", "translate(" + leftdist + "," + (currliney + settings.iconh / 2) + ")").attr("text-anchor", settings.hangleft ? "end" : "start").attr("font-weight", 700).attr("font-size", settings.fontsize).attr("dominant-baseline", "central").text(d.name).style("text-decoration", d.crossedOut ? "line-through" : "");
    if (settings.linesep) {
      currlinex = settings.padleft;
      currliney += settings.lineh;
    } else if (d.hasScale || settings.hangleft) {
      currlinex = leftdist + 2 * settings.padx;
    } else {
      currlinex += settings.padleft + grplabel.node().getBBox().width + 2 * settings.padx;
    }
    d.itemStartX = currlinex;
    if (d.sorter) d.items.sort(d.sorter);
    g.selectAll("g").data(d.items).enter().append("g").each(addItem);
    const bbox = grplabel.node().getBBox();
    if (Math.abs(bbox.y + bbox.height / 2) > 1) {
      grplabel.attr("y", bbox.height / 4);
    }
  }
  function addItem(d, i3) {
    const g = select_default(this).style("opacity", settings.itemOpacity).style("opacity", d.greyedOut ? "0.6" : 1);
    if (d.newLine) {
      currliney += settings.lineh;
      const groupData = this.parentNode ? this.parentNode.__data__ : null;
      const leftdist = !settings.hangleft ? settings.padleft : settings.padleft + settings.hangleft + settings.padx;
      currlinex = groupData && groupData.itemStartX != null ? groupData.itemStartX : leftdist;
    }
    g.attr("transform", "translate(" + currlinex + "," + currliney + ")");
    const itemlabel = g.append("text").attr("transform", "translate(" + (settings.iconw + settings.padx / 2) + "," + settings.iconh / 2 + ")").attr("font-size", settings.fontsize).attr("dominant-baseline", "central").style("cursor", "default").style(
      "text-decoration",
      settings.exclude && settings.exclude.classes && settings.exclude.classes.includes(d.class) || d.crossedOut ? "line-through" : ""
    );
    itemlabel.each(function(d2) {
      const t2 = select_default(this);
      if (settings.isExcludedAttr && d2[settings.isExcludedAttr]) {
        t2.style("text-decoration", "line-through").style("opacity", 0.5);
      }
      if (typeof d2.text == "string") {
        t2.text(d2.text);
      } else if (Array.isArray(d2.text)) {
        t2.selectAll("tspan").data(d2.text).enter().append("tspan").text((d3) => d3).attr("dominant-baseline", "central").attr("x", function(dd, i4) {
          if (i4 == 0) {
            select_default(this).attr("font-weight", 700);
            d2.lastx = select_default(this).node().getComputedTextLength() + 10;
            return 0;
          } else if (d2.lastx) {
            return d2.lastx;
          }
        });
      }
      if (d2.onClickCallback) {
        t2.on("click", () => d2.onClickCallback(d2, t2));
        t2.style("cursor", "pointer");
      }
    });
    const bbox = itemlabel.node().getBBox();
    let width = d.width || settings.iconw;
    if (d.colorPicker) {
      width += (d.inputWidth || 30) + settings.padx;
    }
    if (d.skipIcon) width = 0;
    currlinex += bbox.width + width;
    if (settings.linesep || currlinex > settings.svgw - settings.padright) {
      currliney += settings.lineh;
      const leftdist = !settings.hangleft ? settings.padleft : settings.padleft + settings.hangleft + settings.padx;
      g.attr("transform", "translate(" + leftdist + "," + currliney + ")");
      currlinex = bbox.width + width + settings.padleft;
      if (settings.hangleft) currlinex = settings.iconw + bbox.width + leftdist;
      else currlinex = width + bbox.width + settings.padleft;
    }
    const y = settings.fontsize - bbox.height + (bbox.height - settings.iconh) / 2;
    let colorGradientId;
    if (d.domain) {
      colorGradientId = `sjpp-linear-gradient-${getId()}`;
      const domain = d.domain || [d.minLabel, d.maxLabel];
      const yPos = y + 3;
      const min = d.domain[0];
      const max = d.domain[d.domain.length - 1];
      const domainRange = Math.abs(max - min);
      const tickFontSize = 0.82 * settings.fontsize;
      const tickLabels = [`${min}`, `${max}`];
      const maxLabelLen = Math.max(...tickLabels.map((l) => l.length));
      const measured = getMaxLabelWidth(g, tickLabels, tickFontSize / 16);
      const maxTickLabelWidth = (measured || maxLabelLen * 0.6 * tickFontSize) + 0.6 * tickFontSize;
      const fitTicks = Math.max(2, Math.floor(width / maxTickLabelWidth));
      const opts2 = {
        barwidth: width,
        barheight: settings.iconh,
        colors: d.colors || d.scale.range() || ["white", "grey"],
        domain,
        fontSize: 0.82 * settings.fontsize,
        /** Must separate the color scale from the label for
         * event handlers (e.g. if click behavior on the label
         * is different than click behavior on the color scale itself)*/
        holder: g.append("g"),
        id: colorGradientId,
        position: `${bbox.width + 25},${yPos}`,
        ticks: Math.min(computeTicks(domainRange, 2), fitTicks),
        tickSize: 2,
        topTicks: true
      };
      if (d.labels) {
        opts2.labels = d.labels;
        if (d.text) opts2.position = `${bbox.width + bbox.x + 45 + settings.padx},${yPos}`;
      }
      if (d.numericInputs) opts2.numericInputs = d.numericInputs;
      new ColorScale(opts2);
      if (opts2.labels) currlinex += bbox.width + 25 + 15 * settings.padx;
      else currlinex += 10 * settings.padx;
    } else {
      if (d.colorPicker) {
        const inputHeight = d.inputHeight || settings.iconh + 6;
        const inputWidth = d.inputWidth || 30;
        const colorInput = g.append("foreignObject").attr("x", bbox.width + settings.padx).attr("y", y + settings.iconh / 2 - inputHeight / 2).attr("width", inputWidth).attr("height", inputHeight).append("xhtml:input").attr("type", "color").attr("value", d.color || "#4d4d4d").style("width", `${inputWidth}px`).style("height", `${inputHeight}px`).style("padding", "0").style("border", "1px solid #ccc").style("border-radius", "4px");
        if (typeof d.onColorChange === "function") {
          colorInput.on("change", (event2) => {
            d.onColorChange(event2.target.value);
          });
        }
      } else if (!d.skipIcon) {
        g.append("rect").attr("height", settings.iconh).attr("width", width).attr("y", y).attr("fill", colorGradientId ? `url(#${colorGradientId})` : opts.rectFillFxn).attr("stroke", opts.iconStroke).attr("shape-rendering", "crispEdges");
        currlinex += 2.5 * settings.padx;
      }
    }
    if (Math.abs(bbox.y + bbox.height / 2) > 1) {
      itemlabel.attr("y", bbox.height / 4);
    }
  }
  return render;
}
var i2 = 0;
function getId() {
  return `${i2++}-${Date.now().toString().slice(-6)}-${Math.random().toString().slice(-6)}`;
}

// dom/svg.scroll.js
function svgScroll(_opts) {
  if (!_opts.holder) throw `missing svgScroll.opts.holder argument`;
  const defaults3 = {
    height: 12,
    zoomLevel: 1,
    opacity: 0.3
  };
  const opts = Object.assign({}, defaults3, _opts);
  function scrollInit(e) {
    ref.x = e.clientX;
    select_default("body").on("mousemove.sjppSvgScroll", scrollMove).on("mouseup.sjppSvgScroll", scrollStop);
  }
  function scrollMove(e) {
    if (!("x" in ref)) return;
    const dx = e.clientX - ref.x;
    if (ref.sliderX + ref.sliderWidth + dx > opts.visibleWidth - 1) {
      return;
    }
    if (ref.sliderX + dx < 0) {
      return;
    }
    slider.attr("x", ref.sliderX + dx);
    opts.callback(ref.dxFactor * dx, "move");
  }
  function scrollStop(e) {
    if (!("x" in ref)) return;
    const dx = e.clientX - ref.x;
    opts.callback(ref.dxFactor * Math.min(ref.maxDx, Math.max(dx, ref.minDx)), "up");
    delete ref.x;
    select_default("body").on("mousemove.sjppSvgScroll", null).on("mouseup.sjppSvgScroll", null);
  }
  function scrollByClick(e) {
    ref.x = e.clientX;
    const i3 = e.clientX < slideElem.getBoundingClientRect().x ? -1 : 1;
    scrollStop({ clientX: Math.floor(ref.x + i3 * ref.arrowDx) });
  }
  opts.holder.attr("display", "none").attr("opacity", opts.opacity).on("mouseover", () => opts.holder.attr("opacity", 1)).on("mouseout", () => opts.holder.attr("opacity", opts.opacity));
  const rect = opts.holder.append("rect").style("height", opts.height).style("stroke", "none").style("fill", "#fff").on("click", scrollByClick);
  const line = opts.holder.append("line").style("stroke", "#ccc").style("stroke-width", 1).on("click", scrollByClick);
  const leftArrow = opts.holder.append("path").attr("y", -opts.height).attr("d", `M0,${opts.height / 2}L${opts.height},0L${opts.height},${opts.height}Z`).style("stroke", "#ccc").style("stroke-width", 1).style("fill", "#ccc").on("click", (e) => {
    ref.x = e.clientX;
    scrollStop({ clientX: Math.round(ref.x - ref.arrowDx) });
  });
  const rtArrow = opts.holder.append("path").attr("y", -opts.height).style("stroke", "#ccc").style("stroke-width", 1).style("fill", "#ccc").attr("d", `M0,0L${opts.height},${opts.height / 2}L0,${opts.height}Z`).on("click", (e) => {
    ref.x = e.clientX;
    scrollStop({ clientX: Math.round(ref.x + ref.arrowDx) });
  });
  const sliderHt = opts.height - 4;
  const slider = opts.holder.append("rect").attr("y", 2).attr("height", sliderHt).attr("stroke", "#aaa").attr("stroke-width", 1).attr("fill", "#ccc").attr("rx", sliderHt / 2).on("mousedown", scrollInit).on("mousemove", scrollMove).on("mouseup", scrollStop);
  const slideElem = slider.node();
  const ref = {};
  const api = {
    update(_opts2) {
      const prev = { v: opts.visibleWidth, t: opts.totalWidth, z: opts.zoomCenter };
      Object.assign(opts, _opts2);
      const t2 = opts.totalWidth;
      const v = opts.visibleWidth;
      if (t2 <= v) {
        opts.holder.attr("display", "none");
        return;
      }
      opts.holder.attr("transform", `translate(${opts.x},${opts.y})`).attr("display", "");
      rect.attr("width", v);
      line.attr("x1", 0).attr("x2", v).attr("y1", opts.height / 2).attr("y2", opts.height / 2);
      leftArrow.attr("transform", `translate(0,0)`);
      rtArrow.attr("transform", `translate(${v - opts.height},0)`);
      if (v != prev.v || t2 != prev.t) {
        ref.sliderWidth = v * v / t2;
        ref.dxFactor = (t2 - v) / (v - ref.sliderWidth);
      }
      const center = v * (opts.zoomCenter / t2);
      ref.sliderX = Math.max(0, Math.min(center - ref.sliderWidth / 2, v - ref.sliderWidth - 1));
      slider.attr("width", ref.sliderWidth).attr("x", ref.sliderX);
      ref.maxDx = opts.visibleWidth - ref.sliderX - ref.sliderWidth;
      ref.minDx = -ref.sliderX;
      ref.arrowDx = Math.round(0.1 * opts.visibleWidth);
      delete ref.x;
    }
  };
  return api;
}

// dom/svgSeriesTips.js
function getSeriesTip(line, rect, _tip = null) {
  const tip = _tip || new Menu({ padding: "5px" });
  line.style("display", "none");
  const rectNode = rect.style("fill", "transparent").node();
  function mouseOver(event2) {
    const m = pointer_default(event2, rectNode);
    const mx = m[0];
    const xVal = +opts.xScale.invert(mx).toFixed(opts.decimals);
    const x = opts.xScale(xVal);
    line.style("display", "").attr("stroke", "#aaa").attr("stroke-dasharray", 4).attr("x1", x).attr("x2", x);
    const seriesHtmls = [];
    for (const series of opts.serieses) {
      const data = series.data;
      const data_x = data.map((d) => d.x);
      if (xVal >= Math.min(...data_x) && xVal <= Math.max(...data_x)) {
        const max = Math.max(...data_x.filter((x2) => x2 <= xVal));
        const timepoint = data.find((d) => d.x == max);
        if (timepoint) seriesHtmls.push(timepoint.html);
      }
    }
    if (seriesHtmls.length) {
      tip.show(event2.clientX, event2.clientY).d.html(`<span>${opts.xTitleLabel}: ${xVal}</span><br>` + seriesHtmls.map((d) => d).join(opts.separator));
    } else {
      tip.hide();
    }
  }
  rect.on("mouseover", mouseOver).on("mousemove", mouseOver).on("mouseout", () => {
    line.style("display", "none");
    tip.hide();
  });
  const opts = {
    separator: "<br>",
    decimals: 1
  };
  return {
    /*
    			Will update the length of the vertical line
    			and reassign optional data values
    
    			!!! MUST call api.update() before the expected mouseover event,
    			so that the line will have the proper length and the mouse
    			position could be computed with .xScale !!! 
    
    			_opts{}
    			.xScale					required
    										the d3-scale object that was used for the rect dimensions
    										
    			.xTitleLabel			required
    										title of x-axis
    										will be used as label of x-value in tooltip
    
    			.serieses[{data}] 		required
    										array of series objects, assumed to be visibly rendered
    							
    				.data[{x, html}]	required
    										array of data objects
    										the series data that is currently rendered in the chart
    					
    					.x 				required, float
    										the datapoint's actual, unscaled x value
    					
    					.html   		required, string
    										the HTML to display in the tooltip if this datapoint's 
    										x value matched the vertical line's position
    
    			.separator				optional, string
    										the html to be used to join the series html strings when displayed in the tooltip
    
    			.decimals				optional, number
    										number of decimal places of the datapoint's x-value
    										will control the precision of the vertical line
    		*/
    update(_opts = {}) {
      Object.assign(opts, _opts);
      const x = rect.attr("x");
      const y = rect.attr("y");
      line.attr("x1", x).attr("x2", x).attr("y1", y).attr("y2", rect.attr("height") - y);
    },
    /*
    	detroy to help minimize memory leaks
    	from elements and event handlers not being garbage collected
    	because of non-deactivated references
    */
    destroy() {
      rect.on("mouseover", null).on("mousemove", null).on("mouseout", null);
    }
  };
}

// dom/table2col.js
function table2col(arg) {
  const scrollDiv = arg.holder.append("div").style("max-width", "80vw");
  const table = scrollDiv.append("table").style("margin", arg.margin || "5px 8px").attr("class", "sja_simpletable").attr("data-testid", arg.testid || "sja_simpletable");
  return {
    scrollDiv,
    table,
    addRow: (text1, text2) => {
      if (table.node().offsetHeight > 500 && !arg.disableScroll) {
        scrollDiv.style("height", "450px").style("resize", "both").style("overflow-y", "scroll").attr("class", "sjpp_show_scrollbar");
      }
      const tr = table.append("tr");
      const td1 = tr.append("td").style("padding", arg.cellPadding || "3px").style("color", "#555");
      const td2 = tr.append("td").style("padding", arg.cellPadding || "3px");
      if (text1 != void 0) td1.text(text1);
      if (text2 != void 0) td2.text(text2);
      return [td1, td2];
    }
  };
}
function make_table_2col(holder, data, overlen) {
  const color = "#9e9e9e";
  const table = holder.append("table").style("margin", "5px 8px").style("font-size", "inherit").attr("class", "sja_simpletable");
  for (const i3 of data) {
    const tr = table.append("tr");
    if (i3.kvlst) {
      tr.append("td").attr("rowspan", i3.kvlst.length).style("padding", "3px").style("color", color).html(i3.k);
      tr.append("td").style("padding", "3px").style("color", color).html(i3.kvlst[0].k);
      tr.append("td").style("padding", "3px").html(i3.kvlst[0].v);
      for (let j = 1; j < i3.kvlst.length; j++) {
        const tr2 = table.append("tr");
        tr2.append("td").style("padding", "3px").style("color", color).html(i3.kvlst[j].k);
        tr2.append("td").style("padding", "3px").html(i3.kvlst[j].v);
      }
    } else {
      tr.append("td").attr("colspan", 2).style("padding", "3px").style("color", color).html(i3.k);
      const td = tr.append("td").style("padding", "3px");
      if (overlen && i3.v.length > overlen) {
        td.html(i3.v.substr(0, overlen - 3) + " ...&raquo;").attr("class", "sja_clbtext").on("click", () => {
          td.html(i3.v).classed("sja_clbtext", false).on("click", null);
        });
      } else {
        td.html(i3.v);
      }
    }
  }
  return table;
}

// dom/toggleButtons.ts
var activeColor = "#1575ad";
var inactiveColor = "#757373";
var Tabs = class {
  constructor(opts) {
    this.opts = this.validateOpts(opts);
    this.tabs = opts.tabs;
    this.dom = {
      holder: opts.holder
    };
    this.defaultTabWidth = 90;
    setRenderers5(this);
  }
  validateOpts(opts) {
    if (!opts.holder) throw `missing opts.holder for Tabs()`;
    if (!Array.isArray(opts.tabs)) throw `invalid opts.tabs array for Tabs()`;
    if (!opts.tabsPosition) opts.tabsPosition = "horizontal";
    if (opts.tabsPosition != "horizontal" && opts.tabsPosition != "vertical")
      throw `Invalid .tabsPosition arg. Must be either vertical or horizontal`;
    if (!opts.linePosition) {
      opts.linePosition = opts.tabsPosition == "horizontal" ? "bottom" : "right";
    }
    if (opts.linePosition != "bottom" && opts.linePosition != "top" && opts.linePosition != "right" && opts.linePosition != "left")
      throw `Invalid .linePosition arg. Must be either bottom, top, right, or left`;
    return opts;
  }
  async main() {
    try {
      await this.render();
    } catch (e) {
      if (e.stack) console.log(e.stack);
      else throw e;
    }
  }
};
function setRenderers5(self2) {
  self2.render = async () => {
    const has_active_tab = self2.tabs.find((tab) => tab.active);
    if (!has_active_tab) self2.tabs[0].active = true;
    const textAlign = self2.opts.linePosition == "bottom" || self2.opts.linePosition == "top" ? "center" : self2.opts.linePosition;
    self2.dom.tabsHolder = self2.dom.holder.append("div").style(`border-${self2.opts.linePosition}`, "0.5px solid #1575ad");
    if (!self2.dom.contentHolder && !self2.opts.noContent) {
      self2.dom.contentHolder = self2.opts.contentHolder || self2.dom.holder.append("div");
    }
    if (self2.opts.tabsPosition == "vertical") {
      self2.dom.tabsHolder.style("display", "inline-grid").style("align-items", "start").style("gap", self2.opts.gap || "");
      self2.dom.contentHolder.style("display", "inline-block").style("vertical-align", "top").style("position", "relative");
    } else self2.dom.tabsHolder.style("display", "inline-block");
    await self2.dom.tabsHolder.selectAll("button").data(self2.tabs).enter().append("button").attr("data-testid", (d) => d.testid || "sja_toggle_button").attr("class", "sj-toggle-button").classed("sjpp-active", (tab) => tab.active).style("padding", "0px").style("width", (tab) => tab.width ? `${tab.width}px` : "fit-content").style("min-width", (tab) => tab.width ? null : Math.max(self2.defaultTabWidth)).style("border", "none").style("background-color", "transparent").style("display", (tab) => {
      if (!tab.isVisible || tab.isVisible()) return self2.opts.tabsPosition == "vertical" ? "flex" : "inline-grid";
      else return "none";
    }).property("disabled", (tab) => tab.disabled ? tab.disabled() : false).each(async function(tab) {
      if (tab.active) {
        this.focus();
        this.blur();
      }
      const isVisible = tab.isVisible ? tab.isVisible() : true;
      tab.wrapper = select_default(this).style("cursor", isVisible && tab.disabled?.() ? "not-allowed" : "pointer");
      if (self2.opts.linePosition == "right") tab.wrapper.style("justify-self", "end");
      if (self2.opts.linePosition == "left") tab.wrapper.style("justify-self", "start");
      if (self2.opts.linePosition == "top" || self2.opts.linePosition == "left") {
        tab.line = tab.wrapper.append("div").style("display", self2.opts.linePosition == "left" ? "inline-flex" : "flex");
        tab.tab = tab.wrapper.append("div").style("display", self2.opts.linePosition == "left" ? "inline-block" : "block");
      } else {
        tab.tab = tab.wrapper.append("div").style("display", self2.opts.linePosition == "right" ? "inline-block" : "block");
        tab.line = tab.wrapper.append("div").style("display", self2.opts.linePosition == "right" ? "inline-flex" : "flex");
      }
      tab.tab.attr("data-testid", `sjpp-toggle_button-text-${tab.label.toLowerCase().replace(/\s/g, "-")}`).style("color", tab.active ? activeColor : inactiveColor).style("text-align", textAlign).style("padding", "5px").html(tab.label);
      tab.line.style("background-color", activeColor).style("visibility", tab.active ? "visible" : "hidden");
      if (self2.opts.linePosition == "top" || self2.opts.linePosition == "bottom") {
        tab.line.style("height", "8px").style("padding", "0px 5px");
      } else {
        tab.line.style("align-self", "stretch").style("padding", "5px 0px").html('<span style="width: 8px";>&nbsp</span>');
      }
      if (self2.dom.contentHolder) {
        tab.contentHolder = self2.dom.contentHolder.append("div").style("display", tab.active ? "block" : "none");
        if (self2.opts.tabsPosition == "horizontal" && !self2.opts.noTopContentStyle) {
          tab.contentHolder.style("padding-top", "10px").style("margin-top", "10px");
        }
      }
      if (tab.active && tab.callback) await tab.callback(event, tab);
      tab.wrapper.on("mouseenter", () => {
        tab.tab.style("color", tab.active ? inactiveColor : activeColor);
      }).on("mouseleave", () => {
        tab.tab.style("color", tab.active ? activeColor : inactiveColor);
      });
    }).on("click", async (event2, tab) => {
      for (const t2 of self2.tabs) {
        if (self2.opts.hideOnDblClick && t2.active == true && t2 === tab) {
          t2.active = false;
          continue;
        }
        t2.active = t2 === tab;
      }
      const activeTabIndex2 = self2.tabs.findIndex((t2) => t2.active);
      self2.update(activeTabIndex2);
      if (tab.callback) await tab.callback(event2, tab);
    }).on("keydown", async function(event2, tab) {
      if (event2.target.tagName != "BUTTON") return;
      if (event2.key == "Escape") {
        return false;
      } else if (event2.key == "Enter") {
        if (tab.keydownCallback) tab.keydownCallback(event2, tab);
      }
    });
    const activeTabIndex = self2.tabs.findIndex((t2) => t2.active);
    self2.update(activeTabIndex);
  };
  self2.update = (activeTabIndex = 0) => {
    self2.tabs.forEach((tab, i3) => {
      tab.active = activeTabIndex === i3;
    });
    self2.dom.tabsHolder.selectAll("button").data(self2.tabs).classed("sjpp-active", (tab) => tab.active).each((tab) => {
      const isVisible = tab.isVisible ? tab.isVisible() : true;
      tab.wrapper.classed("sjpp-active", tab.active);
      if (tab.isVisible) tab.wrapper.style("display", isVisible ? "" : "none");
      if (tab.contentHolder) tab.contentHolder.style("display", tab.active ? "block" : "none");
      tab.tab.style("color", tab.active ? activeColor : inactiveColor);
      tab.line.style("visibility", tab.active ? "visible" : "hidden");
      tab.tab.html(tab.label);
    });
  };
}

// dom/zoom.js
function zoom(opts) {
  if (!opts.holder) throw `zoom requires an opts.holder`;
  if (typeof opts.callback != "function") throw `zoom requires an opts.callback function`;
  const defaultSettings = {
    min: 1,
    max: 100,
    value: 25,
    step: 10,
    increment: 1,
    numberInputWidth: "35px",
    showJumpBtns: false
  };
  const settings = Object.assign({}, defaultSettings, opts.settings || {});
  let showSlider = false;
  opts.holder.attr("title", opts.title || null).style("vertical-align", "top").style("text-align", "center").on("mouseenter", () => {
    sliderDiv.style("display", "inline-block").style("overflow", "visible");
    showSlider = true;
  }).on("mouseleave", () => {
    sliderDiv.style("display", "none").style("overflow", "hidden");
    showSlider = false;
  });
  const label = opts.holder.append("label");
  const labelText = label.append("span").text("Zoom");
  const number = label.append("input").attr("title", "Enter a desired zoom level").attr("type", "number").attr("min", settings.min).attr("max", settings.max).attr("step", settings.increment).style("min-width", settings.numberInputWidth).style("width", opts.width || "fit-content").style("margin", "3px 5px").property("value", settings.value).on("change", (event2) => {
    const value = Number(event2.target.value);
    api.update({ value });
    opts.callback(value);
  });
  label.append("span").text("unit" in opts ? opts.unit : "%");
  const box = opts.holder.node().getBoundingClientRect();
  opts.holder.style("max-height", box.height + "px").style("max-width", box.width + "px");
  opts.holder.append("br");
  const sliderDiv = opts.holder.append("div").style("display", "none");
  const minusBtn = !opts.showJumpBtns ? null : opts.holder.append("button").attr("title", "Zoom in").style("width", "25px").html("-").on("click", () => {
    const value = Math.max(
      settings.step * Math.ceil((settings.value - settings.step) / settings.step),
      settings.min
    );
    api.update({ value });
    opts.callback(value);
  });
  const slider = sliderDiv.append("input").attr("title", "Slide to desired zoom level").attr("type", "range").attr("min", settings.min).attr("max", settings.max).attr("step", settings.increment).style("margin", "2px 5px").style("padding", 0).style("vertical-align", "middle").property("value", settings.value).html("-").on("input", (event2) => {
    number.property("value", event2.target.value);
  }).on("change", (event2) => {
    const value = Number(event2.target.value);
    api.update({ value });
    opts.callback(value);
  });
  const plusBtn = !opts.showJumpBtns ? null : opts.holder.append("button").attr("title", "Zoom out").style("width", "25px").html("+").on("click", () => {
    const value = Math.min(
      settings.step * Math.floor((settings.value + settings.step) / settings.step),
      settings.max
    );
    api.update({ value });
    opts.callback(value);
  });
  sliderDiv.append("span").style("text-decoration", "underline").style("cursor", "pointer").style("title", "use the default zoom value").text("Reset").on("click", opts.reset);
  const api = {
    update(s = {}) {
      const box2 = opts.holder.node().getBoundingClientRect();
      if (!box2.height || !box2.width) {
        opts.holder.style("max-height", "").style("max-width", "");
        const box3 = opts.holder.node().getBoundingClientRect();
        opts.holder.style("max-height", box3.height + "px").style("max-width", box3.width + "px");
      }
      Object.assign(settings, s);
      slider.property("value", settings.value).attr("min", settings.min).attr("max", settings.max).attr("step", settings.increment);
      number.property("value", settings.value).attr("min", settings.min).attr("max", settings.max).attr("step", settings.increment);
      minusBtn?.property("disabled", settings.value <= settings.min);
      plusBtn?.property("disabled", settings.value >= settings.max);
    }
  };
  if (opts.debug)
    api.Inner = {
      settings,
      number,
      slider,
      minusBtn,
      plusBtn
    };
  return api;
}

// plots/PlotBase.ts
var PlotBase = class {
  constructor(opts, plotApi) {
    this.dom = {};
    this.components = {};
    /** wait time to show loading div to avoid rapid flicker */
    this.loadingWait = 1e3;
    /** update cycle counter to help simulate error display */
    this.testUpdateNum = 0;
    if (plotApi) this.api = plotApi;
    this.opts = opts;
    this.id = opts?.id;
    this.app = opts?.app;
    this.parentId = opts?.parentId;
    this.uiLabels = defaultUiLabels;
    if (this.app?.vocabApi) this.vocabApi = this.app.vocabApi.create(() => this.api?.getAbortSignal());
  }
  async getMutableConfig() {
    const config = structuredClone(this.state.config);
    if (!config || !this.configTermKeys?.length) return structuredClone(config);
    const opts = {
      vocabApi: this.vocabApi
    };
    for (const key of this.configTermKeys) {
      const value = config[key.split(".")[0]];
      if (!value) continue;
      if (Array.isArray(value)) {
        for (const [i3, v] of value.entries()) {
          if (key.includes(".")) {
            const k = key.split(".")[1];
            const _v = v[k];
            if (Array.isArray(_v)) {
              for (const [j, tw] of _v.entries()) {
                if (tw.type && routedTermTypes.has(tw.term?.type)) {
                  _v[j] = await TwRouter.init(tw, opts);
                }
              }
            } else {
              if (_v.type && routedTermTypes.has(_v.term?.type)) v[k] = await TwRouter.init(_v, opts);
            }
          } else {
            if (v.type && routedTermTypes.has(v.term?.type)) config[key][i3] = await TwRouter.init(v, opts);
          }
        }
      } else if (value.type && routedTermTypes.has(value.term?.type)) {
        config[key] = await TwRouter.initRaw(value, opts);
      }
    }
    return config;
  }
  getStandardDomLayout(holder, opts = {}) {
    const optsControlsHolderIsSelection = opts.controls && typeof opts.controls.append == "function" && typeof opts.controls.selectAll == "function";
    const controls = opts.controls && !optsControlsHolderIsSelection ? null : opts.controls && optsControlsHolderIsSelection ? opts.controls : holder.append("div").style("display", "inline-block");
    const mainWrapper = opts.mainWrapper || holder.append("div").style("display", "inline-block");
    const errdiv = mainWrapper.append("div").attr("class", "sja_errorbar").style("display", "none");
    const loadingDiv = mainWrapper.append("div").style("display", "none").style("padding", "24px").html("Loading ...");
    const banner = mainWrapper.append("div").style("display", "none").style("text-align", "center").style("padding", "24px").style("font-size", "16px");
    const mainDiv = mainWrapper.append("div").style("position", "relative");
    const renderedData = mainDiv.append("div");
    const charts = renderedData.append("div");
    const legendDiv = renderedData.append("div");
    return { controls, errdiv, loadingDiv, banner, mainDiv, renderedData, charts, legendDiv };
  }
  // helper so that 'Loading...' does not flash when not needed
  toggleLoadingDiv(display = "", dataDisplay = "") {
    const loadingDiv = this.dom.loadingDiv || this.dom.loading;
    if (!loadingDiv) return;
    if (display == "none") {
      loadingDiv.style("display", display);
      if (this.dom.renderedData) this.dom.renderedData.style("display", dataDisplay || "");
    } else {
      loadingDiv.style("opacity", 0).style("display", display).transition().duration("loadingWait" in this ? this.loadingWait : 0).style("opacity", 1);
      if (this.dom.renderedData) this.dom.renderedData.style("display", dataDisplay || "none");
    }
  }
  printError(err) {
    console.debug(err);
    if (this.dom.renderedData) this.dom.renderedData.style("display", "none");
    let errdiv = this.dom?.errdiv || this.dom?.error || this.dom?.holder?.select(".sja_errorbar");
    if (!errdiv?.node()) {
      if (!this.dom?.holder) {
        this.app.printError(err + ` (also missing ${this.type}.dom.holder)`);
        return;
      } else {
        this.dom.errdiv = this.dom.holder.insert("div", "div").attr("class", "sja_errorbar");
        errdiv = this.dom.errdiv;
      }
    }
    if (errdiv) errdiv.text(err?.message || err?.error || err).style("display", "");
  }
};
var defaultUiLabels = {
  Samples: "Samples",
  samples: "samples",
  Sample: "Sample",
  sample: "sample",
  Terms: "Variables",
  terms: "variables",
  Term: "Variable",
  term: "Variable",
  Mutations: "Mutations",
  term2: { label: "Overlay", title: "Overlay data" },
  term0: { label: "Divide by", title: "Divide by data" }
};

// plots/GeneExpInput.ts
var GeneExpInput = class _GeneExpInput extends PlotBase {
  static {
    this.type = "GeneExpInput";
  }
  constructor(opts, api) {
    super(opts, api);
    this.type = _GeneExpInput.type;
    this.components = { plots: {} };
  }
  makeTerm(_term) {
    const termProperties = this.state.config?.termProperties || {};
    const term = { ..._term, ...termProperties, type: this.termType, unit: this.unit };
    return term;
  }
  makeConfig(_config) {
    const spawnConfig = this.state.config?.spawnConfig || {};
    const tmp = { ..._config, ...spawnConfig };
    return tmp;
  }
  getState(appState) {
    const config = appState.plots.find((p) => p.id === this.id);
    if (!config) {
      throw `No plot with id='${this.id}' found. Did you set this.id before this.api = getComponentApi(this)?`;
    }
    const subplots = appState.plots.filter((p) => p.parentId === this.id);
    return {
      config,
      termdbConfig: appState.termdbConfig,
      subplots
    };
  }
  async init(appState) {
    const state = this.getState(appState);
    this.genome = this.app.opts.genome;
    this.termType = state.config.termType;
    this.dom = this.initDom();
    if (!this.termType) {
      const possTermTypes = getSelectableGETermTypes(state.termdbConfig);
      if (!possTermTypes || !possTermTypes.length) throw new Error("No selectable data type.");
      if (possTermTypes.length === 1) {
        await this.app.save({
          type: "plot_edit",
          id: this.id,
          config: { termType: possTermTypes[0] }
        });
        return;
      }
      this.renderTermTypeSelect(possTermTypes);
      return;
    }
    await this.renderTermTypeUI(state);
  }
  initDom() {
    const headerText = this.opts.headerText ? `${this.opts.headerText} ` : "";
    const dom = {
      holder: this.opts.holder,
      header: {
        title: this.opts.header.append("span").style("padding-right", "5px").text(headerText).attr("data-testid", "sjpp-gene-exp-input-headerText"),
        plot: this.opts.header.append("span").text(this.termType ? typeGroup[this.termType].toUpperCase() : "").style("font-size", "0.7em").style("opacity", "0.6").attr("data-testid", "sjpp-gene-exp-input-termType")
      },
      tabs: this.opts.holder.append("div").style("margin", "10px").attr("data-testid", "sjpp-gene-exp-input-tabs-wrapper")
    };
    return dom;
  }
  renderTermTypeSelect(possTermTypes) {
    const holder = this.dom.tabs;
    holder.append("div").style("padding-bottom", "5px").text("Please select the data type:");
    make_radios({
      holder: holder.append("div").style("padding-left", "10px"),
      options: possTermTypes.map((termType14) => ({ value: termType14, label: typeGroup[termType14] })),
      callback: async (value) => {
        await this.app.dispatch({
          type: "plot_edit",
          id: this.id,
          config: { termType: value }
        });
      }
    });
  }
  /** Render the termType-dependent gene-selection tabs, once termType is known. */
  async renderTermTypeUI(state) {
    this.termType = state.config.termType;
    this.unit = getUnit(this.termType, this.app.vocabApi);
    this.dom.header.plot.text(typeGroup[this.termType].toUpperCase());
    this.dom.tabs.selectAll("*").remove();
    const chartTypes = new Set(getCurrentCohortChartTypes(this.app.getState()));
    this.tabs = this.getTabOpts(state, chartTypes);
    const chartTabs = new Tabs({
      holder: this.dom.tabs,
      tabs: this.tabs,
      tabsPosition: "vertical"
    });
    await chartTabs.main();
  }
  getTabOpts(state, chartTypes) {
    return [
      {
        label: "One gene",
        isVisible: () => true,
        callback: async (event2, tab) => {
          delete tab.callback;
          if (this.termType === PSEUDOBULK) {
            await this.renderPseudobulkSearch(tab.contentHolder);
          } else this.renderGeneSelect(tab);
        }
      },
      {
        label: "Two genes",
        /** TODO: Does this make sense to enable for pseudobulk? */
        isVisible: () => this.termType !== PSEUDOBULK,
        callback: (event2, tab) => {
          this.renderTwoGeneSelect(tab);
          delete tab.callback;
        }
      },
      {
        label: "Hierarchical clustering",
        isVisible: () => chartTypes.has("matrix"),
        callback: (event2, tab) => {
          if (this.termType !== GENE_EXPRESSION && typeof this.termType === "string") {
            tab.contentHolder.append("div").style("padding", "15px").text(`Hierarchical clustering for ${typeGroup[this.termType]} data is currently in development. Please check back later.`);
          } else this.renderGeneMultiSelect(tab);
          delete tab.callback;
        }
      },
      {
        label: `Differential ${typeGroup[this.termType].toLowerCase()} analysis`,
        //Only enabling for gene expression for now
        chartType: "DEinput",
        //TODO: add whether or not a total file is available for pseudobulk to enable DA
        isVisible: () => chartTypes.has("DA") && this.termType === GENE_EXPRESSION,
        callback: async (event2, tab) => {
          await this.app.dispatch({
            type: "plot_create",
            parentId: this.id,
            config: {
              chartType: "DEinput",
              parentId: this.id,
              /** ' ' overrides the default 'hide_search' mode in DEInput.
               * 'hide_search' by default expands all terms. */
              header_mode: " "
            }
          });
          delete tab.callback;
        }
      },
      {
        label: typeGroup[SSGSEA],
        isVisible: () => {
          return this.termType === GENE_EXPRESSION && state.termdbConfig?.allowedTermTypes?.includes(SSGSEA);
        },
        callback: async (event2, tab) => {
          await this.renderSSGSEA(tab);
          delete tab.callback;
        }
      }
    ];
  }
  async main() {
    const state = this.getState(this.app.getState());
    if (!this.tabs && state.config.termType) await this.renderTermTypeUI(state);
    for (const subplot of state.subplots || []) {
      if (!this.components.plots[subplot.id]) await this.initSubplotInTab(subplot);
    }
  }
  renderGeneSelect(tab) {
    const row = tab.contentHolder.style("padding", "15px");
    row.append("span").style("padding", "5px").text("Select a gene:");
    const geneSearch = addGeneSearchbox({
      row,
      genome: this.genome,
      tip: new Menu({ padding: "0px" }),
      searchOnly: "gene",
      callback: async () => {
        const tw = {
          term: this.makeTerm({
            gene: geneSearch.geneSymbol,
            name: `${geneSearch.geneSymbol} ${this.unit}`
          })
        };
        const config = this.makeConfig({
          chartType: "summary",
          term: tw
        });
        await this.dispatchEdits(config);
      }
    });
  }
  async renderPseudobulkSearch(holder) {
    const _ = await import("./pseudobulk-Y7HWDLIV.js");
    const searchHandler = new _.SearchHandler();
    await searchHandler.init({
      holder: holder.style("padding-left", "10px"),
      app: this.app,
      genomeObj: this.genome,
      usecase: { target: "GeneExpInput", detail: "pseudobulk" },
      callback: async (_term) => {
        const tw = { term: this.makeTerm(_term) };
        const config = this.makeConfig({
          chartType: "summary",
          term: tw
        });
        await this.dispatchEdits(config);
      }
    });
  }
  /** Guide the user to select the first gene then
   * a second to launch the summary plot on submit.*/
  renderTwoGeneSelect(tab) {
    const term = {};
    const term2 = {};
    const holder = tab.contentHolder.style("padding", "10px");
    const gene1row = holder.append("div").style("padding", "5px");
    const gene2row = holder.append("div").style("padding", "5px").style("display", "none");
    const submitButton = holder.append("button").attr("type", "button").attr("disabled", true);
    gene1row.append("span").text("Select the first gene:");
    const geneSearch1 = addGeneSearchbox({
      row: gene1row,
      genome: this.genome,
      tip: new Menu({ padding: "0px" }),
      searchOnly: "gene",
      callback: async () => {
        gene2row.style("display", "block");
        if (!geneSearch1.geneSymbol) throw new Error("First gene result is required");
        term.gene = geneSearch1.geneSymbol;
        term.name = `${geneSearch1.geneSymbol} ${this.unit}`;
      }
    });
    gene2row.append("span").text("Select the second gene:");
    const geneSearch2 = addGeneSearchbox({
      row: gene2row,
      genome: this.genome,
      tip: new Menu({ padding: "0px" }),
      searchOnly: "gene",
      callback: async () => {
        if (!geneSearch2.geneSymbol) throw new Error("Second gene result is required");
        term2.gene = geneSearch2.geneSymbol;
        term2.name = `${geneSearch2.geneSymbol} ${this.unit}`;
        submitButton.attr("disabled", null);
      }
    });
    submitButton.text("Submit").style("border", "none").style("border-radius", "20px").style("padding", "10px 15px").on("click", async () => {
      if (!term.name || !term.gene) {
        sayerror(holder, "Missing first gene. Please provide a valid gene.");
        return;
      }
      if (!term2.name || !term2.gene) {
        sayerror(holder, "Missing second gene. Please provide a valid gene.");
        return;
      }
      const config = this.makeConfig({
        chartType: "summary",
        term: { term: this.makeTerm(term) },
        term2: { term: this.makeTerm(term2) }
      });
      await this.dispatchEdits(config);
    });
  }
  /** Render the GeneSetEdit UI for selection and then
   * launch the hierarchical clustering on submit.*/
  renderGeneMultiSelect(tab) {
    const holder = tab.contentHolder.style("padding", "10px");
    const grpWrapper = holder.append("div").style("padding", "10px");
    grpWrapper.append("span").style("font-weight", "bold").text("Group name:");
    let customName = "New custom group";
    const input = grpWrapper.append("input").style("margin", "2px 5px").style("width", "210px").attr("placeholder", "Group Name").on("input", () => {
      customName = input.property("value");
    });
    new GeneSetEditUI({
      holder: holder.append("div"),
      /** running hier clustering and the editing group
       * is the group used for clustering pass this mode
       * value to inform ui to support the optional button
       * "top variably exp gene" this is hardcoded for
       * the purpose of gene expression and should be improved. */
      genome: this.genome,
      mode: "geneExpression",
      vocabApi: this.app.vocabApi,
      callback: async ({ geneList, name }) => {
        if (geneList.length <= 2) {
          return alert("At least three genes are required for hierarchical clustering. Please select more genes.");
        }
        const group = {
          name: name || customName,
          lst: [],
          type: "hierCluster"
        };
        const tws = await Promise.all(
          geneList.map((d) => {
            const gene = d.symbol || d.gene;
            const name2 = `${gene} ${this.unit}`;
            const term = this.makeTerm({ gene, name: name2 });
            return { term, q: {} };
          })
        );
        group.lst = [...tws];
        const config = this.makeConfig({
          chartType: "hierCluster",
          termgroups: [group],
          //TODO: Need to allow singleCellGeneExpression as well
          dataType: GENE_EXPRESSION
        });
        await this.dispatchEdits(config);
      }
    });
  }
  async renderSSGSEA(tab) {
    const holder = tab.contentHolder.style("padding", "10px");
    const _ = await import("./ssGSEA-OYEIDW4M.js");
    const searchHandler = new _.SearchHandler();
    await searchHandler.init({
      holder,
      app: this.app,
      genomeObj: this.genome,
      callback: async (term) => {
        const config = this.makeConfig({
          chartType: "summary",
          term: { term }
        });
        await this.dispatchEdits(config);
      }
    });
  }
  async initSubplotInTab(subplot) {
    const holder = this.tabs.find((tab) => tab.chartType === subplot.chartType)?.contentHolder;
    if (!holder) throw new Error(`No tab found for chart type ${subplot.chartType}`);
    const opts = Object.assign({}, subplot, {
      holder,
      app: this.app,
      parentId: this.id,
      id: subplot.id
    });
    const { componentInit: componentInit3 } = await importPlot(opts.chartType);
    this.components.plots[subplot.id] = await componentInit3(opts);
  }
  async dispatchEdits(config) {
    await this.app.dispatch({
      type: "app_refresh",
      subactions: [
        {
          type: "plot_create",
          config
        },
        {
          type: "plot_delete",
          id: this.id
        }
      ]
    });
  }
};
function getUnit(termType14, vocabApi) {
  return termType14 === GENE_EXPRESSION ? getGEunit(vocabApi) : getSCGEunit(vocabApi);
}
var geneExpInputInit = getCompInit(GeneExpInput);
var componentInit = geneExpInputInit;
var enabledTermTypes = /* @__PURE__ */ new Set([GENE_EXPRESSION, SINGLECELL_GENE_EXPRESSION, PSEUDOBULK]);
function getPlotConfig(opts) {
  if (opts?.termType && !enabledTermTypes.has(opts.termType)) throw new Error(`Invalid termType: ${opts.termType}`);
  const config = {
    chartType: "GeneExpInput",
    termType: opts?.termType,
    hidePlotFilter: true
  };
  return copyMerge(config, opts);
}
function getSelectableGETermTypes(termdbConfig) {
  return Array.from(enabledTermTypes).filter((termtype) => termtype !== SINGLECELL_GENE_EXPRESSION && (termdbConfig?.allowedTermTypes || [])?.includes(termtype));
}

// mass/charts.ts
var MassCharts = class _MassCharts {
  static {
    this.type = "charts";
  }
  constructor(opts = {}) {
    this.type = _MassCharts.type;
    this.stickyAncestor = getAncestorWithComputedStyle(opts.holder.node(), "position", /* @__PURE__ */ new Set(["sticky", "fixed"]));
    setRenderers6(this);
  }
  async init(appState) {
    this.dom = {
      holder: this.opts.holder,
      tip: new Menu({ padding: "0px", testid: "sjpp-mass-nav-chartBtnMenu" }),
      tooltip: new Menu({ padding: "4px" })
    };
    this.makeButtons(appState);
  }
  // TODO later add reactsTo() to react to filter change
  getState(appState) {
    const state = {
      vocab: appState.vocab,
      // TODO delete it as vocabApi should be used instead
      activeCohort: appState.activeCohort,
      termfilter: appState.termfilter,
      currentCohortChartTypes: getCurrentCohortChartTypes(appState),
      termdbConfig: appState.termdbConfig
    };
    if (appState?.termfilter?.filter) {
      state.filter = getNormalRoot(appState.termfilter.filter);
    }
    return state;
  }
  main() {
    this.dom.btns.style("display", (d) => d.isVisible ? d.isVisible() : this.state.currentCohortChartTypes.includes(d.chartType) ? "" : "none");
  }
  getBtnLabel_dict(state) {
    return state.termdbConfig.queries ? "Data Variables" : "Data Dictionary";
  }
  getBtnLabel_regression(state) {
    const lst = getCurrentCohortChartTypes(state);
    if (!lst.includes("regression")) return "";
    const ms = [];
    if (lst.includes("linear")) ms.push("linear");
    if (lst.includes("logistic")) ms.push("logistic");
    if (lst.includes("cox")) ms.push("cox");
    if (ms.length > 1) return "Regression Analysis";
    return `${capitalizeFirstLetter(ms[0] || "logistic")} Regression`;
  }
  getBtnLabel_sampleScatter(state) {
    const lst = getCurrentCohortChartTypes(state);
    if (state.termdbConfig.scatterplots?.length == 1 && !lst.includes("dynamicScatter")) {
      return state.termdbConfig.scatterplots[0].name;
    }
    return "Sample Scatter";
  }
  getBtnLabel_report(state) {
    return state.termdbConfig.plotConfigByCohort?.default?.report?.name || "Report";
  }
  getBtnLabel_summarizeMutationTerm(state, phrase) {
    if (!state.termdbConfig.queries) return "Not supported!";
    const t2 = [];
    if (state.termdbConfig.queries.snvindel) t2.push("Mutation");
    if (state.termdbConfig.queries.cnv) t2.push("CNV");
    if (state.termdbConfig.queries.svfusion) t2.push("Fusion");
    return `${t2.length > 2 ? "Alterations" : t2.join("/")} vs ${phrase}`;
  }
  getBtnLabel_geneExpression(state) {
    const l = [];
    if (state.termdbConfig?.queries?.geneExpression) l.push("Gene Expression");
    if (state.termdbConfig?.termType2terms?.Pseudobulk) l.push("Pseudobulk Gene Expression");
    if (l.length > 1 || !l.length) return "Gene Expression";
    return l[0];
  }
};
var chartsInit = getCompInit(MassCharts);
function getActiveCohortStr(appState) {
  if (appState?.termdbConfig?.selectCohort?.values) {
    if (!Number.isInteger(appState.activeCohort)) throw "appState.activeCohort is not integer array index";
    const activeCohortObject = appState.termdbConfig.selectCohort.values[appState.activeCohort];
    if (!activeCohortObject) throw "appState.activeCohort array index out of bound";
    return [...activeCohortObject.keys].sort().join(",");
  }
  return "";
}
function getCurrentCohortChartTypes(appState) {
  const activeCohortStr = getActiveCohortStr(appState);
  const chartTypesByCohort = structuredClone(appState.termdbConfig?.supportedChartTypes || {});
  return chartTypesByCohort[activeCohortStr] || ["summary"];
}
function getChartTypeList(self2, state) {
  const buttons = [
    ////////////////////// PROFILE PLOTS START //////////////////////
    {
      label: "Polar",
      chartType: "profilePolar2",
      clickTo: self2.prepPlot,
      config: { chartType: "profilePolar2" }
    },
    {
      label: "Barchart",
      clickTo: self2.prepPlot,
      chartType: "profileBarchart2",
      config: { chartType: "profileBarchart2" }
    },
    {
      label: "Facility Radar",
      chartType: "profileRadarFacility2",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Radar",
      chartType: "profileRadar2",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Templates",
      chartType: "profileForms",
      clickTo: self2.showTree_select1term,
      usecase: { target: "profileForms", detail: "tw" },
      config: { chartType: "profileForms" },
      // Shown instead of the term tree when the active cohort has no plotConfigByCohort
      // entry for this chart type (e.g. Abbreviated PrOFILE has no template config).
      plotConfigByCohort_unavailableMessage: "No templates are currently available for this cohort."
    },
    ////////////////////// PROFILE PLOTS END //////////////////////
    //       rest are general plots applicable to all ds
    {
      label: self2.getBtnLabel_dict(state),
      clickTo: self2.prepPlot,
      chartType: "dictionary",
      config: {
        chartType: "dictionary"
      }
    },
    {
      // currently only used by gdc, so hardcoding correlation input label
      // may allow for other labels if used by other datasets
      label: "Correlation Input",
      clickTo: self2.prepPlot,
      chartType: "summaryInput",
      config: {
        chartType: "summaryInput"
      }
    },
    {
      label: self2.getBtnLabel_report(state),
      chartType: "report",
      clickTo: self2.plotCreate,
      config: { chartType: "report" }
    },
    {
      label: "Sample View",
      clickTo: self2.prepPlot,
      chartType: "sampleView",
      config: {
        chartType: "sampleView"
      }
    },
    {
      label: "Whole Slide Images",
      clickTo: self2.prepPlot,
      chartType: "wsi",
      config: {
        chartType: "wsi"
      }
    },
    {
      label: self2.getBtnLabel_sampleScatter(state),
      chartType: "sampleScatter",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Run Chart",
      chartType: "runChart2",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Frequency Chart",
      chartType: "runChart2",
      clickTo: self2.showTree_select1term,
      usecase: { target: "runChart2", detail: "xtw" }
    },
    {
      label: "Cumulative Incidence",
      chartType: "cuminc",
      clickTo: self2.showTree_select1term,
      usecase: { target: "cuminc", detail: "term" }
    },
    {
      label: "Survival",
      chartType: "survival",
      clickTo: self2.showTree_select1term,
      usecase: { target: "survival", detail: "term" }
    },
    {
      label: self2.getBtnLabel_regression(state),
      chartType: "regression",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Sample Matrix",
      chartType: "matrix",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Genome Browser",
      chartType: "genomeBrowser",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Data Download",
      clickTo: self2.prepPlot,
      chartType: "dataDownload",
      config: {
        chartType: "dataDownload",
        terms: []
      }
    },
    {
      label: "Facet Table",
      clickTo: self2.loadChartSpecificMenu,
      chartType: "facet",
      config: {
        chartType: "facet"
      }
    },
    {
      label: "Brain Imaging",
      // launches a sandbox with the sample table; the plot itself handles sample/template selection
      clickTo: self2.prepPlot,
      chartType: "brainImaging",
      config: {
        chartType: "brainImaging"
      }
    },
    {
      label: "Single Cell",
      clickTo: self2.prepPlot,
      chartType: "sc",
      config: {
        chartType: "sc"
      }
    },
    {
      label: self2.getBtnLabel_geneExpression(state),
      chartType: "GeneExpInput",
      clickTo: self2.prepPlot,
      config: { chartType: "GeneExpInput" },
      isVisible: () => {
        const isAvailable = getSelectableGETermTypes(state.termdbConfig);
        return isAvailable.length > 0;
      }
    },
    {
      label: "Metabolite Intensity",
      chartType: "metaboliteIntensity",
      clickTo: self2.showTree_selectlst,
      usecase: { target: "metaboliteIntensity", detail: "term" },
      updateActionBySelectedTerms: (action, termlst) => {
        const twlst = termlst.map((term) => ({
          term: structuredClone(term),
          q: { mode: NumericModes.continuous }
        }));
        if (twlst.length == 1) {
          action.config.chartType = "summary";
          action.config.term = twlst[0];
          return;
        }
        if (twlst.length == 2) {
          action.config.chartType = "summary";
          action.config.term = twlst[0];
          action.config.term2 = twlst[1];
          return;
        }
        action.config.chartType = "hierCluster";
        action.config.dataType = TermTypes.METABOLITE_INTENSITY;
        action.config.termgroups = [{ name: "Metabolite Intensity Cluster", lst: twlst, type: "hierCluster" }];
      }
    },
    {
      label: "Protein View",
      chartType: "proteinView",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Sample Selection",
      chartType: "proteomeAbundance",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Bubble Chart",
      chartType: "animatedBubbleChart",
      clickTo: self2.plotCreate,
      config: { chartType: "animatedBubbleChart" }
    },
    {
      label: "Site Map",
      chartType: "geomap",
      clickTo: self2.plotCreate,
      config: { chartType: "geomap" }
    },
    {
      label: "Bubble Heatmap",
      chartType: "bubbleHeatmap",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Cell-type Bubble Heatmap",
      chartType: "cellTypeBubbleHeatmap",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Brain Regional Proteome",
      chartType: "brainRegions",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Studies",
      chartType: "studyCatalog",
      clickTo: self2.plotCreate,
      config: { chartType: "studyCatalog" }
    },
    {
      label: state.termdbConfig.queries?.geneRanking?.appName || "Gene Ranking",
      chartType: "geneRanking",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: state.termdbConfig.numericDictTermCluster?.appName || "Numeric Dictionary Term cluster",
      chartType: "numericDictTermCluster",
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Correlation Volcano",
      chartType: "correlationVolcano",
      usecase: { target: "correlationVolcano", detail: "numeric" },
      clickTo: self2.showTree_select1term
    },
    {
      label: "GRIN2",
      chartType: "grin2",
      config: { chartType: "grin2" },
      clickTo: self2.prepPlot
    },
    {
      label: self2.getBtnLabel_summarizeMutationTerm(state, "Disease Type"),
      chartType: "summarizeMutationDiagnosis",
      // type names of other similar charts should all begin with `summarize` to indcate they are based on summary plot
      usecase: { target: "summarizeMutationDiagnosis" },
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: self2.getBtnLabel_summarizeMutationTerm(state, "Survival"),
      chartType: "summarizeMutationSurvival",
      usecase: { target: "summarizeMutationSurvival" },
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "CNV vs Mutation",
      chartType: "summarizeMutationCnv",
      usecase: { target: "summarizeMutationCnv" },
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "CNV vs GeneExp",
      // this is limited to cnv, and could be generalized to include snvindel/fusion
      chartType: "summarizeCnvGeneexp",
      usecase: { target: "summarizeCnvGeneexp" },
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "GeneExp vs Survival",
      chartType: "summarizeGeneexpSurvival",
      usecase: { target: "summarizeGeneexpSurvival" },
      clickTo: self2.loadChartSpecificMenu
    },
    {
      label: "Aggregate Matrix",
      chartType: "aggMatrixInput",
      clickTo: self2.prepPlot,
      usecase: { target: "aggregateMatrix" },
      config: {
        chartType: "aggMatrixInput"
      }
    }
  ];
  const renamedChartTypes = state?.termdbConfig.renamedChartTypes || {};
  for (const btn of buttons) {
    btn.stickyAncestor = self2.stickyAncestor;
    if (renamedChartTypes[btn.chartType]) btn.label = renamedChartTypes[btn.chartType];
  }
  return buttons;
}
function setRenderers6(self2) {
  self2.makeButtons = function(state) {
    const chartTypeList = getChartTypeList(self2, state);
    self2.dom.btns = self2.dom.holder.selectAll("button").data(chartTypeList).enter().append("button").attr("class", "sjpp-chart-btn").attr("data-testid", (d) => `sjpp-chart-btn-${d.label.toLowerCase().replace(/\s/g, "-")}`).style("margin", "10px").style("padding", "10px 15px").style("border-radius", "20px").style("border-color", "#ededed").html((d) => d.label).on("click", function(event2, chart) {
      self2.dom.tip.clear().showunder(this);
      chart.clickTo(chart, this);
    }).on("mouseover", (e, d) => {
      if (d.tooltip) self2.dom.tooltip.clear().showunder(e.target).d.text(d.tooltip);
    }).on("mouseleave", (e, d) => {
      if (d.tooltip) self2.dom.tooltip.hide();
    });
  };
  self2.showTree_select1term = async (chart) => {
    if (chart.plotConfigByCohort_unavailableMessage) {
      const cohortStr = getActiveCohortStr(self2.state);
      const hasCohortConfig = self2.state.termdbConfig?.plotConfigByCohort?.[cohortStr]?.[chart.chartType];
      if (!hasCohortConfig) {
        self2.dom.tip.d.append("div").style("padding", "15px").style("color", "#777").style("font-style", "italic").text(chart.plotConfigByCohort_unavailableMessage);
        return;
      }
    }
    if (chart.usecase.label) {
      self2.dom.tip.d.append("div").style("margin", "3px 5px").style("padding", "3px 5px").style("font-weight", 600).html(chart.usecase.label);
    }
    const action = {
      type: "plot_create",
      id: getId2(),
      config: { chartType: chart.chartType, activeCohort: self2.state.activeCohort }
    };
    if (chart.parentId) action.parentId = chart.parentId;
    const termdb = await import("./app-2NSQK3GQ.js");
    termdb.appInit({
      vocabApi: self2.app.vocabApi,
      holder: self2.dom.tip.d.append("div"),
      state: {
        activeCohort: self2.state.activeCohort,
        nav: {
          header_mode: "search_only"
        },
        tree: { usecase: chart.usecase }
      },
      tree: {
        click_term: (term) => {
          const tw = term.term ? term : { term };
          action.config[chart.usecase.detail] = tw;
          self2.dom.tip.hide();
          self2.app.dispatch(action);
        }
      }
    });
  };
  self2.showTree_selectlst = async (chart) => {
    if (chart.usecase?.label) {
      self2.dom.tip.d.append("div").style("margin", "3px 5px").style("padding", "3px 5px").style("font-weight", 600).html(chart.usecase.label);
    }
    const action = {
      type: "plot_create",
      id: getId2(),
      config: { chartType: chart.chartType }
      // NOTE if chartType is intermediary, action will be updated on term selection
    };
    const termdb = await import("./app-2NSQK3GQ.js");
    self2.dom.submenu = self2.dom.tip.d.append("div");
    termdb.appInit({
      holder: self2.dom.submenu,
      vocabApi: self2.app.vocabApi,
      state: {
        activeCohort: self2.state.activeCohort,
        nav: {
          header_mode: "search_only"
        },
        tree: { usecase: chart.usecase }
      },
      tree: {
        minTermsToSubmit: chart.minTermsToSubmit,
        submit_lst: (termlst) => {
          const data = chart.processSelection ? chart.processSelection(termlst) : termlst;
          action.config[chart.usecase.detail] = data;
          if (chart.updateActionBySelectedTerms) chart.updateActionBySelectedTerms(action, termlst);
          self2.dom.tip.hide();
          self2.app.dispatch(action);
        }
      }
    });
  };
  self2.loadChartSpecificMenu = async (chart) => {
    self2.dom.tip.clear();
    const _ = await importPlot(chart.chartType);
    _.makeChartBtnMenu(self2.dom.tip.d, self2, chart.chartType);
  };
  self2.prepPlot = async function(chart, btnNode) {
    self2.dom.tip.hide();
    if (btnNode) btnNode.disabled = true;
    const action = { type: "plot_prep", config: chart.config, id: getId2() };
    try {
      await self2.app.dispatch(action);
    } finally {
      if (btnNode) btnNode.disabled = false;
    }
  };
  self2.plotCreate = function(chart) {
    self2.dom.tip.hide();
    const action = { type: "plot_create", config: chart.config, id: getId2() };
    self2.app.dispatch(action);
  };
}
var idPrefix = "_CHART_AUTOID_" + Math.random().toString().slice(-6) + "_";
var id2 = Date.now().toString().slice(-6);
function getId2() {
  return idPrefix + id2++;
}

// plots/getBrainImagingSampleSet.ts
var cache = /* @__PURE__ */ new Map();
async function fetchBrainImagingSamples(body) {
  const result = await dofetch3("termdb/brainImagingSamples", { body });
  if (typeof result == "string") throw result;
  if (result.error) throw result.error;
  return result;
}
function getBrainImagingSampleSet(genome, dslabel, refKey) {
  const key = `${genome}	${dslabel}	${refKey}`;
  if (!cache.has(key)) {
    const promise = (async () => {
      const result = await fetchBrainImagingSamples({ genome, dslabel, refKey, samplesOnly: true });
      return new Set((result.samples || []).map((s) => s.sample));
    })();
    promise.catch(() => cache.delete(key));
    cache.set(key, promise);
  }
  return cache.get(key);
}

// plots/diffAnalysis/enabledTermTypes.ts
var DATermTypes = {
  GENE_EXPRESSION,
  SINGLECELL_CELLTYPE,
  DNA_METHYLATION,
  PROTEOME_DAP,
  SINGLECELL_GENE_EXPRESSION
};
var diffAnalysisTermTypeValues = Object.values(DATermTypes);
var enabledTermTypes2 = new Set(diffAnalysisTermTypeValues);

// plots/volcano/settings/defaults.ts
var maxSampleCutoff = 4e3;
var maxGESampleCutoff = 3e3;
function getDefaultVolcanoSettings(overrides = {}, opts) {
  const defaults3 = {
    defaultSignColor: "red",
    defaultNonSignColor: "black",
    defaultHighlightColor: "#ffa200",
    // orange-yellow
    foldChangeCutoff: 0.3,
    height: 400,
    pValue: roundValue(-Math.log10(0.05), 2),
    pValueType: "adjusted",
    //Only declare this value in one place
    sampleNumCutoff: opts.termType == DATermTypes.GENE_EXPRESSION ? maxGESampleCutoff : maxSampleCutoff,
    showPValueTable: false,
    width: 400,
    maxInteractiveDots: 5e3,
    maxTooltipGenes: 5
  };
  addGEDefaults(opts.termType, defaults3);
  addDMDefaults(opts.termType, defaults3, opts);
  return Object.assign(defaults3, overrides);
}
function addGEDefaults(termType14, defaults3) {
  if (termType14 != DATermTypes.GENE_EXPRESSION) return;
  const features = JSON.parse(sessionStorage.getItem("optionalFeatures"));
  const method = features?.runDE_methods?.includes("Wilcoxon") ? "wilcoxon" : "edgeR";
  defaults3.cpmCutoff = 1;
  defaults3.method = method;
  defaults3.minCount = 10;
  defaults3.minTotalCount = 15;
  defaults3.rankBy = "abs(foldChange)";
}
function addDMDefaults(termType14, defaults3, opts) {
  if (termType14 != DATermTypes.DNA_METHYLATION) return;
  defaults3.minSamplesPerGroup = 3;
  defaults3.excludeSexChr = false;
  defaults3.elementType = opts?.app?.vocabApi?.termdbConfig?.queries?.dnaMethylation?.defaultElementType || "promoter";
  defaults3.xAxis = "delta_beta";
  defaults3.deltaBetaCutoff = 0.1;
}
var typesUseDefaultSettings = /* @__PURE__ */ new Set([DATermTypes.SINGLECELL_CELLTYPE, DATermTypes.PROTEOME_DAP, DATermTypes.SINGLECELL_GENE_EXPRESSION]);
function validateVolcanoSettings(config, opts) {
  if (typesUseDefaultSettings.has(config.termType)) return;
  if (!config.settings.volcano) return;
  const settings = config.settings.volcano;
  const sampleNum = getSampleNum(opts);
  if (sampleNum > maxSampleCutoff) {
    throw new Error(
      `Sample size ${sampleNum} exceeds max sample size of ${maxSampleCutoff}. Please reduce sample size.`
    );
  }
  validateGESettings(config.termType, settings, sampleNum, opts);
  validateDMSettings(config.termType, settings);
}
function getSampleNum(config) {
  if (config.termType == DATermTypes.GENE_EXPRESSION || config.termType == DATermTypes.DNA_METHYLATION) {
    return config.samplelst.groups.reduce((sum, g) => sum + g.values.length, 0);
  } else {
    return maxSampleCutoff;
  }
}
function validateGESettings(termType14, settings, sampleNum, opts) {
  if (termType14 != DATermTypes.GENE_EXPRESSION) return;
  const largeNum = sampleNum > settings.sampleNumCutoff;
  if (!opts.overrides && largeNum) {
    settings.method = "wilcoxon";
  } else if (largeNum && settings.method != "wilcoxon") {
    throw new Error(
      `${settings.method} is not supported for ${sampleNum} samples when termtype = ${termType14}. Please use Wilcoxon.`
    );
  }
}
function validateDMSettings(termType14, settings) {
  if (termType14 != DATermTypes.DNA_METHYLATION || !settings) return;
  const min = settings.minSamplesPerGroup;
  if (!Number.isFinite(min) || !Number.isInteger(min) || min < 3) {
    settings.minSamplesPerGroup = 3;
  }
  if (typeof settings.elementType != "string" || !settings.elementType) {
    settings.elementType = "promoter";
  }
}

// mass/groups.js
var colorScale = getColors(5);
var MassGroups = class _MassGroups {
  static type = "groups";
  constructor(opts = {}) {
    this.type = _MassGroups.type;
    this.selectedGroupsIdx = /* @__PURE__ */ new Set();
  }
  async init() {
    this.dom = {
      holder: this.opts.holder.append("div").style("margin", "10px")
    };
    initUI(this);
    this.tip = new Menu({ padding: "0px" });
    this.tip2 = new Menu({ padding: "0px", offsetX: 250, offsetY: -34, parent_menu: this.tip.d.node() });
    this.tip3 = new Menu({ padding: "0px" });
  }
  getState(appState) {
    const state = {
      termfilter: appState.termfilter,
      groups: rebaseGroupFilter(appState),
      customTerms: appState.customTerms,
      currentCohortChartTypes: getCurrentCohortChartTypes(appState),
      matrixplots: this.app.vocabApi.termdbConfig.matrixplots
    };
    return state;
  }
  async main() {
    await updateUI(this);
  }
  //////////////// rest are app-specific logic
  getMassFilter() {
    if (!this.state.termfilter.filter || this.state.termfilter.filter.lst.length == 0) {
      return { type: "tvslst", in: true, join: "", lst: [] };
    }
    const f = getNormalRoot(structuredClone(this.state.termfilter.filter));
    return f;
  }
  async groups2samplelst(groups) {
    const samplelstGroups = [];
    const processedSamples = /* @__PURE__ */ new Set(), overlap = [];
    for (const g of groups) {
      const samples = await this.app.vocabApi.getFilteredSampleList(
        filterJoin([g.filter, this.state.termfilter.filter]),
        this.state.termfilter.filter0
      );
      const items = [];
      for (const sample of samples) {
        const item = { sampleId: sample.id };
        if ("name" in sample) {
          item.sample = sample.name;
        }
        if (!processedSamples.has(sample.id)) items.push(item);
        else {
          for (const pg of samplelstGroups) {
            const i3 = pg.items.findIndex((i4) => i4.sampleId === sample.id);
            if (i3 !== -1) overlap.push(...pg.items.splice(i3, 1));
          }
        }
        processedSamples.add(item.sampleId);
      }
      if (items.length) samplelstGroups.push({ name: g.name, items, color: g.color });
    }
    if (overlap.length) {
      const ok = confirm(
        'Overlap detected: 1 or more samples belong to >1 groups. A new group will be created for these "overlap" samples.'
      );
      if (!ok) return;
      samplelstGroups.push({ name: "Group overlap", items: overlap });
    }
    if (groups.length == 1) {
      const samples = await this.app.vocabApi.getFilteredSampleList(
        filterJoin([negateFilter(groups[0].filter), this.state.termfilter.filter]),
        this.state.termfilter.filter0
      );
      if (!samples.length) throw "0 samples for the other group";
      const items = [];
      for (const sample of samples) {
        const item = { sampleId: sample.id };
        if ("name" in sample) {
          item.sample = sample.name;
        }
        items.push(item);
      }
      samplelstGroups.push({ name: "Not in " + groups[0].name, items, color: "#ccc" });
    }
    return getSamplelstTW2(samplelstGroups);
  }
  updateLaunchButton() {
    this.dom.newTermSpan.style("display", "none");
    this.dom.noGroupSelected.style("display", "none");
    if (this.state.groups.length == 0) return;
    if (this.state.groups.length == 1) {
      this.dom.newTermSpan.style("display", "");
      this.dom.launchButton.text(`Create variable using "${this.state.groups[0].name}"`);
      this.dom.newTermNameInput.property("value", this.state.groups[0].name + " vs others");
      return;
    }
    const lst = [...this.selectedGroupsIdx];
    if (lst.length == 0) {
      this.dom.noGroupSelected.style("display", "");
      return;
    }
    this.dom.newTermSpan.style("display", "");
    if (lst.length == 1) {
      this.dom.launchButton.text(`Create  variable using "${this.state.groups[lst[0]]?.name}"`);
      this.dom.newTermNameInput.property("value", this.state.groups[lst[0]].name + " vs others");
      return;
    }
    this.dom.launchButton.text(`Create variable using ${lst.length} groups`);
    this.dom.newTermNameInput.property("value", lst.map((i3) => this.state.groups[i3].name).join(" vs "));
  }
  displayCustomTerms() {
    this.dom.customTermDiv.selectAll("*").remove();
    if (this.state.customTerms.length == 0) {
      this.dom.customTermDiv.append("div").text("No custom variables. Use above controls to create new ones. Custom variables are added to dictionary.").style("font-size", ".8em");
      return;
    }
    this.dom.customTermDiv.append("div").style("margin-bottom", "10px").style("font-size", ".8em").text("Following custom variables are available in all charts where variables are used. Click one to delete.");
    for (const { name, tw } of this.state.customTerms) {
      const div = this.dom.customTermDiv.append("div");
      div.text(name).attr("class", "sja_filter_tag_btn").attr("data-testid", `sjpp-custom-term-btn`).style("padding", "3px 6px").style("border-radius", "6px").style("margin-right", "5px").on("click", (event2) => {
        const deleteCallback = () => this.app.vocabApi.deleteCustomTerm(name);
        this.showGroupsMenu(event2, tw, deleteCallback);
      });
    }
  }
  newId() {
    this.lastId = get$id2();
    return this.lastId;
  }
  showGroupsMenu(event2, tw, deleteCallback) {
    const samplelstTW = structuredClone(tw);
    this.tip.clear().showunder(event2.target);
    const menuDiv = this.tip.d.append("div");
    const id3 = this?.lastId;
    const groupsInfo = menuDiv.append("div").attr("data-testid", "sjpp-groups-menu");
    const table = table2col({ holder: groupsInfo });
    table.table.style("scale", 0.9).style("margin-left", "0px");
    for (const [grpKey, grp] of Object.entries(tw.term.values)) {
      const colorSquare = grp.color ? `<span style="display:inline-block; width:12px; height:12px; background-color:${grp.color}" ></span>` : `<span style="display:inline-block; width:11px; height:11px; background-color:${"#fff"}; border: 0.1px solid black" ></span>`;
      const [c1, c2] = table.addRow();
      c1.html(`${colorSquare} ${grp.label}`);
      const sampleLabel = this.app.vocabApi.termdbConfig?.uiLabels?.samples || "samples";
      c2.html(`${grp.othersGroupSampleNum || grp.list.length} ${sampleLabel}`);
    }
    if (this.state.currentCohortChartTypes.includes("DA") && samplelstTW.q.groups.length == 2)
      addDiffAnalysisPlotMenuItem(menuDiv, this, samplelstTW);
    addSummarizeOptions(menuDiv, this, samplelstTW, id3);
    mayAddHierClusterPlotMenuItem("geneExpression", menuDiv, "Gene expression", this.tip2, samplelstTW, id3, this, true);
    mayAddMatrixMenuItems(menuDiv, "Matrix", this.tip2, samplelstTW, id3, this, this.state, true, () => this.newId);
    mayAddSamplescatterOption(menuDiv, this, samplelstTW);
    mayAddGenomebrowserOption(menuDiv, this, samplelstTW);
    mayAddBrainImagingOption(menuDiv, this, samplelstTW);
    menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-delete-variable").text("Delete variable").on("click", (event3) => {
      deleteCallback();
      this.tip.hide();
    });
  }
};
var groupsInit = getCompInit(MassGroups);
function addSummarizeOptions(menuDiv, self2, samplelstTW, id3) {
  const d = menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-summarize-option").text("Summarize");
  d.on("click", async () => {
    showTree(
      d,
      (term) => {
        const tw = { term };
        if (isNumericTerm(term)) tw.q = { mode: "continuous" };
        openSummaryPlot(tw, samplelstTW, self2.app, id3, () => self2.newId);
      },
      self2.app,
      self2.tip2
    );
  });
  d.insert("div").html("\u203A").style("float", "right");
  if (self2.state.currentCohortChartTypes.includes("survival"))
    addPlotMenuItem("survival", menuDiv, "Compare survival", self2.tip2, samplelstTW, id3, self2, true);
  if (self2.state.currentCohortChartTypes.includes("cuminc"))
    addPlotMenuItem("cuminc", menuDiv, "Compare cumulative incidence", self2.tip2, samplelstTW, id3, self2, true);
}
function mayAddGenomebrowserOption(menuDiv, self2, samplelstTW) {
  if (!self2.state.currentCohortChartTypes.includes("genomeBrowser")) return;
  if (!self2.app.vocabApi.termdbConfig.queries?.snvindel) return;
  if (self2.app.vocabApi.termdbConfig.queries.snvindel.details) return;
  if (samplelstTW.q.groups.length != 2) return;
  menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-genome-browser-option").text("Compare mutations").on("click", () => {
    self2.tip.hide();
    self2.tip2.hide();
    self2.tip3.hide();
    const [f1, f2] = makeFiltersFromTwoSampleGroups(samplelstTW);
    const config = {
      chartType: "genomeBrowser",
      snvindel: { shown: true, filter: f1 },
      // code filter in 1st tk
      subMds3Tks: [{ filterObj: f2 }]
      // code filter in 2nd tk
    };
    self2.app.dispatch({
      type: "plot_create",
      config
    });
  });
}
function mayAddBrainImagingOption(menuDiv, self2, samplelstTW) {
  const NIdata = self2.app.vocabApi.termdbConfig?.queries?.NIdata;
  if (!NIdata) return;
  const d = menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-brain-imaging-option").text("Compare brain imaging").on("click", async () => {
    const tip = self2.tip2;
    tip.clear().showunderoffset(d.node());
    const submenu = tip.d.append("div");
    const wait = submenu.append("div").style("margin", "5px").style("opacity", 0.5).text("Loading...");
    const seen = /* @__PURE__ */ new Set();
    const sampleNames = [];
    let listedItemCount = 0;
    for (const grp of Object.values(samplelstTW.term.values)) {
      if (grp.in === false) continue;
      for (const item of grp.list || []) {
        listedItemCount++;
        if (!item.sample || seen.has(item.sample)) continue;
        seen.add(item.sample);
        sampleNames.push(item.sample);
      }
    }
    const hasComplement = Object.values(samplelstTW.term.values).some((g) => g.in === false);
    if (!sampleNames.length) {
      wait.text(listedItemCount ? "Sample names are not accessible" : "No samples in this variable");
      return;
    }
    const entries = await Promise.all(
      Object.keys(NIdata.references).map(async (refKey) => {
        try {
          const available = await getBrainImagingSampleSet(
            self2.app.vocabApi.vocab.genome,
            self2.app.vocabApi.vocab.dslabel,
            refKey
          );
          return { refKey, available };
        } catch (e) {
          return { refKey, error: e.message || e };
        }
      })
    );
    wait.remove();
    for (const { refKey, available, error } of entries) {
      if (error) {
        sayerror(submenu, `${refKey}: ${error}`);
        continue;
      }
      const groupNames = sampleNames.filter((name) => available.has(name));
      const otherCount = hasComplement ? available.size - groupNames.length : 0;
      const row = submenu.append("div").text(
        `${refKey} (${groupNames.length} of ${sampleNames.length} with imaging` + (otherCount ? `, vs ${otherCount} others)` : ")")
      );
      if (!groupNames.length) {
        row.attr("class", "sja_menuoption_not_interactive").style("opacity", 0.5);
        continue;
      }
      const names = hasComplement ? [...available] : groupNames;
      row.attr("class", "sja_menuoption sja_sharp_border").on("click", async () => {
        self2.tip.hide();
        tip.hide();
        const divideByTW = structuredClone(samplelstTW);
        await fillTermWrapper(divideByTW, self2.app.vocabApi);
        self2.app.dispatch({
          type: "plot_create",
          config: {
            chartType: "brainImaging",
            queryKey: refKey,
            selectedSampleFileNames: names.map((name) => name + ".nii"),
            divideByTW
          }
        });
      });
    }
  });
  d.insert("div").html("\u203A").style("float", "right");
}
function makeFiltersFromTwoSampleGroups(tw) {
  const [g1, g2] = tw.q.groups;
  if (!g1 || !g2) throw "not 2 groups in tw.q.groups[]";
  return [
    {
      in: g1.in,
      join: "",
      type: "tvslst",
      lst: [
        {
          type: "tvs",
          tvs: {
            term: {
              name: g1.name,
              type: "samplelst",
              values: {
                [g1.name]: {
                  key: g1.name,
                  label: g1.name,
                  list: g1.values
                }
              }
            }
          }
        }
      ]
    },
    {
      in: g2.in,
      join: "",
      type: "tvslst",
      lst: [
        {
          type: "tvs",
          tvs: {
            term: {
              name: g2.name,
              type: "samplelst",
              values: {
                [g2.name]: {
                  key: g2.name,
                  label: g2.name,
                  list: g2.values
                }
              }
            }
          }
        }
      ]
    }
  ];
}
function mayAddSamplescatterOption(menuDiv, self2, samplelstTW) {
  if (!self2.app.vocabApi.termdbConfig.scatterplots) return;
  for (const plot of self2.app.vocabApi.termdbConfig.scatterplots) {
    if (plot.colorTW)
      menuDiv.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", `sjpp-samplescatter-option-${plot.name.toLowerCase()}`).text(`Overlay on ${plot.name}`).on("click", () => {
        self2.tip2.hide();
        let config = {
          chartType: "sampleScatter",
          name: plot.name
        };
        if (plot.sampleCategory)
          config.sampleCategory = {
            tw: structuredClone(plot.sampleCategory.tw),
            order: plot.sampleCategory.order,
            defaultValue: plot.sampleCategory.defaultValue
          };
        if (plot.sampleType) config.sampleType = plot.sampleType;
        config.colorTW = structuredClone(samplelstTW);
        if (plot.settings) config.settings = structuredClone(plot.settings);
        self2.app.dispatch({
          type: "plot_create",
          config
        });
        self2.tip.hide();
      });
  }
}
function addDiffAnalysisPlotMenuItem(div, self2, samplelstTW) {
  if (self2.app.vocabApi.termdbConfig.queries?.rnaseqGeneCount) {
    const itemDiv = div.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-da-option").text(`Differential ${termType2label(TermTypes.GENE_EXPRESSION)} Analysis`).on("click", async (e) => {
      const groups = [];
      for (const group of samplelstTW.q.groups) {
        if (group.values && group.values.length > 0) {
          groups.push(group);
        } else {
          throw "group does not contain samples for differential analysis";
        }
      }
      const body = {
        genome: self2.app.vocabApi.vocab.genome,
        dslabel: self2.app.vocabApi.vocab.dslabel,
        samplelst: { groups },
        filter: self2.state.termfilter.filter,
        filter0: self2.state.termfilter.filter0,
        preAnalysis: true
      };
      const preAnalysisData = await dofetch3("termdb/DE", { body });
      const tip = self2.tip2;
      if (!preAnalysisData?.data) {
        tip.clear().showunderoffset(itemDiv.node());
        sayerror(tip.d.append("div"), "Error retrieving pre-analysis data");
        throw new Error("no data returned from pre-analysis request");
      }
      tip.clear().showunderoffset(itemDiv.node());
      renderPreAnalysisData({ preAnalysisData, samplelstTW, groups, tip, self: self2 });
    });
  }
  const dmQuery = self2.app.vocabApi.termdbConfig.queries?.dnaMethylation;
  if (dmQuery?.promoter || dmQuery?.elementTypes?.length) {
    const itemDiv = div.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", "sjpp-da-dnaMeth-option").text(`Differential ${termType2label(TermTypes.DNA_METHYLATION)} Analysis`).on("click", async () => {
      const groups = [];
      for (const group of samplelstTW.q.groups) {
        if (group.values && group.values.length > 0) {
          groups.push(group);
        } else {
          throw "group does not contain samples for differential analysis";
        }
      }
      const body = {
        genome: self2.app.vocabApi.vocab.genome,
        dslabel: self2.app.vocabApi.vocab.dslabel,
        samplelst: { groups },
        filter: self2.state.termfilter.filter,
        filter0: self2.state.termfilter.filter0,
        preAnalysis: true
      };
      const preAnalysisData = await dofetch3("termdb/diffMeth", { body });
      const tip = self2.tip2;
      if (!preAnalysisData?.data) {
        tip.clear().showunderoffset(itemDiv.node());
        sayerror(tip.d.append("div"), "Error retrieving pre-analysis data");
        throw new Error("no data returned from pre-analysis request");
      }
      tip.clear().showunderoffset(itemDiv.node());
      renderPreAnalysisData({
        preAnalysisData,
        samplelstTW,
        groups,
        tip,
        termType: TermTypes.DNA_METHYLATION,
        self: self2
      });
    });
  }
  if (self2.app.vocabApi.termdbConfig.allowedTermTypes?.includes(TermTypes.METABOLITE_INTENSITY)) {
    div.append("div").text("DA should support metabolite");
  }
  if (self2.app.vocabApi.termdbConfig.allowedTermTypes?.includes(TermTypes.PROTEOME_ABUNDANCE)) {
    div.append("div").text("DA should support whole proteome abundance");
  }
  const noteDiv = div.append("div").style("font-size", "0.8em").style("opacity", 0.8).style("padding", "3px 3px 3px 10px");
  for (const [role, i3] of [
    ["CASE", 1],
    ["CONTROL", 0]
  ]) {
    noteDiv.append("span").style("font-size", ".8em").style("font-weight", "bold").text(role);
    noteDiv.append("span").style("margin", "0 10px 0 4px").text(samplelstTW.q.groups[i3].name);
  }
}
function addGroupCountRow(table, role, samplelstTW, i3, count, sampleLabel) {
  const name = samplelstTW.q.groups[i3].name;
  const color = samplelstTW.term.values[name].color;
  const [c1, c2] = table.addRow();
  c1.append("span").style("font-size", ".8em").style("font-weight", "bold").text(role);
  const square = c1.append("span").style("display", "inline-block").style("margin", "0 4px");
  if (color) square.style("width", "12px").style("height", "12px").style("background-color", color);
  else
    square.style("width", "11px").style("height", "11px").style("background-color", "#fff").style("border", "0.1px solid black");
  c1.append("span").text(name);
  c2.text(`${count} ${sampleLabel}`);
}
function renderCountsFileInfo(holder, preview, sampleLabel) {
  if (!preview) return;
  const lines = [];
  const missing = preview.casesRequested - preview.cases;
  lines.push(
    `${preview.cases} of ${preview.casesRequested} ${sampleLabel} resolve to a counts file` + (missing > 0 ? ` \u2014 ${missing} have no open-access file` : "")
  );
  lines.push(
    `${preview.candidateFiles} candidate ${preview.candidateFiles == 1 ? "file" : "files"}; ${preview.casesWithMultiple} ${sampleLabel} had more than one`
  );
  lines.push(
    "Aliquots: " + Object.entries(preview.byTissueType).map(([t2, n]) => `${n} ${t2}`).join(", ")
  );
  if (preview.axisKnown && preview.toDownload != null)
    lines.push(
      preview.matrixCached ? "Fetch: none, this cohort is already assembled" : preview.toDownload ? `Fetch: ${preview.cached} cached, ${preview.toDownload} to download` : "Fetch: none, every file is already cached"
    );
  lines.push(`Rule: ${preview.selectionRule}`);
  const div = holder.append("div").style("margin", "2px 0 0 5px").style("padding", "0 10px").style("font-size", ".85em").style("opacity", 0.65);
  for (const l of lines) div.append("div").text(l);
}
function renderPreAnalysisData(arg) {
  const { preAnalysisData, samplelstTW, groups, holder, tip, self: self2 } = arg;
  const termType14 = arg.termType || TermTypes.GENE_EXPRESSION;
  const isGE = termType14 == TermTypes.GENE_EXPRESSION;
  if (!preAnalysisData?.data) return;
  const numControl = preAnalysisData.data[samplelstTW.q.groups[0].name];
  const numCase = preAnalysisData.data[samplelstTW.q.groups[1].name];
  if (numControl + numCase > maxSampleCutoff) {
    if (preAnalysisData.alert)
      preAnalysisData.alert += ` | Sample size ${numControl + numCase} exceeds max sample size of ${maxSampleCutoff}. Please reduce sample size.`;
    else
      preAnalysisData.alert = `Sample size ${numControl + numCase} exceeds max sample size of ${maxSampleCutoff}. Please reduce sample size.`;
  }
  const uiLabels = self2?.app?.vocabApi?.termdbConfig?.uiLabels;
  const sampleLabel = uiLabels?.samples || "samples";
  const menuDiv = tip ? tip.d.append("div") : holder.append("div");
  menuDiv.append("div").style("font-weight", "bold").style("margin", "5px 0 0 5px").text(`${uiLabels?.Samples || "Samples"} with ${termType2label(termType14)} data:`);
  const table = table2col({ holder: menuDiv });
  table.table.style("margin-left", "5px").style("padding", "5px 10px");
  addGroupCountRow(table, "CONTROL", samplelstTW, 0, numControl, sampleLabel);
  addGroupCountRow(table, "CASE", samplelstTW, 1, numCase, sampleLabel);
  renderCountsFileInfo(menuDiv, preAnalysisData.countsFiles, sampleLabel);
  const alertDiv = menuDiv.append("div");
  if (preAnalysisData.alert) {
    sayerror(alertDiv, preAnalysisData.alert);
  }
  const sample_size_limit = 8;
  if (!preAnalysisData.alert) {
    const options = !isGE ? [] : numControl + numCase >= maxGESampleCutoff ? [{ label: "Wilcoxon", value: "wilcoxon" }] : numControl <= sample_size_limit && numCase <= sample_size_limit ? [
      { label: "edgeR", value: "edgeR" },
      { label: "Limma", value: "limma" }
    ] : [
      { label: "edgeR", value: "edgeR" },
      { label: "Wilcoxon", value: "wilcoxon" },
      { label: "Limma", value: "limma" }
    ];
    const preferredMethod = self2?.app?.vocabApi?.termdbConfig?.queries?.rnaseqGeneCount?.defaultMethod;
    if (preferredMethod) {
      const i3 = options.findIndex((o) => o.value == preferredMethod);
      if (i3 > 0) options.unshift(options.splice(i3, 1)[0]);
    }
    const launchDEDiv = menuDiv.append("div").style("margin", "8px 5px").style("padding", "5px 10px");
    let selectedMethod = options[0]?.value;
    if (options.length) {
      const radioRow = launchDEDiv.append("tr");
      radioRow.append("td").html("Method").attr("aria-label", "DE Method").attr("class", "sja-termdb-config-row-label").style("padding", "5px");
      const cell = radioRow.append("td");
      const radioBtnDiv = cell.append("div");
      make_radios({
        holder: radioBtnDiv,
        inputName: `de-method-${Date.now()}`,
        options: options.map((o, i3) => ({
          ...o,
          title: `${o.label} method`,
          checked: i3 === 0
          // preselect first option
        })),
        styles: {
          display: "inline-block",
          padding: "0 12px 0 0"
        },
        callback: (v) => selectedMethod = v
      });
    }
    launchDEDiv.append("button").style("border", "none").style("border-radius", "20px").style("padding", "10px 15px").attr("data-testid", "sjpp-da-run-btn").text(`Run Differential ${termType2label(termType14)} Analysis`).on("click", async () => {
      const config = {
        chartType: "differentialAnalysis",
        state: self2.state,
        samplelst: { groups },
        termType: termType14,
        tw: samplelstTW,
        // only expression carries a method; passing an undefined one would fail volcano settings validation
        ...selectedMethod ? { settings: { volcano: { method: selectedMethod } } } : {}
      };
      if (tip) tip.hide();
      if (self2.tip) self2.tip.hide();
      self2.app.dispatch({
        type: "plot_create",
        config
      });
    });
  }
}
function initUI(self2) {
  self2.dom.filterTableDiv = self2.dom.holder.append("div").style("margin-bottom", "10px");
  const btnRow = self2.dom.holder.append("div");
  self2.dom.addNewGroupBtnHolder = btnRow.append("span").style("margin-right", "20px");
  self2.dom.newTermSpan = btnRow.append("span");
  self2.dom.newTermSpan.append("span").style("padding-left", "15px").text("Add variable:");
  self2.dom.newTermNameInput = self2.dom.newTermSpan.append("input").attr("type", "text");
  self2.dom.launchButton = self2.dom.newTermSpan.append("span").attr("class", "sja_menuoption").attr("data-testid", "sjpp-create-new-variable-btn").on("click", () => clickLaunchBtn(self2));
  self2.dom.noGroupSelected = btnRow.append("span").text("No groups selected").style("opacity", 0.5);
  self2.dom.customTermDiv = self2.dom.holder.append("div").style("margin", "20px").style("border-left", "solid 1px black").style("padding", "10px");
}
async function updateUI(self2) {
  if (!self2.filterPrompt) {
    self2.filterPrompt = await filterPromptInit({
      holder: self2.dom.addNewGroupBtnHolder,
      vocabApi: self2.app.vocabApi,
      emptyLabel: "Add group",
      termdbConfig: self2.app.vocabApi.termdbConfig,
      callback: (f) => {
        addNewGroup(self2.app, f, self2.state.groups);
      },
      debug: self2.opts.debug
    });
  }
  self2.filterPrompt.main(self2.getMassFilter());
  const groups = structuredClone(self2.state.groups);
  if (!groups.length) {
    self2.updateLaunchButton();
    self2.dom.filterTableDiv.style("display", "none");
    self2.displayCustomTerms();
    return;
  }
  self2.dom.filterTableDiv.style("display", "").selectAll("*").remove();
  const tableArg = {
    div: self2.dom.filterTableDiv,
    columns: [
      {},
      // blank column to add delete buttons
      {
        label: "NAME",
        editCallback: async (i3, cell) => {
          const newName = cell.value;
          const index = self2.state.groups.findIndex((group) => group.name == newName);
          if (index != -1) {
            alert(`Group named ${newName} already exists`);
            updateUI(self2);
          } else
            await self2.app.dispatch({
              type: "rename_group",
              index: i3,
              newName: cell.value
            });
        }
      },
      {
        label: "COLOR",
        editCallback: async (i3, cell) => {
          await self2.app.dispatch({
            type: "change_color_group",
            index: i3,
            newColor: cell.color
          });
        }
      },
      // dataset may rename what a row counts (GDC: cases, not samples). singular, like the count
      // cells below that already use uiLabels
      { label: `#${uiLabel(self2.app.vocabApi.termdbConfig?.uiLabels, "Sample", "Sample").toUpperCase()}` },
      { label: "FILTER" }
    ],
    rows: [],
    striped: false,
    // no alternating row bg color so delete button appears more visible
    showLines: false
  };
  for (const [i3, g] of groups.entries()) {
    tableArg.rows.push([
      {},
      // blank cell to add delete button
      { value: g.name, dataTestId: `sjpp-groups-name-${i3}` },
      // to allow click to show <input>
      { color: g.color },
      { value: "Loading..." },
      // sample count is lazily retrieved to not to hold up table rendering
      {}
      // blank cell to show filter ui
    ]);
  }
  self2.selectedGroupsIdx.clear();
  if (groups.length == 1) {
    self2.selectedGroupsIdx.add(0);
  } else {
    tableArg.noButtonCallback = (i3, node) => {
      if (node.checked) self2.selectedGroupsIdx.add(i3);
      else self2.selectedGroupsIdx.delete(i3);
      self2.updateLaunchButton();
    };
    tableArg.selectedRows = [];
    for (let i3 = 0; i3 < groups.length; i3++) {
      tableArg.selectedRows.push(i3);
      self2.selectedGroupsIdx.add(i3);
    }
  }
  renderTable(tableArg);
  for (const [i3, row] of tableArg.rows.entries()) {
    row[0].__td.append("div").attr("class", "sja_menuoption").attr("data-testid", "sjpp-delete-group").style("padding", "1px 6px").html("&times;").on("click", () => {
      const group2 = groups[i3];
      self2.app.vocabApi.deleteGroup(group2.name);
    });
    const group = groups[i3];
    filterInit({
      holder: row[4].__td,
      vocabApi: self2.app.vocabApi,
      termdbConfig: self2.app.vocabApi.termdbConfig,
      callback: (f) => {
        if (!f || f.lst.length == 0) {
          const i4 = groups.findIndex((g) => g.name == group.name);
          groups.splice(i4, 1);
        } else {
          group.filter = f;
        }
        self2.app.dispatch({
          type: "app_refresh",
          state: { groups }
        });
      }
    }).main(group.filter);
    self2.app.vocabApi.getFilteredSampleCount(groups[i3].filter, self2.state.termfilter.filter0).then((n) => row[3].__td.text(n)).catch((e) => row[3].__td.text("n/a").attr("title", e?.message || e));
  }
  self2.updateLaunchButton();
  self2.displayCustomTerms();
}
async function clickLaunchBtn(self2) {
  const groups = [];
  for (const i3 of self2.selectedGroupsIdx) {
    const g = self2.state.groups[i3];
    if (g) groups.push(g);
  }
  if (groups.length == 0) throw "No groups, should not happen";
  const name = self2.dom.newTermNameInput.property("value");
  const tw = await self2.groups2samplelst(groups);
  if (!tw) return;
  tw.term.name = name;
  self2.app.vocabApi.addCustomTerm({ name, tw });
  self2.dom.newTermSpan.style("display", "none");
}
function rebaseGroupFilter(s) {
  if (!s.termfilter?.filter || s.termfilter.filter.lst.length == 0) {
    return s.groups;
  }
  const groups = [];
  for (const g of s.groups) {
    const f = getNormalRoot(structuredClone(s.termfilter.filter));
    const f2 = getFilterItemByTag(g.filter, "filterUiRoot");
    if (!f2) {
      groups.push(g);
      continue;
    }
    f.lst.push(f2);
    f.join = f.lst.length > 1 ? "and" : "";
    const g2 = {
      name: g.name,
      filter: f,
      color: g.color
    };
    groups.push(g2);
  }
  return groups;
}
async function openPlot(chartType, term, term2, app, id3, newId) {
  let config = {
    chartType,
    term,
    term2
  };
  if (id3) config.insertBefore = id3;
  if (newId) config.id = newId();
  await app.dispatch({
    type: "plot_create",
    config
  });
}
async function openSummaryPlot(tw, samplelstTW, app, id3, newId) {
  const config = {
    chartType: "summary",
    childType: tw.q?.mode == "continuous" ? "violin" : "barchart",
    term: tw,
    term2: samplelstTW
  };
  if (id3) config.insertBefore = id3;
  if (newId) config.id = newId();
  await app.dispatch({
    type: "plot_create",
    config
  });
}
async function showTree(div, callback, app, tip, treeState = { tree: { usecase: { target: "default", detail: "term" } } }) {
  const activeCohort = app.getState().activeCohort;
  const state = { activeCohort, ...treeState };
  tip.clear().showunderoffset(div.node());
  appInit({
    holder: tip.d,
    vocabApi: app.vocabApi,
    state,
    tree: {
      click_term: (term) => {
        callback(term);
        tip.hide();
        if (tip.dnode.parent_menu) tip.dnode.parent_menu.style.display = "none";
      }
    }
  });
}
function addPlotMenuItem(chartType, div, text, tip, samplelstTW, id3, parent, openOnTop = false) {
  const d = div.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", `sjpp-${chartType}-option`).text(text).on("click", (e) => {
    const state = { tree: { usecase: { target: chartType, detail: "term" } } };
    if (chartType == "survival") state.nav = { header_mode: "hide_search" };
    showTree(
      d,
      (term) => {
        openPlot(chartType, term, samplelstTW, parent.app, id3, openOnTop ? () => parent.newId : null);
      },
      parent.app,
      tip,
      state
    );
  });
  d.insert("div").html("\u203A").style("float", "right");
}
function mayAddHierClusterPlotMenuItem(chartType, div, text, tip, samplelstTW, id3, parent, openOnTop = false) {
  if (!parent.state.currentCohortChartTypes.includes("geneExpression")) return;
  const itemDiv = div.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", `sjpp-hiercluster-option`).text(text).on("click", () => {
    tip.clear().showunderoffset(itemDiv.node());
    new GeneSetEditUI({
      holder: tip.d,
      genome: parent.app.opts.genome,
      geneList: [],
      vocabApi: parent.app.vocabApi,
      mode: TermTypes.GENE_EXPRESSION,
      callback: async ({ geneList, groupName }) => {
        const group = { name: groupName, lst: [], type: "hierCluster" };
        const lst = group.lst.filter((tw) => tw.term.type != "geneExpression");
        const tws = await Promise.all(
          geneList.map(async (d) => {
            const gene = d.symbol || d.gene;
            const unit = getGEunit(parent.app.vocabApi);
            const name = `${gene} ${unit}`;
            const term = { gene, name, type: "geneExpression" };
            let tw = group.lst.find((tw2) => tw2.term.name == d.symbol || tw2.term.name == d.gene);
            if (!tw) {
              tw = { term, q: {} };
            }
            return tw;
          })
        );
        tip.hide();
        if (tip.dnode.parent_menu) tip.dnode.parent_menu.style.display = "none";
        if (tws.length == 1) {
          const tw = tws[0];
          parent.app.dispatch({
            type: "plot_create",
            config: {
              chartType: "summary",
              term: tw,
              term2: samplelstTW
            }
          });
          return;
        }
        if (tws.length == 2) {
          const tw = tws[0];
          const tw2 = tws[1];
          parent.app.dispatch({
            type: "plot_create",
            config: {
              chartType: "summary",
              term: tw,
              term2: tw2,
              colorTW: samplelstTW
            }
          });
          return;
        }
        group.lst = [...lst, ...tws];
        parent.app.dispatch({
          type: "plot_create",
          config: {
            chartType: "hierCluster",
            termgroups: [group],
            dataType: TermTypes.GENE_EXPRESSION,
            divideBy: samplelstTW,
            settings: { hierCluster: { yDendrogramHeight: 0, clusterSamples: false } }
          }
        });
      }
    });
  });
  itemDiv.insert("div").html("\u203A").style("float", "right");
}
function mayAddMatrixMenuItems(div, text, tip, samplelstTW, id3, parent, state, openOnTop = false, newId) {
  if (!state.currentCohortChartTypes.includes("matrix")) return;
  const preBuiltMatrix = state.matrixplots;
  const hasSnvIndel = parent.app.vocabApi.termdbConfig?.queries?.snvindel;
  if (!preBuiltMatrix && !hasSnvIndel) return;
  const itemDiv = div.append("div").attr("class", "sja_menuoption sja_sharp_border").attr("data-testid", `sjpp-matrix-option`).text(text).on("click", () => {
    tip.clear().showunderoffset(itemDiv.node());
    if (preBuiltMatrix) {
      const preBuiltMatrixDiv = tip.d.append("div");
      for (const plot of preBuiltMatrix) {
        preBuiltMatrixDiv.append("button").style("margin", "10px").style("padding", "10px 15px").style("border-radius", "20px").style("border-color", "#ededed").style("display", "inline-block").text("Divide " + plot.name).on("click", async () => {
          const config = await parent.app.vocabApi.getMatrixByName(plot.name);
          config.divideBy = samplelstTW;
          config.insertBefore = id3;
          config.settings.matrix.colw = 0;
          if (newId) config.id = newId();
          parent.app.dispatch({
            type: "plot_create",
            config
          });
          tip.hide();
          tip.dnode.parent_menu.style.display = "none";
        });
      }
    }
    if (hasSnvIndel) {
      const newMatrixDiv = tip.d.append("div");
      new GeneSetEditUI({
        holder: newMatrixDiv,
        genome: parent.app.opts.genome,
        geneList: [],
        mode: TermTypes.GENE_VARIANT,
        vocabApi: parent.app.vocabApi,
        callback: async ({ geneList, groupName }) => {
          tip.hide();
          tip.dnode.parent_menu.style.display = "none";
          const group = { name: groupName, lst: [] };
          const lst = group.lst.filter((tw) => tw.term.type != "geneVariant");
          const tws = await Promise.all(
            geneList.map(async (d) => {
              const term = {
                gene: d.symbol || d.gene,
                name: d.symbol || d.gene,
                type: "geneVariant"
              };
              let tw = group.lst.find((tw2) => tw2.term.name == d.symbol || tw2.term.name == d.gene);
              if (!tw) {
                tw = { term };
                await fillTermWrapper(tw, parent.app.vocabApi);
              } else if (!tw.$id) {
                tw.$id = await get$id2(parent.app.vocabApi.getTwMinCopy({ term }));
              }
              return tw;
            })
          );
          group.lst = [...lst, ...tws];
          parent.app.dispatch({
            type: "plot_create",
            config: {
              chartType: "matrix",
              termgroups: [group],
              dataType: TermTypes.GENE_VARIANT,
              divideBy: samplelstTW
            }
          });
        }
      });
    }
  });
  itemDiv.insert("div").html("\u203A").style("float", "right");
}
function addNewGroup(app, filter2, groups) {
  groups = JSON.parse(JSON.stringify(groups));
  let name = "New group";
  let i3 = 0;
  while (1) {
    const name2 = name + (i3 == 0 ? "" : " " + i3);
    if (!groups.find((g) => g.name == name2)) break;
    i3++;
  }
  name = name + (i3 == 0 ? "" : " " + i3);
  const newGroup = {
    name,
    filter: filter2,
    color: rgb(colorScale(groups.length)).formatHex()
  };
  groups.push(newGroup);
  app.dispatch({
    type: "app_refresh",
    state: { groups }
  });
}
function getSamplelstTWFromIds(ids) {
  if (!ids) throw "getSamplelstTWFromIds: ids is empty";
  if (!Array.isArray(ids)) throw "getSamplelstTWFromIds: ids must be an array";
  const name = "group";
  const values = ids.map((id3) => {
    return { sampleId: id3 };
  });
  const qgroup = {
    name,
    in: true,
    values
  };
  const tw = {
    isAtomic: true,
    term: { name, type: "samplelst", values: { [name]: { key: name, list: values } } },
    q: {
      groups: [qgroup]
    }
  };
  return tw;
}
function getSamplelstFilter(ids) {
  const tw = getSamplelstTWFromIds(ids);
  const filter2 = getFilter(tw);
  return filter2;
}
function getFilter(samplelstTW) {
  let i3 = 0;
  let noEdit = true;
  for (const field in samplelstTW.term.values) {
    const values = samplelstTW.q.groups[i3].values;
    samplelstTW.term.values[field].list = values;
    if (values[0] && "sample" in values[0]) noEdit = false;
    i3++;
  }
  const filter2 = {
    type: "tvslst",
    in: true,
    join: "",
    lst: [
      {
        type: "tvs",
        tvs: { term: samplelstTW.term },
        noEdit
      }
    ]
  };
  return filter2;
}
function getSampleFilter(sampleId) {
  if (!sampleId) throw "getSampleFilter: sampleId is empty";
  if (Array.isArray(sampleId)) throw "getSampleFilter: sampleId arg cannot be an array";
  const group = { name: "", index: 0, items: [{ sampleId }] };
  const samplelst = getSamplelstTW([group], "", false);
  const filter2 = getFilter(samplelst);
  return filter2;
}
function getSamplelstTW2(groups) {
  const values = {};
  const qgroups = [];
  for (const group of groups) {
    const samples = getGroupSamples(group);
    const qgroup = {
      name: group.name,
      in: true,
      values: samples
    };
    qgroups.push(qgroup);
    values[group.name] = { key: group.name, label: group.name, color: group.color, list: samples };
  }
  return {
    isAtomic: true,
    term: { name: "groups", type: "samplelst", values },
    q: { groups: qgroups }
  };
}
function getSamplelstTW(groups, name = groups.length == 1 ? "group" : "groups", notIn = true) {
  const values = {};
  const qgroups = [];
  let samples;
  for (const group of groups) {
    samples = getGroupSamples(group);
    const qgroup = {
      name: group.name,
      in: true,
      values: samples
    };
    qgroups.push(qgroup);
    values[group.name] = { key: group.name, label: group.name, color: group.color, list: samples };
  }
  if (groups.length == 1 && notIn) {
    const name2 = "Not in " + groups[0].name;
    values[name2] = { key: name2, label: name2, color: "#aaa", list: samples, in: false };
    qgroups.push({
      name: name2,
      in: false,
      values: samples
    });
  }
  const tw = {
    isAtomic: true,
    term: { name, type: "samplelst", values },
    q: { groups: qgroups }
  };
  return tw;
}
function getGroupSamples(group) {
  const values = [];
  for (const item of group.items) {
    const value = { sampleId: item.sampleId };
    if ("sample" in item) {
      value.sample = item.sample;
    }
    values.push(value);
  }
  return values;
}

// plots/barchart/bars.renderer.ts
var formatter = format("d");
function barsRenderer(barsapp, holder) {
  holder.selectAll("*").remove();
  const hm = {}, computed = {};
  const emptyObj = {};
  let chart;
  let chartTitle;
  let svg, mainG, series, collabels, rowlabels;
  let axisG, yAxis, yTitle, yLine, xAxis, xTitle, xLine;
  let currCell, currRowTexts, currColTexts;
  let defaults3;
  let currserieses = [];
  let prevBox;
  function main(_chart) {
    const prevOrientation = hm.orientation;
    chart = _chart;
    Object.assign(hm, chart.settings);
    hm.handlers = chart.handlers;
    hm.cols = hm.cols.filter((colId) => hm.colLabels.find((d) => d.id == colId));
    hm.rows = hm.rows?.filter((d) => !hm.exclude.rows.includes(d)) || [];
    const nosvg = !svg;
    if (nosvg) init(_chart);
    const unadjustedColw = hm.colw;
    currserieses = chart.visibleSerieses;
    currserieses.map(setIds);
    chart.serieses.map(setIds);
    setDimensions();
    _chart.name = hm.handlers.chart.title(chart);
    chartTitle.style("width", hm.svgw + 100 + "px").style("font-size", "1.1em").style("margin-bottom", "24px").html(_chart.name);
    if (nosvg) {
      svg.attr("height", 0).attr("width", 0).style("opacity", 0);
      mainG.attr("transform", "translate(" + hm.rowlabelw + ",0)");
    }
    const s = series.attr("transform", seriesGrpTransform).selectAll(".bars-cell-grp").data(currserieses, seriesBindKey);
    s.exit().each(seriesExit);
    s.each(seriesUpdate);
    s.enter().append("g").each(seriesEnter);
    const c = collabels.attr("transform", colLabelsTransform).style("opacity", prevOrientation != hm.orientation ? 1e-4 : 1).style("display", hm.orientation != "vertical" ? "none" : "").selectAll("g").data(hm.colLabels, (d) => d.id);
    c.exit().remove();
    c.each(updateColLabel);
    c.enter().append("g").each(addColLabel);
    const r = rowlabels.attr("transform", rowLabelsTransform).style("opacity", prevOrientation != hm.orientation ? 1e-4 : 1).style("display", hm.orientation != "horizontal" ? "none" : "").selectAll("g").data(hm.colLabels, (d) => d.id);
    r.exit().remove();
    r.each(updateRowLabel);
    r.enter().append("g").each(addRowLabel);
    currColTexts = collabels.selectAll("text");
    hm.delay = 0.35 * hm.duration;
    renderAxes(hm, prevOrientation, chart.visibleTotal);
    hm.colw = unadjustedColw;
    if (prevOrientation != hm.orientation) {
      const labels = hm.orientation == "vertical" ? collabels : rowlabels;
      labels.transition().duration(1500).style("opacity", 1);
    }
    if (nosvg) {
      svg.transition().duration(100).attr("height", 1).attr("width", 1).style("opacity", 1);
    }
    setTimeout(
      () => {
        const extraPad = 20;
        const currBox = mainG.node().getBBox();
        const bbox = !prevBox || currBox.width ? currBox : prevBox;
        prevBox = bbox;
        svg.transition().duration(currBox.width ? 100 : 0).attr("width", bbox.width + extraPad).attr("height", bbox.height + extraPad);
        if (hm.orientation == "vertical") {
          const cbox = collabels.node().getBBox();
          const ytbox = yTitle.node().getBBox();
          const xoffset = Math.max(-cbox.x, -ytbox.x, -bbox.x);
          mainG.transition().duration(currBox.width ? 100 : 0).attr("transform", "translate(" + xoffset + "," + -extraPad + ")");
        } else {
          const rbox = rowlabels.node().getBBox();
          const ytbox = yTitle.node().getBBox();
          const xtbox = xTitle.node().getBBox();
          mainG.transition().duration(currBox.width ? 100 : 0).attr("transform", "translate(" + Math.max(-rbox.x, -ytbox.x) + "," + -xtbox.y + ")");
        }
      },
      nosvg ? 110 : 510
    );
  }
  function init(_chart) {
    defaults3 = {
      geneonrow: hm.geneonrow,
      nicenames: {},
      colw: hm.geneonrow ? Math.min(15, Math.max(1, Math.floor(document.body.clientWidth * 0.7 / hm.cols.length))) : 20,
      rowh: hm.geneonrow ? 20 : Math.min(18, Math.max(10, Math.floor(document.body.clientHeight * 0.7 / hm.rows.length))),
      rowspace: hm.geneonrow ? 2 : hm.rows.length > 100 ? 0 : 1,
      colspace: !hm.geneonrow ? 2 : hm.cols.length > 100 ? 0 : 1,
      rowtick: 8,
      coltick: 5,
      rowlabtickspace: 4,
      collabtickspace: 4,
      collabelh: 150,
      rowlabelw: 250,
      rowheadleft: true,
      colheadtop: false,
      samplecount4gene: true,
      samplecount4legend: false,
      showgrid: true,
      gridstroke: "#fff",
      showEmptyCells: false,
      cellbg: "#eeeeee",
      fontsizeratio: 0.9,
      rowlabelfontsizemax: 16,
      collabelfontsizemax: 12,
      crudefill: hm.colw <= 2,
      duration: 1e3,
      delay: 0
    };
    for (const key in defaults3) {
      if (!(key in hm) || key == "cols" || key == "rows") hm[key] = defaults3[key];
    }
    if (!svg) {
      chartTitle = holder.append("div").attr("class", "pp-chart-title").style("text-align", "center");
      svg = holder.append("svg").attr("class", "pp-bars-svg").style("overflow", "visible").on("mouseover.tphm2", hm.handlers.svg.mouseover).on("mouseout.tphm2", hm.handlers.svg.mouseout).on("click.tphm2", hm.handlers.svg.click);
      _chart.svg = svg;
    }
    mainG = svg.append("g").attr("class", "sjpcb-bars-mainG").attr("data-testid", "sjpcb-bars-mainG");
    hm.h.svg = svg;
    hm.h.mainG = mainG;
    collabels = mainG.append("g").attr("class", "bars-collabels").style("cursor", hm.handlers.barLabel.click ? "pointer" : "").on("mouseover.tphm2", colLabelMouseover).on("mouseout.tphm2", colLabelMouseout).on("click.tphm2", hm.handlers.barLabel.click);
    rowlabels = mainG.append("g").attr("class", "bars-rowlabels").attr("data-testid", "sjpcb-bars-rowlabels").style("cursor", hm.handlers.barLabel.click ? "pointer" : "").on("mouseover.tphm2", colLabelMouseover).on("mouseout.tphm2", colLabelMouseout).on("click.tphm2", hm.handlers.barLabel.click);
    series = mainG.append("g").attr("class", "bars-series").attr("data-testid", "sjpcb-bars-series").on("mouseover.tphm2", seriesMouseOver).on("mouseout.tphm2", seriesMouseOut).on("click", seriesClick).style("cursor", "pointer");
    axisG = mainG.append("g").attr("class", "sjpcb-bar-chart-axis-g");
    yAxis = axisG.append("g").attr("class", "sjpcb-bar-chart-y-axis");
    yLine = axisG.append("line").attr("class", "sjpcb-bar-chart-y-line").style("stroke", "#000");
    yTitle = axisG.append("g").attr("class", "sjpcb-bar-chart-y-title").style("cursor", "default");
    xAxis = axisG.append("g").attr("class", "sjpcb-bar-chart-x-axis");
    xLine = axisG.append("line").attr("class", "sjpcb-bar-chart-x-line").style("stroke", "#000");
    xTitle = axisG.append("g").attr("class", "sjpcb-bar-chart-x-title").style("cursor", "default");
  }
  function setDimensions() {
    const maxChartsPerRow = hm.numCharts < 4 ? hm.numCharts : hm.numCharts % 3 == 0 ? 3 : 2;
    const spacing = hm.cols.length * hm.colspace + (hm.colgrps.length - 1) * hm.colgspace + hm.rowlabelw + hm.rowgrplabelw;
    if (hm.orientation == "horizontal") {
      hm.svgw = hm.plotLength + hm.rowlabelw;
      hm.rowh = Math.max(14, Math.min(22, 0.7 * window.innerHeight / hm.cols.length));
      hm.svgh = hm.cols.length * (hm.rowh + hm.colspace) - hm.colspace + (hm.colgrps.length - 1) * hm.colgspace + hm.rowlabelw + hm.rowgrplabelw;
    } else {
      const maxSvgw = window.innerWidth * 0.92 / maxChartsPerRow;
      hm.colw = Math.min(Math.max(16, Math.round((maxSvgw - spacing) / hm.cols.length)), 30);
      hm.svgw = hm.cols.length * (hm.colw + hm.colspace) - hm.colspace + (hm.colgrps.length - 1) * hm.colgspace + hm.rowlabelw + hm.rowgrplabelw;
      hm.svgh = hm.plotLength + hm.rowlabelw;
    }
    chart.svgh = hm.svgh;
    hm.h.yScale = {};
    hm.h.xScale = {};
    hm.h.yPrevBySeries = {};
    hm.h.xPrevBySeries = {};
    const ratio = hm.scale == "byChart" ? 1 : chart.maxVisibleSeriesTotal / chart.maxVisibleAcrossCharts;
    for (const series2 of currserieses) {
      if (series2.visibleData[0]) {
        const min = 0;
        const max = hm.unit == "pct" ? series2.visibleTotal : hm.unit == "log" ? chart.maxSeriesLogTotal : chart.maxVisibleSeriesTotal;
        hm.h.yScale[series2.seriesId] = linear().domain([min, max / ratio]).range([0, hm.svgh - hm.collabelh]);
        hm.h.xScale[series2.seriesId] = linear().domain([min, max / ratio]).range([0, hm.svgw - hm.rowlabelw]);
        hm.h.yPrevBySeries[series2.seriesId] = 0;
        hm.h.xPrevBySeries[series2.seriesId] = 0;
        for (const data of series2.visibleData) {
          data.height = getRectHeight(data);
          data.y = getRectY(data);
          data.x = getRectX(data);
          data.width = getRectWidth(data);
        }
      }
    }
    computed.colfontsize = Math.min(hm.colw * hm.fontsizeratio, hm.collabelfontsizemax);
    computed.rowfontsize = Math.min(hm.rowh * hm.fontsizeratio, hm.rowlabelfontsizemax);
    computed.rowtextyalign = Math.min(hm.rowh, (hm.rowh + computed.rowfontsize) / 2) + hm.rowspace;
  }
  function setIds(series2) {
    if (!("seriesId" in series2)) {
      series2.data.map((data) => {
        if (data) series2.seriesId = data[hm.serieskey];
      });
    }
    series2.data.map((d) => {
      d.rowId = d[hm.rowkey];
      d.colId = d[hm.colkey];
    });
  }
  function seriesBindKey(series2) {
    return series2.seriesId;
  }
  function cellKey(d) {
    return d.rowId + " " + d.colId;
  }
  function seriesExit() {
    select_default(this).remove();
  }
  function seriesUpdate(series2) {
    const g = select_default(this).selectAll(".bars-cell").data(series2.data.filter(filterData), cellKey);
    g.exit().each(function() {
      select_default(this).remove();
    });
    g.style("display", (d) => {
      return hm.cols.includes(d.colId) ? "block" : "none";
    });
    g.select("rect").datum((d) => d).transition().duration(hm.duration).attr("x", (d) => d.x).attr("y", (d) => d.y).attr("width", (d) => d.width).attr("height", (d) => d.height).attr("fill", hm.handlers.series.rectFill).attr("stroke", hm.handlers.series.strokeFill);
    g.enter().append("g").each(addCell);
    g.selectAll("text").remove();
    addAsterisks(g);
  }
  function seriesEnter(series2) {
    if (!series2 || !series2.data.length) return;
    select_default(this).attr("class", "bars-cell-grp").selectAll("g").data(series2.data.filter(filterData), cellKey).enter().append("g").each(addCell);
  }
  function filterData(d) {
    return hm.rows.includes(d.dataId);
  }
  function addCell(d) {
    const g = select_default(this).attr("class", "bars-cell").datum(d);
    g.style("display", (d2) => {
      return hm.cols.includes(d2.colId) ? "block" : "none";
    });
    g.append("rect").attr("x", (d2) => d2.x).attr("y", (d2) => d2.y).attr("width", (d2) => d2.width).attr("height", (d2) => d2.height).attr("fill", hm.handlers.series.rectFill).attr("stroke", hm.handlers.series.strokeFill).attr("shape-rendering", "crispEdges").style("opacity", 0).transition().delay(hm.delay).duration(hm.duration).style("opacity", 1);
    addPercent(g, d);
    addAsterisks(g);
  }
  function addPercent(g, d) {
    if (!barsapp.config.term2 && barsapp.config.settings.barchart.showPercent) {
      const x = hm.orientation == "horizontal" ? d.x + d.width + 8 : d.x + 4;
      const y = hm.orientation == "horizontal" ? d.y + d.height * 0.7 : d.y - 4;
      const percent = d.seriesTotal / d.chartTotal * 100;
      g.append("g").attr("transform", `translate(${x}, ${y})`).append("text").style("font-size", "0.8em").text(`${percent.toFixed(0)}%`);
    }
  }
  function addAsterisks(g) {
    if (!barsapp.config.settings.barchart.asterisksVisible) {
      return;
    }
    g.append("text").text((d) => {
      const test = d.groupPvalues && d.groupPvalues.term2tests.find((x) => x.term2id == d.dataId);
      if (!test || test.skipped) return "";
      if (barsapp.config.settings.barchart.multiTestingCorr) {
        return test.adjusted_p_value < 0.05 ? "*" : "";
      } else return test.pvalue < 0.05 ? "*" : "";
    }).attr("x", (d) => d.x + d.width / 2).attr("y", (d) => d.y + d.height / 2).attr("dy", "0.6em").style("text-anchor", "middle").style("opacity", 0).transition().delay(hm.delay).duration(hm.duration).style("opacity", 1);
  }
  function seriesGrpTransform() {
    const x = hm.colspace;
    let y = hm.colheadtop ? hm.collabelh : hm.colgrplabelh;
    if (hm.legendontop) y += hm.legendh;
    return "translate(" + x + "," + y + ")";
  }
  function getRectHeight(d) {
    const total = hm.unit == "log" ? d.logTotal : d.total;
    const height = hm.orientation == "vertical" ? hm.h.yScale[d.seriesId](total) : hm.rowh;
    const rowspace = 0;
    hm.h.yPrevBySeries[d.seriesId] += height + rowspace;
    return Math.max(1, height - rowspace);
  }
  function getRectY(d) {
    const grpoffset = hm.colgrps.indexOf(d[hm.colgrpkey]) * hm.colgspace;
    const h = hm.unit == "log" ? Math.max(0, hm.h.yPrevBySeries[d.seriesId]) : hm.h.yPrevBySeries[d.seriesId];
    return hm.orientation == "vertical" ? hm.svgh - hm.collabelh - h : hm.cols.indexOf(d.colId) * (hm.rowh + hm.rowspace) + grpoffset;
  }
  function getRectWidth(d) {
    const total = hm.unit == "log" ? d.logTotal : d.total;
    const width = hm.orientation == "vertical" ? hm.colw : hm.h.xScale[d.seriesId](total);
    const colspace = 0;
    hm.h.xPrevBySeries[d.seriesId] += Math.max(1, width + colspace);
    return Math.max(1, width - colspace);
  }
  function getRectX(d) {
    const grpoffset = hm.colgrps.indexOf(d[hm.colgrpkey]) * hm.colgspace;
    return hm.orientation == "vertical" ? hm.cols.indexOf(d.colId) * (hm.colw + hm.colspace) + grpoffset : hm.h.xPrevBySeries[d.seriesId];
  }
  function colLabelsTransform() {
    const x = 5 + hm.colspace;
    let y = hm.colheadtop ? (
      /*hm.collabelh -*/
      hm.borderwidth + 1
    ) : hm.svgh - hm.collabelh + 25;
    if (hm.legendontop) y += hm.legendh;
    return "translate(" + x + "," + y + ")";
  }
  function colLabelTransform(d) {
    const grp = hm.col2name[d] ? hm.col2name[d].grp : "";
    const x = hm.colgrps.indexOf(grp) * hm.colgspace + hm.cols.indexOf("id" in d ? d.id : d) * (hm.colw + hm.colspace) + hm.colw / 2;
    const y = hm.colheadtop ? -1 * (hm.coltick + hm.collabtickspace) : hm.coltick + hm.collabtickspace;
    return "translate(" + x + "," + y + ")";
  }
  function addColLabel(d) {
    if (!this || d === void 0) return;
    const g = select_default(this).attr("transform", colLabelTransform).style("opacity", 0);
    g.append("text").attr("transform", "rotate(-40)").attr("y", 2).attr("text-anchor", "end").attr("font-size", computed.colfontsize + "px").html(hm.handlers.barLabel.text);
    g.transition().delay(hm.delay).duration(hm.duration).style("opacity", 1);
  }
  function updateColLabel(d) {
    const g = select_default(this).datum(d);
    g.attr("transform", colLabelTransform);
    g.selectAll("text").datum(d).attr("y", 2).attr("text-anchor", "end").attr("font-size", computed.colfontsize + "px").html(hm.handlers.barLabel.text);
  }
  function rowLabelsTransform() {
    const y = hm.colheadtop ? hm.collabelh : hm.colgrplabelh;
    const x = hm.rowheadleft ? (
      /*hm.collabelh -*/
      hm.borderwidth + 1
    ) : hm.svgw - hm.rowlabelw + 20;
    return "translate(" + x + "," + y + ")";
  }
  function rowLabelTransform(d) {
    const grp = hm.row2name[d] ? hm.row2name[d].grp : "";
    const y = hm.colgrps.indexOf(grp) * hm.rowgspace + hm.cols.indexOf("id" in d ? d.id : d) * (hm.rowh + hm.rowspace) + computed.rowtextyalign;
    const x = hm.rowheadleft ? -1 * (hm.rowtick + hm.rowlabtickspace) : hm.rowtick + hm.rowlabtickspace;
    return "translate(" + x + "," + y + ")";
  }
  function addRowLabel(d) {
    if (!this || d === void 0) return;
    const g = select_default(this).attr("transform", rowLabelTransform).style("opacity", 0);
    g.append("text").attr("x", 2).attr("text-anchor", "end").attr("font-size", computed.rowfontsize + "px").html(hm.handlers.barLabel.text);
    g.transition().delay(hm.delay).duration(hm.duration).style("opacity", 1);
  }
  function updateRowLabel(d) {
    const g = select_default(this).datum(d);
    g.attr("transform", rowLabelTransform);
    g.selectAll("text").datum(d).attr("x", 2).attr("text-anchor", "end").attr("font-size", computed.rowfontsize + "px").html(hm.handlers.barLabel.text);
  }
  function rowTextWeight(d) {
    return d == currCell.rowId ? 700 : "";
  }
  function rowTextSize(d) {
    return d == currCell.rowId ? Math.max(12, computed.rowfontsize) : computed.rowfontsize;
  }
  function rowTextColor(d) {
    return d == currCell.rowId ? "#00f" : "";
  }
  function colTextWeight(d) {
    return d == currCell.colId ? 700 : "";
  }
  function colTextSize(d) {
    return d == currCell.colId ? 12 : computed.colfontsize;
  }
  function colTextColor(d) {
    return d == currCell.colId ? "#00f" : "";
  }
  function renderAxes(hm2, prevOrientation, visibleTotal) {
    axisG.style("opacity", prevOrientation != hm2.orientation ? 0 : 1).transition().duration(1500).style("opacity", 1);
    if (hm2.orientation == "vertical") {
      renderAxesOnVertical(hm2, visibleTotal);
    } else {
      renderAxesOnHorizontal(hm2, visibleTotal);
    }
  }
  function renderAxesOnVertical(s, visibleTotal) {
    xAxis.style("display", "none");
    yLine.style("display", "none");
    const colLabelBox = collabels.node().getBBox();
    xTitle.selectAll("*").remove();
    const xLabel = hm.handlers.xAxis.text(visibleTotal);
    xTitle.append("text").style("text-anchor", "middle").style("font-size", s.axisTitleFontSize + "px").style("font-weight", 600).text(xLabel);
    setTimeout(() => {
      xTitle.attr(
        "transform",
        "translate(" + (s.svgw - s.svgPadding.left - s.svgPadding.right - s.rowlabelw) / 2 + "," + (colLabelBox.height + hm.svgh - hm.collabelh + 20 + s.axisTitleFontSize) + ")"
      );
    }, 0);
    const range2 = [s.colgrplabelh, s.svgh - s.collabelh + s.colgrplabelh - s.borderwidth + 1];
    yAxis.style("display", "block").call(getAxisScale(axisLeft, range2, true));
    yTitle.selectAll("*").remove();
    const h = s.svgh - s.collabelh;
    yTitle.style("font-weight", 600).attr("transform", "translate(" + (-s.svgPadding.left - s.axisTitleFontSize) + "," + h / 2 + ")rotate(-90)").append("text").style("text-anchor", "middle").style("font-size", s.axisTitleFontSize + "px").attr("data-testid", "sjpp-massbarchart-vertical-charttitle").text(hm.handlers.yAxis.text(visibleTotal));
  }
  function renderAxesOnHorizontal(s, visibleTotal) {
    yAxis.style("display", "none");
    xLine.style("display", "none");
    yTitle.selectAll("*").remove();
    const yLabel = hm.handlers.yAxis.text(visibleTotal);
    yTitle.append("text").style("text-anchor", "end").style("font-size", s.axisTitleFontSize + "px").style("font-weight", 600).text(yLabel);
    setTimeout(() => {
      yTitle.style("text-anchor", "end").attr(
        "transform",
        "translate(0,0)"
      );
    }, 0);
    const range2 = [0, s.svgw - s.rowlabelw];
    let y = s.colheadtop ? s.collabelh - 2 : s.colgrplabelh - 2;
    if (s.legendontop) y += s.legendh;
    xAxis.style("display", "block").attr("transform", "translate(2.5," + y + ")").call(getAxisScale(axisTop, range2));
    xTitle.selectAll("*").remove();
    const w = s.svgw - s.rowlabelw;
    xTitle.attr("transform", "translate(" + w / 2 + ",0)").append("text").style("text-anchor", "middle").style("font-size", s.axisTitleFontSize + "px").style("font-weight", 600).attr("data-testid", "sjpp-massbarchart-horizontal-charttitle").text(hm.handlers.xAxis.text(visibleTotal));
  }
  function getAxisScale(axisGenerator, range2, reverseDomain = false) {
    const ratio = hm.scale == "byChart" || hm.clickedAge ? 1 : chart.maxVisibleSeriesTotal / chart.maxVisibleAcrossCharts;
    const min = hm.unit == "log" ? 1 : 0;
    const max = hm.unit == "pct" ? 100 : chart.maxVisibleSeriesTotal;
    const domain = [min, max / ratio];
    if (reverseDomain) domain.reverse();
    const scale = hm.unit == "log" ? log() : linear();
    scale.domain(domain).range(range2);
    if (hm.unit == "log") {
      const values = [1];
      for (let i3 = 1; i3 < Math.log10(max); i3++) {
        values.push(Math.pow(10, i3));
      }
      return axisGenerator(scale).tickValues(values).tickFormat(formatter);
    } else {
      return axisGenerator(scale).ticks(5).tickFormat(formatter);
    }
  }
  function seriesMouseOver(event2) {
    const t2 = event2.target.tagName == "tspan" ? event2.target.parentNode : event2.target;
    const d = t2.__data__;
    if (d && (t2.tagName == "rect" || t2.nodeName == "text")) {
      currCell = d;
      currColTexts.attr("font-weight", colTextWeight).attr("font-size", colTextSize).style("fill", colTextColor);
    } else {
      currCell = emptyObj;
      currRowTexts.attr("font-weight", rowTextWeight).attr("font-size", rowTextSize).style("fill", rowTextColor);
      currColTexts.attr("font-weight", colTextWeight).attr("font-size", colTextSize).style("fill", colTextColor);
    }
    hm.handlers.series.mouseover(event2, d);
  }
  function seriesMouseOut(event2) {
    event2.stopPropagation();
    currColTexts.attr("font-weight", "").attr("font-size", computed.colfontsize).style("fill", "");
    currCell = emptyObj;
    if (hm.handlers.series.mouseout) hm.handlers.series.mouseout(event2);
  }
  function colLabelMouseover(event2) {
    const d = event2.target.__data__;
    if (!d) return;
    const r = hm.col2name["id" in d ? d.id : d];
    const cell = { colId: r.name };
    cell[hm.colkey] = r.name;
    cell[hm.colgrpkey] = r.grp;
    if (hm.handlers.barLabel.mouseover) hm.handlers.barLabel.mouseover(event2);
  }
  function colLabelMouseout(event2) {
    currCell = emptyObj;
    if (hm.handlers.barLabel.mouseout) hm.handlers.barLabel.mouseout(event2);
  }
  function seriesClick(event2) {
    const d = event2.target.__data__;
    barsapp.handlers.series.click(event2, d);
  }
  main.hm = hm;
  main.styles = () => {
    const styles = {};
    for (const key in defaults3) {
      styles[key] = hm[key];
    }
    return styles;
  };
  return main;
}

// plots/barchart/bars.settings.ts
var plotLength = 300;
var rendererSettings = JSON.stringify({
  plotLength,
  // maximum bar length
  barwidth: 20,
  // bar thickness
  barspace: 2,
  // space between two bars
  orientation: "horizontal",
  // vertical | horizontal
  h: {},
  relayTiles: false,
  svgw: 600,
  svgh: 400,
  unit: "abs",
  // abs | pct
  scale: "byChart",
  // byGroup | byChart
  currAge: 20,
  rowkey: "dataId",
  rowgrpkey: "rowgrp",
  colkey: "seriesId",
  colgrpkey: "colgrp",
  rowh: 22,
  colw: 36,
  rowspace: 1,
  colspace: 1,
  rowtick: 8,
  coltick: 5,
  rowlabtickspace: 0,
  collabtickspace: 0,
  collabelh: 100,
  rowlabelw: 100,
  rowheadleft: true,
  colheadtop: false,
  legendontop: false,
  legendh: 0,
  legendpadleft: 170,
  hidelegend: false,
  showgrid: true,
  gridstroke: "#fff",
  showEmptyCells: false,
  cellbg: "#eeeeee",
  fontsizeratio: 0.9,
  rowlabelfontsizemax: 16,
  collabelfontsizemax: 12,
  crudefill: true,
  duration: 1e3,
  delay: 0,
  cellfontsize: 11,
  colgspace: 4,
  rowgspace: 4,
  rowglabspace: 5,
  colglabspace: 5,
  colgrplabelh: 25,
  rowgrplabelw: 25,
  rowglabfontsize: 15,
  rowglabfontsizemax: 25,
  colglabfontsize: 15,
  colglabfontsizemax: 25,
  borderwidth: 2,
  svgPadding: {
    top: 10,
    left: 30,
    right: 10,
    bottom: 30
  },
  exclude: {
    rows: [],
    cols: [],
    colgrps: [],
    // used when expanding a column group
    rowgrps: []
  },
  axisTitleFontSize: 16
});

// plots/controls.config.js
var instanceNum = 1;
var controlNum = 1;
function getElemId(instanceNum2) {
  return `sjpp-control-${controlNum++}-${instanceNum2 || Math.random().toString().slice(-4)}-${Math.random().toString().slice(-6)}`;
}
var TdbConfigUiInit = class _TdbConfigUiInit {
  static type = "controlsConfig";
  constructor(opts) {
    this.type = _TdbConfigUiInit.type;
    this.app = opts.app;
    this.id = opts.id;
    this.instanceNum = instanceNum++;
    setRenderers7(this);
  }
  async init() {
    try {
      const dispatch = this.app.dispatch;
      const { table } = this.setDom();
      const debug = this.opts.debug;
      this.inputs = {};
      const componentPromises = {};
      for (const key of this.opts.inputs) {
        if (typeof key == "object") {
          const obj = key;
          if (obj.type in initByInput) {
            this.inputs[obj.settingsKey || obj.configKey] = await initByInput[obj.type](
              Object.assign({}, obj, {
                holder: this.dom.table.append("tr"),
                app: this.app,
                id: this.id,
                instanceNum: this.instanceNum,
                debug: this.opts.debug,
                parent: this
              })
            );
          }
        } else if (key in initByInput) {
          this.inputs[key] = await initByInput[key]({
            holder: this.dom.table.append("tr"),
            app: this.app,
            id: this.id,
            instanceNum: this.instanceNum,
            debug: this.opts.debug,
            parent: this
          });
        } else {
          throw `unsupported opts.inputs[] entry of '${key}' for controlsInit()`;
        }
      }
      this.components = await multiInit(componentPromises);
    } catch (e) {
      throw e;
    }
  }
  setDom() {
    this.dom = {
      holder: this.opts.holder.style("position", "relative").style("max-width", "50px").style("height", 0).style("vertical-align", "top").style("visibility", "hidden"),
      table: this.opts.holder.append("table").attr("cellpadding", 0).attr("cellspacing", 0),
      // .style('transition', '0.2s')
      // default loading div, see if there is an option to override this
      loadingDiv: this.opts.holder.append("div").style("position", "absolute").style("top", 0).style("left", 0).style("height", "100%").style("width", "100%").style("background-color", `rgba(255,255,255,0.7)`).style("display", "none")
    };
    this.dom.loadingDiv.append("div").attr("class", "sjpp-spinner-small");
    this.loadingMasks = [this.dom.loadingDiv];
    if (this.opts.loadingMasks) this.loadingMasks.push(...this.opts.loadingMasks);
    return this.dom;
  }
  getState(appState) {
    const config = appState.plots.find((p) => p.id === this.id);
    return {
      genome: appState.genome,
      dslabel: appState.dslabel,
      activeCohort: appState.activeCohort,
      termfilter: appState.termfilter,
      config,
      isOpen: this.opts.isOpen()
    };
  }
  main() {
    const plot = this.state.config;
    const isOpen = this.opts.isOpen();
    this.render(isOpen);
    for (const name in this.inputs) {
      const o = this.inputs[name];
      o.main(o.usestate ? this.state : plot);
    }
    this.dom.loadingDiv.style("display", "none");
    if (this.opts.loadingMasks) {
      for (const m of this.opts.loadingMasks) m.style("display", "none");
    }
  }
  render(isOpen) {
    this.dom.holder.style("visibility", isOpen ? "visible" : "hidden").style("max-width", isOpen ? "" : "50px").style("height", isOpen ? "" : 0).style("resize", isOpen ? "both" : "none");
    this.dom.table.selectAll("tr").filter(this.rowIsVisible).selectAll("td").style("border-top", "2px solid #FFECDD").style("padding", "5px 10px");
  }
};
var configUiInit = getCompInit(TdbConfigUiInit);
function setRenderers7(self2) {
  self2.rowIsVisible = function() {
    return this.style.display != "none";
  };
}
function setNumberInput(opts) {
  const id3 = getElemId(opts.instanceNum);
  const self2 = {
    id: id3,
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTd: opts.holder.append("td").attr("id", id3).attr("class", "sja-termdb-config-row-label").attr("aria-label", opts.title).html(opts.label),
      inputs: {}
    },
    values: {}
  };
  if (!opts.inputs) {
    opts.inputs = [
      {
        min: opts.min,
        max: opts.max,
        step: opts.step,
        width: opts.width,
        settingsKey: opts.settingsKey
      }
    ];
    if (opts.placeholder) opts.inputs[0].placeholder = opts.placeholder;
  }
  const debounceTimeout = opts.debounceInterval || ("debounceInterval" in opts.parent?.app.opts ? opts.parent?.app.opts.debounceInterval : 100);
  for (const input of opts.inputs) {
    let debouncedDispatch2 = function(noDispatch = false) {
      if (dispatchTimer) clearTimeout(dispatchTimer);
      if (!noDispatch) dispatchTimer = setTimeout(dispatchChange2, debounceTimeout);
    }, dispatchChange2 = function() {
      let value = Number(self2.dom.inputs[input.settingsKey].property("value"));
      if (![void 0, null].includes(input.max) && input.max < value) value = input.max;
      if (![void 0, null].includes(input.min) && input.min > value) value = input.min;
      if (opts.callback) opts.callback(value);
      else {
        opts.app.dispatch({
          type: "plot_edit",
          id: opts.id,
          config: {
            settings: {
              [opts.chartType]: {
                [input.settingsKey]: opts.processInput ? opts.processInput(value) : value
              }
            }
          }
        });
      }
    };
    var debouncedDispatch = debouncedDispatch2, dispatchChange = dispatchChange2;
    let dispatchTimer;
    const inputTd = opts.holder.append("td").style("text-align", opts.align || "").attr("colspan", opts.colspan || "");
    if (!input.settingsKey) {
      inputTd.style("color", "#555").style("cursor", "default").html(input.label);
    } else {
      self2.dom.inputs[input.settingsKey] = inputTd.append("input").attr("aria-labelledby", self2.id).attr("type", "number").attr("placeholder", "placeholder" in input ? input.placeholder : "").attr("min", "min" in input ? input.min : null).attr("max", "max" in input ? input.max : null).attr("step", input.step || opts.step || null).style("width", (input.width || opts.width || 100) + "px").on("keyup", (event2) => {
        const valueChanged = self2.values[opts.settingsKey] !== Number(self2.dom.inputs[input.settingsKey].property("value"));
        debouncedDispatch2(event2.key !== "Enter" && valueChanged);
      }).on("change", (event2) => {
        debouncedDispatch2(false);
      });
    }
  }
  const api = {
    main(plot) {
      const display = opts.getDisplayStyle?.(plot) || "table-row";
      opts.holder.style("display", display);
      for (const settingsKey in self2.dom.inputs) {
        const value = plot.settings[opts.chartType][settingsKey];
        self2.dom.inputs[settingsKey].property("value", value);
        self2.values[settingsKey] = value;
      }
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function setMathExprInput(opts) {
  const id3 = getElemId(opts.instanceNum);
  const self2 = {
    id: id3,
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTd: opts.holder.append("td").attr("id", id3).attr("class", "sja-termdb-config-row-label").attr("aria-label", opts.title).attr("overflow", "visible").html(opts.label),
      inputTd: opts.holder.append("td")
    }
  };
  const textByNumber = {};
  self2.dom.input = self2.dom.inputTd.append("input").attr("type", "text").attr("aria-labelledby", self2.id).style("width", (opts.width || 100) + "px").on("change", () => {
    const value = self2.dom.input.property("value");
    const number = Number(value);
    if (isNaN(number)) throw `non-numeric value for ${opts.settingsKey}='${value}'`;
    textByNumber[number] = value;
    opts.app.dispatch({
      type: "plot_edit",
      id: opts.id,
      config: {
        settings: {
          [opts.chartType]: {
            [opts.settingsKey]: number
          }
        }
      }
    });
  });
  const api = {
    main(plot) {
      const value = plot.settings[opts.chartType][opts.settingsKey];
      const number = typeof value == "number" ? value : Number(value);
      if (typeof value != "number") textByNumber[number] = value;
      self2.dom.input.property("value", value in textByNumber ? textByNumber[number] : value);
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function setTextInput(opts) {
  const id3 = getElemId(opts.instanceNum);
  const self2 = {
    id: id3,
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTd: opts.holder.append("td").attr("id", id3).attr("class", "sja-termdb-config-row-label").attr("aria-label", opts.title).html(opts.label),
      inputTd: opts.holder.append("td")
    }
  };
  self2.dom.input = self2.dom.inputTd.append("input").attr("type", "text").attr("placeholder", opts.placeholder).attr("aria-labelledby", self2.id).style("width", (opts.width || 100) + "px").on("change", () => {
    const value = self2.dom.input.property("value");
    opts.app.dispatch({
      type: "plot_edit",
      id: opts.id,
      config: {
        settings: {
          [opts.chartType]: {
            [opts.settingsKey]: opts.processInput ? opts.processInput(value) : value
          }
        }
      }
    });
  });
  const api = {
    main(plot) {
      self2.dom.input.property("value", plot.settings[opts.chartType][opts.settingsKey]);
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function setColorInput(opts) {
  const id3 = getElemId(opts.instanceNum);
  const self2 = {
    id: id3,
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTd: opts.holder.append("td").attr("id", id3).attr("class", "sja-termdb-config-row-label").attr("aria-label", opts.title).html(opts.label),
      inputTd: opts.holder.append("td").attr("colspan", opts.colspan || "").style("text-align", opts.align || "")
    }
  };
  self2.dom.input = self2.dom.inputTd.append("input").attr("type", "color").attr("aria-labelledby", self2.id).on("change", () => {
    const value = self2.dom.input.property("value");
    opts.app.dispatch({
      type: "plot_edit",
      id: opts.id,
      config: {
        settings: {
          [opts.chartType]: {
            [opts.settingsKey]: opts.processInput ? opts.processInput(value) : value
          }
        }
      }
    });
  });
  const api = {
    main(plot) {
      const color = plot.settings[opts.chartType][opts.settingsKey];
      self2.dom.input.property("value", rgb(color).formatHex());
      opts.holder.style("display", opts.getDisplayStyle?.(plot) || "table-row");
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function setRadioInput(opts) {
  const self2 = {
    dom: {
      row: opts.holder,
      labelTdb: opts.holder.append("td").html(opts.label).attr("aria-label", opts.title).attr("class", "sja-termdb-config-row-label")
    },
    inputs: {}
  };
  const inputs = opts.inputs ? opts.inputs : [
    {
      settingsKey: opts.settingsKey,
      options: opts.options
    }
  ];
  for (const input of inputs) {
    self2.inputs[input.settingsKey] = make_radios({
      inputName: getElemId(opts.instanceNum),
      holder: opts.holder.append("td").attr("colspan", opts.colspan || "").style("text-align", opts.align || ""),
      options: input.options,
      /** In now deleted radio2.js, vertical-align = top was the preference
       * for mass. Keep it as the default to maintain styling */
      styles: Object.assign(opts.styles || {}, { "vertical-align": "top" }),
      listeners: {
        input(event2, d) {
          if (event2.key && event2.key !== "Enter") return;
          if (opts.callback) {
            opts.callback(d.value);
          } else {
            opts.app.dispatch({
              type: "plot_edit",
              id: opts.id,
              config: {
                settings: {
                  [opts.chartType]: {
                    [input.settingsKey]: d.value
                  }
                }
              }
            });
          }
        }
      }
    });
  }
  const api = {
    main(plot) {
      const display = opts.getDisplayStyle?.(plot) || "table-row";
      self2.dom.row.style("display", display);
      if (display == "none") return;
      for (const settingsKey in self2.inputs) {
        const radio = self2.inputs[settingsKey];
        radio.main(plot.settings[opts.chartType][settingsKey]);
        radio.divs.style(
          "display",
          (d) => d.getDisplayStyle?.(plot, opts.styles?.display) || opts.labelDisplay || opts.styles?.display || "inline-block"
        );
        if (opts.setRadioLabel) radio.labels.html(opts.setRadioLabel);
      }
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function setDropdownInput(opts) {
  const id3 = getElemId(opts.instanceNum);
  const self2 = {
    id: id3,
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTd: opts.holder.append("td").attr("id", id3).html(opts.label).attr("class", "sja-termdb-config-row-label"),
      inputTd: opts.holder.append("td")
    }
  };
  let timeoutId;
  self2.dom.select = self2.dom.inputTd.append("select").attr("aria-labelledby", id3).property("disabled", opts.disabled).property("multiple", opts.multiple).on("mousedown", (e) => {
    if (!opts.multiple) return;
    e.preventDefault();
    const option = e.target;
    if (option.tagName === "OPTION") {
      clearTimeout(timeoutId);
      option.selected = !option.selected;
      timeoutId = setTimeout(() => {
        const options = self2.dom.select.node().options;
        const values = [];
        for (const option2 of options) {
          if (option2.selected) values.push(option2.value);
        }
        const value = values;
        callbackOrDispatch(opts, value);
      }, 1e3);
    }
  }).on("change", (e) => {
    if (!opts.multiple) {
      const value = self2.dom.select.property("value");
      callbackOrDispatch(opts, value);
    }
  });
  if (opts.multiple) self2.dom.select.attr("size", opts.options.length > 10 ? 10 : opts.options.length);
  self2.dom.select.selectAll("option").data(opts.options).enter().append("option").property("disabled", (d) => d.disabled).attr("value", (d) => d.value).attr("selected", (d) => d.selected).html((d) => "&nbsp;" + d.label + "&nbsp;");
  const api = {
    main(plot) {
      opts.holder.style("display", opts.getDisplayStyle?.(plot) || "table-row");
      self2.dom.select.property("value", plot.settings[opts.chartType][opts.settingsKey]);
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function callbackOrDispatch(opts, value) {
  if (opts.callback) opts.callback(value);
  else
    opts.app.dispatch({
      type: "plot_edit",
      id: opts.id,
      config: {
        settings: {
          [opts.chartType]: {
            [opts.settingsKey]: opts.processInput ? opts.processInput(value) : value
          }
        }
      }
    });
}
function setCheckboxInput(opts) {
  const id3 = getElemId(opts.instanceNum);
  const self2 = {
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTdb: opts.holder.append("td").attr("id", id3).attr("aria-label", opts.title).html(opts.label).attr("class", "sja-termdb-config-row-label"),
      inputTd: opts.holder.append("td").attr("colspan", opts.colspan || "").style("text-align", opts.align || "")
    }
  };
  const label = self2.dom.inputTd.append(opts.boxLabel ? "label" : "span");
  self2.dom.input = label.append("input").attr("type", "checkbox").attr("aria-labelledBy", opts.boxLabel ? void 0 : id3).attr("data-testid", opts.testid).on("change", () => {
    const value = self2.dom.input.property("checked");
    if (opts.callback) opts.callback(value);
    opts.app.dispatch({
      type: "plot_edit",
      id: opts.id,
      config: {
        settings: {
          [opts.chartType]: {
            [opts.settingsKey]: opts.processInput ? opts.processInput(value) : value
          }
        }
      }
    });
  });
  label.append("span").html("&nbsp;" + opts.boxLabel);
  const api = {
    main(plot) {
      const value = plot.settings[opts.chartType][opts.settingsKey];
      self2.dom.input.property("checked", opts.processInput ? opts.processInput(value) : value);
      opts.holder.style("display", opts.getDisplayStyle?.(plot) || "table-row");
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function setMultiCheckbox(opts) {
  const numCols = opts.style?.colNum || 2;
  const numRows = Math.ceil(opts.options.length / numCols);
  const self2 = {
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTdb: opts.holder.append("td").attr("aria-label", opts.title).html(opts.label).attr("class", "sja-termdb-config-row-label"),
      inputTd: opts.holder.append("td").attr("colspan", opts.colspan || "").style("text-align", opts.align || "").style("padding", "5px")
    }
  };
  self2.dom.selectAllDiv = self2.dom.inputTd.append("div").style("padding", "5px 0").append("label");
  self2.dom.selectAll = self2.dom.selectAllDiv.append("input").attr("type", "checkbox").attr("title", "Check or uncheck all").on("change", () => {
    const checked = self2.dom.selectAll.property("checked");
    self2.dom.inputs.property("checked", checked);
    const values = checked ? opts.options.map((d) => d.value) : [];
    opts.app.dispatch({
      type: "plot_edit",
      id: opts.id,
      config: {
        settings: {
          [opts.chartType]: {
            [opts.settingsKey]: opts.processInput?.(values) || values
          }
        }
      }
    });
  });
  self2.dom.selectAllDiv.append("span").text("Check/Uncheck All").style("opacity", 0.65).style("font-size", "0.9em");
  self2.dom.optionsDiv = self2.dom.inputTd.append("div").style("display", "grid").style("grid-template-columns", `repeat(${numCols}, 1fr)`).style("grid-template-rows", `repeat(${numRows}, auto)`).style("grid-auto-flow", "column").style("gap", `${opts.style.gap || 5}px`);
  self2.dom.labels = self2.dom.optionsDiv.selectAll("label").data(opts.options).enter().append("label").style("margin-right", "8px").each(function(d) {
    const label = select_default(this);
    self2.dom.input = label.append("input").attr("type", "checkbox").attr("name", (d2) => d2.label).attr("value", (d2) => d2.value).on("change", () => {
      const checked = [];
      const value = self2.dom.labels.selectAll("input").each(function(d2) {
        if (this.checked) checked.push(d2.value);
      });
      opts.app.dispatch({
        type: "plot_edit",
        id: opts.id,
        config: {
          settings: {
            [opts.chartType]: {
              [opts.settingsKey]: opts.processInput?.(checked) || checked
            }
          }
        }
      });
    });
    label.append("span").html(d.label);
  });
  self2.dom.inputs = self2.dom.labels.selectAll("input");
  const api = {
    main(plot) {
      const values = plot.settings[opts.chartType][opts.settingsKey];
      const checkedValues = opts.processInput?.(values) || values;
      self2.dom.selectAll.property("checked", checkedValues.length === opts.options.length);
      self2.dom.inputs.property("checked", (d) => checkedValues.includes(d.value));
      self2.dom.labels.style("display", (d) => d.getDisplayStyle?.(plot) || "");
      opts.holder.style("display", opts.getDisplayStyle?.(plot) || "table-row");
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function setCustomInput(opts) {
  const self2 = {
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTd: opts.holder.append("td").html(opts.label).attr("class", "sja-termdb-config-row-label").attr("aria-label", opts.title).style("vertical-align", "top"),
      inputTd: opts.holder.append("td")
    }
  };
  self2.api = opts.init(self2);
  if (opts.debug) self2.api.Inner = self2;
  return Object.freeze(self2.api);
}
async function setTermInput(opts) {
  const self2 = {
    dom: {
      row: opts.holder.style("display", "table-row"),
      labelTd: opts.holder.append("td").html(opts.label).attr("class", "sja-termdb-config-row-label").attr("aria-label", opts.title),
      inputTd: opts.holder.append("td")
    }
  };
  if (opts.disabledMessage) {
    self2.dom.pillDiv = self2.dom.inputTd.append("div").attr("title", opts.disabledMessage).style("cursor", "not-allowed").append("div").style("pointer-events", "none").style("opacity", 0.5);
  } else {
    self2.dom.pillDiv = self2.dom.inputTd.append("div");
  }
  const pill = await termsettingInit({
    menuOptions: opts.menuOptions || "*",
    numericEditMenuVersion: opts.numericEditMenuVersion || ["continuous", "discrete"],
    vocabApi: opts.vocabApi || opts.app.vocabApi,
    vocab: opts.state?.vocab,
    activeCohort: opts.state?.activeCohort,
    holder: self2.dom.pillDiv,
    debug: opts.debug,
    usecase: opts.usecase,
    disable_terms: opts.disable_terms,
    getBodyParams: opts.getBodyParams,
    defaultQ4fillTW: opts.defaultQ4fillTW,
    geneVariantEditMenuOnlyGrp: opts.geneVariantEditMenuOnlyGrp,
    loadingMasks: opts.parent.loadingMasks,
    testids: opts.testids,
    callback: async (tw) => {
      if (opts.parent.dom.loadingDiv && opts.parent.dom.svg) {
        opts.parent.dom.loadingDiv.selectAll("*").remove();
        opts.parent.dom.loadingDiv.html("").style("display", "").style("position", "relative").style("left", "45%");
        opts.parent.dom.loadingDiv.html("Processing data ...");
        opts.parent.dom.svg.style("opacity", 0.1).style("pointer-events", "none");
      }
      if (tw && !tw.q) throw "data.q{} missing from pill callback";
      if (opts.processInput) await opts.processInput(tw);
      await pill.main(tw ? tw : { term: null, q: null });
      const config = {
        [opts.configKey]: tw
      };
      if (opts.processConfig) opts.processConfig(config);
      opts.app.dispatch({
        type: "plot_edit",
        id: opts.id,
        config
      });
    }
  });
  const api = {
    usestate: true,
    main(plot) {
      const display = opts.getDisplayStyle?.(plot) || "table-row";
      opts.holder.style("display", display);
      const { config, activeCohort, termfilter } = JSON.parse(JSON.stringify(plot));
      const tw = plot[opts.configKey] || config && config[opts.configKey] || {};
      const selectedTerms = getSelectedTerms(opts, config);
      const arg = {
        term: tw.term || null,
        q: tw.q,
        activeCohort,
        filter: termfilter && termfilter.filter,
        disable_terms: getSelectedTerms(opts, config)
      };
      if ("$id" in tw) arg.$id = tw.$id;
      pill.main(arg);
      self2.dom.labelTd.datum(tw).html(opts.label);
    }
  };
  if (opts.debug) api.Inner = self2;
  return Object.freeze(api);
}
function getSelectedTerms(opts, config) {
  const inputs = opts.inputs || opts.parent?.opts?.inputs;
  if (!inputs) return [];
  const termInputs = inputs.filter((i3) => i3.type === "term");
  const selectedTerms = [];
  for (const termInput of termInputs) {
    const tw = config[termInput.configKey];
    if (tw) selectedTerms.push(tw.term);
  }
  return selectedTerms;
}
var initByInput = {
  number: setNumberInput,
  math: setMathExprInput,
  text: setTextInput,
  color: setColorInput,
  radio: setRadioInput,
  dropdown: setDropdownInput,
  checkbox: setCheckboxInput,
  multiCheckbox: setMultiCheckbox,
  custom: setCustomInput,
  term: setTermInput
};

// plots/controls.js
var panel_bg_color = "#fdfaf4";
var TdbPlotControls = class _TdbPlotControls {
  static type = "plotControls";
  constructor(opts) {
    this.opts = opts;
    this.type = _TdbPlotControls.type;
    this.customEvents = ["downloadClick", "infoClick", "helpClick"];
    this.isOpen = opts.isOpen || false;
    this.showTopBar = opts.hasOwnProperty("showTopBar") ? opts.showTopBar : true;
    setInteractivity3(this);
    setRenderers8(this);
  }
  async init() {
    try {
      this.setDom();
      const arg = {
        config: configUiInit({
          app: this.app,
          id: this.id,
          holder: this.dom.config_div,
          isOpen: () => this.isOpen,
          tip: this.app.tip,
          inputs: this.opts.inputs,
          loadingMasks: this.opts.loadingMasks
        })
      };
      if (this.showTopBar) {
        arg.topbar = topBarInit({
          app: this.app,
          id: this.id,
          holder: this.dom.topbar,
          callback: this.toggleVisibility,
          isOpen: () => this.isOpen,
          downloadHandler: (event2) => this.bus.emit("downloadClick", event2),
          infoHandler: (isOpen) => this.app.dispatch({
            type: "plot_edit",
            id: this.opts.id,
            config: {
              settings: {
                termInfo: {
                  isVisible: isOpen
                }
              }
            }
          }),
          helpHandler: () => this.bus.emit("helpClick"),
          title: this.opts.title
        });
      }
      this.features = await multiInit(arg);
    } catch (e) {
      throw e;
    }
  }
  setDom() {
    const dataTestId = `sjpp-plot-controls-${this.id}`;
    const topbar = this.opts.holder.append("div").attr("data-testid", `${dataTestId}-topbar`);
    const config_div = this.opts.holder.append("div").attr("data-testid", `${dataTestId}-config`);
    this.dom = {
      holder: this.opts.holder.style("vertical-align", "top").attr("data-testid", `${dataTestId}-holder`),
      // these are listed in the displayed top-down order of input elements
      topbar,
      config_div
    };
  }
  getState(appState) {
    const config = appState.plots.find((p) => p.id === this.id);
    if (!config) {
      throw `No plot with id='${this.id}' found.`;
    }
    return {
      genome: appState.genome,
      dslabel: appState.dslabel,
      activeCohort: appState.activeCohort,
      termfilter: appState.termfilter,
      config
    };
  }
  main(isOpen = void 0) {
    if (!this.state) return;
    if (typeof isOpen == "boolean") this.isOpen = isOpen;
    else {
      const controls = this.state.config.settings.controls;
      if (controls && "isOpen" in controls) this.isOpen = controls.isOpen;
    }
    this.render();
    const appState = this.app.getState();
    for (const name in this.features) {
      this.features[name].update({ state: this.state, appState });
    }
  }
};
var controlsInit = getCompInit(TdbPlotControls);
function setRenderers8(self2) {
  self2.render = function() {
    self2.dom.holder.style("background", self2.isOpen ? panel_bg_color : "");
  };
}
function setInteractivity3(self2) {
  self2.toggleVisibility = () => {
    const controls = self2.state?.config.settings.controls;
    if (controls && "isOpen" in controls) {
      self2.app.dispatch({
        type: "plot_edit",
        id: self2.id,
        config: {
          settings: {
            controls: { isOpen: !controls.isOpen }
          }
        },
        _scope_: "none"
        // may be used to limit the dispatch notification, if it is reliably known that
        // no components above or outside the _notificationRoot_ should react to this action
        //_notificationRoot_: [self.api]
      });
    } else {
      self2.main(!self2.isOpen);
    }
  };
}
function renderTerm1Label(tw) {
  if (!tw || !Object.keys(tw).length) return "";
  switch (tw.term.type) {
    case TermTypes.CATEGORICAL:
      return "Group categories";
    case TermTypes.INTEGER:
    case TermTypes.FLOAT:
      return tw.q.mode == "discrete" ? "Customize bins" : "Customize";
    case TermTypes.GENE_VARIANT:
      return "Group variants";
    case TermTypes.SNP:
      return "Group genotypes";
    default:
      return "Customize";
  }
}

// plots/summaryQ.ts
function getT0T2defaultQ(nqAsBinary = false) {
  const nb = nqAsBinary ? { mode: "discrete", type: "custom-bin", preferredBins: "median" } : { mode: "discrete" };
  const re = {
    [TermTypes.GENE_VARIANT]: { type: "predefined-groupset" },
    // covers float & integer dictionary numeric term. allow to use their default bins
    numeric: structuredClone(nb),
    // this is supposed to be TermCollectionTWFraction
    [TermTypes.TERM_COLLECTION]: {
      mode: "discrete",
      type: "custom-bin",
      lst: getDefaultFractionBins(),
      denominators: [],
      numerators: []
    }
  };
  for (const t2 of numericTypes) {
    if (t2 == "integer" || t2 == "float" || t2 == "date") continue;
    re[t2] = structuredClone(nb);
  }
  return re;
}
function getDefaultFractionBins() {
  return [
    { startunbounded: true, stop: 0.25, label: "<25%" },
    { start: 0.25, stop: 0.5, startinclusive: true, label: "25% to <50%" },
    { start: 0.5, stop: 0.75, startinclusive: true, label: "50% to <75%" },
    { start: 0.75, stopunbounded: true, startinclusive: true, label: "\u226575%" }
  ];
}

// plots/sc/utils/specialCase.ts
function getSingleCellSpecialCase(config, key = "term", noCohortTerms = false) {
  let specialCase = "default";
  const term = config[key];
  const chartType = config.childType || config.chartType || "unknown";
  if (!term || !term.term) {
    console.error(`Term missing to determine if special case handling is needed for ${chartType} chart.`);
  } else if (isSingleCellTerm(term.term)) {
    const sample = term.term?.sample;
    if (!sample) {
      console.error(`Single cell term missing sample information in ${chartType} config for term selection.`);
    } else {
      if (!sample.name && !sample.plots) {
        if (term.term?.plot) sample.plots = [term.term.plot];
      }
      const isMeta = noCohortTerms ? false : sample?.isMetaResult || false;
      specialCase = {
        type: "singleCell",
        isMeta,
        config: { sample }
      };
    }
  }
  return specialCase;
}

// plots/barchart/barchart.ts
var Barchart = class _Barchart extends PlotBase {
  constructor(opts, api) {
    super(opts, api);
    this.configTermKeys = ["term", "term0", "term2"];
    this.type = _Barchart.type;
  }
  static {
    this.type = "barchart";
  }
  //freeze the api of this class. don't want embedder functions to modify it.
  preApiFreeze(api) {
    api.download = this.download;
    api.getChartImages = () => this.getChartImages();
  }
  async init() {
    const opts = this.opts;
    const holder = opts.controls ? opts.holder : opts.holder.append("div");
    const { controls, errdiv, loadingDiv, banner, renderedData, charts, legendDiv } = this.getStandardDomLayout(
      holder,
      opts
    );
    this.dom = {
      loadingDiv,
      errdiv,
      header: opts.header,
      controls,
      holder,
      banner: banner.attr("data-testid", "sjpp-barchart-banner"),
      renderedData,
      barDiv: charts.style("display", "flex").style("flex-direction", "row").style("flex-wrap", "wrap").style("max-width", "100vw"),
      legendDiv: legendDiv.style("margin", "5px 5px 15px 5px")
    };
    if (this.dom.header) this.dom.header.html("Barchart");
    this.settings = JSON.parse(rendererSettings);
    setRenderers9(this);
    setInteractivity4(this);
    this.renderers = {};
    this.legendRenderer = htmlLegend(
      this.dom.legendDiv,
      {
        settings: {
          legendOrientation: "vertical"
        },
        handlers: this.handlers
      },
      this.dom.barDiv
    );
    this.controls = {};
    this.term2toColor = {};
    if (this.opts.bar_click_override) {
    } else if (!this.opts.bar_click_opts) {
      this.opts.bar_click_opts = ["hide_bar"];
      if (this.app.getState().nav.header_mode === "with_tabs") this.opts.bar_click_opts.push("add_filter", "add_group");
    }
  }
  async setControls() {
    const state = this.state;
    const controlLabels = state.config.controlLabels;
    if (!controlLabels) throw "controls labels not found";
    this.dom.controls.selectAll("*").remove();
    if (this.opts.controls) {
      this.opts.controls.on("downloadClick.barchart", this.download);
    } else {
      this.dom.holder.attr("class", "pp-termdb-plot-viz").style("display", "inline-block").style("min-width", "300px");
      const specialCase = getSingleCellSpecialCase(this.state.config);
      const inputs = [
        {
          type: "term",
          configKey: "term",
          chartType: "barchart",
          usecase: { target: "barchart", detail: "term" },
          label: controlLabels.term1?.label || renderTerm1Label,
          vocabApi: this.app.vocabApi,
          menuOptions: "edit",
          defaultQ4fillTW: { geneVariant: { type: "custom-groupset" } },
          getBodyParams: () => {
            const tw = this.config["term"];
            if (!tw) return { skip_categories: true };
            if (tw.term.categories) return { categories: tw.term.categories };
            return {};
          }
        },
        {
          type: "term",
          configKey: "term2",
          chartType: "barchart",
          usecase: { target: "barchart", detail: "term2", specialCase },
          title: controlLabels.term2.title || controlLabels.term2.label,
          label: controlLabels.term2.label,
          vocabApi: this.app.vocabApi,
          numericEditMenuVersion: this.opts.numericEditMenuVersion || ["continuous", "discrete"],
          defaultQ4fillTW: getT0T2defaultQ(),
          // no overlay for membership multivalue term1: overlapping bars invalidate
          // the association tests, same reason multivalue is banned as overlay term
          getDisplayStyle: () => this.isCategoricalTermCollection() || this.isMembershipMultivalue() ? "none" : "",
          processConfig: (config) => {
            const s = this.state.config.settings.barchart;
            if (!config.settings) config.settings = { barchart: {} };
            if (config.term2 && s.unit == "log") config.settings.barchart.unit = "abs";
            if (!config.term2 && s.unit == "pct") config.settings.barchart.unit = "abs";
          },
          getBodyParams: () => {
            const tw = this.config["term2"];
            if (!tw) return { skip_categories: true };
            if (tw.term.categories) return { categories: tw.term.categories };
            return {};
          }
        },
        {
          type: "term",
          configKey: "term0",
          chartType: "barchart",
          usecase: { target: "barchart", detail: "term0", specialCase },
          title: controlLabels.term0.title || controlLabels.term0.label,
          label: controlLabels.term0.label,
          vocabApi: this.app.vocabApi,
          // by default, do not allow continuous mode for divide-by term, since
          // it will create a separate violin-overlay group per unique float or integer value
          // and there will nonsensical tens/hundreds of these charts based on the cohort size
          numericEditMenuVersion: this.opts.numericEditMenuVersion || ["discrete"],
          defaultQ4fillTW: getT0T2defaultQ(),
          getDisplayStyle: () => this.isCategoricalTermCollection() ? "none" : "",
          getBodyParams: () => {
            const tw = this.config["term0"];
            if (!tw) return { skip_categories: true };
            if (tw.term.categories) return { categories: tw.term.categories };
            return {};
          }
        },
        {
          label: "Bar orientation",
          type: "radio",
          chartType: "barchart",
          settingsKey: "orientation",
          options: [
            { label: "Vertical", value: "vertical" },
            { label: "Horizontal", value: "horizontal" }
          ]
        },
        {
          label: "Scale",
          type: "radio",
          chartType: "barchart",
          settingsKey: "unit",
          options: [
            { label: "Linear", value: "abs" },
            /** Option not available when term2 is present:
             * 1. The scale for the plot renders incorrectly
             * 2. The bars do not appear to be rendering correctly as a result
             * TODOs: Investigate the cause of the rendering issue
             */
            {
              label: "Log",
              value: "log",
              getDisplayStyle: (plot, computedDisplay = "inline-block") => plot.term2 ? "none" : computedDisplay
            },
            {
              label: "Proportion",
              value: "pct",
              getDisplayStyle: (plot, computedDisplay = "inline-block") => plot.term2 ? computedDisplay : "none"
            }
          ]
        },
        {
          label: "Multicolor bars",
          title: "Color bars",
          type: "checkbox",
          chartType: "barchart",
          settingsKey: "colorBars",
          boxLabel: "Yes",
          getDisplayStyle: (plot) => plot.term2 ? "none" : "table-row"
        },
        {
          label: "Deduplicate",
          title: "Show samples that belong to multiple categories as their own bar, so each sample is counted once",
          type: "custom",
          // registry key only; the state lives in config.term.q.deduplicate, not in settings
          settingsKey: "dedup",
          init: (input) => {
            const label = input.dom.inputTd.append("label");
            const checkbox = label.append("input").attr("type", "checkbox").attr("data-testid", "sjpp-barchart-dedup").on("change", () => {
              const term = this.config.term;
              this.app.dispatch({
                type: "plot_edit",
                id: this.id,
                config: {
                  term: {
                    $id: term.$id,
                    id: term.id,
                    isAtomic: true,
                    term: term.term,
                    q: { ...term.q, deduplicate: checkbox.property("checked") }
                  }
                }
              });
            });
            label.append("span").html("&nbsp;Yes");
            return {
              main: (plot) => {
                checkbox.property("checked", !!plot.term?.q?.deduplicate);
                const show = plot.term?.term?.type == "multivalue" && plot.term.term.valueMeaning == "membership" && this.chartsData?.charts.find(
                  (c) => c.dedupedSerieses?.length && !deepEqual(
                    c.serieses.map((s) => s.seriesId),
                    c.dedupedSerieses.map((s) => s.seriesId)
                  )
                );
                input.dom.row.style("display", show ? "table-row" : "none");
              }
            };
          }
        }
      ];
      if (isNumericTw(this.config.term))
        inputs.push({
          label: "Show stats",
          type: "checkbox",
          chartType: "barchart",
          settingsKey: "showStats",
          boxLabel: "Yes"
        });
      if (!this.config.term2)
        inputs.push({
          label: "Show percent",
          type: "checkbox",
          chartType: "barchart",
          settingsKey: "showPercent",
          boxLabel: "Yes"
        });
      else
        inputs.push({
          label: "Show association tests",
          type: "checkbox",
          chartType: "barchart",
          settingsKey: "showAssociationTests",
          boxLabel: "Yes"
        });
      if (state.config.settings.barchart.colorBars && (state.config.term2 || state.config.term0))
        inputs.splice(7, 0, {
          label: "Assign colors to",
          title: `Colors bars either considering all the categories or the present categories. If there are many categories and only few are present the present choice will provide more contrast.`,
          type: "radio",
          chartType: "barchart",
          settingsKey: "colorUsing",
          options: [
            { label: "All values", value: "all" },
            { label: "Present values", value: "present" }
          ]
        });
      else if (!state.config.settings.barchart.colorBars)
        inputs.splice(6, 0, {
          label: "Default color",
          title: "Default color for bars when there is no overlay",
          type: "color",
          chartType: "barchart",
          settingsKey: "defaultColor"
          //getDisplayStyle: plot => (plot.settings.barchart.colorBars || plot.term2 ? 'none' : 'table-row')
        });
      inputs.push({
        label: "Plot length",
        title: `Set the plot length in pixels between 200 and 800.`,
        type: "number",
        chartType: "barchart",
        settingsKey: "plotLength",
        min: 200,
        max: 800,
        step: 10
      });
      const multipleTestingCorrection = this.app.getState().termdbConfig.multipleTestingCorrection;
      if (multipleTestingCorrection) {
        inputs.push({
          label: "Asterisks",
          boxLabel: "Visible",
          type: "checkbox",
          chartType: "barchart",
          settingsKey: "asterisksVisible",
          title: "Display the asterisks"
        });
        const mtcMethod = multipleTestingCorrection.method;
        if (!mtcMethod) throw "no multiple testing correction method specified";
        inputs.push({
          label: `Multiple testing correction (${mtcMethod == "bon" ? "Bonferroni" : mtcMethod})`,
          boxLabel: "",
          type: "checkbox",
          chartType: "barchart",
          settingsKey: "multiTestingCorr",
          title: `Perform multiple testing correction (${mtcMethod == "bon" ? "Bonferroni" : mtcMethod})`
        });
      }
      this.components = {
        controls: await controlsInit({
          app: this.app,
          id: this.id,
          holder: this.dom.controls.style("display", "inline-block"),
          inputs
        })
      };
      this.components.controls.on("downloadClick.barchart", this.download);
    }
  }
  setSampleType(sampleType) {
    if (!sampleType) return;
    const keys = Object.keys(sampleType);
    if (!keys.includes("name") || !keys.includes("plural_name")) return;
    this.sampleType = sampleType;
    Object.assign(this.config.controlLabels, {
      sample: sampleType.name,
      samples: sampleType.plural_name,
      Sample: sampleType.name.charAt(0).toUpperCase() + sampleType.name.slice(1),
      Samples: sampleType.plural_name.charAt(0).toUpperCase() + sampleType.plural_name.slice(1)
    });
  }
  reactsTo(action) {
    if (action.type.startsWith("plot_")) {
      return (action.id === this.id || action.id == this.parentId) && (!action.config?.childType || action.config?.childType == this.type);
    }
    return true;
  }
  getState(appState) {
    const config = appState.plots.find((p) => p.id === this.id);
    if (!config) {
      throw `No plot with id='${this.id}' found. Did you set this.id before this.api = getComponentApi(this)?`;
    }
    const parentConfig = this.parentId && appState.plots.find((p) => p.id === this.parentId);
    const termfilter = getCombinedTermFilter(appState, config.filter || parentConfig?.filter);
    return {
      nav: {
        header_mode: appState.nav.header_mode
      },
      termfilter,
      config: Object.assign({}, config, {
        settings: {
          barchart: config.settings.barchart,
          common: config.settings.common
        },
        displaySampleIds: appState.termdbConfig.displaySampleIds && this.app.vocabApi.hasVerifiedToken()
      }),
      multipleTestingCorrection: appState.termdbConfig.multipleTestingCorrection,
      bar_click_menu: appState.bar_click_menu || {},
      groups: rebaseGroupFilter(appState),
      parentError: this.app.getComponents(`plots.${this.parentId}`)?.getError?.()
    };
  }
  async main() {
    const c = this.state.config;
    if (c.chartType != this.type && c.childType != this.type) return;
    if (this.state.parentError) throw this.state.parentError;
    try {
      this.config = await this.getMutableConfig();
      if (!this.currServerData) this.dom.barDiv.style("max-width", window.innerWidth + "px");
      this.prevConfig = this.config || {};
      if (this.dom.header)
        this.dom.header.html(
          this.config.term.term.name + ` <span style="opacity:.6;font-size:.7em;margin-left:10px;">BARCHART</span>`
        );
      this.toggleLoadingDiv();
      await this.setControls();
      const reqOpts = this.getDataRequestOpts();
      await this.getDescrStats();
      const results = await this.app.vocabApi.getNestedChartSeriesData(reqOpts, this.api?.getAbortSignal());
      if (results.error) throw results;
      const data = results.data;
      this.charts = data.charts;
      this.setSampleType(results.sampleType);
      this.bins = results.bins;
      if (results.chartid2dtterm) this.chartid2dtterm = results.chartid2dtterm;
      this.app.vocabApi.syncTermData(this.config, data, this.prevConfig);
      this.currServerData = data;
      if (this.currServerData.refs && this.currServerData.refs.q) {
        for (const q of this.currServerData.refs.q) {
          if (q.error) throw q.error;
        }
      }
      this.term1toColor = {};
      this.term2toColor = {};
      this.hasMultiCategoryKeys = this.isCategoricalTermCollection();
      this.hasMembershipOverlay = this.isMembershipMultivalue();
      this.updateSettings(this.config);
      for (const chart of data.charts) {
        const categoriesPerSerie = chart.serieses.map((s) => s.data.length);
        const hasOverlay = this.config.term2 || this.hasMultiCategoryKeys || this.hasMembershipOverlay;
        const numColors = hasOverlay ? Math.max(...categoriesPerSerie) : chart.serieses.length;
        chart.colorScale = getColors(numColors);
      }
      this.chartsData = this.processData(this.currServerData);
      this.toggleLoadingDiv("none");
      this.render();
      this.dom.renderedData.style("display", "");
    } catch (e) {
      if (this.app.isAbortError(e)) return;
      this.toggleLoadingDiv("none", "none");
      throw e;
    }
  }
  // creates an opts object for the vocabApi.getNestedChartsData()
  getDataRequestOpts() {
    const c = this.config;
    const opts = { term: c.term, filter: this.state.termfilter.filter };
    if (this.state.termfilter.filter0) opts.filter0 = this.state.termfilter.filter0;
    if (c.term2) opts.term2 = c.term2;
    if (c.term0) opts.term0 = c.term0;
    return opts;
  }
  async getDescrStats() {
    const terms = [this.config.term];
    if (this.config.term2) terms.push(this.config.term2);
    if (this.config.term0) terms.push(this.config.term0);
    for (const t2 of terms) {
      if (isNumericTw(t2)) {
        const data = await this.app.vocabApi.getDescrStats(t2, this.state.termfilter, null, this.api?.getAbortSignal());
        if (data.error) throw data.error;
        t2.q.descrStats = data;
      }
    }
  }
  updateSettings(config) {
    if (!config) return;
    const settings = {
      term0: config.term0 ? config.term0.term.id : "",
      // convenient reference to the term id
      term1: config.term.term.id,
      // convenient reference to the term2 id
      term2: config.term2 ? config.term2.term.id : "",
      unit: config.settings.barchart.unit,
      orientation: config.settings.barchart.orientation,
      asterisksVisible: config.settings.barchart.asterisksVisible,
      multiTestingCorr: config.settings.barchart.multiTestingCorr,
      defaultColor: config.settings.barchart.defaultColor,
      colorBars: config.settings.barchart.colorBars,
      dedup: !!config.term.q?.deduplicate,
      plotLength: config.settings.barchart.plotLength,
      // normalize bar thickness regardless of orientation
      colw: config.settings.barchart.barwidth,
      rowh: config.settings.barchart.barwidth,
      colspace: config.settings.barchart.barspace,
      rowspace: config.settings.barchart.barspace,
      colorUsing: config.settings.barchart.colorUsing,
      showStats: config.settings.barchart.showStats,
      showAssociationTests: config.settings.barchart.showAssociationTests
    };
    this.setExclude(this.config.term, this.config.term2);
    Object.assign(this.settings, settings, this.currServerData.refs || {}, {
      exclude: this.settings.exclude
    });
    this.settings.cols = this.settings.dedup ? this.currServerData.refs.dedupCols : this.currServerData.refs.cols;
    this.settings.numCharts = this.currServerData.charts ? this.currServerData.charts.length : 0;
    if (!config.term2 && this.settings.unit == "pct") {
      this.settings.unit = "abs";
    }
  }
  mayResetHidden(term, term2, term0) {
    const combinedTermIds = (term && term.term.id) + ";;" + (term2 && term2.term.id) + ";;" + (term0 && term0.term.id);
    if (combinedTermIds === this.currCombinedTermIds) return;
    for (const chart of this.currServerData.charts) {
      if (term.q && term.q.hiddenValues) {
        this.mayEditHiddenValues(term, chart.serieses.length, "term");
      }
      if (term2 && term2.q && term2.q.hiddenValues) {
        for (const series of chart.serieses) {
          this.mayEditHiddenValues(term2, series.data.length, "term2");
        }
      }
    }
    this.currCombinedTermIds = combinedTermIds;
  }
  mayEditHiddenValues(term, numAvailable, termNum) {
    const numHidden = Object.keys(term.q.hiddenValues).filter((key) => term.q.hiddenValues[key]).length;
    if (numHidden < numAvailable) return;
    for (const key in term.q.hiddenValues) {
      if (!term.q.hiddenValues[key]) return;
      delete term.q.hiddenValues[key];
    }
    this.app.save({
      type: "plot_edit",
      id: this.id,
      config: {
        [termNum]: term
      }
    });
  }
  setExclude(term, term2) {
    this.settings.exclude.cols = Object.keys(term.q?.hiddenValues || {}).filter((id3) => term.q.hiddenValues[id3]).map((id3) => {
      return term.term.type == "categorical" ? id3 : this.settings.cols?.includes(id3) ? id3 : term.term.values[id3]?.label ? term.term.values[id3].label : id3;
    });
    this.settings.exclude.rows = !term2?.q?.hiddenValues ? [] : Object.keys(term2.q.hiddenValues).filter((id3) => term2.q.hiddenValues[id3]).map(
      (id3) => term2.term.type == "categorical" ? id3 : this.settings.rows?.includes(id3) ? id3 : term2.term.values[id3]?.label ? term2.term.values[id3].label : id3
    );
  }
  processData(chartsData) {
    this.seriesOrder = this.setMaxVisibleTotals(chartsData);
    if (!chartsData.charts.length) {
      this.seriesOrder = [];
    } else if (chartsData.refs.useColOrder) {
      this.seriesOrder = this.settings.cols;
    }
    const rows = chartsData.refs.rows;
    this.barSorter = (a, b) => this.seriesOrder.indexOf(a) - this.seriesOrder.indexOf(b);
    this.overlaySorter = chartsData.refs.useRowOrder ? (a, b) => rows.indexOf(a.dataId) - rows.indexOf(b.dataId) : (a, b) => this.totalsByDataId[b.dataId] > this.totalsByDataId[a.dataId] ? 1 : this.totalsByDataId[b.dataId] < this.totalsByDataId[a.dataId] ? -1 : a.dataId < b.dataId ? -1 : 1;
    this.visibleCharts = chartsData.charts.filter((chart) => chart.visibleSerieses.length);
    const t1 = this.config.term;
    const t2 = this.config.term2;
    const chartsTests = chartsData.tests;
    for (const chartId in chartsTests) {
      const chartTests = chartsTests[chartId];
      for (const t1c of chartTests) {
        const t1label = t1.term.values && t1c.term1comparison in t1.term.values ? t1.term.values[t1c.term1comparison].label : t1c.term1comparison;
        t1c.term1Label = t1label;
        for (const t2t of t1c.term2tests) {
          const t2label = t2.term.values && t2t.term2id in t2.term.values ? t2.term.values[t2t.term2id].label : t2t.term2id;
          t2t.term2Label = t2label;
        }
      }
    }
    return chartsData;
  }
  setMaxVisibleTotals(chartsData) {
    this.totalsByDataId = {};
    const t1 = this.config.term;
    const t2 = this.config.term2;
    const visibleTotalsByChartSeriesId = {};
    let maxVisibleAcrossCharts = 0;
    for (const chart of chartsData.charts) {
      if (!chart.settings) chart.settings = JSON.parse(rendererSettings);
      Object.assign(chart.settings, this.settings);
      chart.visibleTotal = 0;
      const serieses = this.settings.dedup ? chart.dedupedSerieses : chart.serieses;
      chart.visibleSerieses = serieses.filter((series) => {
        if (chart.settings.exclude.cols.includes(series.seriesId)) return false;
        series.visibleData = series.data.filter((d) => !chart.settings.exclude.rows.includes(d.dataId));
        series.visibleTotal = series.visibleData.reduce((sum, a) => sum + a.total, 0);
        if (!series.visibleTotal) return false;
        chart.visibleTotal += series.visibleTotal;
        if (!(series.seriesId in visibleTotalsByChartSeriesId))
          visibleTotalsByChartSeriesId[series.seriesId] = series.visibleTotal;
        for (const data of series.data) {
          data.seriesId = series.seriesId;
          if (t1.term.type == "geneVariant" && t1.q.type == "values" || t2?.term.type == "geneVariant" && t2?.q.type == "values") {
            if (!(data.dataId in this.totalsByDataId)) {
              this.totalsByDataId[data.dataId] = {};
            }
            this.totalsByDataId[data.dataId][chart.chartId] = this.totalsByDataId[data.dataId][chart.chartId] ? this.totalsByDataId[data.dataId][chart.chartId] + data.total : 0 + data.total;
          } else {
            if (!(data.dataId in this.totalsByDataId)) {
              this.totalsByDataId[data.dataId] = 0;
            }
            this.totalsByDataId[data.dataId] += data.total;
          }
        }
        return true;
      });
      if (t1.term.type == "multivalue" && t1.term.valueMeaning == "membership") {
        if ("visibleDistinctTotal" in chart) chart.visibleTotal = chart.visibleDistinctTotal;
        else if ("total" in chart) chart.visibleTotal = chart.total;
      }
      chart.settings.colLabels = chart.visibleSerieses.map((series) => {
        const id3 = series.seriesId;
        const label = t1.term.values && id3 in t1.term.values ? t1.term.values[id3].label : id3;
        const af = series && "AF" in series ? ", AF=" + series.AF : "";
        const ntotal = t2 && t2.term.type == "condition" && t2.q.value_by_computable_grade ? "" : `, n=${series.visibleTotal}`;
        return {
          id: id3,
          label: label + af + ntotal
        };
      });
      chart.maxVisibleSeriesTotal = chart.visibleSerieses.reduce((max, series) => {
        return series.visibleTotal > max ? series.visibleTotal : max;
      }, 0);
      if (chart.maxVisibleSeriesTotal > maxVisibleAcrossCharts) {
        maxVisibleAcrossCharts = chart.maxVisibleSeriesTotal;
      }
    }
    for (const chart of chartsData.charts) {
      chart.maxVisibleAcrossCharts = maxVisibleAcrossCharts;
    }
    return Object.keys(visibleTotalsByChartSeriesId).sort(
      (a, b) => visibleTotalsByChartSeriesId[b] - visibleTotalsByChartSeriesId[a]
    );
  }
  sortStacking(series, chart, chartsData) {
    this.term1toColor[series.seriesId] = this.settings.colorBars ? this.getColor(chart, this.config.term, series.seriesId, this.bins?.[1]) : this.settings.defaultColor;
    series.visibleData?.sort(this.overlaySorter);
    let seriesLogTotal = 0;
    for (const result of series.data) {
      this.setTerm2Color(chart, result);
      result.color = this.term2toColor[result.dataId] || this.term1toColor[series.seriesId];
      if (series.visibleData && !series.visibleData.includes(result)) continue;
      result.colgrp = "-";
      result.rowgrp = "-";
      result.chartId = chart.chartId;
      result.seriesId = series.seriesId;
      if (chartsData.tests) {
        result.groupPvalues = chartsData.tests[chart.chartId].find((x) => x.term1comparison === series.seriesId);
      }
      result.seriesTotal = series.total;
      result.chartTotal = chart.visibleTotal;
      result.logTotal = Math.log10(result.total);
      seriesLogTotal += result.logTotal;
    }
    if (seriesLogTotal > chart.maxSeriesLogTotal) {
      chart.maxSeriesLogTotal = seriesLogTotal;
    }
    for (const result of series.data) {
      if (result.color) continue;
      this.setTerm2Color(chart, result);
      result.color = this.term2toColor[result.dataId] || this.term1toColor[series.seriesId];
    }
  }
  setTerm2Color(chart, result) {
    if ((this.hasMultiCategoryKeys || this.hasMembershipOverlay) && !this.config.term2) {
      this.term2toColor[result.dataId] = rgb(chart.colorScale(result.dataId)).toString();
      return;
    }
    if (!this.config.term2) return;
    this.term2toColor[result.dataId] = this.getColor(chart, this.config.term2, result.dataId, this.bins?.[2]);
  }
  isCategoricalTermCollection() {
    const t1 = this.config.term;
    return t1?.term?.type === "termCollection" && t1.term.memberType === "categorical";
  }
  isMembershipMultivalue() {
    const t1 = this.config.term;
    return t1?.term?.type === "multivalue" && t1.term.valueMeaning === "membership";
  }
  getCategoryKeyLabel(t1, t2, dataId) {
    if (t2?.term?.values && dataId in t2.term.values) return t2.term.values[dataId].label;
    if (this.hasMultiCategoryKeys && t1?.term?.termlst?.length) {
      const memberTerm = t1.term.termlst.find((mt) => mt.name === dataId);
      if (memberTerm?.name) return memberTerm.name;
      for (const mt of t1.term.termlst) {
        if (mt.values && dataId in mt.values) return mt.values[dataId].label;
      }
    }
    return dataId;
  }
  getColor(chart, t2, label, bins) {
    if (!t2.term) return;
    if (t2.q.type == "predefined-groupset" || t2.q.type == "custom-groupset") {
      const groupset = t2.q.type == "predefined-groupset" ? t2.term.groupsetting.lst[t2.q.predefined_groupset_idx] : t2.q.customset;
      if (!groupset) throw "groupset is missing";
      const group = groupset.groups.find((g) => g.name == label);
      if (group?.color) return group.color;
    }
    if (t2.term.values && this.settings.colorUsing == "all") {
      for (const [key, v] of Object.entries(t2.term.values)) {
        const val = v;
        if (!val.color) continue;
        if (key === label) return val.color;
        if (val.label === label) return val.color;
      }
    }
    const bin = bins?.find((bin2) => bin2.label == label);
    if (bin?.color) return bin.color;
    if (t2.term.type == "geneVariant" && t2.q.type == "values") return this.getMutationColor(label);
    return rgb(chart.colorScale(label)).toString();
  }
  // should move this outside of setTerm2Color(),
  // otherwise it will get *** recreated on every call *** to setTerm2Color()
  getMutationColor(label) {
    for (const mc of Object.values(mclass)) if (mc.label === label && mc.color) return mc.color;
    for (const key in mclass) {
      if (mclass[key].label === label && mclass[key].color) return mclass[key].color;
    }
  }
  /*
    when term1 or term2 is a geneVariant term, return legendGrps: 
  	[ 
  		[
  			{
  				name: "...", 
  				items: [...]
  			},
  			...
  		],
  		... 
  	]
  */
  getLegendGrps() {
    const t1 = this.config.term;
    const t2 = this.config.term2;
    if (t1.term.type == "geneVariant" && t1.q.type == "values" || t2?.term.type == "geneVariant" && t2?.q.type == "values") {
      const legendGrps = [];
      for (const chart of this.chartsData.charts) {
        legendGrps.push(this.getOneLegendGrps(chart));
      }
      return legendGrps;
    }
    return this.getOneLegendGrps();
  }
  //Used by getLegendGrps to get one legendGrps
  getOneLegendGrps(chart) {
    const legendGrps = [];
    const s = this.settings;
    const t1 = this.config.term;
    const t2 = this.config.term2;
    const headingStyle = "color: #555; font-weight: 400";
    if (t1.q.descrStats && s.showStats) {
      const items = Object.values(t1.q.descrStats).map((stat) => {
        return {
          text: `${stat.label}: ${stat.value}`,
          noIcon: true
        };
      });
      const title = t2 ? `Descriptive statistics: ${t1.term.name}` : "Descriptive statistics";
      const name = `<span style="${headingStyle}">${title}</span>`;
      legendGrps.push({ name, items });
    }
    if (t2?.q.descrStats && s.showAssociationTests) {
      const items = Object.values(t2.q.descrStats).map((stat) => {
        return {
          text: `${stat.label}: ${stat.value}`,
          noIcon: true
        };
      });
      const title = `Descriptive statistics: ${t2.term.name}`;
      const name = `<span style="${headingStyle}">${title}</span>`;
      legendGrps.push({ name, items });
    }
    if (s.cols && s.exclude.cols.length) {
      const reducer = (sum, b) => sum + b.total;
      const items = s.exclude.cols.filter((collabel) => s.cols.includes(collabel)).flatMap((collabel) => {
        const filter2 = (c) => c.seriesId == collabel;
        const total = t2?.term?.type == "condition" ? 0 : t1.term.type == "geneVariant" && t1.q.type == "values" || t2?.term.type == "geneVariant" && t2?.q.type == "values" ? chart.serieses.filter(filter2).reduce(reducer, 0) : this.currServerData.charts.reduce((sum, chart2) => {
          return sum + chart2.serieses.filter(filter2).reduce(reducer, 0);
        }, 0);
        if (!total && !t2?.term?.type) return [];
        const label = t1.term.values && collabel in t1.term.values ? t1.term.values[collabel].label : collabel;
        const ntotal = total ? ", n=" + total : "";
        return [
          {
            id: collabel,
            text: label + ntotal,
            color: "#fff",
            textColor: "#000",
            border: "1px solid #333",
            //inset: total ? "n="+total : '',
            noIcon: true,
            type: "col",
            isHidden: true,
            hiddenOpacity: 1
          }
        ];
      }).sort(this.barSorter);
      if (items.length) {
        const name = t2 ? t1.term.name : "Other categories";
        legendGrps.push({
          name: `<span style="${headingStyle}">${name}</span>`,
          items
        });
      }
    }
    const showOverlayLegend = (t2 || this.hasMultiCategoryKeys || this.hasMembershipOverlay) && Object.keys(this.term2toColor).length;
    if (s.rows && !s.hidelegend && showOverlayLegend) {
      const value_by_label = !t2 || t2.term.type != "condition" || !t2.q ? "" : t2.q.value_by_max_grade ? "max. grade" : t2.q.value_by_most_recent ? "most recent" : "";
      const legendName = !t2 ? this.hasMembershipOverlay ? t1.term.name : "Category" : t2.term.type == "geneVariant" ? "" : t2.term.name;
      legendGrps.push({
        name: `<span style="${headingStyle}">` + legendName + (value_by_label ? ", " + value_by_label : "") + "</span>",
        items: s.rows.flatMap((d) => {
          const total = !t2 && this.hasMembershipOverlay ? this.currServerData.distinctSegmentTotals?.[d] ?? this.totalsByDataId[d] : chart ? this.totalsByDataId[d]?.[chart.chartId] : this.totalsByDataId[d];
          if (this.visibleCharts.length && !total) return [];
          const ntotal = total ? ", n=" + total : "";
          const label = this.getCategoryKeyLabel(t1, t2, d);
          return [
            {
              dataId: d,
              text: label + ntotal,
              color: this.term2toColor[d],
              type: "row",
              isHidden: s.exclude.rows.includes(d)
            }
          ];
        }).sort(this.overlaySorter)
      });
    }
    if (t2 && this.state.multipleTestingCorrection) {
      let testNum = 0;
      for (const chartId in this.chartsData.tests) {
        testNum += this.chartsData.tests[chartId].reduce((a, b) => a + b.term2tests.filter((a2) => !a2.skipped).length, 0);
      }
      const items = testNum > 1 && this.state.config.settings.barchart.multiTestingCorr ? [{ text: `* p-value < (0.05 / ${testNum} tests)`, noEditColor: true }] : [{ text: `* p-value < 0.05`, noEditColor: true }];
      legendGrps.push({
        name: `<span style="${headingStyle}">&nbsp;</span>`,
        items
      });
    }
    return legendGrps;
  }
};
var barInit = getCompInit(Barchart);
var componentInit2 = barInit;
function setRenderers9(self2) {
  self2.render = function() {
    const charts = self2.dom.barDiv.selectAll(".pp-sbar-div").data(self2.visibleCharts, (chart) => chart.chartId);
    charts.exit().each(self2.exitChart);
    charts.each(self2.updateChart);
    charts.enter().append("div").each(self2.addChart);
    if (!self2.visibleCharts.length) {
      for (const chart of self2.charts) {
        chart.serieses.forEach((series) => self2.sortStacking(series, chart, self2.chartsData));
      }
    }
    self2.dom.holder.selectAll(".pp-chart-title").style("display", self2.visibleCharts.length < 2 ? "none" : "block");
    const grps = self2.getLegendGrps();
    self2.legendRenderer(grps);
    if (!self2.visibleCharts.length) {
      const clickLegendMessage = self2.settings.exclude.cols.length || self2.settings.exclude.rows.length ? `<br/><span>click on a legend label below to display the barchart</span>` : "";
      self2.dom.banner.html(`<span>No visible barchart data to render</span>${clickLegendMessage}`).style("display", "block");
    } else {
      self2.dom.banner.text("").style("display", "none");
    }
  };
  self2.exitChart = function(chart) {
    delete self2.renderers[chart.chartId];
    select_default(this).remove();
  };
  self2.updateChart = function(chart) {
    chart.settings.cols.sort(self2.barSorter);
    chart.maxAcrossCharts = self2.chartsData.maxAcrossCharts;
    chart.handlers = self2.handlers;
    chart.maxSeriesLogTotal = 0;
    chart.visibleSerieses.forEach((series) => self2.sortStacking(series, chart, self2.chartsData));
    self2.renderers[chart.chartId] = barsRenderer(self2, select_default(this));
    self2.renderers[chart.chartId](chart);
    const div = select_default(this);
    div.style("display", "inline-block");
    div.append("div").attr("class", "pp-sbar-div-chartLengends").attr("data-testid", "sjpcb-bars-chartLengends").style("vertical-align", "top").style("margin", "10px 10px 10px 30px").style("display", "none");
    if (self2.chartsData.tests && self2.chartsData.tests[chart.chartId] && self2.config.settings.barchart.showAssociationTests) {
      generatePvalueTable(chart, div);
    }
  };
  self2.addChart = function(chart) {
    const div = select_default(this).attr("class", "pp-sbar-div").style("display", "inline-block").style("padding", "20px").style("vertical-align", "top");
    self2.renderers[chart.chartId] = barsRenderer(self2, select_default(this));
    chart.settings.cols.sort(self2.barSorter);
    chart.maxAcrossCharts = self2.chartsData.maxAcrossCharts;
    chart.handlers = self2.handlers;
    chart.maxSeriesLogTotal = 0;
    chart.visibleSerieses.forEach((series) => self2.sortStacking(series, chart, self2.chartsData));
    self2.renderers[chart.chartId](chart);
    div.append("div").attr("class", "pp-sbar-div-chartLengends").attr("data-testid", "sjpcb-bars-chartLengends").style("vertical-align", "top").style("margin", "10px 10px 10px 30px").style("display", "none");
    if (self2.chartsData.tests && self2.chartsData.tests[chart.chartId] && self2.config.settings.barchart.showAssociationTests) {
      generatePvalueTable(chart, div);
    }
  };
  function generatePvalueTable(chart, div) {
    const holder = div.select(".pp-sbar-div-chartLengends").style("display", "inline-block").style("vertical-align", "top").style("text-align", "center").append("div");
    self2.chartsData.tests[chart.chartId].sort(function(a, b) {
      return self2.settings.cols.indexOf(a.term1comparison) - self2.settings.cols.indexOf(b.term1comparison);
    });
    for (const t1c of self2.chartsData.tests[chart.chartId]) {
      t1c.term2tests.sort(function(a, b) {
        return self2.chartsData.refs.rows.indexOf(a.term2id) - self2.chartsData.refs.rows.indexOf(b.term2id);
      });
    }
    const columns = [
      { label: "Row 1" },
      { label: "Row 2" },
      { label: "Column 1" },
      { label: "Column 2" },
      { label: "P-value" }
    ];
    const noSkipped = self2.chartsData.tests[chart.chartId].every(
      (term1) => term1.term2tests.every((term2) => !term2.skipped)
    );
    const rows = [];
    const visibleTests = self2.chartsData.tests[chart.chartId].filter(
      (term1Data) => chart.visibleSerieses.some((visibleTerm1) => visibleTerm1.seriesId === term1Data.term1comparison)
    );
    for (const [index, term1] of visibleTests.entries()) {
      if (visibleTests.length == 2 && index == 1) {
        break;
      }
      const visibleTerm1Data = chart.visibleSerieses.find(
        (visibleTerm1) => visibleTerm1.seriesId === term1.term1comparison
      );
      const visibleTerm2Data = term1.term2tests.filter(
        (term2Data) => visibleTerm1Data.visibleData.some((visibleTerm2) => visibleTerm2.dataId === term2Data.term2id)
      );
      for (const [index2, term2] of visibleTerm2Data.entries()) {
        if (chart.settings.rows.length - chart.settings.exclude.rows.length == 2 && index2 == 1) {
          break;
        }
        let negateTerm2Label = negateTermLabel(term2.term2Label);
        if (chart.settings.rows.length - chart.settings.exclude.rows.length == 2) {
          const visibleTerm2CatsKeys = chart.settings.rows.filter((row) => !chart.settings.exclude.rows.includes(row));
          const visibleTerm2Labels = visibleTerm2CatsKeys.map((catK) => self2.config.term2?.term?.values?.[catK]?.label).filter((x) => x != void 0);
          if (visibleTerm2Labels?.length == 2)
            negateTerm2Label = visibleTerm2Labels[0] == term2.term2Label ? visibleTerm2Labels[1] : visibleTerm2Labels[0];
        }
        rows.push([
          { value: `${term1.term1Label}` },
          // when term1 has only 2 categories, Row2 would be the other category instead of "not Row1"
          { value: visibleTests.length == 2 ? visibleTests[1].term1Label : negateTermLabel(term1.term1Label) },
          { value: term2.term2Label },
          { value: negateTerm2Label },
          //if both chi-square and Fisher's exact tests were used. for the tests computed by Fisher's exact test, add a superscript letter 'a' after the pvalue.
          {
            html: term2.skipped ? "N/A" : term2.pvalue > 1e-4 ? roundValueAuto(Number(term2.pvalue)) : roundValueAuto(Number(term2.pvalue))
          }
        ]);
      }
    }
    holder.append("div").style("font-weight", "bold").style("padding-bottom", "0.5em").attr("data-testid", "sjpp-massbarchart-2x2assotestlabel").html("2x2 Association test (Fisher's exact test)").style("font-size", "0.9em");
    const table = holder.append("div").style("font-size", "0.9em");
    renderTable({
      columns,
      rows,
      div: table,
      showLines: false,
      maxWidth: "70vw",
      maxHeight: `${chart.svgh - 100}px`,
      resize: true
    });
    table.append("div").style("margin-top", "10px").style("text-align", "left").style("font-size", "10px").style("font-weight", "normal").html(noSkipped ? "" : "N/A: association test skipped because of limited sample size <br>");
  }
}
function setInteractivity4(self2) {
  self2.handlers = getHandlers(self2);
  self2.getChartImages = function() {
    const charts = [];
    for (const chart of self2.charts) {
      const name = `${this.config.term.term.name}  ${chart.name ? chart.name : ""}`;
      charts.push({ name, svg: chart.svg });
    }
    return charts;
  };
  self2.download = function(event2) {
    const charts = self2.getChartImages();
    const dm = new DownloadMenu(charts, self2.config.term.term.name);
    dm.show(event2.clientX, event2.clientY, event2.target);
  };
}
function getDefaultBarSettings(app) {
  return {
    barspace: 2,
    barwidth: 20,
    plotLength,
    orientation: "horizontal",
    unit: "abs",
    overlay: "none",
    divideBy: "none",
    rowlabelw: 250,
    asterisksVisible: app?.getState()?.termdbConfig?.multipleTestingCorrection ? true : false,
    multiTestingCorr: app?.getState()?.termdbConfig?.multipleTestingCorrection?.applyByDefault ? true : false,
    defaultColor: plotColor,
    colorBars: false,
    colorUsing: "all",
    showStats: true,
    showAssociationTests: true,
    showPercent: false
  };
}
async function getPlotConfig2(opts, app) {
  if (!opts.term) throw "barchart getPlotConfig: opts.term{} missing";
  try {
    opts.tw = await fillTermWrapper(opts.term, app.vocabApi);
    if (opts.term2) opts.term2 = await fillTermWrapper(opts.term2, app.vocabApi);
    if (opts.term0) opts.term0 = await fillTermWrapper(opts.term0, app.vocabApi);
  } catch (e) {
    console.log("Error reading config: " + JSON.stringify(opts));
    console.error(e);
    throw `${e} [barchart getPlotConfig()]`;
  }
  const config = {
    id: opts.term.term.id,
    controlLabels: Object.assign({}, defaultUiLabels, app.vocabApi.termdbConfig.uiLabels || {}),
    settings: {
      controls: {
        term2: null,
        // the previous overlay value may be displayed as a convenience for toggling
        term0: null
      },
      common: {
        use_logscale: false,
        // flag for y-axis scale type, 0=linear, 1=log
        use_percentage: false
        // Moved to barchart settings
        // barheight: 300, // maximum bar length
        // barwidth: 20, // bar thickness
        // barspace: 2 // space between two bars
      },
      barchart: getDefaultBarSettings(app)
    }
  };
  return copyMerge(config, opts);
}
function negateTermLabel(termLabel) {
  const termLabelStr = String(termLabel);
  if (termLabelStr.toUpperCase().startsWith("NOT ")) {
    return termLabelStr.substring(4);
  } else {
    return "not " + termLabelStr;
  }
}

// plots/barchart/barchart.events.ts
function getHandlers(self2) {
  const tip = new Menu({ padding: "5px" });
  self2.dom.tip = tip;
  const s = self2.settings;
  return {
    chart: {
      title(chart) {
        if (!self2.config.term0) return chart.chartId;
        return self2.config.term0.term.values && chart.chartId in self2.config.term0.term.values ? self2.config.term0.term.values[chart.chartId].label : chart.chartId;
      }
    },
    svg: {
      mouseout: () => {
        tip.hide();
      }
    },
    series: {
      mouseover(event2, d) {
        event2.stopPropagation();
        const hasOverlay = self2.config.term2 || self2.hasMultiCategoryKeys || self2.hasMembershipOverlay;
        let percent = hasOverlay ? d.total / d.seriesTotal * 100 : d.seriesTotal / d.chartTotal * 100;
        percent = parseFloat(percent.toFixed(1));
        const t1 = self2.config.term.term;
        const t2 = self2.config.term2 && self2.config.term2.term;
        const seriesLabel = (t1.values && d.seriesId in t1.values ? t1.values[d.seriesId].label : d.seriesId) + (t1.unit ? " " + t1.unit : "");
        let dataLabel;
        if (t2) {
          dataLabel = (t2.values && d.dataId in t2.values ? t2.values[d.dataId].label : d.dataId) + (t2.unit ? " " + t2.unit : "");
        } else if (self2.hasMultiCategoryKeys) {
          dataLabel = self2.getCategoryKeyLabel(self2.config.term, null, d.dataId);
        } else {
          dataLabel = d.dataId;
        }
        const icon = !hasOverlay ? "" : "<div style='display:inline-block; width:14px; height:14px; margin: 2px 3px; vertical-align:top; background:" + d.color + "'>&nbsp;</div>";
        const rows = [`<tr><td colspan=2 style='padding:3px; text-align:center'>${seriesLabel}</td></tr>`];
        if (hasOverlay) {
          rows.push(
            `<tr><td colspan=2 style='padding:3px; text-align:center'>${icon} <span>${dataLabel}</span></td></tr>`
          );
        }
        const uiLabels = self2.config.controlLabels || self2.app.vocabApi.termdbConfig.uiLabels;
        rows.push(
          `<tr><td style='padding:3px; color:#aaa'>#${uiLabels.Samples || "Individuals"}</td><td style='padding:3px; text-align:center'>${d.total}</td></tr>`,
          `<tr><td style='padding:3px; color:#aaa'>percent</td><td style='padding:3px; text-align:center'>${percent}%</td></tr>`
        );
        if (t2) {
          const pvalue = d.groupPvalues?.term2tests?.find((x) => x.term2id === d.dataId).pvalue;
          const term1Label = d.groupPvalues.term1Label;
          const term2Label = d.groupPvalues.term2tests.find((x) => x.term2id === d.dataId).term2Label;
          const tableValues = d.groupPvalues.term2tests.find((x) => x.term2id === d.dataId).tableValues;
          const skipped = d.groupPvalues.term2tests.find((x) => x.term2id === d.dataId).skipped;
          const negateTerm1Label = !(self2.settings.cols.length - self2.settings.exclude.cols.length == 2 && self2.chartsData.tests[d.chartId].length == 2) ? negateTermLabel(term1Label) : self2.chartsData.tests[d.chartId][0].term1Label == term1Label ? self2.chartsData.tests[d.chartId][1].term1Label : self2.chartsData.tests[d.chartId][0].term1Label;
          let negateTerm2Label = negateTermLabel(term2Label);
          if (self2.settings.rows.length - self2.settings.exclude.rows.length == 2) {
            const visibleTerm2CatsKeys = self2.settings.rows.filter((row) => !self2.settings.exclude.rows.includes(row));
            const visibleTerm2Labels = visibleTerm2CatsKeys.map((catK) => self2.config.term2?.term?.values?.[catK]?.label).filter((x) => x != void 0);
            if (visibleTerm2Labels?.length == 2)
              negateTerm2Label = visibleTerm2Labels[0] == term2Label ? visibleTerm2Labels[1] : visibleTerm2Labels[0];
          }
          if (self2.settings.showAssociationTests) {
            rows.push(
              `<tr>
							<td style='padding:3px; color:#aaa'>p-value</td>
							<td style='padding:3px; text-align:center'>${skipped ? "N/A" : pvalue > 1e-4 ? Number(pvalue.toFixed(4)) : roundValueAuto(Number(pvalue))}</td>
						</tr>
						<table style="margin: 5px; text-align:left; font-size: 0.8em; border-spacing: 5px; border-collapse: separate;"
							<tr>
								<td style='color:#aaa'></td>
								<td style='color:#aaa'>${term2Label}</td>
								<td style='color:#aaa'>${negateTerm2Label}</td>
							</tr>
							<tr>
								<td style='color:#aaa'>${term1Label}</td>
								<td>${tableValues.R1C1}</td>
								<td>${tableValues.R1C2}</td>
							</tr>
							<tr>
								<td style='color:#aaa'>${negateTerm1Label}</td>
								<td>${tableValues.R2C1}</td>
								<td>${tableValues.R2C2}</td>
							</tr>
						</table>`
            );
          }
        }
        if (t1.type != "condition" && (!t2 || t2.type != "condition")) {
          rows.push(
            `<tr><td style='padding:3px; color:#aaa'>Percentage</td><td style='padding:3px; text-align:center'>${(100 * d.total / (t2 ? d.seriesTotal : d.chartTotal)).toFixed(1)}%</td></tr>`
          );
        }
        tip.show(event2.clientX, event2.clientY).d.html(`<table class='sja_simpletable'>${rows.join("\n")}</table>`);
      },
      mouseout: () => {
        tip.hide();
      },
      rectFill(d) {
        return d.color;
      },
      strokeFill(d) {
        const rgbColor = rgb(d.color);
        const stroke = rgbColor.toString() == rgb("white").toString() ? rgbColor.darker() : rgbColor;
        return stroke;
      },
      click: self2.opts.bar_click_override ? (event2, d) => self2.opts.bar_click_override(getTermValues(d, self2)) : (event2, d) => handle_click(event2, self2, d)
    },
    barLabel: {
      text: (d) => {
        return "label" in d ? d.label : self2.config.term.values && "id" in d && d.id in self2.config.term.values ? self2.config.term.values[d.id].label : d;
      },
      click: self2.opts.bar_click_override ? (event2, d) => self2.opts.bar_click_override(getTermValues(d, self2)) : (event2, d) => handle_click(event2, self2, d),
      mouseover: (event2) => {
        event2.stopPropagation();
      },
      mouseout: () => {
        tip.hide();
      }
    },
    legend: {
      onColorClick: (e) => handleLegendClick(e.target, self2),
      click: (e) => handleLegendClick(e.target, self2),
      mouseover: (event2) => {
        event2.stopPropagation();
        const d = event2.target.__data__;
        if (d === void 0) return;
        if (d.isHidden) tip.show(event2.clientX, event2.clientY).d.html("Click to unhide bar");
      },
      mouseout: () => {
        tip.hide();
      }
    },
    yAxis: {
      text: (visibleTotal) => {
        const type = self2.sampleType?.plural_name || "samples";
        const term = self2.config.term;
        if (s.orientation == "vertical") {
          return s.unit == "pct" ? `% of ${type}` : `# of ${type} ` + (term.q.bar_by_children || term.q.value_by_most_recent || term.q.value_by_computable_grade ? "" : `(n=${visibleTotal})`);
        } else {
          return term.q.bar_by_children ? "Sub-condition" : term.q.value_by_max_grade ? "Maximum grade" : term.q.value_by_most_recent ? "Most recent grade" : term.q.value_by_computable_grade ? "Any grade" : term.type == "categorical" || !term.unit ? "" : term.unit;
        }
      }
    },
    xAxis: {
      text: (visibleTotal) => {
        const type = self2.sampleType?.plural_name || "samples";
        const term = self2.config.term;
        if (s.orientation == "vertical") {
          return term.q.bar_by_children ? "Sub-condition" : term.q.value_by_max_grade ? "Maximum grade" : term.q.value_by_most_recent ? "Most recent grade" : term.q.value_by_computable_grade ? "Any grade" : term.type == "categorical" || !term.unit ? "" : term.unit;
        } else {
          return s.unit == "pct" ? `% of ${type}` : `# of ${type} ` + (term.q.bar_by_children || term.q.value_by_most_recent || term.q.value_by_computable_grade ? "" : `(n=${visibleTotal})`);
        }
      }
    }
  };
}
function handleColorClick(d, self2, color) {
  const termNum = d.type == "col" ? "term" : "term2";
  const term = self2.config[termNum];
  let dataId = d.dataId;
  if (term.term.values && !term.term.values?.[dataId]) {
    for (const [key, value] of Object.entries(term.term.values)) if (value.label == d.dataId) dataId = key;
  }
  if (term.term.values?.[dataId]) term.term.values[dataId].color = color;
  if (term.term.type == "geneVariant") {
    let groupset;
    if (term.q.type == "predefined-groupset") {
      groupset = term.term.groupsetting.lst[term.q.predefined_groupset_idx];
    } else if (term.q.type == "custom-groupset") {
      groupset = term.q.customset;
    } else {
      throw "unexpected q.type";
    }
    const group = groupset.groups.find((g) => g.name == d.dataId);
    if (!group) throw "group not found";
    group.color = color;
    term.q.type = "custom-groupset";
    term.q.customset = groupset;
  }
  let binColored = null;
  if (self2.bins[2].length > 0) {
    const binMatched = self2.bins[2].find((bin) => bin.label == d.dataId);
    if (binMatched) {
      binMatched.color = color;
      binColored = self2.bins[2];
    }
  }
  self2.app.dispatch({
    type: "plot_edit",
    id: self2.id,
    config: {
      [termNum]: {
        $id: term.$id,
        id: term.id,
        isAtomic: true,
        term: term.term,
        q: getUpdatedQfromClick(d, term, d.isHidden, binColored)
      }
    }
  });
}
function handleLegendClick(target, self2) {
  const d = target.__data__;
  if (d === void 0) return;
  if (!("type" in d)) return;
  if (d.type == "row" && !self2.config.term2) return;
  const termNum = d.type == "col" ? "term" : "term2";
  const term = self2.config[termNum];
  const isHidden = "isHidden" in d ? !d.isHidden : !(term.q && term.q.hiddenValues && term.q.hiddenValues["dataId" in d ? d.dataId : d.id]);
  const tip = self2.app.tip;
  const menu = tip.clear();
  menu.showunder(target);
  const div = menu.d.append("div");
  div.append("div").attr("class", "sja_menuoption sja_sharp_border").text(!isHidden ? "Show" : "Hide").on("click", () => {
    menu.hide();
    hideCategory(d, self2, isHidden);
  });
  if (term.q.hiddenValues && Object.keys(term.q.hiddenValues).length > 1)
    div.append("div").attr("class", "sja_menuoption sja_sharp_border").text("Show all").on("click", () => {
      menu.hide();
      const tw = structuredClone(term);
      delete tw.q.hiddenValues;
      self2.app.dispatch({
        type: "plot_edit",
        id: self2.id,
        config: { [termNum]: tw }
      });
    });
  const color = rgb(d.color).formatHex();
  if (color != "#ffffff") {
    const input = div.append("div").attr("class", "sja_sharp_border").style("padding", "0px 10px").text("Color:").append("input").attr("type", "color").attr("value", color).on("change", () => {
      handleColorClick(d, self2, input.node().value);
      menu.hide();
    });
  }
}
function hideCategory(d, self2, isHidden) {
  const termNum = d.type == "col" ? "term" : "term2";
  const term = self2.config[termNum];
  self2.app.dispatch({
    type: "plot_edit",
    id: self2.id,
    config: {
      [termNum]: {
        //Fix for list samples options not working
        //after hiding a category
        $id: term?.$id,
        id: term.id,
        isAtomic: true,
        term: term.term,
        q: getUpdatedQfromClick(d, term, isHidden)
      }
    }
  });
}
function getUpdatedQfromClick(d, term, isHidden = false, binColored = null) {
  const label = "id" in d ? d.id : d.type == "col" ? d.seriesId : d.dataId;
  const valueId = term.term.values && Object.keys(term.term.values).find((id4) => term.term.values[id4].label === label);
  const id3 = !valueId ? label : valueId;
  const q = JSON.parse(JSON.stringify(term.q));
  if (!q.hiddenValues) q.hiddenValues = {};
  if (isHidden) q.hiddenValues[id3] = 1;
  else delete q.hiddenValues[id3];
  if (binColored) q.binColored = binColored;
  return q;
}
function handle_click(event2, self2, chart) {
  const d = event2.target.__data__ || event2.target.parentNode.__data__;
  const term1 = self2.config.term.term;
  const term2 = self2.config.term2 ? self2.config.term2.term : null;
  const uncomp_term1 = term1.values ? Object.values(term1.values).map((v) => v.label) : [];
  const uncomp_term2 = term2 && term2.values ? Object.values(term2.values).map((v) => v.label) : [];
  const term1unit = term1.unit && !uncomp_term1.includes(d.seriesId || d.id) ? " " + term1.unit : "";
  const term2unit = term2 && term2.unit && !uncomp_term2.includes(d.dataId || d.id) ? " " + term2.unit : "";
  const seriesId = d.seriesId || d.id;
  const seriesLabel = (term1.values && seriesId in term1.values ? term1.values[seriesId].label : seriesId) + term1unit;
  const dataLabel = (term2 && term2.values && d.dataId in term2.values ? term2.values[d.dataId].label : d.dataId ? d.dataId : d.id) + term2unit;
  const icon = !term2 ? "" : "<div style='display:inline-block; width:14px; height:14px; margin: 2px 3px; vertical-align:top; background:" + d.color + "'>&nbsp;</div>";
  const header = `<div style='padding:2px'><b>${term1.name}</b>: ${seriesLabel}</div>` + (d.seriesId && term2 ? `<div style='padding:2px'><b>${term2.name}</b>: ${dataLabel} ${icon}</div>` : "");
  const data = d.seriesId || d.seriesId === 0 ? d : { seriesId: d.id, dataId: d.dataId };
  const options = [];
  if (self2.opts.bar_click_opts.includes("hide_bar")) {
    const chartId = chart.chartId === void 0 ? "" : chart.chartId;
    const visibleSerieses = chart.visibleSerieses || self2.charts.find((c) => c.chartId === chartId)?.visibleSerieses || [];
    if (visibleSerieses.length > 1) {
      options.push({
        label: data.seriesId ? 'Hide "' + seriesLabel + '"' : "Hide",
        callback: () => {
          const term = self2.config.term;
          self2.app.dispatch({
            type: "plot_edit",
            id: self2.id,
            config: {
              term: {
                $id: term.$id,
                id: term.id,
                isAtomic: true,
                term: term.term,
                q: getUpdatedQfromClick({ id: data.seriesId, type: "col" }, term, true)
              }
            }
          });
        }
      });
    }
    const hasMultipleCells = visibleSerieses.some((s) => s.visibleData.length > 1);
    if (self2.config.term2 && hasMultipleCells && (data.dataId || data.dataId === 0)) {
      options.push({
        label: 'Hide "' + dataLabel + '" ' + icon,
        callback: () => {
          const term22 = self2.config.term2;
          self2.app.dispatch({
            isAtomic: true,
            type: "plot_edit",
            id: self2.id,
            config: {
              term2: {
                isAtomic: true,
                term: term22.term,
                q: getUpdatedQfromClick({ id: data.dataId, type: "row" }, term22, true)
              }
            }
          });
        }
      });
    }
  }
  if (self2.opts.bar_click_opts.includes("add_filter")) {
    const item = findItemByTermId(self2.state.termfilter.filter, self2.config.term.term.id);
    if (!item) {
      options.push({
        label: "Add as filter",
        callback: async (self3, tvslst2) => {
          const arg = getListSamplesArg(event2, self3, data.seriesId, data.dataId, chart.chartId);
          await menuoption_add_filter(self3, tvslst2, arg);
        }
      });
    }
  }
  if (self2.opts.bar_click_opts.includes("add_group") && self2.config.displaySampleIds) {
    options.push({
      label: "Add as group",
      callback: async () => {
        const arg = getListSamplesArg(event2, self2, data.seriesId, data.dataId, chart.chartId);
        await addAsGroup(arg);
      }
    });
  }
  const uiLabels = self2.config.controlLabels || self2.app.vocabApi.termdbConfig.uiLabels;
  if (self2.config.displaySampleIds) {
    options.push({
      label: `List ${uiLabels.samples}`,
      callback: async () => {
        const arg = getListSamplesArg(event2, self2, data.seriesId, data.dataId, chart.chartId);
        try {
          await listSamples(arg, data.seriesId, data.dataId, chart.chartId);
        } catch (e) {
          console.trace(e);
          throw e;
        }
      }
    });
    if (self2.opts.allow2selectSamples) {
      const ss = self2.opts.allow2selectSamples;
      options.push({
        label: ss.buttonText,
        callback: async () => {
          const arg = getListSamplesArg(event2, self2, data.seriesId, data.dataId, chart.chartId);
          const samples = await getSamples(arg);
          ss.callback({
            samples: await self2.app.vocabApi.convertSampleId(samples, ss.attributes),
            source: ss.defaultSelectionLabel || `Selected from barchart`
          });
        }
      });
    }
  }
  if (!options.length) return;
  self2.app.tip.clear();
  if (header) {
    self2.app.tip.d.append("div").html(header);
  }
  const tvslst = getTermValues(data, self2);
  self2.app.tip.d.append("div").selectAll("div").data(options).enter().append("div").attr("class", "sja_menuoption").html((d2) => d2.label).on("click", async (event3, d2) => {
    if (event3.target._clicked) return;
    event3.target._clicked = true;
    event3.target.textContent = "Loading...";
    await d2.callback(self2, tvslst);
    self2.app.tip.hide();
  });
  self2.app.tip.show(event2.clientX, event2.clientY);
}
function getListSamplesArg(event2, self2, seriesId, dataId, chartId) {
  const terms = [self2.config.term];
  const tvslst = {
    type: "tvslst",
    in: true,
    join: "and",
    lst: []
  };
  const geneVariant = {};
  const tvs = getTvs(1, seriesId, self2, geneVariant);
  if (tvs) tvslst.lst.push(tvs);
  if (self2.config.term2) {
    terms.push(self2.config.term2);
    const tvs2 = getTvs(2, dataId, self2, geneVariant);
    if (tvs2) tvslst.lst.push(tvs2);
  }
  if (self2.config.term0) {
    terms.push(self2.config.term0);
    const tvs2 = getTvs(0, chartId, self2, geneVariant);
    if (tvs2) tvslst.lst.push(tvs2);
  }
  const arg = {
    event: event2,
    self: self2,
    terms,
    tvslst,
    geneVariant
  };
  return arg;
}
function getTvs(termIndex, value, self2, geneVariant) {
  if (!value) return;
  const term = termIndex == 0 ? self2.config.term0 : termIndex == 1 ? self2.config.term : self2.config.term2;
  if (term.term.type == "geneVariant") {
    geneVariant[`t${termIndex}value`] = value;
    return;
  }
  if (isFractionTw(term)) {
    const bin = self2.bins[termIndex]?.find((bin2) => bin2.label == value);
    if (!bin) return null;
    return {
      type: "tvs",
      tvs: {
        term: getFractionTvsTerm(term),
        ranges: [bin]
      }
    };
  }
  let tvs = {
    type: "tvs",
    tvs: {
      term: term.term,
      values: [{ key: value }]
    }
  };
  if (term.q.type == "custom-groupset" || term.q.type == "predefined-groupset") {
    const groupset = term.q.type == "custom-groupset" ? term.q.customset : term.term.groupsetting.lst[term.q.predefined_groupset_idx];
    const group = groupset.groups.find((group2) => group2.name == value);
    if (!group) throw "group not found";
    tvs.tvs.values = group.values;
  } else if (isNumericTw(term)) {
    const bins = self2.bins[termIndex];
    if (!bins?.length) return null;
    tvs.tvs.ranges = [bins.find((bin) => bin.label == value)];
  } else if (term.term.type == "samplelst") {
    const list = term.term.values?.[value]?.list || [];
    const ids = list.map((s) => s.sampleId);
    const tvslst = getSamplelstFilter(ids);
    tvs = tvslst.lst[0];
  } else if (term.term.type == "geneVariant" && term.q.type == "values") {
    throw "no longer supported in barchart";
  }
  return tvs;
}
async function listSamples(arg, seriesId, dataId, chartId) {
  for (const k of Object.keys(arg)) {
    const param = arg[k];
    if (!param) throw `parameter '${k}' is undefined`;
  }
  const { event: event2, self: self2, terms, tvslst, geneVariant, tip } = arg;
  const { term0, term, term2 } = self2.config;
  const _terms = structuredClone(terms);
  for (const tw of _terms) {
    const i3 = tw.$id === term0?.$id ? 0 : tw.$id === term2?.$id ? 2 : 1;
    if (!self2.bins[i3].length) continue;
    if (tw.type === "TermCollectionTWFraction") {
      tw.q = {
        ...tw.q,
        mode: "discrete",
        type: "custom-bin",
        lst: self2.bins[i3]
      };
    } else {
      tw.q = {
        mode: "discrete",
        type: "custom-bin",
        lst: self2.bins[i3]
      };
    }
  }
  const uiLabels = self2.config.controlLabels || self2.app.vocabApi.termdbConfig.uiLabels;
  const opts = {
    terms: _terms,
    filter: filterJoin([self2.state.termfilter.filter, tvslst]),
    filter0: self2.state.termfilter.filter0,
    isSummary: true
  };
  const data = await self2.app.vocabApi.getAnnotatedSampleData(opts);
  const rows = [];
  const termIsNumeric = isNumericTw(self2.config.term);
  const term2isNumeric = self2.config.term2 ? isNumericTw(self2.config.term2) : false;
  const term0isNumeric = self2.config.term0 ? isNumericTw(self2.config.term0) : false;
  const termIsGv = self2.config.term.term.type == "geneVariant";
  const term2isGv = self2.config.term2?.term.type == "geneVariant";
  const term0isGv = self2.config.term0?.term.type == "geneVariant";
  const term2isSurv = self2.config.term2?.term.type == "survival";
  const term0isSurv = self2.config.term0?.term.type == "survival";
  const termdbmclass = self2.app.vocabApi.termdbConfig?.mclass;
  const notRenderedVals = /* @__PURE__ */ new Set();
  for (const sample of data.lst) {
    const pass = mayFilterByGeneVariant(sample, self2, geneVariant);
    if (!pass) continue;
    const sampleName = data.refs.bySampleId[sample.sample].label;
    const row = [{ value: sampleName }];
    const urlTemplate = self2.app.vocabApi.termdbConfig?.urlTemplates?.sample;
    if (urlTemplate) {
      row[0].url = urlTemplate.base + (sample[urlTemplate.namekey] || sample.sample);
    }
    const t1entry = sample[self2.config.term.$id];
    if (!t1entry) continue;
    if (self2.config.term.q?.hiddenValues && self2.config.term.q.hiddenValues[t1entry.value]) continue;
    let notRendered = false;
    const value = t1entry.value;
    if (termIsNumeric) {
      row.push({ value: t1entry.key === seriesId ? roundValueAuto(value) : t1entry.key });
    } else if (termIsGv) {
      addGvRowVals(sample, self2.config.term, row, termdbmclass);
    } else {
      row.push({ value: t1entry.key === seriesId ? value : t1entry.key });
    }
    if (t1entry.key !== seriesId) notRendered = true;
    if (self2.config.term2) {
      const t2entry = sample[self2.config.term2.$id];
      if (!t2entry) continue;
      if (self2.config.term2.q?.hiddenValues && self2.config.term2.q.hiddenValues[t2entry.value]) continue;
      if (term2isNumeric) {
        const value2 = roundValueAuto(t2entry.value);
        row.push({ value: t2entry.key === dataId ? value2 : t2entry.key });
      } else if (term2isGv) {
        addGvRowVals(sample, self2.config.term2, row, termdbmclass);
      } else if (term2isSurv) {
        const value2 = self2.config.term2.term.values[t2entry.key].label;
        row.push({ value: value2 });
      } else {
        const label = self2.config.term2.term.values?.[t2entry.value]?.label;
        const value2 = label || t2entry.value;
        row.push({ value: t2entry.key === dataId ? value2 : t2entry.key });
      }
      if (dataId && t2entry.key !== dataId) notRendered = true;
    }
    if (self2.config.term0) {
      const t0entry = sample[self2.config.term0.$id];
      if (!t0entry) continue;
      if (self2.config.term0.q?.hiddenValues && self2.config.term0.q.hiddenValues[t0entry.value]) continue;
      if (term0isNumeric) {
        const value2 = roundValueAuto(t0entry.value);
        row.push({ value: t0entry.key === chartId ? value2 : t0entry.key });
      } else if (term0isGv) {
        addGvRowVals(sample, self2.config.term0, row, termdbmclass);
      } else if (term0isSurv) {
        const value2 = self2.config.term0.term.values[t0entry.key].label;
        row.push({ value: value2 });
      } else {
        const label = self2.config.term0.term.values?.[t0entry.value]?.label;
        const value2 = label || t0entry.value;
        row.push({ value: t0entry.key === chartId ? value2 : t0entry.key });
      }
      if (chartId && t0entry.key !== chartId) notRendered = true;
    }
    if (notRendered && row.length) {
      notRenderedVals.add(row);
    }
    rows.push(row);
  }
  const columns = [{ label: uiLabels.Sample }];
  if (termIsNumeric) {
    columns.push({ label: self2.config.term.term.name });
  } else if (termIsGv) {
    addGvCols(self2.config.term, columns);
  } else {
    columns.push({ label: self2.config.term.term.name });
  }
  if (self2.config.term2) {
    if (term2isGv) {
      addGvCols(self2.config.term2, columns);
    } else {
      columns.push({ label: self2.config.term2.term.name });
    }
  }
  if (self2.config.term0) {
    if (term0isGv) {
      addGvCols(self2.config.term0, columns);
    } else {
      columns.push({ label: self2.config.term0.term.name });
    }
  }
  let div;
  if (tip) {
    div = tip.d;
    tip.clear().show(event2.clientX, event2.clientY, false);
  } else {
    const menu = new Menu({ padding: "5px" });
    menu.show(event2.clientX, event2.clientY, false);
    div = menu.d.append("div");
  }
  rows.sort((a, b) => {
    return a[0].value < b[0].value ? -1 : 1;
  });
  const renderedRows = rows.filter((r) => !notRenderedVals.has(r));
  if (renderedRows.length) {
    await renderTable({
      rows: renderedRows,
      columns,
      div: div.append("div"),
      showLines: true,
      maxHeight: "40vh",
      resize: true,
      dataTestId: "sjpp-listsampletable"
    });
  }
  if (notRenderedVals.size) {
    const barOrChart = self2.config.term0?.term.id.startsWith("case.diagnoses") ? "bar or chart" : "bar";
    const matchedLabels = [];
    if (term?.term?.id?.startsWith("case.diagnoses")) matchedLabels.push(seriesId);
    if (term2?.term?.id?.startsWith("case.diagnoses")) matchedLabels.push(dataId);
    if (term0?.term?.id?.startsWith("case.diagnoses")) matchedLabels.push(chartId);
    const clickedLabel = matchedLabels.join(", ");
    div.append("div").style("margin", "5px").style("padding", "5px").style("max-width", "600px").html(`<span>The ${uiLabels.samples} below have multiple diagnoses entries, where 1 or more entries match the value in 
				the clicked ${barOrChart} (${clickedLabel}), but were not rendered here. The entries corresponding to the 
				primary diagnosis for these cases were rendered and counted in a different ${barOrChart}.</span>
			`);
    await renderTable({
      rows: rows.filter((r) => notRenderedVals.has(r)),
      columns,
      div: div.append("div"),
      showLines: true,
      maxHeight: "40vh",
      resize: true,
      dataTestId: "sjpp-listsampletable"
    });
  }
}
async function getSamples(arg) {
  const { self: self2, terms, tvslst, geneVariant } = arg;
  const opts = {
    terms,
    filter: filterJoin([self2.state.termfilter.filter, tvslst]),
    filter0: self2.state.termfilter.filter0,
    isSummary: true
  };
  const data = await self2.app.vocabApi.getAnnotatedSampleData(opts);
  const samples = [];
  for (const sample of data.lst) {
    const pass = mayFilterByGeneVariant(sample, self2, geneVariant);
    if (!pass) continue;
    const t1entry = sample[self2.config.term.$id];
    if (!t1entry) continue;
    if (self2.config.term.q?.hiddenValues && self2.config.term.q.hiddenValues[t1entry.value]) continue;
    if (self2.config.term2) {
      const t2entry = sample[self2.config.term2.$id];
      if (!t2entry) continue;
      if (self2.config.term2.q?.hiddenValues && self2.config.term2.q.hiddenValues[t2entry.value]) continue;
    }
    if (self2.config.term0) {
      const t0entry = sample[self2.config.term0.$id];
      if (!t0entry) continue;
      if (self2.config.term0.q?.hiddenValues && self2.config.term0.q.hiddenValues[t0entry.value]) continue;
    }
    samples.push(sample);
  }
  return samples;
}
async function getSampleGrp(arg) {
  const samples = await getSamples(arg);
  const group = {
    name: "Group",
    items: samples.map((s) => {
      return { sampleId: s.sample };
    })
  };
  return group;
}
async function addAsGroup(arg) {
  for (const k of Object.keys(arg)) {
    const param = arg[k];
    if (!param) throw `parameter '${k}' is undefined`;
  }
  const group = await getSampleGrp(arg);
  const tw = getSamplelstTW([group]);
  const filter2 = getFilter(tw);
  addNewGroup(arg.self.app, filter2, arg.self.state.groups);
}
function mayFilterByGeneVariant(sample, self2, geneVariant) {
  if (self2.config.term.term.type == "geneVariant" && geneVariant.t1value) {
    const tw = self2.config.term;
    if (tw.q.type == "values") throw "q.type=values not supported";
    const value = sample[tw.$id]?.value;
    if (value != geneVariant.t1value) return false;
  }
  if (self2.config.term2?.term.type == "geneVariant" && geneVariant.t2value) {
    const tw = self2.config.term2;
    if (tw.q.type == "values") throw "q.type=values not supported";
    const value = sample[tw.$id]?.value;
    if (value != geneVariant.t2value) return false;
  }
  if (self2.config.term0?.term.type == "geneVariant" && geneVariant.t0value) {
    const tw = self2.config.term0;
    if (tw.q.type == "values") throw "q.type=values not supported";
    const value = sample[tw.$id]?.value;
    if (value != geneVariant.t0value) return false;
  }
  return true;
}
function addGvRowVals(sample, tw, row, termdbmclass) {
  const mlst = sample[tw.$id]?.values;
  const gene2mlst = /* @__PURE__ */ new Map();
  for (const gene of tw.term.genes) {
    const mlst_gene = mlst.filter((m) => m.gene == gene.id);
    gene2mlst.set(gene.name, mlst_gene);
  }
  if (!gene2mlst.size) throw "gene2mlst is empty";
  if (gene2mlst.size == 1) {
    const entry = gene2mlst.entries().next().value;
    const mlst2 = entry[1];
    const htmls = mlst2htmls(mlst2, termdbmclass);
    row.push({ html: htmls.join("<br>") });
  } else {
    const genes = [];
    const htmls = [];
    for (const [gene, mlst2] of gene2mlst) {
      genes.push(...Array(mlst2.length).fill(gene));
      htmls.push(...mlst2htmls(mlst2, termdbmclass));
    }
    row.push({ html: genes.join("<br>") });
    row.push({ html: htmls.join("<br>") });
  }
}
function mlst2htmls(mlst, termdbmclass) {
  const htmls = mlst.map((m) => {
    const mname = m.mname || "";
    const value = m.value ? roundValueAuto(m.value, false, 3) : "";
    const color = mclass[m.class].color;
    const label = (termdbmclass?.[m.class]?.label || mclass[m.class].label).toUpperCase();
    const holder = create_default("div");
    holder.append("span").text(mname || value);
    holder.append("span").style("margin-left", mname || value ? "5px" : "0px").style("color", color).style("font-size", ".8em").text(label);
    return holder.html();
  });
  return htmls;
}
function addGvCols(tw, columns) {
  if (tw.term.genes.length == 1) {
    columns.push({ label: tw.term.name });
  } else {
    columns.push({ label: "Gene" });
    if (tw.q.type == "predefined-groupset") {
      const groupset = tw.term.groupsetting.lst[tw.q.predefined_groupset_idx];
      columns.push({ label: dt2label[groupset.dt] });
    } else if (tw.q.type == "custom-groupset") {
      columns.push({ label: "Genotype" });
    } else {
      throw "unexpected tw.q.type";
    }
  }
}
async function menuoption_add_filter(self2, tvslst, arg) {
  if (!tvslst) return;
  if (!self2.state.termfilter || self2.state.nav?.header_mode !== "with_tabs") {
    return;
  }
  for (const k of Object.keys(arg)) {
    const param = arg[k];
    if (!param) throw `parameter '${k}' is undefined`;
  }
  const hasGrpSetting = arg.terms.find((t2) => t2.q?.type == "predefined-groupset" || t2.q?.type == "custom-groupset");
  let samplelstTW;
  if (hasGrpSetting) {
    const group = await getSampleGrp(arg);
    samplelstTW = getSamplelstTW([group]);
  }
  const filterUiRoot = getFilterItemByTag(self2.state.termfilter.filter, "filterUiRoot");
  const filter2 = filterJoin([
    filterUiRoot,
    samplelstTW ? getFilter(samplelstTW) : {
      type: "tvslst",
      in: true,
      join: tvslst.length > 1 ? "and" : "",
      lst: [...tvslst.map(wrapTvs)]
    }
  ]);
  filter2.tag = "filterUiRoot";
  self2.app.dispatch({
    type: "filter_replace",
    filter: filter2
  });
}
function wrapTvs(tvs) {
  return tvs.type === "tvs" ? tvs : { type: "tvs", tvs };
}
function getTermValues(d, self2) {
  const termValues = [];
  if (self2.state.nav?.header_mode == "with_cohortHtmlSelect") {
    const cohortFilter = getFilterItemByTag(self2.state.termfilter.filter, "cohortFilter");
    if (cohortFilter) termValues.push(JSON.parse(JSON.stringify(cohortFilter)));
  }
  const t1 = self2.config.term;
  const t1ValKey = t1.term.values && Object.keys(t1.term.values).filter((key) => t1.term.values[key].label === d.seriesId)[0];
  const t1ValId = t1.term.values && t1ValKey in t1.term.values ? t1ValKey : d.seriesId;
  const t2 = self2.config.term2;
  const t2ValKey = t2 && t2.term.values && Object.keys(t2.term.values).filter((key) => t2.term.values[key].label === d.dataId)[0];
  const t2ValId = t2 && t2.term.values && t2ValKey in t2.term.values ? t2ValKey : d.dataId;
  for (const term of [t1, t2]) {
    if (!term) continue;
    const i3 = term == t1 ? 1 : 2;
    const key = term == t1 ? t1ValId : t2ValId;
    if (!key) continue;
    const q = term.q;
    const label = !term || !term.term.values ? key : key in term.term.values ? term.term.values[key].label : key;
    if (q.type == "predefined-groupset" || q.type == "custom-groupset") {
      const groupset = q.type == "predefined-groupset" ? term.term.groupsetting.lst[q.predefined_groupset_idx] : q.customset;
      const group = groupset.groups.find((g) => g.name === key);
      const tvs = { term: term.term, values: group.values, groupset_label: group.name };
      if (term.term.type == "condition") {
        tvs.bar_by_children = term.q.bar_by_children;
        tvs.bar_by_grade = term.q.bar_by_grade;
        tvs.value_by_most_recent = term.q.value_by_most_recent;
        tvs.value_by_max_grade = term.q.value_by_max_grade;
      }
      termValues.push(tvs);
    } else if (term.term.type == "condition") {
      if (!t2 || t1.term.id != t2.term.id) {
        termValues.push(
          Object.assign(
            {
              term: term.term,
              values: [{ key, label }]
            },
            q
          )
        );
      }
      if (term == t1 && t2 && term.term.id == t2.term.id) {
        const q2 = t2.q;
        const term2Label = t2.term.values && d.dataId in t2.term.values ? self2.config.term2.values[d.dataId].label : d.dataId;
        termValues.push(
          Object.assign(
            {
              term: term.term,
              grade_and_child: [
                {
                  grade: q2.bar_by_grade ? d.dataId : key,
                  grade_label: q2.bar_by_grade ? term2Label : label,
                  child_id: q2.bar_by_children ? d.dataId : key,
                  child_label: q2.bar_by_children ? term2Label : label
                }
              ]
            },
            q2
          )
        );
      }
    } else {
      const bins = self2.currServerData.refs.bins[i3];
      if (!bins || !bins.length) {
        termValues.push({ term: term.term, values: [{ key, label }] });
      } else {
        const range2 = bins.find((d2) => d2.label == label || d2.name == label);
        if (range2) termValues.push({ term: term.term, ranges: [range2] });
        else if (term == t1) {
          termValues.push({ term: term.term, ranges: [{ value: key }] });
        } else if (term == t2) {
          termValues.push({ term: term.term, ranges: [{ value: key }] });
        } else {
          throw "should not happen";
        }
      }
    }
  }
  return termValues.map((f) => wrapTvs(f));
}

// dom/summary/ListSamples.ts
var ListSamples = class {
  constructor(opts) {
    /** Indicates a reduced range for the bin (e.g. violin brush) */
    this.useRange = false;
    /** For filtering gene variant terms later */
    this.geneVariant = {};
    if (!opts.term) throw new Error("Missing .term argument");
    this.app = opts.app;
    this.termfilter = opts.termfilter;
    this.plot = opts.plot;
    this.bins = opts.bins || {};
    this.t1 = opts.term;
    this.t2 = opts.term2 || null;
    this.t0 = opts.term0 || null;
    const { term, term2 } = opts;
    this.contTerm = "mode" in term.q && term.q.mode == "continuous" ? term : term2;
    this.overlayTerm = term === this.contTerm ? term2 : term;
    this.terms = [this.t1];
    if (isStrictNumeric(opts.start) && !isStrictNumeric(opts.end) || !isStrictNumeric(opts.start) && isStrictNumeric(opts.end)) {
      throw new Error("Both start and end must be provided for range filtering");
    }
    if (isStrictNumeric(opts.start) && isStrictNumeric(opts.end)) {
      this.useRange = true;
      this.start = opts.start;
      this.end = opts.end;
    }
    this.tvslst = {
      type: "tvslst",
      in: true,
      join: "and",
      lst: []
    };
    this.getTvsLst();
  }
  getTvsLst() {
    this.getTvsLstEntry(1);
    if (this.t2) {
      this.terms.push(this.t2);
      this.getTvsLstEntry(2);
    }
    if (this.t0) {
      this.terms.push(this.t0);
      this.getTvsLstEntry(0);
    }
  }
  getTvsLstEntry(termNum) {
    const tw = this[`t${termNum}`];
    if (!tw) throw new Error("Missing term wrapper");
    if (tw.term.type === TermTypes.GENE_VARIANT) {
      this.geneVariant[`t${termNum}value`] = this.plot.seriesId;
      return;
    }
    const key = termNum == 0 ? this.plot.chartId : this.plot.seriesId;
    if (!key && key !== 0) return;
    if (isFractionTw(tw)) {
      const tvs = this.createTvsRanges({ term: getFractionTvsTerm(tw) }, termNum, key);
      this.tvslst.lst.push({ type: "tvs", tvs });
      return;
    }
    let tvsEntry = {
      type: "tvs",
      tvs: {
        term: tw.term
      }
    };
    if (this.isContinuousOrBinned(tw, termNum)) {
      tvsEntry.tvs = this.createTvsRanges(tvsEntry.tvs, termNum);
    }
    tvsEntry = this.createTvsValues(tvsEntry, tw, key);
    this.tvslst.lst.push(tvsEntry);
  }
  createTvsValues(tvsEntry, tw, key) {
    const { Sample } = Object.assign({}, defaultUiLabels, this.app.vocabApi?.termdbConfig?.uiLabels || {});
    if ((tw?.q?.type == "custom-groupset" || tw?.q?.type == "predefined-groupset") && tw.term.type !== TermTypes.GENE_VARIANT) {
      const groupset = tw.q.type == "custom-groupset" ? tw.q.customset : tw.term.groupsetting.lst[tw.q.predefined_groupset_idx];
      const group = groupset.groups.find((group2) => group2.name == key);
      if (!group) throw new Error(`Group not found in groupset for ${tw.term.name}: ${key}`);
      tvsEntry.tvs.values = group.values;
    } else if (tw.term.type === TermTypes.SAMPLELST) {
      if (!tw.term.values?.[key]) throw new Error(`${Sample} list not found for ${tw.term.name}: ${key}`);
      const ids = (tw.term.values[key].list || []).map((s) => s.sampleId);
      const tmpTvsLst = getSamplelstFilter(ids);
      tvsEntry = tmpTvsLst.lst[0];
    } else {
      tvsEntry.tvs.values = [{ key }];
    }
    if (tw.term.type === TermTypes.CONDITION) {
      Object.assign(tvsEntry.tvs, {
        bar_by_grade: tw.q?.bar_by_grade || null,
        value_by_max_grade: tw.q.value_by_max_grade
      });
    }
    return tvsEntry;
  }
  createTvsRanges(tvs, termNum, key) {
    const tw = this[`t${termNum}`];
    const bins = tw != this.contTerm && this.bins[`term${termNum}`];
    const idOrLabel = key ? key : tw === this.overlayTerm ? this.plot.seriesId : tw === this.t0 ? this.plot.chartId : "";
    const hasIdOrLabel = idOrLabel !== "" && idOrLabel != null;
    const overlayOrChartBin = hasIdOrLabel ? bins?.[String(idOrLabel)] : void 0;
    const uncomputable = Object.entries(tw.term?.values ?? {}).find(
      ([_, v]) => v.label === key && v?.uncomputable
    )?.[0]?.[0];
    if (overlayOrChartBin) {
      tvs.ranges = [overlayOrChartBin];
    } else if (uncomputable) {
      if (!tvs.ranges) tvs.ranges = [];
      tvs.ranges.push({
        value: uncomputable,
        label: idOrLabel
      });
    } else {
      tvs.ranges = [];
    }
    if (!overlayOrChartBin && this.useRange) {
      if (tvs.ranges.length > 0 && tvs.ranges[0]?.start !== void 0) {
        tvs.ranges[0].start = this.start;
        tvs.ranges[0].stop = this.end;
      } else {
        tvs.ranges = [
          {
            start: this.start,
            stop: this.end,
            startinclusive: true,
            stopinclusive: true,
            startunbounded: false,
            stopunbounded: false
          }
        ];
      }
    }
    return tvs;
  }
  //TODO: Remove entirely??
  isContinuousOrBinned(tw, termNum) {
    if (!("mode" in tw.q)) return false;
    return tw.q?.mode === "continuous" || isNumericTerm(tw.term) && Object.keys(this.bins[`term${termNum}`]).length != 0;
  }
  async getData() {
    const { sample } = Object.assign({}, defaultUiLabels, this.app.vocabApi?.termdbConfig?.uiLabels || {});
    try {
      const opts = {
        terms: this.terms,
        filter: filterJoin([this.termfilter.filter, this.tvslst]),
        filter0: this.termfilter.filter0,
        isSummary: true
      };
      const data = await this.app.vocabApi.getAnnotatedSampleData(opts);
      if (!data) throw new Error(`No ${sample} data returned`);
      return data;
    } catch (e) {
      if (e instanceof Error) throw e;
      else {
        throw new Error(`Error fetching ${sample} data: ${e.message || e}`);
      }
    }
  }
  /** Formats the data for #dom/table/renderTable() */
  // also returning a samples[] array that includes samples
  // that pass the filtering steps
  // TODO: make a general function to get and filter sample data upon
  // selecting a bar/violin (similar to "getSamples" in
  // "client/plots/barchart.events.js"). This sample data can then be used
  // for listing samples, create group, create cohort, create filter, etc.
  setTableData(data) {
    const foundInvalidGvTerm = [this.t1, this.t2, this.t0].find((tw) => {
      return tw && tw.term.type === TermTypes.GENE_VARIANT && tw?.q?.type == "values";
    });
    if (foundInvalidGvTerm) throw new Error("q.type = values are not supported for gene variant terms");
    const rows = [];
    const urlTemplate = this.app.vocabApi.termdbConfig?.urlTemplates?.sample;
    const samples = [];
    for (const s of Object.values(data.lst)) {
      const filterSample = this.mayFilterGVSample(s);
      if (filterSample) continue;
      const sampleId = typeof s.sample === "string" ? s.sample : String(s.sample);
      const row = [{ value: data.refs.bySampleId[sampleId].label }];
      if (urlTemplate) {
        row[0].url = urlTemplate.base + (s[urlTemplate.namekey] || s.sample);
      }
      const term1Sample = s[this.t1.$id];
      if (term1Sample) {
        if (this.t1?.q?.hiddenValues && this.t1.q.hiddenValues?.[term1Sample?.["value"]]) {
          continue;
        } else this.addRowValue(s, this.t1, row);
      } else continue;
      if (this.t2) {
        const term2Sample = s[this.t2.$id];
        if (!term2Sample) continue;
        if (this.t2?.q?.hiddenValues && this.t2.q.hiddenValues?.[term2Sample?.["value"]]) continue;
        this.addRowValue(s, this.t2, row);
      }
      if (this.t0) {
        const term0Sample = s[this.t0.$id];
        if (!term0Sample) continue;
        if (this.t0?.q?.hiddenValues && this.t0.q.hiddenValues?.[term0Sample?.["value"]]) continue;
        this.addRowValue(s, this.t0, row);
      }
      rows.push(row);
      samples.push(s);
    }
    const { Sample } = Object.assign({}, defaultUiLabels, this.app.vocabApi?.termdbConfig?.uiLabels || {});
    const columns = [{ label: Sample }];
    this.addColValue(this.t1, columns);
    if (this.t2) this.addColValue(this.t2, columns);
    if (this.t0) this.addColValue(this.t0, columns);
    return [rows, columns, samples];
  }
  mayFilterGVSample(sample) {
    let filterSample = false;
    for (const [idx, tw] of [this.t0, this.t1, this.t2].entries()) {
      if (!tw) continue;
      if (tw.term.type !== TermTypes.GENE_VARIANT) continue;
      if (!this.geneVariant[`t${idx}value`]) continue;
      const value = sample?.[tw.$id]?.["value"];
      if (value != this.geneVariant[`t${idx}value`]) {
        filterSample = true;
        break;
      }
    }
    return filterSample;
  }
  addRowValue(s, tw, row) {
    if (tw.term.type === TermTypes.GENE_VARIANT) {
      addGvRowVals(s, tw, row, this.app.vocabApi.termdbConfig?.mclass);
      return;
    }
    const sample = s[tw.$id];
    let formattedVal;
    if (isNumericTerm(tw.term) || isFractionTw(tw)) {
      formattedVal = roundValueAuto(sample.value);
    } else if (tw.term.type === TermTypes.SURVIVAL) {
      formattedVal = tw.term.values?.[sample.key]?.label || sample.key;
    } else if (tw.term.type === TermTypes.TERM_COLLECTION && typeof sample.value === "object") {
      const termlst = tw.term.termlst || [];
      const parts = [];
      for (const [id3, val] of Object.entries(sample.value)) {
        const name = termlst.find((t2) => (t2.id || t2.name) === id3)?.name || id3;
        parts.push(`${name}: ${roundValueAuto(val)}`);
      }
      formattedVal = parts.join(", ");
    } else {
      formattedVal = tw.term.values?.[sample.value]?.label || sample.value;
    }
    row.push({ value: formattedVal });
  }
  addColValue(tw, columns) {
    if (tw.term.type === TermTypes.GENE_VARIANT) {
      addGvCols(tw, columns);
    } else {
      columns.push({ label: tw.term.name });
    }
  }
};

// dom/table.ts
var idIncr = 0;
var randomSuffix = Math.random();
function getUniqueNameOrId(str = "elem") {
  return `sjpp-${str}-${idIncr++}-${randomSuffix}`;
}
function renderTable({
  columns,
  rows,
  div,
  columnButtons,
  buttons,
  buttonsToLeft,
  noButtonCallback,
  singleMode = false,
  noRadioBtn = false,
  showLines = true,
  striped = true,
  showHeader = true,
  header = {},
  maxWidth = "90vw",
  maxHeight = "40vh",
  selectedRows = [],
  selectAll = false,
  resize = false,
  selectedRowStyle = {},
  inputName = null,
  dataTestId = null,
  download = void 0,
  noAutoScroll = false,
  hoverEffects,
  afterRender,
  allowRestoreRowOrder = false,
  restoreButtonInFooter = false,
  pagination
}) {
  validateInput();
  let _selectedRowStyle = selectedRowStyle;
  const rowsCopy = rows.map((i3) => i3);
  const sortButtonResetFns = [];
  function validateInput() {
    if (!columns || columns?.length == 0) throw `Missing columns data`;
    if (!rows) throw `Missing rows data`;
    if (!div) throw `Missing div argument`;
    const lineNumsWithDataProbs = [];
    for (const [i3, row] of rows.entries()) {
      if (row.length != columns.length) lineNumsWithDataProbs.push(i3 + 1);
    }
    if (lineNumsWithDataProbs.length > 0)
      throw `Num of row objects != num of cols. Line num(s) = ${lineNumsWithDataProbs}`;
    if (buttons) {
      for (const [i3, btn] of buttons.entries()) {
        if (!btn.text) throw `Missing button.text in buttons, line #${i3 + 1}`;
        if (!btn.callback) throw `Missing button.callback in buttons, line #${i3 + 1}`;
      }
    }
    if (allowRestoreRowOrder) {
      const hasSortableColumn = columns.some((col) => col.sortable === true);
      if (!hasSortableColumn) {
        throw `allowRestoreRowOrder can only be true when at least one column has sortable:true`;
      }
    }
  }
  const uniqueInputName = inputName || getUniqueNameOrId("input");
  const originalRows = rows.map((i3) => i3);
  const parentDiv = div.append("div").style("background-color", "white").style("display", "inline-block");
  let restoreButtonDiv;
  let restoreButton;
  if (allowRestoreRowOrder && !restoreButtonInFooter) {
    restoreButtonDiv = div.append("div").style("display", "none").style("padding", "5px").style("vertical-align", "top");
    restoreButton = restoreButtonDiv.append("button").text("Restore row order").attr("data-testid", "sjpp-table-restore-button").on("click", () => {
      restoreButtonDiv.style("display", "none");
      const checked = getCheckedRowIndex();
      const idxMap = new Map(rowsCopy.map((val, idx) => [val, idx]));
      selectedRows = checked.map((i3) => originalRows.findIndex((v) => idxMap.get(v) === i3));
      if (selectedRows.length) selectAll = false;
      for (const resetFn of sortButtonResetFns) resetFn();
      rows = originalRows.map((i3) => i3);
      updateRows();
    });
  }
  if (download) {
    const downloadDiv = div.append("div").style("display", "inline-block").style("padding", "5px").style("vertical-align", "top");
    icons["download"](downloadDiv, {
      width: 15,
      height: 15,
      title: "Download table",
      handler: () => {
        downloadTable(rows, columns, download.fileName || void 0);
      }
    });
  }
  if (resize) {
    if (rows.length > 15) parentDiv.style("height", maxHeight);
    parentDiv.style("max-width", maxWidth);
    parentDiv.style("resize", "both");
  } else {
    parentDiv.style("max-height", maxHeight).style("max-width", maxWidth);
    if (columns.length > 2) parentDiv.style("resize", "horizontal");
  }
  parentDiv.attr("class", "sjpp_show_scrollbar");
  const table = parentDiv.append("table").style("width", "100%");
  if (dataTestId) {
    table.attr("data-testid", dataTestId);
  }
  const thead = table.append("thead").style("position", "sticky").style("top", "0").style("background-color", "white").style("padding", "5px");
  const theadRow = thead.append("tr");
  if (showLines) theadRow.append("td").style("width", "1vw");
  if (buttons || noButtonCallback) {
    if (noRadioBtn) {
    } else {
      const cell = theadRow.append("td").attr("class", "sjpp_table_header").style("width", "1.5vw");
      if (!singleMode) {
        make_one_checkbox({
          holder: cell,
          checked: selectAll,
          testid: "sjpp-table-checkall",
          callback: (checked) => {
            const nodes = tbody.selectAll("input[type=checkbox]").nodes();
            tbody.selectAll("input").property("checked", checked);
            if (buttons) updateButtons();
            if (noButtonCallback) for (const [i3, node] of nodes.entries()) noButtonCallback(i3, node);
          }
        });
        if (!showHeader)
          theadRow.append("th").text("Check/Uncheck All").attr("class", "sjpp_table_header sjpp_table_item");
      }
    }
  }
  if (columnButtons && columnButtons.length > 0) {
    const th = theadRow.append("th").text("Actions").attr("class", "sjpp_table_item sjpp_table_header");
    if (header?.style) {
      for (const k in header.style) th.style(k, header.style[k]);
    }
  }
  if (showHeader) {
    for (const [i3, c] of columns.entries()) {
      const th = theadRow.append("th").attr("class", "sjpp_table_item sjpp_table_header");
      if (c.headerTestId) th.attr("data-testid", c.headerTestId);
      if (c.labelVertical) {
        th.style("vertical-align", "bottom");
        th.append("span").text(c.label).style("display", "inline-block").style("writing-mode", "vertical-rl").style("text-orientation", "mixed").style("transform", "rotate(180deg)").style("white-space", "nowrap");
      } else {
        th.text(c.label);
      }
      if (c.width) th.style("width", c.width);
      if (c.tooltip) th.attr("title", c.tooltip);
      if (header?.allowSort) {
        if (c.sortable) addSort(th, i3);
      }
      if (header?.style) {
        for (const k in header.style) th.style(k, header.style[k]);
      }
      if (c.barplot) {
        th.text("");
        prepareBarPlot(c.barplot, i3, rows);
        drawBarplotAxis(c, th);
        if (c.sortable) addSort(th, i3);
        continue;
      }
    }
  }
  const tbody = table.append("tbody");
  const pageSizeOptions = pagination?.pageSizeOptions || [10, 25, 50, 100];
  let pageSize = pagination?.pageSize ?? pageSizeOptions[0];
  let currentPage = pagination?.currentPage ?? 1;
  function getPageSlice() {
    if (!pagination) return { startIdx: 0, slice: rows };
    const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;
    const startIdx = (currentPage - 1) * pageSize;
    return { startIdx, slice: rows.slice(startIdx, startIdx + pageSize) };
  }
  function updateRows() {
    tbody.selectAll("tr").remove();
    const { startIdx, slice } = getPageSlice();
    for (const [sliceIdx, row] of slice.entries()) {
      const rowIdx = pagination ? startIdx + sliceIdx : sliceIdx;
      let checkbox;
      const tr = tbody.append("tr").attr("class", "sjpp_row_wrapper").attr("tabindex", 0);
      if (striped && rowIdx % 2 == 1) tr.style("background-color", "rgb(245,245,245)");
      const labelCell = row.find((c) => c.value !== "");
      const ariaLabelledBy = row.ariaLabelledBy || labelCell?.elemId || getUniqueNameOrId("td");
      if (!row.ariaLabelledBy && labelCell && !labelCell.elemId) labelCell.elemId = ariaLabelledBy;
      if (buttons || noButtonCallback) {
        const clickHandler = (e) => {
          if (e.target.tagName == "A" || e.target.tagName == "BUTTON" || e.target.tagName === "INPUT") {
            e.stopPropagation();
            return;
          }
          if (e.target !== checkbox.node()) {
            if (singleMode)
              checkbox.node().checked = true;
            else checkbox.node().checked = !checkbox.node().checked;
            checkbox.dispatch("change");
          }
        };
        tr.on("click", clickHandler);
        tr.on("keydown", (event2) => {
          if (event2.target.tagName != "TR") return;
          if (event2.key == "Enter") clickHandler(event2);
        });
      }
      if (showLines) {
        tr.append("td").text(rowIdx + 1).style("text-align", "center").style("width", "1vw").style("font-size", "0.8rem");
      }
      if (buttons || noButtonCallback) {
        const td = tr.append("td").style("width", "1.5vw").style("float", "center");
        if (noRadioBtn) {
          td.style("display", "none");
        }
        const checkboxValue = rowsCopy.findIndex((r) => row == r);
        checkbox = td.append("input").attr("type", singleMode ? "radio" : "checkbox").attr("name", uniqueInputName).attr("value", checkboxValue).attr("aria-labelledby", ariaLabelledBy).property("checked", selectAll || selectedRows.includes(rowIdx)).on("change", () => {
          if (buttons) updateButtons();
          else noButtonCallback(rowIdx, checkbox.node());
          const checked2 = checkbox.property("checked");
          for (const key in _selectedRowStyle) {
            tr.style(key, checked2 ? _selectedRowStyle[key] : "");
          }
        });
        if (noAutoScroll) {
        } else {
          if (selectedRows.length != rows.length && rowIdx === selectedRows[0] && tr.node()) {
            setTimeout(() => {
              tr.node()?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 500);
          }
        }
        const checked = checkbox.property("checked");
        for (const key in selectedRowStyle) {
          tr.style(key, checked ? selectedRowStyle[key] : "");
        }
      }
      if (columnButtons && columnButtons.length > 0) {
        const td = tr.append("td").attr("class", "sjpp_table_item");
        for (const button of columnButtons) {
          button.button = td.append("button").style("white-space", "normal").text(button.text).on("click", (event2) => button.callback(event2, rowIdx));
          if (button.dataTestId) {
            button.button.attr("data-testid", button.dataTestId);
          }
          if (button.class) button.button.attr("class", button.class);
          if ("disabled" in button) button.button.node().disabled = button.disabled(rowIdx);
        }
      }
      for (const [colIdx, cell] of row.entries()) {
        const td = tr.append("td").attr("id", cell.elemId || null).attr("class", "sjpp_table_item").attr("data-testid", cell.dataTestId || "sjpp-table-cell-item");
        cell.__td = td;
        const column = columns[colIdx];
        if (column.barplot) {
          if (typeof cell.value === "number" && Number.isFinite(cell.value)) {
            drawBarplotInCell(cell.value, td, column.barplot);
          } else if (cell.value != null && cell.value !== "") {
            td.text(cell.value);
          }
          continue;
        }
        if (column.editCallback && cell.value) {
          td.on("click", (event2) => {
            event2.stopImmediatePropagation();
            const isEdit = td.select("input").empty();
            if (!isEdit) return;
            td.html("");
            const input = td.append("input").attr("value", cell.value).on("change", () => {
              const value = input.node().value;
              cell.value = value;
              td.text(cell.value);
              column.editCallback(rowIdx, cell);
            });
            input.node().focus();
            input.node().select();
          });
        }
        if (column.width) td.style("width", column.width);
        if (column.align) td.style("text-align", column.align);
        if (column.nowrap) td.style("white-space", "nowrap");
        if (cell.url) {
          td.append("a").text(cell.value || cell.value == 0 ? cell.value : cell.url).attr("href", cell.url).attr("target", "_blank").attr("rel", "noopener noreferrer");
        } else if (cell.html) {
          td.html(cell.html);
        } else if ("value" in cell) {
          td.text(cell.value);
          if (cell.color) td.style("color", cell.color);
        } else if (cell.color) {
          if (cell.disabled) {
            td.style("background-color", cell.color);
          } else {
            const input = td.append("input").attr("type", "color").attr("value", cell.color).on("change", () => {
              const color = input.node().value;
              cell.color = color;
              if (column.editCallback) column.editCallback(rowIdx, cell);
            });
          }
        } else if (column.fillCell) {
          column.fillCell(td, rowIdx);
        }
      }
      if (hoverEffects) hoverEffects(tr, row);
    }
    if (afterRender) afterRender();
  }
  updateRows();
  let pagerDiv;
  let pagerInfo;
  let pagerNav;
  let pageSizeSelect;
  function renderPager() {
    if (!pagination) return;
    pagerNav.selectAll("*").remove();
    const total = rows.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;
    const startIdx = (currentPage - 1) * pageSize;
    const endIdx = Math.min(startIdx + pageSize, total);
    pagerInfo.text(
      total === 0 ? "Showing 0 entries" : `Showing ${(startIdx + 1).toLocaleString()} to ${endIdx.toLocaleString()} of ${total.toLocaleString()} entries`
    );
    const goTo = (p) => {
      if (p < 1 || p > totalPages || p === currentPage) return;
      currentPage = p;
      updateRows();
      renderPager();
      pagination.onChange?.({ currentPage, pageSize });
    };
    const addBtn = (label, page, opts = {}) => {
      const btn = pagerNav.append("button").text(label).style("margin", "0 2px").style("padding", "3px 8px").style("border", "1px solid #ccc").style("background-color", opts.active ? "#000" : "white").style("color", opts.active ? "white" : opts.disabled ? "#999" : "#000").style("cursor", opts.disabled ? "not-allowed" : "pointer").style("border-radius", "3px");
      if (opts.disabled) btn.attr("disabled", "disabled");
      else btn.on("click", () => goTo(page));
      return btn;
    };
    const addEllipsis = () => {
      pagerNav.append("span").text("\u2026").style("margin", "0 4px").style("color", "#999");
    };
    addBtn("Previous", currentPage - 1, { disabled: currentPage === 1 });
    const pages = /* @__PURE__ */ new Set();
    pages.add(1);
    pages.add(totalPages);
    for (let p = currentPage - 2; p <= currentPage + 2; p++) {
      if (p >= 1 && p <= totalPages) pages.add(p);
    }
    const ordered = [...pages].sort((a, b) => a - b);
    let prev = 0;
    for (const p of ordered) {
      if (prev && p - prev > 1) addEllipsis();
      addBtn(String(p), p, { active: p === currentPage });
      prev = p;
    }
    addBtn("Next", currentPage + 1, { disabled: currentPage === totalPages });
  }
  if (pagination) {
    pagerDiv = parentDiv.append("div").style("display", "flex").style("align-items", "center").style("justify-content", "space-between").style("flex-wrap", "wrap").style("padding", "8px 4px").style("font-size", "0.9em");
    const left = pagerDiv.append("div").style("display", "flex").style("align-items", "center").style("gap", "8px");
    left.append("span").text("Show");
    pageSizeSelect = left.append("select").style("padding", "2px 4px").on("change", function() {
      pageSize = Number(this.value);
      currentPage = 1;
      updateRows();
      renderPager();
      pagination.onChange?.({ currentPage, pageSize });
    });
    for (const opt of pageSizeOptions) {
      pageSizeSelect.append("option").attr("value", opt).property("selected", opt === pageSize).text(opt);
    }
    left.append("span").text("entries");
    pagerInfo = pagerDiv.append("div");
    pagerNav = pagerDiv.append("div");
    renderPager();
  }
  if (buttons || allowRestoreRowOrder && restoreButtonInFooter) {
    const footerDiv = div.append("div").insert("div").style("display", "inline-block").style("float", buttonsToLeft ? "left" : "right").style("padding-bottom", "5px");
    if (allowRestoreRowOrder && restoreButtonInFooter) {
      restoreButton = footerDiv.append("button").text("Restore row order").attr("data-testid", "sjpp-table-restore-button").style("display", "none").on("click", () => {
        restoreButton.style("display", "none");
        const checked = getCheckedRowIndex();
        const idxMap = new Map(rowsCopy.map((val, idx) => [val, idx]));
        selectedRows = checked.map((i3) => originalRows.findIndex((v) => idxMap.get(v) === i3));
        if (selectedRows.length) selectAll = false;
        for (const resetFn of sortButtonResetFns) resetFn();
        rows = originalRows.map((i3) => i3);
        updateRows();
      });
    }
    if (buttons) {
      for (const bCfg of buttons) {
        bCfg.button = footerDiv.append("button").text(bCfg.text).style("margin", "10px 10px 0 0").on("click", () => {
          bCfg.callback(getCheckedRowIndex(), bCfg.button.node());
        });
        if (bCfg.class) bCfg.button.attr("class", bCfg.class);
        if (bCfg.dataTestId) bCfg.button.attr("data-testid", bCfg.dataTestId);
        bCfg.button.node().disabled = selectedRows.length == 0 && !selectAll;
      }
      updateButtons();
    }
  }
  function updateButtons() {
    if (!buttons) return;
    const idxlst = getCheckedRowIndex();
    for (const b of buttons) {
      b.button.node().disabled = idxlst.length == 0;
      if (b.onChange) b.onChange(idxlst, b.button.node());
    }
  }
  function getCheckedRowIndex() {
    const checkboxes = tbody.selectAll("input:checked");
    const idxlst = [];
    if (!checkboxes.empty()) {
      checkboxes.each((d, i3, nodes) => {
        const node = nodes[i3];
        idxlst.push(Number.parseInt(node.value));
      });
    }
    return idxlst;
  }
  function addSort(th, i3) {
    const callback = (isAscending) => sortTableCallBack(i3, rows, isAscending);
    const updateTable = (newRows) => {
      const checked = getCheckedRowIndex();
      const idxMap = new Map(rowsCopy.map((val, idx) => [val, idx]));
      selectedRows = checked.map((i4) => newRows.findIndex((v) => idxMap.get(v) === i4));
      if (selectedRows.length) selectAll = false;
      rows = newRows;
      updateRows();
      if (pagination) {
        currentPage = 1;
        renderPager();
        pagination.onChange?.({ currentPage, pageSize });
      }
      if (allowRestoreRowOrder) {
        if (restoreButtonInFooter && restoreButton) {
          restoreButton.style("display", "inline-block");
        } else if (restoreButtonDiv) {
          restoreButtonDiv.style("display", "block");
        }
      }
    };
    const resetFn = createSortButton(th, callback, updateTable);
    sortButtonResetFns.push(resetFn);
  }
  const api = {
    update(opts) {
      if (opts.selectedRowStyle) {
        _selectedRowStyle = opts.selectedRowStyle;
        const trs = tbody.selectAll("tr");
        for (const key in _selectedRowStyle) {
          trs.style(key, function() {
            return select_default(this).select("td input").property("checked") ? _selectedRowStyle[key] : "";
          });
        }
      }
    }
  };
  return api;
}
var BOM = "\uFEFF";
function fileDateStamp(d = /* @__PURE__ */ new Date()) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
async function downloadTable(rows, cols, filename = `table-${fileDateStamp()}.tsv`, note) {
  const cellValue = (cell) => {
    if ("value" in cell) return cell.value;
    if (cell.url) return cell.url;
    if (cell.color) return cell.color;
    return "";
  };
  const escapeCell = (v) => {
    const s = String(v ?? "");
    return /[\t\r\n"]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = cols.map((column) => escapeCell(column.label)).join("	");
  const noteLine = note ? `# ${note.replace(/[\r\n]+/g, " ")}
` : "";
  const lines = noteLine + [header, ...rows.map((row) => row.map((cell) => escapeCell(cellValue(cell))).join("	"))].join("\n") + "\n";
  const dataStr = "data:text/tsv;charset=utf-8," + encodeURIComponent(BOM + lines);
  const link = document.createElement("a");
  link.setAttribute("href", dataStr);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
}
function createSortButton(th, callback, updateTable) {
  let isAscending = false;
  const sortDiv = th.append("div").style("display", "inline-block").attr("class", "sjpp-table-sort-button");
  icons["updown"](sortDiv, {
    handler: () => {
      isAscending = !isAscending;
      const newRows = callback(isAscending);
      updateTable(newRows);
    }
  });
  return () => {
    isAscending = false;
  };
}
function sortTableCallBack(i3, rows, isAscending) {
  let allNumStrs = true;
  for (let r = 0; r < rows.length; r++) {
    const v = rows[r][i3].value;
    if (typeof v !== "string" || !Number.isFinite(+v)) {
      allNumStrs = false;
      break;
    }
  }
  const newRows = rows.sort((a, b) => {
    const aVal = a[i3].value;
    const bVal = b[i3].value;
    if (aVal == null && aVal !== 0 || bVal == null && bVal !== 0) return 0;
    if (typeof aVal === "number" && typeof bVal === "number") {
      return isAscending ? aVal - bVal : bVal - aVal;
    }
    if (allNumStrs) {
      const aNum = +aVal;
      const bNum = +bVal;
      return isAscending ? aNum - bNum : bNum - aNum;
    }
    if (typeof aVal === "string" && typeof bVal === "string") {
      return isAscending ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    }
    return 0;
  });
  return newRows;
}
function prepareBarPlot(cb, i3, rows) {
  if (!cb.axisWidth) cb.axisWidth = 130;
  if (!cb.colorPositive) cb.colorPositive = "#d49353";
  if (!cb.colorNegative) cb.colorNegative = "#5256d1";
  if (!cb.xpadding) cb.xpadding = 5;
  let min = null, max = null;
  for (const r of rows) {
    const v = r[i3].value;
    if (!Number.isFinite(v)) continue;
    if (min == null) {
      min = v;
      max = v;
    } else {
      min = Math.min(min, v);
      max = Math.max(max, v);
    }
  }
  if (min !== null && max !== null && min < 0 && max > 0) {
    const a = Math.max(-min, max);
    min = -a;
    max = a;
  }
  cb.scale = linear().domain([min ?? 0, max ?? 0]).range([0, cb.axisWidth]);
}
function drawBarplotAxis(c, th) {
  const cb = c.barplot;
  const labfontsize = 14;
  const ypad = 5;
  const tickfontsize = 12;
  const ticksize = 4;
  const svg = th.append("svg").attr("width", 2 * (cb.xpadding || 0) + (cb.axisWidth || 0)).attr("height", labfontsize + ypad + tickfontsize + ticksize + 1);
  const axis = axisTop(cb.scale).ticks(cb.tickCount || 4);
  if (cb.tickFormat) axis.tickFormat(format(cb.tickFormat));
  axisstyle({
    axis: svg.append("g").attr("transform", `translate(0,${labfontsize + ypad + tickfontsize + ticksize})`).call(axis),
    color: "black",
    showline: true
  });
  svg.append("text").attr("fill", "black").attr("font-size", labfontsize).attr("text-anchor", "middle").text(c.label).attr("x", (cb.xpadding || 0) + (cb.axisWidth || 0) / 2).attr("y", labfontsize);
}
function drawBarplotInCell(value, td, c) {
  if (!Number.isFinite(value)) return;
  const [min, max] = c.scale.domain();
  let x1, x2, color;
  if (min >= 0) {
    x1 = 0;
    x2 = c.scale(value);
    color = c.colorPositive;
  } else if (max <= 0) {
    x2 = c.axisWidth;
    x1 = c.scale(value);
    color = c.colorNegative;
  } else {
    const x0 = c.scale(0);
    const xv = c.scale(value);
    x1 = Math.min(x0, xv);
    x2 = Math.max(x0, xv);
    color = value > 0 ? c.colorPositive : c.colorNegative;
  }
  const height = 14;
  td.append("svg").style("margin-top", "4px").attr("width", 2 * (c.xpadding ?? 0) + (c.axisWidth ?? 0)).attr("height", height).append("rect").attr("data-testid", "sjpp-table-barplot-item").attr("x", x1).attr("y", 0).attr("width", Math.max(1, x2 - x1)).attr("height", height).attr("fill", color);
}

// import("./tvs.*.ts") in filter/tvs.js
var globImport_tvs_ts = __glob({
  "./tvs.termCollection.ts": () => import("./tvs.termCollection-D5X2HNWO.js")
});

// import("./tvs.*.js") in filter/tvs.js
var globImport_tvs_js = __glob({
  "./tvs.categorical.js": () => import("./tvs.categorical-6IHP6MKD.js"),
  "./tvs.cohort.js": () => import("./tvs.cohort-PI6SVZXZ.js"),
  "./tvs.condition.js": () => import("./tvs.condition-FVTGDTH4.js"),
  "./tvs.density.js": () => import("./tvs.density-V6ZXSFGF.js"),
  "./tvs.dt.js": () => import("./tvs.dt-7CIYMLQF.js"),
  "./tvs.dtcnv.categorical.js": () => import("./tvs.dtcnv.categorical-D3W6R6BM.js"),
  "./tvs.dtcnv.continuous.js": () => import("./tvs.dtcnv.continuous-4WS2TN3K.js"),
  "./tvs.dtfusion.js": () => import("./tvs.dtfusion-NUUFIGG4.js"),
  "./tvs.dtitd.js": () => import("./tvs.dtitd-UCSEWRNJ.js"),
  "./tvs.dtsnvindel.js": () => import("./tvs.dtsnvindel-J4S7KU3Y.js"),
  "./tvs.dtsv.js": () => import("./tvs.dtsv-4OPYIWB6.js"),
  "./tvs.multivalue.js": () => import("./tvs.multivalue-M6WXVKB4.js"),
  "./tvs.numeric.js": () => import("./tvs.numeric-22AHXO5K.js"),
  "./tvs.samplelst.js": () => import("./tvs.samplelst-RUZYZ2FF.js"),
  "./tvs.survival.js": () => import("./tvs.survival-AH4XBPJ5.js")
});

// filter/tvs.js
var tsHandlers = /* @__PURE__ */ new Set(["termCollection"]);
var TVS = class {
  constructor(opts) {
    this.opts = this.validateOpts(opts);
    this.dom = { holder: opts.holder, tip: new Menu({ padding: "5px" }) };
    this.durations = { exit: 0 };
    setInteractivity5(this);
    setRenderers10(this);
    this.categoryData = {};
    this.handlerByType = {};
    this.api = {
      main: this.main.bind(this),
      showMenu: this.showMenu
    };
  }
  validateOpts(o) {
    if (!o.holder) throw ".holder missing";
    if (!o.vocabApi) throw ".vocabApi missing";
    if (typeof o.callback != "function") throw ".callback() is not a function";
    return o;
  }
  async main(data = {}) {
    this.tvs = data.tvs;
    this.filter = data.filter;
    await this.setHandler();
    await this.updateUI();
  }
  async setHandler() {
    if (!this.tvs || !this.tvs.term) return;
    const term = this.tvs.term;
    const type = isNumericTerm(term) ? "numeric" : isCategoricalTerm(term) ? "categorical" : term.type == "dtcnv" ? this.getDtCnvType(term) : term.type;
    if (!this.handlerByType[type]) {
      try {
        const _ = tsHandlers.has(type) ? await globImport_tvs_ts(`./tvs.${type}.ts`) : await globImport_tvs_js(`./tvs.${type}.js`);
        const handler3 = _.handler;
        this.handlerByType[type] = handler3;
      } catch (e) {
        throw `error with handler='./tvs.${type}.js': ${e}`;
      }
    }
    this.handler = this.handlerByType[type];
  }
  getDtCnvType(term) {
    if (term.type != "dtcnv") return;
    const cnv = this.opts.vocabApi.termdbConfig.queries?.cnv;
    if (!cnv) throw "cnv query is missing";
    const keys = Object.keys(cnv);
    const mode = keys.includes("cnvGainCutoff") || keys.includes("cnvLossCutoff") ? "continuous" : "categorical";
    return term.type + "." + mode;
  }
};
var TVSInit = getInitFxn(TVS);
function setRenderers10(self2) {
  self2.updateUI = function() {
    const terms_div = self2.dom.holder;
    const filters = terms_div.selectAll(".tvs_pill").data([self2.tvs], (tvs) => tvs?.term.id);
    filters.exit().each(self2.exitPill);
    filters.each(self2.updatePill);
    filters.enter().append("div").attr("class", "tvs_pill").style("white-space", "nowrap").style("display", "inline-block").transition().duration(200).each(self2.enterPill);
  };
  self2.enterPill = async function() {
    const one_term_div = select_default(this).style("font-size", ".9em");
    one_term_div.append("div").attr("class", "term_name_btn sja_filter_tag_btn").style("display", "inline-block").style("border-radius", "6px 0 0 6px").style("padding", "6px 6px 3px 6px").html(self2.handler.term_name_gen).style("text-transform", "uppercase");
    one_term_div.append("div").attr("class", "negate_btn").style("cursor", "default").style("padding", "6px 6px 3px 6px").style("background", self2.tvs.isnot ? "#f4cccc" : "#a2c4c9").html(
      self2.handler.getNegateText?.(self2) || (self2.tvs.isnot && self2.tvs.term.type !== "geneVariant" ? "NOT" : "IS")
    );
    self2.updatePill.call(this);
  };
  self2.showMenu = async (_holder) => {
    const holder = _holder ? _holder : self2.dom.tip;
    const loadingDiv = holder.append("div").style("padding", "10px").text("Loading ...");
    try {
      if (!dtTermTypes.has(self2.tvs.term.type)) {
        addExcludeCheckbox(holder, self2.tvs, self2);
      }
      await self2.handler.fillMenu(self2, holder, self2.tvs);
      loadingDiv.remove();
    } catch (e) {
      loadingDiv.text("Error: " + (e.message || e));
      if (e.stack) console.log(e);
    }
  };
  self2.updatePill = async function() {
    const one_term_div = select_default(this);
    const tvs = one_term_div.datum();
    const lstlen = self2.tvs.values && self2.tvs.values.length || self2.tvs.ranges && self2.tvs.ranges.length || self2.tvs.term.type == "samplelst" || dtTermTypes.has(self2.tvs.term.type);
    one_term_div.select(".term_name_btn").html(self2.handler.term_name_gen);
    one_term_div.select(".negate_btn").style("display", lstlen ? "inline-block" : "none").style("background", self2.tvs.isnot ? "#f4cccc" : "#a2c4c9").html(self2.handler.getNegateText?.(self2) || (tvs.isnot && tvs.term.type !== "geneVariant" ? "NOT" : "IS"));
    const label = self2.handler.get_pill_label(tvs);
    if (!("grade_type" in label)) label.grade_type = "";
    const value_btns = one_term_div.selectAll(".value_btn").data(label ? [label] : [], (d) => d.txt + d.grade_type);
    value_btns.exit().each(self2.removeValueBtn);
    value_btns.enter().append("div").attr("class", "value_btn sja_filter_tag_btn").style("display", lstlen ? "inline-block" : "none").style("padding", "6px 6px 3px 6px").style("border-radius", "0 6px 6px 0").style("font-style", "italic").html((d) => d.txt).append("div").attr("class", "grade_type_btn").style("display", "inline-block").style("margin", "0 5px").style("font-size", ".6em").style("text-transform", "uppercase").html((d) => d.grade_type).style("opacity", 0).transition().duration(200).style("opacity", 1);
  };
  self2.exitPill = async function(term) {
    select_default(this).style("opacity", 1).transition().duration(self2.durations.exit).style("opacity", 0).remove();
  };
  self2.makeValueTable = function(div, tvs, values, callback) {
    if (values?.length == 0) return div;
    const containerDiv = div.append("div").style("font-size", "0.8rem");
    const tableDiv = containerDiv.append("div");
    const maxCount = Math.max(...values.map((v) => v.samplecount), 0);
    values.forEach((v) => v.bar_width_frac = Number((1 - (maxCount - v.samplecount) / maxCount).toFixed(4)));
    const maxBarWidth = 100;
    const rows = [];
    const selectedIdxs = [];
    for (const [i3, value] of values.entries()) {
      let label = value.label || value.key;
      if (value.samplecount) label += " (n=" + value.samplecount + ")";
      const barWidth = maxBarWidth * value.bar_width_frac;
      const bar_td = `<div style='margin:1px 10px;width:${barWidth}px;height:15px;background-color:#ddd'>`;
      rows.push([{ value: label }, { html: bar_td }]);
      let checked = false;
      if (tvs.term.type == "categorical" || tvs.term.type == "survival" || tvs.term.type == "multivalue" || dtTermTypes.has(tvs.term.type))
        checked = tvs.values.find((a) => a.key === value.key);
      else if (tvs.term.type == "float" || tvs.term.type == "integer")
        checked = tvs.ranges.find((a) => String(a.value) === value.value.toString());
      else if (tvs.term.type == "condition") checked = tvs.values.find((a) => String(a.key) === String(value.key));
      if (checked) selectedIdxs.push(i3);
    }
    const columns = [{ label: "tvs" }, { label: "bar" }];
    const applybt = {
      text: "Apply",
      // unstyled button, found by testid since it no longer carries a distinguishing class
      dataTestId: "sjpp-tvs-apply",
      callback: (indexes) => {
        if (callback) callback(indexes);
      }
    };
    self2.tableApi = renderTable({
      rows,
      columns,
      div: tableDiv,
      maxWidth: "40vw",
      maxHeight: "40vh",
      buttons: [applybt],
      buttonsToLeft: true,
      showHeader: false,
      striped: false,
      showLines: false,
      selectedRows: selectedIdxs,
      noAutoScroll: true,
      selectedRowStyle: {
        "text-decoration": tvs.isnot ? "line-through" : ""
      }
    });
    return tableDiv;
  };
  self2.removeValueBtn = function(d, j) {
    const one_term_div = select_default(this.parentNode);
    const tvs = one_term_div.datum();
    const select_remove_pos = self2.handler.getSelectRemovePos(j, tvs);
    select_default(one_term_div.selectAll(".value_select")._groups[0][select_remove_pos]).remove();
    select_default(one_term_div.selectAll(".or_btn")._groups[0][j]).remove();
    select_default(this).style("opacity", 1).transition().duration(self2.durations.exit).style("opacity", 0).remove();
  };
}
function setInteractivity5(self2) {
}
async function showTvsMenu(opts) {
  const self2 = new TVS(opts);
  self2.tvs = {
    term: opts.term
  };
  self2.filter = opts.filter;
  const loadingDiv = opts.holder.append("div").style("padding", "10px").text("Loading ...");
  try {
    await self2.setHandler();
    if (self2.handler.setTvsDefaults) self2.handler.setTvsDefaults(self2.tvs);
    await self2.handler.fillMenu(self2, opts.holder, self2.tvs);
    loadingDiv.remove();
  } catch (e) {
    loadingDiv.text("Error: " + (e.message || e));
    if (e.stack) console.log(e);
  }
}
function addExcludeCheckbox(holder, tvs, self2) {
  const isNotLabels = holder.selectAll("label").data([{ label: "Exclude", value: "false", checked: tvs.isnot !== void 0 ? tvs.isnot : false }]).enter().append("label").style("margin", "0 5px");
  const isNotInput = isNotLabels.append("input").attr("type", "checkbox").attr("name", "sja_filter_isnot_input").attr("value", (d) => d.value).property("checked", (d) => d.checked).style("vertical-align", "top").style("margin-right", "3px").on("change", () => {
    tvs.isnot = isNotInput.node().checked;
    if (self2.tableApi) {
      self2.tableApi.update({
        selectedRowStyle: {
          "text-decoration": tvs.isnot ? "line-through" : ""
        }
      });
    }
  });
  isNotLabels.append("span").style("margin-right", "5px").style("vertical-align", "top").html((d) => d.label);
}

// filter/filter.utils.js
function findItemByTermId(item, id3) {
  if (item.type === "tvs" && item.tvs.term.id === id3) return item;
  if (item.type !== "tvslst") return;
  for (const subitem of item.lst) {
    const matchingItem = findItemByTermId(subitem, id3);
    if (matchingItem) return matchingItem;
  }
}
function findItem(item, $id2) {
  if (item.$id === $id2) return item;
  if (item.type !== "tvslst") return;
  for (const subitem of item.lst) {
    const matchingItem = findItem(subitem, $id2);
    if (matchingItem) return matchingItem;
  }
}
function findParent(parent, $id2) {
  if (parent.$id === $id2) return parent;
  if (!parent.lst) return;
  for (const item of parent.lst) {
    if (item.$id === $id2) return parent;
    else if (item.type == "tvslst") {
      const matchingParent = findParent(item, $id2);
      if (matchingParent) return matchingParent;
    }
  }
}
function getFilterItemByTag(item, tag) {
  if (item?.tag === tag) return item;
  if (item?.type !== "tvslst") return;
  for (const subitem of item.lst) {
    const matchingItem = getFilterItemByTag(subitem, tag);
    if (matchingItem) return matchingItem;
  }
}
function excludeFilterByTag(filter2, tag) {
  if (!filter2) return getNormalRoot(filter2);
  if (!filter2?.lst) return filter2;
  for (const [i3, f] of filter2.lst.entries()) {
    if (f.tag === tag) {
      filter2.lst.splice(i3, 1);
      break;
    } else if (f.lst) {
      excludeFilterByTag(f, tag);
    }
  }
  return getNormalRoot(filter2);
}
function getNormalRoot(rawFilter) {
  if (!rawFilter) return getWrappedTvslst([]);
  const encoded = typeof rawFilter == "string" ? rawFilter : JSON.stringify(rawFilter);
  const filter2 = JSON.parse(encoded);
  const processedFilter = normalizeFilter(filter2);
  return processedFilter.type == "tvslst" ? processedFilter : getWrappedTvslst([processedFilter]);
}
function normalizeFilter(filter2) {
  if (typeof filter2 != "object") throw `filter must be an object`;
  delete filter2.$id;
  delete filter2.tag;
  if (filter2.tyoe == "tvs") return filter2;
  if (filter2.type != "tvslst") throw `filter.type must be either 'tvslst' or 'tvs'`;
  const lst = filter2.lst.filter((f) => f.type !== "tvslst" || f.lst.length > 0).map((f) => {
    if (f.type !== "tvslst" || f.lst.length > 1) return f;
    if (f.in !== false) return f.lst[0];
    if (f.lst[0].type !== "tvs") throw `unable to handle filter entry type='${f.lst[0].type}'`;
    if (!f.lst[0].tvs) throw `missing filter entry tvs`;
    f.lst[0].tvs.isnot = !f.lst[0].tvs.isnot;
    return f.lst[0];
  });
  lst.forEach(normalizeProps);
  if (!lst.length) {
    return getWrappedTvslst([], "", filter2.$id);
  } else if (lst.length == 1) {
    if (lst[0].type === "tvslst") {
      return normalizeFilter(lst[0]);
    } else {
      return normalizeProps(lst[0]);
    }
  } else {
    filter2.lst = [];
    for (const item of lst) {
      if (item.type === "tvslst") {
        const normalItem = normalizeFilter(item);
        if (normalItem.type !== "tvslst" || normalItem.join != filter2.join || normalItem.in != filter2.in) {
          filter2.lst.push(normalItem);
        } else if (normalItem.lst.length) {
          filter2.lst.push(...normalItem.lst);
        }
      } else {
        filter2.lst.push(item);
      }
    }
    return filter2;
  }
}
function normalizeProps(filter2, callback = null) {
  delete filter2.$id;
  if (typeof callback == "function") callback(filter2);
  if (filter2.type == "tvslst") {
    for (const item of filter2.lst) {
      normalizeProps(item, callback);
    }
  }
  return filter2;
}
function filterJoin(lst) {
  if (!Array.isArray(lst)) throw "filterJoin() arg is not array";
  if (!lst[0]) return;
  let f = JSON.parse(JSON.stringify(lst[0]));
  if (lst.length == 1) return getNormalRoot(f);
  if (f.lst.length < 2) {
    if (f.join !== "") throw 'filter.join must be an empty string "" when filter.lst.length < 2';
    f.join = "and";
  } else if (f.join == "or" || f.in === false) {
    f = {
      type: "tvslst",
      join: "and",
      in: true,
      lst: [f]
    };
  } else if (f.join != "and") {
    throw 'filter.join must be either "and" or "or" when .lst length > 1';
  }
  for (let i3 = 1; i3 < lst.length; i3++) {
    const f2 = JSON.parse(JSON.stringify(lst[i3]));
    if (f2.join == "or" || f2.in === false) f.lst.push(f2);
    else f.lst.push(...f2.lst);
  }
  if (f.lst.length == 1 && f.lst[0].type == "tvs") {
    f.join = "";
  }
  return getNormalRoot(f);
}
function negateFilter(f0, tag = "filterUiRoot") {
  const f = structuredClone(f0);
  const fui = getFilterItemByTag(f, tag);
  if (fui) {
    if (typeof fui.in != "boolean") throw "filterUiRoot f.in is not boolean";
    fui.in = !fui.in;
    return f;
  }
  if (f.lst?.length == 1 && f.lst[0].type == "tvs" && typeof f.lst[0].tvs == "object") {
    f.lst[0].tvs.isnot = !f.lst[0].tvs.isnot;
    return f;
  }
  if (f.lst?.length > 1 && typeof f.in == "boolean") {
    f.in = !f.in;
    return f;
  }
  throw "cannot negate filter";
}
function getCombinedTermFilter(appState, filter2) {
  if (!filter2) return appState.termfilter;
  let _filter = filter2;
  if (appState.termfilter.filter) _filter = filterJoin([appState.termfilter.filter, filter2]);
  return { filter: _filter, filter0: appState.termfilter.filter0 };
}
function getCategoricalTermFilter(filterTWs, values, excludedTw) {
  const lst = [];
  for (const tw of filterTWs) {
    if (excludedTw && tw.id === excludedTw.id) continue;
    processTW(tw, values, lst);
  }
  return {
    type: "tvslst",
    in: true,
    join: lst.length > 1 ? "and" : "",
    lst
  };
}
function processTW(tw, values, lst) {
  const value = values[tw.term.id];
  if (value) {
    if (Array.isArray(value)) {
      const tvs = {
        type: "tvs",
        tvs: {
          term: tw.term,
          values: []
        }
      };
      for (const item of value) if (item) tvs.tvs.values.push({ key: item });
      if (tvs.tvs.values.length) lst.push(tvs);
    } else
      lst.push({
        type: "tvs",
        tvs: {
          term: tw.term,
          values: [{ key: value }]
        }
      });
  }
}

// filter/filter.renderer.js
var filterIndex = 0;
function setRenderers11(self2) {
  self2.initUI = async function() {
    if (self2.opts.newBtn) {
      self2.opts.newBtn.on("click.filter", self2.displayTreeNew);
    } else {
      self2.dom.newBtn = self2.dom.holder.append("div").attr("class", "sja_new_filter_btn sja_menuoption").attr("data-testid", "sjpp-new-filter-btn").html(self2.opts.emptyLabel).style("display", "inline-block").on("click", self2.displayTreeNew);
    }
    self2.dom.filterContainer = self2.dom.holder.append("div").attr("class", "sja_filter_container");
    self2.dom.holder.selectAll(".sja_filter_add_transformer").data(self2.opts.joinWith).enter().append("div").attr("class", "sja_filter_add_transformer").style("display", (d) => self2.filter && self2.filter.join != d ? "inline-block" : "none").style("margin-left", "10px").style("padding", "5px").style("border-radius", "5px").style("cursor", "pointer").html((d) => "+" + d.toUpperCase()).on("click", self2.displayTreeNew);
    self2.dom.table = self2.dom.controlsTip.clear().d.append("table").style("border-collapse", "collapse");
    const menuOptions = [
      { action: "edit", html: ["", "Edit", "&rsaquo;"], handler: self2.editTerm },
      { action: "join", html: ["&#10010;", "", "&rsaquo;"], handler: self2.displayTreeMenu },
      { action: "switch", html: ["", "Switch to", ""], handler: self2.switchJoin },
      { action: "negate", html: ["", "Negate", ""], handler: self2.negateClause },
      { action: "remove", html: ["&#10006;", "Remove", ""], handler: self2.removeTransform }
    ];
    if (self2.opts.vocab) {
      menuOptions.splice(1, 0, {
        action: "replace",
        html: ["", "Replace", "&rsaquo;"],
        handler: self2.displayTreeMenu
      });
    }
    self2.dom.table.selectAll("tr").data(menuOptions).enter().append("tr").attr("class", "sja_menuoption").attr("data-testid", (d) => `sjpp-menu-option-${d.action}`).on("click", self2.handleMenuOptionClick).selectAll("td").data((d) => d.html).enter().append("td").style("padding", "5px").style("border-top", "solid 1px white").style("color", (d, i3) => d == "&#10006;" ? "#a00" : i3 === 0 ? "#0a0" : "#111").style("opacity", (d, i3) => i3 === 0 ? 0.8 : 1).html((d) => d);
    self2.dom.treeHead = self2.dom.treeTip.d.append("div").attr("class", "sja_tree_tip_head").style("padding", "3px");
    self2.dom.termSrcDiv = self2.dom.treeTip.d.append("div").attr("class", "sja_term_src_body");
    self2.dom.treeHeadTitle = self2.dom.treeHead.append("div");
    select_default("body").on("mousedown.sja_filter_" + filterIndex++, (event2) => {
      if ([
        "sja_filter_join_label",
        "sja_filter_clause_negate",
        "sja_filter_paren_open",
        "sja_filter_paren_close"
      ].includes(event2.target.className))
        return;
      self2.dom.filterContainer?.selectAll(".sja_filter_grp").style("background-color", "transparent");
      self2.removeBlankPill();
      this.dom.holder?.selectAll(".sja_filter_add_transformer").style("display", this.getAddTransformerBtnDisplay);
    });
  };
  self2.updateUI = async function(container, filter2) {
    container.datum(filter2).style("display", !filter2.lst || !filter2.lst.length ? "none" : "inline-block");
    const pills = container.selectAll(":scope > .sja_filter_grp").style("background-color", "transparent").data([filter2], self2.getId);
    pills.exit().each(self2.removeGrp);
    pills.each(self2.updateGrp);
    pills.enter().append("div").attr("class", "sja_filter_grp").style("margin", "5px").each(self2.addGrp);
    self2.updatePromise(0);
  };
  self2.addGrp = function(item, i3) {
    const filter2 = this.parentNode.__data__;
    select_default(this).style("display", "inline-block");
    select_default(this).append("div").attr("class", "sja_filter_clause_negate").style("display", filter2.in ? "none" : "inline-block").style("color", "rgb(102,0,0)").style("font-weight", 500).style("cursor", "pointer").html("NOT").on("click", self2.displayControlsMenu);
    select_default(this).append("div").attr("class", "sja_filter_paren_open").html("(").style("display", "none").style("padding", "0 5px").style("font-weight", 500).style("font-size", "24px").style("cursor", "pointer").on("click", self2.displayControlsMenu);
    const data = item.type == "tvslst" ? item.lst : [item];
    const pills = select_default(this).selectAll(":scope > .sja_filter_item").data(data, self2.getId);
    pills.enter().append("div").attr("class", "sja_filter_item").each(self2.addItem);
    if (self2.opts.joinWith.length == 1) {
      self2.dom.last_join_div = select_default(this).append("div").attr("class", "sja_filter_last_join").style("display", "inline");
      self2.dom.last_join_label = self2.dom.last_join_div.append("div").datum({ action: "join", html: ["&#10010;", "", "&rsaquo;"], handler: self2.displayTreeMenu }).attr("class", "sja_filter_last_join_label").style("padding", "0 5px").style("display", filter2.lst.length ? "inline" : "none").style("font-weight", 500).style("cursor", "pointer").html("+" + self2.opts.joinWith[0].toUpperCase()).on("click", self2.showLastJoinBlank);
      select_default("body").on("mousedown.sja_filter_last_join", () => {
        self2.dom.last_join_label.style("display", "inline");
      });
    }
    select_default(this).append("div").attr("class", "sja_filter_paren_close").style("padding", "0 5px").html(")").style("display", "none").style("font-weight", 500).style("font-size", "24px").style("cursor", "pointer").on("click", self2.displayControlsMenu);
    select_default(this).selectAll(":scope > .sja_filter_paren_open, :scope > .sja_filter_paren_close").style(
      "display",
      self2.opts.joinWith.length < 2 || data.length < 2 ? "none" : !filter2.in || data.length > 1 && filter2.tag != "filterUiRoot" ? "inline-block" : "none"
    );
  };
  self2.updateGrp = function(item, i3) {
    const filter2 = this.parentNode.__data__;
    select_default(this).select(":scope > .sja_filter_clause_negate").style("display", filter2.in ? "none" : "inline-block");
    const data = item.type == "tvslst" ? item.lst : [item];
    select_default(this).selectAll(":scope > .sja_filter_paren_open, :scope > .sja_filter_paren_close").style(
      "display",
      self2.opts.joinWith.length < 2 || data.length < 2 ? "none" : !filter2.in || data.length > 1 && filter2.tag != "filterUiRoot" ? "inline-block" : "none"
    );
    const pills = select_default(this).selectAll(":scope > .sja_filter_item").data(data, self2.getId);
    pills.exit().each(self2.removeItem);
    pills.each(self2.updateItem);
    pills.enter().insert("div", ":scope > .sja_filter_paren_close").attr("class", "sja_filter_item").each(self2.addItem);
    select_default(this).selectAll(":scope > .sja_filter_item").sort((a, b) => data.indexOf(a) - data.indexOf(b));
    if (self2.dom.last_join_label) {
      self2.dom.last_join_div.datum(filter2);
      this.insertBefore(self2.dom.last_join_div.node(), select_default(this).select(":scope > .sja_filter_paren_close").node());
      self2.dom.last_join_label.style("display", "inline");
    }
  };
  self2.removeGrp = function(item) {
    self2.numExpectedItems += 1;
    if (item.type == "tvslst") {
      for (const subitem of item.lst) {
        if (subitem.lst) self2.removeGrp(subitem);
        else {
          delete self2.pills[subitem.$id];
        }
      }
    } else {
      delete self2.pills[item.$id];
    }
    if (this instanceof Node) {
      select_default(this).selectAll("*").on("click", null);
      select_default(this).on("click", null).remove();
    }
    self2.updatePromise();
  };
  self2.addItem = async function(item, i3) {
    const filter2 = this.parentNode.__data__;
    if (item.type == "tvslst") {
      self2.updateUI(select_default(this), item);
      self2.addJoinLabel(this, filter2, item);
      return;
    }
    self2.numExpectedItems += 1;
    const holder = select_default(this).style("display", "inline-block").style("position", "relative").style("white-space", "nowrap").append("div").attr("class", "sja_pill_wrapper").style("display", "inline-block").style("margin", self2.opts.joinWith.length > 1 ? "" : "2px").on("click", item.renderAs === "htmlSelect" ? null : self2.displayControlsMenu);
    self2.addJoinLabel(this, filter2, item);
    if (item.renderAs == "htmlSelect") {
      const values = getValuesForHtmlSelect(self2, item);
      const selectElem = holder.append("select").on("change", function() {
        const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
        const filterCopy = findItem(filterUiRoot, filter2.$id);
        const i4 = filter2.lst.indexOf(item);
        if (i4 == -1) return;
        const index = +this.value;
        const itemCopy = JSON.parse(JSON.stringify(item));
        const keys = "keys" in values[index] ? values[index].keys : [values[index].key];
        itemCopy.tvs.values = keys.map((key) => {
          return { key, label: key };
        });
        filterCopy.lst[i4] = itemCopy;
        self2.refresh(filterUiRoot);
      });
      const defaultVal = getDefaultValueForHtmlSelect(self2, item);
      selectElem.selectAll("option").data(values).enter().append("option").property("value", (d, i4) => i4).property("selected", (d, i4) => i4 == defaultVal).html((d) => d.shortLabel ? d.shortLabel : d.label ? d.label : d.key);
    } else {
      const pill = await TVSInit({
        vocabApi: self2.vocabApi,
        holder,
        debug: self2.opts.debug,
        getCategoriesArguments: self2.opts.getCategoriesArguments,
        isMafFilter: self2.opts.isMafFilter,
        callback: (tvs) => {
          const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
          const filterCopy = findItem(filterUiRoot, filter2.$id);
          const i4 = filter2.lst.indexOf(item);
          if (i4 == -1) return;
          const item_i = filterCopy.lst.findIndex((t2) => t2.$id == item.$id);
          if (item_i == -1) filterCopy.lst[i4] = { $id: item.$id, type: "tvs", tvs };
          else filterCopy.lst[item_i].tvs = tvs;
          self2.refresh(filterUiRoot);
        }
      });
      self2.pills[item.$id] = pill;
      await pill.main({ tvs: item.tvs, filter: self2.getFilterExcludingPill(item.$id) });
    }
    self2.updatePromise();
  };
  self2.updateItem = async function(item, i3) {
    const filter2 = this.parentNode.__data__;
    select_default(this).select(":scope > .sja_filter_join_label").style(
      "display",
      self2.opts.joinWith.length > 1 && filter2.lst.indexOf(item) < filter2.lst.length - 1 ? "inline-block" : "none"
    ).style("margin", self2.opts.joinWith.length > 1 ? "" : "2px").html(filter2.join == "and" ? "AND" : "OR");
    if (item.type == "tvslst") {
      self2.updateUI(select_default(this), item);
    } else if (item.renderAs === "htmlSelect") {
      self2.numExpectedItems += 1;
      select_default(this).select("select").property("value", "" + getDefaultValueForHtmlSelect(self2, item));
    } else {
      if (!self2.pills[item.$id]) return;
      self2.numExpectedItems += 1;
      await self2.pills[item.$id].main({ tvs: item.tvs, filter: self2.getFilterExcludingPill(item.$id) });
    }
    self2.updatePromise();
  };
  self2.removeItem = function(item) {
    delete self2.pills[item.$id];
    select_default(this).on("click", null).remove();
  };
  self2.addJoinLabel = function(elem, filter2, item) {
    const i3 = filter2.lst.findIndex((d) => d.$id === item.$id);
    select_default(elem).append("div").attr("class", "sja_filter_join_label").style(
      "display",
      self2.opts.joinWith.length > 1 && filter2.lst.length > 1 && item && i3 != -1 && i3 < filter2.lst.length - 1 ? "inline-block" : "none"
    ).style("width", "50px").style("padding", "5px").style("border", "none").style("border-radius", "5px").style("text-align", "center").style("cursor", "pointer").html(filter2.lst.length < 2 ? "" : filter2.join == "and" ? "AND" : "OR").on("click", self2.displayControlsMenu);
  };
  self2.updateJoinLabel = function(item) {
    const filter2 = this.parentNode.parentNode.parentNode.__data__;
    const i3 = filter2.lst.findIndex((d) => d.$id === item.$id);
    select_default(this).style(
      "display",
      self2.opts.joinWith.length > 1 && filter2.lst.length > 1 && item && i3 != -1 && i3 < filter2.lst.length - 1 ? "inline-block" : "none"
    );
  };
  self2.getAddTransformerBtnDisplay = function(d) {
    if (self2.opts.joinWith.length < 2) {
      return "none";
    } else if (self2.filter && self2.filter.lst.find((f) => f.tag === "cohortFilter")) {
      return self2.filter.lst.length == 1 && d == "and" ? "inline-block" : "none";
    } else {
      return self2.filter && self2.filter.lst.length > 0 && (self2.filter.join !== d || !self2.filter.in) ? "inline-block" : "none";
    }
  };
}
function getValuesForHtmlSelect(self2, item) {
  return item.selectOptionsFrom == "selectCohort" ? self2.opts.termdbConfig.selectCohort.values : Array.isArray(item.tvs.term.values) ? item.tvs.term.values : Object.values(item.tvs.term.values);
}
function getDefaultValueForHtmlSelect(self2, item) {
  const values = getValuesForHtmlSelect(self2, item);
  const defaultKey = JSON.stringify(item.tvs.values.map((o) => o.key).sort());
  const i3 = values.findIndex((d) => d.keys ? defaultKey === JSON.stringify(d.keys.sort()) : d.key === defaultKey);
  return i3;
}

// filter/filter.interactivity.js
var MENU_OPTION_HIGHLIGHT_COLOR = "#fff";
function setInteractivity6(self2) {
  self2.displayControlsMenu = function(event2) {
    event2.stopPropagation();
    if (!self2.activeData) return;
    const item = this.parentNode.__data__;
    const filter2 = findParent(self2.filter, item.$id);
    self2.activeData = { item, filter: filter2, elem: this };
    self2.removeBlankPill();
    self2.resetGrpHighlights(this, filter2);
    if (item.noEdit)
      self2.dom.table.selectAll("tr").filter((d) => d.action == "edit").style("display", "none");
    if (item.tvs?.term.type == "cohort")
      self2.dom.table.selectAll("tr").filter((d) => d.action == "edit" || d.action == "negate").style("display", "none");
    self2.dom.controlsTip.showunder(this);
  };
  self2.resetGrpHighlights = function(elem, filter2) {
    const cls = elem.className;
    const grpAction = cls.includes("join") || cls.includes("negate") || cls.includes("paren");
    const menuRows = self2.dom.controlsTip.d.selectAll("tr").style("background-color", "");
    menuRows.filter((d) => d.action == "edit" || d.action == "replace").style("display", grpAction ? "none" : "table-row");
    menuRows.filter((d) => (
      /*d.action == 'negate' ||*/
      d.action == "remove"
    )).style("display", cls.includes("_join_") && filter2.lst.find((d) => d.tag == "cohortFilter") ? "none" : "table-row");
    menuRows.filter((d) => d.action == "join").style(
      "display",
      self2.opts.joinWith.length < 2 || filter2.$id == self2.filter.$id && filter2.lst.length == 1 || cls.includes("negate") || cls.includes("paren") ? "none" : "table-row"
    ).select("td:nth-child(2)").html(grpAction ? filter2.join.toUpperCase() : filter2.join == "and" ? "OR" : "AND");
    menuRows.filter((d) => d.action == "switch").style(
      "display",
      self2.opts.joinWith.length < 2 || filter2.$id == self2.filter.$id && filter2.lst.length == 1 || !cls.includes("_join_") ? "none" : "table-row"
    ).select("td:nth-child(2)").html((d) => filter2.join == "and" ? "Switch to OR" : "Switch to AND");
    self2.dom.filterContainer.selectAll(".sja_filter_grp").style("background-color", "transparent");
    if (grpAction) {
      if (cls.includes("join")) elem.parentNode.parentNode.style.backgroundColor = "#ee5";
      else elem.parentNode.style.backgroundColor = "#ee5";
    }
  };
  self2.handleMenuOptionClick = async function(event2, d) {
    event2.stopPropagation();
    if (d == self2.activeData.menuOpt) return;
    self2.activeData.menuOpt = d;
    if (self2.activeData.elem.className.includes("join") && d.action !== "join" && d.action != "switch") {
      self2.activeData.item = self2.activeData.filter;
      self2.activeData.filter = findParent(self2.filter, self2.activeData.item);
    }
    self2.resetBlankPill(d.action);
    self2.dom.controlsTip.d.selectAll("tr").style("background-color", "");
    await d.handler(this, d);
  };
  self2.resetBlankPill = function(action) {
    self2.removeBlankPill();
    self2.dom.filterContainer.selectAll(".sja_filter_grp").style("background-color", "transparent");
    if (action != "join") return;
    const elem = self2.dom.last_join_div ? self2.dom.last_join_div.node() : self2.activeData.elem.className.includes("join_label") ? self2.activeData.elem.parentNode.parentNode : self2.activeData.item.type == "tvs" || self2.activeData.filter === self2.filter ? self2.activeData.elem : self2.activeData.elem.parentNode.parentNode;
    const joiner = self2.opts.joinWith.length === 1 ? self2.opts.joinWith[0].toUpperCase() : self2.activeData.elem.className.includes("join_label") ? self2.activeData.filter.join.toUpperCase() : self2.activeData.btn && typeof self2.activeData.btn.__data__ === "string" ? self2.activeData.btn.__data__.toUpperCase() : self2.activeData.item.type == "tvslst" ? self2.activeData.filter.join.toUpperCase() : self2.activeData.filter.join == "or" ? "AND" : "OR";
    if (self2.activeData.item.type == "tvs" && //&& self.activeData.filter != self.filter
    !self2.activeData.elem.className.includes("join_label")) {
      select_default(elem).insert("div", "div").attr("class", "sja_filter_paren_open").style("display", self2.opts.joinWith.length > 1 ? "inline-block" : "none").style("padding", "0 5px").style("font-weight", 500).style("font-size", "24px").style("cursor", "pointer").html("(");
    }
    const blank = select_default(elem).insert("div", ":scope > .sja_filter_paren_close").attr("class", "sja_filter_blank_pill").style("display", "inline-block").style("height", "20px").style("overflow", "visible");
    blank.append("div").style("display", "inline-block").style("width", "50px").style("text-align", "center").html(joiner);
    blank.append("div").style("position", "relative").style("top", "-7px").style("display", "inline-block").style("width", "80px").style("height", "22px").style("margin-right", "5px").style("border", "3px dashed #b8d3ea").style("vertical-align", "top").style("background-color", "#ee5");
    if (self2.activeData.item.type == "tvs" && //&& self.activeData.filter != self.filter
    !self2.activeData.elem.className.includes("join_label")) {
      select_default(elem).append("div").attr("class", "sja_filter_paren_close").style("display", self2.opts.joinWith.length > 1 ? "inline-block" : "none").style("padding", "0 5px").style("font-weight", 500).style("font-size", "24px").style("cursor", "pointer").html(")");
    }
    if (elem == self2.dom.filterContainer.node()) {
      self2.dom.filterContainer.selectAll(
        ":scope > .sja_filter_grp > .sja_filter_paren_open, :scope > .sja_filter_grp > .sja_filter_paren_close"
      ).style("display", self2.opts.joinWith.length > 1 && self2.filter.lst.length > 1 ? "inline-block" : "none");
    }
  };
  self2.removeBlankPill = function() {
    self2.dom.holder?.selectAll(
      ".sja_filter_blank_pill, .sja_pill_wrapper > .sja_filter_paren_open, .sja_pill_wrapper > .sja_filter_paren_close"
    ).remove();
    if (self2.filter.in && self2.filter.lst.filter((f) => f.type === "tvslst").length < 1) {
      self2.dom.filterContainer?.selectAll(
        ":scope > .sja_filter_grp > .sja_filter_paren_open, :scope > .sja_filter_grp > .sja_filter_paren_close"
      ).style("display", "none");
    }
  };
  self2.displayTreeNew = async function(event2, d) {
    event2.stopPropagation();
    if (self2.opts.newBtn && this.className !== "sja_filter_add_transformer" && self2.filter.lst.length) return;
    self2.dom.filterContainer.selectAll(".sja_filter_grp").style("background-color", "transparent");
    if (self2.filter.lst.length > 0) {
      self2.activeData = {
        item: self2.filter,
        filter: self2.filter,
        elem: self2.dom.filterContainer.node(),
        //.select(':scope > .sja_filter_grp').node()
        btn: this
      };
    }
    if (self2.filter.lst.length) self2.resetBlankPill("join");
    const blankPill = self2.dom.filterContainer.select(".sja_filter_blank_pill").node();
    if (blankPill) {
      self2.dom.holder.selectAll(".sja_filter_add_transformer").style("display", "none");
      self2.dom.treeTip.clear().showunder(blankPill);
    } else {
      self2.dom.treeTip.clear().showunder(this);
    }
    const treeFilter = self2.getTreeFilter(d);
    const termdb = await import("./app-2NSQK3GQ.js");
    termdb.appInit({
      vocabApi: self2.vocabApi,
      holder: self2.dom.termSrcDiv,
      getCategoriesArguments: self2.opts.getCategoriesArguments,
      isMafFilter: self2.opts.isMafFilter,
      state: {
        activeCohort: self2.activeCohort,
        termfilter: { filter: treeFilter },
        tree: { usecase: { target: "filter" } },
        nav: { header_mode: self2.opts.header_mode }
      },
      tree: {
        disable_terms: self2.activeData && self2.activeData.filter && self2.activeData.filter.lst && d == "and" ? self2.activeData.filter.lst.filter((d2) => d2.type === "tvs" && d2.tvs.term.type !== "condition").map((d2) => d2.tvs.term) : [],
        click_term2select_tvs(tvs) {
          self2.editFilterRoot(d, [{ type: "tvs", tvs }]);
        }
      }
    });
  };
  self2.getTreeFilter = (join, filter2) => {
    const filterCopy = filter2 ? filter2 : self2.activeData ? self2.getAdjustedRoot(self2.activeData.filter.$id, join) : JSON.parse(self2.rawCopy);
    if (filterCopy.lst.length < 2) filterCopy.join = "";
    const globalFilter = self2.opts?.app?.getState()?.termfilter?.filter;
    return globalFilter && join != "or" ? filterJoin([filterCopy, globalFilter]) : filterCopy;
  };
  self2.editFilterRoot = (d, tvslst) => {
    const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
    if (!filterUiRoot.lst.length) {
      if (tvslst.length > 1) filterUiRoot.join = "and";
      filterUiRoot.lst.push(...tvslst);
      self2.refresh(filterUiRoot);
    } else if (d != "or" && d != "and") {
      throw "unhandled new term(s): invalid appender join value";
    } else {
      if (!filterUiRoot.join) filterUiRoot.join = d;
      if (filterUiRoot.join == d && filterUiRoot.in) {
        if (tvslst.length < 2 || filterUiRoot.join == "and") {
          filterUiRoot.lst.push(...tvslst);
        } else {
          filterUiRoot.push({
            type: "tvslst",
            in: true,
            join: "and",
            lst: tvslst
          });
        }
        self2.refresh(filterUiRoot);
      } else if (d == "and" || tvslst.length < 2) {
        delete filterUiRoot.tag;
        self2.refresh({
          tag: "filterUiRoot",
          type: "tvslst",
          in: true,
          join: d,
          lst: [filterUiRoot, ...tvslst]
        });
      } else {
        delete filterUiRoot.tag;
        self2.refresh({
          tag: "filterUiRoot",
          type: "tvslst",
          in: true,
          join: "or",
          lst: [
            filterUiRoot,
            {
              type: "tvslst",
              in: true,
              join: "and",
              lst: tvslst
            }
          ]
        });
      }
    }
  };
  self2.displayTreeMenu = async function(elem, d) {
    select_default(elem).style("background-color", MENU_OPTION_HIGHLIGHT_COLOR);
    self2.dom.holder.selectAll(".sja_filter_add_transformer").style("display", "none");
    const blankPill = self2.dom.filterContainer.select(".sja_filter_blank_pill").node();
    if (blankPill) {
      self2.dom.controlsTip.hide();
      self2.dom.treeTip.clear().showunder(blankPill);
    } else if (elem.lastChild instanceof HTMLElement) {
      self2.dom.treeTip.clear().showunderoffset(elem.lastChild);
    } else {
      self2.dom.treeTip.clear().showunder(elem);
    }
    const filter2 = self2.getTreeFilter(d, self2.activeData.filter);
    const termdb = await import("./app-2NSQK3GQ.js");
    termdb.appInit({
      vocabApi: self2.vocabApi,
      holder: self2.dom.termSrcDiv,
      getCategoriesArguments: self2.opts.getCategoriesArguments,
      isMafFilter: self2.opts.isMafFilter,
      state: {
        activeCohort: self2.activeCohort,
        nav: { header_mode: self2.opts.header_mode || "search_only" },
        termfilter: { filter: self2.getAdjustedRoot(filter2.$id, filter2.join) },
        tree: { usecase: { target: "filter" } }
      },
      tree: {
        disable_terms: filter2 && filter2.lst && filter2.join == "and" ? filter2.lst.filter((d2) => d2.type === "tvs" && d2.tvs.term.type !== "condition").map((d2) => d2.tvs.term) : !self2.activeData.item ? [] : self2.activeData.item.type == "tvs" ? [self2.activeData.item.tvs.term] : self2.activeData.item.lst ? self2.activeData.item.lst.filter((f) => f.type == "tvs").map((f) => f.tvs.term) : [],
        click_term2select_tvs: d.action == "replace" ? self2.replaceTerm : !filter2.join || !filter2.lst.length || self2.activeData.elem && self2.activeData.elem.className.includes("join") ? self2.appendTerm : self2.subnestFilter
      }
    });
  };
  self2.editTerm = function(elem) {
    select_default(elem.parentNode).selectAll("tr").style("background-color", self2.highlightEditRow);
    const holder = self2.dom.termSrcDiv;
    const item = self2.activeData.item;
    self2.dom.treeTip.clear();
    self2.pills[item.$id].showMenu(holder);
    self2.dom.treeTip.showunderoffset(elem.lastChild);
  };
  self2.highlightEditRow = function(d) {
    return d.action == "edit" ? MENU_OPTION_HIGHLIGHT_COLOR : "";
  };
  self2.handleNotLabelClick = function(event2, d) {
    self2.activeData = {
      item: this.__data__
    };
    self2.negateClause();
  };
  self2.negateClause = function() {
    const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
    const item = findItem(filterUiRoot, self2.activeData.item.$id);
    if (item.type == "tvslst") item.in = !item.in;
    else if (item.type == "tvs" && item.tvs?.term?.type == "geneVariant") {
      const modifiedGrp = item.tvs.values.filter((v) => v.mclassExcludeLst.length > 0)[0];
      const tmp = modifiedGrp.mclassLst;
      modifiedGrp.mclassLst = modifiedGrp.mclassExcludeLst;
      modifiedGrp.mclassExcludeLst = tmp;
      item.tvs.isnot = !item.tvs.isnot;
    } else item.tvs.isnot = !item.tvs.isnot;
    self2.refresh(filterUiRoot);
  };
  self2.replaceTerm = (_tvs_) => {
    const tvslst = Array.isArray(_tvs_) ? _tvs_ : [{ type: "tvs", tvs: _tvs_ }];
    const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
    const filterCopy = findItem(filterUiRoot, self2.activeData.filter.$id);
    const i3 = filterCopy.lst.findIndex((t2) => t2.$id === self2.activeData.item.$id);
    if (tvslst.length < 2 || filterCopy.join == "and") {
      filterCopy.lst.splice(i3, 1, ...tvslst);
    } else {
      filterCopy.lst[i3] = {
        // transform from tvs to tvslst
        in: !_tvs_.isnot,
        type: "tvslst",
        join: "and",
        lst: tvslst
      };
    }
    self2.refresh(filterUiRoot);
  };
  self2.appendTerm = (_tvs_) => {
    const tvslst = Array.isArray(_tvs_) ? _tvs_ : [{ type: "tvs", tvs: _tvs_ }];
    const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
    const filterCopy = findItem(filterUiRoot, self2.activeData.filter.$id);
    if (tvslst.length < 2 || filterCopy.join == "and") {
      filterCopy.lst.push(...tvslst);
      if (filterCopy.join == "" && self2.opts.joinWith.length === 1) filterCopy.join = self2.opts.joinWith[0];
    } else {
      filterCopy.lst.push({
        // transform from tvs to tvslst
        in: true,
        type: "tvslst",
        join: "and",
        lst: tvslst
      });
    }
    self2.refresh(filterUiRoot);
  };
  self2.subnestFilter = (t2) => {
    let tvslst;
    if (Array.isArray(t2)) {
      tvslst = t2;
    } else {
      tvslst = [{ type: "tvs", tvs: t2 }];
    }
    const item = self2.activeData.item;
    const filter2 = self2.activeData.filter;
    const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
    const filterCopy = findItem(filterUiRoot, filter2.$id);
    const i3 = filterCopy.lst.findIndex((t3) => t3.$id === item.$id);
    filterCopy.lst[i3] = {
      in: true,
      type: "tvslst",
      join: filter2.join == "or" ? "and" : "or",
      lst: [item, ...tvslst]
    };
    self2.refresh(filterUiRoot);
  };
  self2.removeTransform = function(elem, t2) {
    const item = t2.action || typeof t2 !== "object" ? self2.activeData.item : findItem(self2.filter, t2.$id);
    const filter2 = findParent(self2.filter, item.$id);
    if (item == filter2) {
      self2.refresh(getWrappedTvslst([], "", item.$id));
      return;
    }
    const i3 = filter2.lst.findIndex((t3) => t3.$id === item.$id);
    if (i3 == -1) return;
    const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
    const filterCopy = findItem(filterUiRoot, filter2.$id);
    filterCopy.lst.splice(i3, 1);
    if (filterCopy.lst.length === 1) {
      const parent = findParent(filterUiRoot, filterCopy.$id);
      if (filterCopy.lst[0].type == "tvslst") {
        if (parent == filterUiRoot) {
          filterCopy.lst[0].tag = "filterUiRoot";
          self2.refresh(filterCopy.lst[0]);
        } else {
          const j = parent.lst.findIndex((t3) => t3.$id == filterCopy.$id);
          if (filterCopy.lst[0].join == parent.join) {
            parent.lst.splice(j, 1, ...filterCopy.lst[0].lst);
            self2.refresh(filterUiRoot);
          } else {
            parent.lst[j] = filterCopy.lst[0];
            self2.refresh(filterUiRoot);
          }
        }
      } else {
        filterCopy.join = "";
        const j = parent.lst.findIndex((t3) => t3.$id === filterCopy.$id);
        parent.lst[j] = filterCopy.lst[0];
        if (!filterCopy.in) {
          parent.lst[j].tvs.isnot = !parent.lst[j].tvs.isnot;
          if (parent == filterUiRoot) parent.in = true;
        }
        self2.refresh(filterUiRoot);
      }
    } else {
      self2.refresh(filterUiRoot);
    }
  };
  self2.showLastJoinBlank = function(event2, d) {
    event2.stopPropagation();
    const elem = self2.dom.last_join_div.node();
    self2.dom.last_join_label.style("display", "none");
    const filter2 = this.parentNode.__data__;
    self2.activeData = { item: filter2, filter: filter2, elem };
    self2.resetBlankPill(d.action);
    self2.displayTreeMenu(elem, d);
  };
  self2.switchJoin = function(event2, d) {
    const filterUiRoot = JSON.parse(JSON.stringify(self2.filter));
    const filterCopy = findItem(filterUiRoot, self2.activeData.filter.$id);
    if (filterCopy.join < 2) return;
    filterCopy.join = filterCopy.join == "and" ? "or" : "and";
    self2.refresh(filterUiRoot);
  };
}

// filter/FilterClass.js
var defaults = deepFreeze({
  joinWith: ["and", "or"]
});
var Filter = class {
  constructor(opts) {
    this.opts = this.validateOpts(opts);
    const parent_menu = this.opts.holder.node()?.closest(".sja_menu_div");
    const controlsTip = new Menu({
      padding: "0px",
      parent_menu
    });
    this.dom = {
      holder: opts.holder,
      controlsTip,
      treeTip: new Menu({
        padding: "5px",
        offsetX: 20,
        offsetY: -34,
        clearSelector: ".sja_term_src_body",
        parent_menu: controlsTip.d.node(),
        ancestor_menus: [parent_menu]
      })
    };
    this.durations = { exit: 500 };
    this.lastId = 0;
    this.categoryData = {};
    this.pills = {};
    setInteractivity6(this);
    setRenderers11(this);
    this.initUI();
    this.filter = {
      type: "tvslst",
      tag: "filterUiRoot",
      join: "and",
      in: true,
      lst: []
    };
    this.promises = {};
  }
  validateOpts(opts) {
    const o = Object.assign({}, defaults, opts);
    if (!o.holder) throw ".holder missing";
    if (o.vocabApi) {
      this.vocabApi = o.vocabApi;
    } else {
      if (!o.vocab) throw ".vocab missing";
      if (o.vocab.dslabel) {
        if (!o.vocab.genome) throw "vocab.genome missing";
      } else {
        if (!o.vocab.terms) throw "vocab.terms missing";
      }
    }
    if (typeof o.callback != "function") throw ".callback() is not a function";
    if (o.getVisibleRoot && typeof o.getVisibleRoot != "function")
      throw ".getVisibleRoot() must be a function if set as an option";
    if (!o.emptyLabel) o.emptyLabel = "+NEW";
    return o;
  }
  /*
  	rawCopy'' JSON-stringified rawFilter object
  	opts{}
  	.activeCohort
  */
  async main(rawCopy, opts = {}) {
    this.promises.postRender = new Promise((resolve, reject) => {
      this.mainResolve = resolve;
      this.mainReject = reject;
    });
    this.numProcessedItems = 0;
    this.numExpectedItems = 0;
    this.opts = Object.assign({}, this.opts, opts);
    this.activeCohort = this.opts.activeCohort;
    this.rawCopy = rawCopy;
    this.rawFilter = JSON.parse(this.rawCopy);
    this.validateFilter(this.rawFilter);
    this.filter = getFilterItemByTag(this.rawFilter, "filterUiRoot");
    if (!this.filter) {
      this.filter = this.rawFilter;
      this.filter.tag = "filterUiRoot";
    }
    await this.resetActiveData(this.filter);
    this.removeBlankPill();
    this.dom.newBtn.style("display", this.opts.newBtn ? "" : this.filter.lst.length == 0 ? "inline-block" : "none");
    this.dom.holder.selectAll(".sja_filter_add_transformer").style("display", this.getAddTransformerBtnDisplay);
    this.setVocabApi();
    this.updateUI(this.dom.filterContainer, this.filter);
    return this.promises.postRender;
  }
  validateFilter(item) {
    if (!("$id" in item)) item.$id = this.lastId++;
    else if (this.lastId <= item.$id) this.lastId = item.$id + 1;
    if (!("type" in item)) throw "missing filter.type";
    if (item.type != "tvs" && item.type != "tvslst") throw "invalid filter.type";
    if (item.type != "tvslst") return;
    if (!Array.isArray(item.lst)) throw "invalid or missing filter.lst[]";
    if (item.lst.length > 1) {
      if (item.join != "and" && item.join != "or") throw "invalid filter.join value for lst.length > 1";
    } else if (item.join !== "") {
      throw "filter.join must be an empty string when lst.length < 2";
    }
    if (!item.lst.length) item.in = true;
    for (const [i3, subitem] of item.lst.entries()) {
      this.validateFilter(subitem);
    }
  }
  resetActiveData(filter2) {
    if (this.dom.controlsTip.d.style("display") == "none") {
      this.activeData = { item: {}, filter: {} };
    } else {
      this.activeData = {
        item: findItem(filter2, this.activeData.item.$id),
        filter: findItem(filter2, this.activeData.filter.$id),
        menuOpt: this.activeData.menuOpt
      };
    }
  }
  refresh(filterUiRoot) {
    this.dom.controlsTip.hide();
    this.dom.treeTip.hide();
    const rootCopy = JSON.parse(JSON.stringify(this.rawFilter));
    delete rootCopy.tag;
    filterUiRoot.tag = "filterUiRoot";
    const rawParent = findParent(rootCopy, this.filter.$id);
    if (!rawParent || this.rawFilter.$id === this.filter.$id) {
      this.api.main(filterUiRoot);
      this.opts.callback(filterUiRoot);
    } else {
      const i3 = rawParent.lst.findIndex((f) => f.$id == this.filter.$id);
      rawParent.lst[i3] = filterUiRoot;
      this.api.main(rootCopy);
      this.opts.callback(filterUiRoot);
    }
  }
  getId(item) {
    return item.$id;
  }
  // The method below is used to get correct categories + sample counts in the pill edit menu,
  // so that all values of the pill term, including filtered-out values, will still show up
  // as checkbox inputs/range option. The other filter data entries will still be applied.
  getFilterExcludingPill($id2) {
    const rootCopy = JSON.parse(JSON.stringify(this.rawFilter));
    const parentCopy = findParent(rootCopy, $id2);
    const i3 = parentCopy.lst.findIndex((f) => f.$id === $id2);
    if (i3 == -1) return null;
    parentCopy.lst.splice(i3, 1);
    if (parentCopy.lst.length < 2) parentCopy.join = "";
    const globalFilter = this.state?.globalFilter || this.app?.getState().termfilter?.filter;
    if (!globalFilter) return rootCopy;
    if (deepEqual(getNormalRoot(this.rawFilter), getNormalRoot(globalFilter))) return rootCopy;
    return getNormalRoot(filterJoin([rootCopy, globalFilter]));
  }
  getAdjustedRoot($id2, join) {
    const rootCopy = JSON.parse(JSON.stringify(this.rawFilter));
    if (join == "and") return rootCopy;
    const cohortFilter = getFilterItemByTag(rootCopy, "cohortFilter");
    const parentCopy = findParent(rootCopy, $id2);
    if (!parentCopy) {
      return { type: "tvslst", in: true, join: "and", lst: cohortFilter ? [cohortFilter] : [] };
    }
    const i3 = parentCopy.lst.findIndex((f) => f.$id === parentCopy.$id);
    if (i3 == -1) return { type: "tvslst", in: true, join: "and", lst: cohortFilter ? [cohortFilter] : [] };
    parentCopy.lst.splice(i3, 1);
    if (cohortFilter && !parentCopy.lst.find((d) => d === cohortFilter)) {
      return getNormalRoot({
        type: "tvslst",
        join: "and",
        lst: [cohortFilter, parentCopy]
      });
    }
    return getNormalRoot(parentCopy);
  }
  setVocabApi() {
    if (!this.vocabApi) {
      const app = {
        getState: () => {
          const filter2 = JSON.parse(this.rawCopy);
          const cohortFilter = getFilterItemByTag(filter2, "cohortFilter");
          if (cohortFilter && this.opts.termdbConfig) {
            cohortFilter.tvs.values = this.activeCohort == -1 || this.activeCohort === void 0 ? [] : this.opts.termdbConfig.selectCohort.values[this.activeCohort].keys.map((key) => {
              return { key, label: key };
            });
          }
          return {
            vocab: this.opts.vocab,
            termfilter: { filter: filter2 },
            tree: { plots: {} }
          };
        }
      };
      const state = app.getState();
      const vocab = state.vocab || {
        genome: state.genome,
        dslabel: state.dslabel
      };
      if (!this.vocabApi) {
        this.vocabApi = vocabInit({
          app,
          state: { vocab }
        });
      }
    }
    this.vocabApi.main();
  }
  updatePromise = function(incr = 1) {
    if (!this.mainResolve) return;
    this.numProcessedItems += incr;
    if (this.numExpectedItems == this.numProcessedItems) {
      this.mainResolve();
      if (this.bus) this.bus.emit("postRender");
      delete this.mainResolve;
    }
  };
  destroy() {
    this.dom.holder.remove();
    this.dom.controlsTip.destroy();
    this.dom.treeTip.destroy();
  }
};

// filter/FilterStateless.js
var FilterStateless = class extends Filter {
  constructor(opts) {
    super(opts);
    this.api = {
      // make sure to bind the 'this' context to the filter instance
      // instead of to the this.api object
      main: this.main.bind(this),
      /*
      				WARNING!!!
      				When using this filter.api.getNormalRoot(),
      				make sure this instance has been updated before the caller,
      				otherwise the normalized root will be stale
      
      				or for reliability, import getNormalRoot() directly 
      				from the common/filter.js component and supply the 
      				caller's known raw filter state
      			*/
      getNormalRoot: () => getNormalRoot(this.rawFilter),
      getPromise: (name) => this.promises[name],
      destroy: () => this.destroy()
    };
    if (opts.callbacks) {
      this.events = ["postInit", "postRender", "firstRender"];
      this.bus = new Bus(this.api, this.events, opts.callbacks);
    }
  }
  async main(rawFilter, opts = {}) {
    this.dom.controlsTip.hide();
    this.dom.treeTip.hide();
    const activeCohort = "activeCohort" in opts ? opts.activeCohort : this.activeCohort;
    const rawCopy = JSON.stringify(rawFilter);
    if (this.rawCopy == rawCopy && JSON.stringify(this.activeCohort) == JSON.stringify(activeCohort)) return;
    await super.main(rawCopy, opts);
  }
};
var filterInit = getInitFxn(FilterStateless);

// ../node_modules/html-to-image/es/util.js
function resolveUrl(url, baseUrl) {
  if (url.match(/^[a-z]+:\/\//i)) {
    return url;
  }
  if (url.match(/^\/\//)) {
    return window.location.protocol + url;
  }
  if (url.match(/^[a-z]+:/i)) {
    return url;
  }
  const doc = document.implementation.createHTMLDocument();
  const base = doc.createElement("base");
  const a = doc.createElement("a");
  doc.head.appendChild(base);
  doc.body.appendChild(a);
  if (baseUrl) {
    base.href = baseUrl;
  }
  a.href = url;
  return a.href;
}
var uuid = /* @__PURE__ */ (() => {
  let counter = 0;
  const random = () => (
    // eslint-disable-next-line no-bitwise
    `0000${(Math.random() * 36 ** 4 << 0).toString(36)}`.slice(-4)
  );
  return () => {
    counter += 1;
    return `u${random()}${counter}`;
  };
})();
function toArray(arrayLike) {
  const arr = [];
  for (let i3 = 0, l = arrayLike.length; i3 < l; i3++) {
    arr.push(arrayLike[i3]);
  }
  return arr;
}
var styleProps = null;
function getStyleProperties(options = {}) {
  if (styleProps) {
    return styleProps;
  }
  if (options.includeStyleProperties) {
    styleProps = options.includeStyleProperties;
    return styleProps;
  }
  styleProps = toArray(window.getComputedStyle(document.documentElement));
  return styleProps;
}
function px(node, styleProperty) {
  const win = node.ownerDocument.defaultView || window;
  const val = win.getComputedStyle(node).getPropertyValue(styleProperty);
  return val ? parseFloat(val.replace("px", "")) : 0;
}
function getNodeWidth(node) {
  const leftBorder = px(node, "border-left-width");
  const rightBorder = px(node, "border-right-width");
  return node.clientWidth + leftBorder + rightBorder;
}
function getNodeHeight(node) {
  const topBorder = px(node, "border-top-width");
  const bottomBorder = px(node, "border-bottom-width");
  return node.clientHeight + topBorder + bottomBorder;
}
function getImageSize(targetNode, options = {}) {
  const width = options.width || getNodeWidth(targetNode);
  const height = options.height || getNodeHeight(targetNode);
  return { width, height };
}
function getPixelRatio() {
  let ratio;
  let FINAL_PROCESS;
  try {
    FINAL_PROCESS = process;
  } catch (e) {
  }
  const val = FINAL_PROCESS && FINAL_PROCESS.env ? FINAL_PROCESS.env.devicePixelRatio : null;
  if (val) {
    ratio = parseInt(val, 10);
    if (Number.isNaN(ratio)) {
      ratio = 1;
    }
  }
  return ratio || window.devicePixelRatio || 1;
}
var canvasDimensionLimit = 16384;
function checkCanvasDimensions(canvas) {
  if (canvas.width > canvasDimensionLimit || canvas.height > canvasDimensionLimit) {
    if (canvas.width > canvasDimensionLimit && canvas.height > canvasDimensionLimit) {
      if (canvas.width > canvas.height) {
        canvas.height *= canvasDimensionLimit / canvas.width;
        canvas.width = canvasDimensionLimit;
      } else {
        canvas.width *= canvasDimensionLimit / canvas.height;
        canvas.height = canvasDimensionLimit;
      }
    } else if (canvas.width > canvasDimensionLimit) {
      canvas.height *= canvasDimensionLimit / canvas.width;
      canvas.width = canvasDimensionLimit;
    } else {
      canvas.width *= canvasDimensionLimit / canvas.height;
      canvas.height = canvasDimensionLimit;
    }
  }
}
function createImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      img.decode().then(() => {
        requestAnimationFrame(() => resolve(img));
      });
    };
    img.onerror = reject;
    img.crossOrigin = "anonymous";
    img.decoding = "async";
    img.src = url;
  });
}
async function svgToDataURL(svg) {
  return Promise.resolve().then(() => new XMLSerializer().serializeToString(svg)).then(encodeURIComponent).then((html) => `data:image/svg+xml;charset=utf-8,${html}`);
}
async function nodeToDataURL(node, width, height) {
  const xmlns = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(xmlns, "svg");
  const foreignObject = document.createElementNS(xmlns, "foreignObject");
  svg.setAttribute("width", `${width}`);
  svg.setAttribute("height", `${height}`);
  svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
  foreignObject.setAttribute("width", "100%");
  foreignObject.setAttribute("height", "100%");
  foreignObject.setAttribute("x", "0");
  foreignObject.setAttribute("y", "0");
  foreignObject.setAttribute("externalResourcesRequired", "true");
  svg.appendChild(foreignObject);
  foreignObject.appendChild(node);
  return svgToDataURL(svg);
}
var isInstanceOfElement = (node, instance) => {
  if (node instanceof instance)
    return true;
  const nodePrototype = Object.getPrototypeOf(node);
  if (nodePrototype === null)
    return false;
  return nodePrototype.constructor.name === instance.name || isInstanceOfElement(nodePrototype, instance);
};

// ../node_modules/html-to-image/es/clone-pseudos.js
function formatCSSText(style) {
  const content = style.getPropertyValue("content");
  return `${style.cssText} content: '${content.replace(/'|"/g, "")}';`;
}
function formatCSSProperties(style, options) {
  return getStyleProperties(options).map((name) => {
    const value = style.getPropertyValue(name);
    const priority = style.getPropertyPriority(name);
    return `${name}: ${value}${priority ? " !important" : ""};`;
  }).join(" ");
}
function getPseudoElementStyle(className, pseudo, style, options) {
  const selector = `.${className}:${pseudo}`;
  const cssText = style.cssText ? formatCSSText(style) : formatCSSProperties(style, options);
  return document.createTextNode(`${selector}{${cssText}}`);
}
function clonePseudoElement(nativeNode, clonedNode, pseudo, options) {
  const style = window.getComputedStyle(nativeNode, pseudo);
  const content = style.getPropertyValue("content");
  if (content === "" || content === "none") {
    return;
  }
  const className = uuid();
  try {
    clonedNode.className = `${clonedNode.className} ${className}`;
  } catch (err) {
    return;
  }
  const styleElement = document.createElement("style");
  styleElement.appendChild(getPseudoElementStyle(className, pseudo, style, options));
  clonedNode.appendChild(styleElement);
}
function clonePseudoElements(nativeNode, clonedNode, options) {
  clonePseudoElement(nativeNode, clonedNode, ":before", options);
  clonePseudoElement(nativeNode, clonedNode, ":after", options);
}

// ../node_modules/html-to-image/es/mimes.js
var WOFF = "application/font-woff";
var JPEG = "image/jpeg";
var mimes = {
  woff: WOFF,
  woff2: WOFF,
  ttf: "application/font-truetype",
  eot: "application/vnd.ms-fontobject",
  png: "image/png",
  jpg: JPEG,
  jpeg: JPEG,
  gif: "image/gif",
  tiff: "image/tiff",
  svg: "image/svg+xml",
  webp: "image/webp"
};
function getExtension(url) {
  const match2 = /\.([^./]*?)$/g.exec(url);
  return match2 ? match2[1] : "";
}
function getMimeType(url) {
  const extension = getExtension(url).toLowerCase();
  return mimes[extension] || "";
}

// ../node_modules/html-to-image/es/dataurl.js
function getContentFromDataUrl(dataURL) {
  return dataURL.split(/,/)[1];
}
function isDataUrl(url) {
  return url.search(/^(data:)/) !== -1;
}
function makeDataUrl(content, mimeType) {
  return `data:${mimeType};base64,${content}`;
}
async function fetchAsDataURL(url, init, process2) {
  const res = await fetch(url, init);
  if (res.status === 404) {
    throw new Error(`Resource "${res.url}" not found`);
  }
  const blob = await res.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onloadend = () => {
      try {
        resolve(process2({ res, result: reader.result }));
      } catch (error) {
        reject(error);
      }
    };
    reader.readAsDataURL(blob);
  });
}
var cache2 = {};
function getCacheKey(url, contentType, includeQueryParams) {
  let key = url.replace(/\?.*/, "");
  if (includeQueryParams) {
    key = url;
  }
  if (/ttf|otf|eot|woff2?/i.test(key)) {
    key = key.replace(/.*\//, "");
  }
  return contentType ? `[${contentType}]${key}` : key;
}
async function resourceToDataURL(resourceUrl, contentType, options) {
  const cacheKey = getCacheKey(resourceUrl, contentType, options.includeQueryParams);
  if (cache2[cacheKey] != null) {
    return cache2[cacheKey];
  }
  if (options.cacheBust) {
    resourceUrl += (/\?/.test(resourceUrl) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime();
  }
  let dataURL;
  try {
    const content = await fetchAsDataURL(resourceUrl, options.fetchRequestInit, ({ res, result }) => {
      if (!contentType) {
        contentType = res.headers.get("Content-Type") || "";
      }
      return getContentFromDataUrl(result);
    });
    dataURL = makeDataUrl(content, contentType);
  } catch (error) {
    dataURL = options.imagePlaceholder || "";
    let msg = `Failed to fetch resource: ${resourceUrl}`;
    if (error) {
      msg = typeof error === "string" ? error : error.message;
    }
    if (msg) {
      console.warn(msg);
    }
  }
  cache2[cacheKey] = dataURL;
  return dataURL;
}

// ../node_modules/html-to-image/es/clone-node.js
async function cloneCanvasElement(canvas) {
  const dataURL = canvas.toDataURL();
  if (dataURL === "data:,") {
    return canvas.cloneNode(false);
  }
  return createImage(dataURL);
}
async function cloneVideoElement(video, options) {
  if (video.currentSrc) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = video.clientWidth;
    canvas.height = video.clientHeight;
    ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataURL2 = canvas.toDataURL();
    return createImage(dataURL2);
  }
  const poster = video.poster;
  const contentType = getMimeType(poster);
  const dataURL = await resourceToDataURL(poster, contentType, options);
  return createImage(dataURL);
}
async function cloneIFrameElement(iframe, options) {
  var _a2;
  try {
    if ((_a2 = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a2 === void 0 ? void 0 : _a2.body) {
      return await cloneNode(iframe.contentDocument.body, options, true);
    }
  } catch (_b) {
  }
  return iframe.cloneNode(false);
}
async function cloneSingleNode(node, options) {
  if (isInstanceOfElement(node, HTMLCanvasElement)) {
    return cloneCanvasElement(node);
  }
  if (isInstanceOfElement(node, HTMLVideoElement)) {
    return cloneVideoElement(node, options);
  }
  if (isInstanceOfElement(node, HTMLIFrameElement)) {
    return cloneIFrameElement(node, options);
  }
  return node.cloneNode(isSVGElement(node));
}
var isSlotElement = (node) => node.tagName != null && node.tagName.toUpperCase() === "SLOT";
var isSVGElement = (node) => node.tagName != null && node.tagName.toUpperCase() === "SVG";
async function cloneChildren(nativeNode, clonedNode, options) {
  var _a2, _b;
  if (isSVGElement(clonedNode)) {
    return clonedNode;
  }
  let children = [];
  if (isSlotElement(nativeNode) && nativeNode.assignedNodes) {
    children = toArray(nativeNode.assignedNodes());
  } else if (isInstanceOfElement(nativeNode, HTMLIFrameElement) && ((_a2 = nativeNode.contentDocument) === null || _a2 === void 0 ? void 0 : _a2.body)) {
    children = toArray(nativeNode.contentDocument.body.childNodes);
  } else {
    children = toArray(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
  }
  if (children.length === 0 || isInstanceOfElement(nativeNode, HTMLVideoElement)) {
    return clonedNode;
  }
  await children.reduce((deferred, child) => deferred.then(() => cloneNode(child, options)).then((clonedChild) => {
    if (clonedChild) {
      clonedNode.appendChild(clonedChild);
    }
  }), Promise.resolve());
  return clonedNode;
}
function cloneCSSStyle(nativeNode, clonedNode, options) {
  const targetStyle = clonedNode.style;
  if (!targetStyle) {
    return;
  }
  const sourceStyle = window.getComputedStyle(nativeNode);
  if (sourceStyle.cssText) {
    targetStyle.cssText = sourceStyle.cssText;
    targetStyle.transformOrigin = sourceStyle.transformOrigin;
  } else {
    getStyleProperties(options).forEach((name) => {
      let value = sourceStyle.getPropertyValue(name);
      if (name === "font-size" && value.endsWith("px")) {
        const reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
        value = `${reducedFont}px`;
      }
      if (isInstanceOfElement(nativeNode, HTMLIFrameElement) && name === "display" && value === "inline") {
        value = "block";
      }
      if (name === "d" && clonedNode.getAttribute("d")) {
        value = `path(${clonedNode.getAttribute("d")})`;
      }
      targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
    });
  }
}
function cloneInputValue(nativeNode, clonedNode) {
  if (isInstanceOfElement(nativeNode, HTMLTextAreaElement)) {
    clonedNode.innerHTML = nativeNode.value;
  }
  if (isInstanceOfElement(nativeNode, HTMLInputElement)) {
    clonedNode.setAttribute("value", nativeNode.value);
  }
}
function cloneSelectValue(nativeNode, clonedNode) {
  if (isInstanceOfElement(nativeNode, HTMLSelectElement)) {
    const clonedSelect = clonedNode;
    const selectedOption = Array.from(clonedSelect.children).find((child) => nativeNode.value === child.getAttribute("value"));
    if (selectedOption) {
      selectedOption.setAttribute("selected", "");
    }
  }
}
function decorate(nativeNode, clonedNode, options) {
  if (isInstanceOfElement(clonedNode, Element)) {
    cloneCSSStyle(nativeNode, clonedNode, options);
    clonePseudoElements(nativeNode, clonedNode, options);
    cloneInputValue(nativeNode, clonedNode);
    cloneSelectValue(nativeNode, clonedNode);
  }
  return clonedNode;
}
async function ensureSVGSymbols(clone, options) {
  const uses = clone.querySelectorAll ? clone.querySelectorAll("use") : [];
  if (uses.length === 0) {
    return clone;
  }
  const processedDefs = {};
  for (let i3 = 0; i3 < uses.length; i3++) {
    const use = uses[i3];
    const id3 = use.getAttribute("xlink:href");
    if (id3) {
      const exist = clone.querySelector(id3);
      const definition = document.querySelector(id3);
      if (!exist && definition && !processedDefs[id3]) {
        processedDefs[id3] = await cloneNode(definition, options, true);
      }
    }
  }
  const nodes = Object.values(processedDefs);
  if (nodes.length) {
    const ns = "http://www.w3.org/1999/xhtml";
    const svg = document.createElementNS(ns, "svg");
    svg.setAttribute("xmlns", ns);
    svg.style.position = "absolute";
    svg.style.width = "0";
    svg.style.height = "0";
    svg.style.overflow = "hidden";
    svg.style.display = "none";
    const defs = document.createElementNS(ns, "defs");
    svg.appendChild(defs);
    for (let i3 = 0; i3 < nodes.length; i3++) {
      defs.appendChild(nodes[i3]);
    }
    clone.appendChild(svg);
  }
  return clone;
}
async function cloneNode(node, options, isRoot) {
  if (!isRoot && options.filter && !options.filter(node)) {
    return null;
  }
  return Promise.resolve(node).then((clonedNode) => cloneSingleNode(clonedNode, options)).then((clonedNode) => cloneChildren(node, clonedNode, options)).then((clonedNode) => decorate(node, clonedNode, options)).then((clonedNode) => ensureSVGSymbols(clonedNode, options));
}

// ../node_modules/html-to-image/es/embed-resources.js
var URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
var URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
var FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function toRegex(url) {
  const escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${escaped})(['"]?\\))`, "g");
}
function parseURLs(cssText) {
  const urls = [];
  cssText.replace(URL_REGEX, (raw, quotation, url) => {
    urls.push(url);
    return raw;
  });
  return urls.filter((url) => !isDataUrl(url));
}
async function embed(cssText, resourceURL, baseURL, options, getContentFromUrl) {
  try {
    const resolvedURL = baseURL ? resolveUrl(resourceURL, baseURL) : resourceURL;
    const contentType = getMimeType(resourceURL);
    let dataURL;
    if (getContentFromUrl) {
      const content = await getContentFromUrl(resolvedURL);
      dataURL = makeDataUrl(content, contentType);
    } else {
      dataURL = await resourceToDataURL(resolvedURL, contentType, options);
    }
    return cssText.replace(toRegex(resourceURL), `$1${dataURL}$3`);
  } catch (error) {
  }
  return cssText;
}
function filterPreferredFontFormat(str, { preferredFontFormat }) {
  return !preferredFontFormat ? str : str.replace(FONT_SRC_REGEX, (match2) => {
    while (true) {
      const [src, , format2] = URL_WITH_FORMAT_REGEX.exec(match2) || [];
      if (!format2) {
        return "";
      }
      if (format2 === preferredFontFormat) {
        return `src: ${src};`;
      }
    }
  });
}
function shouldEmbed(url) {
  return url.search(URL_REGEX) !== -1;
}
async function embedResources(cssText, baseUrl, options) {
  if (!shouldEmbed(cssText)) {
    return cssText;
  }
  const filteredCSSText = filterPreferredFontFormat(cssText, options);
  const urls = parseURLs(filteredCSSText);
  return urls.reduce((deferred, url) => deferred.then((css) => embed(css, url, baseUrl, options)), Promise.resolve(filteredCSSText));
}

// ../node_modules/html-to-image/es/embed-images.js
async function embedProp(propName, node, options) {
  var _a2;
  const propValue = (_a2 = node.style) === null || _a2 === void 0 ? void 0 : _a2.getPropertyValue(propName);
  if (propValue) {
    const cssString = await embedResources(propValue, null, options);
    node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
    return true;
  }
  return false;
}
async function embedBackground(clonedNode, options) {
  ;
  await embedProp("background", clonedNode, options) || await embedProp("background-image", clonedNode, options);
  await embedProp("mask", clonedNode, options) || await embedProp("-webkit-mask", clonedNode, options) || await embedProp("mask-image", clonedNode, options) || await embedProp("-webkit-mask-image", clonedNode, options);
}
async function embedImageNode(clonedNode, options) {
  const isImageElement = isInstanceOfElement(clonedNode, HTMLImageElement);
  if (!(isImageElement && !isDataUrl(clonedNode.src)) && !(isInstanceOfElement(clonedNode, SVGImageElement) && !isDataUrl(clonedNode.href.baseVal))) {
    return;
  }
  const url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
  const dataURL = await resourceToDataURL(url, getMimeType(url), options);
  await new Promise((resolve, reject) => {
    clonedNode.onload = resolve;
    clonedNode.onerror = options.onImageErrorHandler ? (...attributes) => {
      try {
        resolve(options.onImageErrorHandler(...attributes));
      } catch (error) {
        reject(error);
      }
    } : reject;
    const image = clonedNode;
    if (image.decode) {
      image.decode = resolve;
    }
    if (image.loading === "lazy") {
      image.loading = "eager";
    }
    if (isImageElement) {
      clonedNode.srcset = "";
      clonedNode.src = dataURL;
    } else {
      clonedNode.href.baseVal = dataURL;
    }
  });
}
async function embedChildren(clonedNode, options) {
  const children = toArray(clonedNode.childNodes);
  const deferreds = children.map((child) => embedImages(child, options));
  await Promise.all(deferreds).then(() => clonedNode);
}
async function embedImages(clonedNode, options) {
  if (isInstanceOfElement(clonedNode, Element)) {
    await embedBackground(clonedNode, options);
    await embedImageNode(clonedNode, options);
    await embedChildren(clonedNode, options);
  }
}

// ../node_modules/html-to-image/es/apply-style.js
function applyStyle(node, options) {
  const { style } = node;
  if (options.backgroundColor) {
    style.backgroundColor = options.backgroundColor;
  }
  if (options.width) {
    style.width = `${options.width}px`;
  }
  if (options.height) {
    style.height = `${options.height}px`;
  }
  const manual = options.style;
  if (manual != null) {
    Object.keys(manual).forEach((key) => {
      style[key] = manual[key];
    });
  }
  return node;
}

// ../node_modules/html-to-image/es/embed-webfonts.js
var cssFetchCache = {};
async function fetchCSS(url) {
  let cache3 = cssFetchCache[url];
  if (cache3 != null) {
    return cache3;
  }
  const res = await fetch(url);
  const cssText = await res.text();
  cache3 = { url, cssText };
  cssFetchCache[url] = cache3;
  return cache3;
}
async function embedFonts(data, options) {
  let cssText = data.cssText;
  const regexUrl = /url\(["']?([^"')]+)["']?\)/g;
  const fontLocs = cssText.match(/url\([^)]+\)/g) || [];
  const loadFonts = fontLocs.map(async (loc) => {
    let url = loc.replace(regexUrl, "$1");
    if (!url.startsWith("https://")) {
      url = new URL(url, data.url).href;
    }
    return fetchAsDataURL(url, options.fetchRequestInit, ({ result }) => {
      cssText = cssText.replace(loc, `url(${result})`);
      return [loc, result];
    });
  });
  return Promise.all(loadFonts).then(() => cssText);
}
function parseCSS(source) {
  if (source == null) {
    return [];
  }
  const result = [];
  const commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
  let cssText = source.replace(commentsRegex, "");
  const keyframesRegex = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
  while (true) {
    const matches = keyframesRegex.exec(cssText);
    if (matches === null) {
      break;
    }
    result.push(matches[0]);
  }
  cssText = cssText.replace(keyframesRegex, "");
  const importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
  const combinedCSSRegex = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})";
  const unifiedRegex = new RegExp(combinedCSSRegex, "gi");
  while (true) {
    let matches = importRegex.exec(cssText);
    if (matches === null) {
      matches = unifiedRegex.exec(cssText);
      if (matches === null) {
        break;
      } else {
        importRegex.lastIndex = unifiedRegex.lastIndex;
      }
    } else {
      unifiedRegex.lastIndex = importRegex.lastIndex;
    }
    result.push(matches[0]);
  }
  return result;
}
async function getCSSRules(styleSheets, options) {
  const ret = [];
  const deferreds = [];
  styleSheets.forEach((sheet) => {
    if ("cssRules" in sheet) {
      try {
        toArray(sheet.cssRules || []).forEach((item, index) => {
          if (item.type === CSSRule.IMPORT_RULE) {
            let importIndex = index + 1;
            const url = item.href;
            const deferred = fetchCSS(url).then((metadata) => embedFonts(metadata, options)).then((cssText) => parseCSS(cssText).forEach((rule) => {
              try {
                sheet.insertRule(rule, rule.startsWith("@import") ? importIndex += 1 : sheet.cssRules.length);
              } catch (error) {
                console.error("Error inserting rule from remote css", {
                  rule,
                  error
                });
              }
            })).catch((e) => {
              console.error("Error loading remote css", e.toString());
            });
            deferreds.push(deferred);
          }
        });
      } catch (e) {
        const inline = styleSheets.find((a) => a.href == null) || document.styleSheets[0];
        if (sheet.href != null) {
          deferreds.push(fetchCSS(sheet.href).then((metadata) => embedFonts(metadata, options)).then((cssText) => parseCSS(cssText).forEach((rule) => {
            inline.insertRule(rule, inline.cssRules.length);
          })).catch((err) => {
            console.error("Error loading remote stylesheet", err);
          }));
        }
        console.error("Error inlining remote css file", e);
      }
    }
  });
  return Promise.all(deferreds).then(() => {
    styleSheets.forEach((sheet) => {
      if ("cssRules" in sheet) {
        try {
          toArray(sheet.cssRules || []).forEach((item) => {
            ret.push(item);
          });
        } catch (e) {
          console.error(`Error while reading CSS rules from ${sheet.href}`, e);
        }
      }
    });
    return ret;
  });
}
function getWebFontRules(cssRules) {
  return cssRules.filter((rule) => rule.type === CSSRule.FONT_FACE_RULE).filter((rule) => shouldEmbed(rule.style.getPropertyValue("src")));
}
async function parseWebFontRules(node, options) {
  if (node.ownerDocument == null) {
    throw new Error("Provided element is not within a Document");
  }
  const styleSheets = toArray(node.ownerDocument.styleSheets);
  const cssRules = await getCSSRules(styleSheets, options);
  return getWebFontRules(cssRules);
}
function normalizeFontFamily(font2) {
  return font2.trim().replace(/["']/g, "");
}
function getUsedFonts(node) {
  const fonts = /* @__PURE__ */ new Set();
  function traverse(node2) {
    const fontFamily = node2.style.fontFamily || getComputedStyle(node2).fontFamily;
    fontFamily.split(",").forEach((font2) => {
      fonts.add(normalizeFontFamily(font2));
    });
    Array.from(node2.children).forEach((child) => {
      if (child instanceof HTMLElement) {
        traverse(child);
      }
    });
  }
  traverse(node);
  return fonts;
}
async function getWebFontCSS(node, options) {
  const rules = await parseWebFontRules(node, options);
  const usedFonts = getUsedFonts(node);
  const cssTexts = await Promise.all(rules.filter((rule) => usedFonts.has(normalizeFontFamily(rule.style.fontFamily))).map((rule) => {
    const baseUrl = rule.parentStyleSheet ? rule.parentStyleSheet.href : null;
    return embedResources(rule.cssText, baseUrl, options);
  }));
  return cssTexts.join("\n");
}
async function embedWebFonts(clonedNode, options) {
  const cssText = options.fontEmbedCSS != null ? options.fontEmbedCSS : options.skipFonts ? null : await getWebFontCSS(clonedNode, options);
  if (cssText) {
    const styleNode = document.createElement("style");
    const sytleContent = document.createTextNode(cssText);
    styleNode.appendChild(sytleContent);
    if (clonedNode.firstChild) {
      clonedNode.insertBefore(styleNode, clonedNode.firstChild);
    } else {
      clonedNode.appendChild(styleNode);
    }
  }
}

// ../node_modules/html-to-image/es/index.js
async function toSvg(node, options = {}) {
  const { width, height } = getImageSize(node, options);
  const clonedNode = await cloneNode(node, options, true);
  await embedWebFonts(clonedNode, options);
  await embedImages(clonedNode, options);
  applyStyle(clonedNode, options);
  const datauri = await nodeToDataURL(clonedNode, width, height);
  return datauri;
}
async function toCanvas(node, options = {}) {
  const { width, height } = getImageSize(node, options);
  const svg = await toSvg(node, options);
  const img = await createImage(svg);
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const ratio = options.pixelRatio || getPixelRatio();
  const canvasWidth = options.canvasWidth || width;
  const canvasHeight = options.canvasHeight || height;
  canvas.width = canvasWidth * ratio;
  canvas.height = canvasHeight * ratio;
  if (!options.skipAutoScale) {
    checkCanvasDimensions(canvas);
  }
  canvas.style.width = `${canvasWidth}`;
  canvas.style.height = `${canvasHeight}`;
  if (options.backgroundColor) {
    context.fillStyle = options.backgroundColor;
    context.fillRect(0, 0, canvas.width, canvas.height);
  }
  context.drawImage(img, 0, 0, canvas.width, canvas.height);
  return canvas;
}
async function toPng(node, options = {}) {
  const canvas = await toCanvas(node, options);
  return canvas.toDataURL();
}

// filter/FilterRxComp.js
var FilterRxComp = class _FilterRxComp extends Filter {
  static type = "filter";
  constructor(opts) {
    super(opts);
    this.type = _FilterRxComp.type;
    this.parentId = opts.parentId;
    this.initHolder();
  }
  async preApiFreeze(api) {
    api.main = this.main.bind(this);
    api.getNormalRoot = () => getNormalRoot(this.rawFilter);
    api.getFilterImage = async () => {
      const node = this.dom.filterContainer.node().cloneNode(true);
      document.body.appendChild(node);
      const dataUrl = await toPng(node, {
        quality: 0.95,
        style: {
          background: "white"
        }
      });
      document.body.removeChild(node);
      if (dataUrl === "data:,")
        return null;
      return dataUrl;
    };
  }
  getState(appState) {
    const parentConfig = this.parentId && appState.plots.find((p) => p.id === this.parentId);
    const defaultFilter = { type: "tvslst", join: "", lst: [] };
    return {
      // if there is parentConfig, assume this is UI for a local filter,
      // otherwise this UI is for global app filter
      termfilter: parentConfig ? { filter: parentConfig.filter || defaultFilter } : appState.termfilter,
      // make all nested  plot pill edit menus react to global filter changes
      globalFilter: parentConfig ? appState.termfilter.filter : void 0,
      activeCohort: appState.activeCohort
    };
  }
  async main(rawFilter = null) {
    this.dom.controlsTip.hide();
    this.dom.treeTip.hide();
    const f = this.state && this.state.termfilter;
    if (!f) {
      this.dom.holder.style("display", "none");
      return;
    }
    this.dom.holder.style("display", "inline-block");
    const filter2 = structuredClone(rawFilter || f?.filter);
    if (filter2.lst.length < 2) filter2.join = "";
    this.rawCopy = JSON.stringify(filter2);
    super.main(this.rawCopy, { activeCohort: this.state.activeCohort });
  }
  initHolder() {
    const div = this.dom.holder.attr("class", "sjpp_filter_div").style("position", "relative").style("width", "fit-content").style("display", "table").style("border", this.opts.hideLabel ? "none" : "solid 1px #ddd");
    if (this.opts.hideLabel) {
      this.dom.filterDiv = div.style("display", "inline-block").style("padding", "5px 10px");
    } else {
      div.append("span").text("Filter").style("padding", "0 10px");
      this.dom.filterDiv = div.append("div").style("display", "inline-block").style("padding", "5px 10px");
    }
  }
};
var filterRxCompInit = getCompInit(FilterRxComp);

// filter/FilterPrompt.js
var FilterPrompt = class extends Filter {
  constructor(opts) {
    super(opts);
    this.api = {
      // make sure to bind the 'this' context to the filter instance
      // instead of to the this.api object
      main: this.main.bind(this),
      /*
      				WARNING!!!
      				When using this filter.api.getNormalRoot(),
      				make sure this instance has been updated before the caller,
      				otherwise the normalized root will be stale
      
      				or for reliability, import getNormalRoot() directly 
      				from the common/filter.js component and supply the 
      				caller's known raw filter state
      			*/
      getNormalRoot: () => getNormalRoot(this.rawFilter),
      getPromise: (name) => this.promises[name],
      destroy: () => this.destroy()
    };
    if (opts.debug) this.api.Inner = this;
  }
  async main(rawFilter, opts = {}) {
    this.dom.controlsTip.hide();
    this.dom.treeTip.hide();
    const activeCohort = "activeCohort" in opts ? opts.activeCohort : this.activeCohort;
    const filterUiRoot = getFilterItemByTag(rawFilter, "filterUiRoot");
    if (filterUiRoot) delete filterUiRoot.tag;
    rawFilter.lst.push({
      tag: "filterUiRoot",
      type: "tvslst",
      join: "",
      lst: []
    });
    rawFilter.join = rawFilter.lst.length > 1 ? "and" : "";
    const rawCopy = JSON.stringify(rawFilter);
    if (this.rawCopy == rawCopy && JSON.stringify(this.activeCohort) == JSON.stringify(activeCohort)) return;
    await super.main(rawCopy, opts);
  }
  refresh(filterUiRoot) {
    this.dom.controlsTip.hide();
    this.dom.treeTip.hide();
    const rootCopy = JSON.parse(JSON.stringify(this.rawFilter));
    const rawParent = findParent(rootCopy, this.filter.$id);
    if (!rawParent || this.rawFilter.$id === this.filter.$id) {
      this.opts.callback(rootCopy);
    } else {
      const i4 = rawParent.lst.findIndex((f) => f.$id == this.filter.$id);
      rawParent.lst[i4] = filterUiRoot;
      this.opts.callback(rootCopy);
    }
    const i3 = rootCopy.lst.findIndex((f) => f.$id === filterUiRoot.$id);
    rootCopy.lst.splice(i3, 1);
    this.main(rootCopy);
  }
};
var filterPromptInit = getInitFxn(FilterPrompt);

// filter/tvs.dt.js
var handler2 = Object.assign({}, handler, { fillMenu, term_name_gen, get_pill_label });
async function fillMenu(self2, div, tvs) {
  const term = structuredClone(tvs.term);
  await getDtTermValues(term, self2.filter, self2.opts.vocabApi, { withMnames: true });
  const arg = {
    holder: div,
    header: term.parentTerm.name + " " + term.name,
    values: term.values,
    mnames: term.mnames,
    selectedValues: tvs.values,
    genotype: tvs.genotype,
    dt: term.dt,
    mcount: tvs.mcount,
    callback: (config) => {
      const new_tvs = structuredClone(tvs);
      Object.assign(new_tvs, config);
      if (!new_tvs.selfBreakpointRange) delete new_tvs.selfBreakpointRange;
      self2.dom.tip.hide();
      self2.opts.callback(new_tvs);
    }
  };
  const mafFilter = self2.opts.vocabApi.termdbConfig?.queries?.snvindel?.mafFilter;
  if (mafFilter && term.dt == dtsnvindel) {
    mafFilter.active = tvs.mafFilter || mafFilter.filter;
    arg.mafFilter = mafFilter;
  }
  const genome = self2.opts.vocabApi.vocab?.genome;
  if ((term.dt == dtsv || term.dt == dtfusionrna) && genome) {
    arg.getGeneModels = async (gene) => {
      const data = await dofetch3("genelookup", { body: { genome, input: gene, deep: 1 } });
      if (data?.error) throw data.error;
      return data?.gmlst || [];
    };
    const genes = term.parentTerm?.genes;
    if (genes?.length == 1) arg.gene = genes[0].gene || genes[0].name;
    arg.selfBreakpointRange = tvs.selfBreakpointRange;
  }
  renderVariantConfig(arg);
}
function term_name_gen(d) {
  const name = d.term.parentTerm && !d.excludeGeneName ? `${d.term.parentTerm.name} ${d.term.name}` : d.term.name;
  return name.length < 31 ? name : '<label title="' + name + '">' + name.substring(0, 28) + "...</label>";
}
function get_pill_label(tvs) {
  let txt;
  if (tvs.genotype == "variant") {
    if (tvs.values.length == 1) {
      txt = tvs.values[0].label;
    } else {
      if (tvs.term.dt == 1) txt = "Mutated";
      else txt = "Altered";
    }
    const ranges = [];
    if (tvs.selfBreakpointRange) ranges.push(breakpointRangeLabel(tvs.selfBreakpointRange));
    for (const v of tvs.values) {
      if (v.partnerBreakpointRange) ranges.push(breakpointRangeLabel(v.partnerBreakpointRange));
    }
    if (ranges.length) txt += ` @ ${ranges.join(", ")}`;
  } else if (tvs.genotype == "wt") {
    txt = "Wildtype";
  } else if (tvs.genotype == "nt") {
    txt = "Not tested";
  } else {
    throw "tvs.genotype not recognized";
  }
  return { txt };
}
async function getDtTermValues(dtTerm, filter2, vocabApi, opts = {}) {
  if (vocabApi instanceof FrontendVocab) {
    const vocabTerm = vocabApi.vocab?.terms?.find((t2) => t2.id == dtTerm.id);
    if (vocabTerm) dtTerm.values = vocabTerm.values;
    if (opts.withMnames && vocabTerm) dtTerm.mnames = vocabTerm.mnames;
    return;
  }
  const body = { term1_q: { dtLst: [dtTerm.dt] } };
  const categories = await vocabApi.getCategories(dtTerm.parentTerm, filter2, body);
  if (!categories) throw new Error("unable to retrieve variant data");
  const data = categories?.lst.find((x) => x.dt == dtTerm.dt);
  if (!data) return;
  const byOrigin = vocabApi.termdbConfig.assayAvailability?.byDt[dtTerm.dt]?.byOrigin;
  const classes = byOrigin ? data.classes.byOrigin[dtTerm.origin] : data.classes;
  dtTerm.values = Object.fromEntries(
    Object.keys(classes).filter((k) => k != "Blank" && k != "WT").map((k) => {
      const value = { key: k, label: vocabApi.termdbConfig.mclass?.[k]?.label || mclass[k].label };
      if (opts.withMnames) value.samplecount = classes[k];
      return [k, value];
    })
  );
  if (!opts.withMnames) {
    delete dtTerm.mnames;
    return;
  }
  const mnames = byOrigin ? data.mnames?.byOrigin?.[dtTerm.origin] : data.mnames;
  dtTerm.mnames = mnames?.length ? mnames : void 0;
}

// termdb/handlers/geneVariant.ts
var SearchHandler = class {
  async init(opts) {
    this.opts = opts;
    this.dom = {};
    this.term = { type: "geneVariant" };
    this.q = { type: "predefined-groupset" };
    this.callback = opts.callback;
    this.maxNumGenes = this.opts.app.vocabApi.termdbConfig?.maxGeneVariantGeneSetSize || 200;
    opts.holder.style("padding", "5px 10px 10px 25px");
    this.dom.typeSettingDiv = opts.holder.append("div");
    this.dom.searchDiv = opts.holder.append("div").attr("data-testid", "sjpp-genevariant-geneSearchDiv").style("padding-left", "3px");
    this.dom.reuseDiv = opts.holder.append("div").style("display", "none").style("margin-top", "10px");
    this.dom.msgDiv = opts.holder.append("div").style("display", "none").style("font-size", ".7em").style("margin-top", "5px").style("padding-left", "3px");
    if (opts.msg) this.dom.msgDiv.style("display", "block").text(opts.msg);
    getChildTerms(this.term, this.opts.app.vocabApi);
    const mutationTypeTerms = structuredClone(this.term.childTerms);
    if (isEligibleForAllelicGroupset(this.term, this.opts.app.vocabApi))
      mutationTypeTerms.push({ name: "Bi/mono-allelic", dts: [dtsnvindel, dtcnv] });
    this.mutationTypeTerms = mutationTypeTerms;
    const mutationTypeTermIdx = opts.dt ? mutationTypeTerms.findIndex((t2) => t2.dt == opts.dt) : 0;
    if (!Number.isInteger(mutationTypeTermIdx) || mutationTypeTermIdx == -1)
      throw new Error("invalid mutation type term index");
    {
      const table = table2col({ holder: this.dom.typeSettingDiv, margin: "0px 0px 15px 0px" });
      {
        const [td1, td2] = table.addRow();
        td1.text("Mutation Type");
        this.mutationTypeRadio = make_radios({
          holder: td2.attr("data-testid", "sjpp-genevariant-mutationTypeRadios"),
          styles: { display: "inline-block" },
          options: mutationTypeTerms.map((t2, i3) => {
            return {
              label: t2.name,
              value: i3,
              checked: i3 == mutationTypeTermIdx,
              testid: "sjpp-genevarianttermdbhandler-radio-" + t2.name
            };
          }),
          callback: (v) => {
            this.toggleGeneSetRadioDisplay(v);
            this.updateSampleTypeSelect();
            this.clearRememberedQ();
            this.focusSearchbox();
          }
        });
      }
      {
        const [td1, td2] = table.addRow();
        td1.text("Input Type");
        this.inputTypeRadio = make_radios({
          holder: td2.attr("data-testid", "sjpp-genevariant-genesetTypeRadios"),
          styles: { display: "inline-block" },
          options: [
            {
              label: "Single Gene",
              value: "single",
              checked: true,
              testid: "sjpp-genevarianttermdbhandler-singlegene"
            },
            { label: "Gene Set", value: "geneset", checked: false, testid: "sjpp-genevarianttermdbhandler-geneset" }
          ],
          callback: (v) => {
            this.clearRememberedQ();
            if (v == "single") this.searchGene();
            else this.searchGeneSet();
          }
        });
      }
      {
        this.dom.sampleTypeSelectRow = table.addRow();
        this.updateSampleTypeSelect();
      }
    }
    this.toggleGeneSetRadioDisplay(mutationTypeTermIdx);
    this.searchGene();
  }
  updateSampleTypeSelect() {
    const [td1, td2] = this.dom.sampleTypeSelectRow;
    const querySampleTypes = this.getQuerySampleTypes();
    this.sampleTypeSelect = renderSampleTypeSelect(td2, querySampleTypes, this.opts.app.vocabApi.termdbConfig);
    if (this.sampleTypeSelect) {
      td1.style("display", null).text("Sample Type");
      td2.style("display", null);
    } else {
      td1.style("display", "none");
      td2.style("display", "none");
    }
  }
  // get sample types that are present in the selected data type
  getQuerySampleTypes() {
    const selectedMutationType = this.mutationTypeRadio.inputs.nodes().find((r) => r.checked);
    if (!selectedMutationType) return;
    const mutationTypeIdx = Number(selectedMutationType.value);
    if (!Number.isInteger(mutationTypeIdx)) return;
    const dt = this.mutationTypeTerms[mutationTypeIdx]?.dt;
    if (!Number.isInteger(dt)) return;
    const bySampleType = this.opts.app.vocabApi.termdbConfig?.assayAvailability?.byDt?.[dt]?.bySampleType;
    if (!bySampleType) return;
    const querySampleTypes = [];
    for (const [k, v] of Object.entries(bySampleType)) {
      if (v.hasSamples) querySampleTypes.push(Number(k));
    }
    return querySampleTypes;
  }
  // hide gene set radio when mutation type is cnv
  // because cnv of one gene can disguise cnv of another gene
  // example: if sample has cnv amplification in geneA and
  // cnv deletion in geneB, classification of the sample will
  // be ambiguous
  toggleGeneSetRadioDisplay(childTermIdx) {
    const childTerm = this.term.childTerms[childTermIdx];
    const geneSetDiv = this.inputTypeRadio.divs.filter((d) => {
      if (d.value != "single" && d.value != "geneset") throw new Error("unexpected input type radio value");
      return d.value == "geneset";
    });
    const geneInput = this.inputTypeRadio.inputs.filter((d) => {
      if (d.value != "single" && d.value != "geneset") throw new Error("unexpected input type radio value");
      return d.value == "single";
    });
    if (childTerm?.dt == dtcnv) {
      geneSetDiv.style("display", "none");
      geneInput.node().click();
    } else {
      geneSetDiv.style("display", "inline-block");
    }
  }
  searchGene() {
    const searchDiv = this.dom.searchDiv;
    searchDiv.selectAll("*").remove();
    searchDiv.style("margin", "10px 0px");
    const geneSearch = addGeneSearchbox({
      tip: new Menu({ padding: "0px" }),
      genome: this.opts.genomeObj,
      row: searchDiv,
      /* only allowing gene search for now because:
      - coordinate search is not yet supported for gdc
      - for other datasets, even though coordinate search is supported, it is not compatible with input type radios (single gene vs. geneset) because a coordinate may include one or more genes.
      TODO: fully support coordinate search
      */
      searchOnly: "gene",
      callback: async () => await this.selectGene(geneSearch)
    });
    this.dom.searchbox = geneSearch.searchbox;
    searchDiv.select(".sja_genesearchinput").style("margin", "0px");
  }
  /** focus on the search box of the current gene input (single gene or gene set) */
  focusSearchbox() {
    this.dom.searchbox?.node()?.focus();
  }
  async selectGene(geneSearch) {
    if (geneSearch.geneSymbol) {
      const name = geneSearch.geneSymbol;
      Object.assign(this.term, {
        id: name,
        name,
        genes: [
          {
            kind: "gene",
            id: name,
            gene: name,
            name,
            type: "geneVariant"
          }
        ],
        type: "geneVariant"
      });
    } else if (geneSearch.chr && geneSearch.start && geneSearch.stop) {
      const { chr, start, stop } = geneSearch;
      const name = `${chr}:${start + 1}-${stop}`;
      Object.assign(this.term, {
        id: name,
        name,
        genes: [
          {
            kind: "coord",
            chr,
            start,
            stop,
            name,
            type: "geneVariant"
          }
        ],
        type: "geneVariant"
      });
    } else {
      throw "no gene or position specified";
    }
    await this.runCallback();
  }
  // TODO: support sample type selection here too
  searchGeneSet() {
    this.dom.searchDiv.selectAll("*").remove();
    this.dom.searchDiv.style("margin-top", "0px");
    this.dom.geneSetEditUI = new GeneSetEditUI({
      holder: this.dom.searchDiv.append("div"),
      genome: this.opts.genomeObj,
      vocabApi: this.opts.app.vocabApi,
      nameInput: true,
      maxNumGenes: this.maxNumGenes,
      callback: async (result) => await this.selectGeneSet(result)
    });
    this.dom.searchbox = this.dom.geneSetEditUI.geneSearch?.searchbox;
    this.dom.searchDiv.select(".sja_genesetinput").style("padding", "0px").style("margin-top", "-10px");
  }
  async selectGeneSet(result) {
    const genes = result.geneList.map((v) => {
      if (!v.gene) throw "gene name not found";
      const name2 = v.gene;
      const gene = {
        kind: "gene",
        id: name2,
        gene: name2,
        name: name2,
        type: "geneVariant"
      };
      return gene;
    });
    const name = result.name;
    if (!name) throw "gene set name not found";
    Object.assign(this.term, {
      id: name,
      name,
      genes,
      type: "geneVariant"
    });
    await this.runCallback();
  }
  async runCallback() {
    if (this.mayShowRememberedQ()) return;
    await this.applyMutationType();
  }
  /*
  	Offer the settings the user built earlier for the gene(s) just picked, so that the mutation
  	type behind them is not applied until the user chooses, see mayShowRememberedGvQ() in
  	./rememberedGvQ.ts.
  
  	Only offered where the q of the selected term reaches the consumer, see keepsQ in
  	client/termdb/TermTypeSearch.ts.
  
  	The selected mutation type is handed over as well, so that a setting built for that same
  	mutation type leads the options rather than the way to continue with it, see there.
  	*/
  mayShowRememberedQ() {
    if (!this.opts.keepsQ) return false;
    const idx = Number(this.mutationTypeRadio.inputs.nodes().find((r) => r.checked).value);
    const mutationType = this.mutationTypeTerms[idx];
    const shown = mayShowRememberedGvQ({
      holder: this.dom.reuseDiv,
      vocabApi: this.opts.app.vocabApi,
      term: this.term,
      mutationType,
      skipLabel: `Continue with ${mutationType.name}`,
      callback: async (q) => q ? await this.applyRememberedQ(q) : await this.applyMutationType()
    });
    if (shown) this.dom.msgDiv.style("display", "none");
    return shown;
  }
  /** clear the remembered settings offered for the gene last picked, and put back any caller
  message that mayShowRememberedQ() hid while they waited for a choice */
  clearRememberedQ() {
    this.dom.reuseDiv.style("display", "none").selectAll("*").remove();
    if (this.opts.msg) this.dom.msgDiv.style("display", "block").text(this.opts.msg);
  }
  /** apply the mutation type that the radios select, which is the default for a new term */
  // TODO: this seems to be a submit helper. Should rename this
  // function and evaluate whether the submission process can be
  // more streamlined/centralized
  async applyMutationType() {
    const selectedMutationType = this.mutationTypeRadio.inputs.nodes().find((r) => r.checked);
    this.q.predefined_groupset_idx = Number(selectedMutationType.value);
    await this.submit(this.q);
  }
  mayApplySampleType() {
    this.term.sampleTypes = getSelectedSampleTypes(this.sampleTypeSelect) || this.getQuerySampleTypes();
    if (this.sampleTypeSelect && !this.term.sampleTypes?.length) {
      window.alert("Must select at least one sample type");
      const geneSetEditUI = this.dom.geneSetEditUI;
      if (geneSetEditUI) {
        geneSetEditUI.api.dom.submitBtn.property("disabled", false).text("Submit");
      }
      return false;
    }
    return true;
  }
  async applyRememberedQ(q) {
    await this.submit({ ...structuredClone(q), isAtomic: true });
  }
  async submit(q) {
    if (!this.mayApplySampleType()) return;
    this.dom.msgDiv.style("display", "block").text("LOADING ...");
    addParentTerm(this.term);
    await this.callback({ term: this.term, q });
    this.clearRememberedQ();
    this.dom.msgDiv.style("display", "none");
  }
};
function getChildTerms(term, vocabApi) {
  if (!vocabApi.termdbConfig?.queries) throw "termdbConfig.queries is missing";
  term.childTerms = [];
  for (const _t of dtTerms) {
    const t2 = structuredClone(_t);
    if (!Object.keys(vocabApi.termdbConfig.queries).includes(t2.query)) continue;
    const byOrigin = vocabApi.termdbConfig.assayAvailability?.byDt[t2.dt]?.byOrigin;
    if (byOrigin) {
      if (!t2.origin) continue;
      if (!Object.keys(byOrigin).includes(t2.origin)) throw "unexpected origin of dt term";
    } else {
      if (t2.origin) continue;
    }
    term.childTerms.push(t2);
  }
}
function addParentTerm(term) {
  if (!term.childTerms?.length) throw "term.childTerms[] is missing";
  for (const t2 of term.childTerms) {
    t2.parentTerm = structuredClone(term);
    delete t2.parentTerm.childTerms;
    delete t2.parentTerm.groupsetting;
  }
}

// tw/geneVariant.ts
var colorScale2 = getColors(3);
var GvBase = class extends TwBase {
  constructor(tw, opts) {
    super(tw, opts);
    this.term = tw.term;
  }
  /* a filled-in geneVariant term is mostly derived properties that no data
  request needs, see trimGvTermCopy() */
  getMinCopy(override = {}) {
    const copy = super.getMinCopy(override);
    trimGvTermCopy(copy.term, copy.q);
    return copy;
  }
  /** tw.term must already be filled-in at this point */
  static async fill(tw, opts = {}) {
    if (!tw.term) throw `missing tw.term, must already be filled in`;
    if (tw.term.type != "geneVariant") throw `incorrect term.type='${tw.term?.type}', expecting 'geneVariant'`;
    if (opts.defaultQ != null) {
      opts.defaultQ.isAtomic = true;
      const defaultQ = tw.q?.type ? { ...opts.defaultQ, type: tw.q.type } : opts.defaultQ;
      copyMerge(tw.q, defaultQ);
    }
    if (!tw.term.genes?.length) {
      const gene = structuredClone(tw.term);
      tw.term.genes = [gene];
    }
    for (const gene of tw.term.genes) {
      if (!gene.kind) {
        const term = gene;
        if (term.gene || term.name && !term.chr) term.kind = "gene";
        else if (term.chr) term.kind = "coord";
        else throw "unable to assign geneVariant term.kind";
      }
      if (gene.kind == "gene") {
        if (!gene.gene) gene.gene = gene.name;
        if (!gene.name) gene.name = gene.gene;
        if (!gene.gene || !gene.name) throw "missing gene/name";
      } else if (gene.kind == "coord") {
        if (!gene.chr || !Number.isInteger(gene.start) || !Number.isInteger(gene.stop)) throw "no position specified";
        if (!gene.name) {
          gene.name = `${gene.chr}:${gene.start + 1}-${gene.stop}`;
        }
      } else {
        throw "cannot recognize gene.kind";
      }
      if (!gene.id) gene.id = gene.name;
    }
    if (!tw.term.name) tw.term.name = tw.term.genes.map((gene) => gene.name).join(", ");
    if (!Object.keys(tw.q).includes("type")) tw.q.type = "values";
    if (!tw.term.groupsetting) tw.term.groupsetting = { disabled: false };
    if (!tw.term.childTerms) getChildTerms(tw.term, opts.vocabApi);
    addParentTerm(tw.term);
    const cnv = opts.vocabApi.termdbConfig.queries.cnv;
    if (cnv) {
      if ("cnvGainCutoff" in cnv || "cnvLossCutoff" in cnv || "cnvMaxLength" in cnv) {
        const dsCnvCutoffs = {};
        if ("cnvGainCutoff" in cnv) dsCnvCutoffs.cnvGainCutoff = cnv.cnvGainCutoff;
        if ("cnvLossCutoff" in cnv) dsCnvCutoffs.cnvLossCutoff = cnv.cnvLossCutoff;
        if ("cnvMaxLength" in cnv) dsCnvCutoffs.cnvMaxLength = cnv.cnvMaxLength;
        const cnvCutoffsByGene = cnv.cnvCutoffsByGene?.[tw.term.name];
        const defaultCnvCutoffs = cnvCutoffsByGene || dsCnvCutoffs;
        tw.q = Object.assign({}, defaultCnvCutoffs, tw.q);
      }
    }
    tw.type = !tw.q.type || tw.q.type == "values" ? "GvValuesTW" : tw.q.type == "predefined-groupset" ? "GvPredefinedGsTW" : tw.q.type == "custom-groupset" ? "GvCustomGsTW" : tw.type;
    switch (tw.type) {
      case "GvValuesTW":
        return await GvValues.fill(tw);
      case "GvPredefinedGsTW":
        return await GvPredefinedGS.fill(tw, opts);
      case "GvCustomGsTW":
        return await GvCustomGS.fill(tw);
      default:
        throw `tw.type='${tw.type}' is not supported by GvBase.fill()`;
    }
  }
};
var GvValues = class extends GvBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    this.#tw = tw;
  }
  getTw() {
    return this.#tw;
  }
  // See the relevant comments in the GvBase.fill() function above
  static async fill(tw) {
    if (!tw.type) tw.type = "GvValuesTW";
    else if (tw.type != "GvValuesTW") throw `expecting tw.type='GvValuesTW', got '${tw.type}'`;
    if (tw.term.type != "geneVariant") throw `expecting tw.term.type='geneVariant', got '${tw.term.type}'`;
    const { term, q } = tw;
    if (!q.type) q.type = "values";
    else if (q.type != "values") throw `expecting tw.q.type='values', got ${tw.q.type}`;
    delete q.dtLst;
    validateVariantFilter(q.variantFilter, term);
    set_hiddenvalues(q, term);
    return tw;
  }
};
var GvPredefinedGS = class extends GvBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    this.#tw = tw;
    Object.defineProperty(this, "groupset", { value: this.#tw.term.groupsetting[this.#tw.q.predefined_groupset_idx] });
  }
  getTw() {
    return this.#tw;
  }
  // See the relevant comments in the GvBase.fill() function above
  static async fill(tw, opts = {}) {
    if (!tw.type) tw.type = "GvPredefinedGsTW";
    else if (tw.type != "GvPredefinedGsTW") throw `expecting tw.type='GvPredefinedGsTW', got '${tw.type}'`;
    if (tw.term.type != "geneVariant") throw `expecting tw.term.type='geneVariant', got '${tw.term.type}'`;
    if (tw.q.type != "predefined-groupset") throw `expecting tw.q.type='predefined-groupset', got '${tw.q.type}'`;
    const hasIdx = Object.keys(tw.q).includes("predefined_groupset_idx");
    if (!hasIdx) tw.q.predefined_groupset_idx = 0;
    if (!Number.isInteger(tw.q.predefined_groupset_idx)) throw "invalid tw.q.predefined_groupset_idx";
    listPredefinedGroupsets(tw.term, opts.vocabApi);
    delete tw.q.variantFilter;
    const { term, q } = tw;
    if (!term.groupsetting?.lst?.length) throw "term.groupsetting.lst[] is empty";
    if (!hasIdx && q.dtLst?.length) {
      const groupsetIdx = term.groupsetting.lst.findIndex((groupset) => {
        const dts = getGroupsetDts(groupset);
        if (!dts?.length) return false;
        if (dts.length != q.dtLst?.length) return false;
        if (dts.some((dt) => !q.dtLst?.includes(dt))) return false;
        return true;
      });
      if (groupsetIdx == -1) throw new Error("groupset with query dt(s) not found");
      q.predefined_groupset_idx = groupsetIdx;
      q.dtLst = getGroupsetDts(term.groupsetting.lst[groupsetIdx]);
    } else {
      const idx = q.predefined_groupset_idx;
      const lst = term.groupsetting.lst;
      if (!lst[idx]) throw "q.predefined_groupset_idx out of bound";
      q.dtLst = getGroupsetDts(lst[idx]);
    }
    await fillGroupsetGroups(term, q.predefined_groupset_idx, opts.vocabApi);
    set_hiddenvalues(q, term);
    return tw;
  }
  getTitleText() {
    const gsname = this.term?.groupsetting?.lst?.[this.q.predefined_groupset_idx].name || "";
    return `${this.term.name} ${gsname}`;
  }
};
var GvCustomGS = class extends GvBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    Object.defineProperty(this, "groupset", { value: this.q.customset });
    this.#tw = tw;
  }
  getTw() {
    return this.#tw;
  }
  // See the relevant comments in the GvBase.fill() function above
  static async fill(tw) {
    if (!tw.type) tw.type = "GvCustomGsTW";
    else if (tw.type != "GvCustomGsTW") throw `expecting tw.type='GvCustomGsTW', got '${tw.type}'`;
    if (tw.term.type != "geneVariant") throw `expecting tw.term.type='geneVariant', got '${tw.term.type}'`;
    if (tw.q.type != "custom-groupset") throw `expecting tw.q.type='custom-groupset', got '${tw.q.type}'`;
    delete tw.q.variantFilter;
    const { term, q } = tw;
    if (!q.customset) throw "missing tw.q.customset";
    if (!q.customset.groups.length) throw "customset.groups[] is empty";
    clearDtTermMnames(q.customset);
    setGroupsetParentTerms(q.customset, term);
    q.dtLst = getDtsFromGroups(q.customset.groups);
    set_hiddenvalues(q, term);
    return tw;
  }
  getTitleText() {
    return `${this.term.name} Custom Groups`;
  }
};
var allelicGroupsetName = "Bi-/mono-allelic";
function listPredefinedGroupsets(term, vocabApi) {
  if (!term.childTerms?.length) throw "term.childTerms[] is missing";
  const lst = term.childTerms.map((dtTerm) => {
    const groupset = { name: dtTerm.name, dt: dtTerm.dt };
    if (dtTerm.origin) groupset.origin = dtTerm.origin;
    return groupset;
  });
  if (isEligibleForAllelicGroupset(term, vocabApi)) {
    lst.push({ name: allelicGroupsetName, dts: [dtsnvindel, dtcnv] });
  }
  term.groupsetting = { disabled: false, lst };
}
function getGroupsetDts(groupset) {
  if (!groupset) throw "groupset is missing";
  if (groupset.dts) return groupset.dts;
  if (Number.isInteger(groupset.dt)) return [groupset.dt];
  if (!groupset.groups) throw "groupset has neither dt(s) nor groups[]";
  return getDtsFromGroups(groupset.groups);
}
async function fillGroupsetGroups(term, idx, vocabApi) {
  const groupset = term.groupsetting?.lst?.[idx];
  if (!groupset) throw "q.predefined_groupset_idx out of bound";
  if (groupset.groups) return;
  if (!term.childTerms?.length) throw "term.childTerms[] is missing";
  const filter2 = vocabApi.state.termfilter?.filter;
  if (groupset.name == allelicGroupsetName) {
    await getAllelicGroupset(groupset);
  } else {
    const dtTerm = term.childTerms.find(
      (t2) => t2.dt == groupset.dt && (groupset.origin ? t2.origin == groupset.origin : !t2.origin)
    );
    if (!dtTerm) throw "child dt term of the selected groupset not found";
    await getDtTermValues(dtTerm, filter2, vocabApi);
    if (dtTerm.dt == dtcnv) getCnvGroupset(groupset, dtTerm, term.name, vocabApi);
    else getNonCnvGroupset(groupset, dtTerm, term.name);
  }
  function getCnvGroupset(groupset2, dtTerm, geneName, vocabApi2) {
    const cnv = vocabApi2.termdbConfig.queries?.cnv;
    if (!cnv) throw "cnv query is missing";
    const keys = Object.keys(cnv);
    const isContinuous = keys.includes("cnvGainCutoff") || keys.includes("cnvLossCutoff");
    if (isContinuous) getContCnvGroupset(groupset2, dtTerm, geneName, cnv);
    else getCatCnvGroupset(groupset2, dtTerm, geneName);
  }
  function getContCnvGroupset(groupset2, dtTerm, geneName, cnv) {
    const cnvDefault = cnv.cnvCutoffsByGene?.[dtTerm.parentTerm.name] || {
      cnvMaxLength: cnv.cnvMaxLength,
      cnvGainCutoff: cnv.cnvGainCutoff,
      cnvLossCutoff: cnv.cnvLossCutoff
    };
    const gainGroup = {
      name: `${geneName} ${dtTerm.name_noOrigin} ${dtTerm.origin ? `Gain (${dtTerm.origin})` : "Gain"}`,
      type: "filter",
      filter: getWrappedTvslst([
        {
          type: "tvs",
          tvs: {
            term: dtTerm,
            values: [],
            continuousCnv: true,
            cnvGainCutoff: cnvDefault.cnvGainCutoff,
            cnvLossCutoff: -99,
            // set to very low number to get samples with gain events
            cnvMaxLength: cnvDefault.cnvMaxLength,
            fractionOverlap: 0.8,
            excludeGeneName: true
          }
        }
      ])
    };
    const lossGroup = {
      name: `${geneName} ${dtTerm.name_noOrigin} ${dtTerm.origin ? `Loss (${dtTerm.origin})` : "Loss"}`,
      type: "filter",
      filter: getWrappedTvslst([
        {
          type: "tvs",
          tvs: {
            term: dtTerm,
            values: [],
            continuousCnv: true,
            cnvGainCutoff: 99,
            // set to very high number to get samples with loss events
            cnvLossCutoff: cnvDefault.cnvLossCutoff,
            cnvMaxLength: cnvDefault.cnvMaxLength,
            fractionOverlap: 0.8,
            excludeGeneName: true
          }
        }
      ])
    };
    const wtGroup = {
      name: `${geneName} ${dtTerm.name_noOrigin} ${dtTerm.origin ? `Neutral (${dtTerm.origin})` : "Neutral"}`,
      type: "filter",
      filter: getWrappedTvslst([
        {
          type: "tvs",
          tvs: {
            term: dtTerm,
            values: [],
            continuousCnv: true,
            cnvWT: true,
            cnvGainCutoff: cnvDefault.cnvGainCutoff,
            cnvLossCutoff: cnvDefault.cnvLossCutoff,
            cnvMaxLength: cnvDefault.cnvMaxLength,
            fractionOverlap: 0.8,
            excludeGeneName: true
          }
        }
      ])
    };
    groupset2.groups = [gainGroup, lossGroup, wtGroup];
    colorScale2 = getColors(groupset2.groups.length);
    for (const group of groupset2.groups) {
      group.color = rgb(colorScale2(group.name)).formatHex();
    }
  }
  function getCatCnvGroupset(groupset2, dtTerm, geneName) {
    groupset2.groups = [];
    const values = dtTerm.values;
    for (const [k, v] of Object.entries(values)) {
      const filter3 = getWrappedTvslst([
        {
          type: "tvs",
          tvs: {
            term: dtTerm,
            values: [{ key: k, label: v.label, value: k }],
            genotype: "variant",
            mcount: "any",
            excludeGeneName: true
          }
        }
      ]);
      const name = `${geneName} ${dtTerm.name_noOrigin} ${dtTerm.origin ? `${v.label} (${dtTerm.origin})` : v.label}`;
      const color = typeof v.key === "string" ? mclass[v.key].color : void 0;
      groupset2.groups.push({ name, type: "filter", filter: filter3, color });
    }
    groupset2.groups.push({
      name: `${geneName} ${dtTerm.name_noOrigin} ${dtTerm.origin ? `Wildtype (${dtTerm.origin})` : "Wildtype"}`,
      type: "filter",
      filter: getWrappedTvslst([
        {
          type: "tvs",
          tvs: {
            term: dtTerm,
            values: [],
            genotype: "wt",
            excludeGeneName: true
          }
        }
      ]),
      color: mclass["WT"].color
    });
  }
  function getNonCnvGroupset(groupset2, dtTerm, geneName) {
    groupset2.groups = [];
    const grp1Name = `${geneName} ${dtTerm.name_noOrigin} ${dtTerm.origin ? `Mutated (${dtTerm.origin})` : "Mutated"}`;
    const values = dtTerm.values;
    const grp1Tvs = {
      term: dtTerm,
      values: Object.entries(values).map(([k, v]) => {
        return { key: k, label: v.label, value: k };
      }),
      genotype: "variant",
      mcount: "any",
      excludeGeneName: true
    };
    const mafFilter = vocabApi.termdbConfig.queries?.snvindel?.mafFilter;
    if (dtTerm.dt == dtsnvindel && mafFilter) {
      grp1Tvs.mafFilter = mafFilter.filter;
    }
    const grp1Filter = getWrappedTvslst([{ type: "tvs", tvs: grp1Tvs }]);
    groupset2.groups.push({
      name: grp1Name,
      type: "filter",
      filter: grp1Filter,
      color: "#e75480"
    });
    const grp2Name = `${geneName} ${dtTerm.name_noOrigin} ${dtTerm.origin ? `Wildtype (${dtTerm.origin})` : "Wildtype"}`;
    const grp2Tvs = {
      term: dtTerm,
      values: [],
      genotype: "wt",
      excludeGeneName: true
    };
    const grp2Filter = getWrappedTvslst([{ type: "tvs", tvs: grp2Tvs }]);
    groupset2.groups.push({
      name: grp2Name,
      type: "filter",
      filter: grp2Filter,
      color: mclass["WT"].color
    });
  }
  async function getAllelicGroupset(groupset2) {
    const snvIndelTerm = term.childTerms.find((t2) => t2.dt == dtsnvindel);
    const cnvTerm = term.childTerms.find((t2) => t2.dt == dtcnv);
    if (!snvIndelTerm || !cnvTerm) throw "child dt terms of the allelic groupset not found";
    await getDtTermValues(snvIndelTerm, filter2, vocabApi);
    await getDtTermValues(cnvTerm, filter2, vocabApi);
    const homoDel = {
      type: "tvs",
      tvs: {
        term: cnvTerm,
        values: [],
        continuousCnv: true,
        cnvGainCutoff: 99,
        // set to very high number to get samples with loss events
        cnvLossCutoff: -1,
        cnvMaxLength: null,
        excludeGeneName: true
      }
    };
    const hetDel = {
      type: "tvs",
      tvs: {
        term: cnvTerm,
        values: [],
        continuousCnv: true,
        cnvGainCutoff: 99,
        // set to very high number to get samples with loss events
        cnvLossCutoff: -0.3,
        cnvMaxLength: null,
        excludeGeneName: true
      }
    };
    const mutatedValues = Object.entries(snvIndelTerm.values).filter(([k, _v]) => k != "Intron" && k != "Utr3").map(([k, v]) => {
      return { key: k, label: v.label, value: k };
    });
    const homoMut = {
      type: "tvs",
      tvs: {
        term: snvIndelTerm,
        values: mutatedValues,
        genotype: "variant",
        mcount: "any",
        mafFilter: getMafFilter("homo", vocabApi),
        excludeGeneName: true
      }
    };
    const hetMut = {
      type: "tvs",
      tvs: {
        term: snvIndelTerm,
        values: mutatedValues,
        genotype: "variant",
        mcount: "all",
        mafFilter: getMafFilter("het", vocabApi),
        excludeGeneName: true
      }
    };
    const biallelicGroup = {
      name: "Bi-allelic alteration",
      type: "filter",
      filter: {
        type: "tvslst",
        in: true,
        join: "or",
        lst: [
          homoDel,
          {
            type: "tvslst",
            in: true,
            join: "and",
            lst: [hetDel, hetMut]
          },
          homoMut
        ]
      },
      color: "#d10000"
    };
    const monoallelicGroup = {
      name: "Mono-allelic alteration",
      type: "filter",
      filter: {
        type: "tvslst",
        in: true,
        join: "or",
        lst: [hetDel, hetMut]
      },
      color: "#7489d2"
    };
    groupset2.groups = [biallelicGroup, monoallelicGroup];
  }
}
function isEligibleForAllelicGroupset(term, vocabApi) {
  const queries = vocabApi.termdbConfig.queries;
  if (!queries || !queries.snvindel || !queries.cnv) return false;
  if (!queries.snvindel?.mafFilter) return false;
  if (!("cnvGainCutoff" in queries.cnv) && !("cnvLossCutoff" in queries.cnv)) return false;
  if (!term.childTerms) throw new Error("term.childTerms[] is missing");
  const snvIndelTerm = term.childTerms.find((t2) => t2.dt == dtsnvindel);
  const cnvTerm = term.childTerms.find((t2) => t2.dt == dtcnv);
  if (!snvIndelTerm || !cnvTerm) return false;
  if (snvIndelTerm.origin || cnvTerm.origin) return false;
  return true;
}
function isCustomizedGvQ(q) {
  return q?.type == "custom-groupset" && !!q.customset?.groups?.length;
}
function getGvQLabel(term, q) {
  if (q?.type == "custom-groupset") {
    const names = q.customset?.groups?.map((group) => group.name).filter((name) => name);
    return names?.length ? names.join(" / ") : "custom groups";
  }
  if (q?.type == "predefined-groupset") {
    const groupset = term?.groupsetting?.lst?.[q.predefined_groupset_idx];
    return groupset?.name || "predefined groups";
  }
  return "any variant class";
}
function getMafFilter(genotype, vocabApi) {
  const mafFilter = vocabApi.termdbConfig.queries.snvindel.mafFilter;
  if (!mafFilter) throw new Error("mafFilter is missing");
  const mafTerm = mafFilter.terms.find((t2) => t2.default);
  if (!mafTerm) throw new Error("no default mafTerm found");
  if (genotype != "homo" && genotype != "het") throw new Error("unexpected genotype value");
  const range2 = genotype == "homo" ? {
    start: 0.6,
    startinclusive: true,
    startunbounded: false,
    stopunbounded: true
  } : {
    stop: 0.6,
    stopinclusive: false,
    startunbounded: true,
    stopunbounded: false
  };
  return {
    type: "tvslst",
    join: "",
    in: true,
    lst: [
      {
        type: "tvs",
        tvs: {
          term: mafTerm,
          ranges: [range2]
        }
      }
    ]
  };
}

// tw/TwRouter.ts
var routedTermTypes = /* @__PURE__ */ new Set([
  CATEGORICAL,
  INTEGER,
  FLOAT,
  GENE_VARIANT,
  GENE_EXPRESSION,
  ISOFORM_EXPRESSION,
  JUNCTION,
  DATE,
  METABOLITE_INTENSITY,
  PROTEOME_ABUNDANCE,
  SSGSEA,
  SNP,
  SINGLECELL_GENE_EXPRESSION,
  SINGLECELL_CELLTYPE,
  PSEUDOBULK,
  TERM_COLLECTION,
  DNA_METHYLATION
]);
var TwRouter = class _TwRouter {
  constructor(opts) {
    this.opts = opts;
  }
  static init(tw, opts = {}) {
    switch (tw.type) {
      case "NumTWRegularBin":
        return new NumRegularBin(tw, opts);
      case "NumTWCustomBin":
        return new NumCustomBins(tw, opts);
      case "NumTWCont":
        return new NumCont(tw, opts);
      case "NumTWSpline":
        return new NumSpline(tw, opts);
      case "GvValuesTW":
        return new GvValues(tw, opts);
      case "GvPredefinedGsTW":
        return new GvPredefinedGS(tw, opts);
      case "GvCustomGsTW":
        return new GvCustomGS(tw, opts);
      case "QualTWValues":
        return new QualValues(tw, opts);
      case "QualTWPredefinedGS":
        return new QualPredefinedGS(tw, opts);
      case "QualTWCustomGS":
        return new QualCustomGS(tw, opts);
      case "TermCollectionTWCont":
        return new CollectionCont(tw, opts);
      case "TermCollectionTWFraction":
        return new CollectionFraction(tw, opts);
      case "TermCollectionTWQual":
        return new CollectionQual(tw, opts);
      default:
        throw `unable to init(tw)`;
    }
  }
  static async initRaw(rawTw, opts = {}) {
    const tw = await _TwRouter.fill(rawTw, opts);
    const xtw = _TwRouter.init(tw, opts);
    if (!xtw.$id) xtw.$id = await get$id2(xtw.getMinCopy());
    return xtw;
  }
  static async fill(tw, opts = {}) {
    await _TwRouter.preprocess(tw, opts?.vocabApi);
    const type = tw.term.type == "float" || tw.term.type == "integer" ? "numeric" : tw.term.type;
    opts.defaultQ = opts.defaultQByTsHandler?.[type] || null;
    switch (tw.term.type) {
      case "categorical":
      case SINGLECELL_CELLTYPE:
      case "snp": {
        const { QualitativeBase: QualitativeBase2 } = await import("./qualitative-H72GEWTZ.js");
        return await QualitativeBase2.fill(tw, opts);
      }
      case "integer":
      case "float":
      case "geneExpression":
      case "isoformExpression":
      case JUNCTION:
      case "metaboliteIntensity":
      case "proteomeAbundance":
      case "date":
      case "ssGSEA":
      case SINGLECELL_GENE_EXPRESSION:
      case PSEUDOBULK:
      case "dnaMethylation":
        return await NumericBase.fill(tw, opts);
      // case 'condition':
      // 	return
      // case 'survival':
      // 	return
      case "geneVariant":
        return await GvBase.fill(tw, opts);
      case "termCollection":
        return await CollectionBase.fill(tw, opts);
      default:
        throw `unrecognized tw.term?.type='${tw.term?.type}'`;
    }
  }
  // can reuse this function to generate valid preprocessed tw
  // for term-type specific unit tests
  static async preprocess(tw, vocabApi) {
    const keys = Object.keys(tw);
    if (!keys.length) throw `empty tw object`;
    if (tw.id && !tw.term) {
      await mayHydrateDictTwLst([tw], vocabApi);
      delete tw.id;
    }
    if (!tw.q) tw.q = {};
    if (!tw.q.isAtomic) tw.q.isAtomic = true;
    _TwRouter.reshapeLegacyTw(tw);
  }
  // check for legacy tw structure that could be
  // present in old saved sessions
  static reshapeLegacyTw(tw) {
    if (Object.keys(tw.q).includes("groupsetting")) {
      if (!tw.q.groupsetting.inuse) {
        tw.q.type = "values";
      } else if (tw.q.type == "predefined-groupset") {
        tw.q.predefined_groupset_idx = tw.q.groupsetting.predefined_groupset_idx;
      } else if (tw.q.type == "custom-groupset") {
        tw.q.customset = tw.q.groupsetting.customset;
      } else {
        throw "invalid q.type";
      }
      delete tw.q["groupsetting"];
    }
  }
};

// import("./handlers/**/*.ts") in termsetting/utils.ts
var globImport_handlers_ts2 = __glob({
  "./handlers/NumBinaryEditor.ts": () => import("./NumBinaryEditor-V3YCDNRR.js"),
  "./handlers/NumContEditor.ts": () => import("./NumContEditor-FSHA32UV.js"),
  "./handlers/NumCustomBinEditor.ts": () => import("./NumCustomBinEditor-63YQZU52.js"),
  "./handlers/NumDiscreteEditor.ts": () => import("./NumDiscreteEditor-K4AZ6UQF.js"),
  "./handlers/NumRegularBinEditor.ts": () => import("./NumRegularBinEditor-5N3PWOIQ.js"),
  "./handlers/NumSplineEditor.ts": () => import("./NumSplineEditor-ZLB5MWYK.js"),
  "./handlers/NumericDensity.ts": () => import("./NumericDensity-K4CTMN2G.js"),
  "./handlers/NumericHandler.ts": () => import("./NumericHandler-3KACLCOL.js"),
  "./handlers/condition.ts": () => import("./condition-SFZAHMKK.js"),
  "./handlers/geneVariant.ts": () => import("./geneVariant-ZVOUFF27.js"),
  "./handlers/multivalue.ts": () => import("./multivalue-GLE6G3ZO.js"),
  "./handlers/qualitative.ts": () => import("./qualitative-LNRKYTK3.js"),
  "./handlers/samplelst.ts": () => import("./samplelst-3ZWV4XZQ.js"),
  "./handlers/snplocus.ts": () => import("./snplocus-4VWXVQGS.js"),
  "./handlers/snplst.sampleSum.ts": () => import("./snplst.sampleSum-KW245SY2.js"),
  "./handlers/snplst.ts": () => import("./snplst-IE3S5PE2.js"),
  "./handlers/survival.ts": () => import("./survival-GT4CSHX2.js"),
  "./handlers/termCollection.ts": () => import("./termCollection-Y7CIC6GQ.js"),
  "./handlers/test/NumBinaryEditor.unit.spec.ts": () => import("./NumBinaryEditor.unit.spec-IVY27SEV.js"),
  "./handlers/test/NumContEditor.unit.spec.ts": () => import("./NumContEditor.unit.spec-5IFB4GXP.js"),
  "./handlers/test/NumCustomBinEditor.unit.spec.ts": () => import("./NumCustomBinEditor.unit.spec-BJLGQQ4R.js"),
  "./handlers/test/NumDiscreteEditor.unit.spec.ts": () => import("./NumDiscreteEditor.unit.spec-AHL7QA4N.js"),
  "./handlers/test/NumRegularBinEditor.unit.spec.ts": () => import("./NumRegularBinEditor.unit.spec-SYPTBY5A.js"),
  "./handlers/test/NumSplineEditor.unit.spec.ts": () => import("./NumSplineEditor.unit.spec-ZLAVLV7E.js"),
  "./handlers/test/NumericDensity.unit.spec.ts": () => import("./NumericDensity.unit.spec-BLWEQHZC.js"),
  "./handlers/test/NumericHandler.unit.spec.ts": () => import("./NumericHandler.unit.spec-4P7HBSCB.js")
});

// termsetting/utils.ts
var idSuffix2 = `_ts_${(+/* @__PURE__ */ new Date()).toString().slice(-8)}`;
var $id = 0;
async function get$id2(minTwCopy) {
  if (!minTwCopy) return `${$id++}${idSuffix2}`;
  delete minTwCopy.$id;
  const i3 = window.location.pathname == "/testrun.html" || window.location.pathname == "/puppet.html" ? "" : $id++;
  return await digestMessage(JSON.stringify(minTwCopy) + i3);
}
var encoder = new TextEncoder();
async function digestMessage(message) {
  const msgUint8 = encoder.encode(message);
  const hashBuffer = await crypto.subtle.digest("SHA-1", msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  return hexToBase64(hashHex).replace("=", "-");
}
function hexToBase64(hexStr) {
  return btoa(
    [...hexStr].reduce(
      (acc, _, i3) => acc += !(i3 - 1 & 1) ? String.fromCharCode(parseInt(hexStr.substring(i3 - 1, i3 + 1), 16)) : "",
      ""
    )
  );
}
function getPillNameDefault(self2, d) {
  if (!self2.opts.abbrCutoff) return d.name;
  return d.name.length <= self2.opts.abbrCutoff + 2 ? d.name : '<label title="' + d.name + '">' + d.name.substring(0, self2.opts.abbrCutoff) + "...</label>";
}
async function fillTwLst(twlst, vocabApi, defaultQByTsHandler) {
  await mayHydrateDictTwLst(twlst, vocabApi);
  const promises = [];
  for (const tw of twlst) {
    promises.push(fillTermWrapper(tw, vocabApi, defaultQByTsHandler));
  }
  await Promise.all(promises);
}
async function mayHydrateDictTwLst(twlst, vocabApi) {
  const ids = [];
  for (const tw of twlst) {
    if (tw.term) continue;
    if (tw.id === void 0 || tw.id === "") throw ".id is required";
    ids.push(tw.id);
  }
  const terms = ids.length ? await vocabApi.getTerms(ids) : {};
  for (const id3 of ids) {
    if (!terms[id3]) throw `missing dictionary term for id=${id3}`;
    for (const tw of twlst) {
      if (tw.id && tw.id in terms) tw.term = terms[tw.id];
    }
  }
}
async function mayUseTwRouterFill(tw, vocabApi, defaultQByTsHandler) {
  if (!routedTermTypes.has(tw.term?.type || "")) return false;
  if (tw.constructor.name != "Object") return tw;
  const xtw = await TwRouter.initRaw(tw, { vocabApi, defaultQByTsHandler });
  Object.assign(tw, xtw);
  mayValidateQmode(tw);
  if (!tw.$id) tw.$id = await get$id2(vocabApi.getTwMinCopy(tw));
  if (tw.q) tw.q.isAtomic = true;
  return xtw;
}
async function fillTermWrapper(tw, vocabApi, defaultQByTsHandler) {
  tw.isAtomic = true;
  if (!tw.term && tw.id) {
    await mayHydrateDictTwLst([tw], vocabApi);
  }
  const xtw = await mayUseTwRouterFill(tw, vocabApi, defaultQByTsHandler);
  if (xtw) return xtw;
  delete tw.id;
  if (!tw.q) tw.q = {};
  tw.q.isAtomic = true;
  checkLegacyTw(tw);
  await call_fillTW(tw, vocabApi, defaultQByTsHandler);
  mayValidateQmode(tw);
  if (!tw.$id) tw.$id = await get$id2(vocabApi.getTwMinCopy(tw));
  return tw;
}
function checkLegacyTw(tw) {
  if (Object.keys(tw.q).includes("groupsetting")) {
    if (tw.q["groupsetting"]["inuse"]) {
      if (tw.q.type == "predefined-groupset") {
        tw.q["predefined_groupset_idx"] = tw.q["groupsetting"]["predefined_groupset_idx"];
      } else if (tw.q.type == "custom-groupset") {
        tw.q["customset"] = tw.q["groupsetting"]["customset"];
      } else {
        throw "invalid q.type";
      }
    } else {
      tw.q.type = "values";
    }
    delete tw.q["groupsetting"];
  }
}
async function call_fillTW(tw, vocabApi, defaultQByTsHandler) {
  if (await mayUseTwRouterFill(tw, vocabApi, defaultQByTsHandler)) return;
  if (!tw.$id) tw.$id = await get$id2(vocabApi.getTwMinCopy(tw));
  const t2 = tw.term?.type || "";
  const type = t2 == "float" || t2 == "integer" || t2 == "date" ? "numeric" : t2;
  let _;
  if (tw.term?.type) {
    try {
      _ = await globImport_handlers_ts2(`./handlers/${type}.ts`);
    } catch (_e) {
      throw `Type ${type} does not exist`;
    }
  } else throw `Type not defined for ${JSON.stringify(tw)}`;
  await _.fillTW(tw, vocabApi, defaultQByTsHandler ? defaultQByTsHandler[type] : null);
}
function mayValidateQmode(tw) {
  if (!tw.q) return;
  if (!("mode" in tw.q)) {
    return;
  }
  if (typeof tw.q.mode != "string") throw "q.mode not string";
}
function set_hiddenvalues(q, term) {
  if (!q.hiddenValues) {
    q.hiddenValues = {};
    if (term.values) {
      for (const k in term.values) {
        if (term.values[k].uncomputable) q.hiddenValues[k] = 1;
      }
    }
  }
}

// node_modules/balanced-match/dist/esm/index.js
var balanced = (a, b, str) => {
  const ma = a instanceof RegExp ? maybeMatch(a, str) : a;
  const mb = b instanceof RegExp ? maybeMatch(b, str) : b;
  const r = ma !== null && mb != null && range(ma, mb, str);
  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + ma.length, r[1]),
    post: str.slice(r[1] + mb.length)
  };
};
var maybeMatch = (reg, str) => {
  const m = str.match(reg);
  return m ? m[0] : null;
};
var range = (a, b, str) => {
  let begs, beg, left, right = void 0, result;
  let ai = str.indexOf(a);
  let bi = str.indexOf(b, ai + 1);
  let i3 = ai;
  if (ai >= 0 && bi > 0) {
    if (a === b) {
      return [ai, bi];
    }
    begs = [];
    left = str.length;
    while (i3 >= 0 && !result) {
      if (i3 === ai) {
        begs.push(i3);
        ai = str.indexOf(a, i3 + 1);
      } else if (begs.length === 1) {
        const r = begs.pop();
        if (r !== void 0)
          result = [r, bi];
      } else {
        beg = begs.pop();
        if (beg !== void 0 && beg < left) {
          left = beg;
          right = bi;
        }
        bi = str.indexOf(b, i3 + 1);
      }
      i3 = ai < bi && ai >= 0 ? ai : bi;
    }
    if (begs.length && right !== void 0) {
      result = [left, right];
    }
  }
  return result;
};

// node_modules/brace-expansion/dist/esm/index.js
var escSlash = "\0SLASH" + Math.random() + "\0";
var escOpen = "\0OPEN" + Math.random() + "\0";
var escClose = "\0CLOSE" + Math.random() + "\0";
var escComma = "\0COMMA" + Math.random() + "\0";
var escPeriod = "\0PERIOD" + Math.random() + "\0";
var escSlashPattern = new RegExp(escSlash, "g");
var escOpenPattern = new RegExp(escOpen, "g");
var escClosePattern = new RegExp(escClose, "g");
var escCommaPattern = new RegExp(escComma, "g");
var escPeriodPattern = new RegExp(escPeriod, "g");
var slashPattern = /\\\\/g;
var openPattern = /\\{/g;
var closePattern = /\\}/g;
var commaPattern = /\\,/g;
var periodPattern = /\\\./g;
var EXPANSION_MAX = 1e5;
var EXPANSION_MAX_LENGTH = 4e6;
function numeric(str) {
  return !isNaN(str) ? parseInt(str, 10) : str.charCodeAt(0);
}
function escapeBraces(str) {
  return str.replace(slashPattern, escSlash).replace(openPattern, escOpen).replace(closePattern, escClose).replace(commaPattern, escComma).replace(periodPattern, escPeriod);
}
function unescapeBraces(str) {
  return str.replace(escSlashPattern, "\\").replace(escOpenPattern, "{").replace(escClosePattern, "}").replace(escCommaPattern, ",").replace(escPeriodPattern, ".");
}
function parseCommaParts(str) {
  if (!str) {
    return [""];
  }
  const parts = [];
  const m = balanced("{", "}", str);
  if (!m) {
    return str.split(",");
  }
  const { pre, body, post } = m;
  const p = pre.split(",");
  p[p.length - 1] += "{" + body + "}";
  const postParts = parseCommaParts(post);
  if (post.length) {
    ;
    p[p.length - 1] += postParts.shift();
    p.push.apply(p, postParts);
  }
  parts.push.apply(parts, p);
  return parts;
}
function expand(str, options = {}) {
  if (!str) {
    return [];
  }
  const { max = EXPANSION_MAX, maxLength = EXPANSION_MAX_LENGTH } = options;
  if (str.slice(0, 2) === "{}") {
    str = "\\{\\}" + str.slice(2);
  }
  return expand_(escapeBraces(str), max, maxLength, true).map(unescapeBraces);
}
function embrace(str) {
  return "{" + str + "}";
}
function isPadded(el) {
  return /^-?0\d/.test(el);
}
function lte(i3, y) {
  return i3 <= y;
}
function gte(i3, y) {
  return i3 >= y;
}
function combine(acc, pre, values, max, maxLength, dropEmpties) {
  const out = [];
  let length = 0;
  for (let a = 0; a < acc.length; a++) {
    for (let v = 0; v < values.length; v++) {
      if (out.length >= max)
        return out;
      const expansion = acc[a] + pre + values[v];
      if (dropEmpties && !expansion)
        continue;
      if (length + expansion.length > maxLength)
        return out;
      out.push(expansion);
      length += expansion.length;
    }
  }
  return out;
}
function expandSequence(body, isAlphaSequence, max, maxLength) {
  const n = body.split(/\.\./);
  const N = [];
  if (n[0] === void 0 || n[1] === void 0) {
    return N;
  }
  const x = numeric(n[0]);
  const y = numeric(n[1]);
  const width = Math.max(n[0].length, n[1].length);
  let incr = n.length === 3 && n[2] !== void 0 ? Math.max(Math.abs(numeric(n[2])), 1) : 1;
  let test = lte;
  const reverse = y < x;
  if (reverse) {
    incr *= -1;
    test = gte;
  }
  const pad = n.some(isPadded);
  let length = 0;
  for (let i3 = x; test(i3, y) && N.length < max; i3 += incr) {
    let c;
    if (isAlphaSequence) {
      c = String.fromCharCode(i3);
      if (c === "\\") {
        c = "";
      }
    } else {
      c = String(i3);
      if (pad) {
        const need = width - c.length;
        if (need > 0) {
          const z = new Array(need + 1).join("0");
          if (i3 < 0) {
            c = "-" + z + c.slice(1);
          } else {
            c = z + c;
          }
        }
      }
    }
    if (length + c.length > maxLength)
      break;
    N.push(c);
    length += c.length;
  }
  return N;
}
function expand_(str, max, maxLength, isTop) {
  let acc = [""];
  let dropEmpties = false;
  let firstGroup = true;
  for (; ; ) {
    const m = balanced("{", "}", str);
    if (!m) {
      return combine(acc, str, [""], max, maxLength, dropEmpties);
    }
    const pre = m.pre;
    if (/\$$/.test(pre)) {
      acc = combine(acc, pre + "{" + m.body + "}", [""], max, maxLength, dropEmpties && !m.post.length);
      firstGroup = false;
      if (!m.post.length)
        break;
      str = m.post;
      continue;
    }
    const isNumericSequence = /^-?\d+\.\.-?\d+(?:\.\.-?\d+)?$/.test(m.body);
    const isAlphaSequence = /^[a-zA-Z]\.\.[a-zA-Z](?:\.\.-?\d+)?$/.test(m.body);
    const isSequence = isNumericSequence || isAlphaSequence;
    const isOptions = m.body.indexOf(",") >= 0;
    if (!isSequence && !isOptions) {
      if (m.post.match(/,(?!,).*\}/)) {
        str = m.pre + "{" + m.body + escClose + m.post;
        isTop = true;
        continue;
      }
      return combine(acc, pre + "{" + m.body + "}" + m.post, [""], max, maxLength, dropEmpties);
    }
    if (firstGroup) {
      dropEmpties = isTop && !isSequence;
      firstGroup = false;
    }
    let values;
    if (isSequence) {
      values = expandSequence(m.body, isAlphaSequence, max, maxLength);
    } else {
      let n = parseCommaParts(m.body);
      if (n.length === 1 && n[0] !== void 0) {
        n = expand_(n[0], max, maxLength, false).map(embrace);
        if (n.length === 1) {
          acc = combine(acc, pre + n[0], [""], max, maxLength, dropEmpties && !m.post.length);
          if (!m.post.length)
            break;
          str = m.post;
          continue;
        }
      }
      let dropsEmpties = dropEmpties && !m.post.length && !pre;
      for (let d = 0; dropsEmpties && d < acc.length; d++) {
        if (acc[d]) {
          dropsEmpties = false;
        }
      }
      values = [];
      let valuesLength = 0;
      outer: for (let j = 0; j < n.length; j++) {
        const expanded = expand_(n[j], max, maxLength, false);
        for (let k = 0; k < expanded.length; k++) {
          const v = expanded[k];
          if (dropsEmpties && !v)
            continue;
          if (values.length >= max || valuesLength + v.length > maxLength) {
            break outer;
          }
          values.push(v);
          valuesLength += v.length;
        }
      }
    }
    acc = combine(acc, pre, values, max, maxLength, dropEmpties && !m.post.length);
    if (!m.post.length)
      break;
    str = m.post;
  }
  return acc;
}

// node_modules/minimatch/dist/esm/assert-valid-pattern.js
var MAX_PATTERN_LENGTH = 1024 * 64;
var assertValidPattern = (pattern) => {
  if (typeof pattern !== "string") {
    throw new TypeError("invalid pattern");
  }
  if (pattern.length > MAX_PATTERN_LENGTH) {
    throw new TypeError("pattern is too long");
  }
};

// node_modules/minimatch/dist/esm/brace-expressions.js
var posixClasses = {
  "[:alnum:]": ["\\p{L}\\p{Nl}\\p{Nd}", true],
  "[:alpha:]": ["\\p{L}\\p{Nl}", true],
  "[:ascii:]": ["\\x00-\\x7f", false],
  "[:blank:]": ["\\p{Zs}\\t", true],
  "[:cntrl:]": ["\\p{Cc}", true],
  "[:digit:]": ["\\p{Nd}", true],
  "[:graph:]": ["\\p{Z}\\p{C}", true, true],
  "[:lower:]": ["\\p{Ll}", true],
  "[:print:]": ["\\p{C}", true],
  "[:punct:]": ["\\p{P}", true],
  "[:space:]": ["\\p{Z}\\t\\r\\n\\v\\f", true],
  "[:upper:]": ["\\p{Lu}", true],
  "[:word:]": ["\\p{L}\\p{Nl}\\p{Nd}\\p{Pc}", true],
  "[:xdigit:]": ["A-Fa-f0-9", false]
};
var braceEscape = (s) => s.replace(/[[\]\\-]/g, "\\$&");
var regexpEscape = (s) => s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
var rangesToString = (ranges) => ranges.join("");
var parseClass = (glob, position) => {
  const pos = position;
  if (glob.charAt(pos) !== "[") {
    throw new Error("not in a brace expression");
  }
  const ranges = [];
  const negs = [];
  let i3 = pos + 1;
  let sawStart = false;
  let uflag = false;
  let escaping = false;
  let negate = false;
  let endPos = pos;
  let rangeStart = "";
  WHILE: while (i3 < glob.length) {
    const c = glob.charAt(i3);
    if ((c === "!" || c === "^") && i3 === pos + 1) {
      negate = true;
      i3++;
      continue;
    }
    if (c === "]" && sawStart && !escaping) {
      endPos = i3 + 1;
      break;
    }
    sawStart = true;
    if (c === "\\") {
      if (!escaping) {
        escaping = true;
        i3++;
        continue;
      }
    }
    if (c === "[" && !escaping) {
      for (const [cls, [unip, u, neg]] of Object.entries(posixClasses)) {
        if (glob.startsWith(cls, i3)) {
          if (rangeStart) {
            return ["$.", false, glob.length - pos, true];
          }
          i3 += cls.length;
          if (neg)
            negs.push(unip);
          else
            ranges.push(unip);
          uflag = uflag || u;
          continue WHILE;
        }
      }
    }
    escaping = false;
    if (rangeStart) {
      if (c > rangeStart) {
        ranges.push(braceEscape(rangeStart) + "-" + braceEscape(c));
      } else if (c === rangeStart) {
        ranges.push(braceEscape(c));
      }
      rangeStart = "";
      i3++;
      continue;
    }
    if (glob.startsWith("-]", i3 + 1)) {
      ranges.push(braceEscape(c + "-"));
      i3 += 2;
      continue;
    }
    if (glob.startsWith("-", i3 + 1)) {
      rangeStart = c;
      i3 += 2;
      continue;
    }
    ranges.push(braceEscape(c));
    i3++;
  }
  if (endPos < i3) {
    return ["", false, 0, false];
  }
  if (!ranges.length && !negs.length) {
    return ["$.", false, glob.length - pos, true];
  }
  if (negs.length === 0 && ranges.length === 1 && /^\\?.$/.test(ranges[0]) && !negate) {
    const r = ranges[0].length === 2 ? ranges[0].slice(-1) : ranges[0];
    return [regexpEscape(r), false, endPos - pos, false];
  }
  const sranges = "[" + (negate ? "^" : "") + rangesToString(ranges) + "]";
  const snegs = "[" + (negate ? "" : "^") + rangesToString(negs) + "]";
  const comb = ranges.length && negs.length ? "(" + sranges + "|" + snegs + ")" : ranges.length ? sranges : snegs;
  return [comb, uflag, endPos - pos, true];
};

// node_modules/minimatch/dist/esm/unescape.js
var unescape = (s, { windowsPathsNoEscape = false, magicalBraces = true } = {}) => {
  if (magicalBraces) {
    return windowsPathsNoEscape ? s.replace(/\[([^/\\])\]/g, "$1") : s.replace(/((?!\\).|^)\[([^/\\])\]/g, "$1$2").replace(/\\([^/])/g, "$1");
  }
  return windowsPathsNoEscape ? s.replace(/\[([^/\\{}])\]/g, "$1") : s.replace(/((?!\\).|^)\[([^/\\{}])\]/g, "$1$2").replace(/\\([^/{}])/g, "$1");
};

// node_modules/minimatch/dist/esm/ast.js
var _a;
var types = /* @__PURE__ */ new Set(["!", "?", "+", "*", "@"]);
var isExtglobType = (c) => types.has(c);
var isExtglobAST = (c) => isExtglobType(c.type);
var adoptionMap = /* @__PURE__ */ new Map([
  ["!", ["@"]],
  ["?", ["?", "@"]],
  ["@", ["@"]],
  ["*", ["*", "+", "?", "@"]],
  ["+", ["+", "@"]]
]);
var adoptionWithSpaceMap = /* @__PURE__ */ new Map([
  ["!", ["?"]],
  ["@", ["?"]],
  ["+", ["?", "*"]]
]);
var adoptionAnyMap = /* @__PURE__ */ new Map([
  ["!", ["?", "@"]],
  ["?", ["?", "@"]],
  ["@", ["?", "@"]],
  ["*", ["*", "+", "?", "@"]],
  ["+", ["+", "@", "?", "*"]]
]);
var usurpMap = /* @__PURE__ */ new Map([
  ["!", /* @__PURE__ */ new Map([["!", "@"]])],
  [
    "?",
    /* @__PURE__ */ new Map([
      ["*", "*"],
      ["+", "*"]
    ])
  ],
  [
    "@",
    /* @__PURE__ */ new Map([
      ["!", "!"],
      ["?", "?"],
      ["@", "@"],
      ["*", "*"],
      ["+", "+"]
    ])
  ],
  [
    "+",
    /* @__PURE__ */ new Map([
      ["?", "*"],
      ["*", "*"]
    ])
  ]
]);
var startNoTraversal = "(?!(?:^|/)\\.\\.?(?:$|/))";
var startNoDot = "(?!\\.)";
var addPatternStart = /* @__PURE__ */ new Set(["[", "."]);
var justDots = /* @__PURE__ */ new Set(["..", "."]);
var reSpecials = new Set("().*{}+?[]^$\\!");
var regExpEscape = (s) => s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
var qmark = "[^/]";
var star = qmark + "*?";
var starNoEmpty = qmark + "+?";
var ID = 0;
var AST = class {
  type;
  #root;
  #hasMagic;
  #uflag = false;
  #parts = [];
  #parent;
  #parentIndex;
  #negs;
  #filledNegs = false;
  #options;
  #toString;
  // set to true if it's an extglob with no children
  // (which really means one child of '')
  #emptyExt = false;
  id = ++ID;
  get depth() {
    return (this.#parent?.depth ?? -1) + 1;
  }
  [/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")]() {
    return {
      "@@type": "AST",
      id: this.id,
      type: this.type,
      root: this.#root.id,
      parent: this.#parent?.id,
      depth: this.depth,
      partsLength: this.#parts.length,
      parts: this.#parts
    };
  }
  constructor(type, parent, options = {}) {
    this.type = type;
    if (type)
      this.#hasMagic = true;
    this.#parent = parent;
    this.#root = this.#parent ? this.#parent.#root : this;
    this.#options = this.#root === this ? options : this.#root.#options;
    this.#negs = this.#root === this ? [] : this.#root.#negs;
    if (type === "!" && !this.#root.#filledNegs)
      this.#negs.push(this);
    this.#parentIndex = this.#parent ? this.#parent.#parts.length : 0;
  }
  get hasMagic() {
    if (this.#hasMagic !== void 0)
      return this.#hasMagic;
    for (const p of this.#parts) {
      if (typeof p === "string")
        continue;
      if (p.type || p.hasMagic)
        return this.#hasMagic = true;
    }
    return this.#hasMagic;
  }
  // reconstructs the pattern
  toString() {
    return this.#toString !== void 0 ? this.#toString : !this.type ? this.#toString = this.#parts.map((p) => String(p)).join("") : this.#toString = this.type + "(" + this.#parts.map((p) => String(p)).join("|") + ")";
  }
  #fillNegs() {
    if (this !== this.#root)
      throw new Error("should only call on root");
    if (this.#filledNegs)
      return this;
    this.toString();
    this.#filledNegs = true;
    let n;
    while (n = this.#negs.pop()) {
      if (n.type !== "!")
        continue;
      let p = n;
      let pp = p.#parent;
      while (pp) {
        for (let i3 = p.#parentIndex + 1; !pp.type && i3 < pp.#parts.length; i3++) {
          for (const part of n.#parts) {
            if (typeof part === "string") {
              throw new Error("string part in extglob AST??");
            }
            part.copyIn(pp.#parts[i3]);
          }
        }
        p = pp;
        pp = p.#parent;
      }
    }
    return this;
  }
  push(...parts) {
    for (const p of parts) {
      if (p === "")
        continue;
      if (typeof p !== "string" && !(p instanceof _a && p.#parent === this)) {
        throw new Error("invalid part: " + p);
      }
      this.#parts.push(p);
    }
  }
  toJSON() {
    const ret = this.type === null ? this.#parts.slice().map((p) => typeof p === "string" ? p : p.toJSON()) : [this.type, ...this.#parts.map((p) => p.toJSON())];
    if (this.isStart() && !this.type)
      ret.unshift([]);
    if (this.isEnd() && (this === this.#root || this.#root.#filledNegs && this.#parent?.type === "!")) {
      ret.push({});
    }
    return ret;
  }
  isStart() {
    if (this.#root === this)
      return true;
    if (!this.#parent?.isStart())
      return false;
    if (this.#parentIndex === 0)
      return true;
    const p = this.#parent;
    for (let i3 = 0; i3 < this.#parentIndex; i3++) {
      const pp = p.#parts[i3];
      if (!(pp instanceof _a && pp.type === "!")) {
        return false;
      }
    }
    return true;
  }
  isEnd() {
    if (this.#root === this)
      return true;
    if (this.#parent?.type === "!")
      return true;
    if (!this.#parent?.isEnd())
      return false;
    if (!this.type)
      return this.#parent?.isEnd();
    const pl = this.#parent ? this.#parent.#parts.length : 0;
    return this.#parentIndex === pl - 1;
  }
  copyIn(part) {
    if (typeof part === "string")
      this.push(part);
    else
      this.push(part.clone(this));
  }
  clone(parent) {
    const c = new _a(this.type, parent);
    for (const p of this.#parts) {
      c.copyIn(p);
    }
    return c;
  }
  static #parseAST(str, ast, pos, opt, extDepth) {
    const maxDepth = opt.maxExtglobRecursion ?? 2;
    let escaping = false;
    let inBrace = false;
    let braceStart = -1;
    let braceNeg = false;
    if (ast.type === null) {
      let i4 = pos;
      let acc2 = "";
      while (i4 < str.length) {
        const c = str.charAt(i4++);
        if (escaping || c === "\\") {
          escaping = !escaping;
          acc2 += c;
          continue;
        }
        if (inBrace) {
          if (i4 === braceStart + 1) {
            if (c === "^" || c === "!") {
              braceNeg = true;
            }
          } else if (c === "]" && !(i4 === braceStart + 2 && braceNeg)) {
            inBrace = false;
          }
          acc2 += c;
          continue;
        } else if (c === "[") {
          inBrace = true;
          braceStart = i4;
          braceNeg = false;
          acc2 += c;
          continue;
        }
        const doRecurse = !opt.noext && isExtglobType(c) && str.charAt(i4) === "(" && extDepth <= maxDepth;
        if (doRecurse) {
          ast.push(acc2);
          acc2 = "";
          const ext2 = new _a(c, ast);
          i4 = _a.#parseAST(str, ext2, i4, opt, extDepth + 1);
          ast.push(ext2);
          continue;
        }
        acc2 += c;
      }
      ast.push(acc2);
      return i4;
    }
    let i3 = pos + 1;
    let part = new _a(null, ast);
    const parts = [];
    let acc = "";
    while (i3 < str.length) {
      const c = str.charAt(i3++);
      if (escaping || c === "\\") {
        escaping = !escaping;
        acc += c;
        continue;
      }
      if (inBrace) {
        if (i3 === braceStart + 1) {
          if (c === "^" || c === "!") {
            braceNeg = true;
          }
        } else if (c === "]" && !(i3 === braceStart + 2 && braceNeg)) {
          inBrace = false;
        }
        acc += c;
        continue;
      } else if (c === "[") {
        inBrace = true;
        braceStart = i3;
        braceNeg = false;
        acc += c;
        continue;
      }
      const doRecurse = !opt.noext && isExtglobType(c) && str.charAt(i3) === "(" && /* c8 ignore start - the maxDepth is sufficient here */
      (extDepth <= maxDepth || ast && ast.#canAdoptType(c));
      if (doRecurse) {
        const depthAdd = ast && ast.#canAdoptType(c) ? 0 : 1;
        part.push(acc);
        acc = "";
        const ext2 = new _a(c, part);
        part.push(ext2);
        i3 = _a.#parseAST(str, ext2, i3, opt, extDepth + depthAdd);
        continue;
      }
      if (c === "|") {
        part.push(acc);
        acc = "";
        parts.push(part);
        part = new _a(null, ast);
        continue;
      }
      if (c === ")") {
        if (acc === "" && ast.#parts.length === 0) {
          ast.#emptyExt = true;
        }
        part.push(acc);
        acc = "";
        ast.push(...parts, part);
        return i3;
      }
      acc += c;
    }
    ast.type = null;
    ast.#hasMagic = void 0;
    ast.#parts = [str.substring(pos - 1)];
    return i3;
  }
  #canAdoptWithSpace(child) {
    return this.#canAdopt(child, adoptionWithSpaceMap);
  }
  #canAdopt(child, map = adoptionMap) {
    if (!child || typeof child !== "object" || child.type !== null || child.#parts.length !== 1 || this.type === null) {
      return false;
    }
    const gc = child.#parts[0];
    if (!gc || typeof gc !== "object" || gc.type === null) {
      return false;
    }
    return this.#canAdoptType(gc.type, map);
  }
  #canAdoptType(c, map = adoptionAnyMap) {
    return !!map.get(this.type)?.includes(c);
  }
  #adoptWithSpace(child, index) {
    const gc = child.#parts[0];
    const blank = new _a(null, gc, this.options);
    blank.#parts.push("");
    gc.push(blank);
    this.#adopt(child, index);
  }
  #adopt(child, index) {
    const gc = child.#parts[0];
    this.#parts.splice(index, 1, ...gc.#parts);
    for (const p of gc.#parts) {
      if (typeof p === "object")
        p.#parent = this;
    }
    this.#toString = void 0;
  }
  #canUsurpType(c) {
    const m = usurpMap.get(this.type);
    return !!m?.has(c);
  }
  #canUsurp(child) {
    if (!child || typeof child !== "object" || child.type !== null || child.#parts.length !== 1 || this.type === null || this.#parts.length !== 1) {
      return false;
    }
    const gc = child.#parts[0];
    if (!gc || typeof gc !== "object" || gc.type === null) {
      return false;
    }
    return this.#canUsurpType(gc.type);
  }
  #usurp(child) {
    const m = usurpMap.get(this.type);
    const gc = child.#parts[0];
    const nt = m?.get(gc.type);
    if (!nt)
      return false;
    this.#parts = gc.#parts;
    for (const p of this.#parts) {
      if (typeof p === "object") {
        p.#parent = this;
      }
    }
    this.type = nt;
    this.#toString = void 0;
    this.#emptyExt = false;
  }
  static fromGlob(pattern, options = {}) {
    const ast = new _a(null, void 0, options);
    _a.#parseAST(pattern, ast, 0, options, 0);
    return ast;
  }
  // returns the regular expression if there's magic, or the unescaped
  // string if not.
  toMMPattern() {
    if (this !== this.#root)
      return this.#root.toMMPattern();
    const glob = this.toString();
    const [re, body, hasMagic, uflag] = this.toRegExpSource();
    const anyMagic = hasMagic || this.#hasMagic || this.#options.nocase && !this.#options.nocaseMagicOnly && glob.toUpperCase() !== glob.toLowerCase();
    if (!anyMagic) {
      return body;
    }
    const flags = (this.#options.nocase ? "i" : "") + (uflag ? "u" : "");
    return Object.assign(new RegExp(`^${re}$`, flags), {
      _src: re,
      _glob: glob
    });
  }
  get options() {
    return this.#options;
  }
  // returns the string match, the regexp source, whether there's magic
  // in the regexp (so a regular expression is required) and whether or
  // not the uflag is needed for the regular expression (for posix classes)
  // TODO: instead of injecting the start/end at this point, just return
  // the BODY of the regexp, along with the start/end portions suitable
  // for binding the start/end in either a joined full-path makeRe context
  // (where we bind to (^|/), or a standalone matchPart context (where
  // we bind to ^, and not /).  Otherwise slashes get duped!
  //
  // In part-matching mode, the start is:
  // - if not isStart: nothing
  // - if traversal possible, but not allowed: ^(?!\.\.?$)
  // - if dots allowed or not possible: ^
  // - if dots possible and not allowed: ^(?!\.)
  // end is:
  // - if not isEnd(): nothing
  // - else: $
  //
  // In full-path matching mode, we put the slash at the START of the
  // pattern, so start is:
  // - if first pattern: same as part-matching mode
  // - if not isStart(): nothing
  // - if traversal possible, but not allowed: /(?!\.\.?(?:$|/))
  // - if dots allowed or not possible: /
  // - if dots possible and not allowed: /(?!\.)
  // end is:
  // - if last pattern, same as part-matching mode
  // - else nothing
  //
  // Always put the (?:$|/) on negated tails, though, because that has to be
  // there to bind the end of the negated pattern portion, and it's easier to
  // just stick it in now rather than try to inject it later in the middle of
  // the pattern.
  //
  // We can just always return the same end, and leave it up to the caller
  // to know whether it's going to be used joined or in parts.
  // And, if the start is adjusted slightly, can do the same there:
  // - if not isStart: nothing
  // - if traversal possible, but not allowed: (?:/|^)(?!\.\.?$)
  // - if dots allowed or not possible: (?:/|^)
  // - if dots possible and not allowed: (?:/|^)(?!\.)
  //
  // But it's better to have a simpler binding without a conditional, for
  // performance, so probably better to return both start options.
  //
  // Then the caller just ignores the end if it's not the first pattern,
  // and the start always gets applied.
  //
  // But that's always going to be $ if it's the ending pattern, or nothing,
  // so the caller can just attach $ at the end of the pattern when building.
  //
  // So the todo is:
  // - better detect what kind of start is needed
  // - return both flavors of starting pattern
  // - attach $ at the end of the pattern when creating the actual RegExp
  //
  // Ah, but wait, no, that all only applies to the root when the first pattern
  // is not an extglob. If the first pattern IS an extglob, then we need all
  // that dot prevention biz to live in the extglob portions, because eg
  // +(*|.x*) can match .xy but not .yx.
  //
  // So, return the two flavors if it's #root and the first child is not an
  // AST, otherwise leave it to the child AST to handle it, and there,
  // use the (?:^|/) style of start binding.
  //
  // Even simplified further:
  // - Since the start for a join is eg /(?!\.) and the start for a part
  // is ^(?!\.), we can just prepend (?!\.) to the pattern (either root
  // or start or whatever) and prepend ^ or / at the Regexp construction.
  toRegExpSource(allowDot) {
    const dot = allowDot ?? !!this.#options.dot;
    if (this.#root === this) {
      this.#flatten();
      this.#fillNegs();
    }
    if (!isExtglobAST(this)) {
      const noEmpty = this.isStart() && this.isEnd() && !this.#parts.some((s) => typeof s !== "string");
      const src = this.#parts.map((p) => {
        const [re, _, hasMagic, uflag] = typeof p === "string" ? _a.#parseGlob(p, this.#hasMagic, noEmpty) : p.toRegExpSource(allowDot);
        this.#hasMagic = this.#hasMagic || hasMagic;
        this.#uflag = this.#uflag || uflag;
        return re;
      }).join("");
      let start2 = "";
      if (this.isStart()) {
        if (typeof this.#parts[0] === "string") {
          const dotTravAllowed = this.#parts.length === 1 && justDots.has(this.#parts[0]);
          if (!dotTravAllowed) {
            const aps = addPatternStart;
            const needNoTrav = (
              // dots are allowed, and the pattern starts with [ or .
              dot && aps.has(src.charAt(0)) || // the pattern starts with \., and then [ or .
              src.startsWith("\\.") && aps.has(src.charAt(2)) || // the pattern starts with \.\., and then [ or .
              src.startsWith("\\.\\.") && aps.has(src.charAt(4))
            );
            const needNoDot = !dot && !allowDot && aps.has(src.charAt(0));
            start2 = needNoTrav ? startNoTraversal : needNoDot ? startNoDot : "";
          }
        }
      }
      let end = "";
      if (this.isEnd() && this.#root.#filledNegs && this.#parent?.type === "!") {
        end = "(?:$|\\/)";
      }
      const final2 = start2 + src + end;
      return [
        final2,
        unescape(src),
        this.#hasMagic = !!this.#hasMagic,
        this.#uflag
      ];
    }
    const repeated = this.type === "*" || this.type === "+";
    const start = this.type === "!" ? "(?:(?!(?:" : "(?:";
    let body = this.#partsToRegExp(dot);
    if (this.isStart() && this.isEnd() && !body && this.type !== "!") {
      const s = this.toString();
      const me = this;
      me.#parts = [s];
      me.type = null;
      me.#hasMagic = void 0;
      return [s, unescape(this.toString()), false, false];
    }
    let bodyDotAllowed = !repeated || allowDot || dot || !startNoDot ? "" : this.#partsToRegExp(true);
    if (bodyDotAllowed === body) {
      bodyDotAllowed = "";
    }
    if (bodyDotAllowed) {
      body = `(?:${body})(?:${bodyDotAllowed})*?`;
    }
    let final = "";
    if (this.type === "!" && this.#emptyExt) {
      final = (this.isStart() && !dot ? startNoDot : "") + starNoEmpty;
    } else {
      const close = this.type === "!" ? (
        // !() must match something,but !(x) can match ''
        "))" + (this.isStart() && !dot && !allowDot ? startNoDot : "") + star + ")"
      ) : this.type === "@" ? ")" : this.type === "?" ? ")?" : this.type === "+" && bodyDotAllowed ? ")" : this.type === "*" && bodyDotAllowed ? `)?` : `)${this.type}`;
      final = start + body + close;
    }
    return [
      final,
      unescape(body),
      this.#hasMagic = !!this.#hasMagic,
      this.#uflag
    ];
  }
  #flatten() {
    if (!isExtglobAST(this)) {
      for (const p of this.#parts) {
        if (typeof p === "object") {
          p.#flatten();
        }
      }
    } else {
      let iterations = 0;
      let done = false;
      do {
        done = true;
        for (let i3 = 0; i3 < this.#parts.length; i3++) {
          const c = this.#parts[i3];
          if (typeof c === "object") {
            c.#flatten();
            if (this.#canAdopt(c)) {
              done = false;
              this.#adopt(c, i3);
            } else if (this.#canAdoptWithSpace(c)) {
              done = false;
              this.#adoptWithSpace(c, i3);
            } else if (this.#canUsurp(c)) {
              done = false;
              this.#usurp(c);
            }
          }
        }
      } while (!done && ++iterations < 10);
    }
    this.#toString = void 0;
  }
  #partsToRegExp(dot) {
    return this.#parts.map((p) => {
      if (typeof p === "string") {
        throw new Error("string type in extglob ast??");
      }
      const [re, _, _hasMagic, uflag] = p.toRegExpSource(dot);
      this.#uflag = this.#uflag || uflag;
      return re;
    }).filter((p) => !(this.isStart() && this.isEnd()) || !!p).join("|");
  }
  static #parseGlob(glob, hasMagic, noEmpty = false) {
    let escaping = false;
    let re = "";
    let uflag = false;
    let inStar = false;
    for (let i3 = 0; i3 < glob.length; i3++) {
      const c = glob.charAt(i3);
      if (escaping) {
        escaping = false;
        re += (reSpecials.has(c) ? "\\" : "") + c;
        continue;
      }
      if (c === "*") {
        if (inStar)
          continue;
        inStar = true;
        re += noEmpty && /^[*]+$/.test(glob) ? starNoEmpty : star;
        hasMagic = true;
        continue;
      } else {
        inStar = false;
      }
      if (c === "\\") {
        if (i3 === glob.length - 1) {
          re += "\\\\";
        } else {
          escaping = true;
        }
        continue;
      }
      if (c === "[") {
        const [src, needUflag, consumed, magic] = parseClass(glob, i3);
        if (consumed) {
          re += src;
          uflag = uflag || needUflag;
          i3 += consumed - 1;
          hasMagic = hasMagic || magic;
          continue;
        }
      }
      if (c === "?") {
        re += qmark;
        hasMagic = true;
        continue;
      }
      re += regExpEscape(c);
    }
    return [re, unescape(glob), !!hasMagic, uflag];
  }
};
_a = AST;

// node_modules/minimatch/dist/esm/escape.js
var escape = (s, { windowsPathsNoEscape = false, magicalBraces = false } = {}) => {
  if (magicalBraces) {
    return windowsPathsNoEscape ? s.replace(/[?*()[\]{}]/g, "[$&]") : s.replace(/[?*()[\]\\{}]/g, "\\$&");
  }
  return windowsPathsNoEscape ? s.replace(/[?*()[\]]/g, "[$&]") : s.replace(/[?*()[\]\\]/g, "\\$&");
};

// node_modules/minimatch/dist/esm/index.js
var minimatch = (p, pattern, options = {}) => {
  assertValidPattern(pattern);
  if (!options.nocomment && pattern.charAt(0) === "#") {
    return false;
  }
  return new Minimatch(pattern, options).match(p);
};
var starDotExtRE = /^\*+([^+@!?*[(]*)$/;
var starDotExtTest = (ext2) => (f) => !f.startsWith(".") && f.endsWith(ext2);
var starDotExtTestDot = (ext2) => (f) => f.endsWith(ext2);
var starDotExtTestNocase = (ext2) => {
  ext2 = ext2.toLowerCase();
  return (f) => !f.startsWith(".") && f.toLowerCase().endsWith(ext2);
};
var starDotExtTestNocaseDot = (ext2) => {
  ext2 = ext2.toLowerCase();
  return (f) => f.toLowerCase().endsWith(ext2);
};
var starDotStarRE = /^\*+\.\*+$/;
var starDotStarTest = (f) => !f.startsWith(".") && f.includes(".");
var starDotStarTestDot = (f) => f !== "." && f !== ".." && f.includes(".");
var dotStarRE = /^\.\*+$/;
var dotStarTest = (f) => f !== "." && f !== ".." && f.startsWith(".");
var starRE = /^\*+$/;
var starTest = (f) => f.length !== 0 && !f.startsWith(".");
var starTestDot = (f) => f.length !== 0 && f !== "." && f !== "..";
var qmarksRE = /^\?+([^+@!?*[(]*)?$/;
var qmarksTestNocase = ([$0, ext2 = ""]) => {
  const noext = qmarksTestNoExt([$0]);
  if (!ext2)
    return noext;
  ext2 = ext2.toLowerCase();
  return (f) => noext(f) && f.toLowerCase().endsWith(ext2);
};
var qmarksTestNocaseDot = ([$0, ext2 = ""]) => {
  const noext = qmarksTestNoExtDot([$0]);
  if (!ext2)
    return noext;
  ext2 = ext2.toLowerCase();
  return (f) => noext(f) && f.toLowerCase().endsWith(ext2);
};
var qmarksTestDot = ([$0, ext2 = ""]) => {
  const noext = qmarksTestNoExtDot([$0]);
  return !ext2 ? noext : (f) => noext(f) && f.endsWith(ext2);
};
var qmarksTest = ([$0, ext2 = ""]) => {
  const noext = qmarksTestNoExt([$0]);
  return !ext2 ? noext : (f) => noext(f) && f.endsWith(ext2);
};
var qmarksTestNoExt = ([$0]) => {
  const len = $0.length;
  return (f) => f.length === len && !f.startsWith(".");
};
var qmarksTestNoExtDot = ([$0]) => {
  const len = $0.length;
  return (f) => f.length === len && f !== "." && f !== "..";
};
var defaultPlatform = typeof process === "object" && process ? typeof process.env === "object" && process.env && process.env.__MINIMATCH_TESTING_PLATFORM__ || process.platform : "posix";
var path = {
  win32: { sep: "\\" },
  posix: { sep: "/" }
};
var sep = defaultPlatform === "win32" ? path.win32.sep : path.posix.sep;
minimatch.sep = sep;
var GLOBSTAR = /* @__PURE__ */ Symbol("globstar **");
minimatch.GLOBSTAR = GLOBSTAR;
var qmark2 = "[^/]";
var star2 = qmark2 + "*?";
var twoStarDot = "(?:(?!(?:\\/|^)(?:\\.{1,2})($|\\/)).)*?";
var twoStarNoDot = "(?:(?!(?:\\/|^)\\.).)*?";
var filter = (pattern, options = {}) => (p) => minimatch(p, pattern, options);
minimatch.filter = filter;
var ext = (a, b = {}) => Object.assign({}, a, b);
var defaults2 = (def) => {
  if (!def || typeof def !== "object" || !Object.keys(def).length) {
    return minimatch;
  }
  const orig = minimatch;
  const m = (p, pattern, options = {}) => orig(p, pattern, ext(def, options));
  return Object.assign(m, {
    Minimatch: class Minimatch extends orig.Minimatch {
      constructor(pattern, options = {}) {
        super(pattern, ext(def, options));
      }
      static defaults(options) {
        return orig.defaults(ext(def, options)).Minimatch;
      }
    },
    AST: class AST extends orig.AST {
      /* c8 ignore start */
      constructor(type, parent, options = {}) {
        super(type, parent, ext(def, options));
      }
      /* c8 ignore stop */
      static fromGlob(pattern, options = {}) {
        return orig.AST.fromGlob(pattern, ext(def, options));
      }
    },
    unescape: (s, options = {}) => orig.unescape(s, ext(def, options)),
    escape: (s, options = {}) => orig.escape(s, ext(def, options)),
    filter: (pattern, options = {}) => orig.filter(pattern, ext(def, options)),
    defaults: (options) => orig.defaults(ext(def, options)),
    makeRe: (pattern, options = {}) => orig.makeRe(pattern, ext(def, options)),
    braceExpand: (pattern, options = {}) => orig.braceExpand(pattern, ext(def, options)),
    match: (list, pattern, options = {}) => orig.match(list, pattern, ext(def, options)),
    sep: orig.sep,
    GLOBSTAR
  });
};
minimatch.defaults = defaults2;
var braceExpand = (pattern, options = {}) => {
  assertValidPattern(pattern);
  if (options.nobrace || !/\{(?:(?!\{).)*\}/.test(pattern)) {
    return [pattern];
  }
  return expand(pattern, { max: options.braceExpandMax });
};
minimatch.braceExpand = braceExpand;
var makeRe = (pattern, options = {}) => new Minimatch(pattern, options).makeRe();
minimatch.makeRe = makeRe;
var match = (list, pattern, options = {}) => {
  const mm = new Minimatch(pattern, options);
  list = list.filter((f) => mm.match(f));
  if (mm.options.nonull && !list.length) {
    list.push(pattern);
  }
  return list;
};
minimatch.match = match;
var globMagic = /[?*]|[+@!]\(.*?\)|\[|\]/;
var regExpEscape2 = (s) => s.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
var Minimatch = class {
  options;
  set;
  pattern;
  windowsPathsNoEscape;
  nonegate;
  negate;
  comment;
  empty;
  preserveMultipleSlashes;
  partial;
  globSet;
  globParts;
  nocase;
  isWindows;
  platform;
  windowsNoMagicRoot;
  maxGlobstarRecursion;
  regexp;
  constructor(pattern, options = {}) {
    assertValidPattern(pattern);
    options = options || {};
    this.options = options;
    this.maxGlobstarRecursion = options.maxGlobstarRecursion ?? 200;
    this.pattern = pattern;
    this.platform = options.platform || defaultPlatform;
    this.isWindows = this.platform === "win32";
    const awe = "allowWindowsEscape";
    this.windowsPathsNoEscape = !!options.windowsPathsNoEscape || options[awe] === false;
    if (this.windowsPathsNoEscape) {
      this.pattern = this.pattern.replace(/\\/g, "/");
    }
    this.preserveMultipleSlashes = !!options.preserveMultipleSlashes;
    this.regexp = null;
    this.negate = false;
    this.nonegate = !!options.nonegate;
    this.comment = false;
    this.empty = false;
    this.partial = !!options.partial;
    this.nocase = !!this.options.nocase;
    this.windowsNoMagicRoot = options.windowsNoMagicRoot !== void 0 ? options.windowsNoMagicRoot : !!(this.isWindows && this.nocase);
    this.globSet = [];
    this.globParts = [];
    this.set = [];
    this.make();
  }
  hasMagic() {
    if (this.options.magicalBraces && this.set.length > 1) {
      return true;
    }
    for (const pattern of this.set) {
      for (const part of pattern) {
        if (typeof part !== "string")
          return true;
      }
    }
    return false;
  }
  debug(..._) {
  }
  make() {
    const pattern = this.pattern;
    const options = this.options;
    if (!options.nocomment && pattern.charAt(0) === "#") {
      this.comment = true;
      return;
    }
    if (!pattern) {
      this.empty = true;
      return;
    }
    this.parseNegate();
    this.globSet = [...new Set(this.braceExpand())];
    if (options.debug) {
      this.debug = (...args) => console.error(...args);
    }
    this.debug(this.pattern, this.globSet);
    const rawGlobParts = this.globSet.map((s) => this.slashSplit(s));
    this.globParts = this.preprocess(rawGlobParts);
    this.debug(this.pattern, this.globParts);
    let set = this.globParts.map((s, _, __) => {
      if (this.isWindows && this.windowsNoMagicRoot) {
        const isUNC = s[0] === "" && s[1] === "" && (s[2] === "?" || !globMagic.test(s[2])) && !globMagic.test(s[3]);
        const isDrive = /^[a-z]:/i.test(s[0]);
        if (isUNC) {
          return [
            ...s.slice(0, 4),
            ...s.slice(4).map((ss) => this.parse(ss))
          ];
        } else if (isDrive) {
          return [s[0], ...s.slice(1).map((ss) => this.parse(ss))];
        }
      }
      return s.map((ss) => this.parse(ss));
    });
    this.debug(this.pattern, set);
    this.set = set.filter((s) => s.indexOf(false) === -1);
    if (this.isWindows) {
      for (let i3 = 0; i3 < this.set.length; i3++) {
        const p = this.set[i3];
        if (p[0] === "" && p[1] === "" && this.globParts[i3][2] === "?" && typeof p[3] === "string" && /^[a-z]:$/i.test(p[3])) {
          p[2] = "?";
        }
      }
    }
    this.debug(this.pattern, this.set);
  }
  // various transforms to equivalent pattern sets that are
  // faster to process in a filesystem walk.  The goal is to
  // eliminate what we can, and push all ** patterns as far
  // to the right as possible, even if it increases the number
  // of patterns that we have to process.
  preprocess(globParts) {
    if (this.options.noglobstar) {
      for (const partset of globParts) {
        for (let j = 0; j < partset.length; j++) {
          if (partset[j] === "**") {
            partset[j] = "*";
          }
        }
      }
    }
    const { optimizationLevel = 1 } = this.options;
    if (optimizationLevel >= 2) {
      globParts = this.firstPhasePreProcess(globParts);
      globParts = this.secondPhasePreProcess(globParts);
    } else if (optimizationLevel >= 1) {
      globParts = this.levelOneOptimize(globParts);
    } else {
      globParts = this.adjascentGlobstarOptimize(globParts);
    }
    return globParts;
  }
  // just get rid of adjascent ** portions
  adjascentGlobstarOptimize(globParts) {
    return globParts.map((parts) => {
      let gs = -1;
      while (-1 !== (gs = parts.indexOf("**", gs + 1))) {
        let i3 = gs;
        while (parts[i3 + 1] === "**") {
          i3++;
        }
        if (i3 !== gs) {
          parts.splice(gs, i3 - gs);
        }
      }
      return parts;
    });
  }
  // get rid of adjascent ** and resolve .. portions
  levelOneOptimize(globParts) {
    return globParts.map((parts) => {
      parts = parts.reduce((set, part) => {
        const prev = set[set.length - 1];
        if (part === "**" && prev === "**") {
          return set;
        }
        if (part === "..") {
          if (prev && prev !== ".." && prev !== "." && prev !== "**") {
            set.pop();
            return set;
          }
        }
        set.push(part);
        return set;
      }, []);
      return parts.length === 0 ? [""] : parts;
    });
  }
  levelTwoFileOptimize(parts) {
    if (!Array.isArray(parts)) {
      parts = this.slashSplit(parts);
    }
    let didSomething = false;
    do {
      didSomething = false;
      if (!this.preserveMultipleSlashes) {
        for (let i3 = 1; i3 < parts.length - 1; i3++) {
          const p = parts[i3];
          if (i3 === 1 && p === "" && parts[0] === "")
            continue;
          if (p === "." || p === "") {
            didSomething = true;
            parts.splice(i3, 1);
            i3--;
          }
        }
        if (parts[0] === "." && parts.length === 2 && (parts[1] === "." || parts[1] === "")) {
          didSomething = true;
          parts.pop();
        }
      }
      let dd = 0;
      while (-1 !== (dd = parts.indexOf("..", dd + 1))) {
        const p = parts[dd - 1];
        if (p && p !== "." && p !== ".." && p !== "**" && !(this.isWindows && /^[a-z]:$/i.test(p))) {
          didSomething = true;
          parts.splice(dd - 1, 2);
          dd -= 2;
        }
      }
    } while (didSomething);
    return parts.length === 0 ? [""] : parts;
  }
  // First phase: single-pattern processing
  // <pre> is 1 or more portions
  // <rest> is 1 or more portions
  // <p> is any portion other than ., .., '', or **
  // <e> is . or ''
  //
  // **/.. is *brutal* for filesystem walking performance, because
  // it effectively resets the recursive walk each time it occurs,
  // and ** cannot be reduced out by a .. pattern part like a regexp
  // or most strings (other than .., ., and '') can be.
  //
  // <pre>/**/../<p>/<p>/<rest> -> {<pre>/../<p>/<p>/<rest>,<pre>/**/<p>/<p>/<rest>}
  // <pre>/<e>/<rest> -> <pre>/<rest>
  // <pre>/<p>/../<rest> -> <pre>/<rest>
  // **/**/<rest> -> **/<rest>
  //
  // **/*/<rest> -> */**/<rest> <== not valid because ** doesn't follow
  // this WOULD be allowed if ** did follow symlinks, or * didn't
  firstPhasePreProcess(globParts) {
    let didSomething = false;
    do {
      didSomething = false;
      for (let parts of globParts) {
        let gs = -1;
        while (-1 !== (gs = parts.indexOf("**", gs + 1))) {
          let gss = gs;
          while (parts[gss + 1] === "**") {
            gss++;
          }
          if (gss > gs) {
            parts.splice(gs + 1, gss - gs);
          }
          let next = parts[gs + 1];
          const p = parts[gs + 2];
          const p2 = parts[gs + 3];
          if (next !== "..")
            continue;
          if (!p || p === "." || p === ".." || !p2 || p2 === "." || p2 === "..") {
            continue;
          }
          didSomething = true;
          parts.splice(gs, 1);
          const other = parts.slice(0);
          other[gs] = "**";
          globParts.push(other);
          gs--;
        }
        if (!this.preserveMultipleSlashes) {
          for (let i3 = 1; i3 < parts.length - 1; i3++) {
            const p = parts[i3];
            if (i3 === 1 && p === "" && parts[0] === "")
              continue;
            if (p === "." || p === "") {
              didSomething = true;
              parts.splice(i3, 1);
              i3--;
            }
          }
          if (parts[0] === "." && parts.length === 2 && (parts[1] === "." || parts[1] === "")) {
            didSomething = true;
            parts.pop();
          }
        }
        let dd = 0;
        while (-1 !== (dd = parts.indexOf("..", dd + 1))) {
          const p = parts[dd - 1];
          if (p && p !== "." && p !== ".." && p !== "**") {
            didSomething = true;
            const needDot = dd === 1 && parts[dd + 1] === "**";
            const splin = needDot ? ["."] : [];
            parts.splice(dd - 1, 2, ...splin);
            if (parts.length === 0)
              parts.push("");
            dd -= 2;
          }
        }
      }
    } while (didSomething);
    return globParts;
  }
  // second phase: multi-pattern dedupes
  // {<pre>/*/<rest>,<pre>/<p>/<rest>} -> <pre>/*/<rest>
  // {<pre>/<rest>,<pre>/<rest>} -> <pre>/<rest>
  // {<pre>/**/<rest>,<pre>/<rest>} -> <pre>/**/<rest>
  //
  // {<pre>/**/<rest>,<pre>/**/<p>/<rest>} -> <pre>/**/<rest>
  // ^-- not valid because ** doens't follow symlinks
  secondPhasePreProcess(globParts) {
    for (let i3 = 0; i3 < globParts.length - 1; i3++) {
      for (let j = i3 + 1; j < globParts.length; j++) {
        const matched = this.partsMatch(globParts[i3], globParts[j], !this.preserveMultipleSlashes);
        if (matched) {
          globParts[i3] = [];
          globParts[j] = matched;
          break;
        }
      }
    }
    return globParts.filter((gs) => gs.length);
  }
  partsMatch(a, b, emptyGSMatch = false) {
    let ai = 0;
    let bi = 0;
    let result = [];
    let which = "";
    while (ai < a.length && bi < b.length) {
      if (a[ai] === b[bi]) {
        result.push(which === "b" ? b[bi] : a[ai]);
        ai++;
        bi++;
      } else if (emptyGSMatch && a[ai] === "**" && b[bi] === a[ai + 1]) {
        result.push(a[ai]);
        ai++;
      } else if (emptyGSMatch && b[bi] === "**" && a[ai] === b[bi + 1]) {
        result.push(b[bi]);
        bi++;
      } else if (a[ai] === "*" && b[bi] && (this.options.dot || !b[bi].startsWith(".")) && b[bi] !== "**") {
        if (which === "b")
          return false;
        which = "a";
        result.push(a[ai]);
        ai++;
        bi++;
      } else if (b[bi] === "*" && a[ai] && (this.options.dot || !a[ai].startsWith(".")) && a[ai] !== "**") {
        if (which === "a")
          return false;
        which = "b";
        result.push(b[bi]);
        ai++;
        bi++;
      } else {
        return false;
      }
    }
    return a.length === b.length && result;
  }
  parseNegate() {
    if (this.nonegate)
      return;
    const pattern = this.pattern;
    let negate = false;
    let negateOffset = 0;
    for (let i3 = 0; i3 < pattern.length && pattern.charAt(i3) === "!"; i3++) {
      negate = !negate;
      negateOffset++;
    }
    if (negateOffset)
      this.pattern = pattern.slice(negateOffset);
    this.negate = negate;
  }
  // set partial to true to test if, for example,
  // "/a/b" matches the start of "/*/b/*/d"
  // Partial means, if you run out of file before you run
  // out of pattern, then that's fine, as long as all
  // the parts match.
  matchOne(file, pattern, partial = false) {
    let fileStartIndex = 0;
    let patternStartIndex = 0;
    if (this.isWindows) {
      const fileDrive = typeof file[0] === "string" && /^[a-z]:$/i.test(file[0]);
      const fileUNC = !fileDrive && file[0] === "" && file[1] === "" && file[2] === "?" && /^[a-z]:$/i.test(file[3]);
      const patternDrive = typeof pattern[0] === "string" && /^[a-z]:$/i.test(pattern[0]);
      const patternUNC = !patternDrive && pattern[0] === "" && pattern[1] === "" && pattern[2] === "?" && typeof pattern[3] === "string" && /^[a-z]:$/i.test(pattern[3]);
      const fdi = fileUNC ? 3 : fileDrive ? 0 : void 0;
      const pdi = patternUNC ? 3 : patternDrive ? 0 : void 0;
      if (typeof fdi === "number" && typeof pdi === "number") {
        const [fd, pd] = [
          file[fdi],
          pattern[pdi]
        ];
        if (fd.toLowerCase() === pd.toLowerCase()) {
          pattern[pdi] = fd;
          patternStartIndex = pdi;
          fileStartIndex = fdi;
        }
      }
    }
    const { optimizationLevel = 1 } = this.options;
    if (optimizationLevel >= 2) {
      file = this.levelTwoFileOptimize(file);
    }
    if (pattern.includes(GLOBSTAR)) {
      return this.#matchGlobstar(file, pattern, partial, fileStartIndex, patternStartIndex);
    }
    return this.#matchOne(file, pattern, partial, fileStartIndex, patternStartIndex);
  }
  #matchGlobstar(file, pattern, partial, fileIndex, patternIndex) {
    const firstgs = pattern.indexOf(GLOBSTAR, patternIndex);
    const lastgs = pattern.lastIndexOf(GLOBSTAR);
    const [head, body, tail] = partial ? [
      pattern.slice(patternIndex, firstgs),
      pattern.slice(firstgs + 1),
      []
    ] : [
      pattern.slice(patternIndex, firstgs),
      pattern.slice(firstgs + 1, lastgs),
      pattern.slice(lastgs + 1)
    ];
    if (head.length) {
      const fileHead = file.slice(fileIndex, fileIndex + head.length);
      if (!this.#matchOne(fileHead, head, partial, 0, 0)) {
        return false;
      }
      fileIndex += head.length;
      patternIndex += head.length;
    }
    let fileTailMatch = 0;
    if (tail.length) {
      if (tail.length + fileIndex > file.length)
        return false;
      let tailStart = file.length - tail.length;
      if (this.#matchOne(file, tail, partial, tailStart, 0)) {
        fileTailMatch = tail.length;
      } else {
        if (file[file.length - 1] !== "" || fileIndex + tail.length === file.length) {
          return false;
        }
        tailStart--;
        if (!this.#matchOne(file, tail, partial, tailStart, 0)) {
          return false;
        }
        fileTailMatch = tail.length + 1;
      }
    }
    if (!body.length) {
      let sawSome = !!fileTailMatch;
      for (let i4 = fileIndex; i4 < file.length - fileTailMatch; i4++) {
        const f = String(file[i4]);
        sawSome = true;
        if (f === "." || f === ".." || !this.options.dot && f.startsWith(".")) {
          return false;
        }
      }
      return partial || sawSome;
    }
    const bodySegments = [[[], 0]];
    let currentBody = bodySegments[0];
    let nonGsParts = 0;
    const nonGsPartsSums = [0];
    for (const b of body) {
      if (b === GLOBSTAR) {
        nonGsPartsSums.push(nonGsParts);
        currentBody = [[], 0];
        bodySegments.push(currentBody);
      } else {
        currentBody[0].push(b);
        nonGsParts++;
      }
    }
    let i3 = bodySegments.length - 1;
    const fileLength = file.length - fileTailMatch;
    for (const b of bodySegments) {
      b[1] = fileLength - (nonGsPartsSums[i3--] + b[0].length);
    }
    return !!this.#matchGlobStarBodySections(file, bodySegments, fileIndex, 0, partial, 0, !!fileTailMatch);
  }
  // return false for "nope, not matching"
  // return null for "not matching, cannot keep trying"
  #matchGlobStarBodySections(file, bodySegments, fileIndex, bodyIndex, partial, globStarDepth, sawTail) {
    const bs = bodySegments[bodyIndex];
    if (!bs) {
      for (let i3 = fileIndex; i3 < file.length; i3++) {
        sawTail = true;
        const f = file[i3];
        if (f === "." || f === ".." || !this.options.dot && f.startsWith(".")) {
          return false;
        }
      }
      return sawTail;
    }
    const [body, after] = bs;
    while (fileIndex <= after) {
      const m = this.#matchOne(file.slice(0, fileIndex + body.length), body, partial, fileIndex, 0);
      if (m && globStarDepth < this.maxGlobstarRecursion) {
        const sub = this.#matchGlobStarBodySections(file, bodySegments, fileIndex + body.length, bodyIndex + 1, partial, globStarDepth + 1, sawTail);
        if (sub !== false) {
          return sub;
        }
      }
      const f = file[fileIndex];
      if (f === "." || f === ".." || !this.options.dot && f.startsWith(".")) {
        return false;
      }
      fileIndex++;
    }
    return partial || null;
  }
  #matchOne(file, pattern, partial, fileIndex, patternIndex) {
    let fi;
    let pi;
    let pl;
    let fl;
    for (fi = fileIndex, pi = patternIndex, fl = file.length, pl = pattern.length; fi < fl && pi < pl; fi++, pi++) {
      this.debug("matchOne loop");
      let p = pattern[pi];
      let f = file[fi];
      this.debug(pattern, p, f);
      if (p === false || p === GLOBSTAR) {
        return false;
      }
      let hit;
      if (typeof p === "string") {
        hit = f === p;
        this.debug("string match", p, f, hit);
      } else {
        hit = p.test(f);
        this.debug("pattern match", p, f, hit);
      }
      if (!hit)
        return false;
    }
    if (fi === fl && pi === pl) {
      return true;
    } else if (fi === fl) {
      return partial;
    } else if (pi === pl) {
      return fi === fl - 1 && file[fi] === "";
    } else {
      throw new Error("wtf?");
    }
  }
  braceExpand() {
    return braceExpand(this.pattern, this.options);
  }
  parse(pattern) {
    assertValidPattern(pattern);
    const options = this.options;
    if (pattern === "**")
      return GLOBSTAR;
    if (pattern === "")
      return "";
    let m;
    let fastTest = null;
    if (m = pattern.match(starRE)) {
      fastTest = options.dot ? starTestDot : starTest;
    } else if (m = pattern.match(starDotExtRE)) {
      fastTest = (options.nocase ? options.dot ? starDotExtTestNocaseDot : starDotExtTestNocase : options.dot ? starDotExtTestDot : starDotExtTest)(m[1]);
    } else if (m = pattern.match(qmarksRE)) {
      fastTest = (options.nocase ? options.dot ? qmarksTestNocaseDot : qmarksTestNocase : options.dot ? qmarksTestDot : qmarksTest)(m);
    } else if (m = pattern.match(starDotStarRE)) {
      fastTest = options.dot ? starDotStarTestDot : starDotStarTest;
    } else if (m = pattern.match(dotStarRE)) {
      fastTest = dotStarTest;
    }
    const re = AST.fromGlob(pattern, this.options).toMMPattern();
    if (fastTest && typeof re === "object") {
      Reflect.defineProperty(re, "test", { value: fastTest });
    }
    return re;
  }
  makeRe() {
    if (this.regexp || this.regexp === false)
      return this.regexp;
    const set = this.set;
    if (!set.length) {
      this.regexp = false;
      return this.regexp;
    }
    const options = this.options;
    const twoStar = options.noglobstar ? star2 : options.dot ? twoStarDot : twoStarNoDot;
    const flags = new Set(options.nocase ? ["i"] : []);
    let re = set.map((pattern) => {
      const pp = pattern.map((p) => {
        if (p instanceof RegExp) {
          for (const f of p.flags.split(""))
            flags.add(f);
        }
        return typeof p === "string" ? regExpEscape2(p) : p === GLOBSTAR ? GLOBSTAR : p._src;
      });
      pp.forEach((p, i3) => {
        const next = pp[i3 + 1];
        const prev = pp[i3 - 1];
        if (p !== GLOBSTAR || prev === GLOBSTAR) {
          return;
        }
        if (prev === void 0) {
          if (next !== void 0 && next !== GLOBSTAR) {
            pp[i3 + 1] = "(?:\\/|" + twoStar + "\\/)?" + next;
          } else {
            pp[i3] = twoStar;
          }
        } else if (next === void 0) {
          pp[i3 - 1] = prev + "(?:\\/|\\/" + twoStar + ")?";
        } else if (next !== GLOBSTAR) {
          pp[i3 - 1] = prev + "(?:\\/|\\/" + twoStar + "\\/)" + next;
          pp[i3 + 1] = GLOBSTAR;
        }
      });
      const filtered = pp.filter((p) => p !== GLOBSTAR);
      if (this.partial && filtered.length >= 1) {
        const prefixes = [];
        for (let i3 = 1; i3 <= filtered.length; i3++) {
          prefixes.push(filtered.slice(0, i3).join("/"));
        }
        return "(?:" + prefixes.join("|") + ")";
      }
      return filtered.join("/");
    }).join("|");
    const [open, close] = set.length > 1 ? ["(?:", ")"] : ["", ""];
    re = "^" + open + re + close + "$";
    if (this.partial) {
      re = "^(?:\\/|" + open + re.slice(1, -1) + close + ")$";
    }
    if (this.negate)
      re = "^(?!" + re + ").+$";
    try {
      this.regexp = new RegExp(re, [...flags].join(""));
    } catch {
      this.regexp = false;
    }
    return this.regexp;
  }
  slashSplit(p) {
    if (this.preserveMultipleSlashes) {
      return p.split("/");
    } else if (this.isWindows && /^\/\/[^/]+/.test(p)) {
      return ["", ...p.split(/\/+/)];
    } else {
      return p.split(/\/+/);
    }
  }
  match(f, partial = this.partial) {
    this.debug("match", f, this.pattern);
    if (this.comment) {
      return false;
    }
    if (this.empty) {
      return f === "";
    }
    if (f === "/" && partial) {
      return true;
    }
    const options = this.options;
    if (this.isWindows) {
      f = f.split("\\").join("/");
    }
    const ff = this.slashSplit(f);
    this.debug(this.pattern, "split", ff);
    const set = this.set;
    this.debug(this.pattern, "set", set);
    let filename = ff[ff.length - 1];
    if (!filename) {
      for (let i3 = ff.length - 2; !filename && i3 >= 0; i3--) {
        filename = ff[i3];
      }
    }
    for (const pattern of set) {
      let file = ff;
      if (options.matchBase && pattern.length === 1) {
        file = [filename];
      }
      const hit = this.matchOne(file, pattern, partial);
      if (hit) {
        if (options.flipNegate) {
          return true;
        }
        return !this.negate;
      }
    }
    if (options.flipNegate) {
      return false;
    }
    return this.negate;
  }
  static defaults(def) {
    return minimatch.defaults(def).Minimatch;
  }
};
minimatch.AST = AST;
minimatch.Minimatch = Minimatch;
minimatch.escape = escape;
minimatch.unescape = unescape;

// termsetting/TermSettingView.ts
var TermSettingView = class {
  constructor(opts) {
    this.termsetting = opts.termsetting;
    this.initUI();
    const view = this;
    this._exitPill = function() {
      view.exitPill(this);
    };
    this._updatePill = function() {
      view.updatePill(this);
    };
    this._enterPill = function() {
      view.enterPill(this);
    };
  }
  initUI() {
    const self2 = this.termsetting;
    if (self2.opts.$id) {
      self2.dom.tip.d.attr("id", self2.opts.$id + "-ts-tip");
    }
    if (!self2.dom.holder) return;
    self2.dom.holder.style("position", "relative");
    self2.dom.nopilldiv = self2.dom.holder.append("div").style("cursor", "pointer").on("click", (event2) => self2.actions.clickNoPillDiv(event2)).on(`keyup.sjpp-termdb`, (event2) => {
      if (event2.key == "Enter") self2.api.showTree(self2.dom.nopilldiv.node(), event2);
    });
    self2.dom.pilldiv = self2.dom.holder.append("div");
    self2.dom.loadingdiv = self2.dom.holder.append("div").style("display", "none").style("padding", "5px").style("max-width", "150px").style("white-space", "wrap").style("vertical-align", "top");
    if (self2.placeholder) {
      self2.dom.nopilldiv.append("div").html(self2.placeholder).attr("class", "sja_clbtext2").style("padding", "3px 6px 3px 6px").style("display", "inline-block");
    }
    if (self2.opts.placeholderIcon) {
      self2.dom.nopilldiv.append("div").attr("class", "sja_filter_tag_btn add_term_btn").attr("data-testid", "sjpp-tw-addTermBtn-" + (self2.opts.testids?.suffix || "")).style("padding", "3px 6px").style("margin", "2px").style("display", "inline-block").style("border-radius", "6px").text(self2.opts.placeholderIcon).on("mouseover", (e) => e.target.style.opacity = 0.8).on("mouseout", (e) => e.target.style.opacity = 1);
    }
    self2.dom.btnDiv = self2.dom.holder.append("div");
    self2.dom.content_holder = select_default(self2.dom.holder.node().parentNode).append("div");
  }
  async updateUI() {
    const self2 = this.termsetting;
    self2.dom.btnDiv.selectAll("*").remove();
    self2.dom.content_holder.selectAll("*").remove();
    if (!self2.term) {
      self2.dom.nopilldiv.style("display", "inline-block");
      self2.dom.pilldiv.style("display", "none");
      self2.dom.btnDiv.style("display", "none");
      return;
    }
    if (self2.term.hashtmldetail) {
      if (self2.opts.buttons && !self2.opts.buttons.includes("info")) self2.opts.buttons.unshift("info");
      else self2.opts.buttons = ["info"];
    } else {
      self2.opts.buttons = [];
    }
    if (self2.opts.buttons.length) {
      self2.dom.btnDiv.selectAll("div").data(self2.opts.buttons).enter().append("div").style("display", "inline-block").style("padding", "0px 5px").style("cursor", "pointer").style("color", "#999").style("font-size", ".8em").html((d) => d.toUpperCase()).on("click", (event2, d) => {
        if (d == "delete") self2.actions.removeTerm();
        else if (d == "replace") {
          self2.api.showTree(event2.target, event2);
        } else throw "unknown button";
      });
      if (self2.term.hashtmldetail) {
        const infoIcon_div = self2.dom.btnDiv.selectAll("div").filter(function() {
          return select_default(this).text() === "INFO";
        });
        const termInfo = await import("./termInfo-J5Q7Y763.js");
        termInfo.termInfoInit({
          vocabApi: self2.opts.vocabApi,
          icon_holder: infoIcon_div,
          content_holder: self2.dom.content_holder,
          id: self2.term.id,
          state: { term: self2.term }
        });
      }
    }
    self2.dom.nopilldiv.style("display", "none");
    self2.dom.pilldiv.style("display", self2.opts.buttons ? "inline-block" : "block");
    self2.dom.btnDiv.style("display", self2.opts.buttons ? "inline-block" : "none");
    const pills = self2.dom.pilldiv.selectAll(".ts_pill").data([self2.term], (d) => d.id || d.name);
    pills.exit().each(this._exitPill);
    pills.transition().duration(200).each(this._updatePill);
    pills.enter().append("div").attr("class", "ts_pill").style("display", "grid").style("grid-template-columns", "auto").style("grid-template-areas", '"left right"').style("cursor", "pointer").style("margin", "2px").on("click", (event2, clickedElem, menuHolder) => self2.api.showMenu(event2, clickedElem, menuHolder)).transition().duration(200).each(this._enterPill);
  }
  enterPill(elem) {
    const self2 = this.termsetting;
    const one_term_div = select_default(elem);
    self2.dom.pill_termname = one_term_div.append("div").attr("class", "term_name_btn sja_filter_tag_btn").attr("data-testid", "sjpp-tw-pillBtn-" + (self2.opts.testids?.suffix || "")).attr("tabindex", 0).style("display", "flex").style("grid-area", "left").style("position", "relative").style("align-items", "center").style("padding", "3px 6px 3px 6px").style("border-radius", "6px").html((d) => self2.handler.getPillName(d)).on(`keyup.sjpp-termdb`, (event2) => {
      if (event2.key == "Enter") event2.target.click();
    });
    this.updatePill(elem);
  }
  async updatePill(elem) {
    const self2 = this.termsetting;
    const one_term_div = select_default(elem);
    const pillstat = self2.handler.getPillStatus() || { text: "" };
    self2.dom.pill_termname.style("border-radius", pillstat.text ? "6px 0 0 6px" : "6px").html((d) => self2.handler.getPillName(d));
    const pill_settingSummary = one_term_div.selectAll(".ts_summary_btn").data(pillstat.text ? [{ txt: pillstat.text }] : [], (d) => d.txt);
    pill_settingSummary.exit().remove();
    const righthalf = pill_settingSummary.enter().append("div").attr("class", "ts_summary_btn sja_filter_tag_btn").style("display", "flex").style("grid-area", "right").style("position", "relative").style("align-items", "center").style("padding", "3px 6px 3px 6px").style("border-radius", "0 6px 6px 0").style("font-style", "italic").html((d) => d.txt).style("opacity", 0).transition().duration(200).style("opacity", 1);
    if (pillstat.bgcolor) {
      righthalf.transition().duration(200).style("background-color", pillstat.bgcolor);
    }
  }
  exitPill(elem) {
    select_default(elem).style("opacity", 1).transition().duration(this.termsetting.durations.exit).style("opacity", 0).remove();
  }
};

// termsetting/TermSettingActions.ts
var TermSettingActions = class {
  constructor(opts) {
    this.termsetting = opts.termsetting;
  }
  removeTerm() {
    this.termsetting.opts.callback(null);
  }
  async cancelGroupsetting() {
    const self2 = this.termsetting;
    self2.q = { mode: "discrete", type: "values", isAtomic: true };
    await self2.api.runCallback();
  }
  async clickNoPillDiv(event2) {
    const self2 = this.termsetting;
    if (!self2.noTermPromptOptions || self2.noTermPromptOptions.length == 0) {
      await self2.api.showTree(self2.dom.nopilldiv.node(), event2);
      return;
    }
    self2.dom.tip.clear().showunder(self2.dom.nopilldiv.node());
    const optionTip = new Menu();
    for (const option of self2.noTermPromptOptions) {
      const item = self2.dom.tip.d.append("div").attr("class", "sja_menuoption sja_sharp_border").on("click", async (event3) => {
        optionTip.clear().hide();
        if (option.invalid) {
          optionTip.show(event3.clientX, event3.clientY).d.append("div").text(option.invalidMsg || "");
          return;
        }
        self2.dom.tip.clear();
        if (option.isDictionary) {
          await self2.api.showTree(self2.dom.tip.d.node(), event3);
        } else if (option.termtype) {
          if (option.q) self2.q = structuredClone(option.q);
          await self2.setHandler(option.termtype);
          if (!self2.$id) self2.$id = await get$id2(self2.vocabApi.getTwMinCopy({ term: self2.term, q: self2.q }));
          self2.handler.showEditMenu(self2.dom.tip.d);
        } else {
          throw "termtype missing";
        }
      });
      if (option.text) item.text(option.text);
      else if (option.html) item.html(option.html);
    }
  }
};

// import("./handlers/**/*.ts") in termsetting/TermSetting.ts
var globImport_handlers_ts3 = __glob({
  "./handlers/NumBinaryEditor.ts": () => import("./NumBinaryEditor-V3YCDNRR.js"),
  "./handlers/NumContEditor.ts": () => import("./NumContEditor-FSHA32UV.js"),
  "./handlers/NumCustomBinEditor.ts": () => import("./NumCustomBinEditor-63YQZU52.js"),
  "./handlers/NumDiscreteEditor.ts": () => import("./NumDiscreteEditor-K4AZ6UQF.js"),
  "./handlers/NumRegularBinEditor.ts": () => import("./NumRegularBinEditor-5N3PWOIQ.js"),
  "./handlers/NumSplineEditor.ts": () => import("./NumSplineEditor-ZLB5MWYK.js"),
  "./handlers/NumericDensity.ts": () => import("./NumericDensity-K4CTMN2G.js"),
  "./handlers/NumericHandler.ts": () => import("./NumericHandler-3KACLCOL.js"),
  "./handlers/condition.ts": () => import("./condition-SFZAHMKK.js"),
  "./handlers/geneVariant.ts": () => import("./geneVariant-ZVOUFF27.js"),
  "./handlers/multivalue.ts": () => import("./multivalue-GLE6G3ZO.js"),
  "./handlers/qualitative.ts": () => import("./qualitative-LNRKYTK3.js"),
  "./handlers/samplelst.ts": () => import("./samplelst-3ZWV4XZQ.js"),
  "./handlers/snplocus.ts": () => import("./snplocus-4VWXVQGS.js"),
  "./handlers/snplst.sampleSum.ts": () => import("./snplst.sampleSum-KW245SY2.js"),
  "./handlers/snplst.ts": () => import("./snplst-IE3S5PE2.js"),
  "./handlers/survival.ts": () => import("./survival-GT4CSHX2.js"),
  "./handlers/termCollection.ts": () => import("./termCollection-Y7CIC6GQ.js"),
  "./handlers/test/NumBinaryEditor.unit.spec.ts": () => import("./NumBinaryEditor.unit.spec-IVY27SEV.js"),
  "./handlers/test/NumContEditor.unit.spec.ts": () => import("./NumContEditor.unit.spec-5IFB4GXP.js"),
  "./handlers/test/NumCustomBinEditor.unit.spec.ts": () => import("./NumCustomBinEditor.unit.spec-BJLGQQ4R.js"),
  "./handlers/test/NumDiscreteEditor.unit.spec.ts": () => import("./NumDiscreteEditor.unit.spec-AHL7QA4N.js"),
  "./handlers/test/NumRegularBinEditor.unit.spec.ts": () => import("./NumRegularBinEditor.unit.spec-SYPTBY5A.js"),
  "./handlers/test/NumSplineEditor.unit.spec.ts": () => import("./NumSplineEditor.unit.spec-ZLAVLV7E.js"),
  "./handlers/test/NumericDensity.unit.spec.ts": () => import("./NumericDensity.unit.spec-BLWEQHZC.js"),
  "./handlers/test/NumericHandler.unit.spec.ts": () => import("./NumericHandler.unit.spec-4P7HBSCB.js")
});

// termsetting/TermSetting.ts
var defaultOpts = {
  menuOptions: "edit",
  menuLayout: "vertical",
  customMenuOptions: []
};
var TermSetting = class {
  constructor(opts) {
    this.durations = { exit: 0 };
    this.disable_terms = [];
    //Optional opts in script, not init()
    this.doNotHideTipInMain = false;
    //Created
    this.hasError = false;
    this.numqByTermIdModeType = {};
    this.handlerByType = {};
    this.opts = this.validateOpts(opts);
    this.api = opts.api;
    this.vocabApi = opts.vocabApi;
    this.dom = this.getDom(opts);
    this.activeCohort = opts.activeCohort;
    this.placeholder = opts.placeholder;
    this.durations = { exit: 0 };
    this.disable_terms = opts.disable_terms;
    this.usecase = opts.usecase;
    this.abbrCutoff = opts.abbrCutoff;
    this.handler = new HandlerBase({ termsetting: this });
    this.handlerByType.default = this.handler;
    this.actions = new TermSettingActions({ termsetting: this });
    this.view = new TermSettingView({ termsetting: this });
  }
  validateOpts(_opts) {
    const o = {
      ...defaultOpts,
      ..._opts
    };
    if (!o.holder && o.renderAs != "none") throw ".holder missing";
    if (typeof o.callback != "function") throw ".callback() is not a function";
    if (!o.vocabApi) throw ".vocabApi missing";
    if (typeof o.vocabApi != "object") throw ".vocabApi{} is not object";
    if ("placeholder" in o && !o.placeholder && "placeholderIcon" in o && !o.placeholderIcon)
      throw "must specify a non-empty opts.placeholder and/or .placeholderIcon";
    if (!("placeholder" in o)) o.placeholder = "Select term&nbsp;";
    if (!("placeholderIcon" in o)) o.placeholderIcon = "+";
    if (!Number.isInteger(o.abbrCutoff)) o.abbrCutoff = 18;
    this.validateMenuOptions(o);
    if (!o.numericEditMenuVersion) o.numericEditMenuVersion = ["discrete"];
    this.mayValidate_noTermPromptOptions(o);
    return o;
  }
  getDom(opts) {
    const tip = opts.tip || new Menu({
      padding: "0px",
      parent_menu: this.opts.holder && this.opts.holder.node() && this.opts.holder.node().closest(".sja_menu_div")
    });
    return {
      holder: opts.holder,
      tip,
      // tip2 is for showing inside tip, e.g. in snplocus UI
      tip2: new Menu({
        padding: "0px",
        parent_menu: tip.d.node()
      })
    };
  }
  validateMainData(d) {
    if (d.term) {
      if (!d.term.type) throw "data.term.type missing";
      if (isDictionaryType(d.term.type)) {
        if (!d.term.id && d.term.type != TermTypes.SAMPLELST && d.term.type != TermTypes.TERM_COLLECTION)
          throw "data.term.id missing";
        if (!d.term.name) throw "data.term.name missing";
      }
    }
    if (!d.q) d.q = {};
    if (typeof d.q != "object") throw "data.q{} is not object";
    if (d.disable_terms) {
      if (!Array.isArray(d.disable_terms)) throw "data.disable_terms[] is not array";
    }
    this.mayValidate_noTermPromptOptions(d);
  }
  validateMenuOptions(o) {
    if (!o.menuOptions) o.menuOptions = defaultOpts.menuOptions;
    if (o.menuOptions == "all") o.menuOptions = "*";
    for (const opt of ["edit", "replace", "remove"]) {
      if (minimatch(opt, o.menuOptions)) return;
    }
    throw `no matches found for termsetting opts.menuOptions='${o.menuOptions}'`;
  }
  mayValidate_noTermPromptOptions(o) {
    if (!o.noTermPromptOptions) return;
    if (!Array.isArray(o.noTermPromptOptions)) throw "noTermPromptOptions[] is not array";
    for (const t2 of o.noTermPromptOptions) {
      if (t2.isDictionary) {
      } else {
        if (!t2.termtype) throw "element of noTermPromptOptions[] missing both isDictionary=true and .termtype";
      }
      if (!t2.text && !t2.html) throw "element of noTermPromptOptions[] missing both .text and .html";
      if (t2.q && typeof t2.q != "object") throw "type.q{} is not object";
    }
    this.noTermPromptOptions = o.noTermPromptOptions;
  }
  async setHandler(termtype, tw) {
    if (tw instanceof TwBase) {
      switch (tw.type) {
        case "QualTWValues":
        case "QualTWPredefinedGS":
        case "QualTWCustomGS": {
          const { GroupSet } = await import("./qualitative-LNRKYTK3.js");
          this.handler = new GroupSet({ termsetting: this });
          this.handlerByType.qualitative = this.handler;
          return;
        }
        case "NumTWRegularBin":
        case "NumTWCustomBin":
        case "NumTWCont":
        case "NumTWBinary":
        case "NumTWSpline": {
          if (this.handlerByType.numeric) {
            this.handler = this.handlerByType.numeric;
            return;
          }
          const { NumericHandler } = await import("./NumericHandler-3KACLCOL.js");
          this.handler = new NumericHandler({ termsetting: this });
          this.handlerByType.numeric = this.handler;
          return;
        }
        case "TermCollectionTWQual":
        case "TermCollectionTWCont":
        case "TermCollectionTWFraction": {
          const { TermCollectionHandler } = await import("./termCollection-Y7CIC6GQ.js");
          this.handler = new TermCollectionHandler({ termsetting: this });
          return;
        }
        // TODO: should reinstate throw once all migrated tw's have strict handlers for each tw type
        default:
          throw `unsupported tw.type='${tw.type}'`;
      }
    }
    if (!termtype) {
      this.handler = this.handlerByType.default;
      return;
    }
    const type = termtype == "integer" || termtype == "float" || termtype == "date" ? "numeric" : termtype;
    if (!this.handlerByType[type]) {
      try {
        const _ = await globImport_handlers_ts3(`./handlers/${type}.ts`);
        this.handlerByType[type] = await _.getHandler(this);
      } catch (e) {
        throw `error with handler='./handlers/${type}.ts': ${e}`;
      }
    }
    this.handler = this.handlerByType[type];
  }
  destroy() {
    this.dom.holder.remove();
    this.dom.tip.destroy();
    this.dom.tip2.destroy();
  }
};

// termsetting/TermSettingApi.ts
var termsettingInit = (opts) => {
  return new TermSettingApi(opts);
};
var testClickTermDelay = 0;
var fractionOverlayTargets = /* @__PURE__ */ new Set(["barchart", "violin", "boxplot", "survival"]);
function allowsCollectionFraction2(usecase) {
  if (fractionOverlayTargets.has(usecase.target)) return usecase.detail === "term2" || usecase.detail === "term0";
  if (usecase.target === "regression") return usecase.detail === "independent";
  return false;
}
var TermSettingApi = class {
  constructor(opts) {
    this.loadingMasks = [];
    opts.api = this;
    if (opts.loadingMasks) this.loadingMasks.push(...opts.loadingMasks);
    this.#termsetting = new TermSetting(opts);
    if (opts.debug) this.Inner = this.#termsetting;
  }
  #termsetting;
  async main(data = {}) {
    const self2 = this.#termsetting;
    try {
      if (self2.doNotHideTipInMain) {
        self2.doNotHideTipInMain = false;
      } else {
        self2.dom.tip.hide();
      }
      self2.hasError = false;
      delete self2.error;
      self2.validateMainData(data);
      if (!data.tw && (QualitativeBase.termTypes.has(data.term?.type) || NumericBase.termTypes.has(data.term?.type) || data.term?.type == "termCollection")) {
        data.tw = await TwRouter.initRaw({ term: data.term, q: data.q }, { vocabApi: self2.vocabApi });
      }
      self2.tw = data.tw;
      self2.data = data;
      self2.term = data.term;
      self2.q = JSON.parse(JSON.stringify(data.q));
      if ("$id" in data) self2.$id = data.$id;
      if ("disable_terms" in data) self2.disable_terms = data.disable_terms;
      if ("filter" in data) self2.filter = data.filter;
      if ("activeCohort" in data) self2.activeCohort = data.activeCohort;
      if ("sampleCounts" in data) self2.sampleCounts = data.sampleCounts;
      if ("menuOptions" in data) self2.opts.menuOptions = data.menuOptions;
      await self2.setHandler(self2.term ? self2.term.type : null, data.tw);
      if (data.term && self2.handler && self2.handler.validateQ) self2.handler.validateQ(data);
      if (self2.handler.postMain) await self2.handler.postMain();
      if (self2.opts.renderAs != "none") self2.view.updateUI();
    } catch (e) {
      self2.hasError = true;
      throw e;
    }
  }
  async runCallback(overrideTw = null) {
    const self2 = this.#termsetting;
    const arg = self2.term ? { term: self2.term, q: self2.q, isAtomic: true } : {};
    arg.$id = "$id" in this ? this.$id : await get$id2(arg);
    const otw = overrideTw ? JSON.parse(JSON.stringify(overrideTw)) : {};
    const tw = overrideTw ? copyMerge(JSON.stringify(arg), otw) : arg;
    if (routedTermTypes.has(tw.term.type)) self2.tw = await TwRouter.initRaw(tw, self2.opts);
    if (self2.opts.callback) self2.opts.callback(tw);
  }
  async showTree(holder, event2) {
    const self2 = this.#termsetting;
    self2.dom.tip.clear();
    if (holder)
      self2.dom.tip.showunder(
        holder instanceof Element ? holder : this instanceof Element ? this : self2.dom.holder.node()
      );
    else self2.dom.tip.show(event2.clientX, event2.clientY);
    if (!self2.usecase) self2.usecase = { target: "default" };
    const termdb = await import("./app-2NSQK3GQ.js");
    termdb.appInit({
      holder: self2.dom.tip.d,
      vocabApi: self2.vocabApi,
      state: {
        activeCohort: self2.activeCohort,
        termfilter: self2.vocabApi.state?.termfilter,
        tree: {
          usecase: self2.usecase
        }
      },
      tree: {
        disable_terms: self2.disable_terms,
        termCollectionSelectionMode: allowsCollectionFraction2(self2.usecase) ? "fraction" : void 0,
        click_term: async (t2) => {
          self2.dom.nopilldiv.style("display", "none");
          self2.dom.pilldiv.style("display", "none");
          self2.dom.loadingdiv.text("Loading ...").style("display", "inline-block");
          self2.dom.tip.hide();
          this.toggleOptionalLoadingMasks("");
          if (testClickTermDelay) await sleep(testClickTermDelay);
          let tw;
          if (t2.term) tw = t2;
          else {
            const term = t2;
            tw = { term, q: { isAtomic: true }, isAtomic: true };
          }
          if (self2.opts.customFillTw) tw = self2.opts.customFillTw(tw);
          try {
            tw = await fillTermWrapper(tw, self2.vocabApi, self2.opts.defaultQ4fillTW);
          } catch (e) {
            if (this.isAbortError(e)) {
              self2.dom.loadingdiv.text("");
            } else {
              const msg = e.message || e.error || e;
              self2.dom.loadingdiv.text(`Error loading term ${self2.handler?.getPillName?.(tw.term)}: ${msg}`);
            }
            self2.dom.nopilldiv.style("display", !self2.term ? "inline-block" : "none");
            self2.dom.pilldiv.style("display", self2.term ? "block" : "none");
            this.toggleOptionalLoadingMasks("none");
            return;
          }
          self2.opts.callback(tw);
          self2.dom.loadingdiv.style("display", "none");
          self2.dom.nopilldiv.style("display", !self2.term ? "inline-block" : "none");
          self2.dom.pilldiv.style("display", self2.term ? "block" : "none");
          this.toggleOptionalLoadingMasks("none");
        }
      }
    });
  }
  // TODO: move this method to TermSetting class
  showMenu(event2, clickedElem = null, menuHolder = null) {
    const self2 = this.#termsetting;
    const tip = self2.dom.tip;
    tip.clear();
    if (self2.opts.renderAs == "none" && clickedElem) self2.dom.holder = select_default(clickedElem);
    if (self2.dom.holder) {
      const elem = self2.dom.holder?.node();
      if (elem) tip.showunder(elem);
      else tip.show(event2.clientX, event2.clientY);
    }
    const options = [];
    const q = self2.q;
    if (q.type == "predefined-groupset" || q.type == "custom-groupset") {
      if (q.mode != "binary" && self2.term.type != "geneVariant") {
        options.push({ label: "Cancel grouping", callback: () => self2.actions.cancelGroupsetting() });
      }
    }
    const isFractionCollection = self2.tw?.type === "TermCollectionTWFraction";
    if (self2.q && !self2.term.groupsetting?.disabled && self2.term.type != "survival" && minimatch("edit", self2.opts.menuOptions) && !isFractionCollection) {
      options.push({
        label: "Edit",
        callback: async (div) => {
          if (self2.data.editMsg) {
            div.append("div").style("margin", "10px").html(self2.data.editMsg);
          } else {
            await self2.handler.showEditMenu(div.append("div"));
          }
        }
      });
    }
    if (isFractionCollection && self2.q && !self2.term.groupsetting?.disabled && minimatch("edit", self2.opts.menuOptions)) {
      options.push({
        label: "Edit numerator/denominator",
        callback: async (div) => {
          await self2.handler.showEditMenu(div.append("div"));
        }
      });
      options.push({
        label: "Edit bins",
        callback: async (div) => {
          await self2.handler.showBinsEditMenu(div.append("div"));
        }
      });
    }
    if (self2.term.type == "geneVariant" && "type" in self2.q && self2.q.type == "predefined-groupset") {
      const groupsets = self2.term.groupsetting?.lst;
      if (!groupsets || !groupsets.length) throw "predefined groupsets not found";
      for (const [i3, groupset] of groupsets.entries()) {
        options.push({
          label: groupset.name,
          callback: async () => {
            const tw = {
              type: "GvPredefinedGsTW",
              isAtomic: true,
              term: self2.term,
              q: { type: "predefined-groupset", predefined_groupset_idx: i3, isAtomic: true }
            };
            await call_fillTW(tw, self2.vocabApi);
            self2.opts.callback(tw);
          }
        });
      }
    }
    if (self2.term.type == "geneVariant" && minimatch("edit", self2.opts.menuOptions)) {
      const inUse = q?.type == "custom-groupset" ? trimGvQForCache(q) : null;
      for (const entry of self2.vocabApi.getGvQLst?.(self2.term) || []) {
        if (inUse && deepEqual(entry.q, inUse)) continue;
        options.push({
          label: `Reuse: ${entry.label}`,
          callback: async () => {
            const tw = { isAtomic: true, term: self2.term, q: { ...entry.q, isAtomic: true } };
            await call_fillTW(tw, self2.vocabApi);
            self2.opts.callback(tw);
          }
        });
      }
    }
    if (minimatch("replace", self2.opts.menuOptions)) {
      options.push({
        label: "Replace",
        callback: (event3, d) => {
          this.showTree(event3, d);
        }
      });
    }
    if (minimatch("remove", self2.opts.menuOptions)) {
      options.push({ label: "Remove", callback: () => self2.actions.removeTerm() });
    }
    if (self2.opts.customMenuOptions) options.push(...self2.opts.customMenuOptions);
    if (!options.length) {
      tip.hide();
      return;
    }
    const activeMenu = menuHolder || tip.d;
    activeMenu.selectAll("div").data(options).enter().append("div").attr("class", "sja_menuoption sja_sharp_border").attr("tabindex", (d, i3) => i3 + 1).style("display", self2.opts.menuLayout == "horizontal" ? "inline-block" : "block").text((d) => d.label).on("click", (event3, d) => {
      self2.dom.tip.clear();
      d.callback(self2.dom.tip.d);
    }).on("keyup", (event3) => {
      if (event3.key == "Enter") event3.target.click();
    });
    activeMenu.select(".sja_menuoption").node()?.focus();
  }
  // TODO: move this method to TermSetting class
  showGeneSearch(clickedElem, event2) {
    const self2 = this.#termsetting;
    self2.dom.tip.clear();
    if (clickedElem)
      self2.dom.tip.showunder(
        clickedElem instanceof Element ? clickedElem : this instanceof Element ? this : self2.dom.holder.node()
      );
    else self2.dom.tip.show(event2.clientX, event2.clientY);
    const selectedGenes = /* @__PURE__ */ new Set();
    const searchDiv = self2.dom.tip.d.append("div").style("padding", "5px");
    const label = searchDiv.append("label");
    label.append("span").text("Search: ");
    const input = label.append("input").attr("type", "text").on("input", async () => {
      const str = input.property("value");
      const cohortStr = self2.opts.vocabApi.termdbConfig.selectCohort.values[self2.activeCohort || 0].keys.slice().sort().join(",");
      try {
        const results = !str ? { lst: [] } : await self2.vocabApi.findTerm(str, cohortStr, self2.usecase, "gene");
        resultsDiv.selectAll("*").remove();
        resultsDiv.selectAll("div").data(results.lst.filter((g) => !selectedGenes.has(g))).enter().append("div").attr("class", "ts_pill sja_filter_tag_btn sja_tree_click_term").style("display", "block").style("margin", "2px 3px").style("width", "fit-content").text((gene) => gene.name).on("click", async (gene) => {
          self2.dom.tip.hide();
          this.runCallback({
            term: {
              name: gene.name,
              type: "geneVariant"
            },
            q: {
              exclude: []
            }
          });
        });
      } catch (e) {
        alert("Search error: " + e);
      }
    });
    const resultsDiv = self2.dom.tip.d.append("div").style("margin", "5px").style("padding-left", "5px").style("border-left", "2px solid #ccc");
  }
  hasError() {
    return this.#termsetting.hasError;
  }
  validateQ(d) {
    const self2 = this.#termsetting;
    if (!self2.handler?.validateQ) return;
    try {
      self2.handler.validateQ(d);
    } catch (e) {
      this.#termsetting.hasError = true;
      throw e;
    }
  }
  toggleOptionalLoadingMasks(display = "") {
    if (!this.loadingMasks) return;
    for (const m of this.loadingMasks) {
      m.style("display", display || "");
    }
  }
  isAbortError(e) {
    if (e instanceof DOMException) return e.name === "AbortError";
    if (typeof e === "object" && e !== null && e.name === "AbortError") return true;
    if (typeof e == "string") return e.includes("stale sequenceId") || e.includes("AbortError");
    return false;
  }
  destroy() {
    this.#termsetting.destroy();
  }
};

// tw/qualitative.ts
var QualitativeBase = class _QualitativeBase extends TwBase {
  static {
    this.termTypes = /* @__PURE__ */ new Set([CATEGORICAL, SNP, SINGLECELL_CELLTYPE]);
  }
  constructor(tw, opts) {
    super(tw, opts);
    this.term = tw.term;
    this.q = tw.q;
  }
  /** tw.term must already be filled-in at this point */
  static async fill(tw, opts = {}) {
    if (!tw.term) throw `missing tw.term`;
    if (typeof tw.term != "object") throw `tw.term is not an object`;
    if (!_QualitativeBase.termTypes.has(tw.term.type)) throw `non-qualitative term.type='${tw.term.type}'`;
    switch (tw.term.type) {
      case "categorical":
        CategoricalBase.fill(tw.term);
        break;
      case "snp":
        SnpBase.fill(tw.term);
        break;
      case SINGLECELL_CELLTYPE:
        SingleCellCellTypeBase.fill(tw.term);
        break;
      default:
        throw `unexpected qualitative term.type'`;
    }
    if (opts.defaultQ != null) {
      opts.defaultQ.isAtomic = true;
      copyMerge(tw.q, opts.defaultQ);
    }
    if (!tw.q.mode || tw.q.mode == "values") tw.q.mode = "discrete";
    switch (tw.q.mode) {
      case "discrete":
        if (!tw.q.type) tw.q.type = "values";
        break;
      case "binary":
        if (tw.term.values && Object.keys(tw.term.values).length == 2) {
          tw.q.type = "values";
        } else {
          tw.q.type = "custom-groupset";
        }
        break;
      default:
        throw "qualitative tw.q.mode not supported";
    }
    tw.type = !tw.q.type || tw.q.type == "values" ? "QualTWValues" : tw.q.type == "predefined-groupset" ? "QualTWPredefinedGS" : tw.q.type == "custom-groupset" ? "QualTWCustomGS" : tw.type;
    switch (tw.type) {
      case "QualTWValues":
        return await QualValues.fill(tw);
      case "QualTWPredefinedGS":
        return await QualPredefinedGS.fill(tw);
      case "QualTWCustomGS":
        return await QualCustomGS.fill(tw, opts);
      default:
        throw `tw.type='${tw.type} (q.mode:q.type=${tw.q.mode}:${tw.q.type}' is not supported by QualitativeBase.fill()`;
    }
  }
  getTitleText() {
    return this.term.name;
  }
  getStatus(_) {
    return { text: "" };
  }
};
var QualValues = class extends QualitativeBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    this.#tw = tw;
  }
  getTw() {
    return this.#tw;
  }
  // See the relevant comments in the QualitativeBase.fill() function above
  static async fill(tw) {
    if (!tw.type) tw.type = "QualTWValues";
    else if (tw.type != "QualTWValues") throw `expecting tw.type='QualTWValues', got '${tw.type}'`;
    const { term, q } = tw;
    if (!q.type) q.type = "values";
    else if (q.type != "values") throw `expecting tw.q.type='values', got ${tw.q.type}`;
    if (!term.values) term.values = {};
    if (q.mode == "binary") {
      if (Object.keys(term.values).length != 2) throw "term.values must have two keys";
    }
    set_hiddenvalues(q, term);
    return tw;
  }
  getStatus(usecase) {
    if (usecase?.target == "regression") {
      return this.q.mode == "binary" ? { text: "binary" } : { text: "categorical" };
    }
    return { text: "" };
  }
  getGroups(category2samplecount, maxGrpNum = 3) {
    const values = [];
    const groups = [];
    const grpIdxes = /* @__PURE__ */ new Set([0, 1, 2]);
    for (const v of category2samplecount) {
      if (v.uncomputable) return;
      if (v?.group > maxGrpNum)
        throwMsgWithFilePathAndFnName(
          `The maximum number of groups is ${maxGrpNum}. The group index for value = ${v.label} is ${v.group}`
        );
      const value = {
        key: v.key,
        label: v.label,
        group: v.group || 1,
        samplecount: v.samplecount
      };
      values.push(value);
    }
    for (const g of Array.from(grpIdxes)) {
      groups.push({
        currentIdx: g,
        type: this.type,
        name: g === 0 ? `Excluded categories` : `Group ${g.toString()}`,
        uncomputable: g === 0
      });
    }
    return { groups, values };
  }
};
var QualPredefinedGS = class extends QualitativeBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    this.#tw = tw;
    Object.defineProperty(this, "groupset", {
      value: this.#tw.term.groupsetting[this.#tw.q.predefined_groupset_idx]
    });
  }
  getTw() {
    return this.#tw;
  }
  static async fill(tw) {
    if (!tw.type) tw.type = "QualTWPredefinedGS";
    else if (tw.type != "QualTWPredefinedGS") throw `expecting tw.type='QualTWPredefinedGS', got '${tw.type}'`;
    if (tw.q.type != "predefined-groupset") throw `expecting tw.q.type='predefined-groupset', got '${tw.q.type}'`;
    const { term, q } = tw;
    const i3 = q.predefined_groupset_idx;
    if (i3 !== void 0 && !Number.isInteger(i3)) throw `missing or invalid tw.q.predefined_groupset_idx='${i3}'`;
    q.predefined_groupset_idx = i3 || 0;
    const gs = tw.term.groupsetting;
    if (!gs) throw "no term.groupsetting";
    if (!gs.lst?.length) throw "term.groupsetting.lst is empty";
    const groupset = gs.lst?.[q.predefined_groupset_idx];
    if (!groupset) throw `no groupset entry for groupsetting.lst?.[predefined_groupset_idx=${i3}]`;
    if (q.mode == "binary") {
      if (groupset.groups.length != 2) throw "there must be exactly two groups";
    }
    set_hiddenvalues(q, term);
    return tw;
  }
  getStatus(usecase) {
    if (usecase?.target == "regression") {
      return this.q.mode == "binary" ? { text: "binary" } : { text: "categorical" };
    }
    return { text: this.term.groupsetting.lst?.[this.q.predefined_groupset_idx].name || "predefined groups" };
  }
  getGroups() {
    throw `q.type='predefined-groupset' not supported in groupsetting menu`;
  }
};
var QualCustomGS = class extends QualitativeBase {
  #tw;
  // declare a constructor, to narrow the tw type
  constructor(tw, opts = {}) {
    super(tw, opts);
    this.q = tw.q;
    Object.defineProperty(this, "groupset", { value: this.q.customset });
    this.#tw = tw;
  }
  getTw() {
    return this.#tw;
  }
  // See the relevant comments in the QualitativeBase.fill() function above
  static async fill(tw, opts) {
    if (!tw.type) tw.type = "QualTWCustomGS";
    else if (tw.type != "QualTWCustomGS") throw `expecting tw.type='QualTWCustomGS', got '${tw.type}'`;
    if (tw.q.type != "custom-groupset") throw `expecting tw.q.type='custom-groupset', got '${tw.q.type}'`;
    const { term, q } = tw;
    if (!q.customset) await mayFillCustomSet(q, term, opts.vocabApi);
    if (q.mode == "binary") {
      if (q.customset.groups.filter((g) => !g.uncomputable).length != 2) throw "there must be exactly two groups";
    }
    set_hiddenvalues(q, term);
    return tw;
  }
  getStatus(usecase) {
    if (usecase?.target == "regression") {
      return this.q.mode == "binary" ? { text: "binary" } : { text: "categorical" };
    }
    const n = this.q.customset.groups.filter((group) => {
      if (group.type != "values") throw `group.type must be 'values'`;
      if (!group.uncomputable) return true;
    }).length;
    return { text: "Divided into " + n + " groups" };
  }
  getGroups(category2samplecount) {
    const values = [];
    const groups = [];
    const grpIdxes = /* @__PURE__ */ new Set([0, 1, 2]);
    const q = this.q;
    for (const [i3, g] of q.customset.groups.entries()) {
      const group = g;
      const uncomputable = Object.keys(group).includes("uncomputable") ? group.uncomputable : i3 === 0;
      groups.push({
        currentIdx: i3,
        type: group.type,
        name: group.name,
        uncomputable
      });
      grpIdxes.delete(i3);
      if (group.type != "values") throw `group.type should equal 'values'`;
      for (const value of group.values) {
        const c2s = category2samplecount?.find(
          (d) => d.key == value.key
        );
        const label = value.label || c2s?.label || value.key;
        values.push({
          key: value.key,
          label,
          group: i3,
          samplecount: value.samplecount || c2s.samplecount
        });
      }
    }
    return { groups, values };
  }
};
async function mayFillCustomSet(q, term, vocabApi) {
  if (q.mode == "binary") {
    const data = await vocabApi.getCategories(term, vocabApi.state.termfilter.filter);
    const sorted = [...data.lst].sort((a, b) => b.samplecount - a.samplecount);
    const group1 = { name: "Group 1", type: "values", values: [] };
    const group2 = { name: "Group 2", type: "values", values: [] };
    let sum1 = 0;
    let sum2 = 0;
    for (const item of sorted) {
      if (sum1 <= sum2) {
        group1.values.push({ key: item.key, label: item.label });
        sum1 += item.samplecount;
      } else {
        group2.values.push({ key: item.key, label: item.label });
        sum2 += item.samplecount;
      }
    }
    if (sum1 == 0 || sum2 == 0) throw "both groups must have non-zero sample counts";
    const customset = {
      // creating 3 groups instead of 2 groups since current groupset UI expects first group to be excluded group
      // TODO: refactor client/termsetting/handlers/qualitative.ts to not consider the first group (i.e. group.currentIdx === 0) as the excluded group, but rather to consider group.excluded=true as the excluded group
      groups: [
        {
          name: "Excluded categories",
          type: "values",
          values: [],
          uncomputable: true
        },
        group1,
        group2
      ]
    };
    q.customset = customset;
  } else {
    throw "tw.q.customset is required for q.mode=discrete";
  }
}

export {
  appear,
  disappear,
  axisstyle,
  drawBoxplot,
  make_one_checkbox,
  ColorScale,
  getInterpolatedDomainRange,
  colorDelta,
  removeOutliers,
  renderCnvConfig,
  renderTable,
  fileDateStamp,
  downloadTable,
  sayerror,
  throwMsgWithFilePathAndFnName,
  showErrorsWithCounter,
  getGEunit,
  getDNAMethUnit,
  getDNAMethTermName,
  getSCGEunit,
  QualitativeBase,
  QualValues,
  QualPredefinedGS,
  QualCustomGS,
  getDefaultFractionSelection,
  getFractionSelectionError,
  renderFractionSelection,
  pickCollectionFraction,
  mayRenderFractionSelection,
  makeFractionTermWrapper,
  require_partjson_umd,
  handler2 as handler,
  getDtTermValues,
  findParent,
  getFilterItemByTag,
  excludeFilterByTag,
  getNormalRoot,
  filterJoin,
  negateFilter,
  getCombinedTermFilter,
  getCategoricalTermFilter,
  AppBase,
  vocabInit,
  q_to_param,
  getVocabFromSamplesArray,
  first_genetrack_tolist,
  makeNumericAxisConfig,
  table2col,
  make_table_2col,
  configUiInit,
  initByInput,
  controlsInit,
  renderTerm1Label,
  getT0T2defaultQ,
  getDefaultFractionBins,
  PlotBase,
  defaultUiLabels,
  fetchBrainImagingSamples,
  getBrainImagingSampleSet,
  svgLegend,
  getSingleCellSpecialCase,
  Barchart,
  barInit,
  componentInit2 as componentInit,
  getDefaultBarSettings,
  getPlotConfig2 as getPlotConfig,
  negateTermLabel,
  ListSamples,
  DATermTypes,
  enabledTermTypes2 as enabledTermTypes,
  getDefaultVolcanoSettings,
  validateVolcanoSettings,
  getSampleNum,
  getMaxLabelWidth,
  GeneExpInput,
  getUnit,
  geneExpInputInit,
  componentInit as componentInit2,
  getPlotConfig as getPlotConfig2,
  getSelectableGETermTypes,
  downloadSingleSVG,
  downloadChart,
  DownloadMenu,
  downloadSVGsAsPdf,
  Tabs,
  shapes,
  shapesArray,
  shapeSelector,
  to_textfile,
  SearchHandler,
  getChildTerms,
  addParentTerm,
  renderSandboxFormDiv,
  newSandboxDiv,
  addGeneSearchbox,
  string2variant,
  GeneSetEditUI,
  GeneSetEditUIwithTabs,
  chartsInit,
  getActiveCohortStr,
  getCurrentCohortChartTypes,
  groupsInit,
  renderPreAnalysisData,
  rebaseGroupFilter,
  addNewGroup,
  getFilter,
  getSampleFilter,
  getSamplelstTW,
  appInit,
  filterInit,
  filterRxCompInit,
  filterPromptInit,
  fillGroupsetGroups,
  isCustomizedGvQ,
  getGvQLabel,
  routedTermTypes,
  TwRouter,
  get$id2 as get$id,
  digestMessage,
  getPillNameDefault,
  fillTwLst,
  fillTermWrapper,
  set_hiddenvalues,
  termsettingInit,
  createLollipopFromGene,
  showResultsTable,
  DataPointInteractions,
  sketchSplicerna,
  sketchRna,
  sketchProtein2,
  sketchGene,
  allgm2sum,
  isoformSelect,
  fillbar,
  htmlLegend,
  InvalidDataUI,
  LegendCircleReference,
  MultiTermWrapperEditUI,
  make_radios,
  renderAtRiskG,
  renderPvalues,
  renderSampleTypeSelect,
  getSelectedSampleTypes,
  InputSearch,
  select2Terms,
  makeSsmLink,
  capitalizeFirstLetter,
  svgScroll,
  getSeriesTip,
  zoom,
  font,
  colorinframe,
  coloroutframe,
  colorbgleft,
  colorbgright,
  colorantisense,
  colorctx,
  textlensf,
  tkt2 as tkt,
  gmmode2 as gmmode,
  appear2,
  disappear2,
  newpane,
  getdomaintypes,
  newpane3,
  to_svg,
  filetypeselect,
  export_data,
  flyindi,
  labelbox,
  category2legend,
  bulk_badline,
  mclasscolorchangeui,
  mclasscolor2table,
  bwSetting,
  tkexists,
  ranksays,
  rgb2hex,
  keyupEnter,
  may_findmatchingsnp,
  snp_printhtml,
  gmlst2loci,
  tab2box,
  tab_wait,
  client_exports
};
//# sourceMappingURL=chunk-NQDF3U2C.js.map
